import {
  ArrayList3it5z8td81qkl as ArrayList,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  VOID3gxj6tk5isa35 as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  numberToDouble210hrknaofnhf as numberToDouble,
  constructCallableReference23y65rf941mch as constructCallableReference,
  Duration__div_impl_dknbf41gsbotr0sauxp as Duration__div_impl_dknbf4,
  toDuration28gf6ughsr3vf as toDuration_0,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split,
  last1vo29oleiqj36 as last,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toString1pkumu07cwy4m as toString,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  equals2au1ep9vhcato as equals,
  Enum3alwj03lh1n41 as Enum,
  enumEntries20mr21zbe3az4 as enumEntries,
  to2cs3ny02qtbcb as to,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  toString30pk9tzaqopn as toString_0,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  listOf1jh22dvmctj1r as listOf,
  sortedWith2csnbbb21k0lg as sortedWith,
  indexOfa2zokh3tu4p6 as indexOf,
  first58ocm7j58k3q as first,
  drop3na99dw9feawf as drop,
  listOfvhqybd2zx248 as listOf_0,
  plus310ted5e4i90h as plus,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  getKClass3t8tygqu4lcxf as getKClass,
  KClass1cc9rfeybg8hs as KClass,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  Triple1vhi3d0dgpnjb as Triple,
  isBlank1dvkhjjvox3p0 as isBlank,
  plus20p0vtfmu0596 as plus_0,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  printStackTrace18lnx7a39cni as printStackTrace,
  CancellationException3b36o9qz53rgr as CancellationException,
  throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException,
  emptySetcxexqki71qfa as emptySet,
  Default_getInstance3u7accvuecmtb as Default_getInstance,
  random234odtwlu7lq2 as random,
  Long2qws0ah9gnpki as Long,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  first28gmhyvs4kf06 as first_0,
  Exceptiondt2hlxn7j7vw as Exception,
  StringBuildermazzzhj6kkai as StringBuilder,
  mapOf2zpbbmyqk8xpf as mapOf,
  setOf1u3mizs95ngxo as setOf,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  plus18eogev54fmsa as plus_1,
  KProperty1ca4yb4wlo496 as KProperty1,
  System_instance2n5ytli8ed176 as System_instance,
  zipfdxxupzuj2p9 as zip,
  singleo93pzdgfc557 as single,
  singleOrNullrknfaxokm1sl as singleOrNull,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  minus165a8u1e0x1lu as minus,
  toSet2orjxp16sotqu as toSet,
  toList2zksu85ukrmi as toList,
  compareTo3ankvs086tmwq as compareTo,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  getValue48kllevslyh6 as getValue,
  setOf45ia9pnfhe90 as setOf_0,
  toList3jhuyej2anx2q as toList_0,
  contains2gm06f5aa19ov as contains,
  emptyMapr06gerzljqtm as emptyMap,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  coerceInlzh524ulyz3c as coerceIn,
  listOfNotNull2woi2boe01ub4 as listOfNotNull_0,
  minus2znw4oicpx34e as minus_0,
  coerceAtLeastklytehohcpeq as coerceAtLeast,
  toMap1vec9topfei08 as toMap,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  toMutableList20rdgwi7d3cwi as toMutableList,
  startsWith26w8qjqapeeq6 as startsWith,
  chunked1umgsyuj0x9u1 as chunked,
  getOrNull1go7ef9ldk0df as getOrNull,
  firstOrNull1982767dljvdy as firstOrNull,
  removePrefix279df90bhrqqg as removePrefix,
  joinToString1cxrrlmo0chqs as joinToString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Regexxgw0gjiagf4z as Regex,
  HashSet2dzve9y63nf0v as HashSet,
  abs1kdzbjes1idip as abs,
  flatten2dh4kibw1u0qq as flatten,
  reversed22y3au42jl32b as reversed,
  plus1ogy4liedzq5j as plus_2,
  Paire9pteg33gng7 as Pair,
  sorted354mfsiv4s7x5 as sorted,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  copyToArray2j022khrow2yi as copyToArray,
  lazy2hsh8ze7j6ikd as lazy,
  removeAll3o43e67jmwdpc as removeAll,
  trimIndent1qytc1wvt8suh as trimIndent,
  split2bvyvnrlcifjv as split_0,
  KtSetjrjc7fhfd6b9 as KtSet,
  intersect7qttw6wlmz1n as intersect,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  maxWithOrNullsohvqg0i6v8s as maxWithOrNull,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast_0,
  roundToInt1ue8x8yshtznx as roundToInt,
  sum1ib1hqt64m6qf as sum,
  lines3g90sq0zeq43v as lines,
  chunked1r6ubl9km7ic5 as chunked_0,
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
  equals2v6cggk171b6e as equals_0,
  withIndex37cl61h9v5txo as withIndex,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  mapOf1xd03cq9cnmy8 as mapOf_0,
  take9j4462mea726 as take,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr1amknydye3n5l as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  toNumberlmbpvqo27r53 as toNumber,
  Duration__toString_impl_8d916b1rke7yypzm7mk as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz6toho1mmc7plk as Duration__hashCode_impl_u4exz6,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  createThis2j2avj17cvnv2 as createThis,
  plus2lr02ok6jhhxu as plus_3,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  numberToLong345n6tb1n1i71 as numberToLong,
  multiply18i3gv3wlmcjg as multiply,
  toDurationba1nlt78o6vu as toDuration_1,
  Duration__compareTo_impl_pchp0f1g201z2whmah8 as Duration__compareTo_impl_pchp0f,
  toBits279h5gq970cl4 as toBits,
  Random2w0u2xak2xaqi as Random,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  isFinite1tx0gn65nl9tj as isFinite,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  sum2ku6kbgxq0lee as sum_0,
  putAlliz90jhzb8z23 as putAll,
  KProperty02ce7r476m8633 as KProperty0,
  coerceIn10f36k81le1mm as coerceIn_0,
  coerceIn1xblvmyr0tby6 as coerceIn_1,
  coerceAtMostfyc3emgaderp as coerceAtMost,
  EmptyCoroutineContext_getInstance2wsqunjuleo79 as EmptyCoroutineContext_getInstance,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  contains3ue2qo8xhmpf1 as contains_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  AnimationInsertionType_AfterAnswer_getInstance34al2mxixyzul as AnimationInsertionType_AfterAnswer_getInstance,
  MapUiScalingAndPosition2k3s7s83zg6ay as MapUiScalingAndPosition,
  AnimationInsertionType_BeforeAnswerDialog_getInstance2hlw194dds2yn as AnimationInsertionType_BeforeAnswerDialog_getInstance,
  BoardPositionsitk1ym6dh2p as BoardPosition,
  MovementToLocation3b1yqnpsrv3zb as MovementToLocation,
  HunterCharacter38ygd0hbflv64 as HunterCharacter,
  get_featheredKingBeast3ds5cujqs9d2j as get_featheredKingBeast,
  get_isRebornms8euzeh4o9v as get_isReborn,
  ArrivalOfTheTitanContract13gi06ak50pdw as ArrivalOfTheTitanContract,
  RegentOfRuinsContract2uh5qhq408jfw as RegentOfRuinsContract,
  UnlikelyAllianceContractmj9fxfufng2n as UnlikelyAllianceContract,
  AshfallUnlikelyAllianceContractnqvskokvowm3 as AshfallUnlikelyAllianceContract,
  AttackOnTheNorthernSettlementsContractnljrx0wqj9l3 as AttackOnTheNorthernSettlementsContract,
  DisturbanceOfTheNorthernGodsContract2d99s2shgl3us as DisturbanceOfTheNorthernGodsContract,
  UnleashingTheAbyssContract2mi9ncftoxq8b as UnleashingTheAbyssContract,
  SecretsFromALostAgeContract2wlj6eon17pbp as SecretsFromALostAgeContract,
  ShipwreckContractvhcr0iaqf5qa as ShipwreckContract,
  PactLongForgottenContract1h5yqqqzlt7ev as PactLongForgottenContract,
  GreatCleansingContract1ehz34qbzlcov as GreatCleansingContract,
  RecoveryTestContract28bbvevats5p6 as RecoveryTestContract,
  AbilityCardhe2jylhd819j as AbilityCard,
  AshRuinCard1xlfygy61t7p0 as AshRuinCard,
  AshRuin9af1oplpyi1v as AshRuin,
  BeastlyTalentCard2sm6mvj831dxe as BeastlyTalentCard,
  HunterItemCard2be7jfoohe5k1 as HunterItemCard,
  DraftActionCard2p0whed2o3gux as DraftActionCard,
  RecoveryTestBeastReaction1kwagmpmijvbt as RecoveryTestBeastReaction,
  RecoveryTestHunterReaction3oodngygstxnn as RecoveryTestHunterReaction,
  UnknownCard2e53k57p6pyog as UnknownCard,
  OverloadedCard189aar9snn659 as OverloadedCard,
  RecoveryTestCard2j29wtcvm3zds as RecoveryTestCard,
  RecoveryTestConditionCard1elvimztihpyq as RecoveryTestConditionCard,
  get_objectType3emg51nk00g59 as get_objectType,
  BeastCharacter1uqk4ouyve4z0 as BeastCharacter,
  FeatheredKinggsja93p8bm4d as FeatheredKing,
  SimpleObjectType2txv1j3swnokh as SimpleObjectType,
  HunterCompanionType1i9iozl89tih6 as HunterCompanionType,
  BoatType28zpq43km2292 as BoatType,
  SummonType2u4y5qg04ptyg as SummonType,
  EggType3070m439nl235 as EggType,
  SnareTokenTypenh9kgwqcjez7 as SnareTokenType,
  Companion_getInstance1fknlx0kyfzca as Companion_getInstance_0,
  BarrierSideType2l2klrjsko47h as BarrierSideType,
  NoMovement_getInstance1w2sjefrvmlkb as NoMovement_getInstance,
  RelocationStep3vrq1u0j5f80t as RelocationStep,
  PingLocationTypeElementywjrplr6ot1s as PingLocationTypeElement,
  LocationType1qb6l9yeqv2lm as LocationType,
  PingPlayableCardElement2tburza8qxuwr as PingPlayableCardElement,
  PlayableCard3pprsf907u3gl as PlayableCard,
  get_theLastAppliedMapUiScalingAndPosition36tc7xj0jrpsc as get_theLastAppliedMapUiScalingAndPosition,
  GameTeamukq9bbth76rc as GameTeam,
  _BoardPosition___init__impl__1nizgq3b7o6zwawcqwa as _BoardPosition___init__impl__1nizgq,
  GameMapImpl781em8e77vw5 as GameMapImpl,
  get_primaryLocations1gsr9lpfypqai as get_primaryLocations,
  anyAdjacentPositions3dmbyldstbpd0 as anyAdjacentPositions,
  get_beastMovements2v63x4co93x8o as get_beastMovements,
  get_armor3nlhdsrxq6kko as get_armor,
  get_woundsy66mfxvlb27u as get_wounds,
  get_gameRules1liejcou7uyku as get_gameRules,
  SettlerType3458v8k9hj1ql as SettlerType,
  get_allAliveAndDestroyedObjectsjr32nk0g2rm3 as get_allAliveAndDestroyedObjects,
  ObjectOnBoard26086xcy6gjq7 as ObjectOnBoard,
  FarmerType33h0bg4h185y3 as FarmerType,
  NobleTypezfpyd57afrmz as NobleType,
  _EntityId___get_id__impl__v6colhj2j6e8vmtk5h as _EntityId___get_id__impl__v6colh,
  _GameTeam___get_teamId__impl__chxeb33hu9tlgllqitv as _GameTeam___get_teamId__impl__chxeb3,
  BeastBalanceVersion_OfficialV2_getInstance17dyxpa9u5sup as BeastBalanceVersion_OfficialV2_getInstance,
  FeatheredKing_getInstancebsqevwcd17w0 as FeatheredKing_getInstance,
  Helga_getInstance3a4t2szsrwroo as Helga_getInstance,
  Varja_getInstanceczhyz7rvxazb as Varja_getInstance,
  GameSetupStatech68jqj7snwm as GameSetupState,
  Companion_getInstancekrqf3naab3jt as Companion_getInstance_1,
  BeastResourceKind_Game_getInstance2dv9wvjfknbes as BeastResourceKind_Game_getInstance,
  _GameTeam___init__impl__xtwsj231o4obpkk4kig as _GameTeam___init__impl__xtwsj2,
  BeastResourceLookupRequestvc1aq5f9azrx as BeastResourceLookupRequest,
  BeastResourceKind_Replay_getInstance2zdoghkni2ipv as BeastResourceKind_Replay_getInstance,
  get_clientSetupOrNull24ih5m60r311v as get_clientSetupOrNull,
  ReconnectSandboxInitlrmvjd4l15ek as ReconnectSandboxInit,
  ReconnectSandboxPlaying17178inq9l5qg as ReconnectSandboxPlaying,
  get_quixoteTournamentGameskkrf2cv2rg4y as get_quixoteTournamentGames,
  GameStatus_Active_getInstance3chctqjxg3jks as GameStatus_Active_getInstance,
  Authenticated1k16izbzywuc1 as Authenticated,
  get_onboardingReplayCode205sqpfv0ig6i as get_onboardingReplayCode,
  GameMapId_NorthernExpanse_getInstanceja56uoofw23u as GameMapId_NorthernExpanse_getInstance,
  get_northernExpanseMap1aduyn0miqdi7 as get_northernExpanseMap,
  Failure_getInstancel0d9s04nwytw as Failure_getInstance,
  Success1uwr7ypqp5n7 as Success,
  ReplaySharingStatus_Shared_getInstance1hble5m08dwr0 as ReplaySharingStatus_Shared_getInstance,
  GameCodew6y6zhq2wcqb as GameCode,
  PrintingGameRuntimeDiagnostics_instanceknsic9pmcauw as PrintingGameRuntimeDiagnostics_instance,
  checkReplayFromServer25mn7g2penfi9 as checkReplayFromServer,
  ExceptionInReplaying14asrtiz93hs1 as ExceptionInReplaying,
  IncompleteGame_instance3c80wqcf225mu as IncompleteGame_instance,
  GameIsEnded2jecydki34mwe as GameIsEnded,
  GameIsNotFound_instance3st242a02waaj as GameIsNotFound_instance,
  get_beastsGameTeam1y1bdmzuny63m as get_beastsGameTeam,
  get_huntersGameTeamiqiqxeugntgm as get_huntersGameTeam,
  SimpleSavedAnswersSource1q6p7wrygyrx6 as SimpleSavedAnswersSource,
  BeastClientFeature_Sandbox_getInstance2c28w3ydqvi6k as BeastClientFeature_Sandbox_getInstance,
  BeastClientFeature_NetworkPlay_getInstance1zx8ribqem7ec as BeastClientFeature_NetworkPlay_getInstance,
  get_isObserver1kfscec5yzvwu as get_isObserver,
  GameMapId_LowerShatteredIsles_getInstance3se76dqva57oi as GameMapId_LowerShatteredIsles_getInstance,
  displayText10ak5kx15v05p as displayText,
  Maintenance1ei8arz2p2x9n as Maintenance,
  GameSessionReloadRequiredExceptionrlm8v4elghny as GameSessionReloadRequiredException,
  BeastGameI18n27oawf53dbph6 as BeastGameI18n,
  get_gameContentVersion1sb5b1ke1q3q5 as get_gameContentVersion,
  get_allSnaresOnMap1q4vx1fc5qdr1 as get_allSnaresOnMap,
  get_trapPositions2uuqt6g008o2u as get_trapPositions,
  SnareTokenType_getInstance257hn24f6c5bh as SnareTokenType_getInstance,
  get_snareType1ik2geux83au9 as get_snareType,
  splitCamelCase139v8b5swfsah as splitCamelCase,
  InitialPhase39dki7vc6ulgd as InitialPhase,
  PreGamePhase_getInstance32azpmvb01l0c as PreGamePhase_getInstance,
  get_aliveBeastsjroki3mewg6w as get_aliveBeasts,
  get_allBoats3s3ys2y5nhkd5 as get_allBoats,
  Draug3ng4a642yl4k6 as Draug,
  get_draugWillRespawn36hp3zlssxv21 as get_draugWillRespawn,
  get_isDead38rur7mguay67 as get_isDead,
  get_lastSeenPosition1bmb9emrfxren as get_lastSeenPosition,
  get_activeRuinPositions2ki1ytkqnd4d3 as get_activeRuinPositions,
  GameMapId_UpperShatteredIsles_getInstance3hab63460kmdv as GameMapId_UpperShatteredIsles_getInstance,
  get_hazePositionsomol4lef56yz as get_hazePositions,
  WatchtowerType3n9ika29zft6b as WatchtowerType,
  LocationType_Settlement_getInstance2car1ynp5y6zn as LocationType_Settlement_getInstance,
  get_locationType1iwvq3c1f588i as get_locationType,
  AnimalType22lyi8vxi27kq as AnimalType,
  WatchtowerType_getInstance21xrgbyvptnnt as WatchtowerType_getInstance,
  BoatType_getInstance22oq9xcnlzgdx as BoatType_getInstance,
  get_foundTrails39zuttqc7mve9 as get_foundTrails,
  get_possibleTrailMaxCounts28c1al5n7y681 as get_possibleTrailMaxCounts,
  GameMapId_DrenchedLands_getInstance3jqbk3r1gau8o as GameMapId_DrenchedLands_getInstance,
  GameTeam__toString_impl_wfw0a61jglj7o24etxt as GameTeam__toString_impl_wfw0a6,
  get_maxTrapsInZonet3h7ldp564ls as get_maxTrapsInZone,
  BoardPosition__toString_impl_v4mn8218g3ra1bvw0ej as BoardPosition__toString_impl_v4mn82,
  reportWarning2za12zxcfzdkq as reportWarning,
  summonsOnMap2jrlywmkxceyb as summonsOnMap,
  PingBoardPositionElement3jp6ants0c1vo as PingBoardPositionElement,
  BoardPosition__hashCode_impl_9dgqf728yia8xgzt4tw as BoardPosition__hashCode_impl_9dgqf7,
  get_urgullBeastoxtbjmyn6c1z as get_urgullBeast,
  waitWithPossibilityToCancel3i4azlg87zlwy as waitWithPossibilityToCancel,
  get_discardedAbilityCards2lgm76btfolpt as get_discardedAbilityCards,
  UrgullMoltEggsToReturnQuestionContext_getInstance3pclzjxi4gieg as UrgullMoltEggsToReturnQuestionContext_getInstance,
  get_rhagnerBeast29f8i1pwhuu9c as get_rhagnerBeast,
  hoardLevel2yd0h3d12kz93 as hoardLevel,
  Rhagner3ir3yf8tt0g9y as Rhagner,
  get_remainMoltEggsOnCounter1876m25lbah7q as get_remainMoltEggsOnCounter,
  EggType_getInstance1xq9fa9c5vb0a as EggType_getInstance,
  Urgull14bymagpm5zhk as Urgull,
  get_upgradedfcwwucgzg7oz as get_upgraded,
  PlayableInTurnCard42ypiyt9kpf0 as PlayableInTurnCard,
  PlayCardVariant161wiv7hcla9a as PlayCardVariant,
  DiscardToUseBoatVariant2oye4xzerue9s as DiscardToUseBoatVariant,
  DiscardToMoveVariant2dn9qapt834sf as DiscardToMoveVariant,
  Valdip1yeojjk8cqk as Valdi,
  Vacker_getInstance34go2d0btpfmm as Vacker_getInstance,
  Vacker2dbhyn0l3t8gh as Vacker,
  Lydan1m39xongr8vnb as Lydan,
  get_gameTeam2n0lwzk003zju as get_gameTeam,
  get_hand3l0uqiz1oyo3x as get_hand,
  PassVariantdfzww27calua as PassVariant,
  PassVariant_getInstance2kz950waz5v92 as PassVariant_getInstance,
  Mara3nuuraz5dqcns as Mara,
  FlickerCard3guwxqqx674ba as FlickerCard,
  get_allHunters6f2oagp44xgv as get_allHunters,
  Sigrid3d5n0kj6cswml as Sigrid,
  pactTerrain1a6opylccrt4c as pactTerrain,
  SigridAbilityCard2jewmoyuedyv2 as SigridAbilityCard,
  RhagnerCard3u0r0iubs9h6q as RhagnerCard,
  HandPlace2nuj4crujja2o as HandPlace,
  LocationType_Forest_getInstance1oasfju4nlnmj as LocationType_Forest_getInstance,
  LocationType_Cave_getInstance5qwid1edsoph as LocationType_Cave_getInstance,
  LocationType_Swamp_getInstance5r63dmfn758b as LocationType_Swamp_getInstance,
  SigridPactChangeEventnrcfurixoo80 as SigridPactChangeEvent,
  GeneralCardMoveEventp0piwr0iypgm as GeneralCardMoveEvent,
  MoveCardToDiscardEvent29og51w3k7qb3 as MoveCardToDiscardEvent,
  withGameContentVersion96x7zrrhnbg7 as withGameContentVersion,
  availableBeasts7ht1uscvapvp as availableBeasts,
  availableHunters2hbxoiz7l702d as availableHunters,
  Companion_getInstance382hvo2hsz7qp as Companion_getInstance_2,
  Bolgin_getInstance18yrqria3do4a as Bolgin_getInstance,
  get_entries3qv2ciyxxgr7x as get_entries,
  getDraftActionCardDeckru9elefunceo as getDraftActionCardDeck,
  getHunterItemCardDeck1n7thpi2l0ho as getHunterItemCardDeck,
  getBeastTalentCardDeck16ah5hukb8dpj as getBeastTalentCardDeck,
  BeastGameExpansions_ShatteredIsles_getInstance33verx6u4dl6s as BeastGameExpansions_ShatteredIsles_getInstance,
  BeastGameExpansions_TheGreatHunt_getInstance1uqkzoanwkf2v as BeastGameExpansions_TheGreatHunt_getInstance,
  BeastGameExpansions_Ashfall_getInstance1yhnjjgaypnsy as BeastGameExpansions_Ashfall_getInstance,
  GameContentVersion2in87ovmr1f1t as GameContentVersion,
  PlayerTurnPhase3jebsnvqgqk4f as PlayerTurnPhase,
  StartOfDayPhase_getInstance2cvqhztbl5ndi as StartOfDayPhase_getInstance,
  ValdiBloodChangeEventcefi38h24p9e as ValdiBloodChangeEvent,
  GrudgesChange1hwnzcjnj3ggw as GrudgesChange,
  CardsMoveChange319naf3gzozo9 as CardsMoveChange,
  LydanHarvestChangeEvent2wsgg1f93atl7 as LydanHarvestChangeEvent,
  DraugCorruptionChangeEvent2chzjiqztj3vy as DraugCorruptionChangeEvent,
  DestroyedChange21pxfb6dpt14f as DestroyedChange,
  TrailsRevealedChange19a0704imq1zq as TrailsRevealedChange,
  ClearingAfterRevealChange15mu5ijozlp03 as ClearingAfterRevealChange,
  HpChange1pdyid6siekap as HpChange,
  TransformLocationsChange2j3lp2mexkv5e as TransformLocationsChange,
  RevealLastMovementsChangeaetbg9ekii3o as RevealLastMovementsChange,
  BeastMovementInfoChange24yaol0g17fut as BeastMovementInfoChange,
  AddObjectChange278kvdy0l1oj8 as AddObjectChange,
  MovementChange19pzlthnrwra6 as MovementChange,
  UpgradeChange27frns3779qmd as UpgradeChange,
  RuinClaimedChangeEvent35w18jwxo6a44 as RuinClaimedChangeEvent,
  TechnicalGameStateChangeEventzmo2jun5l9vf as TechnicalGameStateChangeEvent,
  AncientPowersChangeEventg9y239jenjid as AncientPowersChangeEvent,
  DraftResultEventzgyj0pnd4ilk as DraftResultEvent,
  get_isRevealed1yvfqt0zljrxx as get_isRevealed,
  Character3krewb5f2wgpd as Character,
  get_beastPath1rk9ruz7s55jx as get_beastPath,
  Valdi_getInstance2kbkzzgcn4q7n as Valdi_getInstance,
  Draug_getInstance2hvbdj9fayw5u as Draug_getInstance,
  Lydan_getInstancef2ktq2h74zdo as Lydan_getInstance,
  DiscardPlace37wz47wxt9u59 as DiscardPlace,
  InPlayPlace2jwkgqes0qnwm as InPlayPlace,
  ComingArsenalPlace1rmt4yby3260a as ComingArsenalPlace,
  DraftOfferPlace1a6vns5kmwnyz as DraftOfferPlace,
  UnusedDraftActionCardPlace3pw0vv13ylf81 as UnusedDraftActionCardPlace,
  DraftRemovedPlace262eblh5g0ymj as DraftRemovedPlace,
  DraftPickedPlace2pm40ebjh07tk as DraftPickedPlace,
  TrapZonePlace33435udmwai9n as TrapZonePlace,
  InPlayPlace_getInstance2f5lcwhn2zg3y as InPlayPlace_getInstance,
  PendingTriggerPlace_getInstance651wnzyb3dh1 as PendingTriggerPlace_getInstance,
  RevealedArsenalPlace_getInstance3ex2xtf4e2o0l as RevealedArsenalPlace_getInstance,
  get_observerGameTeamMarker1qs5fpmrf9k41 as get_observerGameTeamMarker,
  get_fullObserverGameTeamMarker14m9rs3amysry as get_fullObserverGameTeamMarker,
  ControllingActorWithTeam37tsri2skoun6 as ControllingActorWithTeam,
  ControllingByNothing_getInstance2c4rzcwq95354 as ControllingByNothing_getInstance,
  get_regentBeastDominion2ddqq8n0pikrs as get_regentBeastDominion,
  get_regentHunterDominion2eyw5jcfvrosx as get_regentHunterDominion,
  isActiveCharacter1iqi5h29m2d7v as isActiveCharacter,
  get_sharedBeastWounds3obm55vwm9wbk as get_sharedBeastWounds,
  get_entries31bl1p047haec as get_entries_0,
  CardResolvingScopeo6edtcb2em1t as CardResolvingScope,
  CardApplyingScope11xap9foibge3 as CardApplyingScope,
  ItselfGameScopeixkmiax6rfu6 as ItselfGameScope,
  NightlyRewardScopet0984yjfmx8d as NightlyRewardScope,
  EventTriggeredByEffectSourceScope8k4kzzzjpklm as EventTriggeredByEffectSourceScope,
  InAnyOrderStatement3nhelwgdl08bc as InAnyOrderStatement,
  ReceiveSelfDamageStatement26hkqlh9lf3q7 as ReceiveSelfDamageStatement,
  TextItselfGameScope3j2g5tkltixzt as TextItselfGameScope,
  ChooseSettlerForFlareScope2cnw1lqs9yl4s as ChooseSettlerForFlareScope,
  PerformForEachHunter19ocvyousvwzh as PerformForEachHunter,
  EffectsAfterEventScope2316n42q54x3 as EffectsAfterEventScope,
  EffectRecoveryScopehc0528dsuwxx as EffectRecoveryScope,
  PhaseRecoveryScope2rec0tb2zj111 as PhaseRecoveryScope,
  GamePhase4nnhltrkwx9 as GamePhase,
  withStateRuntimew7ff1nikw1ne as withStateRuntime,
  ActionStatement1cnx41a7x8ztj as ActionStatement,
  ControllingByTeam2zv2dp917uply as ControllingByTeam,
  Zone_Barum_getInstance1a6gvpi0jgre1 as Zone_Barum_getInstance,
  Zone_Vildmark_getInstance1gdneryyqfus0 as Zone_Vildmark_getInstance,
  Zone_NewElda_getInstance2qydukshuw1zj as Zone_NewElda_getInstance,
  Zone_Jarlland_getInstance5fa3bdvcmi69 as Zone_Jarlland_getInstance,
  PossibleSnareEffectSourcetosaj8s8us9u as PossibleSnareEffectSource,
  MistShroudCard_getInstance3uv8n1crygurh as MistShroudCard_getInstance,
  PossibleMistShroudEffectSource3appntjopbvbn as PossibleMistShroudEffectSource,
  PossibleTrapEffectSourceys7r185zm215 as PossibleTrapEffectSource,
  ReactionCardTriggerEffectSourcetvvfmrch2yox as ReactionCardTriggerEffectSource,
  TriggerOption2pgl0oruzacgq as TriggerOption,
  ActivateTrapStatementc2tmhrxm1c7b as ActivateTrapStatement,
  ApplyingReactionStatements4puuyqhz01m as ApplyingReactionStatement,
  SubmitDamageEventvqtjysdjmffa as SubmitDamageEvent,
  AssignDamageEventbd1j3fwefeyf as AssignDamageEvent,
  SummonSignStatement1zd9rsibb55e3 as SummonSignStatement,
  BarrierConnectedLocationQuestion2mxsuoje65g5h as BarrierConnectedLocationQuestion,
  SearchLocationQuestion2ib0yfp46z7bp as SearchLocationQuestion,
  GrapnelQuestion2ejkh7zbeaiey as GrapnelQuestion,
  PlaceNewObjectQuestion2hcww1pm3bmd7 as PlaceNewObjectQuestion,
  TransformLocationQuestion1tv0p4ejdq4vl as TransformLocationQuestion,
  PlaceNewSummonStatementeosdppc20njc as PlaceNewSummonStatement,
  ObjectMovementStatementj19wgjylk9qc as ObjectMovementStatement,
  RelocationToSettlementStatement334b0gc15d23z as RelocationToSettlementStatement,
  get_anotherTeamutq24fcfkdxz as get_anotherTeam,
  TwoPlayerDraftStage_Collecting_getInstance7f6a3c5zapf0 as TwoPlayerDraftStage_Collecting_getInstance,
  ArsenalCard1dzcx66vhdy8c as ArsenalCard,
  get_hp5i5yy7amjofz as get_hp,
  BeastMovementCardVariant1uhqn86k5upnb as BeastMovementCardVariant,
  withStateRuntime2d9i5e0jyf3jd as withStateRuntime_0,
  ActivateSnareStatement1wruo5nt9idp as ActivateSnareStatement,
  ClaimRuinStatement185uv9kkqwsfh as ClaimRuinStatement,
  ClaimRuinEffectSourcej1lo46onr4b5 as ClaimRuinEffectSource,
  KillingSettlersClassicGameRules3dmq0tt3d68ga as KillingSettlersClassicGameRules,
  PreGamePhase1lpc1yt5gf143 as PreGamePhase,
  ContractInitPhasebbm6nkk1m701 as ContractInitPhase,
  StartOfDayPhase1wag7duwxz8be as StartOfDayPhase,
  DawnPhase1gkmlp1a4ffp0 as DawnPhase,
  NightPhase3kd1qmzjhtveh as NightPhase,
  TrapCard396b5rurkq1ij as TrapCard,
  ChooseCardOnDraftQuestion3dw7wif1c6a1e as ChooseCardOnDraftQuestion,
  InternalRevertError2kax2xf0fyfgs as InternalRevertError,
  AnotherAnswerReaction_ForbidOtherVariants_getInstancevc6cy4m8d97y as AnotherAnswerReaction_ForbidOtherVariants_getInstance,
  GameWarningEvent2zcfmcsaq1i2r as GameWarningEvent,
  GameQuestionIsComingEvent1d9w5034cvxfd as GameQuestionIsComingEvent,
  ReplayIsFinishedEvent2n430pt3g6q9k as ReplayIsFinishedEvent,
  DraftStateEvent1fq4tkme4t2vi as DraftStateEvent,
  get_currentControllingActoroj43490lha6t as get_currentControllingActor,
  GameScopesChangeEvent3ju8pn6l9637u as GameScopesChangeEvent,
  KnownCardsInfoChangeEvent3sv94itf1uqqr as KnownCardsInfoChangeEvent,
  StartPhaseEvent16kv7wan6gsti as StartPhaseEvent,
  EndOfGameEvent1sosaowh7mxa2 as EndOfGameEvent,
  ReplayNotificationPlainText23jr293j6g42c as ReplayNotificationPlainText,
  ReplayNotificationEventyrin55udv7ge as ReplayNotificationEvent,
  InitGameStateEvent3t2iihh898bro as InitGameStateEvent,
  get_currentControllingTeammrvmv09flsoh as get_currentControllingTeam,
  get_isReplayOpenGame12931rjijwgm8 as get_isReplayOpenGame,
  ChooseCharacterQuestion15prhcvmg0xx6 as ChooseCharacterQuestion,
  BooleanGameQuestion1x6xc30ycsl8k as BooleanGameQuestion,
  CardPlayColorQuestion1njsep2xnid70 as CardPlayColorQuestion,
  UrgullMoltEggsToReturnQuestionn32b555is0iq as UrgullMoltEggsToReturnQuestion,
  TrapByNumberQuestion2bnfeidyvay5a as TrapByNumberQuestion,
  ZoneQuestion1169zovvoqch5 as ZoneQuestion,
  BeastMovementCardQuestion1j0j9jcqebpmg as BeastMovementCardQuestion,
  LocationTypeQuestion1z8yhezyamvr0 as LocationTypeQuestion,
  AncientPowerNumberQuestion3cdrapqw1ph4u as AncientPowerNumberQuestion,
  SnareTypeQuestion3gp1wpngxoqkh as SnareTypeQuestion,
  TriggersQuestionesdw70q2hiv1 as TriggersQuestion,
  StatementQuestion1lxt2f1cnz3ov as StatementQuestion,
  PlayCardInTurnQuestion1hww2zcmfisni as PlayCardInTurnQuestion,
  ChooseCardsQuestion236iunubwe5yh as ChooseCardsQuestion,
  LocationQuestionBase36b8zbqeeqjum as LocationQuestionBase,
  DestinationQuestion3h9r448czxeoe as DestinationQuestion,
  ObjectsGameQuestion2boxyklmnsg55 as ObjectsGameQuestion,
  get_charactersInOrder24hmg1035jqha as get_charactersInOrder,
  UpgradeQuestion1yilwq9twob5k as UpgradeQuestion,
  PhaseRecoveryQuestiono68nj60zs5zl as PhaseRecoveryQuestion,
  ContinueAfterRecoveryQuestioniefkyt7x2a8e as ContinueAfterRecoveryQuestion,
  reportRevisionProblemx3ecmwf56p42 as reportRevisionProblem,
  applyGameStateChanges2qkrglekht180 as applyGameStateChanges,
  applyGameStateRevertChanges2cqxaiql63aht as applyGameStateRevertChanges,
  applyGameStateRevertChanges3ubrnoso5bc81 as applyGameStateRevertChanges_0,
  MasterFixingSupportingAgent3u14yuiuqy94 as MasterFixingSupportingAgent,
  RevertSupportingAgent2za8f9p9lpp6u as RevertSupportingAgent,
  CurrentAndOldStateHolder3bqy5ulcjm8zl as CurrentAndOldStateHolder,
  PingingSupportni7c00aatics as PingingSupport,
  get_draugCorruptionLevel1xfp6vt0i1e2d as get_draugCorruptionLevel,
  get_lydanHarvest5icslm7ws8fu as get_lydanHarvest,
  get_valdiBlood22b7tn918k79i as get_valdiBlood,
  get_activeSouls2umaut8f7g41p as get_activeSouls,
  get_ancientPowerNumber37fr4tjx316p1 as get_ancientPowerNumber,
  get_grudgesNumberemxuaukf6ake as get_grudgesNumber,
  AttackStatement2n5hixt2vwt0t as AttackStatement,
  get_gameScopes2i9ao2ct38ate as get_gameScopes,
  PursuitCard_getInstance3i4l9ond3aid0 as PursuitCard_getInstance,
  ChooseOneOfStatementtgfmlmn00b3t as ChooseOneOfStatement,
  SearchForBeastStatementoiylf8xsp03m as SearchForBeastStatement,
  RecoveryTestForEachHunterStatement2sx4cffup3gnr as RecoveryTestForEachHunterStatement,
  RecoveryTestStatementhvrsvmszxsi3 as RecoveryTestStatement,
  ServerDuelSetupGameData2xlhmtkxgqzhf as ServerDuelSetupGameData,
  GameStartedizt21rsqpez9 as GameStarted,
  SetupUpdate31qygov2ekgx1 as SetupUpdate,
  SetupEnded27wh719dvkgtt as SetupEnded,
  NotFoundSetupSession2fi0jcpix5z9h as NotFoundSetupSession,
  get_entriesmnvhd7ghbgdn as get_entries_1,
  ShowFromDraft1q47jdcfdvgaf as ShowFromDraft,
  ShowFromPossibleAnswer26qvl7hbxc2l1 as ShowFromPossibleAnswer,
  ShowLocationAnimation8r0phb0sqqsc as ShowLocationAnimation,
  LogicalAnimationInsertionkobo11jcfxo as LogicalAnimationInsertion,
  replayTimelineFromSavedAnswers2b1z3180sw5jq as replayTimelineFromSavedAnswers,
  NightPhase_getInstance7ju3w96rz5 as NightPhase_getInstance,
  objectsAt1wc3nedu6wl0q as objectsAt,
  Omma_getInstance2wma8u9a3daxi as Omma_getInstance,
  get_allWatchtowers12ow0abuqxf59 as get_allWatchtowers,
  get_isHidden25d33ee7ol8iu as get_isHidden,
  BeastMovementStatement10g5ibipn3yne as BeastMovementStatement,
  get_place1e3pq2ygsurlg as get_place,
  RevealedArsenalPlace39rhzo8riphf9 as RevealedArsenalPlace,
  get_aliveHunters2br5806nqjy4d as get_aliveHunters,
  get_rhagnerHoardLevels208363hg8hv74 as get_rhagnerHoardLevels,
  ClassicGameRules33zhcezp3h11r as ClassicGameRules,
  direction28a381npiuq8u as direction,
  get_entries3qy97tw50smvt as get_entries_2,
  GainGrudgesEvent2f9md6n75zqvn as GainGrudgesEvent,
  ObjectRemoveForReplacingEventzckex55rv9kr as ObjectRemoveForReplacingEvent,
  NewSimpleObjectEvent2xofhungb2zip as NewSimpleObjectEvent,
  forBeast2v94z7eg8vrvp as forBeast,
  get_nearbyPositions3w7xiiozyhnb as get_nearbyPositions,
  DoubleUpgrade_getInstance31zs7lhuj156b as DoubleUpgrade_getInstance,
  SandboxDamage_getInstance3gn8f2i76f5yx as SandboxDamage_getInstance,
  DamageKind_Other_getInstance3uj3szrtilc3n as DamageKind_Other_getInstance,
  DamageToTargetrk1vyhkkkcr1 as DamageToTarget,
  DealingDamage39kbnhy54vbsh as DealingDamage,
  ApplyDamageEvent1ksol0gohmdlc as ApplyDamageEvent,
  CheckForDestroyEvent3d9009ucbvqzf as CheckForDestroyEvent,
  UpgradeEvent32qat54v0z8iw as UpgradeEvent,
  ChargingUpgradeChangeEvent2ay3u09ue8job as ChargingUpgradeChangeEvent,
  ChargingUpgrade2ater9ebzgtog as ChargingUpgrade,
  ChangeFeatheredKingRebornStatusEvent3quauhy48i2pi as ChangeFeatheredKingRebornStatusEvent,
  get_chargedrtnmfyqtzipz as get_charged,
  RemoveUpgradeEventar63xzq5wtut as RemoveUpgradeEvent,
  outpostEventsrrk6vtwwj2p as outpostEvent,
  Akkeronx0mr6kdyywai as Akkeron,
  LocationType_AbyssalSwamp_getInstance17y2qx5p1qvct as LocationType_AbyssalSwamp_getInstance,
  Urgull_getInstance3a76hoxqtzui9 as Urgull_getInstance,
  LocationType_LivingWeb_getInstancebbhunpk3v3ia as LocationType_LivingWeb_getInstance,
  LocationType_AbyssalForest_getInstance1ja42pe8bgojv as LocationType_AbyssalForest_getInstance,
  TransformLocationsEvent1scwjttf6r1c6 as TransformLocationsEvent,
  TrailsRevealedEvent119ggsxe5h312 as TrailsRevealedEvent,
  RevealBeastEvent1j7ikciugv30k as RevealBeastEvent,
  MovementEvent3rq8oh2k4k02t as MovementEvent,
  MovementType_SimpleMovement_getInstance1uz87gun0unmu as MovementType_SimpleMovement_getInstance,
  MovementType_AbyssalSwampRelocation_getInstancews51g4r3b0b2 as MovementType_AbyssalSwampRelocation_getInstance,
  BeastPathStep2a73znugzotom as BeastPathStep,
  HiddenBeastMovement2joofxxwmdb06 as HiddenBeastMovement,
  MovementEvent2k96wxlpbvifd as MovementEvent_0,
  SetTrapEvent3jphfp2n6c124 as SetTrapEvent,
  ComingArsenalPlace_getInstance2vl9crpg7k01w as ComingArsenalPlace_getInstance,
  get_arsenalType1qrfd4hudz0ix as get_arsenalType,
  get_fullArsenalDeck1z5yb8ce5gwuf as get_fullArsenalDeck,
  GainLydanHarvestEvent31un4l003o7sw as GainLydanHarvestEvent,
  GainDraugCorruptionEvent142c76w3im5rg as GainDraugCorruptionEvent,
  UrgullMoltCounterChangeEventxjeeomb22655 as UrgullMoltCounterChangeEvent,
  SandboxStartParams25sblc3uw8123 as SandboxStartParams,
  HealEvent1sec7vk747aui as HealEvent,
  RhagnerHoardChangeEvent15e727qzym1dl as RhagnerHoardChangeEvent,
  SetSnareMetadataChangeEvent2nngfb98rf27m as SetSnareMetadataChangeEvent,
  get_entries2eem4mm272l8m as get_entries_3,
  SheepType_getInstanceosw2mgv1ahze as SheepType_getInstance,
  BoarType_getInstancelj86bx70vwz2 as BoarType_getInstance,
  BearType_getInstancejcggwf9elj4y as BearType_getInstance,
  NobleType_getInstance1r6cwnd2g0702 as NobleType_getInstance,
  FarmerType_getInstance14w50gs5cbmwd as FarmerType_getInstance,
  get_isAliveType7jtvbe6xddjq as get_isAliveType,
  EsmeriaBeast260au4fsv2p4h as EsmeriaBeast,
  Raaga2g4ue0crvpgfn as Raaga,
  Fangrir1ysz7v8x50mvh as Fangrir,
  Bolgin2aemms6gmbcjq as Bolgin,
  Hogbad1eky9nlnf1e9v as Hogbad,
  Thalduk1o6n5dtg7k8w1 as Thalduk,
  Omma3br73yc1t9rjd as Omma,
  Bramm1nwrg7wamy0 as Bram,
  BloodLustUpgrade_getInstance3gf04019jszwl as BloodLustUpgrade_getInstance,
  EnragedUpgrade_getInstance18e2yxqwr5rop as EnragedUpgrade_getInstance,
  GreatHowlUpgrade_getInstancegrbczsyeuir2 as GreatHowlUpgrade_getInstance,
  HuntingGroundsUpgrade_getInstancehzfigy26gb14 as HuntingGroundsUpgrade_getInstance,
  KinsPursuitUpgrade_getInstance1rfbufk683z9w as KinsPursuitUpgrade_getInstance,
  NaturalInstinctUpgrade_getInstance2jhnvjsm07evu as NaturalInstinctUpgrade_getInstance,
  CullingUpgrade_getInstance3i70g5l3yzfng as CullingUpgrade_getInstance,
  WrathOfEirtirUpgrade_getInstance1ukz51msowrjl as WrathOfEirtirUpgrade_getInstance,
  LeviathanUpgrade_getInstanceytiw8l7ftv0s as LeviathanUpgrade_getInstance,
  MendrsFuryUpgrade_getInstance1somg3owwtysw as MendrsFuryUpgrade_getInstance,
  DrownerUpgrade_getInstance11l9zsho0vyqx as DrownerUpgrade_getInstance,
  TorrentialUpgrade_getInstance1lhvskg9n62q2 as TorrentialUpgrade_getInstance,
  DevourerUpgrade_getInstance11qreoglxcrn3 as DevourerUpgrade_getInstance,
  FatalGazeUpgrade_getInstance239xcg7obmdzt as FatalGazeUpgrade_getInstance,
  EndlessStruggleUpgrade_getInstance3e5mbp8e0ck9d as EndlessStruggleUpgrade_getInstance,
  AccursedWrathUpgrade_getInstance2lvzjm7qtjsw2 as AccursedWrathUpgrade_getInstance,
  KillingsSpreeUpgrade_getInstance3um30ypdt52vx as KillingsSpreeUpgrade_getInstance,
  SinisterActUpgrade_getInstancedt5qprytadpo as SinisterActUpgrade_getInstance,
  MesmeriseUpgrade_getInstance2e9pao5yuxi3p as MesmeriseUpgrade_getInstance,
  TrueInstinctEsmeriaBeastUpgrade_getInstance371p291rupbvu as TrueInstinctEsmeriaBeastUpgrade_getInstance,
  DeathsLamentUpgrade_getInstance2mjyldliozs6b as DeathsLamentUpgrade_getInstance,
  SoulHarvestUpgrade_getInstance1l4rsbsawdx1q as SoulHarvestUpgrade_getInstance,
  PandemoniumUpgrade_getInstance352dekrjnj6tj as PandemoniumUpgrade_getInstance,
  SongOfTemptationUpgrade_getInstancezc5lwjxetfhp as SongOfTemptationUpgrade_getInstance,
  VanishUpgrade_getInstance1rd8tilpn88ax as VanishUpgrade_getInstance,
  VoidPresenceUpgrade_getInstance3bvs07jkr4kvw as VoidPresenceUpgrade_getInstance,
  FearTheNightUpgrade_getInstance35v6gkg0dcuw8 as FearTheNightUpgrade_getInstance,
  RampageousUpgrade_getInstance20qler45ed3tk as RampageousUpgrade_getInstance,
  InfernalTusksUpgrade_getInstanceu0eoxm7jk7ly as InfernalTusksUpgrade_getInstance,
  HordesMarchUpgrade_getInstance26pw31qnofh8z as HordesMarchUpgrade_getInstance,
  WildOdeUpgrade_getInstance3u97dbufeuewd as WildOdeUpgrade_getInstance,
  ChiefsCommandUpgrade_getInstance2dxya4qj8ztm6 as ChiefsCommandUpgrade_getInstance,
  PrimalInstinctsUpgrade_getInstance3jei4xwog5utn as PrimalInstinctsUpgrade_getInstance,
  AmassUpgrade_getInstance1lglbend3dcs6 as AmassUpgrade_getInstance,
  MirrorBeastUpgrade_getInstance1shruqdzgscbq as MirrorBeastUpgrade_getInstance,
  GoldenBeakUpgrade_getInstanceep4gkqslzxck as GoldenBeakUpgrade_getInstance,
  SoulHarvestVackerUpgrade_getInstance38wps62shyf9 as SoulHarvestVackerUpgrade_getInstance,
  SwiftKillUpgrade_getInstance1xv48hy8o2ds1 as SwiftKillUpgrade_getInstance,
  EntrancingUpgrade_getInstance1fg34bq2ch6cd as EntrancingUpgrade_getInstance,
  ReveranceUpgrade_getInstancesnpfe741c1op as ReveranceUpgrade_getInstance,
  CloudShiftUpgrade_getInstance2chygpwnezhfk as CloudShiftUpgrade_getInstance,
  BehornedUpgrade_getInstance17amq8wb5hhnr as BehornedUpgrade_getInstance,
  StormBringerUpgrade_getInstance3pokdtb8vvwpn as StormBringerUpgrade_getInstance,
  EruptionUpgrade_getInstance263d2jis24mnw as EruptionUpgrade_getInstance,
  SuddenShockUpgrade_getInstance1uw03c9hgdvlz as SuddenShockUpgrade_getInstance,
  DischargeUpgrade_getInstancej0tjvxw7ax3l as DischargeUpgrade_getInstance,
  StarFallUpgrade_getInstance3aqpg9j0iuxiv as StarFallUpgrade_getInstance,
  VoidCallUpgrade_getInstance3py8q7h5c5cmy as VoidCallUpgrade_getInstance,
  AbyssalBeastUpgrade_getInstance1hc669c99ktee as AbyssalBeastUpgrade_getInstance,
  EchoUpgrade_getInstancefvvlof0n29pi as EchoUpgrade_getInstance,
  EternityUpgrade_getInstance3b3forivta0sz as EternityUpgrade_getInstance,
  VoidStepUpgrade_getInstance1sc7gm2am3nty as VoidStepUpgrade_getInstance,
  DarkSpawnUpgrade_getInstance38lcsze0o5g0p as DarkSpawnUpgrade_getInstance,
  InfestationUpgrade_getInstance3blcpcc0mlcbx as InfestationUpgrade_getInstance,
  WitheringMawUpgrade_getInstance3mcgrufbw5wa3 as WitheringMawUpgrade_getInstance,
  UnendingHungerUpgrade_getInstance1epf05k4acriw as UnendingHungerUpgrade_getInstance,
  BlightUpgrade_getInstance11xwyn7uiptsy as BlightUpgrade_getInstance,
  ExpandTheMarshUpgrade_getInstance30knaujkdik0a as ExpandTheMarshUpgrade_getInstance,
  LurkingDeadUpgrade_getInstance1yt05hff6zhux as LurkingDeadUpgrade_getInstance,
  CascadeUpgrade_getInstance1rnasrmbf09r6 as CascadeUpgrade_getInstance,
  ResurrectionUpgrade_getInstancejhbmez0sdr8w as ResurrectionUpgrade_getInstance,
  OverlordUpgrade_getInstance2yp8i65eq3nzj as OverlordUpgrade_getInstance,
  RegalUpgrade_getInstanceyf181ww6r8q9 as RegalUpgrade_getInstance,
  ProminenceUpgrade_getInstance3vrfjxjwgpgdr as ProminenceUpgrade_getInstance,
  EndlessDreamUpgrade_getInstance16kc49nmr6qw8 as EndlessDreamUpgrade_getInstance,
  WorshipUpgrade_getInstance2f9n6yzjwu3bc as WorshipUpgrade_getInstance,
  MartyrUpgrade_getInstance18fj834136pqm as MartyrUpgrade_getInstance,
  SoulCollectorUpgrade_getInstance1r4fldxurtugc as SoulCollectorUpgrade_getInstance,
  AbyssalHellFireUpgrade_getInstance8jks2ef35bbr as AbyssalHellFireUpgrade_getInstance,
  BurnUpgrade_getInstanceeyg7cccsefm8 as BurnUpgrade_getInstance,
  DraconicBondsUpgrade_getInstanceo21ffcw9m5qr as DraconicBondsUpgrade_getInstance,
  AngerUpgrade_getInstance22p20ppoeheqs as AngerUpgrade_getInstance,
  IncinerateCard_getInstance4d2fr3l5xny9 as IncinerateCard_getInstance,
  RiseCard_getInstance2wn892vq76rnr as RiseCard_getInstance,
  ScorchedEarthCard_getInstance90pb98bi1u1i as ScorchedEarthCard_getInstance,
  SummonLindwyrmCard_getInstance3f2omsnl4r3hm as SummonLindwyrmCard_getInstance,
  BeyondTheVeilUpgrade_getInstance3aisklc7asizr as BeyondTheVeilUpgrade_getInstance,
  AbundanceUpgrade_getInstance6m2cw5bz5g84 as AbundanceUpgrade_getInstance,
  ReuniteUpgrade_getInstance29ix03is7iio6 as ReuniteUpgrade_getInstance,
  DoomCallUpgrade_getInstance1q8dbolddlnv9 as DoomCallUpgrade_getInstance,
  FleshboundUpgrade_getInstance3l3n0qpgseoq6 as FleshboundUpgrade_getInstance,
  SpiritboundUpgrade_getInstance2grx91on64vgm as SpiritboundUpgrade_getInstance,
  DistractionUpgrade_getInstancesyc50p6dvf27 as DistractionUpgrade_getInstance,
  ThickMistUpgrade_getInstance33c1kp4v8ooza as ThickMistUpgrade_getInstance,
  NightbindUpgrade_getInstancega6p3vx44b2p as NightbindUpgrade_getInstance,
  CursedLandUpgrade_getInstance15uz1ipykxatz as CursedLandUpgrade_getInstance,
  BroodswellUpgrade_getInstance4gxshv59qnrq as BroodswellUpgrade_getInstance,
  RuptureSeedsUpgrade_getInstance1nt6wi2ttwmgr as RuptureSeedsUpgrade_getInstance,
  InfestUrgullUpgrade_getInstance2ehxdvj17jw53 as InfestUrgullUpgrade_getInstance,
  LairUpgrade_getInstance22y5eznv50mci as LairUpgrade_getInstance,
  Assar_getInstancen2izszy6zzwz as Assar_getInstance,
  ResonanceUpgrade_getInstance39fv8swhbsu2f as ResonanceUpgrade_getInstance,
  ExceptionalTrackerUpgrade_getInstance22s1fq3jj09f9 as ExceptionalTrackerUpgrade_getInstance,
  SeekerUpgrade_getInstanceuydsse60349w as SeekerUpgrade_getInstance,
  ExploreUpgrade_getInstance2qmfu3qhretkg as ExploreUpgrade_getInstance,
  HornOfValhUpgrade_getInstance3k2wwgy47v1fv as HornOfValhUpgrade_getInstance,
  HuntersBaneUpgrade_getInstance25acd9c1yf2v as HuntersBaneUpgrade_getInstance,
  HeroicSpeechUpgrade_getInstancemgl1ytakjrzy as HeroicSpeechUpgrade_getInstance,
  TacticalManouverUpgrade_getInstance2h1m3vqxiaefk as TacticalManouverUpgrade_getInstance,
  Iona_getInstance1jzicrvxoqh2j as Iona_getInstance,
  JointEffortUpgrade_getInstance1qijcrl3s7f9m as JointEffortUpgrade_getInstance,
  BallistaUpgrade_getInstance24ltlqkot0a91 as BallistaUpgrade_getInstance,
  CrepuscularUpgrade_getInstanceiffjqyc4w26t as CrepuscularUpgrade_getInstance,
  AncientCallingUpgrade_getInstance1pft1zar3r8ic as AncientCallingUpgrade_getInstance,
  TormentingVisionsUpgrade_getInstance7oijh7crpv2r as TormentingVisionsUpgrade_getInstance,
  SoothsayerUpgrade_getInstance1xdqvxe7i19en as SoothsayerUpgrade_getInstance,
  ClairvoyantUpgrade_getInstance13bjoijg14bu4 as ClairvoyantUpgrade_getInstance,
  AncientBondUpgrade_getInstance1tiy9x1gwqxok as AncientBondUpgrade_getInstance,
  Grimgeir_getInstance2zodqxltkel1u as Grimgeir_getInstance,
  WatchtowerPassageUpgrade_getInstance2d416h3uamtnl as WatchtowerPassageUpgrade_getInstance,
  RefugeUpgrade_getInstance1z3rfn400uwmj as RefugeUpgrade_getInstance,
  TownswatchUpgrade_getInstance2rlzdrpzz39x6 as TownswatchUpgrade_getInstance,
  DefenderUpgrade_getInstance10u5q98lbpze4 as DefenderUpgrade_getInstance,
  Krim_getInstance2389fdoqv8bcc as Krim_getInstance,
  ScavengerUpgrade_getInstance3qjd3kscx0hmk as ScavengerUpgrade_getInstance,
  TrapLauncherUpgrade_getInstancefwfmzpith2h8 as TrapLauncherUpgrade_getInstance,
  PortableWorkshopUpgrade_getInstance3gt4n41q3pgeu as PortableWorkshopUpgrade_getInstance,
  ResourcefulnessUpgrade_getInstance1jjl13y9wyedu as ResourcefulnessUpgrade_getInstance,
  Fara_getInstancemdwtm6nnavzs as Fara_getInstance,
  IgniteUpgrade_getInstance3ey0ws2n6t4j8 as IgniteUpgrade_getInstance,
  FlingUpgrade_getInstance3h5hbx7jkdmoj as FlingUpgrade_getInstance,
  DarkFlameUpgrade_getInstance1wzvod0iesvsv as DarkFlameUpgrade_getInstance,
  RebirthByFireUpgrade_getInstance25hff0ava4wos as RebirthByFireUpgrade_getInstance,
  InfusionUpgrade_getInstance3ka2tewp3jh69 as InfusionUpgrade_getInstance,
  BloodCraftUpgrade_getInstance3tzjdxj354k14 as BloodCraftUpgrade_getInstance,
  DissectionUpgrade_getInstanceskly95zkyv7f as DissectionUpgrade_getInstance,
  ExtractUpgrade_getInstance1xvp9dnzuxq36 as ExtractUpgrade_getInstance,
  Eivind_getInstance2himpstzhncmh as Eivind_getInstance,
  SkyMasterUpgrade_getInstanceyootg4ww9dyo as SkyMasterUpgrade_getInstance,
  RopePullUpgrade_getInstance11um93z7jm6eq as RopePullUpgrade_getInstance,
  ReachUpgrade_getInstance2iocunj0ye5a9 as ReachUpgrade_getInstance,
  EsmeriaHuntress_getInstancevxtyudowtt7n as EsmeriaHuntress_getInstance,
  HuntmasterUpgrade_getInstancet08p1j8e8f15 as HuntmasterUpgrade_getInstance,
  BlackStarUpgrade_getInstancegzz3l653uy8o as BlackStarUpgrade_getInstance,
  PredictUpgrade_getInstance34n1fame3n18m as PredictUpgrade_getInstance,
  TrueInstinctEsmeriaHuntressUpgrade_getInstance24eagk0u16y9i as TrueInstinctEsmeriaHuntressUpgrade_getInstance,
  Nora_getInstanceld7hf8eu3opr as Nora_getInstance,
  AwarenessUpgrade_getInstance23934seg03j50 as AwarenessUpgrade_getInstance,
  RevengeOfTheSheepUpgrade_getInstance3iwfw82506tq as RevengeOfTheSheepUpgrade_getInstance,
  WildbondUpgrade_getInstance2wydodpfmm9bj as WildbondUpgrade_getInstance,
  BeastTongueUpgrade_getInstance1rqvs5xut64kw as BeastTongueUpgrade_getInstance,
  Bram_getInstancelahd0revfkbw as Bram_getInstance,
  AbruptAssembleUpgrade_getInstance346t11xzy1dmx as AbruptAssembleUpgrade_getInstance,
  MassProductionUpgrade_getInstance13wd8w11wgndw as MassProductionUpgrade_getInstance,
  LivingBlockadeUpgrade_getInstancel1sxlgyni4em as LivingBlockadeUpgrade_getInstance,
  TacticalInsightUpgrade_getInstance2sx4rrtn01sgs as TacticalInsightUpgrade_getInstance,
  BloodlessFuryUpgrade_getInstance2gp9hzz9ba9tf as BloodlessFuryUpgrade_getInstance,
  PalebloodAxesUpgrade_getInstance2yzo8bk78f9fm as PalebloodAxesUpgrade_getInstance,
  SharedMadnessUpgrade_getInstanceseip4v95lpx7 as SharedMadnessUpgrade_getInstance,
  Sigrid_getInstance2l23mbv8bteb8 as Sigrid_getInstance,
  EcholocationUpgrade_getInstance2fhsds0a65bfw as EcholocationUpgrade_getInstance,
  SwapUpgrade_getInstancenkv4gi8jncbk as SwapUpgrade_getInstance,
  PactReversalUpgrade_getInstancemaho3m9br6gn as PactReversalUpgrade_getInstance,
  LowerShatteredRuins_getInstance1en5yqro19pzh as LowerShatteredRuins_getInstance,
  UpperShatteredRuins_getInstancee0zhx2t8d1a5 as UpperShatteredRuins_getInstance,
  _BoardPosition___get_y__impl__tale2e17vnr4e3jxfsy as _BoardPosition___get_y__impl__tale2e,
  _BoardPosition___get_x__impl__gyx07381tpzaynedb as _BoardPosition___get_x__impl__gyx07,
  Zone_Thealis_getInstance1iiz35256er8h as Zone_Thealis_getInstance,
  Zone_Achur_getInstance1b1y9e0oznx0u as Zone_Achur_getInstance,
  Zone_Elysur_getInstance11z7eujtmcigp as Zone_Elysur_getInstance,
  Zone_Myrna_getInstance3fi0m84elinzb as Zone_Myrna_getInstance,
  get_drenchedLandsMapoob5465oeezj as get_drenchedLandsMap,
  get_upperShatteredIslesMap25cel880pe8pl as get_upperShatteredIslesMap,
  get_lowerShatteredIslesMap1edqmk7dc1qwc as get_lowerShatteredIslesMap,
  BeastUserSettings_getInstance3ofip79i65tbl as BeastUserSettings_getInstance,
  get_entries3j5h5c2c0yh6t as get_entries_4,
  ClientLinksxthcu9kzrmk2 as ClientLinks,
  Companion_getInstance18elh27sqar33 as Companion_getInstance_3,
  AnotherAnswerReaction_ReshowVariants_getInstance2p4pnhj458ex as AnotherAnswerReaction_ReshowVariants_getInstance,
  RageCard29alys0oanyxv as RageCard,
  DisappearCard_getInstance1nwpvazmbkdv3 as DisappearCard_getInstance,
  SilverArrowCard_getInstance2ujdtlcaf3usa as SilverArrowCard_getInstance,
  TrackCard1gemj30o7zpkp as TrackCard,
  FireTrapCard3jejuv4t1n1tt as FireTrapCard,
  SmokeBombCard3qyzfh70i7qlq as SmokeBombCard,
  AurorasPassage_getInstance1iv95si3960n4 as AurorasPassage_getInstance,
  DisperseCard2qepgz4kjbldw as DisperseCard,
  FlareCard36tx25o1tara1 as FlareCard,
  BladeOfValhCard_getInstance31t71anst074h as BladeOfValhCard_getInstance,
  OutpostCard1ffzsar9gm9bf as OutpostCard,
  SummonPolypCard_getInstance1h86vkh8ulqlg as SummonPolypCard_getInstance,
  BeastlyTongueCard_getInstancet114a32976bo as BeastlyTongueCard_getInstance,
  EngorgeCard_getInstance13d2ezow3zuya as EngorgeCard_getInstance,
  LeapCard_getInstanceznp92u5id8gd as LeapCard_getInstance,
  HuntCard15h4e8elykc4g as HuntCard,
  SeerCard_getInstance7zjuuadxukfm as SeerCard_getInstance,
  CommandCard_getInstance2g5w6pf0p5woa as CommandCard_getInstance,
  ChargeCard_getInstance32yjm1dm8ag1w as ChargeCard_getInstance,
} from './beast-beast-common.mjs';
import {
  V22su20mpwty0v0 as V2,
  _interpolated0idy8l9id9j as _interpolate,
  _interpolateAngle308nqn33qn9pa as _interpolateAngle,
  get180k0um3w6tn5 as get,
  getz0kndyh9g55h as get_0,
  Key_P_getInstance268wrcumhzni3 as Key_P_getInstance,
  Key_M_getInstance1yosu7g51o3lh as Key_M_getInstance,
  Key_B_getInstance3vqbr947ty93s as Key_B_getInstance,
  Key_N_getInstance2p8cnpwrjvt2i as Key_N_getInstance,
  Key_I_getInstance30f2ckkjb8q5o as Key_I_getInstance,
  Key_R_getInstance2u2y4f0iaj45e as Key_R_getInstance,
  Key_H_getInstancepl0m56eerxl9 as Key_H_getInstance,
  Key_X_getInstance3858vbsixd1dp as Key_X_getInstance,
  Key_L_getInstance2fxxzbm4b446d as Key_L_getInstance,
  Key_A_getInstancetdikhj2xu69a as Key_A_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  _interpolateColor3ps0kri0tazz4 as _interpolateColor,
  MouseButton_LEFT_getInstance2rob4difvxgbp as MouseButton_LEFT_getInstance,
  gettu4yrnc3vnyf as get_1,
  Key_LEFT_getInstance29zwyh1fmlq32 as Key_LEFT_getInstance,
  Key_RIGHT_getInstance328pcefkf4k6z as Key_RIGHT_getInstance,
  Key_UP_getInstances4e142e2o5i8 as Key_UP_getInstance,
  Key_DOWN_getInstance3ax9ubgau4vvs as Key_DOWN_getInstance,
  Key_Q_getInstance2wl544h8onckd as Key_Q_getInstance,
  Key_W_getInstancegb6gidgzz09l as Key_W_getInstance,
  V2Callback2d6dtckx13wqz as V2Callback,
  Cursor_HAND_getInstance1fp92l7zmq1m4 as Cursor_HAND_getInstance,
  Cursor_DEFAULT_getInstance2mvsp8zxmuifx as Cursor_DEFAULT_getInstance,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  Companion_getInstance3szcobow9wmlz as Companion_getInstance_4,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  SDFShaders_getInstance36frvn0k1jot as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  DefaultShaders_getInstance5rngqjolrj76 as DefaultShaders_getInstance,
  Quality_QUALITY_getInstance2y19g1gn64f0j as Quality_QUALITY_getInstance,
} from './korge-root-korge-core.mjs';
import {
  tween1evm9gy4140aa as tween,
  Image1b2d7ghyim7p5 as Image,
  addTo25e29vq105prw as addTo,
  Scenezu810y12qpqp as Scene,
  get_mouse1jstwhfaumelj as get_mouse,
  get_keysmipauarvwdlb as get_keys,
  SContainerfim2zr5seafm as SContainer,
  Container7486fjmip554 as Container,
  onMouseDrag20om3ch85u2pf as onMouseDrag,
  positionu6441b7hkb4l as position,
  scalea9fc0mbrr7ub as scale,
  anchor3c5itxst996yy as anchor,
  position2v5vbepn4kziz as position_0,
  GraphicsRenderer_GPU_getInstance1cg0kq57kqo7y as GraphicsRenderer_GPU_getInstance,
  Circlepba9jsmewo4k as Circle,
  Text3kimhvgfxflj3 as Text,
  rotation29g98bv3f78wn as rotation,
  xy1gb51vhy014mx as xy,
  Korgem48lxg0vwq9x as Korge,
  Korge2cqygya336n5n as Korge_0,
  SceneContainer99ijjqni12hp as SceneContainer,
  Companion_getInstance3vle38qw3uwk as Companion_getInstance_5,
  Companion_instance8kerorzbjbkv as Companion_instance,
  UITextInput3hf6kt3o0p9up as UITextInput,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views8ixu1gnhxenz as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  SolidRect131p7hyzlx7j8 as SolidRect,
  Companion_instancev4lanw37mf9n as Companion_instance_0,
  RoundRect16qm0yoxjizxs as RoundRect,
  xyssniz4rympby as xy_0,
  size1ac0fubkxl72w as size,
  View11ybmmoof9vue as View,
  setText209z1w9h7o9hy as setText,
  size3ul8wgwwt88hf as size_0,
  addUpdater1la23qj9g2d42 as addUpdater,
  renderToBitmap3m6yism7c9see as renderToBitmap,
  Anchorable2p2wd2c4mob8i as Anchorable,
  set_cursor2bma4bfi3ugur as set_cursor,
  Companion_instance10s1y12mqzdxm as Companion_instance_1,
  ShadedView18n2s98uu6wc3 as ShadedView,
  BaseProgramProvider4fzf1zwbol51 as BaseProgramProvider,
  Companion_getInstance3ur4fgjzgmjwp as Companion_getInstance_6,
  ShaderFilter10394gibq1ewd as ShaderFilter,
  ClipContainernpx31s3mxtjx as ClipContainer,
  set_filter36wgvpm5cukpc as set_filter,
} from './korge-root-korge.mjs';
import {
  delayvyed5wvki0ic as delay,
  coroutineScope39ukucf23mhsm as coroutineScope,
  launch1c91vkjzdi9sd as launch,
  CompletableDeferred10t3vc1asgghx as CompletableDeferred,
  Key_instancebefxze3q9f64 as Key_instance,
  cancel36mj9lv3a0whl as cancel,
  cancelAndJoin21f2rd386nyt8 as cancelAndJoin,
  Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance,
  CoroutineStart_LAZY_getInstanceyyljs516jwiz as CoroutineStart_LAZY_getInstance,
  Job13y4jkazwjho0 as Job,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  FlowCollector26clgpmzihvke as FlowCollector,
  yieldyvh2mab0488 as yield_0,
  delay3e2ei0hoxjoud as delay_0,
  NonCancellable_getInstance245ec57g3sl0k as NonCancellable_getInstance,
  withContextqz5k6d9p9xx5 as withContext,
  collectLatest385x84q3xq78u as collectLatest,
  MutableStateFlow34bfoyvwu8czu as MutableStateFlow,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred_0,
  asyncz02dsa2nb2zt as async,
  awaitAllncublvoeclj6 as awaitAll,
  get_isActivehakov5bm97hw as get_isActive,
  Channel3r72atmcithql as Channel,
  Mutex16li1l0asjv17 as Mutex,
  withTimeout1cf9pp7nybo8u as withTimeout,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  get_job2zvlvce9o9a29 as get_job,
  first3ar30drnglxos as first_1,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  cancel1xim2hrvjmwpn as cancel_0,
  cancelChildren10wlln0b749a7 as cancelChildren,
  awaitCancellation3exsywb4az079 as awaitCancellation,
  cancelChildrennwartoz0yn6c as cancelChildren_0,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
} from './kotlinx-coroutines-core.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  UrlVfs3infs84pplmp3 as UrlVfs,
} from './korlibs-io-root-korlibs-io.mjs';
import { readSoundsszptn4ctju3 as readSound } from './korlibs-audio-root-korlibs-audio.mjs';
import {
  toPoint1vle82q653j9s as toPoint,
  Companion_getInstancedn3d4os5eemi as Companion_getInstance_7,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance1a9vx2vzoy0c2 as Companion_getInstance_8,
  _Angle___init__impl__g23q1m2b2a3p1lcfecp as _Angle___init__impl__g23q1m,
  Companion_getInstancepzu5ca8urjqj as Companion_getInstance_9,
  Angle2itorpob18n08 as Angle,
  Vector2D378fe5rov8fgw as Vector2D,
  _Angle___get_ratio__impl__ap3on4xjct7npipfzx as _Angle___get_ratio__impl__ap3on4,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstancenbsqt92rl0cr as Companion_getInstance_10,
  Companion_getInstance1feyrzu0npiil as Companion_getInstance_11,
  RectCorners2yrtl8r42p5bs as RectCorners,
  Companion_getInstance1mhteccb9s8gp as Companion_getInstance_12,
  get_radians87y5j8tewvub as get_radians,
  get_degrees3czcd4ojw4i as get_degrees,
  plus1k1r08st2gekm as plus_4,
  toDouble1sqmo9z3buff3 as toDouble,
  Angle__cosine_impl_bgvzun30j3tzbj9negy as Angle__cosine_impl_bgvzun,
  Angle__sine_impl_3l11xv107tog2g378xw as Angle__sine_impl_3l11xv,
  Companion_instance2yvqvvbiokzog as Companion_instance_2,
  Circle1sk1qi5ph1m23 as Circle_0,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Rectangle3q03woyn9k8x1 as Rectangle,
  toVector12s348td227ca as toVector,
  Companion_getInstance11dw08y48m2m0 as Companion_getInstance_13,
  BoundsBuilder__plus_impl_cz7f7x16kulpov94zla as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gxzjc7xpskx0n0 as _BoundsBuilder___get_bounds__impl__s1l1gx,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y3ofskh6zksge6 as Ratio__times_impl_ucdh7y,
  _Ratio___init__impl__9mwvn21qwyi4zg9z4fu as _Ratio___init__impl__9mwvn2,
  Ratio__plus_impl_pm43pkjs7dunhlzo3l as Ratio__plus_impl_pm43pk,
  Companion_getInstance2q13golofn64 as Companion_getInstance_14,
  _Ratio___get_value__impl__57cli62yq1wlg55nngd as _Ratio___get_value__impl__57cli6,
  toIntCeil3h286vm49zgwd as toIntCeil,
  toIntCeiltm5lvaa6k4k9 as toIntCeil_0,
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Bitmap321klycakvwgb5w as Bitmap32,
  Colors_getInstance3pptco3oesytn as Colors_getInstance,
  get_DefaultTtfFontddovg6zy24ck as get_DefaultTtfFont,
  RGBA34obx2i62wcl3 as RGBA,
  Companion_getInstance3k5cs6pucdtn7 as Companion_getInstance_15,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstance1hhdzhwpqlcg8 as Companion_getInstance_16,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  RGBA__withA_impl_vogscm35996kpuzu85s as RGBA__withA_impl_vogscm,
  RGBA__withAd_impl_cralao3tppw6lob1jl8 as RGBA__withAd_impl_cralao,
  readBitmapo6nrz66d4x8p as readBitmap,
  RGBA__toString_impl_4lw6dphy5yaenoheku as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf61f7mvf3brfggb as RGBA__hashCode_impl_h59qf6,
  _RGBA___get_a__impl__6msvu71iz31ltxv1lni as _RGBA___get_a__impl__6msvu7,
  readBitmap1mzeobqc4iv0x as readBitmap_0,
  slice2pfxfvku0ybgy as slice,
  extractrn4rijx1x4kx as extract,
  BitmapEffect3nrrxebx6tit3 as BitmapEffect,
  Companion_getInstance19jbnxyfpggdq as Companion_getInstance_17,
  MutableAtlas41tbjanvwcb0 as MutableAtlas,
  renderGlyphToBitmap31bj0136i501b as renderGlyphToBitmap,
  mipmaps15hw75h1oqdr8 as mipmaps,
  Companion_instance32vng4qkr3hdi as Companion_instance_3,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  _RGBA___get_r__impl__duz7mo1syen2f503lbi as _RGBA___get_r__impl__duz7mo,
  _RGBA___get_g__impl__o8pukr2r7akkj4liw5z as _RGBA___get_g__impl__o8pukr,
  _RGBA___get_b__impl__m6tl8019te0bj9gepls as _RGBA___get_b__impl__m6tl80,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  UiSessionState152j89nvae1zt as UiSessionState,
  get_replayTimeline1zceyqjy38q6d as get_replayTimeline,
  get_isNetworkGame3j47mql0se16c as get_isNetworkGame,
  get_canShareReplay2i20c2ebxo8sw as get_canShareReplay,
  shareReplay1hga7jj1zwgtn as shareReplay,
  reloadGameCallback272ilqsw0e9x8 as reloadGameCallback,
  MenuManagementp52wobde9q5e as MenuManagement,
  ServerDuelSetuph7xwhhxe2xfz as ServerDuelSetup,
  SandboxSetup1s0c85bn4b5d7 as SandboxSetup,
  NewGameSetup1lcqmn970xsp6 as NewGameSetup,
  ReplayVisibility_CurrentTeam_getInstance31k9ithqooozn as ReplayVisibility_CurrentTeam_getInstance,
  NewGameSetup_instance21xugcdjajd1l as NewGameSetup_instance,
  LoadGameSetup_instancedynmdw5l1ibx as LoadGameSetup_instance,
  ReconnectSandboxSetup2nwh12h6ozq2w as ReconnectSandboxSetup,
  replayStartShowAnswerFromjqt988fml6oc as replayStartShowAnswerFrom,
  SwitchingGameTeamProvider3nw4zylvxdxlr as SwitchingGameTeamProvider,
  JustGameTeamProvider1igg1wo0xc3wh as JustGameTeamProvider,
  OfflineRecordedGameSetup3bgixk2i1vcnw as OfflineRecordedGameSetup,
  visibleServerMessages1gk72m0zmjr4m as visibleServerMessages,
  reconnectClientAfterReload3me0qgkvquf5r as reconnectClientAfterReload,
  processDuelSession329ouhvf1a0wt as processDuelSession,
  LoadGameSetup1k9f8hcugoyuv as LoadGameSetup,
  SandboxInit2yt0sj0f9nsmu as SandboxInit,
  canSeePrivateInfoOf9e2d27g7wzcs as canSeePrivateInfoOf,
  GameTeamProvider2tka980cqn2bv as GameTeamProvider,
  ContentVersionSelectionState30lx6a5rvrcza as ContentVersionSelectionState,
  MasterFixing225222srs8psi as MasterFixing,
  SandboxInit_instance2eyebb5m3b2w3 as SandboxInit_instance,
  SpecialSetupFlow1wg19nhji0s66 as SpecialSetupFlow,
  SandboxSetupFlowh4qs7yy80fds as SandboxSetupFlow,
  RevertMode_RevertFirstForSure_getInstance15jk7v54dl2u1 as RevertMode_RevertFirstForSure_getInstance,
  ReplayRevertConfiguration114bh0uw7avj5 as ReplayRevertConfiguration,
  ReplayRevertFlow3p2tqo0e2v4x0 as ReplayRevertFlow,
  InstalledChoice2nyv8x5v495wn as InstalledChoice,
  ChoicePresentation1vh53566cmej6 as ChoicePresentation,
  ChoiceFlowConfiguration2jqt6nz2oewh2 as ChoiceFlowConfiguration,
  ChoiceFlow3r341chgmsw27 as ChoiceFlow,
  answerFlow2bhqnoa9tb0qv as answerFlow,
  get_entries34vldtkch6t8x as get_entries_5,
  UiFlowConfiguration1h4ikmn9s7ox6 as UiFlowConfiguration,
  SameScreenFlowAgent16e8wth7lkmsa as SameScreenFlowAgent,
  EmptyListener_instancelj0tdcdfktrc as EmptyListener_instance,
  PressedBackException22atp96o0y92v as PressedBackException,
  OnboardingSequence_Outpost_getInstance1oyyrqk0uw5zh as OnboardingSequence_Outpost_getInstance,
  OnboardingScript1xddc1rg7qnob as OnboardingScript,
} from './beast-beast-common-ui.mjs';
import { Level_INFO_getInstance2u0wredwjoo6m as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_EASE_IN3dgilxucimnao as get_EASE_IN,
  get_EASE_OUT_QUAD2mpgddt0aepte as get_EASE_OUT_QUAD,
  SliceRotation_R180_getInstance85sagbi84b4q as SliceRotation_R180_getInstance,
  get_EASE_IN_OUT1plt1ext4tf71 as get_EASE_IN_OUT,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class AwaitingGameReloadScene extends Scene {
  constructor(menuManagement, message) {
    message = message === VOID ? 'Reloading game...' : message;
    super();
    this.bl9_1 = menuManagement;
    this.cl9_1 = message;
  }
  *ti4(_this__u8e3s4, $completion) {
    var panel = new ControlPanelY();
    addTo_0(PlainText(this.cl9_1, get_gameLayout().vl5_1), panel);
    addTo_0(ActionButton.vlb('Main menu', VOID, VOID, VOID, VOID, VOID, AwaitingGameReloadScene$sceneInit$slambda(this)), panel);
    addTo(panel.xlb_1, _this__u8e3s4);
    return Unit_instance;
  }
}
class GameImageManager {
  constructor(prefix, views, checkMode) {
    this.xld_1 = prefix;
    this.yld_1 = views;
    this.zld_1 = checkMode;
    this.ale_1 = Mutex();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.ble_1 = LinkedHashMap.m7();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.cle_1 = LinkedHashMap.m7();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.dle_1 = LinkedHashMap.m7();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.ele_1 = LinkedHashMap.m7();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.fle_1 = LinkedHashMap.m7();
  }
  *zle(bitmap, color, outlineThicknessRatio, $completion) {
    // Inline function 'kotlin.require' call
    if (!!this.zld_1) {
      var message = 'Check mode is not supported';
      throw IllegalArgumentException.h2(toString(message));
    }
    var outlineLayerSize = 1.0 + outlineThicknessRatio;
    var tmp0 = this.ele_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = new Triple(bitmap, new RGBA(color), outlineLayerSize);
    var value = tmp0.w4(key);
    var tmp;
    if (value == null) {
      var whiteMask = maskFor(this, bitmap, color);
      // Inline function 'kotlin.apply' call
      var this_0 = Container.fi2();
      // Inline function 'korlibs.korge.view.image' call
      var anchor_0 = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Image.lk7(whiteMask, anchor_0);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_2, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      scale(this_2, outlineLayerSize);
      // Inline function 'korlibs.korge.view.image' call
      var anchor_1 = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = Image.lk7(bitmap, anchor_1);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, this_0);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_4, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      var answer = yield* renderToBitmap(this_0, ensureNotNull(this.yld_1), VOID, VOID, VOID, VOID, $completion);
      tmp0.b5(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  alf(bitmap, area) {
    var tmp0 = this.fle_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = to(bitmap, area);
    var value = tmp0.w4(key);
    var tmp;
    if (value == null) {
      var answer = extract(slice(bitmap, area));
      tmp0.b5(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  *gle(path, $completion) {
    if (this.zld_1) {
      // Inline function 'kotlin.require' call
      if (!(yield* get_resourcesVfs().wi(this.xld_1 + path).ubh($completion))) {
        var message = 'Image ' + path + ' not found';
        throw IllegalArgumentException.h2(toString(message));
      }
      return CompletableDeferred_0();
    }
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.ale_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      var result = this.ble_1.w4(path);
      if (!(result == null))
        return CompletableDeferred(result);
      var deferred = this.cle_1.w4(path);
      var tmp_0;
      if (deferred == null) {
        var d = CompletableDeferred_0();
        // Inline function 'kotlin.collections.set' call
        this.cle_1.b5(path, d);
        tmp_0 = to(d, true);
      } else {
        tmp_0 = to(deferred, false);
      }
      tmp = tmp_0;
    }finally {
      this_0.k2a(null);
    }
    var completableDeferred = tmp.jm();
    var needCalculate = tmp.km();
    if (!needCalculate) {
      return completableDeferred;
    }
    yield* this.ylb(path, ImageLoadingStage_Started_getInstance(), $completion);
    var tmp_1 = get_globalLoadingResourceManager().llo_1;
    yield* tmp_1.j22(GameImageManager$getImageWithCaching$slambda(this, path, completableDeferred), $completion);
    return completableDeferred;
  }
}
class BeastGameImages extends GameImageManager {
  constructor(views, loadingResourceReporter, checkMode) {
    loadingResourceReporter = loadingResourceReporter === VOID ? null : loadingResourceReporter;
    checkMode = checkMode === VOID ? false : checkMode;
    super('BeastResources/', views, checkMode);
    this.al7_1 = loadingResourceReporter;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.bl7_1 = LinkedHashMap.m7();
  }
  *ylb(path, stage, $completion) {
    switch (stage.w1_1) {
      case 0:
        get_gameConfiguration().xlc_1.fld('Try load ' + path);
        break;
      case 2:
        get_gameConfiguration().xlc_1.fld('Image ' + path + ' loaded');
        break;
      case 1:
        get_gameConfiguration().xlc_1.fld('Disconnecting while loading ' + path);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp1_safe_receiver = this.al7_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      yield* tmp1_safe_receiver.ylb(path, stage, $completion);
    return Unit_instance;
  }
  *tld(icon, $completion) {
    return yield* this.gle('Icons/128x128/' + icon.wld_1 + '.png', $completion);
  }
  *hle(locationType, $completion) {
    return yield* this.gle('Tokens/' + locationType.v1_1 + '.png', $completion);
  }
  *ile(gameMapId, mapFormat, $completion) {
    var tmp;
    if (mapFormat.equals(MapFormat_PreviewMap_getInstance())) {
      var tmp_0;
      switch (gameMapId.w1_1) {
        case 0:
          tmp_0 = 'NorthernExpanse';
          break;
        case 1:
          tmp_0 = 'DrenchedLands';
          break;
        case 2:
          tmp_0 = 'UpperShatteredIsles';
          break;
        case 3:
          tmp_0 = 'LowerShatteredIsles';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var mapName = tmp_0;
      tmp = yield* this.gle('SmallMaps/' + mapName + '-small.jpg', $completion);
    } else {
      var tmp_1;
      switch (gameMapId.w1_1) {
        case 0:
          tmp_1 = yield* this.gle('Maps/NorthernExpanse.jpg', $completion);
          break;
        case 1:
          tmp_1 = yield* this.gle('Maps/DrenchedLands.jpg', $completion);
          break;
        case 2:
          var tmp_2;
          if (mapFormat.equals(MapFormat_ShortMap_getInstance())) {
            tmp_2 = yield* this.gle('Maps/UpperShatteredIsles-no-text.jpg', $completion);
          } else {
            tmp_2 = yield* this.gle('Maps/UpperShatteredIsles.jpg', $completion);
          }

          tmp_1 = tmp_2;
          break;
        case 3:
          tmp_1 = yield* this.gle('Maps/LowerShatteredIsles.jpg', $completion);
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  *jle(rules, $completion) {
    var tmp;
    if (rules instanceof RecoveryTestContract) {
      tmp = recoveryTestImage(this, 'Recovery test', 'Add > Item Card on the Beast. Keep in hand: Setup failure: fail after setup bonuses. Night rewards failure: fail before rewards. Beast reward failure: gain 1 Grudge, then fail. Start at Contract specific setup or Night. Remove a card to disable its failure. Play other diagnostic cards for effect failures.', 'CONTRACT');
    } else {
      if (rules instanceof GreatCleansingContract) {
        tmp = yield* this.gle('Contracts/2-3/GreatCleansing.jpg', $completion);
      } else {
        if (rules instanceof PactLongForgottenContract) {
          tmp = yield* this.gle('Contracts/4/PactLongForgotten.jpg', $completion);
        } else {
          if (rules instanceof ShipwreckContract) {
            tmp = yield* this.gle('Contracts/2-3/Shipwreck.jpg', $completion);
          } else {
            if (rules instanceof SecretsFromALostAgeContract) {
              tmp = yield* this.gle('Contracts/2-3/SecretsFromALostAge.jpg', $completion);
            } else {
              if (rules instanceof UnleashingTheAbyssContract) {
                tmp = yield* this.gle('Contracts/4/UnleashingTheAbyss.jpg', $completion);
              } else {
                if (rules instanceof DisturbanceOfTheNorthernGodsContract) {
                  tmp = yield* this.gle('Contracts/4/NorthernGods.jpg', $completion);
                } else {
                  if (rules instanceof AttackOnTheNorthernSettlementsContract) {
                    tmp = yield* this.gle('Contracts/4/NorthernSettlements.jpg', $completion);
                  } else {
                    if (rules instanceof AshfallUnlikelyAllianceContract) {
                      tmp = yield* this.gle('Contracts/5/AshfallUnlikelyAlliance.jpg', $completion);
                    } else {
                      if (rules instanceof UnlikelyAllianceContract) {
                        tmp = yield* this.gle('Contracts/5/UnlikelyAlliance.jpg', $completion);
                      } else {
                        if (rules instanceof RegentOfRuinsContract) {
                          tmp = yield* this.gle('Contracts/2-3/RegentOfRuins.jpg', $completion);
                        } else {
                          if (rules instanceof ArrivalOfTheTitanContract) {
                            tmp = yield* this.gle('Contracts/5/ArrivalOfTheTitan.jpg', $completion);
                          } else {
                            noWhenBranchMatchedException();
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  *kle(card, $completion) {
    var tmp;
    if (isInterface(card, DraftActionCard)) {
      tmp = 'DraftActionCards';
    } else {
      if (isInterface(card, HunterItemCard)) {
        tmp = 'HunterItems';
      } else {
        if (isInterface(card, BeastlyTalentCard)) {
          tmp = 'BeastlyTalent';
        } else {
          if (isInterface(card, AshRuin)) {
            return yield* this.lle(card, $completion);
          } else {
            if (isInterface(card, AshRuinCard)) {
              tmp = 'AshRuins';
            } else {
              if (isInterface(card, AbilityCard)) {
                tmp = fullCharacterPrefix(this, card);
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    var prefix = tmp;
    return yield* this.gle(prefix + '/cardBack.jpg', $completion);
  }
  *mle(card, $completion) {
    var tmp;
    if (isInterface(card, RecoveryTestConditionCard)) {
      tmp = recoveryTestImage(this, card.m5z(), card.n5z(), 'PASSIVE / KEEP IN HAND');
    } else {
      if (isInterface(card, RecoveryTestCard)) {
        tmp = recoveryTestImage(this, card.j5z().y5z_1, card.j5z().z5z_1, 'ARSENAL / FREE / SPLIT');
      } else {
        var tmp_0;
        if (card instanceof RecoveryTestHunterReaction) {
          tmp_0 = true;
        } else {
          tmp_0 = card instanceof RecoveryTestBeastReaction;
        }
        if (tmp_0) {
          tmp = recoveryTestImage(this, 'Failing reaction', 'Keep in hand and play the Trigger diagnostic card. Gain 1 Grudge, then fail before resolving the reaction. After repair, the committed card is discarded.', 'REACTION / FREE');
        } else {
          if (isInterface(card, OverloadedCard)) {
            tmp = yield* this.mle(card.y3k(), $completion);
          } else {
            if (isInterface(card, UnknownCard)) {
              tmp = yield* this.kle(card, $completion);
            } else {
              if (isInterface(card, DraftActionCard)) {
                var simpleName = ensureNotNull(getKClassFromExpression(card).j1());
                var fileName = removeSuffix(simpleName, 'Card');
                tmp = yield* this.gle('DraftActionCards/' + fileName + '.jpg', $completion);
              } else {
                if (isInterface(card, AbilityCard)) {
                  var simpleName_0 = ensureNotNull(getKClassFromExpression(card).j1());
                  var fileName_0 = removeSuffix(simpleName_0, 'Card');
                  var fullPrefix = fullCharacterPrefix(this, card);
                  tmp = yield* this.gle(fullPrefix + '/' + fileName_0 + '.jpg', $completion);
                } else {
                  if (isInterface(card, HunterItemCard)) {
                    var simpleName_1 = ensureNotNull(getKClassFromExpression(card).j1());
                    var fileName_1 = removeSuffix(simpleName_1, 'Card');
                    var tmp1_safe_receiver = card.u37();
                    var tmp_1;
                    if (tmp1_safe_receiver == null) {
                      tmp_1 = null;
                    } else {
                      // Inline function 'kotlin.let' call
                      tmp_1 = '-' + (tmp1_safe_receiver + 1 | 0);
                    }
                    var tmp2_elvis_lhs = tmp_1;
                    var suffix = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
                    tmp = yield* this.gle('HunterItems/' + fileName_1 + suffix + '.jpg', $completion);
                  } else {
                    if (isInterface(card, BeastlyTalentCard)) {
                      var simpleName_2 = ensureNotNull(getKClassFromExpression(card).j1());
                      var fileName_2 = removeSuffix(simpleName_2, 'Card');
                      var tmp3_safe_receiver = card.u37();
                      var tmp_2;
                      if (tmp3_safe_receiver == null) {
                        tmp_2 = null;
                      } else {
                        // Inline function 'kotlin.let' call
                        tmp_2 = '-' + (tmp3_safe_receiver + 1 | 0);
                      }
                      var tmp4_elvis_lhs = tmp_2;
                      var suffix_0 = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
                      tmp = yield* this.gle('BeastlyTalent/' + fileName_2 + suffix_0 + '.jpg', $completion);
                    } else {
                      if (isInterface(card, AshRuin)) {
                        tmp = yield* this.lle(card, $completion);
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  *nle(beastCharacter, $completion) {
    return yield* this.gle('Beasts/' + getKClassFromExpression(beastCharacter).j1() + '/trail.png', $completion);
  }
  *ole(gsCtx, baseObject, $completion) {
    return yield* this.ple(get_objectType(gsCtx, baseObject), gsCtx, $completion);
  }
  *ple(objectType, gameState, $completion) {
    var tmp;
    if (objectType instanceof SnareTokenType) {
      tmp = yield* this.gle('Beasts/Omma/Snare.png', $completion);
    } else {
      if (objectType instanceof EggType) {
        tmp = yield* this.gle('Beasts/' + getKClassFromExpression(objectType.k6c_1).j1() + '/Egg.png', $completion);
      } else {
        if (isInterface(objectType, SummonType)) {
          tmp = yield* this.gle('Beasts/' + getKClassFromExpression(objectType.r37()).j1() + '/summon-1.png', $completion);
        } else {
          if (objectType instanceof BoatType) {
            tmp = yield* this.gle('GeneralUnits/Boat.png', $completion);
          } else {
            if (isInterface(objectType, HunterCompanionType)) {
              tmp = yield* this.gle('Hunters/' + getKClassFromExpression(objectType.p3x()).j1() + '/companion.png', $completion);
            } else {
              if (isInterface(objectType, SimpleObjectType)) {
                tmp = yield* this.gle('GeneralUnits/' + removeSuffix(ensureNotNull(getKClassFromExpression(objectType).j1()), 'Type') + '.png', $completion);
              } else {
                if (isInterface(objectType, HunterCharacter)) {
                  tmp = yield* this.gle('Hunters/' + getKClassFromExpression(objectType).j1() + '/standee.png', $completion);
                } else {
                  if (objectType instanceof FeatheredKing) {
                    var suffix = suffixForFeatheredKing(this, gameState);
                    tmp = yield* this.gle('Beasts/' + getKClassFromExpression(objectType).j1() + '/standee' + suffix + '.png', $completion);
                  } else {
                    if (isInterface(objectType, BeastCharacter)) {
                      tmp = yield* this.gle('Beasts/' + getKClassFromExpression(objectType).j1() + '/standee.png', $completion);
                    } else {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  qle(objectType, gameState, $completion, $super) {
    gameState = gameState === VOID ? null : gameState;
    return $super === VOID ? this.ple(objectType, gameState, $completion) : $super.ple.call(this, objectType, gameState, $completion);
  }
  *rle(pathNumber, $completion) {
    var idx = pathNumber % 6 | 0;
    return yield* this.gle('Tokens/Entry-' + idx + '.png', $completion);
  }
  *sle($completion) {
    return yield* this.qle(new BarrierSideType(Companion_getInstance_0().i3l_1), VOID, $completion);
  }
  *tle(character, gameState, $completion) {
    var tmp;
    if (character instanceof FeatheredKing) {
      tmp = suffixForFeatheredKing(this, gameState);
    } else {
      var tmp0_safe_receiver = character.w36(gameState);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = '-' + tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    }
    var suffix = tmp;
    return yield* this.ule(character, suffix, $completion);
  }
  *ule(character, suffix, $completion) {
    var tmp;
    if (isInterface(character, HunterCharacter)) {
      tmp = yield* this.gle('Hunters/' + getKClassFromExpression(character).j1() + '/upgrades' + suffix + '.jpg', $completion);
    } else {
      if (isInterface(character, BeastCharacter)) {
        tmp = yield* this.gle('Beasts/' + getKClassFromExpression(character).j1() + '/upgrades' + suffix + '.jpg', $completion);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  *vle(token, $completion) {
    return yield* this.gle('Tokens/' + token.v1_1 + '.png', $completion);
  }
  *lle(ashRuin, $completion) {
    var ruinNameWithSuffix = ensureNotNull(getKClassFromExpression(ashRuin).j1());
    var ruinName = removeSuffix(ruinNameWithSuffix, 'Ruin');
    return yield* this.gle('AshRuins/' + ruinName + '.png', $completion);
  }
  *wle(movement, $completion) {
    if (movement == null)
      return yield* this.gle('Movements/back.jpg', $completion);
    var tmp;
    if (movement instanceof RelocationStep) {
      tmp = 'AbyssalMovement';
    } else {
      if (equals(movement, NoMovement_getInstance())) {
        tmp = 'NoMovement';
      } else {
        if (equals(movement, Companion_getInstance_0().i3l_1)) {
          tmp = 'West';
        } else {
          if (equals(movement, Companion_getInstance_0().g3l_1)) {
            tmp = 'East';
          } else {
            if (equals(movement, Companion_getInstance_0().f3l_1)) {
              tmp = 'North';
            } else {
              if (equals(movement, Companion_getInstance_0().h3l_1)) {
                tmp = 'South';
              } else {
                // Inline function 'kotlin.error' call
                var message = 'Cannot add card for movement ' + toString(movement);
                throw IllegalStateException.o(toString(message));
              }
            }
          }
        }
      }
    }
    var name = tmp;
    return yield* this.gle('Movements/' + name + '-1.png', $completion);
  }
  *xle(nameWithExt, $completion) {
    return yield* this.gle('Preview/' + nameWithExt, $completion);
  }
  *yle(nameWithExt, $completion) {
    return yield* this.gle('Images/' + nameWithExt, $completion);
  }
  *cl7(isBeastCursor, $completion) {
    return yield* this.gle('Cursors/' + (isBeastCursor ? 'Fangrir' : 'Hunters') + '.png', $completion);
  }
}
class InterfaceIcon extends Enum {
  constructor(name, ordinal, iconName) {
    super(name, ordinal);
    this.wld_1 = iconName;
  }
}
class GeneralTokens extends Enum {}
class BeastGameScene extends Scene {
  constructor(gameUi) {
    super();
    this.mlk_1 = gameUi;
    this.nlk_1 = true;
    this.olk_1 = null;
  }
  *ti4(_this__u8e3s4, $completion) {
    if (!this.nlk_1)
      return Unit_instance;
    this.mlk_1.lll(_this__u8e3s4);
    this.nlk_1 = false;
    var beastUiMap = this.mlk_1.gll_1;
    var tmp0_elvis_lhs = this.mlk_1.hll_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var korgeControlAgent = tmp;
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    var $this$keys = get_keys(_this__u8e3s4);
    var tmp_0 = Key_P_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_0, BeastGameScene$sceneInit$slambda(korgeControlAgent));
    var tmp_1 = Key_M_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_1, BeastGameScene$sceneInit$slambda_0(_this__u8e3s4));
    var tmp_2 = Key_B_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_2, BeastGameScene$sceneInit$slambda_1());
    var tmp_3 = Key_N_getInstance();
    $this$keys.rhv(tmp_3, BeastGameScene$sceneInit$slambda_2(this, korgeControlAgent));
    var tmp_4 = Key_I_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_4, BeastGameScene$sceneInit$slambda_3(korgeControlAgent));
    var tmp_5 = Key_R_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_5, BeastGameScene$sceneInit$slambda_4(korgeControlAgent));
    var tmp_6 = Key_H_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_6, BeastGameScene$sceneInit$slambda_5(beastUiMap));
    var tmp_7 = Key_H_getInstance();
    sceneInit$gameplayDown(this, $this$keys, tmp_7, BeastGameScene$sceneInit$slambda_6(beastUiMap));
    var tmp_8 = Key_X_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_8, BeastGameScene$sceneInit$slambda_7(this, _this__u8e3s4, beastUiMap));
    var tmp_9 = Key_L_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_9, BeastGameScene$sceneInit$slambda_8(this, _this__u8e3s4, beastUiMap));
    var tmp_10 = Key_A_getInstance();
    sceneInit$gameplayUp(this, $this$keys, tmp_10, BeastGameScene$sceneInit$slambda_9(korgeControlAgent));
    return Unit_instance;
  }
  *zi4($completion) {
    this.mlk_1.u1o();
    return Unit_instance;
  }
}
class BeastGameUi {
  constructor(root, map, controlAgent, images, scope) {
    this.fll_1 = root;
    this.gll_1 = map;
    this.hll_1 = controlAgent;
    this.ill_1 = images;
    this.jll_1 = scope;
    this.kll_1 = false;
  }
  lll(container) {
    var tmp0_safe_receiver = this.jll_1.d1m().ae(Key_instance);
    // Inline function 'kotlin.check' call
    if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e1m()) === true)) {
      var message = 'Cannot mount a disposed gameplay UI';
      throw IllegalStateException.o(toString(message));
    }
    container.uie(this.fll_1);
    this.kll_1 = true;
  }
  u1o() {
    cancel(this.jll_1);
  }
}
class GameUiContext {}
function get_dialogLayerContainer() {
  return this.pln();
}
class BeastUiMap {
  constructor(gameUiContext, gameTeamProvider, mapBitmap, mapping, coroutineContextFromScene) {
    this.dl7_1 = gameUiContext;
    this.el7_1 = gameTeamProvider;
    this.fl7_1 = mapping;
    this.gl7_1 = coroutineContextFromScene;
    this.hl7_1 = Container.fi2();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.jl7_1 = LinkedHashMap.m7();
    var tmp_0 = this;
    tmp_0.kl7_1 = BeastUiMap$positionAndScaleAdjuster$slambda();
    this.ll7_1 = new UiDynamicLayer();
    this.ml7_1 = new UiDynamicLayer();
    this.nl7_1 = new UiDynamicLayer();
    this.ol7_1 = new UiDynamicLayer();
    this.pl7_1 = new UiDynamicLayer();
    this.ql7_1 = new UiDynamicLayer();
    this.rl7_1 = new UiDynamicLayer();
    this.sl7_1 = new UiDynamicLayer();
    this.tl7_1 = new UiDynamicLayer();
    this.ul7_1 = new UiDynamicLayer();
    this.vl7_1 = new UiDynamicLayer();
    this.wl7_1 = new UiDynamicLayer();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.xl7_1 = LinkedHashMap.m7();
    this.yl7_1 = new UiDynamicLayer();
    this.zl7_1 = new UiDynamicLayer();
    this.al8_1 = new UiDynamicLayer();
    this.bl8_1 = Container.fi2();
    this.cl8_1 = Container.fi2();
    this.dl8_1 = listOf([this.ll7_1, this.ml7_1, this.nl7_1, this.ol7_1, this.pl7_1, this.ql7_1, this.rl7_1, this.sl7_1, this.tl7_1, this.ul7_1, this.vl7_1, this.yl7_1, this.wl7_1, this.zl7_1, this.al8_1]);
    this.el8_1 = null;
    this.fl8_1 = null;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.gl8_1 = ArrayList.p2();
    // Inline function 'korlibs.korge.view.image' call
    var this_0 = this.hl7_1;
    var anchor = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(mapBitmap, anchor);
    // Inline function 'kotlin.apply' call
    addTo(this_1, this_0);
    if (false) {
      addCoordinatesOnMap(this);
    }
    var _iterator__ex2g4s = this.dl8_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var layer = _iterator__ex2g4s.r1();
      this.hl7_1.uie(layer.tln_1);
    }
    this.hl7_1.uie(this.bl8_1);
    this.bln();
  }
  xlm() {
    var tmp = this.il7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('korgeControlAgent');
    }
  }
  k3q() {
    return this.xlm().k3q();
  }
  me0() {
    return this.xlm().me0();
  }
  se3() {
    return this.xlm().bm5();
  }
  ylm() {
    toHeight(this.hl7_1, get_gameLayout().ll5_1);
    // Inline function 'korlibs.korge.view.xy' call
    var this_0 = this.hl7_1;
    xy(this_0, numberToDouble(0), numberToDouble(0));
  }
  zlm() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var result = LinkedHashMap.m7();
    // Inline function 'kotlin.with' call
    var $this$with = _get_gameState__b96etq(this);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.wl7_1.uln_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var info = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var view = _destruct__k2r9zo.k3();
      var tmp = info.cm5_1;
      if (isInterface(tmp, SettlerType)) {
        // Inline function 'steelart.beast.castFilter' call
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = info.dm5_1;
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList.p2();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = tmp0.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element = _iterator__ex2g4s_0.r1();
          var tmp$ret$12;
          $l$block: {
            // Inline function 'steelart.beast.cast' call
            var tmp_0 = get_objectType($this$with, element);
            if (isInterface(tmp_0, SettlerType)) {
              tmp$ret$12 = element instanceof ObjectOnBoard ? element : THROW_CCE();
              break $l$block;
            }
            tmp$ret$12 = null;
          }
          var tmp0_safe_receiver = tmp$ret$12;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.d2(tmp0_safe_receiver);
          }
        }
        var _iterator__ex2g4s_1 = destination.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var settler = _iterator__ex2g4s_1.r1();
          var tmp0_0 = view.wb5();
          // Inline function 'korlibs.math.geom.Vector2D.div' call
          // Inline function 'korlibs.math.geom.Vector2D.div' call
          var this_0 = toPoint(view.nig());
          // Inline function 'korlibs.math.geom.Vector2D.plus' call
          var that = Vector2D.t9g(this_0.r9g_1 / 2, this_0.s9g_1 / 2);
          var tmp$ret$17 = Vector2D.t9g(tmp0_0.r9g_1 + that.r9g_1, tmp0_0.s9g_1 + that.s9g_1);
          // Inline function 'kotlin.collections.set' call
          var value = to(tmp$ret$17, view.rig() * 0.7);
          result.b5(settler, value);
        }
      }
    }
    return result;
  }
  *aln($completion) {
    yield* /*#__NOINLINE__*/deinstallHoveredUi(this, $completion);
    return Unit_instance;
  }
  bln() {
    // Inline function 'korlibs.korge.input.mouse' call
    var this_0 = this.hl7_1;
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse(this_0);
    // Inline function 'korlibs.korge.input.MouseEvents.onMove' call
    var handler = BeastUiMap$addMouseHoverOptions$slambda(this);
    var tmp = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_0 = getPropertyCallableRef('move', 1, tmp, MouseEvents$_get_move_$ref_mt1fcf(), null).get($this$mouse);
    tmp_0.v9y(BeastUiMap$addMouseHoverOptions$lambda($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onMoveOutside' call
    var handler_0 = BeastUiMap$addMouseHoverOptions$slambda_0(this);
    var tmp_1 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_2 = getPropertyCallableRef('moveOutside', 1, tmp_1, MouseEvents$_get_moveOutside_$ref_f8k8ca(), null).get($this$mouse);
    tmp_2.v9y(BeastUiMap$addMouseHoverOptions$lambda_0($this$mouse, handler_0));
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var handler_1 = BeastUiMap$addMouseHoverOptions$slambda_1(this);
    var tmp_3 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_4 = getPropertyCallableRef('click', 1, tmp_3, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
    tmp_4.v9y(BeastUiMap$addMouseHoverOptions$lambda_1($this$mouse, handler_1));
  }
  *cln(korgeControlAgent, $completion) {
    this.il7_1 = korgeControlAgent;
    addCustomHighlightingAreaIfNeeded(this);
    this.jl7_1.a5();
    try {
      yield* /*#__NOINLINE__*/collectUiUpdate(this, $completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw e;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  *dln($completion) {
    var _iterator__ex2g4s = this.dl8_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var container = _iterator__ex2g4s.r1();
      yield* container.dln($completion);
    }
    return Unit_instance;
  }
  *eln($completion) {
    yield* /*#__NOINLINE__*/deinstallHoveredUi(this, $completion);
    this.fl8_1 = null;
    this.el8_1 = null;
    this.il8();
    this.rln(emptyMap());
    this.jl7_1.a5();
    this.xl7_1.a5();
    this.bl8_1.tie();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.dl8_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.a5();
    }
    return Unit_instance;
  }
  fln(baseObject) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_gameState__b96etq(this);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($this$with, baseObject);
      if (tmp instanceof WatchtowerType) {
        tmp$ret$2 = baseObject instanceof ObjectOnBoard ? baseObject : THROW_CCE();
        break $l$block;
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.ul7_1.hm5(BeastUiMap$getViewForObjectOnBoard$lambda(tmp0_safe_receiver, $this$with));
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver_0;
      }
      reportWarning(this, 'Cannot find watchtower view for ' + tmp0_safe_receiver.toString() + ' at ' + BoardPosition__toString_impl_v4mn82(tmp0_safe_receiver.s2w($this$with)));
      return null;
    }
    var tmp0_elvis_lhs = this.xl7_1.w4(baseObject);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var groupedObjectsInfo = tmp_1;
    return this.wl7_1.im5(groupedObjectsInfo);
  }
  *gln(movementChange, $completion) {
    var movedObject = movementChange.q4v_1;
    var path = movementChange.r4v_1;
    yield* this.hln(movedObject, path.s2() > 2 ? path.t4(path.s2() - 2 | 0, path.s2()) : path, $completion);
    return Unit_instance;
  }
  *hln(movedObject, path, $completion) {
    if (get_gameConfiguration().olc_1)
      return Unit_instance;
    var tmp0_elvis_lhs = this.xl7_1.w4(movedObject);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var groupedObjectsInfo = tmp;
    var tmp1_elvis_lhs = this.wl7_1.im5(groupedObjectsInfo);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var view = tmp_0;
    var tmp2_elvis_lhs = this.wl7_1.xln_1.w4(view);
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var destination = tmp_1;
    if (!equals(groupedObjectsInfo.dm5_1, setOf(movedObject))) {
      this.sln('Implement "split" group');
    }
    var tmp_2;
    if (path.s2() > 2) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = path.t4(1, path.s2() - 1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        var it = item.r2v_1;
        var tmp$ret$2 = ensureNotNull(this.fl7_1.jl8(it)).ml8_1;
        destination_0.d2(tmp$ret$2);
      }
      tmp_2 = destination_0;
    } else {
      tmp_2 = emptyList();
    }
    var intermediate = tmp_2;
    var pointPath = plus(plus(listOf_0(view.wb5()), intermediate), listOf_0(destination));
    var inductionVariable = 0;
    var last = pointPath.s2() - 1 | 0;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_3 = KMutableProperty0;
        var tmp_4 = View$_get_pos_$ref_lp2nil(view);
        var tmp3_vs = [get(getPropertyCallableRef('pos', 0, tmp_3, tmp_4, View$_set_pos_$ref_npt43j(view)), pointPath.u2(i), pointPath.u2(i + 1 | 0))];
        var tmp4_easing = get_gameAnimations().ll4_1;
        var tmp5_time = get_gameAnimations().pl4_1;
        yield* tween(view, tmp3_vs, tmp5_time, tmp4_easing, VOID, VOID, VOID, VOID, $completion);
      }
       while (inductionVariable < last);
    return Unit_instance;
  }
  *iln(movedObject, intermediatePosition, $completion) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_gameState__b96etq(this);
    var tmp = this.jl7_1.w4(movedObject);
    var tmp0_elvis_lhs = tmp == null ? null : tmp.r2v_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new BoardPosition(tmp_1)) == null) {
      tmp_0 = movedObject.s2w($this$with);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var lastPosition = tmp_0;
    if (lastPosition === intermediatePosition) {
      return Unit_instance;
    }
    var tmp0 = this.jl7_1;
    // Inline function 'kotlin.collections.set' call
    var value = new BoardPosition(intermediatePosition);
    tmp0.b5(movedObject, value);
    yield* /*#__NOINLINE__*/collectUiUpdate(this, $completion);
    yield* this.hln(movedObject, listOf([new BoardPosition(lastPosition), new BoardPosition(intermediatePosition)]), $completion);
    yield* this.dln($completion);
    return Unit_instance;
  }
  jln(characterObject) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_gameState__b96etq(this);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($this$with, characterObject);
      if (isInterface(tmp, BeastCharacter)) {
        tmp$ret$2 = characterObject instanceof ObjectOnBoard ? characterObject : THROW_CCE();
        break $l$block;
      }
      tmp$ret$2 = null;
    }
    var beast = tmp$ret$2;
    var tmp_0 = get_objectType($this$with, characterObject);
    var tmp0_safe_receiver = isInterface(tmp_0, HunterCharacter) ? tmp_0 : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i3e();
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$with.f4l();
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (equals(get_objectType($this$with, element), tmp1_safe_receiver)) {
          destination.d2(element);
        }
      }
      tmp_1 = destination;
    }
    var tmp2_safe_receiver = tmp_1;
    var hunterCompanions = tmp2_safe_receiver == null ? null : toSet(tmp2_safe_receiver);
    var additional = !(beast == null) ? summonsOnMap($this$with, beast) : !(hunterCompanions == null) ? hunterCompanions : emptySet();
    var objectsOnBoard = plus(listOf_0(characterObject), additional);
    var tmp_2 = this.xlm().jl2_1;
    return launch(tmp_2, VOID, VOID, BeastUiMap$highlightCharacterObjectAndSummons$slambda(objectsOnBoard, this, additional));
  }
  kln(movedObject, questionCoroutineScope) {
    var tmp0_elvis_lhs = this.fln(movedObject);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var view = tmp;
    var tmp1_elvis_lhs = view.x1m();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var viewParent = tmp_0;
    var _destruct__k2r9zo = get_centerAndSize(view);
    var center = _destruct__k2r9zo.jm();
    var size = _destruct__k2r9zo.km();
    var glow = createGlowImage();
    var job = launch(questionCoroutineScope, VOID, VOID, BeastUiMap$highlightMovingObject$slambda(glow, viewParent, size, center));
    job.g1n(BeastUiMap$highlightMovingObject$lambda(glow));
  }
  lln(questionCoroutineScope, positions, posToAnswer, onChoose) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var uiVariants = ArrayList.p2();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var m = LinkedHashMap.m7();
    var _iterator__ex2g4s = positions.p1();
    while (_iterator__ex2g4s.q1()) {
      var position = _iterator__ex2g4s.r1().r2v_1;
      var area = ensureNotNull(this.fl7_1.jl8(position));
      var tmp = this.wlm(area);
      // Inline function 'kotlin.also' call
      var this_0 = addClickOption(tmp, BeastUiMap$addLocationVariants$slambda(onChoose, position, uiVariants, this));
      uiVariants.d2(this_0);
      var c = this_0;
      launch(questionCoroutineScope, VOID, VOID, BeastUiMap$addLocationVariants$slambda_0(c));
      var tmp2 = posToAnswer(new BoardPosition(position));
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(c, Vector2D.a9k(0, 0));
      m.b5(tmp2, value);
    }
    this.rln(m);
  }
  mln(questionCoroutineScope, positions, posToAnswer, onChoose, $super) {
    var tmp;
    if (posToAnswer === VOID) {
      tmp = BeastUiMap$addLocationVariants$lambda;
    } else {
      tmp = posToAnswer;
    }
    posToAnswer = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.lln(questionCoroutineScope, positions, posToAnswer, onChoose);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.lln.call(this, questionCoroutineScope, positions, posToAnswer, onChoose);
    }
    return tmp_0;
  }
  wlm(area) {
    // Inline function 'kotlin.apply' call
    var this_0 = CircleWithHover.wm4();
    this_0.yjp(area.nl8_1);
    this_0.cjq(new RGBA(Companion_getInstance_15().ich(136, 136, 255, 255)));
    this_0.djq(new RGBA(Colors_getInstance().cc3_1));
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    position_0(this_0, area.ml8_1);
    addTo(this_0, this.hl7_1);
    return this_0;
  }
  ell(activated) {
    if (activated) {
      this.hl7_1.uie(this.cl8_1);
    } else
      this.hl7_1.cif(this.cl8_1);
  }
  hl8(position) {
    return this.nln(setOf(new BoardPosition(position)));
  }
  nln(positions) {
    this.cl8_1.tie();
    this.hl7_1.uie(this.cl8_1);
    var _iterator__ex2g4s = positions.p1();
    while (_iterator__ex2g4s.q1()) {
      var position = _iterator__ex2g4s.r1().r2v_1;
      var tmp0_safe_receiver = this.fl7_1.jl8(position);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp0 = this.cl8_1;
        var tmp2 = tmp0_safe_receiver.nl8_1;
        // Inline function 'korlibs.korge.view.circle' call
        var fill = new RGBA(Colors_getInstance().pc8_1);
        var stroke = new RGBA(Colors_getInstance().zc2_1);
        var renderer = GraphicsRenderer_GPU_getInstance();
        // Inline function 'korlibs.korge.view.addTo' call
        var this_0 = Circle.ajq(numberToDouble(tmp2), fill, stroke, numberToDouble(0.0), true, renderer);
        // Inline function 'kotlin.apply' call
        var this_1 = addTo(this_0, tmp0);
        // Inline function 'korlibs.korge.view.anchor' call
        anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
        position_0(this_1, tmp0_safe_receiver.ml8_1);
        this_1.sig(0.5);
      }
    }
  }
  il8() {
    this.cl8_1.tie();
    this.hl7_1.cif(this.cl8_1);
  }
  *blk(isOnlyForTeam, $completion) {
    var isOnlyForTeamEventually = isOnlyForTeam && this.k3q() === get_beastsGameTeam() && this.xlm().t6h().i38_1.s2() === 5;
    var tmp0_elvis_lhs = this.pln().dhv();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stage = tmp;
    var mousePos = this.hl7_1.eih(stage.phw());
    var area = this.fl7_1.vlm(mousePos);
    if (!(area == null)) {
      var serverDrivenConfiguration = get_gameConfiguration().flc_1;
      if (serverDrivenConfiguration == null)
        null;
      else
        yield* serverDrivenConfiguration.w6l(new PingBoardPositionElement(area.kl8_1), isOnlyForTeamEventually, $completion);
    }
    return Unit_instance;
  }
  oln(position) {
    var tmp = this.xlm().jl2_1;
    launch(tmp, VOID, VOID, BeastUiMap$pingLocation$slambda(this, position));
  }
  f5c(warning, cause) {
    return this.xlm().f5c(warning, cause);
  }
  pl6() {
    return this.dl7_1.pl6();
  }
  pln() {
    return this.dl7_1.pln();
  }
  ol6() {
    return this.dl7_1.ol6();
  }
  qln() {
    return this.dl7_1.qln();
  }
  rln(_set____db54di) {
    this.dl7_1.rln(_set____db54di);
  }
  dl5() {
    return this.dl7_1.dl5();
  }
  sln(message) {
    this.dl7_1.sln(message);
  }
}
class BeastMapUiForDevelop extends BeastUiMap {
  constructor(gameUiContext, gameTeamProvider, mapBitmap, mapping, coroutineContextFromScene) {
    super(gameUiContext, gameTeamProvider, mapBitmap, mapping, coroutineContextFromScene);
    this.tlm_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.ulm_1 = LinkedHashSet.v2();
    if (equals(get_gameConfiguration().zlb_1, LocalGameMode_CheckNearPositions_getInstance())) {
      addAdjustentMovementTracker(this);
    }
    if (equals(get_gameConfiguration().zlb_1, LocalGameMode_CheckLocationType_getInstance())) {
      checkLocationTypes(this);
    }
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.jlo_1 = function_0;
  }
  pj(a, b) {
    return this.jlo_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.jlo_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class HotSeatSceneManager extends UiSessionState {
  constructor(sceneContainer) {
    super();
    this.plo_1 = sceneContainer;
  }
}
class BindingTestMenuManagement {
  constructor() {
    this.qlo_1 = -1;
  }
  pdw(_set____db54di) {
    this.qlo_1 = _set____db54di;
  }
  vdw() {
    return this.qlo_1;
  }
  *udx($completion) {
    return Unit_instance;
  }
  *wdx(answerIndexBeforeAnotherAnswerChosen, $completion) {
    return Unit_instance;
  }
}
class sam$kotlinx_coroutines_flow_FlowCollector$0 {
  constructor(function_0) {
    this.als_1 = function_0;
  }
  *k24(value, $completion) {
    return yield* this.als_1(value, $completion);
  }
  p5() {
    return this.als_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class MainMenuScene$performGameReplay$1$menuManagement$1 {
  constructor($gameReplayDriver, $isSandboxGame, $completedGame, this$0, $serverDrivenConfiguration, $gameCode, $switchingGameTeamProvider) {
    this.uls_1 = $isSandboxGame;
    this.vls_1 = $completedGame;
    this.wls_1 = this$0;
    this.xls_1 = $serverDrivenConfiguration;
    this.yls_1 = $gameCode;
    this.zls_1 = $switchingGameTeamProvider;
    this.rls_1 = -1;
    this.sls_1 = $gameReplayDriver.z97();
    this.tls_1 = (!$isSandboxGame && $completedGame.h6n_1);
  }
  pdw(_set____db54di) {
    this.rls_1 = _set____db54di;
  }
  vdw() {
    return this.rls_1;
  }
  z97() {
    return this.sls_1;
  }
  sdx() {
    return this.tls_1;
  }
  *tdx($completion) {
    yield* /*#__NOINLINE__*/requestPublicReplaySharing(this.wls_1, this.wls_1.ulp_1.plo_1, this.xls_1, this.yls_1, $completion);
    return Unit_instance;
  }
  *udx($completion) {
    this.wls_1.ulp_1.odx();
    clearNavigationUrl(true);
    yield* insideScope(this.wls_1.ulp_1.plo_1, MainMenuScene$performGameReplay$slambda$o$restartCallback$slambda(this.wls_1), $completion);
    return Unit_instance;
  }
  *wdx(answerIndexBeforeAnotherAnswerChosen, $completion) {
    var tmp;
    if (this.zls_1._v == null) {
      throwUninitializedPropertyAccessException('switchingGameTeamProvider');
    } else {
      tmp = this.zls_1._v;
    }
    setReplayCodeInUrl(this.yls_1, this.uls_1, answerIndexBeforeAnotherAnswerChosen, VOID, tmp.ze0_1);
    var tmp_0;
    if (this.zls_1._v == null) {
      throwUninitializedPropertyAccessException('switchingGameTeamProvider');
    } else {
      tmp_0 = this.zls_1._v;
    }
    performGameReplay(this.wls_1, this.xls_1, this.vls_1, this.uls_1, answerIndexBeforeAnotherAnswerChosen, VOID, tmp_0.ze0_1, false);
    return Unit_instance;
  }
}
class MainMenuScene extends Scene {
  constructor(hotSeatSceneManager, images, logicScope) {
    super();
    this.ulp_1 = hotSeatSceneManager;
    this.vlp_1 = images;
    this.wlp_1 = logicScope;
    this.xlp_1 = null;
    this.ylp_1 = null;
    this.zlp_1 = null;
    this.alq_1 = null;
    this.blq_1 = null;
    this.clq_1 = null;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = Container.fi2();
    this_0.thy(false);
    this_0.sig(0.0);
    tmp.dlq_1 = this_0;
    this.elq_1 = null;
  }
  *ti4(_this__u8e3s4, $completion) {
    set_currentKorgeMode(OtherControlAgentMode_instance);
    _this__u8e3s4.uie(this.dlq_1);
    var serverDrivenConfiguration = get_gameConfiguration().flc_1;
    setNavigationUrlChangeListener(MainMenuScene$sceneInit$lambda(this, serverDrivenConfiguration));
    if (!(serverDrivenConfiguration == null)) {
      launch(this, VOID, VOID, MainMenuScene$sceneInit$slambda(serverDrivenConfiguration, this, _this__u8e3s4));
      launch(this, VOID, VOID, MainMenuScene$sceneInit$slambda_0(serverDrivenConfiguration, this, _this__u8e3s4));
    } else {
      yield* this.bls(_this__u8e3s4, $completion);
    }
    return Unit_instance;
  }
  *bls(sContainer, $completion) {
    var tmp0_safe_receiver = get_gameConfiguration().flc_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      yield* tmp0_safe_receiver.c6l($completion);
    if (!get_gameConfiguration().mll()) {
      yield* /*#__NOINLINE__*/initGame(this.ulp_1, this.vlp_1, this.wlp_1, NewGameSetup_instance, $completion);
      return Unit_instance;
    }
    var controlPanelY = new ButtonColumn(Size2D.l9i(337, 49));
    var menuContent = new ControlPanelY();
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(yield* (yield* this.vlp_1.yle('BeastTitle.png', $completion)).m1q($completion));
    this_0.uif(get_gameLayout().el6_1 * 0.25 / this_0.w9z());
    var titleImage = this_0;
    var tmp1_safe_receiver = get_gameConfiguration().hlc_1.b6k_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(tmp1_safe_receiver)) {
        tmp_0 = tmp1_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = createLinkText("Steelart's edition", tmp2_safe_receiver, get_gameLayout().sl5_1);
    }
    var editionLink = tmp_1;
    var tmp3_safe_receiver = this.blq_1;
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      var userInfo = new UserInfoView(this.ulp_1.plo_1, tmp3_safe_receiver, this.clq_1, get_gameLayout().ul5_1, get_gameLayout().ul5_1 * 2);
      // Inline function 'kotlin.apply' call
      var this_1 = new ControlPanelY();
      this_1.mlr(userInfo.clt_1);
      tmp_2 = this_1;
    }
    var signedInUserPanel = tmp_2;
    var tmp_3 = DialogCorner_RIGHT_TOP_getInstance();
    var gameDialog = GameDialog.mlt(sContainer, DialogContent.llt(menuContent.xlb_1, mapOf(to(tmp_3, signedInUserPanel == null ? null : signedInUserPanel.xlb_1))));
    this.zlp_1 = gameDialog;
    var tmp5_safe_receiver = get_gameConfiguration().hlc_1.c6k_1;
    var tmp_4;
    if (tmp5_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_5;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(tmp5_safe_receiver)) {
        tmp_5 = tmp5_safe_receiver;
      } else {
        tmp_5 = null;
      }
      tmp_4 = tmp_5;
    }
    var tmp6_safe_receiver = tmp_4;
    var tmp_6;
    if (tmp6_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_6 = createLinkText('Version: 1.0.5', tmp6_safe_receiver, get_gameLayout().sl5_1);
    }
    var versionLink = tmp_6;
    var serverDrivenConfiguration = get_gameConfiguration().flc_1;
    if (!(serverDrivenConfiguration == null)) {
      var authenticationCapabilities = yield* serverDrivenConfiguration.t6k($completion);
      set_gameConfiguration(get_gameConfiguration().glr(VOID, VOID, VOID, VOID, authenticationCapabilities.v6i_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, authenticationCapabilities.y6i_1));
      if (this.blq_1 == null && authenticationCapabilities.x6i_1) {
        set_gameConfiguration(get_gameConfiguration().glr(VOID, setOf(BeastClientFeature_Sandbox_getInstance()), false));
      }
      if (this.blq_1 == null || get_gameConfiguration().blc_1) {
        if (authenticationCapabilities.s6i_1 || authenticationCapabilities.t6i_1 || authenticationCapabilities.u6i_1) {
          addTo_0(ActionButton.vlb('Log In', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda(gameDialog, this, sContainer, serverDrivenConfiguration, authenticationCapabilities)), controlPanelY);
        }
      } else if (!(this.blq_1 == null)) {
        var userActions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
        var tmp_7;
        try {
          tmp_7 = yield* serverDrivenConfiguration.r6l($completion);
        } catch ($p) {
          var tmp_8;
          if ($p instanceof CancellationException) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception) {
              var e_0 = $p;
              println('Failed to load pending consents: ' + e_0.message);
              tmp_8 = emptyList();
            } else {
              throw $p;
            }
          }
          tmp_7 = tmp_8;
        }
        var pendingConsents = tmp_7;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!pendingConsents.n1()) {
          addTo_0(ActionButton.vlb('Pending consents', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_0(this, serverDrivenConfiguration, gameDialog, sContainer)), userActions);
        }
        addTo_0(ActionButton.vlb('Settings', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_1(gameDialog, this, sContainer, serverDrivenConfiguration)), userActions);
        addTo_0(ActionButton.vlb('Log out', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_2(this, serverDrivenConfiguration, gameDialog, sContainer)), userActions);
        // Inline function 'kotlin.requireNotNull' call
        var tmp$ret$18;
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (signedInUserPanel == null) {
            var message = 'Required value was null.';
            throw IllegalArgumentException.h2(toString(message));
          } else {
            tmp$ret$18 = signedInUserPanel;
            break $l$block;
          }
        }
        var tmp$ret$17 = tmp$ret$18;
        addTo_0(userActions.xlb_1, tmp$ret$17);
        // Inline function 'kotlin.apply' call
        var this_2 = signedInUserPanel.xlb_1;
        var panelWidth = this_2.w9z();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this_2.xi1_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.rif(panelWidth - element.pig());
        }
      }
    }
    controlPanelY.tlt_1 = controlPanelY.tlt_1 + get_gameLayout().vl5_1;
    var recording = get_gameConfiguration().jlc_1;
    var tmp_9;
    if (!(this.blq_1 == null) && get_gameConfiguration().vlt(BeastClientFeature_Sandbox_getInstance()) && !(serverDrivenConfiguration == null)) {
      tmp_9 = yield* serverDrivenConfiguration.k6l($completion);
    } else {
      tmp_9 = emptyList();
    }
    var sandboxReplays = tmp_9;
    var hasOwnReplays = false;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_3 = ArrayList.p2();
    if (!(serverDrivenConfiguration == null)) {
      var activeGameSessions = yield* serverDrivenConfiguration.a6l($completion);
      var tmp0 = activeGameSessions.g6m_1.y4();
      var tmp$ret$28;
      $l$block_1: {
        // Inline function 'kotlin.collections.any' call
        var tmp_10;
        if (isInterface(tmp0, Collection)) {
          tmp_10 = tmp0.n1();
        } else {
          tmp_10 = false;
        }
        if (tmp_10) {
          tmp$ret$28 = false;
          break $l$block_1;
        }
        var _iterator__ex2g4s_0 = tmp0.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (element_0.z6p_1) {
            tmp$ret$28 = true;
            break $l$block_1;
          }
        }
        tmp$ret$28 = false;
      }
      if (tmp$ret$28) {
        addTo_0(ActionButton.vlb('Continue Game', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_3(gameDialog, this, sContainer)), controlPanelY);
      }
      if (get_gameConfiguration().vlt(BeastClientFeature_NetworkPlay_getInstance())) {
        var gamesForReplay = yield* serverDrivenConfiguration.j6l($completion);
        // Inline function 'kotlin.collections.isNotEmpty' call
        hasOwnReplays = !gamesForReplay.n1();
        addTo_0(ActionButton.vlb('Create Game', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_4(gameDialog, this, sContainer, serverDrivenConfiguration)), controlPanelY);
        addTo_0(ActionButton.vlb('Join Lobby', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_5(gameDialog, this, sContainer, serverDrivenConfiguration)), controlPanelY);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!gamesForReplay.n1()) {
          addTo_0(ActionButton.vlb('Replays', VOID, VOID, VOID, VOID, VOID, MainMenuScene$topLevelScene$slambda_6(gameDialog, this, sContainer, serverDrivenConfiguration, gamesForReplay)), controlPanelY);
        }
      }
      var tmp_11 = get_gameI18n().i6y_1;
      this_3.d2(new TextAndAction(tmp_11, MainMenuScene$topLevelScene$slambda_7(serverDrivenConfiguration, this)));
      if (!hasOwnReplays) {
        var tmp_12 = get_gameI18n().j6y_1;
        this_3.d2(new TextAndAction(tmp_12, MainMenuScene$topLevelScene$slambda_8(gameDialog, this, sContainer, serverDrivenConfiguration)));
      }
    }
    if (get_gameConfiguration().vlt(BeastClientFeature_Sandbox_getInstance()) || get_gameConfiguration().wlt(LocalGameMode_Sandbox_getInstance())) {
      var tmp_13 = get_gameI18n().k6y_1;
      this_3.d2(new TextAndAction(tmp_13, MainMenuScene$topLevelScene$slambda_9(serverDrivenConfiguration, sandboxReplays, this, sContainer)));
    }
    this_3.d2(new TextAndAction('Content Reference', MainMenuScene$topLevelScene$slambda_10(gameDialog, this, sContainer)));
    var tmp_14;
    // Inline function 'kotlin.text.isNullOrBlank' call
    var this_4 = get_gameConfiguration().hlc_1.e6k_1;
    if (!(this_4 == null || isBlank(this_4))) {
      tmp_14 = true;
    } else {
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_5 = get_gameConfiguration().hlc_1.f6k_1;
      tmp_14 = !(this_5 == null || isBlank(this_5));
    }
    if (tmp_14) {
      this_3.d2(new TextAndAction('Community', MainMenuScene$topLevelScene$slambda_11(gameDialog, this, sContainer)));
    }
    if (get_gameConfiguration().wlt(LocalGameMode_HotSeat_getInstance())) {
      var tmp_15 = get_gameI18n().n6y_1;
      this_3.d2(new TextAndAction(tmp_15, MainMenuScene$topLevelScene$slambda_12(this)));
      var tmp_16 = get_gameI18n().o6y_1;
      this_3.d2(new TextAndAction(tmp_16, MainMenuScene$topLevelScene$slambda_13(this)));
    }
    var actions = this_3.g9();
    var _iterator__ex2g4s_1 = (recording ? listOf_0(last(actions)) : actions).p1();
    while (_iterator__ex2g4s_1.q1()) {
      var action = _iterator__ex2g4s_1.r1();
      addTo_0(ActionButton.xlt(action, MainMenuScene$topLevelScene$slambda_14(gameDialog)), controlPanelY);
    }
    controlPanelY.tlt_1 = controlPanelY.tlt_1 + get_gameLayout().vl5_1;
    addTo_0(controlPanelY.xlb_1, menuContent);
    if (get_gameConfiguration().blc_1) {
      addTo_0(PlainText('Guest games expire after inactivity. Log in to keep them.', get_gameLayout().sl5_1), menuContent);
    }
    menuContent.flr();
    gameDialog.ylq();
    var dialogBackground = gameDialog.ylt();
    // Inline function 'kotlin.requireNotNull' call
    var tmp0_0 = dialogBackground.x1m();
    var tmp$ret$35;
    $l$block_2: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0_0 == null) {
        var message_0 = 'Required value was null.';
        throw IllegalArgumentException.h2(toString(message_0));
      } else {
        tmp$ret$35 = tmp0_0;
        break $l$block_2;
      }
    }
    var tmp$ret$34 = tmp$ret$35;
    xy(addTo(titleImage, tmp$ret$34), dialogBackground.wea() + (dialogBackground.w9z() - titleImage.pig()) / 2, dialogBackground.xea() + get_gameLayout().ql5_1);
    if (editionLink == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.requireNotNull' call
      var tmp0_1 = dialogBackground.x1m();
      var tmp$ret$40;
      $l$block_3: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_1 == null) {
          var message_1 = 'Required value was null.';
          throw IllegalArgumentException.h2(toString(message_1));
        } else {
          tmp$ret$40 = tmp0_1;
          break $l$block_3;
        }
      }
      var tmp$ret$39 = tmp$ret$40;
      xy(addTo(editionLink, tmp$ret$39), dialogBackground.wea() + (dialogBackground.w9z() - editionLink.pig()) / 2, titleImage.xea() + titleImage.rig() + get_gameLayout().yl5_1);
    }
    if (versionLink == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.requireNotNull' call
      var tmp0_2 = dialogBackground.x1m();
      var tmp$ret$45;
      $l$block_4: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_2 == null) {
          var message_2 = 'Required value was null.';
          throw IllegalArgumentException.h2(toString(message_2));
        } else {
          tmp$ret$45 = tmp0_2;
          break $l$block_4;
        }
      }
      var tmp$ret$44 = tmp$ret$45;
      xy(addTo(versionLink, tmp$ret$44), dialogBackground.wea() + (dialogBackground.w9z() - versionLink.pig()) / 2, dialogBackground.xea() + dialogBackground.x9z() - get_gameLayout().ql5_1 - versionLink.rig());
    }
    startMenuBackground(this);
    var tmp9_safe_receiver = getContentReferenceFromUrl();
    if (tmp9_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      openContentReference(this, sContainer, tmp9_safe_receiver, false);
    }
    return Unit_instance;
  }
  *cls(sContainer, $completion) {
    var controlPanelY = new ControlPanelY();
    var gameRows = new ControlPanelY();
    var gameDialog = GameDialog.xlq(sContainer, controlPanelY.xlb_1);
    var reconnectInProgress = {_v: false};
    addTo_0(PlainText('Choose where to reconnect', get_gameLayout().vl5_1), controlPanelY);
    addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$reconnectOptions$slambda(gameDialog, this, sContainer)), controlPanelY);
    var serverDrivenConfiguration = ensureNotNull(get_gameConfiguration().flc_1);
    var activeGameSessions = yield* serverDrivenConfiguration.a6l($completion);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = activeGameSessions.g6m_1.i3().p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var gameName = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var sessionInfo = _destruct__k2r9zo.k3();
      if (!sessionInfo.z6p_1)
        continue $l$loop;
      var gameCode = sessionInfo.x6p_1;
      var controlPanelX = new ButtonRow();
      addTo_0(PlainText(gameName, get_gameLayout().sl5_1), controlPanelX);
      var _iterator__ex2g4s_0 = sessionInfo.y6p_1.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var gameTeam = _iterator__ex2g4s_0.r1().r3p_1;
        var tmp = 'Reconnect As ' + get_gameI18n().m70(gameTeam);
        addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, MainMenuScene$reconnectOptions$slambda_0(reconnectInProgress, sContainer, serverDrivenConfiguration, gameCode, gameTeam, gameDialog, this)), controlPanelX);
      }
      var tmp0 = sessionInfo.y6p_1;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_1 = tmp0.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element = _iterator__ex2g4s_1.r1();
          var it = element.r3p_1;
          if (!get_isObserver(it)) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3) {
        addTo_0(ActionButton.vlb('Reload game', VOID, VOID, VOID, VOID, VOID, MainMenuScene$reconnectOptions$slambda_1(reconnectInProgress, sContainer, serverDrivenConfiguration, gameCode, sessionInfo, gameDialog, this)), controlPanelX);
      }
      var tmp0_0 = sessionInfo.y6p_1;
      var tmp$ret$5;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(tmp0_0, Collection)) {
          tmp_1 = tmp0_0.n1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$5 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_2 = tmp0_0.p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_0 = _iterator__ex2g4s_2.r1();
          var it_0 = element_0.r3p_1;
          if (!get_isObserver(it_0)) {
            tmp$ret$5 = true;
            break $l$block_2;
          }
        }
        tmp$ret$5 = false;
      }
      if (tmp$ret$5) {
        addTo_0(ActionButton.vlb('Cancel', VOID, VOID, VOID, VOID, VOID, MainMenuScene$reconnectOptions$slambda_2(reconnectInProgress, serverDrivenConfiguration, gameCode, gameDialog, this, sContainer)), controlPanelX);
      }
      addTo_0(controlPanelX.xlb_1, gameRows);
    }
    addScrollableGameRows(controlPanelY, gameRows);
    gameDialog.ylq();
    return Unit_instance;
  }
}
class initGame$menuManagement$1 {
  constructor($gameSetup, $requestGameReload, $hotSeatSceneManager, $images, $logicScope) {
    this.glx_1 = $gameSetup;
    this.hlx_1 = $requestGameReload;
    this.ilx_1 = $hotSeatSceneManager;
    this.jlx_1 = $images;
    this.klx_1 = $logicScope;
    this.elx_1 = -1;
    var tmp = this;
    tmp.flx_1 = $gameSetup instanceof ServerDuelSetup;
  }
  pdw(_set____db54di) {
    this.elx_1 = _set____db54di;
  }
  vdw() {
    return this.elx_1;
  }
  rdx() {
    return this.flx_1;
  }
  vdx() {
    return this.hlx_1._v();
  }
  *udx($completion) {
    launch(this.ilx_1.plo_1, VOID, VOID, initGame$o$restartCallback$slambda(this.ilx_1, this.jlx_1, this.klx_1));
    return Unit_instance;
  }
  *wdx(answerIndexBeforeAnotherAnswerChosen, $completion) {
    this.ilx_1.odx();
    this.ilx_1.ldx_1 = null;
    var tmp = this.glx_1;
    if (!(tmp instanceof OfflineRecordedGameSetup)) {
      // Inline function 'kotlin.error' call
      var message = 'This can be used only for offline games';
      throw IllegalStateException.o(toString(message));
    }
    var gameSetupFromAnswerNumber = new OfflineRecordedGameSetup(false, answerIndexBeforeAnotherAnswerChosen);
    yield* /*#__NOINLINE__*/initGame(this.ilx_1, this.jlx_1, this.klx_1, gameSetupFromAnswerNumber, $completion);
    return Unit_instance;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.jm1_1 = function_0;
  }
  pj(a, b) {
    return this.jm1_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.jm1_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.km1_1 = function_0;
  }
  pj(a, b) {
    return this.km1_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.km1_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class MapHoveredUi {}
function *onLeave($completion) {
  return Unit_instance;
}
function *onClick($completion) {
  return Unit_instance;
}
class BeastUiMap$installSandboxRelatedHovers$1 {
  constructor(this$0, $position, $sandboxHoverView) {
    this.lm1_1 = this$0;
    this.mm1_1 = $position;
    this.nm1_1 = $sandboxHoverView;
  }
  *om1($completion) {
    var tmp0_safe_receiver = this.lm1_1.el8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* tmp0_safe_receiver(new BoardPosition(this.mm1_1), $completion);
      this.lm1_1.el8_1 = null;
      return Unit_instance;
    }
    yield* showVariantsForLocation(this.lm1_1.xlm(), this.mm1_1, $completion);
    return Unit_instance;
  }
  *zlx($completion) {
    this.nm1_1.uih();
    return Unit_instance;
  }
}
class BeastUiMap$installRuinHover$2 {
  constructor($ruinsPanel) {
    this.pm1_1 = $ruinsPanel;
  }
  *om1($completion) {
    return Unit_instance;
  }
  *zlx($completion) {
    this.pm1_1.xlb_1.uih();
    return Unit_instance;
  }
}
class BeastUiMap$installSnareHover$2 {
  constructor($snareHover) {
    this.qm1_1 = $snareHover;
  }
  *om1($completion) {
    return Unit_instance;
  }
  *zlx($completion) {
    this.qm1_1.uih();
    return Unit_instance;
  }
}
class BeastUiMap$collectUiUpdate$$inlined$with$12 {
  constructor($this) {
    this.rm1_1 = $this;
  }
  n7() {
    return this.rm1_1.p1();
  }
  f10(element) {
    return new BoardPosition(element.cly_1);
  }
  o7(element) {
    return this.f10(element);
  }
}
class HoverableUiElement {}
function *pingHighlight($completion) {
  var timeMillis = get_gameAnimations().al5_1;
  yield* delay(timeMillis, $completion);
  while (true) {
    this.pl8(true);
    this.ql8();
    yield* delay(timeMillis, $completion);
    this.pl8(false);
    this.ql8();
    yield* delay(timeMillis, $completion);
    this.pl8(true);
    this.ql8();
    yield* delay(timeMillis, $completion);
    this.pl8(false);
    this.ql8();
    yield* delay(get_gameAnimations().bl5_1, $completion);
  }
  return Unit_instance;
}
class TransparencyHoverableUiElement {}
function get_inactiveAlpha() {
  return 0.3;
}
function get_hoverAlpha() {
  return this.ym4() * 1.5;
}
function applyStyle() {
  if (this.am5()) {
    (this instanceof View ? this : THROW_CCE()).sig(this.zm4());
  } else {
    (this instanceof View ? this : THROW_CCE()).sig(this.ym4());
  }
}
class CircleWithHover extends Circle {
  constructor() {
    return new.target.wm4();
  }
  static wm4() {
    var $this = this.ajq();
    $this.sm4_1 = false;
    $this.tm4_1 = get_inactiveAlpha.call($this);
    $this.um4_1 = 0.7;
    return $this;
  }
  pl8(_set____db54di) {
    this.sm4_1 = _set____db54di;
  }
  am5() {
    return this.sm4_1;
  }
  xm4(_set____db54di) {
    this.tm4_1 = _set____db54di;
  }
  ym4() {
    return this.tm4_1;
  }
  zm4() {
    return this.um4_1;
  }
  *klo($completion) {
    var tmp0_elvis_lhs = this.x1m();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var p = tmp;
    var tmp1_radius = this.vjp();
    var tmp2_fill = Colors_getInstance().ec3_1;
    var tmp3_strokeThickness = this.vjp() / 7;
    var tmp4_stroke = Colors_getInstance().bc3_1;
    // Inline function 'kotlin.also' call
    var this_0 = Circle.ajq(tmp1_radius, new RGBA(tmp2_fill), new RGBA(tmp4_stroke), tmp3_strokeThickness);
    var tmp0 = this.wb5();
    var tmp0_0 = toVector(this.nig());
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var that = this.jjb().q9g();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that_0 = Vector2D.t9g(tmp0_0.r9g_1 * that.r9g_1, tmp0_0.s9g_1 * that.s9g_1);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 - that_0.r9g_1, tmp0.s9g_1 - that_0.s9g_1);
    this_0.fcw(tmp$ret$3);
    this_0.ijb(Companion_getInstance_7().c9g_1);
    var c = this_0;
    try {
      var timeMillis = get_gameAnimations().al5_1;
      while (true) {
        yield* delay(timeMillis, $completion);
        p.uie(c);
        yield* delay(timeMillis, $completion);
        p.cif(c);
        yield* delay(timeMillis, $completion);
        p.uie(c);
        yield* delay(timeMillis, $completion);
        p.cif(c);
        yield* delay(get_gameAnimations().bl5_1, $completion);
      }
    }finally {
      p.cif(c);
    }
    return Unit_instance;
  }
  *vm4($completion) {
    var start = 0.1;
    while (true) {
      var tmp = Duration__div_impl_dknbf4(get_gameAnimations().cl5_1, 2);
      yield* tween(this, [], tmp, VOID, VOID, VOID, VOID, CircleWithHover$slowPulse$lambda(this, start), $completion);
      var tmp_0 = Duration__div_impl_dknbf4(get_gameAnimations().cl5_1, 2);
      yield* tween(this, [], tmp_0, VOID, VOID, VOID, VOID, CircleWithHover$slowPulse$lambda_0(this, start), $completion);
    }
    return Unit_instance;
  }
}
class BeastUiMap$addCustomHighlightingAreaIfNeeded$1 extends CircleWithHover {
  constructor() {
    return new.target.im1();
  }
  static im1() {
    var $this = this.wm4();
    $this.gm1_1 = 0.0;
    $this.hm1_1 = 0.5;
    return $this;
  }
  xm4(_set____db54di) {
    this.gm1_1 = _set____db54di;
  }
  ym4() {
    return this.gm1_1;
  }
  zm4() {
    return this.hm1_1;
  }
}
class BeastMovementsKey {
  constructor(beastCharacter, count, lastMovement) {
    this.jm5_1 = beastCharacter;
    this.km5_1 = count;
    this.lm5_1 = lastMovement;
  }
  toString() {
    return 'BeastMovementsKey(beastCharacter=' + toString(this.jm5_1) + ', count=' + this.km5_1 + ', lastMovement=' + toString_0(this.lm5_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.jm5_1);
    result = imul(result, 31) + this.km5_1 | 0;
    result = imul(result, 31) + (this.lm5_1 == null ? 0 : this.lm5_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMovementsKey))
      return false;
    if (!equals(this.jm5_1, other.jm5_1))
      return false;
    if (!(this.km5_1 === other.km5_1))
      return false;
    if (!equals(this.lm5_1, other.lm5_1))
      return false;
    return true;
  }
}
class AlternativeBeastSetupPlaceholder {
  constructor(position, beast) {
    this.mm5_1 = position;
    this.nm5_1 = beast;
  }
  toString() {
    return 'AlternativeBeastSetupPlaceholder(position=' + BoardPosition__toString_impl_v4mn82(this.mm5_1) + ', beast=' + this.nm5_1.toString() + ')';
  }
  hashCode() {
    var result = BoardPosition__hashCode_impl_9dgqf7(this.mm5_1);
    result = imul(result, 31) + this.nm5_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AlternativeBeastSetupPlaceholder))
      return false;
    if (!(this.mm5_1 === other.mm5_1))
      return false;
    if (!this.nm5_1.equals(other.nm5_1))
      return false;
    return true;
  }
}
class GroupedObjectsInfo {
  constructor(objectType, objects, shownWounds, shownArmor, isAlternativeView) {
    isAlternativeView = isAlternativeView === VOID ? false : isAlternativeView;
    this.cm5_1 = objectType;
    this.dm5_1 = objects;
    this.em5_1 = shownWounds;
    this.fm5_1 = shownArmor;
    this.gm5_1 = isAlternativeView;
  }
  toString() {
    return 'GroupedObjectsInfo(objectType=' + toString(this.cm5_1) + ', objects=' + toString(this.dm5_1) + ', shownWounds=' + this.em5_1 + ', shownArmor=' + this.fm5_1 + ', isAlternativeView=' + this.gm5_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.cm5_1);
    result = imul(result, 31) + hashCode(this.dm5_1) | 0;
    result = imul(result, 31) + this.em5_1 | 0;
    result = imul(result, 31) + this.fm5_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gm5_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GroupedObjectsInfo))
      return false;
    if (!equals(this.cm5_1, other.cm5_1))
      return false;
    if (!equals(this.dm5_1, other.dm5_1))
      return false;
    if (!(this.em5_1 === other.em5_1))
      return false;
    if (!(this.fm5_1 === other.fm5_1))
      return false;
    if (!(this.gm5_1 === other.gm5_1))
      return false;
    return true;
  }
}
class TrailInfoKey {
  constructor(beastCharacter, position, hiddenTrails, foundTrails, needBigTrail, trailOffset, totalTrails) {
    this.om5_1 = beastCharacter;
    this.pm5_1 = position;
    this.qm5_1 = hiddenTrails;
    this.rm5_1 = foundTrails;
    this.sm5_1 = needBigTrail;
    this.tm5_1 = trailOffset;
    this.um5_1 = totalTrails;
  }
  toString() {
    return 'TrailInfoKey(beastCharacter=' + toString(this.om5_1) + ', position=' + BoardPosition__toString_impl_v4mn82(this.pm5_1) + ', hiddenTrails=' + this.qm5_1 + ', foundTrails=' + this.rm5_1 + ', needBigTrail=' + this.sm5_1 + ', trailOffset=' + this.tm5_1 + ', totalTrails=' + this.um5_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.om5_1);
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.pm5_1) | 0;
    result = imul(result, 31) + this.qm5_1 | 0;
    result = imul(result, 31) + this.rm5_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.sm5_1) | 0;
    result = imul(result, 31) + this.tm5_1 | 0;
    result = imul(result, 31) + this.um5_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrailInfoKey))
      return false;
    if (!equals(this.om5_1, other.om5_1))
      return false;
    if (!(this.pm5_1 === other.pm5_1))
      return false;
    if (!(this.qm5_1 === other.qm5_1))
      return false;
    if (!(this.rm5_1 === other.rm5_1))
      return false;
    if (!(this.sm5_1 === other.sm5_1))
      return false;
    if (!(this.tm5_1 === other.tm5_1))
      return false;
    if (!(this.um5_1 === other.um5_1))
      return false;
    return true;
  }
}
class PlacedTrapsZoneInfo {
  constructor(zone, trapsCount) {
    this.vm5_1 = zone;
    this.wm5_1 = trapsCount;
  }
  toString() {
    return 'PlacedTrapsZoneInfo(zone=' + this.vm5_1.toString() + ', trapsCount=' + this.wm5_1 + ')';
  }
  hashCode() {
    var result = this.vm5_1.hashCode();
    result = imul(result, 31) + this.wm5_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedTrapsZoneInfo))
      return false;
    if (!this.vm5_1.equals(other.vm5_1))
      return false;
    if (!(this.wm5_1 === other.wm5_1))
      return false;
    return true;
  }
}
class TrailRenderInfo {
  constructor(beast, position, hiddenTrails, foundTrails) {
    this.bly_1 = beast;
    this.cly_1 = position;
    this.dly_1 = hiddenTrails;
    this.ely_1 = foundTrails;
  }
  jm() {
    return this.bly_1;
  }
  fly() {
    return this.cly_1;
  }
  fx() {
    return this.dly_1;
  }
  gly() {
    return this.ely_1;
  }
  toString() {
    return 'TrailRenderInfo(beast=' + this.bly_1.toString() + ', position=' + BoardPosition__toString_impl_v4mn82(this.cly_1) + ', hiddenTrails=' + this.dly_1 + ', foundTrails=' + this.ely_1 + ')';
  }
  hashCode() {
    var result = this.bly_1.hashCode();
    result = imul(result, 31) + BoardPosition__hashCode_impl_9dgqf7(this.cly_1) | 0;
    result = imul(result, 31) + this.dly_1 | 0;
    result = imul(result, 31) + this.ely_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TrailRenderInfo))
      return false;
    if (!this.bly_1.equals(other.bly_1))
      return false;
    if (!(this.cly_1 === other.cly_1))
      return false;
    if (!(this.dly_1 === other.dly_1))
      return false;
    if (!(this.ely_1 === other.ely_1))
      return false;
    return true;
  }
}
class RoundRectWithHover extends Container {
  static fmd(r, $box) {
    var $this = this.fi2(VOID, $box);
    init_steelart_ui_korge_RoundRectWithHover($this);
    $this.uie(r);
    return $this;
  }
  static gmg(size, radius, $box) {
    var $this = this.fi2(VOID, $box);
    init_steelart_ui_korge_RoundRectWithHover($this);
    $this.uie(RoundRect.rka(size, radius));
    return $this;
  }
  pl8(_set____db54di) {
    this.emd_1 = _set____db54di;
  }
  am5() {
    return this.emd_1;
  }
}
class createHoveredIconAction$roundRect$1 extends RoundRectWithHover {
  constructor($r, $text, $result) {
    return new.target.km8($r, $text, $result);
  }
  static km8($r, $text, $result, $box) {
    if ($box === VOID)
      $box = {};
    $box.im8_1 = $text;
    $box.jm8_1 = $result;
    var $this = this.fmd($r, $box);
    $this.gm8_1 = 0.0;
    $this.hm8_1 = 0.4;
    return $this;
  }
  ym4() {
    return this.gm8_1;
  }
  zm4() {
    return this.hm8_1;
  }
  ql8() {
    protoOf(RoundRectWithHover).ql8.call(this);
    if (this.am5() && !(this.im8_1 == null)) {
      var tmp;
      if (this.jm8_1._v == null) {
        throwUninitializedPropertyAccessException('result');
      } else {
        tmp = this.jm8_1._v;
      }
      tmp.uie(this.im8_1);
    } else {
      var tmp_0;
      if (this.jm8_1._v == null) {
        throwUninitializedPropertyAccessException('result');
      } else {
        tmp_0 = this.jm8_1._v;
      }
      tmp_0.cif(this.im8_1);
    }
  }
}
class createHoveredIconAction$1 extends Container {
  constructor($roundRect) {
    return new.target.uma($roundRect);
  }
  static uma($roundRect, $box) {
    if ($box === VOID)
      $box = {};
    $box.tma_1 = $roundRect;
    return this.fi2(VOID, $box);
  }
  pl8(value) {
    this.tma_1.pl8(value);
  }
  am5() {
    return this.tma_1.am5();
  }
  ql8() {
    this.tma_1.ql8();
  }
}
class CardUi extends Container {
  constructor(content, w, element, isPlayable, isHoverable, rightClick, cardAction) {
    return new.target.ilo(content, w, element, isPlayable, isHoverable, rightClick, cardAction);
  }
  static ilo(content, w, element, isPlayable, isHoverable, rightClick, cardAction) {
    w = w === VOID ? content.w9z() / 40.0 : w;
    element = element === VOID ? null : element;
    isPlayable = isPlayable === VOID ? true : isPlayable;
    isHoverable = isHoverable === VOID ? isPlayable : isHoverable;
    var tmp;
    if (rightClick === VOID) {
      tmp = CardUi$_init_$slambda_g2mqa0();
    } else {
      tmp = rightClick;
    }
    rightClick = tmp;
    var $this = this.fi2();
    $this.jlh_1 = element;
    $this.klh_1 = rightClick;
    $this.llh_1 = cardAction;
    $this.nlh_1 = false;
    $this.olh_1 = Colors_getInstance().vc5_1;
    $this.uie(content);
    var tmp_0 = $this;
    var tmp2 = Size2D.y9p(content.w9z(), content.x9z());
    Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var corner = w * 2;
    var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp6 = new RGBA(Colors_getInstance().fc3_1);
    var tmp9 = 2 * w;
    // Inline function 'korlibs.korge.view.roundRect' call
    var stroke = new RGBA(Colors_getInstance().zc2_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.rka(tmp2, tmp4, tmp6, stroke, tmp9, true);
    // Inline function 'kotlin.apply' call
    tmp_0.mlh_1 = addTo(this_0, $this);
    $this.ql8();
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse($this);
    if (isHoverable) {
      // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
      var handler = CardUi$slambda($this);
      var tmp_1 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_2 = getPropertyCallableRef('over', 1, tmp_1, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
      tmp_2.v9y(CardUi$lambda($this$mouse, handler));
      // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
      var handler_0 = CardUi$slambda_0($this);
      var tmp_3 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_4 = getPropertyCallableRef('out', 1, tmp_3, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
      tmp_4.v9y(CardUi$lambda_0($this$mouse, handler_0));
    }
    if (isPlayable) {
      // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
      var handler_1 = CardUi$slambda_1($this);
      var tmp_5 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_6 = getPropertyCallableRef('click', 1, tmp_5, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
      tmp_6.v9y(CardUi$lambda_1($this$mouse, handler_1));
    }
    return $this;
  }
  static tm1(picture, w, element, isPlayable, rightClick, cardAction) {
    w = w === VOID ? picture.sc1_1 / 40.0 : w;
    element = element === VOID ? null : element;
    isPlayable = isPlayable === VOID ? true : isPlayable;
    var tmp;
    if (rightClick === VOID) {
      tmp = CardUi$_init_$slambda_g2mqa0_0();
    } else {
      tmp = rightClick;
    }
    rightClick = tmp;
    return this.ilo(Image.lk7(picture), w, element, isPlayable, VOID, rightClick, cardAction);
  }
  pl8(_set____db54di) {
    this.nlh_1 = _set____db54di;
  }
  am5() {
    return this.nlh_1;
  }
  ql8() {
    this.mlh_1.djq(new RGBA(getBorderColor(this)));
  }
}
class UrgullMoltEggsToReturnBoardData {
  constructor(question, result) {
    this.emg_1 = question;
    this.fmg_1 = result;
  }
  bmg() {
    return this.fmg_1;
  }
  t3o() {
    return UrgullMoltEggsToReturnQuestionContext_getInstance();
  }
  toString() {
    return 'UrgullMoltEggsToReturnBoardData(question=' + this.emg_1.toString() + ', result=' + toString(this.fmg_1) + ')';
  }
  hashCode() {
    var result = this.emg_1.hashCode();
    result = imul(result, 31) + hashCode(this.fmg_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrgullMoltEggsToReturnBoardData))
      return false;
    if (!this.emg_1.equals(other.emg_1))
      return false;
    if (!equals(this.fmg_1, other.fmg_1))
      return false;
    return true;
  }
}
class JustShowTheCard {}
class ShowDiscardedCard {}
class AdditionalButton {
  constructor(icon, hint, textColor, action) {
    textColor = textColor === VOID ? Colors_getInstance().zc2_1 : textColor;
    action = action === VOID ? null : action;
    this.pmg_1 = icon;
    this.qmg_1 = hint;
    this.rmg_1 = textColor;
    this.smg_1 = action;
  }
}
class ShowTheCardWithAdditionalButtons {
  constructor(additionalButtons) {
    this.omg_1 = additionalButtons;
  }
}
class ShowTheCardWithAction {
  constructor(cardAction) {
    this.img_1 = cardAction;
  }
}
class PlayTheCard {
  constructor(result, m, isDiscardable, canUseBoat, isPlayable) {
    this.jmg_1 = result;
    this.kmg_1 = m;
    this.lmg_1 = isDiscardable;
    this.mmg_1 = canUseBoat;
    this.nmg_1 = isPlayable;
  }
}
class DiscardCardsType extends Enum {}
class showHands$HandRow {
  constructor(rowPanel, cardsPanel, cardsAreaWidth) {
    this.jmh_1 = rowPanel;
    this.kmh_1 = cardsPanel;
    this.lmh_1 = cardsAreaWidth;
  }
  toString() {
    return 'HandRow(rowPanel=' + toString(this.jmh_1) + ', cardsPanel=' + toString(this.kmh_1) + ', cardsAreaWidth=' + this.lmh_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.jmh_1);
    result = imul(result, 31) + hashCode(this.kmh_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.lmh_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof showHands$HandRow))
      return false;
    if (!equals(this.jmh_1, other.jmh_1))
      return false;
    if (!equals(this.kmh_1, other.kmh_1))
      return false;
    if (!equals(this.lmh_1, other.lmh_1))
      return false;
    return true;
  }
}
class ChooseScenarioScene extends Scene {
  constructor(hotSeatSceneManager, images, logicScope, isSandboxMode) {
    super();
    this.blp_1 = hotSeatSceneManager;
    this.clp_1 = images;
    this.dlp_1 = logicScope;
    this.elp_1 = isSandboxMode;
    this.flp_1 = new GameSetupState();
    this.glp_1 = ContentVersionSelectionState.fdy(Companion_getInstance_2().w39_1);
    this.hlp_1 = get_gameConfiguration().dlc_1;
    this.jlp_1 = CompletableDeferred_0();
  }
  *ti4(_this__u8e3s4, $completion) {
    createStatusLayer(this, this.clp_1, _this__u8e3s4);
    launch(this, VOID, VOID, ChooseScenarioScene$sceneInit$slambda(this));
    if (this.elp_1) {
      var tmp = this.glp_1;
      showContentVersionSelectionDialog(_this__u8e3s4, tmp, this.hlp_1, ChooseScenarioScene$sceneInit$lambda(this, _this__u8e3s4));
    } else {
      yield* /*#__NOINLINE__*/showScenarioSelectionDialog(this, first(get_gameConfiguration().tlc_1), _this__u8e3s4, $completion);
    }
    return Unit_instance;
  }
}
class ContentReferenceDialogState {
  constructor(coroutineScope, frame, gameDialog, images, gameContentVersion, backCallback, content, onRouteChanged) {
    content = content === VOID ? new Beast(Bolgin_getInstance()) : content;
    onRouteChanged = onRouteChanged === VOID ? null : onRouteChanged;
    this.qmh_1 = coroutineScope;
    this.rmh_1 = frame;
    this.smh_1 = gameDialog;
    this.tmh_1 = images;
    this.umh_1 = backCallback;
    this.vmh_1 = content;
    this.wmh_1 = onRouteChanged;
    this.xmh_1 = null;
    this.ymh_1 = null;
    this.zmh_1 = null;
    this.ami_1 = emptyList();
    this.bmi_1 = null;
    var tmp0_safe_receiver = this.qmh_1.d1m().ae(Key_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.g1n(ContentReferenceDialogState$lambda(this));
    }
    if (!(this.wmh_1 == null)) {
      var tmp1_safe_receiver = this.qmh_1.d1m().ae(Key_instance);
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.g1n(ContentReferenceDialogState$lambda_0(this));
      }
    }
    this.cmi_1 = ContentVersionSelectionState.fdy(gameContentVersion).idy(get_gameConfiguration().dlc_1);
  }
  dmi(text) {
    reinstallContentReferenceDialog(this, text);
  }
  emi(selection) {
    this.bmi_1 = selection;
    var tmp0_safe_receiver = this.zmh_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    this.zmh_1 = null;
    var tmp1_safe_receiver = this.xmh_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.o1n();
    }
    var tmp = this;
    tmp.xmh_1 = launch(this.qmh_1, VOID, VOID, ContentReferenceDialogState$requestShowContent$slambda(this));
  }
  lmi(selection, $super) {
    selection = selection === VOID ? null : selection;
    var tmp;
    if ($super === VOID) {
      this.emi(selection);
      tmp = Unit_instance;
    } else {
      tmp = $super.emi.call(this, selection);
    }
    return tmp;
  }
}
class ResolvedContentReference {
  constructor(route, usedFallback) {
    this.rlq_1 = route;
    this.slq_1 = usedFallback;
  }
  toString() {
    return 'ResolvedContentReference(route=' + this.rlq_1.toString() + ', usedFallback=' + this.slq_1 + ')';
  }
  hashCode() {
    var result = this.rlq_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.slq_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResolvedContentReference))
      return false;
    if (!this.rlq_1.equals(other.rlq_1))
      return false;
    if (!(this.slq_1 === other.slq_1))
      return false;
    return true;
  }
}
class ContentReferenceRoute {
  constructor(content, version, chosen) {
    content = content === VOID ? new Beast(Bolgin_getInstance()) : content;
    version = version === VOID ? Companion_getInstance_2().w39_1 : version;
    chosen = chosen === VOID ? null : chosen;
    this.tlq_1 = content;
    this.ulq_1 = version;
    this.vlq_1 = chosen;
  }
  wlq() {
    var tmp0_subject = this.tlq_1;
    var tmp;
    if (tmp0_subject instanceof Beast) {
      tmp = 'beast-' + get_slug_0(this.tlq_1.hmi_1);
    } else {
      if (tmp0_subject instanceof Hunter) {
        tmp = 'hunter-' + get_slug_0(this.tlq_1.gmi_1);
      } else {
        if (tmp0_subject instanceof Cards) {
          tmp = 'cards-' + get_slug_1(this.tlq_1.imi_1);
        } else {
          if (tmp0_subject instanceof Contract) {
            tmp = 'contract-' + get_slug_2(this.tlq_1.fmi_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var tmp_0 = tmp;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_entries();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (this.ulq_1.q3d_1.w2(element)) {
        destination.d2(element);
      }
    }
    var tmp_1 = destination;
    // Inline function 'kotlin.text.ifEmpty' call
    var this_0 = joinToString(tmp_1, '.', VOID, VOID, VOID, VOID, ContentReferenceRoute$toUrlParams$lambda);
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_0) === 0) {
      tmp_2 = null;
    } else {
      tmp_2 = this_0;
    }
    var tmp$ret$3 = tmp_2;
    return new UrlContentReferenceParams(tmp_0, tmp$ret$3, this.vlq_1);
  }
  qmi(content, version, chosen) {
    return new ContentReferenceRoute(content, version, chosen);
  }
  pmi(content, version, chosen, $super) {
    content = content === VOID ? this.tlq_1 : content;
    version = version === VOID ? this.ulq_1 : version;
    chosen = chosen === VOID ? this.vlq_1 : chosen;
    return $super === VOID ? this.qmi(content, version, chosen) : $super.qmi.call(this, content, version, chosen);
  }
  toString() {
    return 'ContentReferenceRoute(content=' + toString(this.tlq_1) + ', version=' + this.ulq_1.toString() + ', chosen=' + this.vlq_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.tlq_1);
    result = imul(result, 31) + this.ulq_1.hashCode() | 0;
    result = imul(result, 31) + (this.vlq_1 == null ? 0 : getStringHashCode(this.vlq_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ContentReferenceRoute))
      return false;
    if (!equals(this.tlq_1, other.tlq_1))
      return false;
    if (!this.ulq_1.equals(other.ulq_1))
      return false;
    if (!(this.vlq_1 == other.vlq_1))
      return false;
    return true;
  }
}
class Beast {
  constructor(beast) {
    this.hmi_1 = beast;
  }
  toString() {
    return 'Beast(beast=' + toString(this.hmi_1) + ')';
  }
  hashCode() {
    return hashCode(this.hmi_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Beast))
      return false;
    if (!equals(this.hmi_1, other.hmi_1))
      return false;
    return true;
  }
}
class Hunter {
  constructor(hunter) {
    this.gmi_1 = hunter;
  }
  toString() {
    return 'Hunter(hunter=' + toString(this.gmi_1) + ')';
  }
  hashCode() {
    return hashCode(this.gmi_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Hunter))
      return false;
    if (!equals(this.gmi_1, other.gmi_1))
      return false;
    return true;
  }
}
class Cards {
  constructor(kind) {
    this.imi_1 = kind;
  }
  toString() {
    return 'Cards(kind=' + this.imi_1.toString() + ')';
  }
  hashCode() {
    return this.imi_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Cards))
      return false;
    if (!this.imi_1.equals(other.imi_1))
      return false;
    return true;
  }
}
class Contract {
  constructor(gameRules) {
    this.fmi_1 = gameRules;
  }
  toString() {
    return 'Contract(gameRules=' + toString(this.fmi_1) + ')';
  }
  hashCode() {
    return hashCode(this.fmi_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contract))
      return false;
    if (!equals(this.fmi_1, other.fmi_1))
      return false;
    return true;
  }
}
class ContentReferenceDialogCardsKind extends Enum {}
class AnimationInfo {
  constructor(viewToRemove, animate) {
    this.umi_1 = viewToRemove;
    this.vmi_1 = animate;
  }
  toString() {
    return 'AnimationInfo(viewToRemove=' + toString_0(this.umi_1) + ', animate=' + toString(this.vmi_1) + ')';
  }
  hashCode() {
    var result = this.umi_1 == null ? 0 : hashCode(this.umi_1);
    result = imul(result, 31) + hashCode(this.vmi_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AnimationInfo))
      return false;
    if (!equals(this.umi_1, other.umi_1))
      return false;
    if (!equals(this.vmi_1, other.vmi_1))
      return false;
    return true;
  }
}
class GamePresencePanel extends Container {
  constructor() {
    return new.target.iml();
  }
  static iml() {
    var $this = this.fi2();
    $this.eml_1 = get_gameLayout().kl6_1 * 0.23;
    $this.fml_1 = addTo(VerticalScrollViewport.amg(), $this);
    $this.gml_1 = null;
    $this.jml('Loading connected clients\u2026');
    return $this;
  }
  jml(message) {
    this.gml_1 = null;
    // Inline function 'kotlin.apply' call
    var this_0 = new ControlPanelY();
    addTo_0(PlainText(message, get_gameLayout().sl5_1), this_0);
    render(this, this_0);
  }
  kml(presence) {
    if (presence.equals(this.gml_1))
      return Unit_instance;
    this.gml_1 = presence;
    var rows = new ControlPanelY();
    var _iterator__ex2g4s = listOf([to(new GameTeam(get_beastsGameTeam()), 'Beasts\u2019 players'), to(new GameTeam(get_huntersGameTeam()), 'Hunters\u2019 players'), to(new GameTeam(get_observerGameTeamMarker()), 'Observers'), to(new GameTeam(get_fullObserverGameTeamMarker()), 'Full observers')]).p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      var team = _destruct__k2r9zo.jm().r3p_1;
      var title = _destruct__k2r9zo.km();
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = presence.i6p_1.w4(new GameTeam(team));
      var clients = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      if (clients.n1() && (team === get_observerGameTeamMarker() || team === get_fullObserverGameTeamMarker()))
        continue $l$loop;
      addTo_0(PlainText(title, get_gameLayout().sl5_1), rows);
      if (clients.n1()) {
        // Inline function 'kotlin.apply' call
        var this_0 = PlainText('  None', get_gameLayout().sl5_1);
        this_0.sig(0.45);
        addTo_0(this_0, rows);
      }
      var _iterator__ex2g4s_0 = clients.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var client = _iterator__ex2g4s_0.r1();
        // Inline function 'kotlin.apply' call
        var this_1 = PlainText('  ' + client.n6r_1, get_gameLayout().sl5_1);
        if (!client.o6r_1) {
          this_1.sig(0.4);
        }
        if (this_1.pig() > this.eml_1) {
          toWidth(this_1, this.eml_1);
        }
        addTo_0(this_1, rows);
      }
      rows.dlr_1 = rows.dlr_1 + get_gameLayout().yl5_1;
    }
    var tmp0_safe_receiver = presence.j6p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addTo_0(PlainText('Unbound observers: ' + tmp0_safe_receiver, get_gameLayout().sl5_1), rows);
    }
    render(this, rows);
  }
}
class SandboxGamePlaying {
  constructor(gameCode) {
    this.lml_1 = gameCode;
  }
}
class OtherControlAgentMode {}
class TurnVariantRequest {
  constructor(characterObject, variants, result) {
    this.bmh_1 = characterObject;
    this.cmh_1 = variants;
    this.dmh_1 = result;
  }
  toString() {
    return 'TurnVariantRequest(characterObject=' + this.bmh_1.toString() + ', variants=' + toString(this.cmh_1) + ', result=' + toString(this.dmh_1) + ')';
  }
  hashCode() {
    var result = this.bmh_1.hashCode();
    result = imul(result, 31) + hashCode(this.cmh_1) | 0;
    result = imul(result, 31) + hashCode(this.dmh_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TurnVariantRequest))
      return false;
    if (!this.bmh_1.equals(other.bmh_1))
      return false;
    if (!equals(this.cmh_1, other.cmh_1))
      return false;
    if (!equals(this.dmh_1, other.dmh_1))
      return false;
    return true;
  }
}
class UpgradeRequest {
  constructor(characterObjects, selectableUpgrades, result, mayUpgradeNothing, questionContext) {
    this.gmd_1 = characterObjects;
    this.hmd_1 = selectableUpgrades;
    this.imd_1 = result;
    this.jmd_1 = mayUpgradeNothing;
    this.kmd_1 = questionContext;
  }
  toString() {
    return 'UpgradeRequest(characterObjects=' + toString(this.gmd_1) + ', selectableUpgrades=' + toString(this.hmd_1) + ', result=' + toString(this.imd_1) + ', mayUpgradeNothing=' + this.jmd_1 + ', questionContext=' + toString_0(this.kmd_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.gmd_1);
    result = imul(result, 31) + hashCode(this.hmd_1) | 0;
    result = imul(result, 31) + hashCode(this.imd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jmd_1) | 0;
    result = imul(result, 31) + (this.kmd_1 == null ? 0 : hashCode(this.kmd_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UpgradeRequest))
      return false;
    if (!equals(this.gmd_1, other.gmd_1))
      return false;
    if (!equals(this.hmd_1, other.hmd_1))
      return false;
    if (!equals(this.imd_1, other.imd_1))
      return false;
    if (!(this.jmd_1 === other.jmd_1))
      return false;
    if (!equals(this.kmd_1, other.kmd_1))
      return false;
    return true;
  }
}
class KorgeControlAgent$choiceFlow$2$1 {
  constructor(this$0) {
    this.omo_1 = this$0;
    this.nmo_1 = 0;
  }
  *ddx($completion) {
    this.omo_1.ol3_1 = null;
    yield* /*#__NOINLINE__*/updateAdditionalPanel(this.omo_1, $completion);
    return Unit_instance;
  }
  edx(restore) {
    this.omo_1.il4_1 = restore;
  }
  *adw($context_GameStateRuntime_604ce3, question, mayNothing, scope, $completion) {
    var _destruct__k2r9zo = yield* this.omo_1.pmo($context_GameStateRuntime_604ce3, question, mayNothing, scope, $completion);
    var answer = _destruct__k2r9zo.jm();
    var needDialog = _destruct__k2r9zo.km();
    return new InstalledChoice(answer, needDialog);
  }
  *bdw(choice, scope, $completion) {
    if (choice.odv_1)
      yield* /*#__NOINLINE__*/addRestoreDialogButtonIfNeeded(this.omo_1, scope, $completion);
    return Unit_instance;
  }
  cdw() {
    this.omo_1.ol3_1 = null;
  }
  *idx(animations, $completion) {
    yield* animateCursorBeforeDialog(this.omo_1, animations, $completion);
    this.nmo_1 = this.omo_1.gl2_1.hl7_1.xi1_1.s2();
    return Unit_instance;
  }
  *hdx(animation, $completion) {
    yield* animatePreAnswer(this.omo_1, animation, $completion);
    return Unit_instance;
  }
  *fdw(answer, $completion) {
    yield* pingHighlightAnswerElement(this.omo_1, answer, $completion);
    return Unit_instance;
  }
  *sdw(answer, animations, $completion) {
    yield* animateAutoCursor(this.omo_1, answer, animations, $completion);
    return Unit_instance;
  }
  *tdw($completion) {
    while (this.omo_1.gl2_1.hl7_1.xi1_1.s2() > this.nmo_1) {
      this.omo_1.gl2_1.hl7_1.rie(this.nmo_1);
    }
    return Unit_instance;
  }
  *hdw($completion) {
    yield* /*#__NOINLINE__*/showWrongAnswerMessage(this.omo_1, $completion);
    return Unit_instance;
  }
}
class KorgeControlAgent$chooseAncientPowerNumber$clickable$1 extends RoundRectWithHover {
  constructor($r) {
    return new.target.bmo($r);
  }
  static bmo($r) {
    var $this = this.fmd($r);
    $this.zmn_1 = 0.0;
    $this.amo_1 = 0.4;
    return $this;
  }
  ym4() {
    return this.zmn_1;
  }
  zm4() {
    return this.amo_1;
  }
}
class KorgeControlAgent {
  constructor(gameUiContext, gameTeamProvider, beastUiMap, sidePanelLeftTopCorner, menuManagement, panelBackground, sceneCoroutineScope, diagnostics) {
    this.dl2_1 = gameUiContext;
    this.el2_1 = diagnostics;
    this.fl2_1 = gameTeamProvider;
    this.gl2_1 = beastUiMap;
    this.hl2_1 = sidePanelLeftTopCorner;
    this.il2_1 = menuManagement;
    this.jl2_1 = sceneCoroutineScope;
    this.kl2_1 = Container.fi2();
    this.ll2_1 = Container.fi2();
    this.ml2_1 = Container.fi2();
    this.nl2_1 = Container.fi2();
    this.ol2_1 = Container.fi2();
    this.pl2_1 = null;
    this.ql2_1 = null;
    var tmp = this;
    var tmp0 = this.il2_1;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = MenuManagement$_get_answerIndexBeforeAnotherAnswerChosen_$ref_e9q8pw(tmp0);
    tmp.rl2_1 = getPropertyCallableRef('answerIndexBeforeAnotherAnswerChosen', 0, tmp_0, tmp_1, MenuManagement$_set_answerIndexBeforeAnotherAnswerChosen_$ref_3cws4o(tmp0));
    this.sl2_1 = false;
    this.tl2_1 = false;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.ul2_1 = ArrayList.p2();
    this.vl2_1 = new UiDynamicLayer(this.kl2_1);
    this.wl2_1 = false;
    this.xl2_1 = null;
    this.yl2_1 = null;
    this.zl2_1 = this.hl2_1.r9g_1 + get_gameLayout().zl5_1;
    this.al3_1 = this.hl2_1.s9g_1 + get_gameLayout().zl5_1;
    this.bl3_1 = this.zl2_1;
    this.cl3_1 = this.al3_1;
    this.dl3_1 = get_gameLayout().zl5_1;
    this.el3_1 = get_gameLayout().zl5_1;
    this.fl3_1 = this.dl3_1;
    this.gl3_1 = this.el3_1;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.jl3_1 = LinkedHashMap.m7();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_4.kl3_1 = LinkedHashMap.m7();
    var tmp_5 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_5.ll3_1 = LinkedHashMap.m7();
    this.ml3_1 = Channel();
    this.nl3_1 = null;
    this.ol3_1 = null;
    this.pl3_1 = null;
    this.ql3_1 = null;
    this.rl3_1 = null;
    this.sl3_1 = null;
    this.vl3_1 = _GameTeam___init__impl__xtwsj2(0);
    this.wl3_1 = emptyMap();
    this.xl3_1 = emptyMap();
    this.yl3_1 = false;
    var tmp_6 = this;
    tmp_6.zl3_1 = lazy(KorgeControlAgent$specialSetupFlow$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.al4_1 = lazy(KorgeControlAgent$sandboxSetupFlow$delegate$lambda(this));
    // Inline function 'korlibs.korge.view.image' call
    var this_0 = this.pln();
    var anchor = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(panelBackground, anchor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    this_2.fcw(this.hl2_1);
    toHeight(this_2, get_gameLayout().fl6_1);
    this.pln().uie(this.kl2_1);
    this.pln().uie(this.ll2_1);
    this.pln().uie(this.ml2_1);
    this.pln().uie(this.nl2_1);
    this.pln().uie(this.ol2_1);
    this.bl4_1 = true;
    this.cl4_1 = null;
    this.dl4_1 = null;
    var tmp_8 = this;
    tmp_8.el4_1 = lazy(KorgeControlAgent$replayRevertFlow$delegate$lambda(this));
    this.fl4_1 = '';
    var tmp_9 = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_9.gl4_1 = emptyList();
    var tmp_10 = this;
    tmp_10.hl4_1 = lazy(KorgeControlAgent$choiceFlow$delegate$lambda(this));
    var tmp_11 = this;
    tmp_11.il4_1 = KorgeControlAgent$restoreDialogCallback$slambda();
    this.jl4_1 = get_gameDialogClose();
  }
  me0() {
    return this.fl2_1.me0() && (!(this.k3q() === get_fullObserverGameTeamMarker()) || (this.y6h() && this.t6h().p38_1 == null));
  }
  be1(team) {
    return this.me0() || this.k3q() === team;
  }
  qln() {
    return this.nl2_1;
  }
  qdw(_set____db54di) {
    this.ql2_1 = _set____db54di;
  }
  o6t() {
    return this.ql2_1;
  }
  ge2() {
    return _get_choiceFlow__u1vu9o(this).udv_1;
  }
  nml() {
    return this.sl2_1 || this.udw();
  }
  emh() {
    return this.nml() && get_gameConfiguration().eld_1.equals(AnotherAnswerReaction_ForbidOtherVariants_getInstance());
  }
  gdw() {
    return this.tl2_1;
  }
  qmo() {
    return _get_replayRevertFlow__95swe(this).je1_1;
  }
  blt(value) {
    _get_replayRevertFlow__95swe(this).ke1_1 = value;
  }
  pml() {
    return _get_replayRevertFlow__95swe(this).ke1_1;
  }
  mmh(value) {
    _get_choiceFlow__u1vu9o(this).xdv_1 = value;
  }
  rmo() {
    return _get_choiceFlow__u1vu9o(this).xdv_1;
  }
  v6h(_set____db54di) {
    this.hl3_1 = _set____db54di;
  }
  w6h() {
    var tmp = this.hl3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('oldGameState');
    }
  }
  x6h(_set____db54di) {
    this.il3_1 = _set____db54di;
  }
  t6h() {
    var tmp = this.il3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('gameState');
    }
  }
  rdw() {
    return this.ml3_1;
  }
  fmh() {
    return _get_choiceFlow__u1vu9o(this).vdv_1;
  }
  kl4() {
    var tmp = this.tl3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('autoCursorImage');
    }
  }
  ol8() {
    var tmp = this.ul3_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('clickSound');
    }
  }
  ql6() {
    return this.k3q() === get_beastsGameTeam();
  }
  il5() {
    return !(this.tl3_1 == null);
  }
  wdw() {
    _get_choiceFlow__u1vu9o(this).wdw();
  }
  jmo() {
    var tmp0 = this.zl3_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('specialSetupFlow', 1, tmp, KorgeControlAgent$_get_specialSetupFlow_$ref_2s83y0(), null);
    return tmp0.k3();
  }
  sm1() {
    return this.jmo().qe3_1;
  }
  se3() {
    return this.jmo().se3();
  }
  bm5() {
    return this.jmo().e1m();
  }
  kmo() {
    var tmp0 = this.al4_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sandboxSetupFlow', 1, tmp, KorgeControlAgent$_get_sandboxSetupFlow_$ref_do5rwa(), null);
    return tmp0.k3();
  }
  *w6q(masterFixingEventsConsumer, $completion) {
    return yield* this.jmo().w6q(masterFixingEventsConsumer, $completion);
  }
  *plk($completion) {
    yield* this.ml3_1.j22(Unit_instance, $completion);
    return Unit_instance;
  }
  *s6q(element, $completion) {
    if (element instanceof PingBoardPositionElement) {
      this.gl2_1.oln(element.z6q_1);
    } else {
      if (element instanceof PingLocationTypeElement) {
        var tmp = Image.lk7(yield* (yield* this.pl6().hle(element.e6r_1, $completion)).m1q($completion));
        var locationTypeView = toHeight(RoundButton.fmo(tmp, VOID, VOID, VOID, KorgeControlAgent$pingElement$slambda()), get_gameLayout().ll6_1);
        yield* /*#__NOINLINE__*/showPingElement(this, locationTypeView, $completion);
      } else {
        if (element instanceof PingPlayableCardElement) {
          var cardView = toWidth(yield* createCard(this, yield* (yield* this.pl6().mle(element.j6r_1, $completion)).m1q($completion), element.j6r_1, JustShowTheCard_instance, $completion), get_sidePanelCardWidth());
          yield* /*#__NOINLINE__*/showPingElement(this, cardView, $completion);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return Unit_instance;
  }
  *smo(useRightSided, showCancelIcon, $completion) {
    // Inline function 'kotlin.with' call
    var $this$with = this.t6h();
    return yield* showContractInfoImpl($this$with, this, useRightSided, showCancelIcon, $completion);
  }
  dll(useRightSided, showCancelIcon, $completion, $super) {
    useRightSided = useRightSided === VOID ? false : useRightSided;
    showCancelIcon = showCancelIcon === VOID ? true : showCancelIcon;
    return $super === VOID ? this.smo(useRightSided, showCancelIcon, $completion) : $super.smo.call(this, useRightSided, showCancelIcon, $completion);
  }
  y6h() {
    return !(this.il3_1 == null);
  }
  emo() {
    var tmp0_safe_receiver = this.nl3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    this.nl3_1 = null;
    this.yl3_1 = false;
    this.pl3_1 = null;
  }
  le1() {
    return this.lmo();
  }
  lmo() {
    this.emo();
    var tmp = this;
    tmp.il4_1 = KorgeControlAgent$hideCurrentQuestionGameDialog$slambda();
    this.mml();
    this.tmo();
  }
  mml() {
    var _iterator__ex2g4s = this.ul2_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var view = _iterator__ex2g4s.r1();
      var tmp;
      if (view instanceof ActionButton) {
        tmp = view.bhq_1 === get_gameI18n().w6y_1;
      } else {
        tmp = false;
      }
      if (tmp) {
        view.uih();
      }
    }
    removeAll(this.ul2_1, KorgeControlAgent$clearRestoreDialogButton$lambda);
  }
  tmo() {
    this.xl2_1 = null;
    this.yl2_1 = null;
    this.wl3_1 = emptyMap();
    this.xl3_1 = emptyMap();
  }
  mmo() {
    var _iterator__ex2g4s = this.ul2_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var view = _iterator__ex2g4s.r1();
      view.uih();
    }
    this.ul2_1.a5();
    hideStatusBarHoverPopup(this);
  }
  *r6t(notification, $completion) {
    var event = notification.x3p_1;
    if (event instanceof GameWarningEvent) {
      yield* get_gameConfiguration().slc_1.hdz(this, event, $completion);
      yield* this.z6h(notification, $completion);
      yield* showGameWarningDialog(this, event, $completion);
      yield* get_gameConfiguration().slc_1.idz(this, event, $completion);
      return Unit_instance;
    }
    var keepDraftDialog = yield* this.umo(event, $completion);
    _set_eventWasApplied__3k751l(this, false);
    yield* /*#__NOINLINE__*/updateReplayControlElement(this, $completion);
    if (!(event instanceof GameQuestionIsComingEvent)) {
      clearAnotherTeamNotification(this);
    }
    yield* get_gameConfiguration().slc_1.hdz(this, event, $completion);
    if (event instanceof ReplayIsFinishedEvent) {
      var panel = new ControlPanelY();
      addTo_0(PlainText('The replay is finished', get_gameLayout().vl5_1), panel);
      var gameDialog = GameDialog.xlq(this.pln(), panel.xlb_1, VOID, get_gameDialogClose());
      gameDialog.ylq();
    }
    _get_choiceFlow__u1vu9o(this).adx(event);
    var stateChanges = yield* this.z6h(notification, $completion);
    _set_eventWasApplied__3k751l(this, true);
    if (event instanceof DraftStateEvent) {
      var draft = this.t6h().p38_1;
      var questionVariants = this.ol3_1;
      if (!(draft == null) && !(questionVariants == null) && !(_get_currentQuestionUiJob__7ts88v(this) == null)) {
        // Inline function 'kotlin.with' call
        var $this$with = this.t6h();
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = draft.r4m_1;
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList.p2();
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (get_gameTeam($this$with, $this$with.i38_1.u2(element)) === this.k3q()) {
            destination.d2(element);
          }
        }
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_0 = ArrayList.p2();
        var _iterator__ex2g4s_0 = destination.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          var list = draft.s4m_1 ? draft.p4m_1.u2(element_0) : draft.o4m_1.u2(element_0);
          addAll(destination_0, list);
        }
        var availableCards = toSet(destination_0);
        if (!equals(availableCards, questionVariants)) {
          cancelCurrentQuestionUi(this);
        }
      }
      if (_get_currentQuestionUiJob__7ts88v(this) == null) {
        yield* /*#__NOINLINE__*/showDraftWaitingDialog(this, $completion);
      } else if (!(draft == null)) {
        var message = this.pl3_1;
        var tmp0_safe_receiver = this.nl3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_0;
          if (tmp0_safe_receiver.kmi()) {
            tmp_0 = tmp0_safe_receiver;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        }
        var dialog = tmp;
        if (!(message == null) && !(dialog == null)) {
          dialog.vmo(dialog.s2f(), draftDialogMessage(this, draft, message));
        }
      }
      yield* get_gameConfiguration().slc_1.idz(this, event, $completion);
      return Unit_instance;
    }
    updateGameAnimationParameters(this, get_currentControllingActor(this.t6h().c38_1));
    var tmp_1;
    var tmp_2;
    if (!(event instanceof KnownCardsInfoChangeEvent)) {
      tmp_2 = !(event instanceof GameScopesChangeEvent);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = !(event instanceof GameQuestionIsComingEvent);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      cancelCurrentQuestionUi(this);
      this.lmo();
    }
    this.mmo();
    yield* /*#__NOINLINE__*/updateBeastsMovementCards(this, $completion);
    yield* /*#__NOINLINE__*/updateStatusBar(this, $completion);
    yield* /*#__NOINLINE__*/updateMainPanel(this, $completion);
    yield* /*#__NOINLINE__*/updateAdditionalPanel(this, $completion);
    yield* this.gl2_1.cln(this, $completion);
    if (event instanceof StartPhaseEvent) {
      yield* announcePhase(this, event.i5a_1, $completion);
    }
    yield* animateChangesBeforeWholeUpdate(this, stateChanges, notification, $completion);
    yield* this.vl2_1.dln($completion);
    yield* this.gl2_1.dln($completion);
    yield* animateChangesAfterWholeUpdate(this, stateChanges, $completion);
    // Inline function 'kotlin.with' call
    var $this$with_0 = this.t6h();
    var charactersInOrder = $this$with_0.i38_1;
    var _iterator__ex2g4s_1 = charactersInOrder.p1();
    $l$loop: while (_iterator__ex2g4s_1.q1()) {
      var characterObject = _iterator__ex2g4s_1.r1();
      var info = ensureNotNull(this.jl3_1.w4(get_objectType($this$with_0, characterObject)));
      var visualInfo = info.jm();
      var container = info.km();
      var newInfo = get_visualInfo($this$with_0, characterObject);
      if (visualInfo.equals(newInfo))
        continue $l$loop;
      info.zmg_1 = newInfo;
      container.tie();
      yield* addCharacterInfo($this$with_0, this.pl6(), info, $completion);
    }
    this.ll3_1.a5();
    if (event instanceof EndOfGameEvent) {
      var winnerTeam = event.b51_1;
      if (get_gameConfiguration().jlc_1) {
        yield* animateOfflineReplayEndOfGame(this, winnerTeam, $completion);
      } else {
        yield* showEndOfGameDialog(this, winnerTeam, $completion);
      }
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!_get_postAnswerAnimations__o7z6hu(this).n1()) {
      if (get_gameConfiguration().nlc_1) {
        yield* animatePostAnswerAutoCursor(this, _get_postAnswerAnimations__o7z6hu(this), $completion);
      } else {
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp0_0 = _get_postAnswerAnimations__o7z6hu(this);
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination_1 = ArrayList.p2();
        var _iterator__ex2g4s_2 = tmp0_0.p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_1 = _iterator__ex2g4s_2.r1();
          if (element_1 instanceof MapUiScalingAndPosition) {
            destination_1.d2(element_1);
          }
        }
        yield* animatePostAnswerAutoCursor(this, destination_1, $completion);
      }
      _set_postAnswerAnimations__a9wihi(this, emptyList());
    }
    if (event instanceof ReplayNotificationEvent) {
      var info_0 = event.x57_1;
      var tmp_3;
      if (info_0 instanceof ReplayNotificationPlainText) {
        tmp_3 = split_0(trimIndent(info_0.d5c_1), ['\n']);
      } else {
        noWhenBranchMatchedException();
      }
      var lines = tmp_3;
      try {
        yield* showInformationDialog(this, true, null, lines, VOID, VOID, $completion);
      }finally {
        closeLastInfoDialog();
      }
    }
    var tmp_4;
    if (event instanceof InitGameStateEvent) {
      tmp_4 = !(this.t6h().p38_1 == null);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      yield* /*#__NOINLINE__*/showDraftWaitingDialog(this, $completion);
    } else {
      if (keepDraftDialog) {
        yield* /*#__NOINLINE__*/addRestoreDialogButtonIfNeeded(this, VOID, $completion);
      } else {
        if (this.bl4_1 && !get_isObserver(this.k3q()) && this.cl4_1 == null) {
          // Inline function 'kotlin.with' call
          var $this$with_1 = this.t6h();
          var tmp_5 = get_currentControllingTeam($this$with_1.c38_1);
          var tmp_6 = tmp_5 == null ? null : new GameTeam(tmp_5);
          var currentControllingTeam = tmp_6 == null ? null : tmp_6.r3p_1;
          var tmp_7;
          var tmp_8;
          if (event instanceof InitGameStateEvent) {
            var tmp_9 = currentControllingTeam;
            // Inline function 'kotlin.let' call
            var tmp_10 = tmp_9 == null ? null : new GameTeam(tmp_9);
            var it = tmp_10 == null ? null : tmp_10.r3p_1;
            var tmp_11;
            var tmp_12 = it;
            if (!((tmp_12 == null ? null : new GameTeam(tmp_12)) == null)) {
              var tmp_13 = it;
              tmp_11 = !equals(tmp_13 == null ? null : new GameTeam(tmp_13), new GameTeam(this.k3q()));
            } else {
              tmp_11 = false;
            }
            tmp_8 = tmp_11;
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            tmp_7 = true;
          } else {
            var tmp_14;
            if (event instanceof GameQuestionIsComingEvent) {
              tmp_14 = !(event.d55_1.k3q() === this.k3q());
            } else {
              tmp_14 = false;
            }
            tmp_7 = tmp_14;
          }
          if (tmp_7) {
            var tmp_15 = this;
            tmp_15.cl4_1 = launch(this.jl2_1, VOID, VOID, KorgeControlAgent$notifyAboutGameEvent$slambda(this));
          }
        }
      }
    }
    yield* get_gameConfiguration().slc_1.idz(this, event, $completion);
    return Unit_instance;
  }
  *umo(event, $completion) {
    if (event instanceof InitGameStateEvent) {
      this.dl4_1 = null;
      cancelCurrentQuestionUi(this);
      this.lmo();
      clearAnotherTeamNotification(this);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = this.kl3_1.y4().p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        yield* cancelAndJoin(element, $completion);
      }
      this.kl3_1.a5();
      var tmp0_safe_receiver = this.rl3_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        yield* cancelAndJoin(tmp0_safe_receiver, $completion);
      this.rl3_1 = null;
      var tmp1_safe_receiver = this.sl3_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.uih();
      }
      this.sl3_1 = null;
      this.mmo();
      this.rln(emptyMap());
      _get_choiceFlow__u1vu9o(this).zdw();
      this.ll3_1.a5();
      this.jl3_1.a5();
      this.vl2_1.a5();
      yield* this.gl2_1.eln($completion);
      return false;
    }
    var tmp;
    if (this.yl3_1 && !(this.t6h().p38_1 == null)) {
      var tmp_0;
      if (event instanceof DraftStateEvent) {
        tmp_0 = !(event.t52_1 == null);
      } else {
        var tmp_1;
        if (event instanceof GameScopesChangeEvent) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (event instanceof KnownCardsInfoChangeEvent) {
            tmp_2 = true;
          } else {
            tmp_2 = event instanceof GameQuestionIsComingEvent;
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    var keepDraftDialog = tmp;
    if (this.yl3_1 && !keepDraftDialog) {
      this.emo();
    }
    var tmp_3;
    if (!(event instanceof DraftStateEvent)) {
      tmp_3 = !keepDraftDialog;
    } else {
      tmp_3 = false;
    }
    if (tmp_3)
      yield* /*#__NOINLINE__*/awaitUiStateWithoutDialogs(this, $completion);
    return keepDraftDialog;
  }
  *u6q(event, revertingChanges, checkInfo, $completion) {
    this.dl4_1 = null;
    _set_postAnswerAnimations__a9wihi(this, emptyList());
    cancelCurrentQuestionUi(this);
    this.lmo();
    clearAnotherTeamNotification(this);
    _set_shouldPlayNextQuestionStrictlyAfterRevert__vklew5(this, _get_shouldPlayNextQuestionStrictlyAfterRevert__9tipeh(this) || !(this.rmo() == null));
    yield* this.k6i(event, revertingChanges, checkInfo, $completion);
    yield* this.wmo($completion);
    if (!(this.t6h().p38_1 == null))
      yield* /*#__NOINLINE__*/showDraftWaitingDialog(this, $completion);
    updateStrictlyPlayingCardAfterRevert(this);
    return Unit_instance;
  }
  *pe1(revertMode, $completion) {
    return yield* _get_replayRevertFlow__95swe(this).pe1(revertMode, $completion);
  }
  *oe1($completion) {
    return yield* this.wmo($completion);
  }
  *wmo($completion) {
    this.mmo();
    yield* /*#__NOINLINE__*/updateBeastsMovementCards(this, $completion);
    yield* /*#__NOINLINE__*/updateStatusBar(this, $completion);
    yield* /*#__NOINLINE__*/updateMainPanel(this, $completion);
    yield* /*#__NOINLINE__*/updateAdditionalPanel(this, $completion);
    yield* this.gl2_1.cln(this, $completion);
    yield* this.vl2_1.dln($completion);
    yield* this.gl2_1.dln($completion);
    return Unit_instance;
  }
  smi() {
    return this.gl2_1.hl7_1.khy().a9l_1;
  }
  tmi(character) {
    // Inline function 'kotlin.with' call
    var tmp;
    if (this.t6h().i38_1.s2() === 5) {
      tmp = isInterface(character, BeastCharacter);
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp0_safe_receiver = this.vl2_1.hm5(KorgeControlAgent$pointAndSizeAtCharacter$lambda);
      var centerAndSize = tmp0_safe_receiver == null ? null : get_centerAndSize(tmp0_safe_receiver);
      if (!(centerAndSize == null))
        return centerAndSize;
    }
    var characterContainer = ensureNotNull(this.jl3_1.w4(character)).amh_1;
    var tmp_0 = characterContainer.oih(toPoint(characterContainer.s2().l9s(2)));
    // Inline function 'kotlin.let' call
    var it = characterContainer.khy().a9l_1 * characterContainer.x9z() * get_gameLayout().al6_1;
    var tmp$ret$2 = Size2D.y9p(it, it);
    return new CenterAndSize(tmp_0, tmp$ret$2);
  }
  *he2($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled, $completion) {
    var tmp;
    if (this.yl3_1) {
      tmp = !(gameQuestion instanceof ChooseCardOnDraftQuestion);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.emo();
    }
    _get_choiceFlow__u1vu9o(this).xdw();
    clearAnotherTeamNotification(this);
    var tmp_0 = get_gameConfiguration().slc_1;
    var tmp_1 = KorgeControlAgent$choose$slambda(this, $context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled);
    var tmp_2 = KorgeControlAgent$choose$slambda_0(this);
    return yield* answerFlow(this, tmp_0, gameQuestion, mayNothing, tmp_1, tmp_2, KorgeControlAgent$choose$slambda_1(gameQuestion, this), $completion);
  }
  udw() {
    return _get_choiceFlow__u1vu9o(this).udw();
  }
  *pmo($context_GameState_t6qee5, gameQuestion, mayNothing, questionCoroutineScope, $completion) {
    var tmp;
    if (gameQuestion instanceof ContinueAfterRecoveryQuestion) {
      var result = CompletableDeferred_0();
      var panel = new ControlPanelY();
      addTo_0(ActionButton.vlb('Continue after repair', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$installChooseVariants$slambda(result)), panel);
      yield* this.dmo(panel.xlb_1, dialogCornerText(get_gameI18n().j70_1), VOID, $completion);
      tmp = to(result, true);
    } else {
      if (gameQuestion instanceof PhaseRecoveryQuestion) {
        var result_0 = CompletableDeferred_0();
        yield* /*#__NOINLINE__*/playDefaultVariantImpl(this, gameQuestion.s4a_1, mayNothing, result_0, dialogCornerText(get_gameI18n().i70_1), $completion);
        tmp = to(result_0, true);
      } else {
        if (gameQuestion instanceof UpgradeQuestion) {
          var result_1 = CompletableDeferred_0();
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = get_charactersInOrder($context_GameState_t6qee5);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList.p2();
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!intersect(gameQuestion.s4b_1, get_objectType($context_GameState_t6qee5, element).t35()).n1()) {
              destination.d2(element);
            }
          }
          var possibleUpgrading = destination;
          var tmp_0;
          if (possibleUpgrading.n1()) {
            // Inline function 'kotlin.require' call
            if (!mayNothing) {
              var message = 'No possible upgradable: ' + gameQuestion.s4b_1.toString();
              throw IllegalArgumentException.h2(toString(message));
            }
            result_1.l1t(null);
            tmp_0 = to(result_1, false);
          } else {
            yield* showUpgradeCharacterBoard(this, possibleUpgrading, gameQuestion.s4b_1, result_1, mayNothing, gameQuestion.t4b_1, this.jl4_1, $completion);
            tmp_0 = to(result_1, true);
          }
          tmp = tmp_0;
        } else {
          if (gameQuestion instanceof ObjectsGameQuestion) {
            var result_2 = CompletableDeferred_0();
            var needDialog = yield* /*#__NOINLINE__*/chooseObjectVariant(this, gameQuestion.m4a_1, mayNothing, result_2, gameQuestion.n4a_1, questionCoroutineScope, $completion);
            tmp = to(result_2, needDialog);
          } else {
            if (gameQuestion instanceof DestinationQuestion) {
              var result_3 = CompletableDeferred_0();
              var positionDeferred = CompletableDeferred_0();
              yield* /*#__NOINLINE__*/chooseMovementVariant(this, gameQuestion, mayNothing, positionDeferred, questionCoroutineScope, $completion);
              launch(questionCoroutineScope, VOID, VOID, KorgeControlAgent$installChooseVariants$slambda_0(positionDeferred, gameQuestion, result_3, this, mayNothing));
              tmp = to(result_3, false);
            } else {
              if (isInterface(gameQuestion, LocationQuestionBase)) {
                var result_4 = CompletableDeferred_0();
                yield* /*#__NOINLINE__*/chooseLocationVariant(this, gameQuestion, mayNothing, result_4, questionCoroutineScope, $completion);
                tmp = to(result_4, false);
              } else {
                if (gameQuestion instanceof ChooseCardsQuestion) {
                  var result_5 = CompletableDeferred_0();
                  yield* /*#__NOINLINE__*/generalCardsDialog(this, gameQuestion.l48_1, result_5, mayNothing, gameQuestion.m48_1, $completion);
                  tmp = to(result_5, true);
                } else {
                  if (gameQuestion instanceof ChooseCardOnDraftQuestion) {
                    var result_6 = CompletableDeferred_0();
                    yield* /*#__NOINLINE__*/draftCardsDialog(this, gameQuestion, result_6, $completion);
                    tmp = to(result_6, true);
                  } else {
                    if (gameQuestion instanceof PlayCardInTurnQuestion) {
                      var result_7 = CompletableDeferred_0();
                      yield* /*#__NOINLINE__*/choosePlayOrDiscardVariant(this, gameQuestion.x4a_1, gameQuestion.y4a_1, result_7, $completion);
                      tmp = to(result_7, true);
                    } else {
                      if (gameQuestion instanceof BeastMovementCardQuestion) {
                        var result_8 = CompletableDeferred_0();
                        yield* /*#__NOINLINE__*/playDefaultVariant(this, gameQuestion.t47_1, mayNothing, result_8, gameQuestion.u47_1, $completion);
                        tmp = to(result_8, true);
                      } else {
                        if (gameQuestion instanceof StatementQuestion) {
                          var result_9 = CompletableDeferred_0();
                          yield* /*#__NOINLINE__*/playDefaultVariant(this, gameQuestion.d4b_1, mayNothing, result_9, gameQuestion.t3o(), $completion);
                          tmp = to(result_9, true);
                        } else {
                          if (gameQuestion instanceof TriggersQuestion) {
                            var result_10 = CompletableDeferred_0();
                            yield* /*#__NOINLINE__*/playTriggersVariant(this, gameQuestion, mayNothing, result_10, $completion);
                            tmp = to(result_10, true);
                          } else {
                            if (gameQuestion instanceof SnareTypeQuestion) {
                              var result_11 = CompletableDeferred_0();
                              yield* /*#__NOINLINE__*/playDefaultVariant(this, gameQuestion.u5t_1, mayNothing, result_11, null, $completion);
                              tmp = to(result_11, true);
                            } else {
                              if (gameQuestion instanceof AncientPowerNumberQuestion) {
                                var result_12 = CompletableDeferred_0();
                                yield* /*#__NOINLINE__*/chooseAncientPowerNumber(this, gameQuestion.o47_1, result_12, $completion);
                                tmp = to(result_12, true);
                              } else {
                                if (gameQuestion instanceof LocationTypeQuestion) {
                                  var result_13 = CompletableDeferred_0();
                                  yield* this.nmh(gameQuestion.g4a_1, mayNothing, result_13, $completion);
                                  tmp = to(result_13, true);
                                } else {
                                  if (gameQuestion instanceof BeastMovementCardQuestion) {
                                    var result_14 = CompletableDeferred_0();
                                    yield* showChooseMovementCardDialog(this, gameQuestion, result_14, mayNothing, $completion);
                                    tmp = to(result_14, true);
                                  } else {
                                    if (gameQuestion instanceof ZoneQuestion) {
                                      var result_15 = CompletableDeferred_0();
                                      yield* /*#__NOINLINE__*/chooseZoneQuestion(this, gameQuestion.y4b_1, mayNothing, result_15, gameQuestion.t3o(), $completion);
                                      tmp = to(result_15, true);
                                    } else {
                                      if (gameQuestion instanceof TrapByNumberQuestion) {
                                        var result_16 = CompletableDeferred_0();
                                        yield* /*#__NOINLINE__*/chooseTrapByNumberNumber(this, gameQuestion, result_16, $completion);
                                        tmp = to(result_16, true);
                                      } else {
                                        if (gameQuestion instanceof UrgullMoltEggsToReturnQuestion) {
                                          var result_17 = CompletableDeferred_0();
                                          yield* showUrgullMoltEggsToReturnBoard(this, gameQuestion, result_17, this.jl4_1, $completion);
                                          tmp = to(result_17, true);
                                        } else {
                                          if (gameQuestion instanceof CardPlayColorQuestion) {
                                            var result_18 = CompletableDeferred_0();
                                            yield* /*#__NOINLINE__*/playDefaultVariant(this, gameQuestion.s3o(), mayNothing, result_18, gameQuestion.t3o(), $completion);
                                            tmp = to(result_18, true);
                                          } else {
                                            if (isInterface(gameQuestion, BooleanGameQuestion)) {
                                              var result_19 = CompletableDeferred_0();
                                              var tmp_1 = gameQuestion.s3o();
                                              yield* /*#__NOINLINE__*/playBooleanVariant(this, isInterface(tmp_1, KtSet) ? tmp_1 : THROW_CCE(), mayNothing, result_19, get_gameI18n().g71(gameQuestion), $completion);
                                              tmp = to(result_19, true);
                                            } else {
                                              if (gameQuestion instanceof ChooseCharacterQuestion) {
                                                var result_20 = CompletableDeferred_0();
                                                if (this.nml() || get_isReplayOpenGame($context_GameState_t6qee5) || mayNothing) {
                                                  if (mayNothing) {
                                                    yield* /*#__NOINLINE__*/playDefaultVariant(this, gameQuestion.r48_1, mayNothing, result_20, gameQuestion.t3o(), $completion);
                                                  } else {
                                                    yield* /*#__NOINLINE__*/simpleChooseCharacter(this, gameQuestion.r48_1, result_20, $completion);
                                                  }
                                                } else {
                                                  yield* /*#__NOINLINE__*/chooseCharacter(this, gameQuestion.r48_1, result_20, $completion);
                                                }
                                                tmp = to(result_20, true);
                                              } else {
                                                noWhenBranchMatchedException();
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var givenAnswerAndNeedDialog = tmp;
    return givenAnswerAndNeedDialog;
  }
  *nmh(variants, mayNothing, result, $completion) {
    var controlPanelX = new ControlPanelX();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var m = LinkedHashMap.m7();
    var _iterator__ex2g4s = variants.p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var locationType = _iterator__ex2g4s.r1();
      if (!locationType.q45()) {
        continue $l$loop;
      }
      var picture = yield* (yield* this.pl6().hle(locationType, $completion)).m1q($completion);
      var tmp = Image.lk7(picture);
      // Inline function 'kotlin.also' call
      var this_0 = addTo_0(toHeight(RoundButton.fmo(tmp, locationType, VOID, VOID, KorgeControlAgent$chooseLocationTypeQuestion$slambda(result, locationType)), get_gameLayout().ll6_1), controlPanelX);
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
      m.b5(locationType, value);
    }
    if (mayNothing) {
      addNothingVariant(this, result, controlPanelX, m, get_gameI18n().c6z_1);
    }
    this.rln(m);
    yield* this.cmo(controlPanelX.xlb_1, get_gameI18n().e6z_1, VOID, $completion);
    return Unit_instance;
  }
  *hmh(characterObject, isHandMode, onSelectCharacterObject, $completion) {
    // Inline function 'kotlin.with' call
    var $this$with = this.t6h();
    var cardContent = Container.fi2();
    var characterInfo = new CharacterVisualInfoAndContainer(get_visualInfo($this$with, characterObject), cardContent);
    yield* addCharacterInfo($this$with, this.pl6(), characterInfo, $completion);
    return CardUi.ilo(cardContent, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$createCharacterPortrait$slambda(onSelectCharacterObject, characterObject, isHandMode, this));
  }
  imh(characterObject, isHandMode, onSelectCharacterObject, $completion, $super) {
    onSelectCharacterObject = onSelectCharacterObject === VOID ? null : onSelectCharacterObject;
    return $super === VOID ? this.hmh(characterObject, isHandMode, onSelectCharacterObject, $completion) : $super.hmh.call(this, characterObject, isHandMode, onSelectCharacterObject, $completion);
  }
  *imo(content, message, onClickOnEmpty, $completion) {
    return yield* this.gmh(content, dialogCornerText(message), onClickOnEmpty, $completion);
  }
  cmo(content, message, onClickOnEmpty, $completion, $super) {
    message = message === VOID ? null : message;
    onClickOnEmpty = onClickOnEmpty === VOID ? this.jl4_1 : onClickOnEmpty;
    return $super === VOID ? this.imo(content, message, onClickOnEmpty, $completion) : $super.imo.call(this, content, message, onClickOnEmpty, $completion);
  }
  *gmh(content, cornerView, onClickOnEmpty, $completion) {
    return yield* this.dmg(DialogContent.cmg(content, cornerView), onClickOnEmpty, VOID, $completion);
  }
  dmo(content, cornerView, onClickOnEmpty, $completion, $super) {
    onClickOnEmpty = onClickOnEmpty === VOID ? this.jl4_1 : onClickOnEmpty;
    return $super === VOID ? this.gmh(content, cornerView, onClickOnEmpty, $completion) : $super.gmh.call(this, content, cornerView, onClickOnEmpty, $completion);
  }
  *xmo(dialogContent, onClickOnEmpty, showCancelIcon, $completion) {
    var tmp;
    if (this.nl3_1 == null) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this.nl3_1;
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kmi()) === false;
    }
    if (tmp) {
      var gameDialog = {_v: null};
      var tmp_0;
      if (showCancelIcon) {
        tmp_0 = yield* /*#__NOINLINE__*/createDialogCancelView(this, KorgeControlAgent$installCurrentGameDialog$slambda(gameDialog), $completion);
      } else {
        tmp_0 = null;
      }
      var cancelView = tmp_0;
      gameDialog._v = GameDialog.mlt(this.nl2_1, dialogContent.jmi(DialogCorner_RIGHT_TOP_getInstance(), cancelView), onClickOnEmpty);
      var tmp_1 = this;
      var tmp_2;
      if (gameDialog._v == null) {
        throwUninitializedPropertyAccessException('gameDialog');
      } else {
        tmp_2 = gameDialog._v;
      }
      tmp_1.nl3_1 = tmp_2;
      var tmp_3;
      if (gameDialog._v == null) {
        throwUninitializedPropertyAccessException('gameDialog');
      } else {
        tmp_3 = gameDialog._v;
      }
      yield* tmp_3.vma($completion);
      var tmp_4;
      if (gameDialog._v == null) {
        throwUninitializedPropertyAccessException('gameDialog');
      } else {
        tmp_4 = gameDialog._v;
      }
      return tmp_4;
    } else {
      var dialog = ensureNotNull(this.nl3_1);
      dialog.hlq_1 = onClickOnEmpty;
      var tmp_5;
      if (showCancelIcon) {
        tmp_5 = yield* /*#__NOINLINE__*/createDialogCancelView(this, KorgeControlAgent$installCurrentGameDialog$slambda_0(dialog), $completion);
      } else {
        tmp_5 = null;
      }
      var cancelView_0 = tmp_5;
      yield* dialog.ymo(dialogContent.jmi(DialogCorner_RIGHT_TOP_getInstance(), cancelView_0), $completion);
      return dialog;
    }
  }
  dmg(dialogContent, onClickOnEmpty, showCancelIcon, $completion, $super) {
    onClickOnEmpty = onClickOnEmpty === VOID ? this.jl4_1 : onClickOnEmpty;
    showCancelIcon = showCancelIcon === VOID ? true : showCancelIcon;
    return $super === VOID ? this.xmo(dialogContent, onClickOnEmpty, showCancelIcon, $completion) : $super.xmo.call(this, dialogContent, onClickOnEmpty, showCancelIcon, $completion);
  }
  zmo(draftActionCard) {
    return this.xl3_1.w4(draftActionCard);
  }
  plx(ui, hoverPosition) {
    this.ol2_1.uie(ui);
    switch (hoverPosition.w1_1) {
      case 0:
        ui.rif(get_gameLayout().el6_1 - ui.pig() - get_gameLayout().yl5_1);
        ui.sif(get_gameLayout().fl6_1 - ui.rig() - get_gameLayout().yl5_1);
        break;
      case 1:
        ui.rif(this.hl2_1.r9g_1 + (get_gameLayout().el6_1 - this.hl2_1.r9g_1 - ui.pig()) / 2);
        ui.sif(this.hl2_1.s9g_1 + get_gameLayout().yl5_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  *v6q(requestingTeam, $completion) {
    var answer = CompletableDeferred_0();
    var panel = new ControlPanelY();
    addTo_0(PlainText('The other team requests master-fixing mode. Approve?', get_gameLayout().sl5_1), panel);
    var actions = new ButtonRow();
    addTo_0(ActionButton.vlb('Approve', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$approveMasterFixing$slambda(answer)), actions);
    addTo_0(ActionButton.vlb('Decline', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$approveMasterFixing$slambda_0(answer)), actions);
    addTo_0(actions.xlb_1, panel);
    var dialog = GameDialog.xlq(this.nl2_1, panel.xlb_1, 'Master fixing approval', KorgeControlAgent$approveMasterFixing$slambda_1(answer));
    dialog.ylq();
    try {
      return yield* answer.m1q($completion);
    }finally {
      dialog.qlq();
    }
  }
  *t6q(requestingTeam, $completion) {
    var answer = CompletableDeferred_0();
    var panel = new ControlPanelY();
    addTo_0(PlainText('The other team requests reverting. Allow repeated reverts until the next normal answer?', get_gameLayout().sl5_1), panel);
    var actions = new ButtonRow();
    addTo_0(ActionButton.vlb('Approve', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$approveRevert$slambda(answer)), actions);
    addTo_0(ActionButton.vlb('Decline', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$approveRevert$slambda_0(answer)), actions);
    addTo_0(actions.xlb_1, panel);
    var dialog = GameDialog.xlq(this.nl2_1, panel.xlb_1, 'Revert approval', KorgeControlAgent$approveRevert$slambda_1(answer));
    dialog.ylq();
    try {
      return yield* answer.m1q($completion);
    }finally {
      dialog.qlq();
    }
  }
  amp() {
    if (!get_gameConfiguration().vlc_1)
      return null;
    var tmp0_elvis_lhs = this.vl2_1.im5(MenuButtonElement_instance);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var menuButton = tmp;
    var tmp_0 = get_gameI18n().q6y_1;
    // Inline function 'kotlin.apply' call
    var this_0 = ActionButton.vlb(tmp_0, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$createOnboardingMenuButton$slambda(this));
    this_0.fcw(menuButton.wb5());
    this_0.sig(0.0);
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse(this_0);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = KorgeControlAgent$createOnboardingMenuButton$slambda_0(this_0);
    var tmp_1 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_2 = getPropertyCallableRef('over', 1, tmp_1, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
    tmp_2.v9y(KorgeControlAgent$createOnboardingMenuButton$lambda($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = KorgeControlAgent$createOnboardingMenuButton$slambda_1(this_0);
    var tmp_3 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_4 = getPropertyCallableRef('out', 1, tmp_3, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
    tmp_4.v9y(KorgeControlAgent$createOnboardingMenuButton$lambda_0($this$mouse, handler_0));
    return this_0;
  }
  *gmo($completion) {
    var controlPanelY = new ControlPanelY();
    var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
    var tmp = get_gameI18n().r6y_1;
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda(this)), actions);
    var tmp_0 = get_gameI18n().s6y_1;
    addTo_0(ActionButton.vlb(tmp_0, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_0(this)), actions);
    var tmp_1 = this.fl2_1;
    var switchingProvider = tmp_1 instanceof SwitchingGameTeamProvider ? tmp_1 : null;
    if (this.nml() && !(switchingProvider == null) && switchingProvider.ve0_1) {
      var tmp_2 = 'Visibility: ' + switchingProvider.ze0_1.pe0_1;
      addTo_0(ActionButton.vlb(tmp_2, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_1(this, switchingProvider)), actions);
    }
    addJumpInTimelineButtonIfNeeded(this, actions);
    if (this.nml() && this.il2_1.sdx()) {
      addTo_0(ActionButton.vlb('Request public sharing', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_2(this)), actions);
    }
    addTo_0(ActionButton.vlb('Content Reference', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_3(this)), actions);
    if (!(get_gameConfiguration().flc_1 == null)) {
      addTo_0(ActionButton.vlb('Settings', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_4(this)), actions);
    }
    var mode = get_currentKorgeMode();
    var tmp_3;
    if (mode instanceof SandboxGamePlaying) {
      tmp_3 = !get_gameConfiguration().blc_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      addTo_0(ActionButton.vlb('Finish and Share', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_5(this, mode)), actions);
    }
    var tmp0_safe_receiver = get_gameConfiguration().flc_1;
    var tmp_4;
    if (tmp0_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.takeUnless' call
      var tmp_5;
      if (!this.nml()) {
        tmp_5 = tmp0_safe_receiver;
      } else {
        tmp_5 = null;
      }
      tmp_4 = tmp_5;
    }
    var tmp1_safe_receiver = tmp_4;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addTo_0(ActionButton.vlb('Master fixing', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_6(this, tmp1_safe_receiver)), actions);
      addTo_0(ActionButton.vlb('Revert turn', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_7(this, tmp1_safe_receiver)), actions);
      if (this.il2_1.rdx()) {
        addTo_0(ActionButton.vlb('Reload game', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$showMenu$slambda_8(this)), actions);
      }
    }
    addTo_0(actions.xlb_1, controlPanelY);
    if (!(get_gameConfiguration().flc_1 == null)) {
      addTo_0(PlainText('Disconnected ' + get_numberOfDisconnectionsSoFar() + ' time(s) by now', get_gameLayout().sl5_1), controlPanelY);
    }
    var tmp2_safe_receiver = get_gameConfiguration().flc_1;
    var tmp_6;
    if (tmp2_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_7;
      if (this.il2_1.rdx() && !this.nml()) {
        tmp_7 = tmp2_safe_receiver;
      } else {
        tmp_7 = null;
      }
      tmp_6 = tmp_7;
    }
    var presenceConfiguration = tmp_6;
    var tmp_8;
    if (presenceConfiguration == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_8 = GamePresencePanel.iml();
    }
    var presencePanel = tmp_8;
    var dialog = yield* this.dmg(DialogContent.llt(controlPanelY.xlb_1, mapOf(to(DialogCorner_LEFT_TOP_getInstance(), presencePanel))), get_gameDialogClose(), VOID, $completion);
    if (!(presencePanel == null)) {
      launch(this.jl2_1, VOID, VOID, KorgeControlAgent$showMenu$slambda_9(dialog, controlPanelY, presenceConfiguration, presencePanel));
    }
    return Unit_instance;
  }
  *u6h(message, $completion) {
    var tmp0_safe_receiver = get_gameConfiguration().flc_1;
    if ((tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver.c6m(this.t6h().g38_1, message, stackTraceToString(Exception.te()), $completion))) == null)
      yield* reportRevisionProblem.call(this, message, $completion);
    return Unit_instance;
  }
  pl6() {
    return this.dl2_1.pl6();
  }
  pln() {
    return this.dl2_1.pln();
  }
  ol6() {
    return this.dl2_1.ol6();
  }
  rln(_set____db54di) {
    this.dl2_1.rln(_set____db54di);
  }
  dl5() {
    return this.dl2_1.dl5();
  }
  sln(message) {
    this.dl2_1.sln(message);
  }
  k3q() {
    return this.fl2_1.k3q();
  }
  f5c(warning, cause) {
    return this.el2_1.f5c(warning, cause);
  }
}
class CharacterVisualInfoAndContainer {
  constructor(visualInfo, container) {
    this.zmg_1 = visualInfo;
    this.amh_1 = container;
  }
  jm() {
    return this.zmg_1;
  }
  km() {
    return this.amh_1;
  }
  toString() {
    return 'CharacterVisualInfoAndContainer(visualInfo=' + this.zmg_1.toString() + ', container=' + this.amh_1.toString() + ')';
  }
  hashCode() {
    var result = this.zmg_1.hashCode();
    result = imul(result, 31) + hashCode(this.amh_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CharacterVisualInfoAndContainer))
      return false;
    if (!this.zmg_1.equals(other.zmg_1))
      return false;
    if (!equals(this.amh_1, other.amh_1))
      return false;
    return true;
  }
}
class CharacterVisualInfo {
  constructor(character, isAlternativeView, wounds, ancientPowerNumber, grudgeNumber, uniqueResourceNumber) {
    this.tmg_1 = character;
    this.umg_1 = isAlternativeView;
    this.vmg_1 = wounds;
    this.wmg_1 = ancientPowerNumber;
    this.xmg_1 = grudgeNumber;
    this.ymg_1 = uniqueResourceNumber;
  }
  toString() {
    return 'CharacterVisualInfo(character=' + toString(this.tmg_1) + ', isAlternativeView=' + this.umg_1 + ', wounds=' + this.vmg_1 + ', ancientPowerNumber=' + this.wmg_1 + ', grudgeNumber=' + this.xmg_1 + ', uniqueResourceNumber=' + this.ymg_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.tmg_1);
    result = imul(result, 31) + getBooleanHashCode(this.umg_1) | 0;
    result = imul(result, 31) + this.vmg_1 | 0;
    result = imul(result, 31) + this.wmg_1 | 0;
    result = imul(result, 31) + this.xmg_1 | 0;
    result = imul(result, 31) + this.ymg_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CharacterVisualInfo))
      return false;
    if (!equals(this.tmg_1, other.tmg_1))
      return false;
    if (!(this.umg_1 === other.umg_1))
      return false;
    if (!(this.vmg_1 === other.vmg_1))
      return false;
    if (!(this.wmg_1 === other.wmg_1))
      return false;
    if (!(this.xmg_1 === other.xmg_1))
      return false;
    if (!(this.ymg_1 === other.ymg_1))
      return false;
    return true;
  }
}
class StatusBarKey {
  constructor(phase, dayNumber, currentTurnNumber, additionalInfo) {
    this.bmp_1 = phase;
    this.cmp_1 = dayNumber;
    this.dmp_1 = currentTurnNumber;
    this.emp_1 = additionalInfo;
  }
  toString() {
    return 'StatusBarKey(phase=' + toString(this.bmp_1) + ', dayNumber=' + this.cmp_1 + ', currentTurnNumber=' + this.dmp_1 + ', additionalInfo=' + toString(this.emp_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.bmp_1);
    result = imul(result, 31) + this.cmp_1 | 0;
    result = imul(result, 31) + this.dmp_1 | 0;
    result = imul(result, 31) + hashCode(this.emp_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StatusBarKey))
      return false;
    if (!equals(this.bmp_1, other.bmp_1))
      return false;
    if (!(this.cmp_1 === other.cmp_1))
      return false;
    if (!(this.dmp_1 === other.dmp_1))
      return false;
    if (!equals(this.emp_1, other.emp_1))
      return false;
    return true;
  }
}
class TwoBeastsHpElement {
  constructor(wounds) {
    this.fmp_1 = wounds;
  }
  toString() {
    return 'TwoBeastsHpElement(wounds=' + this.fmp_1 + ')';
  }
  hashCode() {
    return this.fmp_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TwoBeastsHpElement))
      return false;
    if (!(this.fmp_1 === other.fmp_1))
      return false;
    return true;
  }
}
class MenuButtonElement {
  toString() {
    return 'MenuButtonElement';
  }
  hashCode() {
    return 526595940;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuButtonElement))
      return false;
    return true;
  }
}
class CharacterElement {
  constructor(characterObject) {
    this.gmp_1 = characterObject;
  }
  toString() {
    return 'CharacterElement(characterObject=' + this.gmp_1.toString() + ')';
  }
  hashCode() {
    return this.gmp_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CharacterElement))
      return false;
    if (!this.gmp_1.equals(other.gmp_1))
      return false;
    return true;
  }
}
class DiscardButtonElement {
  toString() {
    return 'DiscardButtonElement';
  }
  hashCode() {
    return 396448179;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardButtonElement))
      return false;
    return true;
  }
}
class RuinButtonElement {
  toString() {
    return 'RuinButtonElement';
  }
  hashCode() {
    return -579283781;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuinButtonElement))
      return false;
    return true;
  }
}
class CardAtSidePanelElement {
  constructor(card, isInPlayArea) {
    this.hmp_1 = card;
    this.imp_1 = isInPlayArea;
  }
  toString() {
    return 'CardAtSidePanelElement(card=' + toString(this.hmp_1) + ', isInPlayArea=' + this.imp_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.hmp_1);
    result = imul(result, 31) + getBooleanHashCode(this.imp_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardAtSidePanelElement))
      return false;
    if (!equals(this.hmp_1, other.hmp_1))
      return false;
    if (!(this.imp_1 === other.imp_1))
      return false;
    return true;
  }
}
class TextGameScopeElement {
  constructor(gameScope) {
    this.jmp_1 = gameScope;
  }
  toString() {
    return 'TextGameScopeElement(gameScope=' + toString(this.jmp_1) + ')';
  }
  hashCode() {
    return hashCode(this.jmp_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextGameScopeElement))
      return false;
    if (!equals(this.jmp_1, other.jmp_1))
      return false;
    return true;
  }
}
class OverPanelUiHoverPosition extends Enum {}
class CardsGridPlacing {
  constructor(rows, cardsInRow, cellWidth, cellHeight, minViewScale) {
    this.kmp_1 = rows;
    this.lmp_1 = cardsInRow;
    this.mmp_1 = cellWidth;
    this.nmp_1 = cellHeight;
    this.omp_1 = minViewScale;
  }
  toString() {
    return 'CardsGridPlacing(rows=' + this.kmp_1 + ', cardsInRow=' + this.lmp_1 + ', cellWidth=' + this.mmp_1 + ', cellHeight=' + this.nmp_1 + ', minViewScale=' + this.omp_1 + ')';
  }
  hashCode() {
    var result = this.kmp_1;
    result = imul(result, 31) + this.lmp_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.mmp_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.nmp_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.omp_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CardsGridPlacing))
      return false;
    if (!(this.kmp_1 === other.kmp_1))
      return false;
    if (!(this.lmp_1 === other.lmp_1))
      return false;
    if (!equals(this.mmp_1, other.mmp_1))
      return false;
    if (!equals(this.nmp_1, other.nmp_1))
      return false;
    if (!equals(this.omp_1, other.omp_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0_2 {
  constructor(function_0) {
    this.pmp_1 = function_0;
  }
  pj(a, b) {
    return this.pmp_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.pmp_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class KorgeStateLogging {}
function debugPrintPosAndScale($context_Container_60lnhb) {
}
function logGivenAnswer($context_GameState_t6qee5, gameQuestion, answer) {
}
function logTurnOfPlayer($context_GameState_t6qee5, characterObject) {
}
function logImageLoading(s) {
}
function logTodo(message) {
}
class EmptyKorgeStateLogging {}
class MapZoomAnimation {
  constructor(mapImage, destination, duration) {
    this.dls_1 = mapImage;
    this.els_1 = duration;
    this.fls_1 = anchor_0(this, toPoint(this.dls_1.s2().l9s(2)));
    this.gls_1 = anchor_0(this, destination);
    this.dls_1.ijb(this.fls_1);
    this.dls_1.uif(0.18);
  }
  *hls($completion) {
    var tmp0_$receiver = this.dls_1;
    var tmp0 = this.dls_1;
    var tmp = KMutableProperty0;
    var tmp_0 = Image$_get_anchor_$ref_nch4q6(tmp0);
    var tmp_1 = get_1(getPropertyCallableRef('anchor', 0, tmp, tmp_0, Image$_set_anchor_$ref_wmec3q(tmp0)), this.fls_1, this.gls_1);
    var tmp0_0 = this.dls_1;
    var tmp_2 = KMutableProperty0;
    var tmp_3 = Image$_get_scale_$ref_62rx9v(tmp0_0);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('scale', 0, tmp_2, tmp_3, Image$_set_scale_$ref_zdmdof(tmp0_0));
    var tmp1_vs = [tmp_1, new V2(this_0, 0.18, 1.0, _interpolate$ref(), true)];
    var tmp2_easing = get_EASE_IN_OUT(Companion_getInstance_14());
    var tmp3_time = this.els_1;
    yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }
  v7e() {
    this.dls_1.ijb(this.gls_1);
    this.dls_1.uif(1.0);
  }
}
class ReplayLoadingProgress {
  constructor(targetAnswerIndex) {
    this.kls_1 = targetAnswerIndex;
    this.lls_1 = 0;
    this.mls_1 = null;
    this.nls_1 = null;
  }
  alt(currentAnswerIndex) {
    this.lls_1 = currentAnswerIndex;
    updateText(this);
  }
  pls(text) {
    this.mls_1 = text;
    updateText(this);
  }
  qls(dialog) {
    this.nls_1 = dialog;
  }
  v7e() {
    var tmp0_safe_receiver = this.nls_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    this.nls_1 = null;
    this.mls_1 = null;
  }
  ols() {
    var tmp;
    if (this.kls_1 > 0) {
      tmp = 'Loading Replay: ' + this.lls_1 + '/' + this.kls_1;
    } else {
      tmp = 'Loading Replay...';
    }
    return tmp;
  }
}
class SameScreenControlAgent$1 {
  constructor($shared, $hotSeatSceneManager) {
    this.ymp_1 = $shared;
    this.zmp_1 = $hotSeatSceneManager;
  }
  te2() {
    return this.ymp_1.mlu_1.jl2_1;
  }
  ke2(value) {
    this.zmp_1.ldx_1 = value;
  }
  ie2() {
    return this.zmp_1.ldx_1;
  }
  re2() {
    return this.ymp_1.mlu_1;
  }
  *ze1($completion) {
    yield* this.ymp_1.plu(this.zmp_1.plo_1, $completion);
    return this.re2();
  }
  *fe2(block, $completion) {
    return yield* insideScope(this.zmp_1.plo_1, SameScreenControlAgent$_init_$o$inScope$slambda_v7irhk(block), $completion);
  }
  *je2(team, showIllustration, updatePerspective, $completion) {
    return yield* this.ymp_1.je2(team, showIllustration, updatePerspective, $completion);
  }
}
class SameScreenControlAgent extends SameScreenFlowAgent {
  constructor(gameTeam, switchingGameTeamProvider, shared, hotSeatSceneManager, images, requireHotSeatHandover) {
    requireHotSeatHandover = requireHotSeatHandover === VOID ? false : requireHotSeatHandover;
    var tmp = new SameScreenControlAgent$1(shared, hotSeatSceneManager);
    super(gameTeam, switchingGameTeamProvider, tmp, SameScreenControlAgent$_init_$lambda_7uc4gh, requireHotSeatHandover);
    this.jmq_1 = hotSeatSceneManager;
    this.kmq_1 = images;
  }
}
class SharedTeamsScene extends BeastGameScene {
  constructor(gameUi, controlAgent) {
    super(gameUi);
    this.mlu_1 = controlAgent;
    this.nlu_1 = Mutex();
    this.olu_1 = false;
  }
  *plu(sceneContainer, $completion) {
    return yield* insideScope(sceneContainer, SharedTeamsScene$show$slambda(this, sceneContainer), $completion);
  }
  *je2(team, showIllustration, updatePerspective, $completion) {
    return yield* coroutineScope(SharedTeamsScene$handover$slambda(this, updatePerspective, team, showIllustration), $completion);
  }
}
class sam$kotlinx_coroutines_flow_FlowCollector$0_0 {
  constructor(function_0) {
    this.wmq_1 = function_0;
  }
  *k24(value, $completion) {
    return yield* this.wmq_1(value, $completion);
  }
  p5() {
    return this.wmq_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class createStatusLayer$2 {
  constructor($isDisconnected, $fadingJob, $statusText, $statusLayer, $scope, $loadingResourceReporter) {
    this.xmq_1 = $isDisconnected;
    this.ymq_1 = $fadingJob;
    this.zmq_1 = $statusText;
    this.amr_1 = $statusLayer;
    this.bmr_1 = $scope;
    this.cmr_1 = $loadingResourceReporter;
  }
  *dmr(state, $completion) {
    if (this.xmq_1._v)
      return Unit_instance;
    createStatusLayer$updateText(this.ymq_1, this.zmq_1, this.amr_1, 'Loading Images: ' + state.fmr_1 + '/' + state.emr_1);
    return Unit_instance;
  }
  *gmr($completion) {
    if (this.xmq_1._v)
      return Unit_instance;
    this.xmq_1._v = true;
    var _unary__edvuaz = get_numberOfDisconnectionsSoFar();
    set_numberOfDisconnectionsSoFar(_unary__edvuaz + 1 | 0);
    createStatusLayer$updateText(this.ymq_1, this.zmq_1, this.amr_1, 'Reconnecting...');
    return Unit_instance;
  }
  *hmr($completion) {
    this.xmq_1._v = false;
    createStatusLayer$updateText(this.ymq_1, this.zmq_1, this.amr_1, 'Reconnected');
    return Unit_instance;
  }
  *imr($completion) {
    createStatusLayer$startFadeStatusNotification(this.zmq_1, this.ymq_1, this.bmr_1, this.cmr_1);
    return Unit_instance;
  }
}
class BeastMapUiPlacing {
  constructor(locationSide, townSide, centerSide, locations, movementCardPlace, movementCardWidth, trapAreaSize, trapMap) {
    this.alo_1 = locationSide;
    this.blo_1 = townSide;
    this.clo_1 = centerSide;
    this.dlo_1 = locations;
    this.elo_1 = movementCardPlace;
    this.flo_1 = movementCardWidth;
    this.glo_1 = trapAreaSize;
    this.hlo_1 = trapMap;
  }
  toString() {
    return 'BeastMapUiPlacing(locationSide=' + this.alo_1 + ', townSide=' + this.blo_1 + ', centerSide=' + this.clo_1 + ', locations=' + toString(this.dlo_1) + ', movementCardPlace=' + toString(this.elo_1) + ', movementCardWidth=' + this.flo_1 + ', trapAreaSize=' + this.glo_1.toString() + ', trapMap=' + toString(this.hlo_1) + ')';
  }
  hashCode() {
    var result = this.alo_1;
    result = imul(result, 31) + this.blo_1 | 0;
    result = imul(result, 31) + this.clo_1 | 0;
    result = imul(result, 31) + hashCode(this.dlo_1) | 0;
    result = imul(result, 31) + hashCode(this.elo_1) | 0;
    result = imul(result, 31) + this.flo_1 | 0;
    result = imul(result, 31) + this.glo_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.hlo_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BeastMapUiPlacing))
      return false;
    if (!(this.alo_1 === other.alo_1))
      return false;
    if (!(this.blo_1 === other.blo_1))
      return false;
    if (!(this.clo_1 === other.clo_1))
      return false;
    if (!equals(this.dlo_1, other.dlo_1))
      return false;
    if (!equals(this.elo_1, other.elo_1))
      return false;
    if (!(this.flo_1 === other.flo_1))
      return false;
    if (!this.glo_1.equals(other.glo_1))
      return false;
    if (!equals(this.hlo_1, other.hlo_1))
      return false;
    return true;
  }
}
class LocationArea {
  constructor(position, locationUiType, center, radios) {
    this.kl8_1 = position;
    this.ll8_1 = locationUiType;
    this.ml8_1 = center;
    this.nl8_1 = radios;
  }
  toString() {
    return 'LocationArea(position=' + BoardPosition__toString_impl_v4mn82(this.kl8_1) + ', locationUiType=' + this.ll8_1.toString() + ', center=' + this.ml8_1.toString() + ', radios=' + this.nl8_1 + ')';
  }
  hashCode() {
    var result = BoardPosition__hashCode_impl_9dgqf7(this.kl8_1);
    result = imul(result, 31) + this.ll8_1.hashCode() | 0;
    result = imul(result, 31) + this.ml8_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.nl8_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LocationArea))
      return false;
    if (!(this.kl8_1 === other.kl8_1))
      return false;
    if (!this.ll8_1.equals(other.ll8_1))
      return false;
    if (!this.ml8_1.equals(other.ml8_1))
      return false;
    if (!equals(this.nl8_1, other.nl8_1))
      return false;
    return true;
  }
}
class MapLogicalAndUiMappingImpl {
  constructor(logicalMap, placing) {
    this.jmr_1 = logicalMap;
    this.kmr_1 = placing;
  }
  nll() {
    return this.kmr_1;
  }
  h47() {
    return this.jmr_1;
  }
  jl8(position) {
    var columns = (_BoardPosition___get_x__impl__gyx07(this.jmr_1.o44_1) - _BoardPosition___get_x__impl__gyx07(this.jmr_1.n44_1) | 0) + 1 | 0;
    var tmp;
    var containsLower = _BoardPosition___get_x__impl__gyx07(this.jmr_1.n44_1);
    var containsUpper = _BoardPosition___get_x__impl__gyx07(this.jmr_1.o44_1);
    var containsArg = _BoardPosition___get_x__impl__gyx07(position);
    if (!(containsLower <= containsArg ? containsArg <= containsUpper : false)) {
      tmp = true;
    } else {
      var containsLower_0 = _BoardPosition___get_y__impl__tale2e(this.jmr_1.n44_1);
      var containsUpper_0 = _BoardPosition___get_y__impl__tale2e(this.jmr_1.o44_1);
      var containsArg_0 = _BoardPosition___get_y__impl__tale2e(position);
      tmp = !(containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false);
    }
    if (tmp) {
      return null;
    }
    var index = imul(_BoardPosition___get_y__impl__tale2e(position) - _BoardPosition___get_y__impl__tale2e(this.jmr_1.n44_1) | 0, columns) + (_BoardPosition___get_x__impl__gyx07(position) - _BoardPosition___get_x__impl__gyx07(this.jmr_1.n44_1) | 0) | 0;
    var tmp0_elvis_lhs = this.kmr_1.dlo_1.u2(index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var location = tmp_0;
    var tmp1_safe_receiver = this.jmr_1.p44_1.w4(new BoardPosition(position));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k45_1;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var locationType = tmp_1;
    var uiType = position === _BoardPosition___init__impl__1nizgq(0, 0) ? LocationUiType_centerLocation_getInstance() : locationType.equals(LocationType_Settlement_getInstance()) ? LocationUiType_townLocation_getInstance() : LocationUiType_commonLocation_getInstance();
    var width = position === _BoardPosition___init__impl__1nizgq(0, 0) ? this.kmr_1.clo_1 : locationType.equals(LocationType_Settlement_getInstance()) ? this.kmr_1.blo_1 : this.kmr_1.alo_1;
    return new LocationArea(position, uiType, location, width / 2);
  }
  vlm(point) {
    var inductionVariable = _BoardPosition___get_y__impl__tale2e(this.jmr_1.n44_1);
    var last = _BoardPosition___get_y__impl__tale2e(this.jmr_1.o44_1);
    if (inductionVariable <= last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = _BoardPosition___get_x__impl__gyx07(this.jmr_1.n44_1);
        var last_0 = _BoardPosition___get_x__impl__gyx07(this.jmr_1.o44_1);
        if (inductionVariable_0 <= last_0)
          $l$loop: do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var position = _BoardPosition___init__impl__1nizgq(x, y);
            var tmp0_elvis_lhs = this.jl8(position);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var area = tmp;
            var tmp_0;
            var containsLower = area.ml8_1.r9g_1 - area.nl8_1;
            var containsUpper = area.ml8_1.r9g_1 + area.nl8_1;
            var containsArg = point.r9g_1;
            if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
              var containsLower_0 = area.ml8_1.s9g_1 - area.nl8_1;
              var containsUpper_0 = area.ml8_1.s9g_1 + area.nl8_1;
              var containsArg_0 = point.s9g_1;
              tmp_0 = containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var tmp0 = area.ml8_1.r9g_1 - point.r9g_1;
              // Inline function 'kotlin.math.hypot' call
              var y_0 = area.ml8_1.s9g_1 - point.s9g_1;
              if (hypot(tmp0, y_0) < area.nl8_1) {
                return area;
              }
            }
          }
           while (!(x === last_0));
      }
       while (!(y === last));
    return null;
  }
}
class LocationUiType extends Enum {}
class MapFormat extends Enum {}
class UserInfoView {
  constructor(avatarScope, displayName, avatarUrl, textSize, avatarSize, sessionCount) {
    sessionCount = sessionCount === VOID ? 1 : sessionCount;
    var tmp;
    if (avatarUrl == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.apply' call
      var this_0 = Container.fi2();
      // Inline function 'korlibs.korge.view.solidRect' call
      var color = get_gameColors().qlx_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = SolidRect.mkf(Size2D.y9p(avatarSize, avatarSize), color);
      // Inline function 'kotlin.apply' call
      addTo(this_1, this_0);
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = take(displayName, 1).toUpperCase();
      addTo(xy(PlainText(tmp$ret$8, textSize), avatarSize / 4, avatarSize / 4), this_0);
      tmp = this_0;
    }
    var avatar = tmp;
    var label = displayName + (sessionCount > 1 ? ' x' + sessionCount : '');
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new ControlPanelX();
    if (avatar == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_2.mlr(avatar);
    }
    this_2.mlr(PlainText(label, textSize));
    this_2.flr();
    tmp_0.clt_1 = this_2.xlb_1;
    var tmp_1 = this;
    var tmp_2;
    if (avatar == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = launch(avatarScope, VOID, VOID, UserInfoView$slambda(avatar, avatarSize, avatarUrl));
    }
    tmp_1.dlt_1 = tmp_2;
  }
}
class ActionButton extends Container {
  constructor(text, isActiveButton, icon, onRightClick, explicitSize, explicitTextSize, onActionInvoked) {
    return new.target.vlb(text, isActiveButton, icon, onRightClick, explicitSize, explicitTextSize, onActionInvoked);
  }
  static vlb(text, isActiveButton, icon, onRightClick, explicitSize, explicitTextSize, onActionInvoked) {
    isActiveButton = isActiveButton === VOID ? true : isActiveButton;
    icon = icon === VOID ? null : icon;
    onRightClick = onRightClick === VOID ? null : onRightClick;
    explicitSize = explicitSize === VOID ? null : explicitSize;
    explicitTextSize = explicitTextSize === VOID ? null : explicitTextSize;
    var $this = this.fi2();
    var tmp = $this;
    tmp.llb_1 = explicitTextSize == null ? get_gameLayout().sl5_1 : explicitTextSize;
    $this.mlb_1 = $this.llb_1 * get_gameLayout().wl5_1;
    var tmp_0 = $this;
    var tmp0 = get_gameLayout().xl5_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = 2 * $this.mlb_1;
    tmp_0.nlb_1 = Math.max(tmp0, b);
    $this.olb_1 = PlainText(text, $this.llb_1);
    var tmp_1 = $this;
    var tmp_2;
    if (icon == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = toHeight(Image.lk7(icon), $this.olb_1.x9z());
    }
    tmp_1.plb_1 = tmp_2;
    var tmp_3 = $this;
    var tmp_4;
    if (explicitSize == null) {
      var tmp_5 = $this.olb_1.w9z() + 2 * $this.nlb_1;
      var tmp1_safe_receiver = $this.plb_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.pig();
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + $this.mlb_1;
      tmp_4 = Size2D.y9p(tmp_5 + (tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs), $this.olb_1.x9z() + 2 * $this.mlb_1);
    } else {
      tmp_4 = explicitSize;
    }
    tmp_3.qlb_1 = tmp_4;
    $this.rlb_1 = ShaderButtonBackground.gmu($this.qlb_1);
    $this.slb_1 = Companion_instance.ekd($this.qlb_1.j9i_1, $this.qlb_1.k9i_1, Colors_getInstance().ec3_1);
    $this.tlb_1 = isActiveButton;
    $this.ulb_1 = false;
    $this.rlb_1.xmt_1 = isActiveButton;
    $this.rlb_1.hmu(getStringHashCode(text));
    $this.uie($this.rlb_1);
    var tmp0_safe_receiver = $this.plb_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.thy(false);
      $this.uie(tmp0_safe_receiver);
    }
    $this.olb_1.thy(false);
    $this.uie($this.olb_1);
    $this.uie($this.slb_1);
    $this.zlq($this.qlb_1);
    $this.ql8();
    // Inline function 'korlibs.korge.input.mouse' call
    var this_0 = $this.slb_1;
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse(this_0);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = ActionButton$slambda($this);
    var tmp_6 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_7 = getPropertyCallableRef('over', 1, tmp_6, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
    tmp_7.v9y(ActionButton$lambda($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = ActionButton$slambda_0($this);
    var tmp_8 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_9 = getPropertyCallableRef('out', 1, tmp_8, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
    tmp_9.v9y(ActionButton$lambda_0($this$mouse, handler_0));
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var handler_1 = ActionButton$slambda_1($this, onActionInvoked, onRightClick);
    var tmp_10 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_11 = getPropertyCallableRef('click', 1, tmp_10, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
    tmp_11.v9y(ActionButton$lambda_1($this$mouse, handler_1));
    addUpdater($this, ActionButton$lambda_2);
    return $this;
  }
  imu() {
    return this.rlb_1.umt_1;
  }
  lmq() {
    return this.rlb_1.vmt_1;
  }
  ils(value) {
    if (this.tlb_1 === value)
      return Unit_instance;
    this.tlb_1 = value;
    this.rlb_1.xmt_1 = value;
    if (!value) {
      this.pl8(false);
      this.rlb_1.wmt_1 = 0.0;
    }
    this.ql8();
  }
  pl8(value) {
    this.ulb_1 = value;
    this.ql8();
  }
  am5() {
    return this.ulb_1;
  }
  static xlt(textAndAction, common) {
    return this.vlb(textAndAction.smp_1, VOID, VOID, VOID, VOID, VOID, ActionButton$_init_$slambda_iro9fo(textAndAction, common));
  }
  zlq(size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(size.j9i_1 > 0 && size.k9i_1 > 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    this.rlb_1.jmu(size);
    xy(this.rlb_1, -this.imu(), -this.imu());
    // Inline function 'korlibs.korge.view.xy' call
    var this_0 = size_0(this.slb_1, size);
    xy(this_0, numberToDouble(0), numberToDouble(0));
    var tmp = this.olb_1.w9z();
    var tmp0_safe_receiver = this.plb_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pig();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver + this.mlb_1;
    var contentWidth = tmp + (tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
    var contentX = (size.j9i_1 - contentWidth) / 2;
    var tmp3_safe_receiver = this.plb_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      xy(tmp3_safe_receiver, contentX, (size.k9i_1 - tmp3_safe_receiver.rig()) / 2);
    }
    var tmp4_safe_receiver = this.plb_1;
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.pig();
    var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver + this.mlb_1;
    xy(this.olb_1, contentX + (tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs), (size.k9i_1 - this.olb_1.x9z()) / 2);
    this.gih();
  }
  oib() {
    return new Rectangle(0.0, 0.0, this.lmq().j9i_1, this.lmq().k9i_1);
  }
  ql8() {
    if (get_gameConfiguration().olc_1) {
      this.rlb_1.wmt_1 = this.tlb_1 && this.ulb_1 ? 1.0 : 0.0;
    }
    this.olb_1.zjp(!this.tlb_1 ? Colors_getInstance().qci('#8a9295') : this.rlb_1.wmt_1 > 0.5 ? Colors_getInstance().qci('#fff0cb') : Colors_getInstance().qci('#f1f0ec'));
    this.rlb_1.hie();
  }
}
class TextAndAction {
  constructor(text, action) {
    this.smp_1 = text;
    this.tmp_1 = action;
  }
}
class ControlPanel {
  constructor(panelSize, container) {
    this.wlb_1 = panelSize;
    var tmp = this;
    tmp.xlb_1 = container == null ? Container.fi2() : container;
  }
  mlr(view) {
    this.xlb_1.uie(view);
  }
}
class ButtonColumn extends ControlPanel {
  constructor(minimumSurfaceSize, surfaceGap) {
    minimumSurfaceSize = minimumSurfaceSize === VOID ? Size2D.l9i(0, 49) : minimumSurfaceSize;
    surfaceGap = surfaceGap === VOID ? 11.0 : surfaceGap;
    super(null, ButtonLayoutContainer.smw());
    this.plt_1 = minimumSurfaceSize;
    this.qlt_1 = surfaceGap;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.rlt_1 = ArrayList.p2();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.slt_1 = LinkedHashMap.m7();
    this.tlt_1 = 0.0;
    this.ult_1 = 0.0;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(this.plt_1.j9i_1 >= 0 && this.plt_1.k9i_1 >= 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(this.qlt_1 >= 0)) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message_0));
    }
  }
  mlr(view) {
    // Inline function 'kotlin.require' call
    if (!(view instanceof ActionButton)) {
      var message = 'ButtonColumn accepts only ActionButton';
      throw IllegalArgumentException.h2(toString(message));
    }
    var extraGap = coerceAtLeast(this.tlt_1 - this.ult_1, 0.0);
    // Inline function 'kotlin.collections.set' call
    this.slt_1.b5(view, extraGap);
    // Inline function 'kotlin.collections.plusAssign' call
    this.rlt_1.d2(view);
    super.mlr(view);
    layoutButtons(this);
  }
  flr() {
    layoutButtons(this);
  }
}
class ButtonRow extends ControlPanel {
  constructor(maxWidth, surfaceGap, equalWidths) {
    maxWidth = maxWidth === VOID ? Infinity : maxWidth;
    surfaceGap = surfaceGap === VOID ? 5.0 : surfaceGap;
    equalWidths = equalWidths === VOID ? false : equalWidths;
    super(null, ButtonLayoutContainer.smw());
    this.wlr_1 = maxWidth;
    this.xlr_1 = surfaceGap;
    this.ylr_1 = equalWidths;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.zlr_1 = ArrayList.p2();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(this.wlr_1 > 0 && this.xlr_1 >= 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
  }
  mlr(view) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.zlr_1.d2(view);
    super.mlr(view);
    layoutButtons_0(this);
  }
  flr() {
    layoutButtons_0(this);
  }
}
class ButtonLayoutContainer extends Container {
  constructor() {
    return new.target.smw();
  }
  static smw() {
    return this.fi2();
  }
  oib() {
    var bounds = Companion_getInstance_13().e9i();
    var _iterator__ex2g4s = this.xi1_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var child = _iterator__ex2g4s.r1();
      if (child.yig())
        bounds = BoundsBuilder__plus_impl_cz7f7x(bounds, child.gii(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bounds);
  }
}
class ControlPanelY extends ControlPanel {
  constructor(panelSize, offsetX, offsetY, stepY) {
    panelSize = panelSize === VOID ? null : panelSize;
    offsetX = offsetX === VOID ? 0.0 : offsetX;
    offsetY = offsetY === VOID ? 0.0 : offsetY;
    stepY = stepY === VOID ? get_gameLayout().yl5_1 : stepY;
    super(panelSize, null);
    this.clr_1 = offsetX;
    this.dlr_1 = offsetY;
    this.elr_1 = stepY;
  }
  mlr(view) {
    super.mlr(view);
    xy(view, this.clr_1, this.dlr_1);
    this.dlr_1 = this.dlr_1 + (view.rig() + this.elr_1);
  }
  flr() {
    var tmp0_safe_receiver = this.wlb_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9i_1;
    var fullWidth = tmp1_elvis_lhs == null ? this.xlb_1.w9z() : tmp1_elvis_lhs;
    var _iterator__ex2g4s = this.xlb_1.xi1_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var view = _iterator__ex2g4s.r1();
      view.rif((fullWidth - view.pig()) / 2);
    }
  }
}
class ControlPanelX extends ControlPanel {
  constructor(panelSize, container, offsetX, offsetY, stepX) {
    panelSize = panelSize === VOID ? null : panelSize;
    container = container === VOID ? null : container;
    offsetX = offsetX === VOID ? 0.0 : offsetX;
    offsetY = offsetY === VOID ? 0.0 : offsetY;
    stepX = stepX === VOID ? get_gameLayout().yl5_1 : stepX;
    super(panelSize, container);
    this.jlr_1 = offsetX;
    this.klr_1 = offsetY;
    this.llr_1 = stepX;
  }
  mlr(view) {
    super.mlr(view);
    xy(view, this.jlr_1, this.klr_1);
    this.jlr_1 = this.jlr_1 + (view.pig() + this.llr_1);
  }
  flr() {
    var tmp0_safe_receiver = this.wlb_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k9i_1;
    var fullHeight = tmp1_elvis_lhs == null ? this.xlb_1.x9z() : tmp1_elvis_lhs;
    var _iterator__ex2g4s = this.xlb_1.xi1_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var view = _iterator__ex2g4s.r1();
      view.sif((fullHeight - view.rig()) / 2);
    }
  }
}
class DialogCancelIcon extends Container {
  constructor(icon, height, onCancel) {
    return new.target.dlx(icon, height, onCancel);
  }
  static dlx(icon, height, onCancel) {
    height = height === VOID ? get_gameLayout().tl5_1 : height;
    var $this = this.fi2();
    $this.alx_1 = false;
    $this.blx_1 = null;
    $this.sig(0.2);
    addTo(toHeight(Image.lk7(icon), height), $this);
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    var tmp0 = get_mouse($this);
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var handler = DialogCancelIcon$slambda(onCancel);
    var tmp = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_0 = getPropertyCallableRef('click', 1, tmp, MouseEvents$_get_click_$ref_klwzrm(), null).get(tmp0);
    tmp_0.v9y(DialogCancelIcon$lambda(tmp0, handler));
    return $this;
  }
  *clx(shown, $completion) {
    if (this.alx_1 === shown)
      return Unit_instance;
    this.alx_1 = shown;
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.od();
    var currentJob = get_job(tmp$ret$0);
    var tmp0_safe_receiver = this.blx_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (!(tmp0_safe_receiver === currentJob)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else
      yield* cancelAndJoin(tmp1_safe_receiver, $completion);
    this.blx_1 = currentJob;
    this.thy(shown);
    try {
      if (get_gameConfiguration().olc_1) {
        this.sig(shown ? 1.0 : 0.2);
      } else {
        var tmp_1 = KMutableProperty0;
        var tmp_2 = DialogCancelIcon$_get_alpha_$ref_w2lfvd(this);
        var tmp0 = getPropertyCallableRef('alpha', 0, tmp_1, tmp_2, DialogCancelIcon$_set_alpha_$ref_2rqzgt(this));
        var tmp2 = this.tig();
        // Inline function 'korlibs.korge.tween.get' call
        var end = shown ? 1.0 : 0.2;
        var tmp$ret$4 = new V2(tmp0, tmp2, end, _interpolate$ref(), true);
        yield* tween(this, [tmp$ret$4], get_gameAnimations().rl4_1, get_gameAnimations().ll4_1, VOID, VOID, VOID, VOID, $completion);
      }
      if (!shown && !this.alx_1) {
        this.sig(0.2);
      }
    }finally {
      if (this.blx_1 === currentJob)
        this.blx_1 = null;
    }
    return Unit_instance;
  }
}
class GameAnimationParams {
  constructor(generalEasing, supplyToCenter, centerToCharacter, betweenSupplying, movement, dialogShowAnimation, dialogCancelIconAnimation, notificationComingAnimation, notificationWaitingAnimation, notificationDisappearingAnimation, upgradePulseAnimation, upgradePinAnimation, upgradeWaitAfter, sidePanelElementShowAnimation, autoCursorShowTime, pingHighlightPulse, pingReapplyTimeout, slowPulseDuration) {
    generalEasing = generalEasing === VOID ? get_EASE_IN_OUT(Companion_getInstance_14()) : generalEasing;
    var tmp;
    if (supplyToCenter === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp = supplyToCenter;
    }
    supplyToCenter = tmp;
    var tmp_0;
    if (centerToCharacter === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_0 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_0 = centerToCharacter;
    }
    centerToCharacter = tmp_0;
    var tmp_1;
    if (betweenSupplying === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_1 = betweenSupplying;
    }
    betweenSupplying = tmp_1;
    var tmp_2;
    if (movement === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_2 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_2 = movement;
    }
    movement = tmp_2;
    var tmp_3;
    if (dialogShowAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_3 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_3 = dialogShowAnimation;
    }
    dialogShowAnimation = tmp_3;
    var tmp_4;
    if (dialogCancelIconAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_4 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_4 = dialogCancelIconAnimation;
    }
    dialogCancelIconAnimation = tmp_4;
    var tmp_5;
    if (notificationComingAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_5 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_5 = notificationComingAnimation;
    }
    notificationComingAnimation = tmp_5;
    var tmp_6;
    if (notificationWaitingAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_6 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_6 = notificationWaitingAnimation;
    }
    notificationWaitingAnimation = tmp_6;
    var tmp_7;
    if (notificationDisappearingAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_7 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_7 = notificationDisappearingAnimation;
    }
    notificationDisappearingAnimation = tmp_7;
    var tmp_8;
    if (upgradePulseAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_8 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_8 = upgradePulseAnimation;
    }
    upgradePulseAnimation = tmp_8;
    var tmp_9;
    if (upgradePinAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_9 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_9 = upgradePinAnimation;
    }
    upgradePinAnimation = tmp_9;
    var tmp_10;
    if (upgradeWaitAfter === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_10 = toDuration(1500, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_10 = upgradeWaitAfter;
    }
    upgradeWaitAfter = tmp_10;
    var tmp_11;
    if (sidePanelElementShowAnimation === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_11 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_11 = sidePanelElementShowAnimation;
    }
    sidePanelElementShowAnimation = tmp_11;
    var tmp_12;
    if (autoCursorShowTime === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_12 = toDuration(150, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_12 = autoCursorShowTime;
    }
    autoCursorShowTime = tmp_12;
    var tmp_13;
    if (pingHighlightPulse === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_13 = toDuration(250, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_13 = pingHighlightPulse;
    }
    pingHighlightPulse = tmp_13;
    var tmp_14;
    if (pingReapplyTimeout === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_14 = toDuration(4000, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_14 = pingReapplyTimeout;
    }
    pingReapplyTimeout = tmp_14;
    var tmp_15;
    if (slowPulseDuration === VOID) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_15 = toDuration(1500, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_15 = slowPulseDuration;
    }
    slowPulseDuration = tmp_15;
    this.ll4_1 = generalEasing;
    this.ml4_1 = supplyToCenter;
    this.nl4_1 = centerToCharacter;
    this.ol4_1 = betweenSupplying;
    this.pl4_1 = movement;
    this.ql4_1 = dialogShowAnimation;
    this.rl4_1 = dialogCancelIconAnimation;
    this.sl4_1 = notificationComingAnimation;
    this.tl4_1 = notificationWaitingAnimation;
    this.ul4_1 = notificationDisappearingAnimation;
    this.vl4_1 = upgradePulseAnimation;
    this.wl4_1 = upgradePinAnimation;
    this.xl4_1 = upgradeWaitAfter;
    this.yl4_1 = sidePanelElementShowAnimation;
    this.zl4_1 = autoCursorShowTime;
    this.al5_1 = pingHighlightPulse;
    this.bl5_1 = pingReapplyTimeout;
    this.cl5_1 = slowPulseDuration;
  }
  toString() {
    return 'GameAnimationParams(generalEasing=' + toString(this.ll4_1) + ', supplyToCenter=' + Duration__toString_impl_8d916b(this.ml4_1) + ', centerToCharacter=' + Duration__toString_impl_8d916b(this.nl4_1) + ', betweenSupplying=' + Duration__toString_impl_8d916b(this.ol4_1) + ', movement=' + Duration__toString_impl_8d916b(this.pl4_1) + ', dialogShowAnimation=' + Duration__toString_impl_8d916b(this.ql4_1) + ', dialogCancelIconAnimation=' + Duration__toString_impl_8d916b(this.rl4_1) + ', notificationComingAnimation=' + Duration__toString_impl_8d916b(this.sl4_1) + ', notificationWaitingAnimation=' + Duration__toString_impl_8d916b(this.tl4_1) + ', notificationDisappearingAnimation=' + Duration__toString_impl_8d916b(this.ul4_1) + ', upgradePulseAnimation=' + Duration__toString_impl_8d916b(this.vl4_1) + ', upgradePinAnimation=' + Duration__toString_impl_8d916b(this.wl4_1) + ', upgradeWaitAfter=' + Duration__toString_impl_8d916b(this.xl4_1) + ', sidePanelElementShowAnimation=' + Duration__toString_impl_8d916b(this.yl4_1) + ', autoCursorShowTime=' + Duration__toString_impl_8d916b(this.zl4_1) + ', pingHighlightPulse=' + Duration__toString_impl_8d916b(this.al5_1) + ', pingReapplyTimeout=' + Duration__toString_impl_8d916b(this.bl5_1) + ', slowPulseDuration=' + Duration__toString_impl_8d916b(this.cl5_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.ll4_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.ml4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.nl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.ol4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.pl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.ql4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.rl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.sl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.tl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.ul4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.vl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.wl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.xl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.yl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.zl4_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.al5_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.bl5_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.cl5_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameAnimationParams))
      return false;
    if (!equals(this.ll4_1, other.ll4_1))
      return false;
    if (!equals(this.ml4_1, other.ml4_1))
      return false;
    if (!equals(this.nl4_1, other.nl4_1))
      return false;
    if (!equals(this.ol4_1, other.ol4_1))
      return false;
    if (!equals(this.pl4_1, other.pl4_1))
      return false;
    if (!equals(this.ql4_1, other.ql4_1))
      return false;
    if (!equals(this.rl4_1, other.rl4_1))
      return false;
    if (!equals(this.sl4_1, other.sl4_1))
      return false;
    if (!equals(this.tl4_1, other.tl4_1))
      return false;
    if (!equals(this.ul4_1, other.ul4_1))
      return false;
    if (!equals(this.vl4_1, other.vl4_1))
      return false;
    if (!equals(this.wl4_1, other.wl4_1))
      return false;
    if (!equals(this.xl4_1, other.xl4_1))
      return false;
    if (!equals(this.yl4_1, other.yl4_1))
      return false;
    if (!equals(this.zl4_1, other.zl4_1))
      return false;
    if (!equals(this.al5_1, other.al5_1))
      return false;
    if (!equals(this.bl5_1, other.bl5_1))
      return false;
    if (!equals(this.cl5_1, other.cl5_1))
      return false;
    return true;
  }
}
class ScreenSwitchMode extends Enum {}
class GameColors {
  constructor(panelBackgrounds, notificationForeground, statementBackground, upgradeTriggerBackground, dialogFrameBackground, dialogBackground, dialogStroke, upgradePinColor, auxiliaryDialogsBackground) {
    panelBackgrounds = panelBackgrounds === VOID ? Companion_getInstance_15().pci(50, 50, 50) : panelBackgrounds;
    notificationForeground = notificationForeground === VOID ? Colors_getInstance().zc2_1 : notificationForeground;
    statementBackground = statementBackground === VOID ? Colors_getInstance().dc3_1 : statementBackground;
    upgradeTriggerBackground = upgradeTriggerBackground === VOID ? Colors_getInstance().pc3_1 : upgradeTriggerBackground;
    dialogFrameBackground = dialogFrameBackground === VOID ? Companion_getInstance_15().ich(100, 100, 100, 100) : dialogFrameBackground;
    dialogBackground = dialogBackground === VOID ? Companion_getInstance_15().ich(50, 50, 50, 230) : dialogBackground;
    dialogStroke = dialogStroke === VOID ? Colors_getInstance().zc2_1 : dialogStroke;
    upgradePinColor = upgradePinColor === VOID ? RGBA__withAd_impl_cralao(Colors_getInstance().pc3_1, 0.8) : upgradePinColor;
    auxiliaryDialogsBackground = auxiliaryDialogsBackground === VOID ? Colors_getInstance().qci('#14413c') : auxiliaryDialogsBackground;
    this.qlx_1 = panelBackgrounds;
    this.rlx_1 = notificationForeground;
    this.slx_1 = statementBackground;
    this.tlx_1 = upgradeTriggerBackground;
    this.ulx_1 = dialogFrameBackground;
    this.vlx_1 = dialogBackground;
    this.wlx_1 = dialogStroke;
    this.xlx_1 = upgradePinColor;
    this.ylx_1 = auxiliaryDialogsBackground;
  }
  toString() {
    return 'GameColors(panelBackgrounds=' + RGBA__toString_impl_4lw6dp(this.qlx_1) + ', notificationForeground=' + RGBA__toString_impl_4lw6dp(this.rlx_1) + ', statementBackground=' + RGBA__toString_impl_4lw6dp(this.slx_1) + ', upgradeTriggerBackground=' + RGBA__toString_impl_4lw6dp(this.tlx_1) + ', dialogFrameBackground=' + RGBA__toString_impl_4lw6dp(this.ulx_1) + ', dialogBackground=' + RGBA__toString_impl_4lw6dp(this.vlx_1) + ', dialogStroke=' + RGBA__toString_impl_4lw6dp(this.wlx_1) + ', upgradePinColor=' + RGBA__toString_impl_4lw6dp(this.xlx_1) + ', auxiliaryDialogsBackground=' + RGBA__toString_impl_4lw6dp(this.ylx_1) + ')';
  }
  hashCode() {
    var result = RGBA__hashCode_impl_h59qf6(this.qlx_1);
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.rlx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.slx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.tlx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.ulx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.vlx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.wlx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.xlx_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.ylx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameColors))
      return false;
    if (!(this.qlx_1 === other.qlx_1))
      return false;
    if (!(this.rlx_1 === other.rlx_1))
      return false;
    if (!(this.slx_1 === other.slx_1))
      return false;
    if (!(this.tlx_1 === other.tlx_1))
      return false;
    if (!(this.ulx_1 === other.ulx_1))
      return false;
    if (!(this.vlx_1 === other.vlx_1))
      return false;
    if (!(this.wlx_1 === other.wlx_1))
      return false;
    if (!(this.xlx_1 === other.xlx_1))
      return false;
    if (!(this.ylx_1 === other.ylx_1))
      return false;
    return true;
  }
}
class GameConfiguration {
  constructor(localGameMode, availableFeatures, isGuest, availableLocalGameModes, allowedExpansions, recordingGameModeAvailable, serverDrivenConfiguration, diagnostics, links, isFullScreenBeast, isOfflineReplay, globalStartReplayFromStart, replaySwitchingMode, isWaitingForStartReplayMode, needShowControlsAndHighlightingsInReplay, disableAllAnimations, alwaysPlayPrecisely, justPrintOnboardingTextsMode, isOnboardingMode, globalGameFlowListener, supportedContracts, problemReporter, needShowMenuButton, holdNewCardsInCenter, stateLogging, playHotSeatGame, playLoadingHotSeatGame, useFullSandboxSetup, enableRecoveryTestContent, sandboxGameManager, offlineReplayGameManager, anotherAnswerReaction) {
    localGameMode = localGameMode === VOID ? null : localGameMode;
    availableFeatures = availableFeatures === VOID ? toSet(get_entries_4()) : availableFeatures;
    isGuest = isGuest === VOID ? false : isGuest;
    availableLocalGameModes = availableLocalGameModes === VOID ? toSet(get_entries_8()) : availableLocalGameModes;
    allowedExpansions = allowedExpansions === VOID ? toSet(get_entries()) : allowedExpansions;
    recordingGameModeAvailable = recordingGameModeAvailable === VOID ? true : recordingGameModeAvailable;
    serverDrivenConfiguration = serverDrivenConfiguration === VOID ? null : serverDrivenConfiguration;
    var tmp;
    if (diagnostics === VOID) {
      tmp = serverDrivenConfiguration == null ? PrintingGameRuntimeDiagnostics_instance : serverDrivenConfiguration;
    } else {
      tmp = diagnostics;
    }
    diagnostics = tmp;
    links = links === VOID ? new ClientLinks() : links;
    isFullScreenBeast = isFullScreenBeast === VOID ? false : isFullScreenBeast;
    isOfflineReplay = isOfflineReplay === VOID ? false : isOfflineReplay;
    globalStartReplayFromStart = globalStartReplayFromStart === VOID ? false : globalStartReplayFromStart;
    replaySwitchingMode = replaySwitchingMode === VOID ? ScreenSwitchMode_SWITCH_SIDES_getInstance() : replaySwitchingMode;
    isWaitingForStartReplayMode = isWaitingForStartReplayMode === VOID ? false : isWaitingForStartReplayMode;
    needShowControlsAndHighlightingsInReplay = needShowControlsAndHighlightingsInReplay === VOID ? true : needShowControlsAndHighlightingsInReplay;
    disableAllAnimations = disableAllAnimations === VOID ? false : disableAllAnimations;
    alwaysPlayPrecisely = alwaysPlayPrecisely === VOID ? false : alwaysPlayPrecisely;
    justPrintOnboardingTextsMode = justPrintOnboardingTextsMode === VOID ? false : justPrintOnboardingTextsMode;
    isOnboardingMode = isOnboardingMode === VOID ? false : isOnboardingMode;
    globalGameFlowListener = globalGameFlowListener === VOID ? EmptyListener_instance : globalGameFlowListener;
    supportedContracts = supportedContracts === VOID ? listOf([GreatCleansingContract.j5f(Companion_getInstance_3().e3a_1), AttackOnTheNorthernSettlementsContract.s3f(Companion_getInstance_3().e3a_1), AshfallUnlikelyAllianceContract.u3d(Companion_getInstance_3().e3a_1), DisturbanceOfTheNorthernGodsContract.g3t(Companion_getInstance_3().e3a_1), ArrivalOfTheTitanContract.d3a(Companion_getInstance_3().e3a_1), RegentOfRuinsContract.i60(Companion_getInstance_3().e3a_1), ShipwreckContract.i65(Companion_getInstance_3().e3a_1), SecretsFromALostAgeContract.x64(Companion_getInstance_3().e3a_1), UnleashingTheAbyssContract.n69(Companion_getInstance_3().e3a_1), UnlikelyAllianceContract.y69(Companion_getInstance_3().e3a_1), PactLongForgottenContract.l5w(Companion_getInstance_3().e3a_1)]) : supportedContracts;
    problemReporter = problemReporter === VOID ? new DefaultProblemReporter() : problemReporter;
    needShowMenuButton = needShowMenuButton === VOID ? true : needShowMenuButton;
    holdNewCardsInCenter = holdNewCardsInCenter === VOID ? false : holdNewCardsInCenter;
    stateLogging = stateLogging === VOID ? EmptyKorgeStateLogging_instance : stateLogging;
    playHotSeatGame = playHotSeatGame === VOID ? null : playHotSeatGame;
    playLoadingHotSeatGame = playLoadingHotSeatGame === VOID ? null : playLoadingHotSeatGame;
    useFullSandboxSetup = useFullSandboxSetup === VOID ? true : useFullSandboxSetup;
    enableRecoveryTestContent = enableRecoveryTestContent === VOID ? false : enableRecoveryTestContent;
    sandboxGameManager = sandboxGameManager === VOID ? null : sandboxGameManager;
    offlineReplayGameManager = offlineReplayGameManager === VOID ? null : offlineReplayGameManager;
    anotherAnswerReaction = anotherAnswerReaction === VOID ? AnotherAnswerReaction_ReshowVariants_getInstance() : anotherAnswerReaction;
    this.zlb_1 = localGameMode;
    this.alc_1 = availableFeatures;
    this.blc_1 = isGuest;
    this.clc_1 = availableLocalGameModes;
    this.dlc_1 = allowedExpansions;
    this.elc_1 = recordingGameModeAvailable;
    this.flc_1 = serverDrivenConfiguration;
    this.glc_1 = diagnostics;
    this.hlc_1 = links;
    this.ilc_1 = isFullScreenBeast;
    this.jlc_1 = isOfflineReplay;
    this.klc_1 = globalStartReplayFromStart;
    this.llc_1 = replaySwitchingMode;
    this.mlc_1 = isWaitingForStartReplayMode;
    this.nlc_1 = needShowControlsAndHighlightingsInReplay;
    this.olc_1 = disableAllAnimations;
    this.plc_1 = alwaysPlayPrecisely;
    this.qlc_1 = justPrintOnboardingTextsMode;
    this.rlc_1 = isOnboardingMode;
    this.slc_1 = globalGameFlowListener;
    this.tlc_1 = supportedContracts;
    this.ulc_1 = problemReporter;
    this.vlc_1 = needShowMenuButton;
    this.wlc_1 = holdNewCardsInCenter;
    this.xlc_1 = stateLogging;
    this.ylc_1 = playHotSeatGame;
    this.zlc_1 = playLoadingHotSeatGame;
    this.ald_1 = useFullSandboxSetup;
    this.bld_1 = enableRecoveryTestContent;
    this.cld_1 = sandboxGameManager;
    this.dld_1 = offlineReplayGameManager;
    this.eld_1 = anotherAnswerReaction;
  }
  omh() {
    return plus(this.tlc_1, this.bld_1 ? listOf_0(RecoveryTestContract.i5y()) : emptyList());
  }
  mll() {
    return this.zlb_1 == null || setOf_0([LocalGameMode_Sandbox_getInstance(), LocalGameMode_HotSeat_getInstance(), LocalGameMode_ReplayRecording_getInstance()]).w2(this.zlb_1);
  }
  vlt(feature) {
    return this.alc_1.w2(feature);
  }
  wlt(mode) {
    return equals(this.zlb_1, mode) || this.clc_1.w2(mode);
  }
  tmw(localGameMode, availableFeatures, isGuest, availableLocalGameModes, allowedExpansions, recordingGameModeAvailable, serverDrivenConfiguration, diagnostics, links, isFullScreenBeast, isOfflineReplay, globalStartReplayFromStart, replaySwitchingMode, isWaitingForStartReplayMode, needShowControlsAndHighlightingsInReplay, disableAllAnimations, alwaysPlayPrecisely, justPrintOnboardingTextsMode, isOnboardingMode, globalGameFlowListener, supportedContracts, problemReporter, needShowMenuButton, holdNewCardsInCenter, stateLogging, playHotSeatGame, playLoadingHotSeatGame, useFullSandboxSetup, enableRecoveryTestContent, sandboxGameManager, offlineReplayGameManager, anotherAnswerReaction) {
    return new GameConfiguration(localGameMode, availableFeatures, isGuest, availableLocalGameModes, allowedExpansions, recordingGameModeAvailable, serverDrivenConfiguration, diagnostics, links, isFullScreenBeast, isOfflineReplay, globalStartReplayFromStart, replaySwitchingMode, isWaitingForStartReplayMode, needShowControlsAndHighlightingsInReplay, disableAllAnimations, alwaysPlayPrecisely, justPrintOnboardingTextsMode, isOnboardingMode, globalGameFlowListener, supportedContracts, problemReporter, needShowMenuButton, holdNewCardsInCenter, stateLogging, playHotSeatGame, playLoadingHotSeatGame, useFullSandboxSetup, enableRecoveryTestContent, sandboxGameManager, offlineReplayGameManager, anotherAnswerReaction);
  }
  glr(localGameMode, availableFeatures, isGuest, availableLocalGameModes, allowedExpansions, recordingGameModeAvailable, serverDrivenConfiguration, diagnostics, links, isFullScreenBeast, isOfflineReplay, globalStartReplayFromStart, replaySwitchingMode, isWaitingForStartReplayMode, needShowControlsAndHighlightingsInReplay, disableAllAnimations, alwaysPlayPrecisely, justPrintOnboardingTextsMode, isOnboardingMode, globalGameFlowListener, supportedContracts, problemReporter, needShowMenuButton, holdNewCardsInCenter, stateLogging, playHotSeatGame, playLoadingHotSeatGame, useFullSandboxSetup, enableRecoveryTestContent, sandboxGameManager, offlineReplayGameManager, anotherAnswerReaction, $super) {
    localGameMode = localGameMode === VOID ? this.zlb_1 : localGameMode;
    availableFeatures = availableFeatures === VOID ? this.alc_1 : availableFeatures;
    isGuest = isGuest === VOID ? this.blc_1 : isGuest;
    availableLocalGameModes = availableLocalGameModes === VOID ? this.clc_1 : availableLocalGameModes;
    allowedExpansions = allowedExpansions === VOID ? this.dlc_1 : allowedExpansions;
    recordingGameModeAvailable = recordingGameModeAvailable === VOID ? this.elc_1 : recordingGameModeAvailable;
    serverDrivenConfiguration = serverDrivenConfiguration === VOID ? this.flc_1 : serverDrivenConfiguration;
    diagnostics = diagnostics === VOID ? this.glc_1 : diagnostics;
    links = links === VOID ? this.hlc_1 : links;
    isFullScreenBeast = isFullScreenBeast === VOID ? this.ilc_1 : isFullScreenBeast;
    isOfflineReplay = isOfflineReplay === VOID ? this.jlc_1 : isOfflineReplay;
    globalStartReplayFromStart = globalStartReplayFromStart === VOID ? this.klc_1 : globalStartReplayFromStart;
    replaySwitchingMode = replaySwitchingMode === VOID ? this.llc_1 : replaySwitchingMode;
    isWaitingForStartReplayMode = isWaitingForStartReplayMode === VOID ? this.mlc_1 : isWaitingForStartReplayMode;
    needShowControlsAndHighlightingsInReplay = needShowControlsAndHighlightingsInReplay === VOID ? this.nlc_1 : needShowControlsAndHighlightingsInReplay;
    disableAllAnimations = disableAllAnimations === VOID ? this.olc_1 : disableAllAnimations;
    alwaysPlayPrecisely = alwaysPlayPrecisely === VOID ? this.plc_1 : alwaysPlayPrecisely;
    justPrintOnboardingTextsMode = justPrintOnboardingTextsMode === VOID ? this.qlc_1 : justPrintOnboardingTextsMode;
    isOnboardingMode = isOnboardingMode === VOID ? this.rlc_1 : isOnboardingMode;
    globalGameFlowListener = globalGameFlowListener === VOID ? this.slc_1 : globalGameFlowListener;
    supportedContracts = supportedContracts === VOID ? this.tlc_1 : supportedContracts;
    problemReporter = problemReporter === VOID ? this.ulc_1 : problemReporter;
    needShowMenuButton = needShowMenuButton === VOID ? this.vlc_1 : needShowMenuButton;
    holdNewCardsInCenter = holdNewCardsInCenter === VOID ? this.wlc_1 : holdNewCardsInCenter;
    stateLogging = stateLogging === VOID ? this.xlc_1 : stateLogging;
    playHotSeatGame = playHotSeatGame === VOID ? this.ylc_1 : playHotSeatGame;
    playLoadingHotSeatGame = playLoadingHotSeatGame === VOID ? this.zlc_1 : playLoadingHotSeatGame;
    useFullSandboxSetup = useFullSandboxSetup === VOID ? this.ald_1 : useFullSandboxSetup;
    enableRecoveryTestContent = enableRecoveryTestContent === VOID ? this.bld_1 : enableRecoveryTestContent;
    sandboxGameManager = sandboxGameManager === VOID ? this.cld_1 : sandboxGameManager;
    offlineReplayGameManager = offlineReplayGameManager === VOID ? this.dld_1 : offlineReplayGameManager;
    anotherAnswerReaction = anotherAnswerReaction === VOID ? this.eld_1 : anotherAnswerReaction;
    return $super === VOID ? this.tmw(localGameMode, availableFeatures, isGuest, availableLocalGameModes, allowedExpansions, recordingGameModeAvailable, serverDrivenConfiguration, diagnostics, links, isFullScreenBeast, isOfflineReplay, globalStartReplayFromStart, replaySwitchingMode, isWaitingForStartReplayMode, needShowControlsAndHighlightingsInReplay, disableAllAnimations, alwaysPlayPrecisely, justPrintOnboardingTextsMode, isOnboardingMode, globalGameFlowListener, supportedContracts, problemReporter, needShowMenuButton, holdNewCardsInCenter, stateLogging, playHotSeatGame, playLoadingHotSeatGame, useFullSandboxSetup, enableRecoveryTestContent, sandboxGameManager, offlineReplayGameManager, anotherAnswerReaction) : $super.tmw.call(this, localGameMode, availableFeatures, isGuest, availableLocalGameModes, allowedExpansions, recordingGameModeAvailable, serverDrivenConfiguration, diagnostics, links, isFullScreenBeast, isOfflineReplay, globalStartReplayFromStart, replaySwitchingMode, isWaitingForStartReplayMode, needShowControlsAndHighlightingsInReplay, disableAllAnimations, alwaysPlayPrecisely, justPrintOnboardingTextsMode, isOnboardingMode, globalGameFlowListener, supportedContracts, problemReporter, needShowMenuButton, holdNewCardsInCenter, stateLogging, playHotSeatGame, playLoadingHotSeatGame, useFullSandboxSetup, enableRecoveryTestContent, sandboxGameManager, offlineReplayGameManager, anotherAnswerReaction);
  }
  toString() {
    return 'GameConfiguration(localGameMode=' + toString_0(this.zlb_1) + ', availableFeatures=' + toString(this.alc_1) + ', isGuest=' + this.blc_1 + ', availableLocalGameModes=' + toString(this.clc_1) + ', allowedExpansions=' + toString(this.dlc_1) + ', recordingGameModeAvailable=' + this.elc_1 + ', serverDrivenConfiguration=' + toString_0(this.flc_1) + ', diagnostics=' + toString(this.glc_1) + ', links=' + this.hlc_1.toString() + ', isFullScreenBeast=' + this.ilc_1 + ', isOfflineReplay=' + this.jlc_1 + ', globalStartReplayFromStart=' + this.klc_1 + ', replaySwitchingMode=' + this.llc_1.toString() + ', isWaitingForStartReplayMode=' + this.mlc_1 + ', needShowControlsAndHighlightingsInReplay=' + this.nlc_1 + ', disableAllAnimations=' + this.olc_1 + ', alwaysPlayPrecisely=' + this.plc_1 + ', justPrintOnboardingTextsMode=' + this.qlc_1 + ', isOnboardingMode=' + this.rlc_1 + ', globalGameFlowListener=' + toString(this.slc_1) + ', supportedContracts=' + toString(this.tlc_1) + ', problemReporter=' + toString(this.ulc_1) + ', needShowMenuButton=' + this.vlc_1 + ', holdNewCardsInCenter=' + this.wlc_1 + ', stateLogging=' + toString(this.xlc_1) + ', playHotSeatGame=' + toString_0(this.ylc_1) + ', playLoadingHotSeatGame=' + toString_0(this.zlc_1) + ', useFullSandboxSetup=' + this.ald_1 + ', enableRecoveryTestContent=' + this.bld_1 + ', sandboxGameManager=' + toString_0(this.cld_1) + ', offlineReplayGameManager=' + toString_0(this.dld_1) + ', anotherAnswerReaction=' + this.eld_1.toString() + ')';
  }
  hashCode() {
    var result = this.zlb_1 == null ? 0 : this.zlb_1.hashCode();
    result = imul(result, 31) + hashCode(this.alc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.blc_1) | 0;
    result = imul(result, 31) + hashCode(this.clc_1) | 0;
    result = imul(result, 31) + hashCode(this.dlc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.elc_1) | 0;
    result = imul(result, 31) + (this.flc_1 == null ? 0 : hashCode(this.flc_1)) | 0;
    result = imul(result, 31) + hashCode(this.glc_1) | 0;
    result = imul(result, 31) + this.hlc_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ilc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jlc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.klc_1) | 0;
    result = imul(result, 31) + this.llc_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mlc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.nlc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.olc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.plc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qlc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.rlc_1) | 0;
    result = imul(result, 31) + hashCode(this.slc_1) | 0;
    result = imul(result, 31) + hashCode(this.tlc_1) | 0;
    result = imul(result, 31) + hashCode(this.ulc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vlc_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wlc_1) | 0;
    result = imul(result, 31) + hashCode(this.xlc_1) | 0;
    result = imul(result, 31) + (this.ylc_1 == null ? 0 : hashCode(this.ylc_1)) | 0;
    result = imul(result, 31) + (this.zlc_1 == null ? 0 : hashCode(this.zlc_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ald_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bld_1) | 0;
    result = imul(result, 31) + (this.cld_1 == null ? 0 : hashCode(this.cld_1)) | 0;
    result = imul(result, 31) + (this.dld_1 == null ? 0 : hashCode(this.dld_1)) | 0;
    result = imul(result, 31) + this.eld_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameConfiguration))
      return false;
    if (!equals(this.zlb_1, other.zlb_1))
      return false;
    if (!equals(this.alc_1, other.alc_1))
      return false;
    if (!(this.blc_1 === other.blc_1))
      return false;
    if (!equals(this.clc_1, other.clc_1))
      return false;
    if (!equals(this.dlc_1, other.dlc_1))
      return false;
    if (!(this.elc_1 === other.elc_1))
      return false;
    if (!equals(this.flc_1, other.flc_1))
      return false;
    if (!equals(this.glc_1, other.glc_1))
      return false;
    if (!this.hlc_1.equals(other.hlc_1))
      return false;
    if (!(this.ilc_1 === other.ilc_1))
      return false;
    if (!(this.jlc_1 === other.jlc_1))
      return false;
    if (!(this.klc_1 === other.klc_1))
      return false;
    if (!this.llc_1.equals(other.llc_1))
      return false;
    if (!(this.mlc_1 === other.mlc_1))
      return false;
    if (!(this.nlc_1 === other.nlc_1))
      return false;
    if (!(this.olc_1 === other.olc_1))
      return false;
    if (!(this.plc_1 === other.plc_1))
      return false;
    if (!(this.qlc_1 === other.qlc_1))
      return false;
    if (!(this.rlc_1 === other.rlc_1))
      return false;
    if (!equals(this.slc_1, other.slc_1))
      return false;
    if (!equals(this.tlc_1, other.tlc_1))
      return false;
    if (!equals(this.ulc_1, other.ulc_1))
      return false;
    if (!(this.vlc_1 === other.vlc_1))
      return false;
    if (!(this.wlc_1 === other.wlc_1))
      return false;
    if (!equals(this.xlc_1, other.xlc_1))
      return false;
    if (!equals(this.ylc_1, other.ylc_1))
      return false;
    if (!equals(this.zlc_1, other.zlc_1))
      return false;
    if (!(this.ald_1 === other.ald_1))
      return false;
    if (!(this.bld_1 === other.bld_1))
      return false;
    if (!equals(this.cld_1, other.cld_1))
      return false;
    if (!equals(this.dld_1, other.dld_1))
      return false;
    if (!this.eld_1.equals(other.eld_1))
      return false;
    return true;
  }
}
class LocalGameMode extends Enum {}
class DefaultProblemReporter {
  *jls(message, $completion) {
    println('Problem: ' + message);
    return Unit_instance;
  }
}
class GameDialog {
  constructor(frame, dialogContent, onClickOnEmpty) {
    return new.target.mlt(frame, dialogContent, onClickOnEmpty);
  }
  static mlt(frame, dialogContent, onClickOnEmpty) {
    var tmp;
    if (onClickOnEmpty === VOID) {
      tmp = GameDialog$_init_$slambda_h5cqsy();
    } else {
      tmp = onClickOnEmpty;
    }
    onClickOnEmpty = tmp;
    var $this = createThis(this);
    $this.flq_1 = frame;
    $this.glq_1 = dialogContent;
    $this.hlq_1 = onClickOnEmpty;
    $this.ilq_1 = get_gameLayout().pl5_1;
    $this.nlq_1 = MutableStateFlow(false);
    $this.olq_1 = null;
    $this.plq_1 = null;
    return $this;
  }
  static xlq(frame, content, message, onClickOnEmpty) {
    message = message === VOID ? null : message;
    var tmp;
    if (onClickOnEmpty === VOID) {
      tmp = GameDialog$_init_$slambda_h5cqsy_0();
    } else {
      tmp = onClickOnEmpty;
    }
    onClickOnEmpty = tmp;
    return this.mlt(frame, DialogContent.cmg(content, dialogCornerText(message)), onClickOnEmpty);
  }
  s2f() {
    return this.glq_1.elt_1;
  }
  ymw() {
    var tmp = this.klq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('contentContainer');
    }
  }
  ylt() {
    var tmp = this.llq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('roundRectAroundContent');
    }
  }
  umq() {
    var tmp = this.mlq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('dialogContainer');
    }
  }
  kmi() {
    return this.nlq_1.k3();
  }
  *oml(message, $completion) {
    return yield* coroutineScope(GameDialog$awaitUntilNotShown$slambda(message, this), $completion);
  }
  hmo(message, $completion, $super) {
    message = message === VOID ? null : message;
    return $super === VOID ? this.oml(message, $completion) : $super.oml.call(this, message, $completion);
  }
  ylq() {
    this.nlq_1.p25(true);
    this.mlq_1 = createDialog(this, false);
    addTo(this.umq(), this.flq_1);
  }
  *vma($completion) {
    if (get_gameConfiguration().olc_1) {
      this.ylq();
      return Unit_instance;
    }
    this.nlq_1.p25(true);
    this.mlq_1 = createDialog(this, true);
    addTo(this.umq(), this.flq_1);
    yield* coroutineScope(GameDialog$animateInstall$slambda(this), $completion);
    return Unit_instance;
  }
  *tmq(anotherDialog, $completion) {
    this.mlq_1 = createDialog(this, false);
    var tmp = anotherDialog.s2f();
    var tmp0 = anotherDialog.s2f();
    var tmp_0 = KMutableProperty0;
    var tmp_1 = View$_get_alpha_$ref_oftner(tmp0);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp_0, tmp_1, View$_set_alpha_$ref_4v0szt(tmp0));
    var tmp_2 = [new V2(this_0, 1.0, 0.0, _interpolate$ref(), true)];
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(50, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp, tmp_2, tmp$ret$1, VOID, VOID, VOID, VOID, VOID, $completion);
    var tmp_3 = anotherDialog.ymw();
    var tmp0_0 = anotherDialog.ymw();
    var tmp_4 = KMutableProperty0;
    var tmp_5 = View$_get_pos_$ref_lp2nil(tmp0_0);
    var tmp_6 = get(getPropertyCallableRef('pos', 0, tmp_4, tmp_5, View$_set_pos_$ref_npt43j(tmp0_0)), anotherDialog.ymw().wb5(), this.ymw().wb5());
    var tmp0_1 = anotherDialog.ylt();
    var tmp_7 = KMutableProperty0;
    var tmp_8 = RoundRect$_get_size_$ref_djl5fv(tmp0_1);
    var tmp_9 = [tmp_6, get_0(getPropertyCallableRef('size', 0, tmp_7, tmp_8, RoundRect$_set_size_$ref_qchgwn(tmp0_1)), anotherDialog.ylt().s2(), this.ylt().s2())];
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$2 = toDuration(150, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp_3, tmp_9, tmp$ret$2, VOID, VOID, VOID, VOID, VOID, $completion);
    anotherDialog.qlq();
    this.nlq_1.p25(true);
    addTo(this.umq(), this.flq_1);
    var tmp_10 = this.s2f();
    var tmp0_2 = this.s2f();
    var tmp_11 = KMutableProperty0;
    var tmp_12 = View$_get_alpha_$ref_oftner(tmp0_2);
    // Inline function 'korlibs.korge.tween.get' call
    var this_1 = getPropertyCallableRef('alpha', 0, tmp_11, tmp_12, View$_set_alpha_$ref_4v0szt(tmp0_2));
    var tmp_13 = [new V2(this_1, 0.0, 1.0, _interpolate$ref(), true)];
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$4 = toDuration(150, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp_10, tmp_13, tmp$ret$4, VOID, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }
  *ymo(newDialogContent, $completion) {
    var animate = !get_gameConfiguration().olc_1;
    if (animate) {
      var tmp = this.s2f();
      var tmp0 = this.s2f();
      var tmp_0 = KMutableProperty0;
      var tmp_1 = View$_get_alpha_$ref_oftner(tmp0);
      // Inline function 'korlibs.korge.tween.get' call
      var this_0 = getPropertyCallableRef('alpha', 0, tmp_0, tmp_1, View$_set_alpha_$ref_4v0szt(tmp0));
      var tmp$ret$0 = new V2(this_0, 1.0, 0.0, _interpolate$ref(), true);
      yield* tween(tmp, [tmp$ret$0], get_gameAnimations().ql4_1, VOID, VOID, VOID, VOID, VOID, $completion);
    }
    this.pmh(newDialogContent);
    if (animate) {
      var tmp_2 = this.s2f();
      var tmp0_0 = this.s2f();
      var tmp_3 = KMutableProperty0;
      var tmp_4 = View$_get_alpha_$ref_oftner(tmp0_0);
      // Inline function 'korlibs.korge.tween.get' call
      var this_1 = getPropertyCallableRef('alpha', 0, tmp_3, tmp_4, View$_set_alpha_$ref_4v0szt(tmp0_0));
      var tmp$ret$1 = new V2(this_1, 0.0, 1.0, _interpolate$ref(), true);
      yield* tween(tmp_2, [tmp$ret$1], get_gameAnimations().ql4_1, VOID, VOID, VOID, VOID, VOID, $completion);
    }
    return Unit_instance;
  }
  vmo(newContent, newMessage) {
    this.pmh(DialogContent.llt(newContent, plus_3(this.glq_1.flt_1, to(DialogCorner_LEFT_TOP_getInstance(), dialogCornerText(newMessage))), this.glq_1.glt_1, this.glq_1.hlt_1, this.glq_1.ilt_1, this.glq_1.jlt_1, this.glq_1.klt_1));
  }
  pmh(newDialogContent) {
    this.umq().uih();
    this.glq_1 = newDialogContent;
    this.mlq_1 = createDialog(this, false);
    addTo(this.umq(), this.flq_1);
  }
  qlq() {
    this.nlq_1.p25(false);
    this.flq_1.cif(this.umq());
  }
}
class DialogColoringStyle {
  constructor(fill, stroke, strokeThickness) {
    fill = fill === VOID ? get_gameColors().vlx_1 : fill;
    stroke = stroke === VOID ? get_gameColors().wlx_1 : stroke;
    strokeThickness = strokeThickness === VOID ? get_gameLayout().rl5_1 : strokeThickness;
    this.umw_1 = fill;
    this.vmw_1 = stroke;
    this.wmw_1 = strokeThickness;
  }
  toString() {
    return 'DialogColoringStyle(fill=' + RGBA__toString_impl_4lw6dp(this.umw_1) + ', stroke=' + RGBA__toString_impl_4lw6dp(this.vmw_1) + ', strokeThickness=' + this.wmw_1 + ')';
  }
  hashCode() {
    var result = RGBA__hashCode_impl_h59qf6(this.umw_1);
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.vmw_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wmw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DialogColoringStyle))
      return false;
    if (!(this.umw_1 === other.umw_1))
      return false;
    if (!(this.vmw_1 === other.vmw_1))
      return false;
    if (!equals(this.wmw_1, other.wmw_1))
      return false;
    return true;
  }
}
class DialogContent {
  constructor(content, cornerView, dialogLayout, dialogCornerRadius, dialogColoringStyle, useOutsideShadow, blockOutsideMouse) {
    return new.target.llt(content, cornerView, dialogLayout, dialogCornerRadius, dialogColoringStyle, useOutsideShadow, blockOutsideMouse);
  }
  static llt(content, cornerView, dialogLayout, dialogCornerRadius, dialogColoringStyle, useOutsideShadow, blockOutsideMouse) {
    cornerView = cornerView === VOID ? mapOf(to(DialogCorner_LEFT_TOP_getInstance(), null)) : cornerView;
    dialogLayout = dialogLayout === VOID ? BigCenter_instance : dialogLayout;
    dialogCornerRadius = dialogCornerRadius === VOID ? get_gameLayout().ql5_1 : dialogCornerRadius;
    dialogColoringStyle = dialogColoringStyle === VOID ? get_defaultDialogColoringStyle() : dialogColoringStyle;
    useOutsideShadow = useOutsideShadow === VOID ? true : useOutsideShadow;
    blockOutsideMouse = blockOutsideMouse === VOID ? true : blockOutsideMouse;
    var $this = createThis(this);
    $this.elt_1 = content;
    $this.flt_1 = cornerView;
    $this.glt_1 = dialogLayout;
    $this.hlt_1 = dialogCornerRadius;
    $this.ilt_1 = dialogColoringStyle;
    $this.jlt_1 = useOutsideShadow;
    $this.klt_1 = blockOutsideMouse;
    return $this;
  }
  static cmg(content, cornerView, dialogLayout, dialogCornerRadius, dialogColoringStyle, useOutsideShadow, blockOutsideMouse) {
    dialogLayout = dialogLayout === VOID ? BigCenter_instance : dialogLayout;
    dialogCornerRadius = dialogCornerRadius === VOID ? get_gameLayout().ql5_1 : dialogCornerRadius;
    dialogColoringStyle = dialogColoringStyle === VOID ? get_defaultDialogColoringStyle() : dialogColoringStyle;
    useOutsideShadow = useOutsideShadow === VOID ? true : useOutsideShadow;
    blockOutsideMouse = blockOutsideMouse === VOID ? true : blockOutsideMouse;
    return this.llt(content, mapOf(to(DialogCorner_LEFT_TOP_getInstance(), cornerView)), dialogLayout, dialogCornerRadius, dialogColoringStyle, useOutsideShadow, blockOutsideMouse);
  }
  jmi(corner, view) {
    return DialogContent.llt(this.elt_1, plus_3(this.flt_1, to(corner, view)), this.glt_1, this.hlt_1, this.ilt_1, this.jlt_1, this.klt_1);
  }
}
class DialogCorner extends Enum {}
class BigCenter {}
class BigRightSided {
  constructor(rightOffset) {
    rightOffset = rightOffset === VOID ? get_gameLayout().zl5_1 : rightOffset;
    this.xmw_1 = rightOffset;
  }
  toString() {
    return 'BigRightSided(rightOffset=' + this.xmw_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.xmw_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BigRightSided))
      return false;
    if (!equals(this.xmw_1, other.xmw_1))
      return false;
    return true;
  }
}
class FitContent {
  constructor(marginLeft, marginRight, marginTop, marginBottom, xPlacing, yPlacing) {
    marginLeft = marginLeft === VOID ? 5 * get_gameLayout().zl5_1 : marginLeft;
    marginRight = marginRight === VOID ? 5 * get_gameLayout().zl5_1 : marginRight;
    marginTop = marginTop === VOID ? 5 * get_gameLayout().zl5_1 : marginTop;
    marginBottom = marginBottom === VOID ? 5 * get_gameLayout().zl5_1 : marginBottom;
    xPlacing = xPlacing === VOID ? new OffsetFromCenter(0.0) : xPlacing;
    yPlacing = yPlacing === VOID ? new OffsetFromCenter(0.0) : yPlacing;
    this.mmq_1 = marginLeft;
    this.nmq_1 = marginRight;
    this.omq_1 = marginTop;
    this.pmq_1 = marginBottom;
    this.qmq_1 = xPlacing;
    this.rmq_1 = yPlacing;
  }
  cmx(marginLeft, marginRight, marginTop, marginBottom, xPlacing, yPlacing) {
    return new FitContent(marginLeft, marginRight, marginTop, marginBottom, xPlacing, yPlacing);
  }
  smq(marginLeft, marginRight, marginTop, marginBottom, xPlacing, yPlacing, $super) {
    marginLeft = marginLeft === VOID ? this.mmq_1 : marginLeft;
    marginRight = marginRight === VOID ? this.nmq_1 : marginRight;
    marginTop = marginTop === VOID ? this.omq_1 : marginTop;
    marginBottom = marginBottom === VOID ? this.pmq_1 : marginBottom;
    xPlacing = xPlacing === VOID ? this.qmq_1 : xPlacing;
    yPlacing = yPlacing === VOID ? this.rmq_1 : yPlacing;
    return $super === VOID ? this.cmx(marginLeft, marginRight, marginTop, marginBottom, xPlacing, yPlacing) : $super.cmx.call(this, marginLeft, marginRight, marginTop, marginBottom, xPlacing, yPlacing);
  }
  toString() {
    return 'FitContent(marginLeft=' + this.mmq_1 + ', marginRight=' + this.nmq_1 + ', marginTop=' + this.omq_1 + ', marginBottom=' + this.pmq_1 + ', xPlacing=' + toString(this.qmq_1) + ', yPlacing=' + toString(this.rmq_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.mmq_1);
    result = imul(result, 31) + getNumberHashCode(this.nmq_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.omq_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pmq_1) | 0;
    result = imul(result, 31) + hashCode(this.qmq_1) | 0;
    result = imul(result, 31) + hashCode(this.rmq_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FitContent))
      return false;
    if (!equals(this.mmq_1, other.mmq_1))
      return false;
    if (!equals(this.nmq_1, other.nmq_1))
      return false;
    if (!equals(this.omq_1, other.omq_1))
      return false;
    if (!equals(this.pmq_1, other.pmq_1))
      return false;
    if (!equals(this.qmq_1, other.qmq_1))
      return false;
    if (!equals(this.rmq_1, other.rmq_1))
      return false;
    return true;
  }
}
class OffsetFromStart {
  constructor(offset) {
    this.zmw_1 = offset;
  }
}
class OffsetFromEnd {
  constructor(offset) {
    this.amx_1 = offset;
  }
}
class OffsetFromCenter {
  constructor(offset) {
    this.bmx_1 = offset;
  }
}
class LoadingResourceManager {
  constructor() {
    this.llo_1 = Channel(10);
  }
  *rlu($completion) {
    yield* coroutineScope(LoadingResourceManager$startLoadingManagement$slambda(this), $completion);
    return Unit_instance;
  }
  f7() {
    this.llo_1.y22();
  }
}
class ImageLoadingStage extends Enum {}
class GameLayout {
  constructor(sidePanelLayout, mapAreaWidth, mapAreaHeight, sidePanelWidth, bottomPanelHeight, cardHeightInDialog, dialogAreaPart, dialogCornerRadius, dialogStrokeThickness, normalTextSize, normalActionButtonHeight, dialogCornerTextSize, notificationTextSize, buttonOffsetAsPercentFromTextSize, actionButtonHorizontalPadding, stepInPanel, panelOffset, grudgeScaleOnCharacterHeight, threeGrudgeScaleOnCharacterHeight, contractHeightCoefficient, cursorHeight) {
    sidePanelLayout = sidePanelLayout === VOID ? SidePanelLayout_Narrow_getInstance() : sidePanelLayout;
    mapAreaWidth = mapAreaWidth === VOID ? 1350 - (sidePanelLayout.equals(SidePanelLayout_Wide_getInstance()) ? 120 : 0) | 0 : mapAreaWidth;
    mapAreaHeight = mapAreaHeight === VOID ? 900 : mapAreaHeight;
    sidePanelWidth = sidePanelWidth === VOID ? 250 + (sidePanelLayout.equals(SidePanelLayout_Wide_getInstance()) ? 120 : 0) | 0 : sidePanelWidth;
    bottomPanelHeight = bottomPanelHeight === VOID ? 0 : bottomPanelHeight;
    cardHeightInDialog = cardHeightInDialog === VOID ? 250.0 : cardHeightInDialog;
    dialogAreaPart = dialogAreaPart === VOID ? 19.0 / 20.0 : dialogAreaPart;
    dialogCornerRadius = dialogCornerRadius === VOID ? 10.0 : dialogCornerRadius;
    dialogStrokeThickness = dialogStrokeThickness === VOID ? 5.0 : dialogStrokeThickness;
    normalTextSize = normalTextSize === VOID ? 20.0 : normalTextSize;
    normalActionButtonHeight = normalActionButtonHeight === VOID ? 33.0 : normalActionButtonHeight;
    dialogCornerTextSize = dialogCornerTextSize === VOID ? 25.0 : dialogCornerTextSize;
    notificationTextSize = notificationTextSize === VOID ? 40.0 : notificationTextSize;
    buttonOffsetAsPercentFromTextSize = buttonOffsetAsPercentFromTextSize === VOID ? 0.25 : buttonOffsetAsPercentFromTextSize;
    actionButtonHorizontalPadding = actionButtonHorizontalPadding === VOID ? 24.0 : actionButtonHorizontalPadding;
    stepInPanel = stepInPanel === VOID ? 5.0 : stepInPanel;
    panelOffset = panelOffset === VOID ? 5.0 : panelOffset;
    grudgeScaleOnCharacterHeight = grudgeScaleOnCharacterHeight === VOID ? 0.25 : grudgeScaleOnCharacterHeight;
    threeGrudgeScaleOnCharacterHeight = threeGrudgeScaleOnCharacterHeight === VOID ? 0.33 : threeGrudgeScaleOnCharacterHeight;
    contractHeightCoefficient = contractHeightCoefficient === VOID ? 0.9 : contractHeightCoefficient;
    cursorHeight = cursorHeight === VOID ? 50.0 : cursorHeight;
    this.jl5_1 = sidePanelLayout;
    this.kl5_1 = mapAreaWidth;
    this.ll5_1 = mapAreaHeight;
    this.ml5_1 = sidePanelWidth;
    this.nl5_1 = bottomPanelHeight;
    this.ol5_1 = cardHeightInDialog;
    this.pl5_1 = dialogAreaPart;
    this.ql5_1 = dialogCornerRadius;
    this.rl5_1 = dialogStrokeThickness;
    this.sl5_1 = normalTextSize;
    this.tl5_1 = normalActionButtonHeight;
    this.ul5_1 = dialogCornerTextSize;
    this.vl5_1 = notificationTextSize;
    this.wl5_1 = buttonOffsetAsPercentFromTextSize;
    this.xl5_1 = actionButtonHorizontalPadding;
    this.yl5_1 = stepInPanel;
    this.zl5_1 = panelOffset;
    this.al6_1 = grudgeScaleOnCharacterHeight;
    this.bl6_1 = threeGrudgeScaleOnCharacterHeight;
    this.cl6_1 = contractHeightCoefficient;
    this.dl6_1 = cursorHeight;
    this.el6_1 = this.kl5_1 + this.ml5_1 | 0;
    this.fl6_1 = this.ll5_1 + this.nl5_1 | 0;
    this.gl6_1 = Size2D.l9i(this.el6_1, this.fl6_1);
    this.hl6_1 = 744.0 / 1039.0;
    this.il6_1 = this.ol5_1 * this.hl6_1;
    this.jl6_1 = Size2D.l9i(550, 795);
    this.kl6_1 = this.el6_1 * this.pl5_1;
    this.ll6_1 = this.ol5_1 * 0.75;
    this.ml6_1 = 80.0;
    this.nl6_1 = this.tl5_1 * 3;
  }
  toString() {
    return 'GameLayout(sidePanelLayout=' + this.jl5_1.toString() + ', mapAreaWidth=' + this.kl5_1 + ', mapAreaHeight=' + this.ll5_1 + ', sidePanelWidth=' + this.ml5_1 + ', bottomPanelHeight=' + this.nl5_1 + ', cardHeightInDialog=' + this.ol5_1 + ', dialogAreaPart=' + this.pl5_1 + ', dialogCornerRadius=' + this.ql5_1 + ', dialogStrokeThickness=' + this.rl5_1 + ', normalTextSize=' + this.sl5_1 + ', normalActionButtonHeight=' + this.tl5_1 + ', dialogCornerTextSize=' + this.ul5_1 + ', notificationTextSize=' + this.vl5_1 + ', buttonOffsetAsPercentFromTextSize=' + this.wl5_1 + ', actionButtonHorizontalPadding=' + this.xl5_1 + ', stepInPanel=' + this.yl5_1 + ', panelOffset=' + this.zl5_1 + ', grudgeScaleOnCharacterHeight=' + this.al6_1 + ', threeGrudgeScaleOnCharacterHeight=' + this.bl6_1 + ', contractHeightCoefficient=' + this.cl6_1 + ', cursorHeight=' + this.dl6_1 + ')';
  }
  hashCode() {
    var result = this.jl5_1.hashCode();
    result = imul(result, 31) + this.kl5_1 | 0;
    result = imul(result, 31) + this.ll5_1 | 0;
    result = imul(result, 31) + this.ml5_1 | 0;
    result = imul(result, 31) + this.nl5_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.ol5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ql5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.rl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ul5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.vl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.zl5_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.al6_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.bl6_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.cl6_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.dl6_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameLayout))
      return false;
    if (!this.jl5_1.equals(other.jl5_1))
      return false;
    if (!(this.kl5_1 === other.kl5_1))
      return false;
    if (!(this.ll5_1 === other.ll5_1))
      return false;
    if (!(this.ml5_1 === other.ml5_1))
      return false;
    if (!(this.nl5_1 === other.nl5_1))
      return false;
    if (!equals(this.ol5_1, other.ol5_1))
      return false;
    if (!equals(this.pl5_1, other.pl5_1))
      return false;
    if (!equals(this.ql5_1, other.ql5_1))
      return false;
    if (!equals(this.rl5_1, other.rl5_1))
      return false;
    if (!equals(this.sl5_1, other.sl5_1))
      return false;
    if (!equals(this.tl5_1, other.tl5_1))
      return false;
    if (!equals(this.ul5_1, other.ul5_1))
      return false;
    if (!equals(this.vl5_1, other.vl5_1))
      return false;
    if (!equals(this.wl5_1, other.wl5_1))
      return false;
    if (!equals(this.xl5_1, other.xl5_1))
      return false;
    if (!equals(this.yl5_1, other.yl5_1))
      return false;
    if (!equals(this.zl5_1, other.zl5_1))
      return false;
    if (!equals(this.al6_1, other.al6_1))
      return false;
    if (!equals(this.bl6_1, other.bl6_1))
      return false;
    if (!equals(this.cl6_1, other.cl6_1))
      return false;
    if (!equals(this.dl6_1, other.dl6_1))
      return false;
    return true;
  }
}
class SidePanelLayout extends Enum {}
class GameUiContextImpl {
  constructor(images, frame, topFrame) {
    this.dmx_1 = images;
    this.emx_1 = frame;
    this.fmx_1 = topFrame;
    this.gmx_1 = emptyMap();
  }
  pl6() {
    return this.dmx_1;
  }
  pln() {
    return this.emx_1;
  }
  ol6() {
    return this.fmx_1;
  }
  rln(_set____db54di) {
    this.gmx_1 = _set____db54di;
  }
  dl5() {
    return this.gmx_1;
  }
  sln(message) {
    get_gameConfiguration().xlc_1.rmp(message);
  }
}
class AutoHighlight {
  constructor(view, relativeCenter, applyNextStep) {
    applyNextStep = applyNextStep === VOID ? null : applyNextStep;
    this.el5_1 = view;
    this.fl5_1 = relativeCenter;
    this.gl5_1 = applyNextStep;
    var tmp = this;
    var tmp_0;
    var tmp_1 = this.el5_1;
    if (isInterface(tmp_1, Anchorable)) {
      var tmp_2 = Companion_getInstance_9();
      // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
      var this_0 = toPoint(Size2D.y9p(this.el5_1.s2().j9i_1 * this.el5_1.jjb().l9g_1, this.el5_1.s2().k9i_1 * this.el5_1.jjb().m9g_1));
      var tmp$ret$0 = Vector2D.t9g(-this_0.r9g_1, -this_0.s9g_1);
      tmp_0 = tmp_2.m9i(tmp$ret$0, this.el5_1.s2());
    } else {
      tmp_0 = Companion_getInstance_9().m9i(Vector2D.a9k(0, 0), this.el5_1.s2());
    }
    tmp.hl5_1 = tmp_0;
  }
  jm() {
    return this.el5_1;
  }
  km() {
    return this.fl5_1;
  }
  toString() {
    return 'AutoHighlight(view=' + this.el5_1.toString() + ', relativeCenter=' + this.fl5_1.toString() + ', applyNextStep=' + toString_0(this.gl5_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.el5_1);
    result = imul(result, 31) + this.fl5_1.hashCode() | 0;
    result = imul(result, 31) + (this.gl5_1 == null ? 0 : hashCode(this.gl5_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoHighlight))
      return false;
    if (!equals(this.el5_1, other.el5_1))
      return false;
    if (!this.fl5_1.equals(other.fl5_1))
      return false;
    if (!equals(this.gl5_1, other.gl5_1))
      return false;
    return true;
  }
}
class NullVariant {}
class KorgeOnboardingGameFlowListener extends OnboardingScript {
  constructor() {
    KorgeOnboardingGameFlowListener_instance = null;
    super();
    KorgeOnboardingGameFlowListener_instance = this;
    var tmp = this;
    tmp.all_1 = KorgeOnboardingGameFlowListener$emptyApplyPrepareStep$slambda();
    this.bll_1 = this.all_1;
    this.cll_1 = CompletableDeferred_0();
  }
  hmx(startFromInfoStep, startFromAnswer) {
    closeLastInfoDialog();
    closeOnboardingTemporaryDialogs();
    this.zdy(startFromInfoStep, startFromAnswer);
    this.bll_1 = this.all_1;
    this.cll_1 = CompletableDeferred_0();
  }
  he0() {
    return get_gameConfiguration().qlc_1;
  }
  ie0(holder) {
    return holder instanceof KorgeControlAgent;
  }
  *je0(holder, hint, $completion) {
    yield* /*#__NOINLINE__*/showInfoImpl(this, _get_asKorgeAgent__wlcdb4(this, holder), hint.mdz_1, lines(hint.ndz_1), hintLayout(this, hint), $completion);
    return Unit_instance;
  }
  *ge0(holder, closeHint, $completion) {
    if (closeHint) {
      closeLastInfoDialog();
    }
    this.bll_1 = this.all_1;
    return Unit_instance;
  }
  ke0(holder) {
    setReplayCodeInUrl(get_onboardingReplayCode(), false, this.tdy_1, 0);
  }
  *edz(holder, notificationType, $completion) {
    // Inline function 'kotlin.with' call
    var $this$with = _get_asKorgeAgent__wlcdb4(this, holder);
    if ($this$with.qmo())
      throw PressedBackException.pdy();
    initiateRevertIntoAnotherListener(KorgeOnboardingGameFlowListener_getInstance(), $this$with, notificationType);
    return Unit_instance;
  }
  *be0(holder, sequence, $completion) {
    return yield* coroutineScope(KorgeOnboardingGameFlowListener$presentSequence$slambda(sequence, holder), $completion);
  }
}
class LoadingResourceReporter {
  constructor(scope, delayBeforeStartReport, delayBeforeFadeMs) {
    this.gld_1 = scope;
    this.hld_1 = delayBeforeStartReport;
    this.ild_1 = delayBeforeFadeMs;
    this.jld_1 = null;
    this.kld_1 = Mutex();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.lld_1 = LinkedHashSet.v2();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_0.mld_1 = LinkedHashSet.v2();
    this.nld_1 = null;
    this.old_1 = null;
    this.pld_1 = false;
    this.qld_1 = null;
    this.rld_1 = 0;
    this.sld_1 = 0;
  }
  *vmq($completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.kld_1;
    yield* this_0.y2a(null, $completion);
    try {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.mld_1.n1()) {
        return Unit_instance;
      }
      this.rld_1 = 0;
      this.sld_1 = 0;
      this.pld_1 = false;
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }
  *ylb(path, stage, $completion) {
    switch (stage.w1_1) {
      case 0:
        yield* /*#__NOINLINE__*/startLoading(this, path, $completion);
        break;
      case 1:
        // Inline function 'kotlinx.coroutines.sync.withLock' call

        var this_0 = this.kld_1;
        yield* this_0.y2a(null, $completion);
        var tmp;
        try {
          if (this.lld_1.n1()) {
            var tmp0_safe_receiver = this.jld_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              yield* tmp0_safe_receiver.gmr($completion);
          }
          tmp = this.lld_1.d2(path);
        }finally {
          this_0.k2a(null);
        }

        break;
      case 2:
        yield* /*#__NOINLINE__*/finishLoading(this, path, $completion);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  }
}
class LoadingProgressState {
  constructor(total, current) {
    this.emr_1 = total;
    this.fmr_1 = current;
  }
  toString() {
    return 'LoadingProgressState(total=' + this.emr_1 + ', current=' + this.fmr_1 + ')';
  }
  hashCode() {
    var result = this.emr_1;
    result = imul(result, 31) + this.fmr_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadingProgressState))
      return false;
    if (!(this.emr_1 === other.emr_1))
      return false;
    if (!(this.fmr_1 === other.fmr_1))
      return false;
    return true;
  }
}
class RoundButton extends Container {
  constructor(content, element, isActive, onRightClick, onActionInvoked) {
    return new.target.fmo(content, element, isActive, onRightClick, onActionInvoked);
  }
  static fmo(content, element, isActive, onRightClick, onActionInvoked) {
    element = element === VOID ? null : element;
    isActive = isActive === VOID ? true : isActive;
    onRightClick = onRightClick === VOID ? null : onRightClick;
    var $this = this.fi2();
    $this.xlj_1 = element;
    $this.ylj_1 = false;
    var tmp = $this;
    var tmp0 = content.pig() / 2;
    // Inline function 'kotlin.math.max' call
    var b = content.rig() / 2;
    tmp.zlj_1 = Math.max(tmp0, b);
    var tmp_0 = $this;
    var tmp2 = $this.zlj_1;
    // Inline function 'korlibs.korge.view.circle' call
    var fill = new RGBA(Companion_getInstance_15().ich(255, 255, 255, 255));
    var stroke = new RGBA(Colors_getInstance().zc2_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Circle.ajq(numberToDouble(tmp2), fill, stroke, numberToDouble(0.0), true, renderer);
    // Inline function 'kotlin.apply' call
    tmp_0.alk_1 = addTo(this_0, $this);
    $this.bif(content, 0);
    content.fcw(Vector2D.t9g($this.zlj_1 - content.pig() / 2, $this.zlj_1 - content.rig() / 2));
    $this.alk_1.sig(0.0);
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse($this);
    if (isActive) {
      // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
      var handler = RoundButton$slambda($this);
      var tmp_1 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_2 = getPropertyCallableRef('over', 1, tmp_1, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
      tmp_2.v9y(RoundButton$lambda($this$mouse, handler));
      // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
      var handler_0 = RoundButton$slambda_0($this);
      var tmp_3 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_4 = getPropertyCallableRef('out', 1, tmp_3, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
      tmp_4.v9y(RoundButton$lambda_0($this$mouse, handler_0));
    }
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var handler_1 = RoundButton$slambda_1(isActive, onActionInvoked, onRightClick);
    var tmp_5 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_6 = getPropertyCallableRef('click', 1, tmp_5, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
    tmp_6.v9y(RoundButton$lambda_1($this$mouse, handler_1));
    if (!isActive) {
      $this.alk_1.sig(0.2);
    }
    return $this;
  }
  pl8(_set____db54di) {
    this.ylj_1 = _set____db54di;
  }
  am5() {
    return this.ylj_1;
  }
  ql8() {
    if (this.ylj_1) {
      this.alk_1.sig(0.5);
    } else {
      this.alk_1.sig(0.0);
    }
  }
}
class HighlightPattern {
  constructor(positions, widths, topGains, bottomGains, topSpreads, bottomSpreads) {
    this.smy_1 = positions;
    this.tmy_1 = widths;
    this.umy_1 = topGains;
    this.vmy_1 = bottomGains;
    this.wmy_1 = topSpreads;
    this.xmy_1 = bottomSpreads;
  }
  toString() {
    return 'HighlightPattern(positions=' + this.smy_1.toString() + ', widths=' + this.tmy_1.toString() + ', topGains=' + this.umy_1.toString() + ', bottomGains=' + this.vmy_1.toString() + ', topSpreads=' + this.wmy_1.toString() + ', bottomSpreads=' + this.xmy_1.toString() + ')';
  }
  hashCode() {
    var result = this.smy_1.hashCode();
    result = imul(result, 31) + this.tmy_1.hashCode() | 0;
    result = imul(result, 31) + this.umy_1.hashCode() | 0;
    result = imul(result, 31) + this.vmy_1.hashCode() | 0;
    result = imul(result, 31) + this.wmy_1.hashCode() | 0;
    result = imul(result, 31) + this.xmy_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HighlightPattern))
      return false;
    if (!this.smy_1.equals(other.smy_1))
      return false;
    if (!this.tmy_1.equals(other.tmy_1))
      return false;
    if (!this.umy_1.equals(other.umy_1))
      return false;
    if (!this.vmy_1.equals(other.vmy_1))
      return false;
    if (!this.wmy_1.equals(other.wmy_1))
      return false;
    if (!this.xmy_1.equals(other.xmy_1))
      return false;
    return true;
  }
}
class ButtonUB extends UniformBlock {
  constructor() {
    ButtonUB_instance = null;
    super(6);
    ButtonUB_instance = this;
    var tmp = this;
    var tmp_0 = this.dew();
    var tmp_1 = KProperty1;
    tmp.mmx_1 = tmp_0.vev(this, getPropertyCallableRef('u_Size', 1, tmp_1, ShaderButtonBackground$ButtonUB$_get_u_Size_$ref_3wbedx(), null));
    var tmp_2 = this;
    var tmp_3 = this.bew();
    var tmp_4 = KProperty1;
    tmp_2.nmx_1 = tmp_3.vev(this, getPropertyCallableRef('u_Margin', 1, tmp_4, ShaderButtonBackground$ButtonUB$_get_u_Margin_$ref_azhadk(), null));
    var tmp_5 = this;
    var tmp_6 = this.bew();
    var tmp_7 = KProperty1;
    tmp_5.omx_1 = tmp_6.vev(this, getPropertyCallableRef('u_Hover', 1, tmp_7, ShaderButtonBackground$ButtonUB$_get_u_Hover_$ref_sz4kaw(), null));
    var tmp_8 = this;
    var tmp_9 = this.bew();
    var tmp_10 = KProperty1;
    tmp_8.pmx_1 = tmp_9.vev(this, getPropertyCallableRef('u_Enabled', 1, tmp_10, ShaderButtonBackground$ButtonUB$_get_u_Enabled_$ref_rhuajh(), null));
    var tmp_11 = this;
    var tmp_12 = this.bew();
    var tmp_13 = KProperty1;
    tmp_11.qmx_1 = tmp_12.vev(this, getPropertyCallableRef('u_Highlights', 1, tmp_13, ShaderButtonBackground$ButtonUB$_get_u_Highlights_$ref_pp9iuh(), null));
    var tmp_14 = this;
    var tmp_15 = this.bew();
    var tmp_16 = KProperty1;
    tmp_14.rmx_1 = tmp_15.vev(this, getPropertyCallableRef('u_OuterGlow', 1, tmp_16, ShaderButtonBackground$ButtonUB$_get_u_OuterGlow_$ref_55sfxg(), null));
    var tmp_17 = this;
    var tmp_18 = this.bew();
    var tmp_19 = KProperty1;
    tmp_17.smx_1 = tmp_18.vev(this, getPropertyCallableRef('u_InnerGlow', 1, tmp_19, ShaderButtonBackground$ButtonUB$_get_u_InnerGlow_$ref_4v8vfj(), null));
    var tmp_20 = this;
    var tmp_21 = this.bew();
    var tmp_22 = KProperty1;
    tmp_20.tmx_1 = tmp_21.vev(this, getPropertyCallableRef('u_Radius', 1, tmp_22, ShaderButtonBackground$ButtonUB$_get_u_Radius_$ref_jt75no(), null));
    var tmp_23 = this;
    var tmp_24 = this.bew();
    var tmp_25 = KProperty1;
    tmp_23.umx_1 = tmp_24.vev(this, getPropertyCallableRef('u_Border', 1, tmp_25, ShaderButtonBackground$ButtonUB$_get_u_Border_$ref_71fitm(), null));
    var tmp_26 = this;
    var tmp_27 = this.dew();
    var tmp_28 = KProperty1;
    tmp_26.vmx_1 = tmp_27.vev(this, getPropertyCallableRef('u_EdgePositions', 1, tmp_28, ShaderButtonBackground$ButtonUB$_get_u_EdgePositions_$ref_kb1yfd(), null));
    var tmp_29 = this;
    var tmp_30 = this.dew();
    var tmp_31 = KProperty1;
    tmp_29.wmx_1 = tmp_30.vev(this, getPropertyCallableRef('u_EdgeWidths', 1, tmp_31, ShaderButtonBackground$ButtonUB$_get_u_EdgeWidths_$ref_xyrqxg(), null));
    var tmp_32 = this;
    var tmp_33 = this.dew();
    var tmp_34 = KProperty1;
    tmp_32.xmx_1 = tmp_33.vev(this, getPropertyCallableRef('u_TopCornerGains', 1, tmp_34, ShaderButtonBackground$ButtonUB$_get_u_TopCornerGains_$ref_b9ek8k(), null));
    var tmp_35 = this;
    var tmp_36 = this.dew();
    var tmp_37 = KProperty1;
    tmp_35.ymx_1 = tmp_36.vev(this, getPropertyCallableRef('u_BottomCornerGains', 1, tmp_37, ShaderButtonBackground$ButtonUB$_get_u_BottomCornerGains_$ref_l18tgw(), null));
    var tmp_38 = this;
    var tmp_39 = this.dew();
    var tmp_40 = KProperty1;
    tmp_38.zmx_1 = tmp_39.vev(this, getPropertyCallableRef('u_TopCornerSpreads', 1, tmp_40, ShaderButtonBackground$ButtonUB$_get_u_TopCornerSpreads_$ref_buncxs(), null));
    var tmp_41 = this;
    var tmp_42 = this.dew();
    var tmp_43 = KProperty1;
    tmp_41.amy_1 = tmp_42.vev(this, getPropertyCallableRef('u_BottomCornerSpreads', 1, tmp_43, ShaderButtonBackground$ButtonUB$_get_u_BottomCornerSpreads_$ref_7mk9yc(), null));
    var tmp_44 = this;
    var tmp_45 = this.bew();
    var tmp_46 = KProperty1;
    tmp_44.bmy_1 = tmp_45.vev(this, getPropertyCallableRef('u_Variation', 1, tmp_46, ShaderButtonBackground$ButtonUB$_get_u_Variation_$ref_l8twb5(), null));
  }
  cmy() {
    var tmp = KProperty1;
    return this.mmx_1.yq(this, getPropertyCallableRef('u_Size', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Size_$ref_3wbedx(), null));
  }
  dmy() {
    var tmp = KProperty1;
    return this.nmx_1.yq(this, getPropertyCallableRef('u_Margin', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Margin_$ref_azhadk(), null));
  }
  emy() {
    var tmp = KProperty1;
    return this.omx_1.yq(this, getPropertyCallableRef('u_Hover', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Hover_$ref_sz4kaw(), null));
  }
  fmy() {
    var tmp = KProperty1;
    return this.pmx_1.yq(this, getPropertyCallableRef('u_Enabled', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Enabled_$ref_rhuajh(), null));
  }
  gmy() {
    var tmp = KProperty1;
    return this.qmx_1.yq(this, getPropertyCallableRef('u_Highlights', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Highlights_$ref_pp9iuh(), null));
  }
  hmy() {
    var tmp = KProperty1;
    return this.rmx_1.yq(this, getPropertyCallableRef('u_OuterGlow', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_OuterGlow_$ref_55sfxg(), null));
  }
  imy() {
    var tmp = KProperty1;
    return this.smx_1.yq(this, getPropertyCallableRef('u_InnerGlow', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_InnerGlow_$ref_4v8vfj(), null));
  }
  jmy() {
    var tmp = KProperty1;
    return this.tmx_1.yq(this, getPropertyCallableRef('u_Radius', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Radius_$ref_jt75no(), null));
  }
  kmy() {
    var tmp = KProperty1;
    return this.umx_1.yq(this, getPropertyCallableRef('u_Border', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Border_$ref_71fitm(), null));
  }
  lmy() {
    var tmp = KProperty1;
    return this.vmx_1.yq(this, getPropertyCallableRef('u_EdgePositions', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_EdgePositions_$ref_kb1yfd(), null));
  }
  mmy() {
    var tmp = KProperty1;
    return this.wmx_1.yq(this, getPropertyCallableRef('u_EdgeWidths', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_EdgeWidths_$ref_xyrqxg(), null));
  }
  nmy() {
    var tmp = KProperty1;
    return this.xmx_1.yq(this, getPropertyCallableRef('u_TopCornerGains', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_TopCornerGains_$ref_b9ek8k(), null));
  }
  omy() {
    var tmp = KProperty1;
    return this.ymx_1.yq(this, getPropertyCallableRef('u_BottomCornerGains', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_BottomCornerGains_$ref_l18tgw(), null));
  }
  pmy() {
    var tmp = KProperty1;
    return this.zmx_1.yq(this, getPropertyCallableRef('u_TopCornerSpreads', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_TopCornerSpreads_$ref_buncxs(), null));
  }
  qmy() {
    var tmp = KProperty1;
    return this.amy_1.yq(this, getPropertyCallableRef('u_BottomCornerSpreads', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_BottomCornerSpreads_$ref_7mk9yc(), null));
  }
  rmy() {
    var tmp = KProperty1;
    return this.bmy_1.yq(this, getPropertyCallableRef('u_Variation', 1, tmp, ShaderButtonBackground$ButtonUB$_get_u_Variation_$ref_l8twb5(), null));
  }
}
class Companion {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'BeastButton';
    var tmp1_$this = Companion_getInstance_4().vg8_1;
    var tmp2_name = name == null ? Companion_getInstance_4().vg8_1.ueo_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    var size = ButtonUB_getInstance().cmy();
    var hover = ButtonUB_getInstance().emy();
    var active = ButtonUB_getInstance().fmy();
    var p = this_0.kez(this_0.uf0(this_0.ney(this_0.fey(), this_0.xf0(size, this_0.lf0([this_0.bf1(ButtonUB_getInstance().dmy(), 2.0)]))), this_0.lf0([ButtonUB_getInstance().dmy()])));
    var d = this_0.kez(this_0.nez(SDFShaders_getInstance().rge(), this_0.uf0(p, this_0.bf1(size, 0.5)), this_0.bf1(size, 0.5), this_0.qey([ButtonUB_getInstance().jmy()])));
    var aa = this_0.kez(this_0.gf0(this_0.hf0(d), this_0.pey(0.35)));
    var inside = this_0.kez(this_0.vf0(1.0, this_0.jf0(this_0.tf0(aa), aa, d)));
    var uv = this_0.kez(this_0.wey(p, size));
    var cornerUV = this_0.kez(this_0.ef0(uv, this_0.mf0(new Float32Array([0.0])), this_0.mf0(new Float32Array([1.0]))));
    var cornerGain = this_0.kez(this_0.if0(this_0.if0(this_0.pf0(ButtonUB_getInstance().nmy()), this_0.qf0(ButtonUB_getInstance().nmy()), this_0.pf0(cornerUV)), this_0.if0(this_0.pf0(ButtonUB_getInstance().omy()), this_0.qf0(ButtonUB_getInstance().omy()), this_0.pf0(cornerUV)), this_0.qf0(cornerUV)));
    var cornerSpread = this_0.kez(this_0.if0(this_0.if0(this_0.pf0(ButtonUB_getInstance().pmy()), this_0.qf0(ButtonUB_getInstance().pmy()), this_0.pf0(cornerUV)), this_0.if0(this_0.pf0(ButtonUB_getInstance().qmy()), this_0.qf0(ButtonUB_getInstance().qmy()), this_0.pf0(cornerUV)), this_0.qf0(cornerUV)));
    var cornerRoom = this_0.kez(this_0.ff0(this_0.jf0(this_0.pey(140.0), this_0.pey(337.0), this_0.pf0(size)), this_0.jf0(this_0.pey(30.0), this_0.pey(49.0), this_0.qf0(size))));
    var cornerStrength = this_0.kez(this_0.if0(this_0.pey(0.5), this_0.pey(0.9), cornerRoom));
    var cornerReach = this_0.kez(this_0.if0(this_0.pey(0.7), this_0.pey(1.0), cornerRoom));
    var cornerPosition = this_0.kez(this_0.wey(this_0.lf0([this_0.ff0(this_0.cf0(this_0.pf0(p)), this_0.cf0(this_0.uf0(this_0.pf0(p), this_0.pf0(size)))), this_0.ff0(this_0.cf0(this_0.qf0(p)), this_0.cf0(this_0.uf0(this_0.qf0(p), this_0.qf0(size))))]), this_0.ney(this_0.ney(this_0.mf0(new Float32Array([15.0, 12.0])), cornerSpread), cornerReach)));
    var cornerLight = this_0.kez(this_0.ney(this_0.ney(this_0.af0(this_0.bf1(this_0.tf0(this_0.kf0(cornerPosition, cornerPosition)), 0.5)), cornerGain), cornerStrength));
    var edgeDelta = this_0.kez(this_0.wey(this_0.uf0(this_0.lf0([this_0.pf0(p)]), this_0.ney(this_0.pf0(size), ButtonUB_getInstance().lmy())), this_0.ff0(ButtonUB_getInstance().mmy(), this_0.lf0([this_0.bf1(this_0.pf0(size), 0.065)]))));
    var topSpots = this_0.kez(this_0.af0(this_0.bf1(this_0.ney(this_0.tf0(this_0.pf0(edgeDelta)), this_0.pf0(edgeDelta)), 0.5)));
    var bottomSpots = this_0.kez(this_0.af0(this_0.bf1(this_0.ney(this_0.tf0(this_0.qf0(edgeDelta)), this_0.qf0(edgeDelta)), 0.5)));
    var edgeSpot = this_0.kez(this_0.ney(this_0.ney(this_0.ney(this_0.xf0(this_0.ney(topSpots, this_0.af0(this_0.cf1(this_0.tf0(this_0.cf0(this_0.qf0(p))), 4.0))), this_0.ney(bottomSpots, this_0.af0(this_0.cf1(this_0.tf0(this_0.cf0(this_0.uf0(this_0.qf0(p), this_0.qf0(size)))), 4.0)))), ButtonUB_getInstance().rmy()), ButtonUB_getInstance().gmy()), active));
    var irregular = this_0.kez(this_0.xf0(this_0.ney(this_0.wf0(topSpots, 0.28), this_0.af0(this_0.cf1(this_0.tf0(this_0.cf0(this_0.qf0(p))), 5.0))), this_0.ney(this_0.wf0(bottomSpots, 0.28), this_0.af0(this_0.cf1(this_0.tf0(this_0.cf0(this_0.uf0(this_0.qf0(p), this_0.qf0(size)))), 5.0)))));
    var light = this_0.kez(this_0.ef0(this_0.ney(this_0.xf0(this_0.xf0(this_0.yf0(0.36, this_0.af1(0.11, this_0.vf0(1.0, this_0.qf0(uv)))), this_0.ney(this_0.af1(0.72, cornerLight), this_0.yf0(0.82, this_0.af1(0.18, this_0.pf0(uv))))), this_0.ney(irregular, ButtonUB_getInstance().rmy())), ButtonUB_getInstance().gmy()), this_0.pey(0.0), this_0.pey(1.0)));
    var normalFill = this_0.kez(this_0.if0(this_0.of0(new Float32Array([0.155, 0.164, 0.173])), this_0.of0(new Float32Array([0.163, 0.17, 0.192])), active));
    var fillColor = this_0.kez(this_0.xf0(this_0.if0(normalFill, this_0.of0(new Float32Array([0.285, 0.225, 0.164])), hover), this_0.nf0([this_0.af1(0.014, this_0.vf0(1.0, this_0.ef0(this_0.qf0(uv), this_0.pey(0.0), this_0.pey(1.0))))])));
    var fillAlpha = this_0.kez(this_0.bf1(inside, 0.88));
    var result = this_0.kez(this_0.qey([this_0.ney(fillColor, fillAlpha), fillAlpha]));
    var innerCornerPosition = this_0.kez(this_0.wey(this_0.lf0([this_0.ff0(this_0.cf0(this_0.pf0(p)), this_0.cf0(this_0.uf0(this_0.pf0(p), this_0.pf0(size)))), this_0.ff0(this_0.cf0(this_0.qf0(p)), this_0.cf0(this_0.uf0(this_0.qf0(p), this_0.qf0(size))))]), this_0.ney(this_0.ney(this_0.mf0(new Float32Array([32.0, 21.0])), cornerSpread), cornerReach)));
    var innerCorner = this_0.kez(this_0.ney(this_0.ney(this_0.af0(this_0.bf1(this_0.tf0(this_0.kf0(innerCornerPosition, innerCornerPosition)), 0.5)), cornerGain), cornerStrength));
    var inner = this_0.kez(this_0.ney(this_0.ney(this_0.ney(this_0.ney(this_0.xf0(this_0.xf0(this_0.ney(this_0.af0(this_0.cf1(this_0.ff0(d, this_0.pey(0.0)), 7.0)), this_0.yf0(0.08, this_0.af1(0.18, light))), this_0.af1(0.26, innerCorner)), this_0.bf1(edgeSpot, 0.38)), this_0.yf0(1.0, this_0.bf1(hover, 0.35))), inside), ButtonUB_getInstance().imy()), this_0.if0(this_0.pey(0.3), this_0.pey(1.0), active)));
    var innerColor = this_0.kez(this_0.if0(this_0.of0(new Float32Array([0.77, 0.765, 0.82])), this_0.of0(new Float32Array([1.0, 0.68, 0.32])), hover));
    this_0.jey(result, this_0.mez(SDFShaders_getInstance().tge(), result, this_0.qey([this_0.ney(innerColor, inner), inner])));
    var bevel = this_0.kez(this_0.bf1(this_0.ney(this_0.vf0(1.0, this_0.jf0(this_0.pey(0.25), this_0.pey(1.2), this_0.cf0(this_0.zf0(d, 1.8)))), inside), 0.16));
    this_0.jey(result, this_0.mez(SDFShaders_getInstance().tge(), result, this_0.qey([this_0.ney(this_0.of0(new Float32Array([0.025])), bevel), bevel])));
    var border = this_0.kez(this_0.ney(this_0.vf0(1.0, this_0.jf0(this_0.bf1(this_0.tf0(aa), 0.5), this_0.bf1(aa, 0.5), this_0.uf0(this_0.cf0(this_0.xf0(d, this_0.bf1(ButtonUB_getInstance().kmy(), 0.5))), this_0.bf1(ButtonUB_getInstance().kmy(), 0.5)))), this_0.if0(this_0.pey(0.32), this_0.pey(0.96), active)));
    var cool = this_0.kez(this_0.if0(this_0.of0(new Float32Array([0.67, 0.66, 0.72])), this_0.of0(new Float32Array([1.0, 0.99, 1.0])), light));
    var warm = this_0.kez(this_0.if0(this_0.of0(new Float32Array([0.95, 0.74, 0.46])), this_0.of0(new Float32Array([1.0, 0.985, 0.89])), light));
    var borderColor = this_0.kez(this_0.if0(cool, warm, hover));
    var shoulder = this_0.kez(this_0.ney(this_0.ney(this_0.ney(this_0.af0(this_0.cf1(this_0.tf0(this_0.cf0(this_0.xf0(d, this_0.bf1(ButtonUB_getInstance().kmy(), 0.6)))), 1.2)), inside), this_0.xf0(this_0.if0(this_0.pey(0.18), this_0.pey(0.26), hover), this_0.ney(edgeSpot, this_0.if0(this_0.pey(0.5), this_0.pey(0.7), hover)))), this_0.if0(this_0.pey(0.3), this_0.pey(1.0), active)));
    this_0.jey(result, this_0.mez(SDFShaders_getInstance().tge(), result, this_0.qey([this_0.ney(borderColor, shoulder), shoulder])));
    this_0.jey(result, this_0.mez(SDFShaders_getInstance().tge(), result, this_0.qey([this_0.ney(borderColor, border), border])));
    var outsideDistance = this_0.kez(this_0.gf0(d, this_0.pey(0.0)));
    var haloFalloff = this_0.kez(this_0.xf0(this_0.ney(this_0.af0(this_0.cf1(this_0.ney(this_0.tf0(outsideDistance), outsideDistance), 7.0)), this_0.yf0(0.004, this_0.bf1(hover, 0.48))), this_0.bf1(this_0.ney(this_0.af0(this_0.cf1(this_0.ney(this_0.tf0(outsideDistance), outsideDistance), 28.0)), hover), 0.12)));
    var halo = this_0.kez(this_0.ney(this_0.ney(this_0.ney(this_0.ney(this_0.xf0(this_0.ney(haloFalloff, this_0.xf0(this_0.yf0(0.45, this_0.af1(0.25, light)), this_0.af1(0.95, cornerLight))), this_0.ney(this_0.ney(this_0.af0(this_0.cf1(this_0.ney(this_0.tf0(outsideDistance), outsideDistance), 7.0)), edgeSpot), this_0.yf0(0.035, this_0.bf1(hover, 0.55)))), this_0.vf0(1.0, inside)), this_0.vf0(1.0, this_0.jf0(this_0.wf0(ButtonUB_getInstance().dmy(), 4.0), this_0.wf0(ButtonUB_getInstance().dmy(), 1.0), outsideDistance))), ButtonUB_getInstance().hmy()), active));
    var glowColor = this_0.kez(this_0.if0(this_0.of0(new Float32Array([0.79, 0.78, 0.84])), this_0.of0(new Float32Array([1.0, 0.57, 0.19])), hover));
    this_0.jey(result, this_0.mez(SDFShaders_getInstance().tge(), result, this_0.qey([this_0.ney(glowColor, halo), halo])));
    this_0.jey(this_0.mey(), this_0.ney(result, Companion_getInstance_4().bg9()));
    var tmp3_fragment = FragmentShader(this_0.rey());
    tmp.ymy_1 = tmp1_$this.wfl(VOID, tmp3_fragment, tmp2_name);
  }
}
class ShaderButtonBackground extends ShadedView {
  constructor(surfaceSize, glowMargin) {
    return new.target.gmu(surfaceSize, glowMargin);
  }
  static gmu(surfaceSize, glowMargin) {
    Companion_getInstance_18();
    surfaceSize = surfaceSize === VOID ? Size2D.l9i(337, 49) : surfaceSize;
    glowMargin = glowMargin === VOID ? 14.0 : glowMargin;
    var $this = this.ckd(Companion_getInstance_18().ymy_1, Size2D.y9p(surfaceSize.j9i_1 + 2 * glowMargin, surfaceSize.k9i_1 + 2 * glowMargin));
    $this.umt_1 = glowMargin;
    $this.vmt_1 = surfaceSize;
    $this.wmt_1 = 0.0;
    $this.xmt_1 = true;
    $this.ymt_1 = 1.0;
    $this.zmt_1 = 1.0;
    $this.amu_1 = 1.0;
    $this.bmu_1 = 9.0;
    $this.cmu_1 = 1.45;
    $this.dmu_1 = makeEdgeHighlights(Companion_getInstance_18(), 0.0);
    $this.emu_1 = 0.0;
    $this.fmu_1 = 0.42;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(surfaceSize.j9i_1 > 0 && surfaceSize.k9i_1 > 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!($this.umt_1 >= 2)) {
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message_0));
    }
    $this.thy(false);
    return $this;
  }
  jmu(value) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(value.j9i_1 > 0 && value.k9i_1 > 0)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    this.vmt_1 = value;
    this.lib(Size2D.y9p(value.j9i_1 + 2 * this.umt_1, value.k9i_1 + 2 * this.umt_1));
    this.gih();
    this.hie();
  }
  hmu(value) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!isFinite(value)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException.h2(toString(message));
    }
    this.emu_1 = value;
    this.dmu_1 = makeEdgeHighlights(Companion_getInstance_18(), value);
    this.hie();
  }
  dkd(ctx) {
    var tmp0 = ctx.ieo(ButtonUB_getInstance());
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = tmp0.z6x();
      tmp0.efc(_unary__edvuaz + 1 | 0);
      tmp0.ffc(tmp0.z6x() + 1 | 0);
      var blockSize = tmp0.beo_1;
      var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
      var index1 = imul(tmp0.z6x(), blockSize);
      var texBlockSize = tmp0.yen_1.wev().s2();
      var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0.z6x(), texBlockSize);
      if (tmp0.z6x() > 0) {
        arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
      } else {
        arrayfill(tmp0.deo_1, 0, 0, blockSize);
      }
      var tmp0_0 = tmp0.yen_1;
      var it = tmp0.eeo_1;
      it.lfc(tmp0_0.cmy(), Vector2D.t9g(this.vmt_1.j9i_1, this.vmt_1.k9i_1));
      it.kfc(tmp0_0.dmy(), this.umt_1);
      it.kfc(tmp0_0.emy(), this.xmt_1 ? coerceIn(this.wmt_1, 0.0, 1.0) : 0.0);
      it.kfc(tmp0_0.fmy(), this.xmt_1 ? 1.0 : 0.0);
      it.kfc(tmp0_0.gmy(), coerceIn(this.ymt_1, 0.0, 2.0));
      it.kfc(tmp0_0.hmy(), coerceIn(this.zmt_1, 0.0, 2.0));
      it.kfc(tmp0_0.imy(), coerceIn(this.amu_1, 0.0, 2.0));
      var tmp = tmp0_0.jmy();
      var tmp_0 = this.bmu_1;
      var tmp0_1 = this.vmt_1.j9i_1;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.vmt_1.k9i_1;
      var tmp$ret$2 = Math.min(tmp0_1, b);
      it.kfc(tmp, coerceIn(tmp_0, 0.0, tmp$ret$2 / 2));
      it.kfc(tmp0_0.kmy(), coerceIn(this.cmu_1, 0.5, 3.0));
      it.lfc(tmp0_0.lmy(), this.dmu_1.smy_1);
      it.lfc(tmp0_0.mmy(), this.dmu_1.tmy_1);
      it.lfc(tmp0_0.nmy(), this.dmu_1.umy_1);
      it.lfc(tmp0_0.omy(), this.dmu_1.vmy_1);
      it.lfc(tmp0_0.pmy(), this.dmu_1.wmy_1);
      it.lfc(tmp0_0.qmy(), this.dmu_1.xmy_1);
      it.kfc(tmp0_0.rmy(), coerceIn(this.fmu_1, 0.0, 0.6));
      if (true && tmp0.z6x() >= 1) {
        var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = tmp0.z6x();
          tmp0.efc(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
}
class TextStyle extends Enum {}
class UiDynamicLayer {
  constructor(container) {
    container = container === VOID ? Container.fi2() : container;
    this.tln_1 = container;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.uln_1 = LinkedHashMap.m7();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_0.vln_1 = LinkedHashSet.v2();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.wln_1 = LinkedHashMap.m7();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.xln_1 = LinkedHashMap.m7();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.yln_1 = LinkedHashMap.m7();
  }
  a5() {
    this.tln_1.tie();
    this.uln_1.a5();
    this.vln_1.a5();
    this.wln_1.a5();
    this.xln_1.a5();
    this.yln_1.a5();
  }
  im5(key) {
    var tmp0_elvis_lhs = this.uln_1.w4(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = this.wln_1.w4(key);
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zmy_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  *bmz(key, where, needHeight, animation, creator, $completion) {
    var oldView = this.uln_1.w4(key);
    if (!(oldView == null)) {
      this.vln_1.d2(key);
      if (!(where == null) && !oldView.wb5().equals(where)) {
        // Inline function 'kotlin.collections.set' call
        this.xln_1.b5(oldView, where);
      }
      if (!(needHeight == null) && !(needHeight === oldView.rig())) {
        // Inline function 'kotlin.collections.set' call
        this.yln_1.b5(oldView, needHeight);
      }
      return oldView;
    } else {
      var view = yield* creator($completion);
      var tmp0 = this.wln_1;
      // Inline function 'kotlin.also' call
      if (!(where == null)) {
        view.fcw(where);
      }
      if (!(needHeight == null)) {
        toHeight(view, needHeight);
      }
      // Inline function 'kotlin.collections.set' call
      var value = new ViewAndAnimation(view, animation);
      tmp0.b5(key, value);
      return view;
    }
  }
  zln(key, where, needHeight, animation, creator, $completion, $super) {
    where = where === VOID ? null : where;
    needHeight = needHeight === VOID ? null : needHeight;
    animation = animation === VOID ? null : animation;
    return $super === VOID ? this.bmz(key, where, needHeight, animation, creator, $completion) : $super.bmz.call(this, key, where, needHeight, animation, creator, $completion);
  }
  aly(key, where) {
    var oldView = this.uln_1.w4(key);
    if (!(oldView == null)) {
      // Inline function 'kotlin.collections.set' call
      this.xln_1.b5(oldView, where);
    } else {
      var tmp0_safe_receiver = this.wln_1.w4(key);
      var comingView = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zmy_1;
      // Inline function 'kotlin.require' call
      if (!!(comingView == null)) {
        var message = 'No view for ' + toString_0(key);
        throw IllegalArgumentException.h2(toString(message));
      }
      comingView.fcw(where);
    }
  }
  *dln($completion) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.xln_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var view = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var newPos = _destruct__k2r9zo.k3();
      view.fcw(newPos);
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = this.yln_1.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.collections.component1' call
      var view_0 = _destruct__k2r9zo_0.j3();
      // Inline function 'kotlin.collections.component2' call
      var newHeight = _destruct__k2r9zo_0.k3();
      toHeight(view_0, newHeight);
    }
    var toRemove = willBeRemoved(this);
    var _iterator__ex2g4s_1 = toRemove.p1();
    $l$loop: while (_iterator__ex2g4s_1.q1()) {
      var removedElement = _iterator__ex2g4s_1.r1();
      var tmp0_elvis_lhs = this.uln_1.w4(removedElement);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var view_1 = tmp;
      this.tln_1.cif(view_1);
      this.uln_1.c5(removedElement);
    }
    var _iterator__ex2g4s_2 = this.wln_1.y4().p1();
    while (_iterator__ex2g4s_2.q1()) {
      var x = _iterator__ex2g4s_2.r1();
      var view_2 = x.zmy_1;
      var animation = x.amz_1;
      this.tln_1.uie(view_2);
      if (!get_gameConfiguration().olc_1) {
        if (animation == null)
          null;
        else
          yield* animation(view_2, $completion);
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.wln_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(this_0.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = this_0.i3().p1();
    while (_iterator__ex2g4s_3.q1()) {
      var item = _iterator__ex2g4s_3.r1();
      var tmp$ret$9 = to(item.j3(), item.k3().zmy_1);
      destination.d2(tmp$ret$9);
    }
    putAll(this.uln_1, destination);
    this.wln_1.a5();
    this.vln_1.a5();
    return Unit_instance;
  }
  hm5(check) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.uln_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var view = _destruct__k2r9zo.k3();
      if (check(key))
        return view;
    }
    return null;
  }
}
class ViewAndAnimation {
  constructor(view, animation) {
    this.zmy_1 = view;
    this.amz_1 = animation;
  }
}
class CenterAndSize {
  constructor(center, size) {
    this.um1_1 = center;
    this.vm1_1 = size;
  }
  jm() {
    return this.um1_1;
  }
  km() {
    return this.vm1_1;
  }
  toString() {
    return 'CenterAndSize(center=' + this.um1_1.toString() + ', size=' + this.vm1_1.toString() + ')';
  }
  hashCode() {
    var result = this.um1_1.hashCode();
    result = imul(result, 31) + this.vm1_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CenterAndSize))
      return false;
    if (!this.um1_1.equals(other.um1_1))
      return false;
    if (!this.vm1_1.equals(other.vm1_1))
      return false;
    return true;
  }
}
class LinearEasing {
  o9f(it) {
    return it;
  }
}
class makeGlowBitmap$Stop {
  constructor(t, c) {
    this.cmz_1 = t;
    this.dmz_1 = c;
  }
  toString() {
    return 'Stop(t=' + this.cmz_1 + ', c=' + RGBA__toString_impl_4lw6dp(this.dmz_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.cmz_1);
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.dmz_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof makeGlowBitmap$Stop))
      return false;
    if (!equals(this.cmz_1, other.cmz_1))
      return false;
    if (!(this.dmz_1 === other.dmz_1))
      return false;
    return true;
  }
}
class UrlReplayStartParams {
  constructor(replayCode, isSandboxGame, startFromAnswer, infoStep, replayVisibility) {
    startFromAnswer = startFromAnswer === VOID ? 0 : startFromAnswer;
    infoStep = infoStep === VOID ? null : infoStep;
    replayVisibility = replayVisibility === VOID ? ReplayVisibility_CurrentTeam_getInstance() : replayVisibility;
    this.plr_1 = replayCode;
    this.qlr_1 = isSandboxGame;
    this.rlr_1 = startFromAnswer;
    this.slr_1 = infoStep;
    this.tlr_1 = replayVisibility;
  }
  jm() {
    return this.plr_1;
  }
  km() {
    return this.qlr_1;
  }
  toString() {
    return 'UrlReplayStartParams(replayCode=' + this.plr_1.toString() + ', isSandboxGame=' + this.qlr_1 + ', startFromAnswer=' + this.rlr_1 + ', infoStep=' + this.slr_1 + ', replayVisibility=' + this.tlr_1.toString() + ')';
  }
  hashCode() {
    var result = this.plr_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.qlr_1) | 0;
    result = imul(result, 31) + this.rlr_1 | 0;
    result = imul(result, 31) + (this.slr_1 == null ? 0 : this.slr_1) | 0;
    result = imul(result, 31) + this.tlr_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrlReplayStartParams))
      return false;
    if (!this.plr_1.equals(other.plr_1))
      return false;
    if (!(this.qlr_1 === other.qlr_1))
      return false;
    if (!(this.rlr_1 === other.rlr_1))
      return false;
    if (!(this.slr_1 == other.slr_1))
      return false;
    if (!this.tlr_1.equals(other.tlr_1))
      return false;
    return true;
  }
}
class UrlContentReferenceParams {
  constructor(reference, expansions, chosen) {
    expansions = expansions === VOID ? null : expansions;
    chosen = chosen === VOID ? null : chosen;
    this.mmi_1 = reference;
    this.nmi_1 = expansions;
    this.omi_1 = chosen;
  }
  toString() {
    return 'UrlContentReferenceParams(reference=' + this.mmi_1 + ', expansions=' + this.nmi_1 + ', chosen=' + this.omi_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.mmi_1);
    result = imul(result, 31) + (this.nmi_1 == null ? 0 : getStringHashCode(this.nmi_1)) | 0;
    result = imul(result, 31) + (this.omi_1 == null ? 0 : getStringHashCode(this.omi_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrlContentReferenceParams))
      return false;
    if (!(this.mmi_1 === other.mmi_1))
      return false;
    if (!(this.nmi_1 == other.nmi_1))
      return false;
    if (!(this.omi_1 == other.omi_1))
      return false;
    return true;
  }
}
class UrlGameReconnectionParams {
  constructor(gameCode, teamId) {
    this.nlr_1 = gameCode;
    this.olr_1 = teamId;
  }
  jm() {
    return this.nlr_1;
  }
  km() {
    return this.olr_1;
  }
  toString() {
    return 'UrlGameReconnectionParams(gameCode=' + this.nlr_1.toString() + ', teamId=' + this.olr_1 + ')';
  }
  hashCode() {
    var result = this.nlr_1.hashCode();
    result = imul(result, 31) + (this.olr_1 == null ? 0 : this.olr_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UrlGameReconnectionParams))
      return false;
    if (!this.nlr_1.equals(other.nlr_1))
      return false;
    if (!(this.olr_1 == other.olr_1))
      return false;
    return true;
  }
}
class FadeUB extends UniformBlock {
  constructor() {
    FadeUB_instance = null;
    super(5);
    FadeUB_instance = this;
    var tmp = this;
    var tmp_0 = this.bew();
    var tmp_1 = KProperty1;
    tmp.imz_1 = tmp_0.vev(this, getPropertyCallableRef('u_FadeRatio', 1, tmp_1, VerticalEdgeFadeFilter$FadeUB$_get_u_FadeRatio_$ref_5ch4ot(), null));
  }
  jmz() {
    var tmp = KProperty1;
    return this.imz_1.yq(this, getPropertyCallableRef('u_FadeRatio', 1, tmp, VerticalEdgeFadeFilter$FadeUB$_get_u_FadeRatio_$ref_5ch4ot(), null));
  }
}
class Program extends BaseProgramProvider {
  constructor() {
    Program_instance = null;
    super();
    Program_instance = this;
    var tmp = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    var y = this_0.pf0(DefaultShaders_getInstance().ses_1);
    var fade = this_0.qf0(DefaultShaders_getInstance().ses_1);
    var cubicFade = this_0.rf0(DefaultShaders_getInstance().ses_1);
    this_0.jey(this_0.mey(), Companion_getInstance_6().yki(this_0, Companion_getInstance_6().xki(this_0)));
    this_0.jey(y, this_0.qf0(Companion_getInstance_6().zki(this_0)));
    this_0.jey(fade, this_0.ff0(this_0.wey(y, FadeUB_getInstance().jmz()), this_0.wey(this_0.uf0(this_0.pey(1.0), y), FadeUB_getInstance().jmz())));
    this_0.jey(fade, this_0.ef0(fade, this_0.pey(0.0), this_0.pey(1.0)));
    this_0.jey(cubicFade, this_0.ney(this_0.ney(fade, fade), fade));
    this_0.jey(this_0.mey(), this_0.ney(this_0.mey(), cubicFade));
    tmp.nmz_1 = FragmentShader(this_0.rey());
  }
  x7u() {
    return this.nmz_1;
  }
}
class VerticalEdgeFadeFilter extends ShaderFilter {
  constructor(fadeRatio) {
    fadeRatio = fadeRatio === VOID ? 0.08 : fadeRatio;
    super();
    this.vmz_1 = fadeRatio;
  }
  jkj() {
    return Program_getInstance();
  }
  hkj(ctx, filterScale) {
    super.hkj(ctx, filterScale);
    var tmp0 = ctx.ieo(FadeUB_getInstance());
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = tmp0.z6x();
      tmp0.efc(_unary__edvuaz + 1 | 0);
      tmp0.ffc(tmp0.z6x() + 1 | 0);
      var blockSize = tmp0.beo_1;
      var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
      var index1 = imul(tmp0.z6x(), blockSize);
      var texBlockSize = tmp0.yen_1.wev().s2();
      var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0.z6x(), texBlockSize);
      if (tmp0.z6x() > 0) {
        arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
      } else {
        arrayfill(tmp0.deo_1, 0, 0, blockSize);
      }
      var tmp0_0 = tmp0.yen_1;
      tmp0.eeo_1.kfc(tmp0_0.jmz(), this.vmz_1);
      if (true && tmp0.z6x() >= 1) {
        var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = tmp0.z6x();
          tmp0.efc(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
}
class VerticalScrollViewport extends ClipContainer {
  constructor(size, scrollWheelSpeed) {
    return new.target.amg(size, scrollWheelSpeed);
  }
  static amg(size, scrollWheelSpeed) {
    size = size === VOID ? Companion_getInstance_10().c9s_1 : size;
    scrollWheelSpeed = scrollWheelSpeed === VOID ? 10.0 : scrollWheelSpeed;
    var $this = this.xj5(size);
    $this.wmf_1 = scrollWheelSpeed;
    $this.xmf_1 = addTo(Container.fi2(), $this);
    $this.ymf_1 = 0.0;
    $this.zmf_1 = false;
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse($this);
    var dragging = {_v: false};
    var lastDragY = {_v: 0.0};
    $this$mouse.khx_1.w9y(VerticalScrollViewport$lambda($this));
    // Inline function 'korlibs.korge.input.MouseEvents.onDown' call
    var handler = VerticalScrollViewport$slambda($this, dragging, lastDragY);
    var tmp = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_0 = getPropertyCallableRef('down', 1, tmp, MouseEvents$_get_down_$ref_qneabi(), null).get($this$mouse);
    tmp_0.v9y(VerticalScrollViewport$lambda_0($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onMoveAnywhere' call
    var handler_0 = VerticalScrollViewport$slambda_0(dragging, $this, lastDragY);
    var tmp_1 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_2 = getPropertyCallableRef('moveAnywhere', 1, tmp_1, MouseEvents$_get_moveAnywhere_$ref_si2le4(), null).get($this$mouse);
    tmp_2.v9y(VerticalScrollViewport$lambda_1($this$mouse, handler_0));
    // Inline function 'korlibs.korge.input.MouseEvents.onUpAnywhere' call
    var handler_1 = VerticalScrollViewport$slambda_1(dragging);
    var tmp_3 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_4 = getPropertyCallableRef('upAnywhere', 1, tmp_3, MouseEvents$_get_upAnywhere_$ref_s41vu2(), null).get($this$mouse);
    tmp_4.v9y(VerticalScrollViewport$lambda_2($this$mouse, handler_1));
    return $this;
  }
  hmg(viewportHeight, edgeFadeRatio, initialContentTopY) {
    size(this, this.xmf_1.pig(), viewportHeight);
    this.ymf_1 = coerceAtMost(viewportHeight - this.xmf_1.rig(), 0.0);
    this.zmf_1 = this.xmf_1.rig() > viewportHeight;
    var tmp;
    if (!(initialContentTopY == null)) {
      tmp = coerceIn_1(-initialContentTopY, this.ymf_1, 0.0);
    } else {
      tmp = coerceAtMost(this.ymf_1, 0.0);
    }
    this.xmf_1.sif(tmp);
    var tmp_0;
    if (this.zmf_1 && !(edgeFadeRatio == null)) {
      tmp_0 = new VerticalEdgeFadeFilter(edgeFadeRatio);
    } else {
      tmp_0 = null;
    }
    set_filter(this, tmp_0);
  }
  hml(viewportHeight, edgeFadeRatio, initialContentTopY, $super) {
    edgeFadeRatio = edgeFadeRatio === VOID ? null : edgeFadeRatio;
    initialContentTopY = initialContentTopY === VOID ? null : initialContentTopY;
    var tmp;
    if ($super === VOID) {
      this.hmg(viewportHeight, edgeFadeRatio, initialContentTopY);
      tmp = Unit_instance;
    } else {
      tmp = $super.hmg.call(this, viewportHeight, edgeFadeRatio, initialContentTopY);
    }
    return tmp;
  }
  wmz(deltaY) {
    if (!this.zmf_1)
      return Unit_instance;
    this.xmf_1.sif(coerceIn_1(this.xmf_1.xea() + deltaY, this.ymf_1, 0.0));
  }
}
//endregion
function *animateAutoCursor(_this__u8e3s4, savedAnswer, preAnswerAnimations, $completion) {
  return yield* withCursorAutoAnimation(_this__u8e3s4, animateAutoCursor$slambda(_this__u8e3s4, preAnswerAnimations, savedAnswer), $completion);
}
function *animatePostAnswerAutoCursor(_this__u8e3s4, answerAnimations, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = answerAnimations.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.u6x().equals(AnimationInsertionType_AfterAnswer_getInstance())) {
      destination.d2(element);
    }
  }
  var postAnimations = destination;
  if (postAnimations.n1())
    return Unit_instance;
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(postAnimations, Collection)) {
      tmp = postAnimations.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$3 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = postAnimations.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (!(element_0 instanceof MapUiScalingAndPosition)) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
    }
    tmp$ret$3 = true;
  }
  if (tmp$ret$3) {
    var _iterator__ex2g4s_1 = postAnimations.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var insertion = _iterator__ex2g4s_1.r1();
      yield* animatePreAnswer(_this__u8e3s4, insertion, $completion);
    }
    return Unit_instance;
  }
  yield* withCursorAutoAnimation(_this__u8e3s4, animatePostAnswerAutoCursor$slambda(_this__u8e3s4, postAnimations), $completion);
  return Unit_instance;
}
function *animateCursorBeforeDialog(_this__u8e3s4, preAnswerAnimations, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = preAnswerAnimations.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.u6x().equals(AnimationInsertionType_BeforeAnswerDialog_getInstance())) {
      destination.d2(element);
    }
  }
  var insertions = destination;
  if (insertions.n1())
    return Unit_instance;
  yield* withCursorAutoAnimation(_this__u8e3s4, animateCursorBeforeDialog$slambda(insertions, _this__u8e3s4), $completion);
  return Unit_instance;
}
function *withCursorAutoAnimation(_this__u8e3s4, fn, $completion) {
  yield* initCursorIfNeeded(_this__u8e3s4, $completion);
  var tmp0_$receiver = _this__u8e3s4.kl4();
  var tmp0 = _this__u8e3s4.kl4();
  var tmp = KMutableProperty0;
  var tmp_0 = Image$_get_alpha_$ref_d2kncp(tmp0);
  // Inline function 'korlibs.korge.tween.get' call
  var this_0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, Image$_set_alpha_$ref_g89t1v(tmp0));
  var tmp1_vs = [new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
  var tmp2_easing = get_gameAnimations().ll4_1;
  var tmp3_time = get_gameAnimations().zl4_1;
  yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
  yield* fn($completion);
  var tmp4_$receiver = _this__u8e3s4.kl4();
  var tmp0_0 = _this__u8e3s4.kl4();
  var tmp_1 = KMutableProperty0;
  var tmp_2 = Image$_get_alpha_$ref_d2kncp(tmp0_0);
  // Inline function 'korlibs.korge.tween.get' call
  var this_1 = getPropertyCallableRef('alpha', 0, tmp_1, tmp_2, Image$_set_alpha_$ref_g89t1v(tmp0_0));
  var tmp5_vs = [new V2(this_1, 1.0, 0.0, _interpolate$ref(), true)];
  var tmp6_easing = get_gameAnimations().ll4_1;
  var tmp7_time = get_gameAnimations().zl4_1;
  yield* tween(tmp4_$receiver, tmp5_vs, tmp7_time, tmp6_easing, VOID, VOID, VOID, VOID, $completion);
  return Unit_instance;
}
function *animateAutoCursorImpl(_this__u8e3s4, preAnswerAnimations, savedAnswer, $completion) {
  var _iterator__ex2g4s = preAnswerAnimations.p1();
  while (_iterator__ex2g4s.q1()) {
    var insertion = _iterator__ex2g4s.r1();
    yield* animatePreAnswer(_this__u8e3s4, insertion, $completion);
  }
  var cursorEnd = {_v: _this__u8e3s4.kl4().wb5()};
  var tmp;
  var tmp_0;
  if (savedAnswer instanceof MovementToLocation) {
    var tmp0 = _this__u8e3s4.dl5();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = new BoardPosition(savedAnswer.v3g_1);
    tmp_0 = (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).u4(key);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = _this__u8e3s4.dl5().w4(new BoardPosition(savedAnswer.v3g_1));
  } else {
    var tmp_1 = _this__u8e3s4.dl5();
    tmp = tmp_1.w4(savedAnswer == null ? NullVariant_instance : savedAnswer);
  }
  var autoHighlight = tmp;
  var applyNextStep = autoHighlight == null ? null : autoHighlight.gl5_1;
  if (!(autoHighlight == null)) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$2 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$2, $completion);
    var view = autoHighlight.jm();
    var relativeCenter = autoHighlight.km();
    cursorEnd._v = view.oih(relativeCenter);
    yield* moveCursor(_this__u8e3s4, cursorEnd._v, autoHighlight, VOID, $completion);
  }
  var cursorClickHalfAnimationMs = 300;
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var cursorClickHalfAnimationTime = toDuration(cursorClickHalfAnimationMs, DurationUnit_MILLISECONDS_getInstance());
  yield* coroutineScope(animateAutoCursorImpl$slambda(cursorClickHalfAnimationMs, _this__u8e3s4, cursorClickHalfAnimationTime, cursorEnd), $completion);
  if (!(applyNextStep == null)) {
    yield* applyNextStep($completion);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$4 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$4, $completion);
    yield* animateAutoCursorImpl(_this__u8e3s4, preAnswerAnimations, savedAnswer, $completion);
    return Unit_instance;
  }
  return Unit_instance;
}
function *initCursorIfNeeded(_this__u8e3s4, $completion) {
  var initialized = _this__u8e3s4.il5();
  if (!initialized) {
    _this__u8e3s4.ul3_1 = yield* readSound(get_resourcesVfs().wi('BeastResources/Sounds/mouse-click.mp3'), VOID, VOID, $completion);
  }
  if (!initialized || !(_this__u8e3s4.vl3_1 === _this__u8e3s4.k3q())) {
    var initialPos = toPoint(get_gameLayout().gl6_1.l9s(2));
    if (initialized) {
      initialPos = _this__u8e3s4.kl4().wb5();
      _this__u8e3s4.ol6().cif(_this__u8e3s4.kl4());
    }
    _this__u8e3s4.vl3_1 = _this__u8e3s4.k3q();
    var bitmap = yield* (yield* _this__u8e3s4.pl6().cl7(_this__u8e3s4.ql6(), $completion)).m1q($completion);
    var tmp = _this__u8e3s4;
    // Inline function 'kotlin.apply' call
    var this_0 = addTo(Image.lk7(bitmap), _this__u8e3s4.ol6());
    if (_this__u8e3s4.ql6()) {
      Companion_getInstance_8();
      // Inline function 'korlibs.math.geom.Companion.fromRatio' call
      var ratio = -0.05;
      // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
      var ratio_0 = toRatio(ratio);
      var tmp$ret$3 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
      var tmp$ret$2 = _Angle___init__impl__g23q1m(tmp$ret$3);
      this_0.eig(tmp$ret$2);
    } else {
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_7();
      var tmp$ret$4 = Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0));
      this_0.ijb(tmp$ret$4);
      Companion_getInstance_8();
      // Inline function 'korlibs.math.geom.Companion.fromRatio' call
      var ratio_1 = -0.125;
      // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
      var ratio_2 = toRatio(ratio_1);
      var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
      var tmp$ret$5 = _Angle___init__impl__g23q1m(tmp$ret$6);
      this_0.eig(tmp$ret$5);
    }
    this_0.fcw(initialPos);
    toHeight(this_0, get_gameLayout().dl6_1);
    tmp.tl3_1 = this_0;
  }
  return Unit_instance;
}
function *moveCursor(_this__u8e3s4, cursorDestination, autoHighlight, speedupKey, $completion) {
  autoHighlight = autoHighlight === VOID ? null : autoHighlight;
  speedupKey = speedupKey === VOID ? 20 : speedupKey;
  var done = {_v: false};
  yield* coroutineScope(moveCursor$slambda(autoHighlight, done, _this__u8e3s4, cursorDestination, speedupKey), $completion);
  return Unit_instance;
}
function globalRect(view, highlightRect) {
  var globalTopLeft = view.oih(highlightRect.n9i());
  var globalBottomRight = view.oih(highlightRect.p9i());
  var globalRect = Companion_getInstance_9().i9i(globalTopLeft, globalBottomRight);
  return globalRect;
}
function *moveCursorOverLocationAndHighlight(_this__u8e3s4, position, $completion) {
  yield* moveCursorOverLocation(_this__u8e3s4, position, $completion);
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(50, DurationUnit_MILLISECONDS_getInstance());
  yield* delay(tmp$ret$0, $completion);
  _this__u8e3s4.gl2_1.hl8(position);
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  yield* delay(tmp$ret$1, $completion);
  _this__u8e3s4.gl2_1.il8();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$2 = toDuration(50, DurationUnit_MILLISECONDS_getInstance());
  yield* delay(tmp$ret$2, $completion);
  return Unit_instance;
}
function *moveCursorOverLocation(_this__u8e3s4, position, $completion) {
  var tmp0_elvis_lhs = _this__u8e3s4.gl2_1.fl7_1.jl8(position);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var locationArea = tmp;
  var globalP = _this__u8e3s4.gl2_1.hl7_1.oih(locationArea.ml8_1);
  yield* /*#__NOINLINE__*/moveCursor(_this__u8e3s4, globalP, VOID, VOID, $completion);
  return Unit_instance;
}
function animateAutoCursor$slambda($this_animateAutoCursor, $preAnswerAnimations, $savedAnswer) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/animateAutoCursorImpl($this_animateAutoCursor, $preAnswerAnimations, $savedAnswer, $completion);
    return Unit_instance;
  }, 0);
}
function animatePostAnswerAutoCursor$slambda($this_animatePostAnswerAutoCursor, $postAnimations) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/initCursorIfNeeded($this_animatePostAnswerAutoCursor, $completion);
    var _iterator__ex2g4s = $postAnimations.p1();
    while (_iterator__ex2g4s.q1()) {
      var insertion = _iterator__ex2g4s.r1();
      yield* animatePreAnswer($this_animatePostAnswerAutoCursor, insertion, $completion);
    }
    return Unit_instance;
  }, 0);
}
function animateCursorBeforeDialog$slambda($insertions, $this_animateCursorBeforeDialog) {
  return constructCallableReference(function *($completion) {
    var _iterator__ex2g4s = $insertions.p1();
    while (_iterator__ex2g4s.q1()) {
      var insertion = _iterator__ex2g4s.r1();
      yield* animatePreAnswer($this_animateCursorBeforeDialog, insertion, $completion);
    }
    return Unit_instance;
  }, 0);
}
function Image$_get_alpha_$ref_d2kncp(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 534, VOID, [p0]);
}
function Image$_set_alpha_$ref_g89t1v(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 535, VOID, [p0]);
}
function _interpolate$ref() {
  return constructCallableReference((p0, p1, p2) => _interpolate(p0.v9f_1, p1, p2), 3, 0, 536, '_interpolate');
}
function animateAutoCursorImpl$slambda$slambda($cursorClickHalfAnimationMs, $this_animateAutoCursorImpl) {
  return constructCallableReference(function *($this$launch, $completion) {
    Companion_getInstance();
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = $cursorClickHalfAnimationMs - 100 | 0;
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    yield* $this_animateAutoCursorImpl.ol8().pkz(VOID, $completion);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$1, $completion);
    return Unit_instance;
  }, 1);
}
function Image$_get_rotation_$ref_ewgs57(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new Angle(tmp0.fig());
  }, 0, 0, 537, VOID, [p0]);
}
function Image$_set_rotation_$ref_ug7ipb(p0) {
  return constructCallableReference((p0_0) => {
    p0.eig(p0_0.v9g_1);
    return Unit_instance;
  }, 1, 0, 538, VOID, [p0]);
}
function _interpolateAngle$ref() {
  return constructCallableReference((p0, p1, p2) => new Angle(_interpolateAngle(p0.v9f_1, p1.v9g_1, p2.v9g_1)), 3, 0, 539, '_interpolateAngle');
}
function Image$_get_pos_$ref_wxqx6l(p0) {
  return constructCallableReference(() => p0.wb5(), 0, 0, 540, VOID, [p0]);
}
function Image$_set_pos_$ref_7bimtl(p0) {
  return constructCallableReference((p0_0) => {
    p0.fcw(p0_0);
    return Unit_instance;
  }, 1, 0, 541, VOID, [p0]);
}
function Image$_get_scaledSize_$ref_a05za0(p0) {
  return constructCallableReference(() => p0.nig(), 0, 0, 542, VOID, [p0]);
}
function Image$_set_scaledSize_$ref_zhumno(p0) {
  return constructCallableReference((p0_0) => {
    p0.mig(p0_0);
    return Unit_instance;
  }, 1, 0, 543, VOID, [p0]);
}
function animateAutoCursorImpl$slambda$slambda_0($this_animateAutoCursorImpl, $cursorClickHalfAnimationTime, $cursorEnd) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    if ($this_animateAutoCursorImpl.ql6()) {
      var s = $this_animateAutoCursorImpl.kl4().nig();
      var shift = s.k9i_1 / 2;
      var pBeforeClick = Vector2D.t9g(shift, -shift);
      var curRot = $this_animateAutoCursorImpl.kl4().fig();
      $this_animateAutoCursorImpl.kl4().ijb(Companion_getInstance_7().c9g_1);
      var tmp0_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0 = $this_animateAutoCursorImpl.kl4();
      var tmp_0 = KMutableProperty0;
      var tmp_1 = Image$_get_rotation_$ref_ewgs57(tmp0);
      var tmp0_0 = getPropertyCallableRef('rotation', 0, tmp_0, tmp_1, Image$_set_rotation_$ref_ug7ipb(tmp0));
      Companion_getInstance_8();
      // Inline function 'korlibs.math.geom.Companion.fromRatio' call
      // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
      var ratio = Ratio__plus_impl_pm43pk(_Angle___get_ratio__impl__ap3on4(curRot), _Ratio___init__impl__9mwvn2(-0.15));
      var tmp$ret$1 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
      // Inline function 'korlibs.korge.tween.get' call
      var end = _Angle___init__impl__g23q1m(tmp$ret$1);
      var tmp_2 = new V2(tmp0_0, new Angle(curRot), new Angle(end), _interpolateAngle$ref(), true);
      var tmp0_1 = $this_animateAutoCursorImpl.kl4();
      var tmp_3 = KMutableProperty0;
      var tmp_4 = Image$_get_pos_$ref_wxqx6l(tmp0_1);
      var tmp_5 = getPropertyCallableRef('pos', 0, tmp_3, tmp_4, Image$_set_pos_$ref_7bimtl(tmp0_1));
      var tmp_6 = $this_animateAutoCursorImpl.kl4().wb5();
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var this_0 = $this_animateAutoCursorImpl.kl4().wb5();
      var tmp$ret$3 = Vector2D.t9g(this_0.r9g_1 + pBeforeClick.r9g_1, this_0.s9g_1 + pBeforeClick.s9g_1);
      var tmp1_vs = [tmp_2, get(tmp_5, tmp_6, tmp$ret$3)];
      var tmp2_easing = get_gameAnimations().ll4_1;
      var tmp3_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
      var tmp4_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_2 = $this_animateAutoCursorImpl.kl4();
      var tmp_7 = KMutableProperty0;
      var tmp_8 = Image$_get_rotation_$ref_ewgs57(tmp0_2);
      var tmp0_3 = getPropertyCallableRef('rotation', 0, tmp_7, tmp_8, Image$_set_rotation_$ref_ug7ipb(tmp0_2));
      var tmp2 = $this_animateAutoCursorImpl.kl4().fig();
      Companion_getInstance_8();
      // Inline function 'korlibs.math.geom.Companion.fromRatio' call
      // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
      var ratio_0 = Ratio__plus_impl_pm43pk(_Angle___get_ratio__impl__ap3on4($this_animateAutoCursorImpl.kl4().fig()), _Ratio___init__impl__9mwvn2(-0.05));
      var tmp$ret$5 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
      // Inline function 'korlibs.korge.tween.get' call
      var end_0 = _Angle___init__impl__g23q1m(tmp$ret$5);
      var tmp_9 = new V2(tmp0_3, new Angle(tmp2), new Angle(end_0), _interpolateAngle$ref(), true);
      var tmp0_4 = $this_animateAutoCursorImpl.kl4();
      var tmp_10 = KMutableProperty0;
      var tmp_11 = Image$_get_pos_$ref_wxqx6l(tmp0_4);
      var tmp5_vs = [tmp_9, get(getPropertyCallableRef('pos', 0, tmp_10, tmp_11, Image$_set_pos_$ref_7bimtl(tmp0_4)), $this_animateAutoCursorImpl.kl4().wb5(), $cursorEnd._v)];
      var tmp6_easing = get_gameAnimations().ll4_1;
      var tmp7_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp4_$receiver, tmp5_vs, tmp7_time, tmp6_easing, VOID, VOID, VOID, VOID, $completion);
      var tmp8_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_5 = $this_animateAutoCursorImpl.kl4();
      var tmp_12 = KMutableProperty0;
      var tmp_13 = Image$_get_rotation_$ref_ewgs57(tmp0_5);
      var tmp0_6 = getPropertyCallableRef('rotation', 0, tmp_12, tmp_13, Image$_set_rotation_$ref_ug7ipb(tmp0_5));
      var tmp2_0 = $this_animateAutoCursorImpl.kl4().fig();
      Companion_getInstance_8();
      // Inline function 'korlibs.math.geom.Companion.fromRatio' call
      // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
      var ratio_1 = Ratio__plus_impl_pm43pk(_Angle___get_ratio__impl__ap3on4($this_animateAutoCursorImpl.kl4().fig()), _Ratio___init__impl__9mwvn2(0.15));
      var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
      // Inline function 'korlibs.korge.tween.get' call
      var end_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
      var tmp_14 = new V2(tmp0_6, new Angle(tmp2_0), new Angle(end_1), _interpolateAngle$ref(), true);
      var tmp0_7 = $this_animateAutoCursorImpl.kl4();
      var tmp_15 = KMutableProperty0;
      var tmp_16 = Image$_get_pos_$ref_wxqx6l(tmp0_7);
      var tmp_17 = getPropertyCallableRef('pos', 0, tmp_15, tmp_16, Image$_set_pos_$ref_7bimtl(tmp0_7));
      var tmp_18 = $this_animateAutoCursorImpl.kl4().wb5();
      var tmp0_8 = $cursorEnd._v;
      // Inline function 'korlibs.math.geom.Vector2D.div' call
      // Inline function 'korlibs.math.geom.Vector2D.div' call
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var that = Vector2D.t9g(pBeforeClick.r9g_1 / 2, pBeforeClick.s9g_1 / 2);
      var tmp$ret$12 = Vector2D.t9g(tmp0_8.r9g_1 + that.r9g_1, tmp0_8.s9g_1 + that.s9g_1);
      var tmp9_vs = [tmp_14, get(tmp_17, tmp_18, tmp$ret$12)];
      var tmp10_easing = get_gameAnimations().ll4_1;
      var tmp11_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp8_$receiver, tmp9_vs, tmp11_time, tmp10_easing, VOID, VOID, VOID, VOID, $completion);
      var tmp12_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_9 = $this_animateAutoCursorImpl.kl4();
      var tmp_19 = KMutableProperty0;
      var tmp_20 = Image$_get_rotation_$ref_ewgs57(tmp0_9);
      var tmp0_10 = getPropertyCallableRef('rotation', 0, tmp_19, tmp_20, Image$_set_rotation_$ref_ug7ipb(tmp0_9));
      // Inline function 'korlibs.korge.tween.get' call
      var initial = $this_animateAutoCursorImpl.kl4().fig();
      var tmp_21 = new V2(tmp0_10, new Angle(initial), new Angle(curRot), _interpolateAngle$ref(), true);
      var tmp0_11 = $this_animateAutoCursorImpl.kl4();
      var tmp_22 = KMutableProperty0;
      var tmp_23 = Image$_get_pos_$ref_wxqx6l(tmp0_11);
      var tmp13_vs = [tmp_21, get(getPropertyCallableRef('pos', 0, tmp_22, tmp_23, Image$_set_pos_$ref_7bimtl(tmp0_11)), $this_animateAutoCursorImpl.kl4().wb5(), $cursorEnd._v)];
      var tmp14_easing = get_gameAnimations().ll4_1;
      var tmp15_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp12_$receiver, tmp13_vs, tmp15_time, tmp14_easing, VOID, VOID, VOID, VOID, $completion);
      $this_animateAutoCursorImpl.kl4().eig(curRot);
      $this_animateAutoCursorImpl.kl4().fcw($cursorEnd._v);
      $this_animateAutoCursorImpl.kl4().ijb(Companion_getInstance_7().c9g_1);
      tmp = Unit_instance;
    } else {
      var curRot_0 = $this_animateAutoCursorImpl.kl4().fig();
      var s_0 = $this_animateAutoCursorImpl.kl4().nig();
      var shift_0 = s_0.k9i_1 / 4;
      var pBeforeClick_0 = Vector2D.t9g(shift_0, -shift_0);
      var tmp16_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_12 = $this_animateAutoCursorImpl.kl4();
      var tmp_24 = KMutableProperty0;
      var tmp_25 = Image$_get_rotation_$ref_ewgs57(tmp0_12);
      var tmp0_13 = getPropertyCallableRef('rotation', 0, tmp_24, tmp_25, Image$_set_rotation_$ref_ug7ipb(tmp0_12));
      Companion_getInstance_8();
      // Inline function 'korlibs.math.geom.Companion.fromRatio' call
      // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
      var ratio_2 = Ratio__plus_impl_pm43pk(_Angle___get_ratio__impl__ap3on4(curRot_0), _Ratio___init__impl__9mwvn2(-0.2));
      var tmp$ret$15 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
      // Inline function 'korlibs.korge.tween.get' call
      var end_2 = _Angle___init__impl__g23q1m(tmp$ret$15);
      var tmp_26 = new V2(tmp0_13, new Angle(curRot_0), new Angle(end_2), _interpolateAngle$ref(), true);
      var tmp0_14 = $this_animateAutoCursorImpl.kl4();
      var tmp_27 = KMutableProperty0;
      var tmp_28 = Image$_get_pos_$ref_wxqx6l(tmp0_14);
      var tmp_29 = getPropertyCallableRef('pos', 0, tmp_27, tmp_28, Image$_set_pos_$ref_7bimtl(tmp0_14));
      var tmp_30 = $this_animateAutoCursorImpl.kl4().wb5();
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var this_1 = $this_animateAutoCursorImpl.kl4().wb5();
      var tmp$ret$17 = Vector2D.t9g(this_1.r9g_1 + pBeforeClick_0.r9g_1, this_1.s9g_1 + pBeforeClick_0.s9g_1);
      var tmp17_vs = [tmp_26, get(tmp_29, tmp_30, tmp$ret$17)];
      var tmp18_easing = get_gameAnimations().ll4_1;
      var tmp19_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp16_$receiver, tmp17_vs, tmp19_time, tmp18_easing, VOID, VOID, VOID, VOID, $completion);
      var tmp20_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_15 = $this_animateAutoCursorImpl.kl4();
      var tmp_31 = KMutableProperty0;
      var tmp_32 = Image$_get_pos_$ref_wxqx6l(tmp0_15);
      var tmp_33 = get(getPropertyCallableRef('pos', 0, tmp_31, tmp_32, Image$_set_pos_$ref_7bimtl(tmp0_15)), $this_animateAutoCursorImpl.kl4().wb5(), $cursorEnd._v);
      var tmp0_16 = $this_animateAutoCursorImpl.kl4();
      var tmp_34 = KMutableProperty0;
      var tmp_35 = Image$_get_scaledSize_$ref_a05za0(tmp0_16);
      var tmp21_vs = [tmp_33, get_0(getPropertyCallableRef('scaledSize', 0, tmp_34, tmp_35, Image$_set_scaledSize_$ref_zhumno(tmp0_16)), s_0, s_0.b9q(0.8))];
      var tmp22_easing = get_gameAnimations().ll4_1;
      var tmp23_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp20_$receiver, tmp21_vs, tmp23_time, tmp22_easing, VOID, VOID, VOID, VOID, $completion);
      var tmp24_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_17 = $this_animateAutoCursorImpl.kl4();
      var tmp_36 = KMutableProperty0;
      var tmp_37 = Image$_get_pos_$ref_wxqx6l(tmp0_17);
      var tmp_38 = getPropertyCallableRef('pos', 0, tmp_36, tmp_37, Image$_set_pos_$ref_7bimtl(tmp0_17));
      var tmp_39 = $this_animateAutoCursorImpl.kl4().wb5();
      var tmp0_18 = $cursorEnd._v;
      // Inline function 'korlibs.math.geom.Vector2D.div' call
      // Inline function 'korlibs.math.geom.Vector2D.div' call
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var that_0 = Vector2D.t9g(pBeforeClick_0.r9g_1 / 2, pBeforeClick_0.s9g_1 / 2);
      var tmp$ret$20 = Vector2D.t9g(tmp0_18.r9g_1 + that_0.r9g_1, tmp0_18.s9g_1 + that_0.s9g_1);
      var tmp_40 = get(tmp_38, tmp_39, tmp$ret$20);
      var tmp0_19 = $this_animateAutoCursorImpl.kl4();
      var tmp_41 = KMutableProperty0;
      var tmp_42 = Image$_get_scaledSize_$ref_a05za0(tmp0_19);
      var tmp25_vs = [tmp_40, get_0(getPropertyCallableRef('scaledSize', 0, tmp_41, tmp_42, Image$_set_scaledSize_$ref_zhumno(tmp0_19)), s_0.b9q(0.8), s_0)];
      var tmp26_easing = get_gameAnimations().ll4_1;
      var tmp27_time = Duration__div_impl_dknbf4($cursorClickHalfAnimationTime, 2);
      yield* tween(tmp24_$receiver, tmp25_vs, tmp27_time, tmp26_easing, VOID, VOID, VOID, VOID, $completion);
      var tmp28_$receiver = $this_animateAutoCursorImpl.kl4();
      var tmp0_20 = $this_animateAutoCursorImpl.kl4();
      var tmp_43 = KMutableProperty0;
      var tmp_44 = Image$_get_rotation_$ref_ewgs57(tmp0_20);
      var tmp0_21 = getPropertyCallableRef('rotation', 0, tmp_43, tmp_44, Image$_set_rotation_$ref_ug7ipb(tmp0_20));
      // Inline function 'korlibs.korge.tween.get' call
      var initial_0 = $this_animateAutoCursorImpl.kl4().fig();
      var tmp_45 = new V2(tmp0_21, new Angle(initial_0), new Angle(curRot_0), _interpolateAngle$ref(), true);
      var tmp0_22 = $this_animateAutoCursorImpl.kl4();
      var tmp_46 = KMutableProperty0;
      var tmp_47 = Image$_get_pos_$ref_wxqx6l(tmp0_22);
      var tmp29_vs = [tmp_45, get(getPropertyCallableRef('pos', 0, tmp_46, tmp_47, Image$_set_pos_$ref_7bimtl(tmp0_22)), $this_animateAutoCursorImpl.kl4().wb5(), $cursorEnd._v)];
      var tmp30_easing = get_gameAnimations().ll4_1;
      yield* tween(tmp28_$receiver, tmp29_vs, $cursorClickHalfAnimationTime, tmp30_easing, VOID, VOID, VOID, VOID, $completion);
      $this_animateAutoCursorImpl.kl4().fcw($cursorEnd._v);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function animateAutoCursorImpl$slambda($cursorClickHalfAnimationMs, $this_animateAutoCursorImpl, $cursorClickHalfAnimationTime, $cursorEnd) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    launch($this$coroutineScope, VOID, VOID, animateAutoCursorImpl$slambda$slambda($cursorClickHalfAnimationMs, $this_animateAutoCursorImpl));
    return launch($this$coroutineScope, VOID, VOID, animateAutoCursorImpl$slambda$slambda_0($this_animateAutoCursorImpl, $cursorClickHalfAnimationTime, $cursorEnd));
  }, 1);
}
function moveCursor$slambda$slambda($autoHighlight, $done, $this_moveCursor) {
  return constructCallableReference(function *($this$launch, $completion) {
    var highlightRect = $autoHighlight.hl5_1;
    var view = $autoHighlight.el5_1;
    var globalRect_0 = globalRect(view, highlightRect);
    while (!$done._v) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(17, DurationUnit_MILLISECONDS_getInstance());
      yield* delay(tmp$ret$0, $completion);
      if (globalRect_0.k9j($this_moveCursor.kl4().wb5())) {
        if (isInterface(view, HoverableUiElement)) {
          view.pl8(true);
          view.ql8();
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function moveCursor$slambda$slambda_0($this_moveCursor, $cursorDestination, $speedupKey, $done) {
  return constructCallableReference(function *($this$launch, $completion) {
    var cur = $this_moveCursor.kl4().wb5();
    var tmp0_$receiver = $this_moveCursor.kl4();
    var tmp0 = $this_moveCursor.kl4();
    var tmp = KMutableProperty0;
    var tmp_0 = Image$_get_pos_$ref_wxqx6l(tmp0);
    var tmp1_vs = [get(getPropertyCallableRef('pos', 0, tmp, tmp_0, Image$_set_pos_$ref_7bimtl(tmp0)), cur, $cursorDestination)];
    var tmp2_easing = get_gameAnimations().ll4_1;
    Companion_getInstance();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = $cursorDestination;
    // Inline function 'kotlin.math.sqrt' call
    var x = Vector2D.t9g(cur.r9g_1 - that.r9g_1, cur.s9g_1 - that.s9g_1).a();
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = Math.sqrt(x) * $speedupKey;
    var tmp3_time = toDuration_0(this_0, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
    $done._v = true;
    return Unit_instance;
  }, 1);
}
function moveCursor$slambda($autoHighlight, $done, $this_moveCursor, $cursorDestination, $speedupKey) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp;
    if (!($autoHighlight == null)) {
      launch($this$coroutineScope, VOID, VOID, moveCursor$slambda$slambda($autoHighlight, $done, $this_moveCursor));
      tmp = Unit_instance;
    }
    return launch($this$coroutineScope, VOID, VOID, moveCursor$slambda$slambda_0($this_moveCursor, $cursorDestination, $speedupKey, $done));
  }, 1);
}
function AwaitingGameReloadScene$sceneInit$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* this$0.bl9_1.udx($completion);
    return Unit_instance;
  }, 1);
}
function recoveryTestImage($this, title, description, kind) {
  var tmp0 = $this.bl7_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var key = kind + '/' + title;
  var value = tmp0.w4(key);
  var tmp;
  if (value == null) {
    var lines = mutableListOf(['']);
    var _iterator__ex2g4s = split(description, charArrayOf([_Char___init__impl__6a9atx(32)])).p1();
    while (_iterator__ex2g4s.q1()) {
      var word = _iterator__ex2g4s.r1();
      if ((last(lines).length + word.length | 0) > 30) {
        // Inline function 'kotlin.collections.plusAssign' call
        lines.d2('');
      }
      var tmp_0 = get_lastIndex(lines);
      // Inline function 'kotlin.text.trim' call
      var this_0 = last(lines) + ' ' + word;
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      lines.e5(tmp_0, tmp$ret$3);
    }
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.ecb(600, 840, Colors_getInstance().qci('#182533'));
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.wc1_1;
    if (true) {
      this_1.fc2();
    }
    var result;
    try {
      var ctx = this_1.oc9(true);
      try {
        var tmp2 = 'RECOVERY TEST';
        var tmp4 = Vector2D.a9k(35, 70);
        var tmp6 = get_DefaultTtfFont();
        var tmp11 = new RGBA(Colors_getInstance().qci('#ffcd70'));
        // Inline function 'korlibs.image.vector.Context2d.fillText' call
        var align = ctx.rdq();
        var tmp331_size = numberToDouble(42);
        ctx.adr(tmp2, tmp4, true, VOID, tmp6, tmp331_size, VOID, align, VOID, tmp11);
        var tmp4_0 = Vector2D.a9k(35, 120);
        var tmp6_0 = get_DefaultTtfFont();
        var tmp11_0 = new RGBA(Colors_getInstance().zc2_1);
        // Inline function 'korlibs.image.vector.Context2d.fillText' call
        var align_0 = ctx.rdq();
        var tmp331_size_0 = numberToDouble(23);
        ctx.adr(kind, tmp4_0, true, VOID, tmp6_0, tmp331_size_0, VOID, align_0, VOID, tmp11_0);
        var tmp4_1 = Vector2D.a9k(35, 205);
        var tmp6_1 = get_DefaultTtfFont();
        var tmp11_1 = new RGBA(Colors_getInstance().zc2_1);
        // Inline function 'korlibs.image.vector.Context2d.fillText' call
        var align_1 = ctx.rdq();
        var tmp331_size_1 = numberToDouble(36);
        ctx.adr(title, tmp4_1, true, VOID, tmp6_1, tmp331_size_1, VOID, align_1, VOID, tmp11_1);
        var iterator = lines.p1();
        var index = 0;
        while (iterator.q1()) {
          var index_0 = index;
          index = index + 1 | 0;
          var line = iterator.r1();
          var tmp4_2 = Vector2D.a9k(35, 285 + imul(index_0, 38) | 0);
          var tmp6_2 = get_DefaultTtfFont();
          var tmp11_2 = new RGBA(Colors_getInstance().zc2_1);
          // Inline function 'korlibs.image.vector.Context2d.fillText' call
          var align_2 = ctx.rdq();
          var tmp331_size_2 = numberToDouble(29);
          ctx.adr(line, tmp4_2, true, VOID, tmp6_2, tmp331_size_2, VOID, align_2, VOID, tmp11_2);
        }
        var tmp2_0 = 'Deliberate internal error';
        var tmp4_3 = Vector2D.a9k(35, 770);
        var tmp6_3 = get_DefaultTtfFont();
        var tmp11_3 = new RGBA(Colors_getInstance().qci('#ffcd70'));
        // Inline function 'korlibs.image.vector.Context2d.fillText' call
        var align_3 = ctx.rdq();
        var tmp331_size_3 = numberToDouble(28);
        ctx.adr(tmp2_0, tmp4_3, true, VOID, tmp6_3, tmp331_size_3, VOID, align_3, VOID, tmp11_3);
        var tmp2_1 = 'Sandbox diagnostics only';
        var tmp4_4 = Vector2D.a9k(35, 810);
        var tmp6_4 = get_DefaultTtfFont();
        var tmp11_4 = new RGBA(Colors_getInstance().zc2_1);
        // Inline function 'korlibs.image.vector.Context2d.fillText' call
        var align_4 = ctx.rdq();
        var tmp331_size_4 = numberToDouble(25);
        ctx.adr(tmp2_1, tmp4_4, true, VOID, tmp6_4, tmp331_size_4, VOID, align_4, VOID, tmp11_4);
      }finally {
        ctx.u1o();
      }
    }finally {
      result = true ? this_1.hc2(rect) : 0;
    }
    var answer = CompletableDeferred(this_1);
    tmp0.b5(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function fullCharacterPrefix($this, card) {
  var tmp0_subject = card.t37();
  var tmp;
  if (isInterface(tmp0_subject, HunterCharacter)) {
    tmp = 'Hunters';
  } else {
    tmp = 'Beasts';
  }
  var prefix = tmp;
  var fullPrefix = prefix + '/' + getKClassFromExpression(card.t37()).j1();
  return fullPrefix;
}
function suffixForFeatheredKing($this, gameState) {
  var tmp;
  var tmp_0;
  if (gameState == null) {
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.with' call
    tmp_0 = !get_isReborn(gameState, get_featheredKingBeast(gameState));
  }
  if (tmp_0) {
    tmp = '-unborn';
  } else {
    tmp = '-reborn';
  }
  return tmp;
}
var InterfaceIcon_Flee_instance;
var InterfaceIcon_StrictPlay_instance;
var InterfaceIcon_MagnifyingGlass_instance;
var InterfaceIcon_Play_instance;
var InterfaceIcon_PlayStep_instance;
var InterfaceIcon_Pause_instance;
var InterfaceIcon_Back_instance;
var InterfaceIcon_Inaccessible_instance;
var InterfaceIcon_Cancel_instance;
var InterfaceIcon_entriesInitialized;
function InterfaceIcon_initEntries() {
  if (InterfaceIcon_entriesInitialized)
    return Unit_instance;
  InterfaceIcon_entriesInitialized = true;
  InterfaceIcon_Flee_instance = new InterfaceIcon('Flee', 0, 'move');
  InterfaceIcon_StrictPlay_instance = new InterfaceIcon('StrictPlay', 1, 'strict');
  InterfaceIcon_MagnifyingGlass_instance = new InterfaceIcon('MagnifyingGlass', 2, 'magnifying-glass');
  InterfaceIcon_Play_instance = new InterfaceIcon('Play', 3, 'play');
  InterfaceIcon_PlayStep_instance = new InterfaceIcon('PlayStep', 4, 'play-step');
  InterfaceIcon_Pause_instance = new InterfaceIcon('Pause', 5, 'pause');
  InterfaceIcon_Back_instance = new InterfaceIcon('Back', 6, 'back');
  InterfaceIcon_Inaccessible_instance = new InterfaceIcon('Inaccessible', 7, 'inaccessible');
  InterfaceIcon_Cancel_instance = new InterfaceIcon('Cancel', 8, 'cancel');
}
var GeneralTokens_OneDamage_instance;
var GeneralTokens_ThreeDamages_instance;
var GeneralTokens_OneGrudge_instance;
var GeneralTokens_ThreeGrudges_instance;
var GeneralTokens_AncientPower_instance;
var GeneralTokens_Fire_instance;
var GeneralTokens_SettlerContour_instance;
var GeneralTokens_RuinHunter_instance;
var GeneralTokens_RuinBeast_instance;
var GeneralTokens_RuinNeutral_instance;
var GeneralTokens_RedSign_instance;
var GeneralTokens_BlueSign_instance;
var GeneralTokens_SummonActivation_instance;
var GeneralTokens_TrapSign_instance;
var GeneralTokens_ReactionSign_instance;
var GeneralTokens_Shield_instance;
var GeneralTokens_BloodDrop_instance;
var GeneralTokens_LifeForce_instance;
var GeneralTokens_SnareTrap_instance;
var GeneralTokens_Haze_instance;
function values() {
  return [GeneralTokens_OneDamage_getInstance(), GeneralTokens_ThreeDamages_getInstance(), GeneralTokens_OneGrudge_getInstance(), GeneralTokens_ThreeGrudges_getInstance(), GeneralTokens_AncientPower_getInstance(), GeneralTokens_Fire_getInstance(), GeneralTokens_SettlerContour_getInstance(), GeneralTokens_RuinHunter_getInstance(), GeneralTokens_RuinBeast_getInstance(), GeneralTokens_RuinNeutral_getInstance(), GeneralTokens_RedSign_getInstance(), GeneralTokens_BlueSign_getInstance(), GeneralTokens_SummonActivation_getInstance(), GeneralTokens_TrapSign_getInstance(), GeneralTokens_ReactionSign_getInstance(), GeneralTokens_Shield_getInstance(), GeneralTokens_BloodDrop_getInstance(), GeneralTokens_LifeForce_getInstance(), GeneralTokens_SnareTrap_getInstance(), GeneralTokens_Haze_getInstance()];
}
function get_entries_6() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var GeneralTokens_entriesInitialized;
function GeneralTokens_initEntries() {
  if (GeneralTokens_entriesInitialized)
    return Unit_instance;
  GeneralTokens_entriesInitialized = true;
  GeneralTokens_OneDamage_instance = new GeneralTokens('OneDamage', 0);
  GeneralTokens_ThreeDamages_instance = new GeneralTokens('ThreeDamages', 1);
  GeneralTokens_OneGrudge_instance = new GeneralTokens('OneGrudge', 2);
  GeneralTokens_ThreeGrudges_instance = new GeneralTokens('ThreeGrudges', 3);
  GeneralTokens_AncientPower_instance = new GeneralTokens('AncientPower', 4);
  GeneralTokens_Fire_instance = new GeneralTokens('Fire', 5);
  GeneralTokens_SettlerContour_instance = new GeneralTokens('SettlerContour', 6);
  GeneralTokens_RuinHunter_instance = new GeneralTokens('RuinHunter', 7);
  GeneralTokens_RuinBeast_instance = new GeneralTokens('RuinBeast', 8);
  GeneralTokens_RuinNeutral_instance = new GeneralTokens('RuinNeutral', 9);
  GeneralTokens_RedSign_instance = new GeneralTokens('RedSign', 10);
  GeneralTokens_BlueSign_instance = new GeneralTokens('BlueSign', 11);
  GeneralTokens_SummonActivation_instance = new GeneralTokens('SummonActivation', 12);
  GeneralTokens_TrapSign_instance = new GeneralTokens('TrapSign', 13);
  GeneralTokens_ReactionSign_instance = new GeneralTokens('ReactionSign', 14);
  GeneralTokens_Shield_instance = new GeneralTokens('Shield', 15);
  GeneralTokens_BloodDrop_instance = new GeneralTokens('BloodDrop', 16);
  GeneralTokens_LifeForce_instance = new GeneralTokens('LifeForce', 17);
  GeneralTokens_SnareTrap_instance = new GeneralTokens('SnareTrap', 18);
  GeneralTokens_Haze_instance = new GeneralTokens('Haze', 19);
}
var $ENTRIES;
function InterfaceIcon_Flee_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_Flee_instance;
}
function InterfaceIcon_StrictPlay_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_StrictPlay_instance;
}
function InterfaceIcon_MagnifyingGlass_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_MagnifyingGlass_instance;
}
function InterfaceIcon_Play_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_Play_instance;
}
function InterfaceIcon_PlayStep_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_PlayStep_instance;
}
function InterfaceIcon_Pause_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_Pause_instance;
}
function InterfaceIcon_Back_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_Back_instance;
}
function InterfaceIcon_Inaccessible_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_Inaccessible_instance;
}
function InterfaceIcon_Cancel_getInstance() {
  InterfaceIcon_initEntries();
  return InterfaceIcon_Cancel_instance;
}
function GeneralTokens_OneDamage_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_OneDamage_instance;
}
function GeneralTokens_ThreeDamages_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_ThreeDamages_instance;
}
function GeneralTokens_OneGrudge_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_OneGrudge_instance;
}
function GeneralTokens_ThreeGrudges_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_ThreeGrudges_instance;
}
function GeneralTokens_AncientPower_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_AncientPower_instance;
}
function GeneralTokens_Fire_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_Fire_instance;
}
function GeneralTokens_SettlerContour_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_SettlerContour_instance;
}
function GeneralTokens_RuinHunter_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_RuinHunter_instance;
}
function GeneralTokens_RuinBeast_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_RuinBeast_instance;
}
function GeneralTokens_RuinNeutral_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_RuinNeutral_instance;
}
function GeneralTokens_RedSign_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_RedSign_instance;
}
function GeneralTokens_BlueSign_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_BlueSign_instance;
}
function GeneralTokens_SummonActivation_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_SummonActivation_instance;
}
function GeneralTokens_TrapSign_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_TrapSign_instance;
}
function GeneralTokens_ReactionSign_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_ReactionSign_instance;
}
function GeneralTokens_Shield_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_Shield_instance;
}
function GeneralTokens_BloodDrop_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_BloodDrop_instance;
}
function GeneralTokens_LifeForce_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_LifeForce_instance;
}
function GeneralTokens_SnareTrap_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_SnareTrap_instance;
}
function GeneralTokens_Haze_getInstance() {
  GeneralTokens_initEntries();
  return GeneralTokens_Haze_instance;
}
function *pingMap($this, $receiver, beastUiMap, isOnlyForTeam, $completion) {
  var pos = $this.phw().ghn_1.pg5();
  var tmp0_safe_receiver = $receiver.dhv();
  var view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qih(pos);
  var serverDrivenConfiguration = get_gameConfiguration().flc_1;
  var tmp;
  if (view == null) {
    tmp = null;
  } else {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'steelart.ui.korge.findAncestorOfType' call
      var current = view;
      while (!(current == null)) {
        if (current instanceof CardUi) {
          tmp$ret$0 = current;
          break $l$block;
        }
        current = current.x1m();
      }
      tmp$ret$0 = null;
    }
    tmp = tmp$ret$0;
  }
  var tmp2_safe_receiver = tmp;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.jlh_1;
  var tmp_0;
  if (tmp3_elvis_lhs == null) {
    var tmp_1;
    if (view == null) {
      tmp_1 = null;
    } else {
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'steelart.ui.korge.findAncestorOfType' call
        var current_0 = view;
        while (!(current_0 == null)) {
          if (current_0 instanceof RoundButton) {
            tmp$ret$1 = current_0;
            break $l$block_0;
          }
          current_0 = current_0.x1m();
        }
        tmp$ret$1 = null;
      }
      tmp_1 = tmp$ret$1;
    }
    var tmp5_safe_receiver = tmp_1;
    tmp_0 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.xlj_1;
  } else {
    tmp_0 = tmp3_elvis_lhs;
  }
  var element = tmp_0;
  var tmp_2;
  if (!(element == null) ? isInterface(element, PlayableCard) : false) {
    tmp_2 = to(new PingPlayableCardElement(element), isOnlyForTeam);
  } else {
    if (element instanceof LocationType) {
      tmp_2 = to(new PingLocationTypeElement(element), isOnlyForTeam);
    } else {
      tmp_2 = null;
    }
  }
  var ping = tmp_2;
  if (!(ping == null)) {
    if (serverDrivenConfiguration == null)
      null;
    else
      yield* serverDrivenConfiguration.w6l(ping.pm_1, ping.qm_1, $completion);
  } else {
    yield* beastUiMap.blk(isOnlyForTeam, $completion);
  }
  return Unit_instance;
}
function BeastGameScene$sceneInit$gameplayUp$slambda(this$0, $action) {
  return constructCallableReference(function *(it, $completion) {
    if (this$0.olk_1 == null)
      yield* $action($completion);
    return Unit_instance;
  }, 1);
}
function BeastGameScene$sceneInit$gameplayDown$slambda(this$0, $action) {
  return constructCallableReference(function *(it, $completion) {
    if (this$0.olk_1 == null)
      yield* $action($completion);
    return Unit_instance;
  }, 1);
}
function sceneInit$gameplayUp(this$0, $this_keys, key, action) {
  return $this_keys.rhv(key, BeastGameScene$sceneInit$gameplayUp$slambda(this$0, action));
}
function sceneInit$gameplayDown(this$0, $this_keys, key, action) {
  return $this_keys.qhv(key, BeastGameScene$sceneInit$gameplayDown$slambda(this$0, action));
}
function BeastGameScene$sceneInit$slambda($korgeControlAgent) {
  return constructCallableReference(function *($completion) {
    $korgeControlAgent.tl2_1 = !$korgeControlAgent.tl2_1;
    var tmp;
    if ($korgeControlAgent.tl2_1) {
      tmp = yield* $korgeControlAgent.plk($completion);
    }
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_0($this_sceneInit) {
  return constructCallableReference(function *($completion) {
    println('Mouse pos = ' + get_mouse($this_sceneInit).xhx_1.toString());
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_1() {
  return constructCallableReference(function *($completion) {
    KorgeOnboardingGameFlowListener_getInstance().cll_1.l1t(Unit_instance);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_2(this$0, $korgeControlAgent) {
  return constructCallableReference(function *(it, $completion) {
    var tmp0_safe_receiver = this$0.olk_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.l1t(Unit_instance);
      return Unit_instance;
    }
    yield* $korgeControlAgent.plk($completion);
    return Unit_instance;
  }, 1);
}
function BeastGameScene$sceneInit$slambda_3($korgeControlAgent) {
  return constructCallableReference(function *($completion) {
    yield* $korgeControlAgent.dll(VOID, VOID, $completion);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_4($korgeControlAgent) {
  return constructCallableReference(function *($completion) {
    yield* $korgeControlAgent.il4_1($completion);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_5($beastUiMap) {
  return constructCallableReference(function *($completion) {
    $beastUiMap.ell(false);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_6($beastUiMap) {
  return constructCallableReference(function *($completion) {
    $beastUiMap.ell(true);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_7(this$0, $this_sceneInit, $beastUiMap) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/pingMap(this$0, $this_sceneInit, $beastUiMap, true, $completion);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_8(this$0, $this_sceneInit, $beastUiMap) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/pingMap(this$0, $this_sceneInit, $beastUiMap, false, $completion);
    return Unit_instance;
  }, 0);
}
function BeastGameScene$sceneInit$slambda_9($korgeControlAgent) {
  return constructCallableReference(function *($completion) {
    yield* animateAutoCursor($korgeControlAgent, null, emptyList(), $completion);
    return Unit_instance;
  }, 0);
}
function *createBeastGameUi(scope, images, gameTeamProvider, menuManagement, gameMapId, mapFormat, configureAgent, $completion) {
  var tmp;
  if (configureAgent === VOID) {
    tmp = createBeastGameUi$lambda;
  } else {
    tmp = configureAgent;
  }
  configureAgent = tmp;
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var callerJob = $completion.od().ae(Key_instance);
  return yield* insideScope(scope, createBeastGameUi$slambda(scope, images, gameTeamProvider, menuManagement, gameMapId, mapFormat, configureAgent, callerJob), $completion);
}
function *buildBeastGameUi(uiScope, images, gameTeamProvider, menuManagement, gameMapId, mapFormat, configureAgent, $completion) {
  var tmp;
  switch (mapFormat.w1_1) {
    case 0:
      tmp = SidePanelLayout_Narrow_getInstance();
      break;
    case 1:
      tmp = SidePanelLayout_Wide_getInstance();
      break;
    case 2:
      // Inline function 'kotlin.error' call

      var message = 'Preview maps cannot be used for gameplay';
      throw IllegalStateException.o(toString(message));
    default:
      noWhenBranchMatchedException();
      break;
  }
  var sidePanelLayout = tmp;
  set_gameLayoutCurrent(new GameLayout(sidePanelLayout));
  var root = SContainer.si4(Size2D.l9i(get_gameLayout().el6_1, get_gameLayout().fl6_1));
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.fi2(false);
  // Inline function 'kotlin.apply' call
  var frame = addTo(this_0, root);
  createStatusLayer(uiScope, images, root);
  var gameUiContext = new GameUiContextImpl(images, frame, root);
  var mapBitmap = yield* (yield* images.ile(gameMapId, mapFormat, $completion)).m1q($completion);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Container.fi2(false);
  // Inline function 'kotlin.apply' call
  var content = addTo(this_1, frame);
  var mapping = getMapLogicalAndUiMapping(gameMapId);
  var tmp_0;
  if (get_gameConfiguration().mll()) {
    tmp_0 = new BeastUiMap(gameUiContext, gameTeamProvider, mapBitmap, mapping, uiScope.d1m());
  } else {
    tmp_0 = new BeastMapUiForDevelop(gameUiContext, gameTeamProvider, mapBitmap, mapping, uiScope.d1m());
  }
  var beastUiMap = tmp_0;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = beastUiMap.hl7_1;
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, content);
  toHeight(this_3, get_gameLayout().ll5_1);
  var initialScale = this_3.vif();
  var maxScale = mapBitmap.s2().o9s_1 / get_gameLayout().kl5_1 / 1;
  var tmp_1 = beastUiMap;
  tmp_1.kl7_1 = buildBeastGameUi$slambda(maxScale, initialScale, beastUiMap, this_3, mapBitmap);
  var tmp0_safe_receiver = get_theLastAppliedMapUiScalingAndPosition().w4(new GameTeam(gameTeamProvider.k3q()));
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var x = tmp0_safe_receiver.jm();
    var y = tmp0_safe_receiver.km();
    var s = tmp0_safe_receiver.fx();
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.min' call
    var b = Math.max(initialScale, s);
    var restoredScale = Math.min(maxScale, b);
    beastUiMap.hl7_1.uif(restoredScale);
    beastUiMap.hl7_1.fcw(buildBeastGameUi$adjustPosition(mapBitmap, Vector2D.a9k(x, y), restoredScale));
  }
  onMouseDrag(this_3, VOID, VOID, buildBeastGameUi$lambda(this_3, mapBitmap));
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  get_mouse(this_3).khx_1.w9y(buildBeastGameUi$lambda_0(this_3, maxScale, initialScale, mapBitmap));
  if (equals(get_gameConfiguration().zlb_1, LocalGameMode_FindLocationPlacing_getInstance())) {
    placingLocationUtility(beastUiMap, mapping.nll());
  }
  if (equals(get_gameConfiguration().zlb_1, LocalGameMode_FindMovementPlacing_getInstance())) {
    yield* placingMovementUtility(beastUiMap, mapping.nll(), images, $completion);
  }
  if (equals(get_gameConfiguration().zlb_1, LocalGameMode_FindRuinPlacing_getInstance())) {
    yield* placingRuinUtility(beastUiMap, mapping.nll(), images, $completion);
  }
  var tmp_2;
  if (get_gameConfiguration().mll()) {
    var panelBackground = yield* (yield* images.yle('PanelBackground.png', $completion)).m1q($completion);
    var korgeControlAgent = new KorgeControlAgent(gameUiContext, gameTeamProvider, beastUiMap, Vector2D.a9k(get_gameLayout().kl5_1, 0), menuManagement, panelBackground, uiScope, get_gameConfiguration().glc_1);
    // Inline function 'kotlin.apply' call
    configureAgent(korgeControlAgent);
    tmp_2 = korgeControlAgent;
  } else {
    tmp_2 = null;
  }
  var controlAgent = tmp_2;
  return new BeastGameUi(root, beastUiMap, controlAgent, images, uiScope);
}
function createBeastGameUi$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function createBeastGameUi$slambda$lambda($ui) {
  return (failure) => {
    var tmp;
    if (!(failure == null) || !$ui.kll_1) {
      $ui.u1o();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function createBeastGameUi$slambda$lambda_0($cancellation) {
  return (it) => {
    var tmp0_safe_receiver = $cancellation;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.u1o();
    }
    return Unit_instance;
  };
}
function createBeastGameUi$slambda($scope, $images, $gameTeamProvider, $menuManagement, $gameMapId, $mapFormat, $configureAgent, $callerJob) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var uiScope = supervisorSubScope($scope);
    var tmp;
    try {
      var ui = yield* /*#__NOINLINE__*/buildBeastGameUi(uiScope, $images, $gameTeamProvider, $menuManagement, $gameMapId, $mapFormat, $configureAgent, $completion);
      var tmp0_safe_receiver = $callerJob;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp0_safe_receiver.g1n(createBeastGameUi$slambda$lambda(ui));
      }
      var cancellation = tmp_0;
      var tmp_1 = ensureNotNull(uiScope.d1m().ae(Key_instance));
      tmp_1.g1n(createBeastGameUi$slambda$lambda_0(cancellation));
      tmp = ui;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var failure = $p;
        cancel(uiScope);
        throw failure;
      } else {
        throw $p;
      }
    }
    return tmp;
  }, 1);
}
function buildBeastGameUi$adjustPosition(mapBitmap, p, s) {
  // Inline function 'kotlin.math.min' call
  var a = p.r9g_1;
  var tmp0 = Math.min(a, 0.0);
  // Inline function 'kotlin.math.max' call
  var b = get_gameLayout().kl5_1 - mapBitmap.s2().o9s_1 * s;
  var newX = Math.max(tmp0, b);
  // Inline function 'kotlin.math.min' call
  var a_0 = p.s9g_1;
  var tmp0_0 = Math.min(a_0, 0.0);
  // Inline function 'kotlin.math.max' call
  var b_0 = get_gameLayout().ll5_1 - mapBitmap.s2().p9s_1 * s;
  var newY = Math.max(tmp0_0, b_0);
  return Vector2D.t9g(newX, newY);
}
function buildBeastGameUi$adjustPosition_0(mapBitmap, $this_addTo) {
  $this_addTo.fcw(buildBeastGameUi$adjustPosition(mapBitmap, $this_addTo.wb5(), $this_addTo.vif()));
}
function Container$_get_pos_$ref_h0y57b(p0) {
  return constructCallableReference(() => p0.wb5(), 0, 0, 544, VOID, [p0]);
}
function Container$_set_pos_$ref_8la55p(p0) {
  return constructCallableReference((p0_0) => {
    p0.fcw(p0_0);
    return Unit_instance;
  }, 1, 0, 545, VOID, [p0]);
}
function Container$_get_scale_$ref_cu76r7(p0) {
  return constructCallableReference(() => p0.vif(), 0, 0, 546, VOID, [p0]);
}
function Container$_set_scale_$ref_ggn9nd(p0) {
  return constructCallableReference((p0_0) => {
    p0.uif(p0_0);
    return Unit_instance;
  }, 1, 0, 547, VOID, [p0]);
}
function buildBeastGameUi$slambda($maxScale, $initialScale, $beastUiMap, $$this$addTo, $mapBitmap) {
  return constructCallableReference(function *(p, s, $completion) {
    var tmp0 = $maxScale;
    // Inline function 'kotlin.math.max' call
    var a = $initialScale;
    // Inline function 'kotlin.math.min' call
    var b = Math.max(a, s);
    var s2 = Math.min(tmp0, b);
    var tmp0_$receiver = $beastUiMap.hl7_1;
    var tmp0_0 = $beastUiMap.hl7_1;
    var tmp = KMutableProperty0;
    var tmp_0 = Container$_get_pos_$ref_h0y57b(tmp0_0);
    var tmp_1 = get(getPropertyCallableRef('pos', 0, tmp, tmp_0, Container$_set_pos_$ref_8la55p(tmp0_0)), $beastUiMap.hl7_1.wb5(), buildBeastGameUi$adjustPosition($mapBitmap, p, s2));
    var tmp0_1 = $beastUiMap.hl7_1;
    var tmp_2 = KMutableProperty0;
    var tmp_3 = Container$_get_scale_$ref_cu76r7(tmp0_1);
    var tmp0_2 = getPropertyCallableRef('scale', 0, tmp_2, tmp_3, Container$_set_scale_$ref_ggn9nd(tmp0_1));
    // Inline function 'korlibs.korge.tween.get' call
    var initial = $beastUiMap.hl7_1.vif();
    var tmp1_vs = [tmp_1, new V2(tmp0_2, initial, s2, _interpolate$ref(), true)];
    var tmp2_easing = get_gameAnimations().ll4_1;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp3_time = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
    buildBeastGameUi$adjustPosition_0($mapBitmap, $$this$addTo);
    return Unit_instance;
  }, 2);
}
function buildBeastGameUi$lambda($$this$addTo, $mapBitmap) {
  return ($this$onMouseDrag, info) => {
    position($$this$addTo, $$this$addTo.wea() - info.hhw_1, $$this$addTo.xea() - info.ihw_1);
    var tmp;
    if (info.xhv_1) {
      buildBeastGameUi$adjustPosition_0($mapBitmap, $$this$addTo);
      tmp = Unit_instance;
    }
    get_gameConfiguration().xlc_1.oll($$this$addTo);
    return Unit_instance;
  };
}
function buildBeastGameUi$lambda_0($$this$addTo, $maxScale, $initialScale, $mapBitmap) {
  return (event) => {
    // Inline function 'kotlin.math.pow' call
    var x = -event.zhy() * 30;
    var factor = Math.pow(1.01, x);
    var oldMouse = event.uhy();
    scale($$this$addTo, $$this$addTo.xif() * factor, $$this$addTo.zif() * factor);
    var tmp0 = $maxScale;
    var tmp0_0 = $initialScale;
    // Inline function 'kotlin.math.max' call
    var b = $$this$addTo.vif();
    // Inline function 'kotlin.math.min' call
    var b_0 = Math.max(tmp0_0, b);
    var tmp$ret$2 = Math.min(tmp0, b_0);
    $$this$addTo.uif(tmp$ret$2);
    var newMouse = event.uhy();
    var diffX = newMouse.r9g_1 - oldMouse.r9g_1;
    var diffY = newMouse.s9g_1 - oldMouse.s9g_1;
    position($$this$addTo, $$this$addTo.wea() + diffX * $$this$addTo.xif(), $$this$addTo.xea() + diffY * $$this$addTo.zif());
    buildBeastGameUi$adjustPosition_0($mapBitmap, $$this$addTo);
    get_gameConfiguration().xlc_1.oll($$this$addTo);
    return Unit_instance;
  };
}
function checkLocationTypes($this) {
  var paintCheck = {_v: false};
  // Inline function 'korlibs.korge.input.mouse' call
  var this_0 = $this.hl7_1;
  // Inline function 'kotlin.run' call
  get_mouse(this_0).vhw_1.w9y(BeastMapUiForDevelop$checkLocationTypes$lambda(paintCheck, $this));
}
function addAdjustentMovementTracker($this) {
  // Inline function 'korlibs.korge.input.mouse' call
  var this_0 = $this.hl7_1;
  // Inline function 'kotlin.run' call
  get_mouse(this_0).ghx_1.w9y(BeastMapUiForDevelop$addAdjustentMovementTracker$lambda($this));
}
function clearPreviousHighlighting($this) {
  var _iterator__ex2g4s = $this.ulm_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var view = _iterator__ex2g4s.r1();
    $this.hl7_1.cif(view);
  }
}
function BeastMapUiForDevelop$checkLocationTypes$lambda$slambda(this$0, $locationType, $area) {
  return constructCallableReference(function *($completion) {
    var bitmap = yield* (yield* this$0.pl6().hle($locationType, $completion)).m1q($completion);
    // Inline function 'korlibs.korge.view.image' call
    var this_0 = this$0.hl7_1;
    var anchor_0 = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(bitmap, anchor_0);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_2, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    toHeight(this_2, $area.nl8_1 * 2);
    position_0(this_2, $area.ml8_1);
    var image = this_2;
    this$0.ulm_1.d2(image);
    return Unit_instance;
  }, 0);
}
function BeastMapUiForDevelop$checkLocationTypes$lambda($paintCheck, this$0) {
  return (it) => {
    $paintCheck._v = !$paintCheck._v;
    var tmp;
    if ($paintCheck._v) {
      var inductionVariable = -4;
      var tmp_0;
      if (inductionVariable <= 4) {
        do {
          var y = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var inductionVariable_0 = -5;
          if (inductionVariable_0 <= 5)
            $l$loop_0: do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var position = _BoardPosition___init__impl__1nizgq(x, y);
              var tmp_1 = this$0.fl7_1.h47();
              var tmp0_safe_receiver = (tmp_1 instanceof GameMapImpl ? tmp_1 : THROW_CCE()).p44_1.w4(new BoardPosition(position));
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k45_1;
              var tmp_2;
              if (tmp1_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp_2 = tmp1_elvis_lhs;
              }
              var locationType = tmp_2;
              if (!get_primaryLocations().w2(locationType))
                continue $l$loop_0;
              var tmp2_safe_receiver = this$0.fl7_1.jl8(position);
              if (tmp2_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                launchUnscoped(this$0.gl7_1, BeastMapUiForDevelop$checkLocationTypes$lambda$slambda(this$0, locationType, tmp2_safe_receiver));
              }
            }
             while (inductionVariable_0 <= 5);
        }
         while (inductionVariable <= 4);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } else {
      clearPreviousHighlighting(this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BeastMapUiForDevelop$addAdjustentMovementTracker$lambda(this$0) {
  return (it) => {
    var point = it.uhy();
    var area = this$0.fl7_1.vlm(point);
    var tmp;
    if (area == null) {
      clearPreviousHighlighting(this$0);
      this$0.tlm_1 = null;
      tmp = Unit_instance;
    } else if (!equals(this$0.tlm_1, area)) {
      println('highlighting: ' + area.toString() + ', zone = ' + toString_0(this$0.fl7_1.h47().h3t(area.kl8_1)));
      clearPreviousHighlighting(this$0);
      this$0.tlm_1 = area;
      this$0.ulm_1.a5();
      var tmp_0 = this$0.ulm_1;
      var tmp0 = this$0.hl7_1;
      var tmp2 = area.nl8_1;
      var tmp4 = new RGBA(Companion_getInstance_15().ich(255, 255, 255, 255));
      // Inline function 'korlibs.korge.view.circle' call
      var stroke = new RGBA(Colors_getInstance().cc3_1);
      var renderer = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = Circle.ajq(numberToDouble(tmp2), tmp4, stroke, numberToDouble(0.0), true, renderer);
      // Inline function 'kotlin.apply' call
      var this_1 = addTo(this_0, tmp0);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      this_1.sig(0.6);
      position_0(this_1, area.ml8_1);
      tmp_0.d2(this_1);
      var _iterator__ex2g4s = anyAdjacentPositions(this$0.fl7_1.h47(), area.kl8_1).p1();
      while (_iterator__ex2g4s.q1()) {
        var adjacentPosition = _iterator__ex2g4s.r1().r2v_1;
        var tmp_1 = this$0.ulm_1;
        // Inline function 'kotlin.also' call
        var this_2 = this$0.wlm(ensureNotNull(this$0.fl7_1.jl8(adjacentPosition)));
        this_2.sig(0.4);
        tmp_1.d2(this_2);
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function *addMovementCardElement(_this__u8e3s4, beast, layer, needAddEmptyView, placeAndScale, $completion) {
  needAddEmptyView = needAddEmptyView === VOID ? false : needAddEmptyView;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var beastMovements = get_beastMovements($this$with, beast);
  var last = lastOrNull(beastMovements);
  var count = beastMovements.s2();
  var key = new BeastMovementsKey(get_objectType($this$with, beast), count, last);
  if (last == null) {
    if (needAddEmptyView) {
      yield* layer.zln(key, VOID, VOID, VOID, addMovementCardElement$slambda(), $completion);
    }
    return key;
  }
  yield* layer.zln(key, VOID, VOID, VOID, addMovementCardElement$slambda_0(_this__u8e3s4, last, count, placeAndScale, beast), $completion);
  return key;
}
function movementCardLayoutForAboveMap(_this__u8e3s4, beastIndex) {
  var c = get_gameLayout().ll5_1 / _this__u8e3s4.gl2_1.hl7_1.s2().k9i_1;
  // Inline function 'korlibs.math.geom.Vector2D.times' call
  var this_0 = _this__u8e3s4.gl2_1.fl7_1.nll().elo_1.u2(beastIndex);
  var tmp$ret$0 = Vector2D.t9g(this_0.r9g_1 * c, this_0.s9g_1 * c);
  return to(tmp$ret$0, _this__u8e3s4.gl2_1.fl7_1.nll().flo_1 * get_gameLayout().jl6_1.k9i_1 / get_gameLayout().jl6_1.j9i_1 * c);
}
function *addWoundsToSimpleObjects(images, container, wounds, additionalScale, $completion) {
  additionalScale = additionalScale === VOID ? 1.0 : additionalScale;
  var bitmapWidth = container.w9z();
  var bitmapHeight = container.x9z();
  if (wounds === 0)
    return Unit_instance;
  var woundHeight = bitmapHeight * 0.25 * additionalScale;
  var threeWoundHeight = bitmapHeight * 0.4 * additionalScale;
  var woundBitmap = yield* (yield* images.vle(GeneralTokens_OneDamage_getInstance(), $completion)).m1q($completion);
  var threeWoundBitmap = yield* (yield* images.vle(GeneralTokens_ThreeDamages_getInstance(), $completion)).m1q($completion);
  if (wounds > 8) {
    // Inline function 'kotlin.error' call
    var message = 'Not implemented more than 8 wounds';
    throw IllegalStateException.o(toString(message));
  }
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p2();
  var threeDamageTokensCount = wounds / 3 | 0;
  var oneDamageTokensCount = wounds % 3 | 0;
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < threeDamageTokensCount)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_0.d2(to(threeWoundBitmap, threeWoundHeight));
    }
     while (inductionVariable < threeDamageTokensCount);
  // Inline function 'kotlin.repeat' call
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < oneDamageTokensCount)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      this_0.d2(to(woundBitmap, woundHeight));
    }
     while (inductionVariable_0 < oneDamageTokensCount);
  var tokens = this_0.g9();
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = tokens.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp = sum;
    sum = tmp + element.qm_1;
  }
  var totalHeight = sum;
  var y = bitmapHeight * 0.5 - totalHeight / 2;
  var _iterator__ex2g4s_0 = tokens.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_0.r1();
    var tokenBitmap = _destruct__k2r9zo.jm();
    var tokenHeight = _destruct__k2r9zo.km();
    y = y + tokenHeight / 2;
    // Inline function 'korlibs.korge.view.image' call
    var anchor_0 = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(tokenBitmap, anchor_0);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, container);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_2, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    toHeight(this_2, tokenHeight);
    position(this_2, bitmapWidth * 0.5, y);
    y = y + tokenHeight / 2;
  }
  return Unit_instance;
}
function *pingHighlightAnswerElement(_this__u8e3s4, answerToHighlight, $completion) {
  return yield* coroutineScope(pingHighlightAnswerElement$slambda(answerToHighlight, _this__u8e3s4), $completion);
}
function *targetObjectView($context_GameState_t6qee5, _this__u8e3s4, target, $completion) {
  var container = Container.fi2();
  var objectType = get_objectType($context_GameState_t6qee5, target);
  var bitmap = yield* (yield* _this__u8e3s4.pl6().ole($context_GameState_t6qee5, target, $completion)).m1q($completion);
  // Inline function 'korlibs.korge.view.image' call
  var anchor = Companion_getInstance_7().c9g_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.lk7(bitmap, anchor);
  // Inline function 'kotlin.apply' call
  addTo(this_0, container);
  yield* addArmorToSimpleObjects(objectType, _this__u8e3s4.pl6(), container, get_armor($context_GameState_t6qee5, target), $completion);
  yield* /*#__NOINLINE__*/addWoundsToSimpleObjects(_this__u8e3s4.pl6(), container, get_wounds($context_GameState_t6qee5, target), VOID, $completion);
  var tmp;
  var tmp_0 = get_gameRules($context_GameState_t6qee5);
  if (tmp_0 instanceof ShipwreckContract) {
    tmp = isInterface(objectType, SettlerType);
  } else {
    tmp = false;
  }
  if (tmp) {
    var names = listOf(['Dyl', 'Tyl']);
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = get_allAliveAndDestroyedObjects($context_GameState_t6qee5);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$10;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp_1 = get_objectType($context_GameState_t6qee5, element);
        if (isInterface(tmp_1, SettlerType)) {
          tmp$ret$10 = element instanceof ObjectOnBoard ? element : THROW_CCE();
          break $l$block;
        }
        tmp$ret$10 = null;
      }
      var tmp0_safe_receiver = tmp$ret$10;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = targetObjectView$lambda;
    var tmp$ret$14 = new sam$kotlin_Comparator$0(tmp_2);
    var settlers = sortedWith(destination, tmp$ret$14);
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOf(settlers, target);
    var tmp_3;
    if (this_1 >= 0) {
      tmp_3 = this_1;
    } else {
      tmp_3 = null;
    }
    var tmp0_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Settler ' + target.toString() + ' not found';
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_4 = tmp0_elvis_lhs;
    }
    var index = tmp_4;
    var name = names.u2(index);
    var tmp_5;
    if (objectType instanceof FarmerType) {
      tmp_5 = Colors_getInstance().ac3_1;
    } else {
      tmp_5 = Colors_getInstance().zc2_1;
    }
    var color = tmp_5;
    var text = addTo(toWidth(Text.aj6(name, VOID, color), bitmap.tc1_1 * 0.33), container);
    Companion_getInstance_8();
    // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
    // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
    var tmp$ret$19 = -90.0 * 0.017453292519943295;
    var tmp$ret$18 = _Angle___init__impl__g23q1m(tmp$ret$19);
    rotation(text, tmp$ret$18);
    text.sif(bitmap.tc1_1 * 0.8);
    var tmp_6 = bitmap.sc1_1;
    var tmp_7;
    if (objectType instanceof FarmerType) {
      tmp_7 = 0.1;
    } else {
      tmp_7 = 0.35;
    }
    text.rif(tmp_6 * tmp_7);
  }
  return container;
}
function *addArmorToSimpleObjects(objectType, images, container, armor, $completion) {
  if (armor === 0)
    return Unit_instance;
  var bitmapWidth = container.w9z();
  var bitmapHeight = container.x9z();
  var shieldHeight = bitmapHeight * 0.4;
  var shieldBitmap = yield* (yield* images.vle(GeneralTokens_Shield_getInstance(), $completion)).m1q($completion);
  var tmp;
  if (objectType instanceof NobleType) {
    tmp = bitmapWidth * 0.2;
  } else {
    tmp = -bitmapWidth * 0.15;
  }
  var shiftX = tmp;
  var inductionVariable = 0;
  if (inductionVariable < armor)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.image' call
      var anchor = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = Image.lk7(shieldBitmap, anchor);
      // Inline function 'kotlin.apply' call
      var this_1 = addTo(this_0, container);
      toHeight(this_1, shieldHeight);
      position(this_1, shiftX, bitmapHeight * 0.5 - shieldHeight / 2 + i * shieldHeight * 0.33);
    }
     while (inductionVariable < armor);
  return Unit_instance;
}
function *buildMovementCardContent(_this__u8e3s4, movement, number, revealHiddenMovements, isHoverable, isPlayable, isDialogPlace, mainCardHeight, cardAction, $completion) {
  isPlayable = isPlayable === VOID ? true : isPlayable;
  isDialogPlace = isDialogPlace === VOID ? false : isDialogPlace;
  var mainMovement = first(movement.i3g_1);
  var falseMovements = drop(movement.i3g_1, 1);
  var cardsToRender = plus(listOf_0(mainMovement), falseMovements);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(cardsToRender, 10));
  var _iterator__ex2g4s = cardsToRender.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp;
    var tmp_0;
    if (revealHiddenMovements || movement.k3g_1) {
      tmp_0 = true;
    } else {
      tmp_0 = item instanceof RelocationStep;
    }
    if (tmp_0) {
      tmp = item;
    } else {
      tmp = null;
    }
    var tmp$ret$2 = tmp;
    destination.d2(tmp$ret$2);
  }
  var shownCards = destination;
  var container = Container.fi2();
  var mainPicture = yield* (yield* _this__u8e3s4.pl6().wle(first(shownCards), $completion)).m1q($completion);
  // Inline function 'kotlin.apply' call
  var this_0 = Container.fi2();
  this_0.uie(Image.lk7(mainPicture));
  // Inline function 'kotlin.apply' call
  var this_1 = BorderedText(number.toString(), mainPicture.tc1_1 / 4 | 0);
  var tmp2 = mainPicture.sc1_1 / 10 | 0;
  // Inline function 'korlibs.korge.view.position' call
  var y = mainPicture.tc1_1 * 0.05;
  xy(this_1, numberToDouble(tmp2), numberToDouble(y));
  addTo(this_1, this_0);
  var mainCardContent = this_0;
  var mainCard = toHeight(CardUi.ilo(mainCardContent, VOID, VOID, isPlayable, isHoverable, VOID, buildMovementCardContent$slambda(cardAction)), mainCardHeight);
  var falseCardScale = 0.7;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s_0 = drop(shownCards, 1).p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item_0 = _iterator__ex2g4s_0.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var falsePicture = yield* (yield* _this__u8e3s4.pl6().wle(item_0, $completion)).m1q($completion);
    var falseCardShiftX = mainCard.pig() * 0.5;
    var falseCardShiftY = mainCardHeight * 0.08;
    var tmp_1 = Image.lk7(falsePicture);
    var falseMovementCard = addTo(toHeight(CardUi.ilo(tmp_1, VOID, VOID, isPlayable, isHoverable, VOID, buildMovementCardContent$slambda_0(cardAction)), mainCardHeight * falseCardScale), container);
    if (isDialogPlace) {
      position(falseMovementCard, mainCard.pig() * (1 - falseCardScale) / 2, mainCard.rig() * (1 - falseCardScale / 2));
    } else {
      position(falseMovementCard, -falseCardShiftX - index_0 * falseCardShiftX * 0.5, falseCardShiftY);
    }
  }
  var tmp_2;
  if (isDialogPlace && !movement.k3g_1 && !revealHiddenMovements) {
    tmp_2 = !(mainMovement instanceof RelocationStep);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    container.sig(0.5);
  }
  addTo(mainCard, container);
  return container;
}
function addMovementCardElement$slambda() {
  return constructCallableReference(function *($completion) {
    return BorderedText('Revealed', get_gameLayout().sl5_1);
  }, 0);
}
function addMovementCardElement$slambda$slambda($this_addMovementCardElement, $beast) {
  return constructCallableReference(function *($completion) {
    yield* showMovementCardsDialog_0($this_addMovementCardElement, $beast, $completion);
    return Unit_instance;
  }, 0);
}
function addMovementCardElement$slambda_0($this_addMovementCardElement, $last, $count, $placeAndScale, $beast) {
  return constructCallableReference(function *($completion) {
    var tmp = get_gameLayout().ol5_1;
    // Inline function 'kotlin.also' call
    var this_0 = yield* /*#__NOINLINE__*/buildMovementCardContent($this_addMovementCardElement, $last, $count, false, true, VOID, false, tmp, addMovementCardElement$slambda$slambda($this_addMovementCardElement, $beast), $completion);
    $placeAndScale(this_0);
    return this_0;
  }, 0);
}
function pingHighlightAnswerElement$slambda$slambda($element) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $element.klo($completion);
    return Unit_instance;
  }, 1);
}
function pingHighlightAnswerElement$slambda($answerToHighlight, $this_pingHighlightAnswerElement) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp0_safe_receiver = $answerToHighlight instanceof MovementToLocation ? $answerToHighlight : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v3g_1;
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null) {
      tmp = $answerToHighlight;
    } else {
      var tmp_1 = tmp1_elvis_lhs;
      tmp = tmp_1 == null ? null : new BoardPosition(tmp_1);
    }
    var adjusted = tmp;
    var answerKey = adjusted == null ? NullVariant_instance : adjusted;
    var highlightedElement = null;
    var highlightJob = null;
    var tmp_2;
    try {
      while (true) {
        var tmp3_safe_receiver = $this_pingHighlightAnswerElement.dl5().w4(answerKey);
        var tmp_3 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.el5_1;
        var currentElement = (!(tmp_3 == null) ? isInterface(tmp_3, HoverableUiElement) : false) ? tmp_3 : null;
        if (!(currentElement === highlightedElement)) {
          var tmp4_safe_receiver = highlightJob;
          if (tmp4_safe_receiver == null)
            null;
          else
            yield* cancelAndJoin(tmp4_safe_receiver, $completion);
          var tmp5_safe_receiver = highlightedElement;
          if (tmp5_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            tmp5_safe_receiver.pl8(false);
            tmp5_safe_receiver.ql8();
          }
          highlightedElement = currentElement;
          var tmp_4;
          if (currentElement == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_4 = launch($this$coroutineScope, VOID, VOID, pingHighlightAnswerElement$slambda$slambda(currentElement));
          }
          highlightJob = tmp_4;
        }
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$4 = toDuration(250, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$4, $completion);
      }
      tmp_2 = Unit_instance;
    }finally {
      var tmp7_safe_receiver = highlightJob;
      if (tmp7_safe_receiver == null)
        null;
      else {
        tmp7_safe_receiver.o1n();
      }
      var tmp8_safe_receiver = highlightedElement;
      if (tmp8_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp8_safe_receiver.pl8(false);
        tmp8_safe_receiver.ql8();
      }
    }
    return Unit_instance;
  }, 1);
}
function targetObjectView$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = _EntityId___get_id__impl__v6colh(a.r2w_1);
  var tmp$ret$2 = _EntityId___get_id__impl__v6colh(b.r2w_1);
  return compareValues(tmp, tmp$ret$2);
}
function buildMovementCardContent$slambda($cardAction) {
  return constructCallableReference(function *($completion) {
    yield* $cardAction($completion);
    return Unit_instance;
  }, 0);
}
function buildMovementCardContent$slambda_0($cardAction) {
  return constructCallableReference(function *($completion) {
    yield* $cardAction($completion);
    return Unit_instance;
  }, 0);
}
function get_gameI18n() {
  _init_properties_BeastUiMain_kt__6hf30m();
  return gameI18n;
}
var gameI18n;
function *startKorgeUi(externalLogicScope, $completion) {
  println('Client version 1.0.5; commit=aff1bf7e93a2');
  var logicScope = supervisorSubScope(externalLogicScope);
  if (get_gameConfiguration().ilc_1) {
    var tmp1_windowSize = Size2D.l9i(3840, 2160).l9s(2);
    var tmp2_virtualSize = Size2D.l9i(get_gameLayout().el6_1, get_gameLayout().fl6_1);
    var tmp3_windowCreationConfig = new GameWindowCreationConfig(VOID, VOID, VOID, VOID, VOID, VOID, true, false);
    var tmp4_backgroundColor = Colors_getInstance().qci('#2b2b2b');
    var tmp = new Korge_0(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_windowSize, tmp2_virtualSize, VOID, 'Beast', tmp4_backgroundColor, VOID, VOID, VOID, VOID, tmp3_windowCreationConfig);
    yield* tmp.thm(startKorgeUi$slambda(logicScope), $completion);
  } else {
    var tmp6_windowSize = Size2D.l9i(get_gameLayout().el6_1, get_gameLayout().fl6_1);
    var tmp7_backgroundColor = Colors_getInstance().qci('#2b2b2b');
    yield* Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp6_windowSize, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 'Beast', VOID, tmp7_backgroundColor, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, startKorgeUi$slambda_0(logicScope), $completion);
  }
  return Unit_instance;
}
function *initEngineGame(_this__u8e3s4, logicScope, $completion) {
  return yield* commonInitGame(_this__u8e3s4, initEngineGame$slambda(_this__u8e3s4, logicScope), $completion);
}
function *commonInitGame(_this__u8e3s4, fn, $completion) {
  fixFullScreen(_this__u8e3s4.phw());
  try {
    yield* coroutineScope(commonInitGame$slambda(_this__u8e3s4, fn), $completion);
  }finally {
    get_globalLoadingResourceManager().f7();
  }
  return Unit_instance;
}
var BindingTestMenuManagement_instance;
function BindingTestMenuManagement_getInstance() {
  return BindingTestMenuManagement_instance;
}
function *initGame(hotSeatSceneManager, images, logicScope, gameSetup, $completion) {
  return yield* initGame_0(hotSeatSceneManager, images, logicScope, gameSetup, true, $completion);
}
function *startFromMainMenu(hotSeatSceneManager, images, logicScope, $completion) {
  clearOnboardingGlobalMode();
  hotSeatSceneManager.ndx_1 = true;
  hotSeatSceneManager.ldx_1 = null;
  var tmp0 = hotSeatSceneManager.plo_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
  var transition = tmp0.hhu_1;
  var tmp2 = getKClass(MainMenuScene);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = tmp0.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), tmp0).qe4(getKClass(Resources), new Resources(tmp0.d1m(), tmp0.ghu_1.whu().wbw_1, tmp0.ghu_1.whu()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.qe4(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  var newScene = new MainMenuScene(hotSeatSceneManager, images, logicScope);
  // Inline function 'korlibs.logger.Logger.info' call
  var tmp0_0 = Companion_getInstance_5().mi5_1;
  // Inline function 'korlibs.logger.Logger.log' call
  var level = Level_INFO_getInstance();
  if (tmp0_0.obj(level)) {
    var tmp$ret$9 = 'Changing scene to... ' + toString(tmp2) + ' ... ' + toString(newScene);
    tmp0_0.pbj(level, tmp$ret$9);
  }
  if (true) {
    newScene.be5(sceneInjector);
    var tmp_0 = getKClassFromExpression(newScene);
    var tmp_1 = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    tmp0.ghu_1.fhn_1.ue4(tmp_1, startFromMainMenu$lambda(sceneInjector, hotSeatSceneManager, images, logicScope));
  }
  yield* tmp0.oi5(newScene, time, transition, $completion);
  return Unit_instance;
}
function *initGame_0(hotSeatSceneManager, images, logicScope, gameSetup, reconnectNetworkSession, $completion) {
  hotSeatSceneManager.odx();
  hotSeatSceneManager.ndx_1 = false;
  var requestGameReload = {_v: initGame$lambda};
  var menuManagement = new initGame$menuManagement$1(gameSetup, requestGameReload, hotSeatSceneManager, images, logicScope);
  if (gameSetup instanceof ServerDuelSetup) {
    var serverDrivenConfiguration = ensureNotNull(get_gameConfiguration().flc_1);
    var setup = gameSetup.xdx_1;
    setGameCodeInUrl(setup.o6q_1, _GameTeam___get_teamId__impl__chxeb3(setup.p6q_1));
    var agent = yield* initSingleKorgeAgent(hotSeatSceneManager, images, menuManagement, setup.p6q_1, setup.q6q_1.h3a(), requiredMapFormat(setup.q6q_1), $completion);
    yield* serverDrivenConfiguration.i6l(agent, setup.p6q_1, $completion);
    var sessionJob = {_v: null};
    requestGameReload._v = initGame$lambda_0(hotSeatSceneManager, sessionJob, logicScope, serverDrivenConfiguration, menuManagement, setup, images);
    var tmp = Dispatchers_getInstance().c1u_1;
    var tmp_0 = CoroutineStart_LAZY_getInstance();
    sessionJob._v = launch(logicScope, tmp, tmp_0, initGame$slambda(serverDrivenConfiguration, setup, reconnectNetworkSession, hotSeatSceneManager, sessionJob, logicScope, menuManagement, images));
    var tmp_1 = hotSeatSceneManager;
    var tmp_2;
    if (sessionJob._v == null) {
      throwUninitializedPropertyAccessException('sessionJob');
    } else {
      tmp_2 = sessionJob._v;
    }
    tmp_1.mdx_1 = tmp_2;
    var tmp_3;
    if (sessionJob._v == null) {
      throwUninitializedPropertyAccessException('sessionJob');
    } else {
      tmp_3 = sessionJob._v;
    }
    tmp_3.b1n();
    return Unit_instance;
  }
  var tmp_4;
  var tmp_5;
  if (gameSetup instanceof NewGameSetup) {
    tmp_5 = true;
  } else {
    var tmp_6;
    if (gameSetup instanceof SandboxSetup) {
      tmp_6 = gameSetup.ydx_1 == null;
    } else {
      tmp_6 = false;
    }
    tmp_5 = tmp_6;
  }
  if (tmp_5) {
    var tmp_7;
    if (get_gameConfiguration().ald_1) {
      var chooseScenarioScene = new ChooseScenarioScene(hotSeatSceneManager, images, logicScope, gameSetup instanceof SandboxSetup);
      var tmp0 = hotSeatSceneManager.plo_1;
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
      var injects = [];
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
      var transition = tmp0.hhu_1;
      var tmp2 = getKClass(ChooseScenarioScene);
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
      var injects_0 = injects.slice();
      var sceneInjector = tmp0.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), tmp0).qe4(getKClass(Resources), new Resources(tmp0.d1m(), tmp0.ghu_1.whu().wbw_1, tmp0.ghu_1.whu()));
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < injects_0.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var inject = injects_0[_unary__edvuaz];
        var tmp_8 = getKClassFromExpression(inject);
        sceneInjector.qe4(isInterface(tmp_8, KClass) ? tmp_8 : THROW_CCE(), inject);
      }
      var newScene = chooseScenarioScene;
      // Inline function 'korlibs.logger.Logger.info' call
      var tmp0_0 = Companion_getInstance_5().mi5_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_INFO_getInstance();
      if (tmp0_0.obj(level)) {
        var tmp$ret$9 = 'Changing scene to... ' + toString(tmp2) + ' ... ' + toString(newScene);
        tmp0_0.pbj(level, tmp$ret$9);
      }
      if (true) {
        newScene.be5(sceneInjector);
        var tmp_9 = getKClassFromExpression(newScene);
        var tmp_10 = isInterface(tmp_9, KClass) ? tmp_9 : THROW_CCE();
        tmp0.ghu_1.fhn_1.ue4(tmp_10, initGame$lambda_1(sceneInjector, chooseScenarioScene));
      }
      yield* tmp0.oi5(newScene, time, transition, $completion);
      tmp_7 = chooseScenarioScene.jlp_1;
    } else {
      tmp_7 = CompletableDeferred(new GameSetupState(GreatCleansingContract.j5f(BeastBalanceVersion_OfficialV2_getInstance()), VOID, mutableListOf([FeatheredKing_getInstance()]), mutableListOf([Helga_getInstance(), Varja_getInstance()])));
    }
    tmp_4 = tmp_7;
  } else {
    tmp_4 = null;
  }
  var newGameSetupState = tmp_4;
  var tmp_11 = Dispatchers_getInstance().c1u_1;
  var gameLogicJob = launch(logicScope, tmp_11, VOID, initGame$slambda_0(gameSetup, images, menuManagement, hotSeatSceneManager, newGameSetupState));
  hotSeatSceneManager.mdx_1 = gameLogicJob;
  return Unit_instance;
}
function MainMenuScene$performGameReplay$slambda$o$restartCallback$slambda(this$0) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/startFromMainMenu(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, $completion);
    return Unit_instance;
  }, 1);
}
function closeCurrentDialog($this) {
  var tmp0_safe_receiver = $this.alq_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1n();
  }
  $this.alq_1 = null;
  var tmp1_safe_receiver = $this.zlp_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.qlq();
  }
  $this.zlp_1 = null;
}
function openContentReference($this, frame, params, addToHistory) {
  closeCurrentDialog($this);
  var resolved = resolveContentReference(params, get_gameConfiguration().dlc_1, get_gameConfiguration().tlc_1);
  var currentRoute = {_v: resolved.rlq_1};
  setContentReferenceInUrl(currentRoute._v.wlq(), addToHistory);
  var job = Job($this.d1m().ae(Key_instance));
  $this.alq_1 = job;
  if (resolved.slq_1) {
    var tmp = $this;
    var tmp_0 = PlainText('Requested reference content is unknown or unavailable. Showing available content.', get_gameLayout().vl5_1);
    // Inline function 'kotlin.also' call
    var this_0 = GameDialog.xlq(frame, tmp_0, VOID, MainMenuScene$openContentReference$slambda($this, frame, currentRoute));
    this_0.ylq();
    tmp.zlp_1 = this_0;
    return Unit_instance;
  }
  var tmp_1 = $this;
  var tmp_2 = CoroutineScope($this.d1m().ep(job));
  var tmp_3 = currentRoute._v.ulq_1;
  var tmp_4 = currentRoute._v;
  var tmp_5 = MainMenuScene$openContentReference$lambda(currentRoute);
  tmp_1.zlp_1 = createAndShowContentReferenceDialog(tmp_2, frame, $this.vlp_1, tmp_3, tmp_4, tmp_5, MainMenuScene$openContentReference$slambda_0($this, frame));
}
function showCommunityDialog($this, sContainer) {
  var panel = new ControlPanelY();
  var dialog = GameDialog.xlq(sContainer, panel.xlb_1, 'Community');
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = listOf([new Triple("Midhall Studio's official Beast Universe Discord server is\nthe best place to clarify rules, meet fellow hunters,\nand arrange an online game here or in Tabletop Simulator", 'Join the official Beast Universe Discord', get_gameConfiguration().hlc_1.e6k_1), new Triple('Good old BGG is still a perfect place for board game geeks!', 'BGG related thread', get_gameConfiguration().hlc_1.f6k_1)]);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var description = element.jm();
    var label = element.km();
    var url = element.fx();
    var tmp;
    if (url == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(url)) {
        tmp_0 = url;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      var descriptionText = PlainText(description, get_gameLayout().sl5_1);
      var button = ActionButton.vlb(label, VOID, VOID, VOID, VOID, VOID, MainMenuScene$showCommunityDialog$slambda(tmp1_safe_receiver));
      tmp_1 = to(descriptionText, button);
    }
    var tmp0_safe_receiver = tmp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var sections = destination;
  var backButton = ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showCommunityDialog$slambda_0(dialog, $this, sContainer));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(sections, 10));
  var _iterator__ex2g4s_0 = sections.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var tmp$ret$14 = item.qm_1;
    destination_0.d2(tmp$ret$14);
  }
  var buttons = plus_0(destination_0, backButton);
  var tmp$ret$15;
  $l$block: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator = sections.p1();
    if (!iterator.q1()) {
      tmp$ret$15 = null;
      break $l$block;
    }
    var maxValue = iterator.r1().pm_1.pig();
    while (iterator.q1()) {
      var v = iterator.r1().pm_1.pig();
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    tmp$ret$15 = maxValue;
  }
  var tmp0_elvis_lhs = tmp$ret$15;
  var tmp2 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_0 = buttons.p1();
  if (!iterator_0.q1())
    throw NoSuchElementException.w7();
  var maxValue_0 = iterator_0.r1().qlb_1.j9i_1;
  while (iterator_0.q1()) {
    var v_0 = iterator_0.r1().qlb_1.j9i_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = maxValue_0;
    maxValue_0 = Math.max(a_0, v_0);
  }
  // Inline function 'kotlin.comparisons.maxOf' call
  var c = maxValue_0;
  var tmp_2 = Math.max(337.0, tmp2, c);
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_1 = buttons.p1();
  if (!iterator_1.q1())
    throw NoSuchElementException.w7();
  var maxValue_1 = iterator_1.r1().qlb_1.k9i_1;
  while (iterator_1.q1()) {
    var v_1 = iterator_1.r1().qlb_1.k9i_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_1 = maxValue_1;
    maxValue_1 = Math.max(a_1, v_1);
  }
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = maxValue_1;
  var tmp$ret$28 = Math.max(49.0, b);
  var buttonSize = Size2D.y9p(tmp_2, tmp$ret$28);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = buttons.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_0 = _iterator__ex2g4s_1.r1();
    element_0.zlq(buttonSize);
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s_2 = sections.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var item_0 = _iterator__ex2g4s_2.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var description_0 = item_0.jm();
    var button_0 = item_0.km();
    if (index_0 > 0) {
      panel.dlr_1 = panel.dlr_1 + get_gameLayout().sl5_1;
      addTo_0(Companion_instance.ekd(buttonSize.j9i_1, 1.0, Colors_getInstance().qci('#808080')), panel);
      panel.dlr_1 = panel.dlr_1 + get_gameLayout().sl5_1;
    }
    addTo_0(description_0, panel);
    addTo_0(button_0, panel);
  }
  panel.dlr_1 = panel.dlr_1 + get_gameLayout().sl5_1 * 4;
  addTo_0(backButton, panel);
  panel.flr();
  dialog.ylq();
}
function startMenuBackground($this) {
  if (!($this.elq_1 == null))
    return Unit_instance;
  var tmp = $this;
  tmp.elq_1 = launch($this, VOID, VOID, MainMenuScene$startMenuBackground$slambda($this));
}
function showLoginDialog($this, sContainer, serverDrivenConfiguration, authenticationCapabilities) {
  var panel = new ControlPanelY();
  var gameDialog = GameDialog.xlq(sContainer, panel.xlb_1, 'Log In');
  if (authenticationCapabilities.s6i_1) {
    addTo_0(PlainText('Access code', get_gameLayout().vl5_1), panel);
    // Inline function 'korlibs.korge.ui.uiTextInput' call
    var size = Size2D.l9i(128, 24);
    // Inline function 'kotlin.also' call
    var this_0 = addTo(UITextInput.kj3('', size), sContainer);
    var tmp = this_0.jj3();
    tmp.w9y(MainMenuScene$showLoginDialog$lambda($this, serverDrivenConfiguration, gameDialog, sContainer));
    addTo_0(this_0, panel);
  }
  var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  if (authenticationCapabilities.t6i_1) {
    addTo_0(ActionButton.vlb('Log in with Discord', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showLoginDialog$slambda()), actions);
  }
  if (authenticationCapabilities.u6i_1) {
    addTo_0(ActionButton.vlb('Log in with Steam', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showLoginDialog$slambda_0()), actions);
  }
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showLoginDialog$slambda_1(gameDialog, $this, sContainer)), actions);
  addTo_0(actions.xlb_1, panel);
  var tmp0_safe_receiver = get_gameConfiguration().hlc_1.d6k_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(tmp0_safe_receiver)) {
      tmp_1 = tmp0_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp1_safe_receiver = tmp_0;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    addTo_0(createLinkText('Privacy Notice', tmp1_safe_receiver, get_gameLayout().sl5_1), panel);
  }
  gameDialog.ylq();
}
function showPendingReplayConsents($this, sContainer, server, pending) {
  var panel = new ControlPanelY();
  var dialog = GameDialog.xlq(sContainer, panel.xlb_1, 'Pending consents');
  addTo_0(PlainText('Approval makes the full replay public, including hidden decisions,\nfor anyone to view or copy. All players must approve.', get_gameLayout().sl5_1), panel);
  if (pending.n1()) {
    addTo_0(PlainText('No pending consents.', get_gameLayout().sl5_1), panel);
  }
  var rows = new ControlPanelY();
  var _iterator__ex2g4s = pending.p1();
  while (_iterator__ex2g4s.q1()) {
    var consent = _iterator__ex2g4s.r1();
    var row = new ControlPanelX();
    addTo_0(PlainText(consent.c6o_1 + ' (' + consent.b6o_1.o6k_1 + ')', get_gameLayout().sl5_1), row);
    addTo_0(ActionButton.vlb('Approve', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showPendingReplayConsents$slambda($this, server, consent, dialog, sContainer)), row);
    addTo_0(ActionButton.vlb('Decline', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showPendingReplayConsents$slambda_0($this, server, consent, dialog, sContainer)), row);
    addTo_0(row.xlb_1, rows);
  }
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$showPendingReplayConsents$slambda_1(dialog, $this, sContainer)), panel);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!pending.n1()) {
    addScrollableGameRows(panel, rows);
  }
  dialog.ylq();
}
function *requestPublicReplaySharing($this, sContainer, server, gameCode, $completion) {
  switch ((yield* server.q6l(gameCode, $completion)).w1_1) {
    case 3:
      showSharedCode(sContainer, gameCode, server, false);
      break;
    case 1:
      showSingleTextDialog(sContainer, 'Sharing requested. The full replay stays private until every player approves.\nPlayers can respond from Pending consents on the main screen.');
      break;
    case 2:
      showSingleTextDialog(sContainer, 'A player declined public sharing. The replay remains private.');
      break;
    case 0:
      showErrorDialog(sContainer, 'Only game participants can request sharing of a completed replay with players.');
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return Unit_instance;
}
function showUserSettingsDialog($this, sContainer, serverDrivenConfiguration) {
  var gameDialog = {_v: null};
  var tmp = MainMenuScene$showUserSettingsDialog$slambda($this);
  var tmp_0 = MainMenuScene$showUserSettingsDialog$slambda_0($this, gameDialog, sContainer, serverDrivenConfiguration);
  var settingsPanel = createUserSettingsPanel(serverDrivenConfiguration, tmp, tmp_0, MainMenuScene$showUserSettingsDialog$slambda_1(gameDialog, $this, sContainer));
  gameDialog._v = GameDialog.xlq(sContainer, settingsPanel, 'User settings');
  var tmp_1;
  if (gameDialog._v == null) {
    throwUninitializedPropertyAccessException('gameDialog');
  } else {
    tmp_1 = gameDialog._v;
  }
  tmp_1.ylq();
}
function *applyAuthenticatedConfiguration($this, serverDrivenConfiguration, configuration, $completion) {
  var settings = configuration.r6j_1 ? Companion_getInstance_1().l6u_1 : (yield* serverDrivenConfiguration.x6k($completion)).o6u_1;
  $this.blq_1 = configuration.n6j_1.w6j_1;
  $this.clq_1 = configuration.n6j_1.x6j_1;
  var tmp0_$this = get_gameConfiguration();
  var tmp1_isGuest = configuration.r6j_1;
  var tmp2_availableFeatures = configuration.o6j_1;
  var tmp3_allowedExpansions = configuration.p6j_1;
  var tmp4_recordingGameModeAvailable = configuration.q6j_1;
  var tmp5_enableRecoveryTestContent = configuration.s6j_1;
  set_gameConfiguration(withUserSettings(tmp0_$this.glr(VOID, tmp2_availableFeatures, tmp1_isGuest, VOID, tmp3_allowedExpansions, tmp4_recordingGameModeAvailable, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp5_enableRecoveryTestContent), settings));
  return Unit_instance;
}
function createGameOptions($this, sContainer, server) {
  var panel = new ControlPanelY();
  var dialog = GameDialog.xlq(sContainer, panel.xlb_1);
  var tmp0_color = Colors_getInstance().bc3_1;
  var tmp1_textSize = get_gameLayout().sl5_1;
  var problemText = PlainText('', tmp1_textSize, tmp0_color);
  var creating = {_v: false};
  var columns = new ControlPanelX(VOID, VOID, VOID, VOID, 50.0);
  var privateColumn = new ControlPanelY();
  addTo_0(ActionButton.vlb('Create private game', VOID, VOID, VOID, VOID, VOID, MainMenuScene$createGameOptions$slambda(creating, problemText, server, dialog, $this, sContainer)), privateColumn);
  addTo_0(privateColumn.xlb_1, columns);
  var publicColumn = new ControlPanelY();
  var publicRow = new ButtonRow();
  addTo_0(PlainText('Game name:', get_gameLayout().sl5_1), publicRow);
  // Inline function 'kotlin.apply' call
  var this_0 = UITextInput.kj3();
  var tmp = this_0.jj3();
  tmp.w9y(MainMenuScene$createGameOptions$lambda($this, creating, problemText, server, dialog, sContainer));
  var gameNameInput = addTo_0(this_0, publicRow);
  addTo_0(publicRow.xlb_1, publicColumn);
  var createPublicButton = addTo_0(ActionButton.vlb('Create public game', false, VOID, VOID, VOID, VOID, MainMenuScene$createGameOptions$slambda_0(gameNameInput, creating, problemText, server, dialog, $this, sContainer)), publicColumn);
  gameNameInput.xj2_1.tij_1.w9y(MainMenuScene$createGameOptions$lambda_0(createPublicButton, gameNameInput));
  publicColumn.flr();
  addTo_0(publicColumn.xlb_1, columns);
  columns.flr();
  addTo_0(columns.xlb_1, panel);
  panel.dlr_1 = columns.xlb_1.xea() + columns.xlb_1.rig() + 50.0;
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$createGameOptions$slambda_1(creating, dialog, $this, sContainer)), panel);
  addTo_0(problemText, panel);
  panel.flr();
  dialog.ylq();
}
function *joinLobbyOptions($this, sContainer, serverDrivenConfiguration, $completion) {
  var controlPanelY = new ControlPanelY();
  var gameDialog = GameDialog.xlq(sContainer, controlPanelY.xlb_1);
  var joinInProgress = {_v: false};
  addTo_0(PlainText('Choose a lobby', get_gameLayout().vl5_1), controlPanelY);
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$joinLobbyOptions$slambda(joinInProgress, gameDialog, $this, sContainer)), controlPanelY);
  var privateRow = new ControlPanelX();
  addTo_0(PlainText('Private game code:', get_gameLayout().sl5_1), privateRow);
  var privateCodeInput = addTo_0(UITextInput.kj3(), privateRow);
  var tmp0_color = Colors_getInstance().bc3_1;
  var tmp1_textSize = get_gameLayout().sl5_1;
  var problemText = PlainText('', tmp1_textSize, tmp0_color);
  var tmp = privateCodeInput.jj3();
  tmp.w9y(MainMenuScene$joinLobbyOptions$lambda($this, joinInProgress, privateCodeInput, problemText, serverDrivenConfiguration, gameDialog, sContainer));
  addTo_0(ActionButton.vlb('Join', VOID, VOID, VOID, VOID, VOID, MainMenuScene$joinLobbyOptions$slambda_0(joinInProgress, privateCodeInput, problemText, serverDrivenConfiguration, gameDialog, $this, sContainer)), privateRow);
  controlPanelY.mlr(privateRow.xlb_1);
  addTo_0(problemText, controlPanelY);
  var lobbyList = yield* serverDrivenConfiguration.b6l($completion);
  if (lobbyList.l6m_1.n1()) {
    addTo_0(PlainText('No public lobbies are open right now', get_gameLayout().sl5_1), controlPanelY);
  }
  var _iterator__ex2g4s = lobbyList.l6m_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var lobby = _iterator__ex2g4s.r1();
    var controlPanelX = new ControlPanelX();
    var tmp2_safe_receiver = lobby.h6q_1;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = getKClassFromExpression(tmp2_safe_receiver).j1();
    }
    var tmp3_elvis_lhs = tmp_0;
    var rulesName = tmp3_elvis_lhs == null ? 'No contract' : tmp3_elvis_lhs;
    addTo_0(PlainText(lobby.e6q_1 + ' - ' + rulesName + ' - ' + lobby.j6q_1 + ' clients', get_gameLayout().sl5_1), controlPanelX);
    addTo_0(ActionButton.vlb('Join', VOID, VOID, VOID, VOID, VOID, MainMenuScene$joinLobbyOptions$slambda_1(joinInProgress, sContainer, serverDrivenConfiguration, lobby, gameDialog, $this)), controlPanelX);
    addTo_0(controlPanelX.xlb_1, controlPanelY);
  }
  gameDialog.ylq();
  return Unit_instance;
}
function tryToReconnectByUrl($this, serverDrivenConfiguration, replayParams) {
  var urlParams = getGameReconnectParamsFromUrl();
  println('replayParams = ' + toString_0(replayParams));
  var sandboxCode = getSandboxCodeFromUrl();
  if (replayParams == null && urlParams == null && sandboxCode == null)
    return false;
  var tmp0_safe_receiver = $this.ylp_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1n();
  }
  var tmp = $this;
  tmp.ylp_1 = launch($this.wlp_1, VOID, VOID, MainMenuScene$tryToReconnectByUrl$slambda($this, replayParams, serverDrivenConfiguration, sandboxCode, urlParams));
  return true;
}
function navigateByCurrentUrl($this, serverDrivenConfiguration) {
  var replayParams = getReplayStartParamsFromUrl();
  var hasRoute = !(replayParams == null) || !(getGameReconnectParamsFromUrl() == null) || !(getSandboxCodeFromUrl() == null);
  if (hasRoute && !(serverDrivenConfiguration == null)) {
    closeCurrentDialog($this);
    tryToReconnectByUrl($this, serverDrivenConfiguration, replayParams);
    return Unit_instance;
  }
  if ($this.ulp_1.ndx_1) {
    if ($this.zlp_1 == null)
      return Unit_instance;
    var frame = $this.ei2();
    var referenceParams = getContentReferenceFromUrl();
    if (!(referenceParams == null)) {
      openContentReference($this, frame, referenceParams, false);
    } else if (!($this.alq_1 == null)) {
      closeCurrentDialog($this);
      launch($this, VOID, VOID, MainMenuScene$navigateByCurrentUrl$slambda($this, frame));
    }
    return Unit_instance;
  }
  var tmp0_safe_receiver = $this.ylp_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1n();
  }
  if (!$this.ulp_1.ndx_1) {
    $this.ulp_1.odx();
    var tmp = $this;
    tmp.ylp_1 = launch($this.wlp_1, VOID, VOID, MainMenuScene$navigateByCurrentUrl$slambda_0($this));
  }
}
function *tryReconnectByParams($this, replayParams, serverDrivenConfiguration, sandboxCode, urlParams, $completion) {
  try {
    var tmp;
    if (!(replayParams == null)) {
      tmp = new BeastResourceLookupRequest(BeastResourceKind_Replay_getInstance(), replayParams.plr_1, replayParams.qlr_1);
    } else {
      if (!(sandboxCode == null)) {
        tmp = new BeastResourceLookupRequest(BeastResourceKind_Game_getInstance(), sandboxCode, true);
      } else {
        if (!((urlParams == null ? null : urlParams.olr_1) == null)) {
          tmp = new BeastResourceLookupRequest(BeastResourceKind_Game_getInstance(), urlParams.nlr_1, VOID, _GameTeam___init__impl__xtwsj2(urlParams.olr_1));
        } else {
          tmp = null;
        }
      }
    }
    var resourceLookupRequest = tmp;
    if (!(resourceLookupRequest == null)) {
      var handoff = yield* serverDrivenConfiguration.m6l(resourceLookupRequest, $completion);
      if (!(handoff == null)) {
        navigateToFullPage(handoff.n6n_1);
        return true;
      }
    }
    if (!(replayParams == null)) {
      var replayCode = replayParams.jm();
      var isSandboxGame = replayParams.km();
      var completedGame = yield* serverDrivenConfiguration.l6l(replayCode, isSandboxGame, $completion);
      if (completedGame == null) {
        println('Failed to find replay game with code ' + replayCode.toString());
        return false;
      }
      performGameReplay($this, serverDrivenConfiguration, completedGame, isSandboxGame, replayParams.rlr_1, replayParams.slr_1, replayParams.tlr_1, false);
    } else if (!(sandboxCode == null)) {
      var ok = yield* reconnectToSandbox($this, serverDrivenConfiguration, sandboxCode, $completion);
      if (!ok)
        return false;
    } else if (!(urlParams == null)) {
      var urlGameCode = urlParams.jm();
      var urlTeamId = urlParams.km();
      if (urlTeamId == null)
        return false;
      var tmp1_elvis_lhs = get_clientSetupOrNull(yield* serverDrivenConfiguration.g6l(urlGameCode, _GameTeam___init__impl__xtwsj2(urlTeamId), VOID, $completion));
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return false;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var setup = tmp_0;
      yield* insideScope($this.ulp_1.plo_1, MainMenuScene$tryReconnectByParams$slambda($this, setup), $completion);
      return true;
    }
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var t = $p;
        printStackTrace(t);
        return false;
      } else {
        throw $p;
      }
    }
  }
  return true;
}
function *reconnectToSandbox($this, serverDrivenConfiguration, sandboxCode, $completion) {
  var tmp0_safe_receiver = yield* serverDrivenConfiguration.m6l(new BeastResourceLookupRequest(BeastResourceKind_Game_getInstance(), sandboxCode, true), $completion);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    navigateToFullPage(tmp0_safe_receiver.n6n_1);
    return true;
  }
  var reconnectResult = yield* serverDrivenConfiguration.t6l(sandboxCode, $completion);
  if (reconnectResult instanceof ReconnectSandboxPlaying) {
    var gameRules = reconnectResult.q6o_1;
    yield* insideScope($this.ulp_1.plo_1, MainMenuScene$reconnectToSandbox$slambda($this, gameRules, sandboxCode), $completion);
  } else {
    if (reconnectResult instanceof ReconnectSandboxInit) {
      yield* insideScope($this.ulp_1.plo_1, MainMenuScene$reconnectToSandbox$slambda_0($this, reconnectResult), $completion);
    } else {
      return false;
    }
  }
  return true;
}
function *showQuixoteTournamentReplays($this, sContainer, serverDrivenConfiguration, $completion) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = get_quixoteTournamentGames();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_safe_receiver = yield* serverDrivenConfiguration.l6l(element, false, $completion);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var tournamentGames = destination;
  yield* insideScope($this.ulp_1.plo_1, MainMenuScene$showQuixoteTournamentReplays$slambda($this, sContainer, serverDrivenConfiguration, tournamentGames), $completion);
  return Unit_instance;
}
function *duelGameReplayOptions($this, sContainer, serverDrivenConfiguration, gamesForReplay, includeTournamentReplays, $completion) {
  includeTournamentReplays = includeTournamentReplays === VOID ? false : includeTournamentReplays;
  var controlPanelY = new ControlPanelY();
  var gameRows = new ControlPanelY();
  var gameDialog = GameDialog.xlq(sContainer, controlPanelY.xlb_1);
  var tmp;
  if (includeTournamentReplays) {
    var tmp_0 = get_gameI18n().j6y_1;
    tmp = addTo_0(ActionButton.vlb(tmp_0, VOID, VOID, VOID, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda(gameDialog, $this, sContainer, serverDrivenConfiguration)), controlPanelY);
  } else {
    tmp = null;
  }
  var tournamentButton = tmp;
  addTo_0(PlainText('Choose a completed game to replay', get_gameLayout().vl5_1), controlPanelY);
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda_0(gameDialog, $this, sContainer)), controlPanelY);
  var _iterator__ex2g4s = gamesForReplay.p1();
  while (_iterator__ex2g4s.q1()) {
    var completedGame = _iterator__ex2g4s.r1();
    var controlPanelX = new ButtonRow();
    var timeStamp = !(completedGame.k6n() == null) ? ' at ' + toString_0(completedGame.k6n()) : '';
    var gameInfoPanel = new ControlPanelY();
    addTo_0(PlainText(completedGame.d6n_1 + timeStamp + ' (' + completedGame.e6n_1.toString() + ')', get_gameLayout().sl5_1), gameInfoPanel);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!completedGame.i6n_1.n1()) {
      var portraitsPanel = new ControlPanelX();
      var _iterator__ex2g4s_0 = completedGame.i6n_1.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var character = _iterator__ex2g4s_0.r1();
        addTo_0(toHeight(Image.lk7(yield* (yield* $this.vlp_1.qle(character, VOID, $completion)).m1q($completion)), get_gameLayout().nl6_1), portraitsPanel);
      }
      addTo_0(portraitsPanel.xlb_1, gameInfoPanel);
    }
    addTo_0(gameInfoPanel.xlb_1, controlPanelX);
    addTo_0(ActionButton.vlb('Replay', VOID, VOID, VOID, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda_1(gameDialog, $this, serverDrivenConfiguration, completedGame)), controlPanelX);
    if (completedGame.h6n_1) {
      addTo_0(ActionButton.vlb('Request public sharing', VOID, VOID, VOID, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda_2($this, serverDrivenConfiguration, completedGame, sContainer)), controlPanelX);
    }
    addTo_0(ActionButton.vlb('Check', VOID, VOID, VOID, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda_3($this, serverDrivenConfiguration, completedGame, sContainer)), controlPanelX);
    controlPanelX.flr();
    addTo_0(controlPanelX.xlb_1, gameRows);
  }
  addScrollableGameRows(controlPanelY, gameRows);
  if (tournamentButton == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tournamentButton.rif((controlPanelY.xlb_1.w9z() - tournamentButton.pig()) / 2);
  }
  gameDialog.ylq();
  return Unit_instance;
}
function *startNewSandbox($this, serverDrivenConfiguration, $completion) {
  if (!(serverDrivenConfiguration == null)) {
    yield* /*#__NOINLINE__*/applyAuthenticatedConfiguration($this, serverDrivenConfiguration, yield* serverDrivenConfiguration.o6l($completion), $completion);
  }
  yield* /*#__NOINLINE__*/initGame($this.ulp_1, $this.vlp_1, $this.wlp_1, new SandboxSetup(null), $completion);
  return Unit_instance;
}
function sandboxGamesOptions($this, sContainer, serverDrivenConfiguration, gamesForReplay) {
  var controlPanelY = new ControlPanelY();
  var gameRows = new ControlPanelY();
  var gameDialog = GameDialog.xlq(sContainer, controlPanelY.xlb_1);
  var navigationButtons = new ButtonColumn(Size2D.l9i(337, 49));
  addTo_0(ActionButton.vlb('New Sandbox', VOID, VOID, VOID, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda(gameDialog, $this, serverDrivenConfiguration)), navigationButtons);
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda_0(gameDialog, $this, sContainer)), navigationButtons);
  addTo_0(navigationButtons.xlb_1, controlPanelY);
  controlPanelY.dlr_1 = controlPanelY.dlr_1 + get_gameLayout().vl5_1;
  addTo_0(PlainText('Previous sandbox games', get_gameLayout().vl5_1), controlPanelY);
  var _iterator__ex2g4s = gamesForReplay.p1();
  while (_iterator__ex2g4s.q1()) {
    var sandboxGame = _iterator__ex2g4s.r1();
    var controlPanelX = new ControlPanelX();
    addTo_0(PlainText(sandboxGame.d6n_1 + ' at ' + toString_0(sandboxGame.k6n()), get_gameLayout().sl5_1), controlPanelX);
    var actions = new ButtonRow();
    addTo_0(actions.xlb_1, controlPanelX);
    addTo_0(ActionButton.vlb('Replay', VOID, VOID, VOID, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda_1(gameDialog, $this, serverDrivenConfiguration, sandboxGame)), actions);
    if (sandboxGame.e6n_1.equals(GameStatus_Active_getInstance())) {
      addTo_0(ActionButton.vlb('Continue', VOID, VOID, VOID, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda_2($this, serverDrivenConfiguration, sandboxGame)), actions);
    }
    if (!get_gameConfiguration().blc_1) {
      var tmp = sandboxGame.e6n_1.equals(GameStatus_Active_getInstance()) ? 'Finish and Share' : 'Share';
      addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda_3($this, serverDrivenConfiguration, sandboxGame, sContainer)), actions);
    }
    controlPanelX.flr();
    addTo_0(controlPanelX.xlb_1, gameRows);
  }
  addScrollableGameRows(controlPanelY, gameRows);
  controlPanelY.flr();
  gameDialog.ylq();
}
function performGameReplay($this, serverDrivenConfiguration, completedGame, isSandboxGame, startFromAnswer, infoStep, replayVisibility, updateUrlOnStart) {
  startFromAnswer = startFromAnswer === VOID ? 0 : startFromAnswer;
  infoStep = infoStep === VOID ? null : infoStep;
  replayVisibility = replayVisibility === VOID ? ReplayVisibility_CurrentTeam_getInstance() : replayVisibility;
  updateUrlOnStart = updateUrlOnStart === VOID ? true : updateUrlOnStart;
  var tmp0_safe_receiver = $this.xlp_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1n();
  }
  $this.ulp_1.odx();
  $this.ulp_1.ra8();
  $this.ulp_1.ndx_1 = false;
  var gameMapId = completedGame.g6n_1.h3a();
  var loadingProgress = new ReplayLoadingProgress(startFromAnswer);
  var startedReplayJob = null;
  var tmp = CoroutineStart_LAZY_getInstance();
  startedReplayJob = launch($this.wlp_1, VOID, tmp, MainMenuScene$performGameReplay$slambda(serverDrivenConfiguration, completedGame, isSandboxGame, $this, infoStep, startFromAnswer, replayVisibility, gameMapId, updateUrlOnStart, loadingProgress));
  var tmp_0 = $this;
  var tmp_1;
  if (startedReplayJob == null) {
    throwUninitializedPropertyAccessException('startedReplayJob');
  } else {
    tmp_1 = startedReplayJob;
  }
  tmp_0.xlp_1 = tmp_1;
  var tmp_2 = $this.ulp_1;
  var tmp_3;
  if (startedReplayJob == null) {
    throwUninitializedPropertyAccessException('startedReplayJob');
  } else {
    tmp_3 = startedReplayJob;
  }
  tmp_2.mdx_1 = tmp_3;
  var tmp_4;
  if (startedReplayJob == null) {
    throwUninitializedPropertyAccessException('startedReplayJob');
  } else {
    tmp_4 = startedReplayJob;
  }
  tmp_4.b1n();
}
function MainMenuScene$sceneInit$lambda(this$0, $serverDrivenConfiguration) {
  return () => {
    navigateByCurrentUrl(this$0, $serverDrivenConfiguration);
    return Unit_instance;
  };
}
function MainMenuScene$sceneInit$slambda$slambda$slambda($this_sceneInit, $reconnectingDialog) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration_0(1000, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    var gameDialog = showSingleTextDialog($this_sceneInit, 'Reconnecting...');
    $reconnectingDialog._v = gameDialog;
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sceneInit$slambda$slambda($onDisconnectJob, $reconnectingDialog, this$0, $this_sceneInit) {
  return constructCallableReference(function *(connectionStatus, $completion) {
    var tmp;
    switch (connectionStatus.w1_1) {
      case 0:
        var tmp1_safe_receiver = $onDisconnectJob._v;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.o1n();
        }

        $onDisconnectJob._v = null;
        var tmp2_safe_receiver = $reconnectingDialog._v;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.qlq();
        }

        $reconnectingDialog._v = null;
        tmp = Unit_instance;
        break;
      case 1:
        $onDisconnectJob._v = launch(this$0, VOID, VOID, MainMenuScene$sceneInit$slambda$slambda$slambda($this_sceneInit, $reconnectingDialog));
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sceneInit$slambda($serverDrivenConfiguration, this$0, $this_sceneInit) {
  return constructCallableReference(function *($this$launch, $completion) {
    var onDisconnectJob = {_v: null};
    var reconnectingDialog = {_v: null};
    var tmp = $serverDrivenConfiguration.r6k();
    var tmp_0 = MainMenuScene$sceneInit$slambda$slambda(onDisconnectJob, reconnectingDialog, this$0, $this_sceneInit);
    yield* tmp.s25(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), $completion);
    throwKotlinNothingValueException();
  }, 1);
}
function MainMenuScene$sceneInit$slambda_0($serverDrivenConfiguration, this$0, $this_sceneInit) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* $serverDrivenConfiguration.v6k($completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        println('Failed to restore the user session on main screen: ' + e.message);
        printStackTrace(e);
        throw e;
      } else {
        throw $p;
      }
    }
    var sessionState = tmp;
    var tmp_1;
    if (sessionState instanceof Authenticated) {
      tmp_1 = yield* /*#__NOINLINE__*/applyAuthenticatedConfiguration(this$0, $serverDrivenConfiguration, sessionState.h6j_1, $completion);
    } else {
      this$0.blq_1 = null;
      this$0.clq_1 = null;
      set_gameConfiguration(withUserSettings(get_gameConfiguration().glr(VOID, emptySet(), false), Companion_getInstance_1().l6u_1));
      tmp_1 = Unit_instance;
    }
    var replayParams = getReplayStartParamsFromUrl();
    var shouldShowLoadingState = tryToReconnectByUrl(this$0, $serverDrivenConfiguration, replayParams);
    var tmp_2;
    if (shouldShowLoadingState) {
      if (replayParams == null) {
        showSingleTextDialog($this_sceneInit, 'Loading...');
      }
      return Unit_instance;
    }
    var mainClientPath = (yield* $serverDrivenConfiguration.t6k($completion)).w6i_1;
    var tmp_3;
    if (!(mainClientPath == null)) {
      setNavigationUrlChangeListener(null);
      navigateToFullPage(mainClientPath, true);
      return Unit_instance;
    }
    this$0.ulp_1.ra8();
    yield* this$0.bls($this_sceneInit, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda($gameDialog, this$0, $sContainer, $serverDrivenConfiguration, $authenticationCapabilities) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    showLoginDialog(this$0, $sContainer, $serverDrivenConfiguration, $authenticationCapabilities);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda$slambda($serverDrivenConfiguration, $gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var pending = yield* $serverDrivenConfiguration.r6l($completion);
      $gameDialog.qlq();
      showPendingReplayConsents(this$0, $sContainer, $serverDrivenConfiguration, pending);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          var tmp0_elvis_lhs = e_0.message;
          showErrorDialog($sContainer, tmp0_elvis_lhs == null ? 'Failed to load pending consents' : tmp0_elvis_lhs);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_0(this$0, $serverDrivenConfiguration, $gameDialog, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$topLevelScene$slambda$slambda($serverDrivenConfiguration, $gameDialog, this$0, $sContainer));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_1($gameDialog, this$0, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    showUserSettingsDialog(this$0, $sContainer, $serverDrivenConfiguration);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda$slambda$slambda($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda$slambda_0($serverDrivenConfiguration, this$0, $gameDialog, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $serverDrivenConfiguration.w6k($completion);
    this$0.blq_1 = null;
    this$0.clq_1 = null;
    set_gameConfiguration(withUserSettings(get_gameConfiguration().glr(VOID, emptySet(), false), Companion_getInstance_1().l6u_1));
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$topLevelScene$slambda$slambda$slambda($gameDialog, this$0, $sContainer), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_2(this$0, $serverDrivenConfiguration, $gameDialog, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$topLevelScene$slambda$slambda_0($serverDrivenConfiguration, this$0, $gameDialog, $sContainer));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_3($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* this$0.cls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_4($gameDialog, this$0, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    createGameOptions(this$0, $sContainer, $serverDrivenConfiguration);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_5($gameDialog, this$0, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* /*#__NOINLINE__*/joinLobbyOptions(this$0, $sContainer, $serverDrivenConfiguration, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda$slambda$slambda_0(this$0, $sContainer, $serverDrivenConfiguration, $gamesForReplay) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/duelGameReplayOptions(this$0, $sContainer, $serverDrivenConfiguration, $gamesForReplay, true, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda$slambda_1(this$0, $sContainer, $serverDrivenConfiguration, $gamesForReplay) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$topLevelScene$slambda$slambda$slambda_0(this$0, $sContainer, $serverDrivenConfiguration, $gamesForReplay), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_6($gameDialog, this$0, $sContainer, $serverDrivenConfiguration, $gamesForReplay) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$topLevelScene$slambda$slambda_1(this$0, $sContainer, $serverDrivenConfiguration, $gamesForReplay));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_7($serverDrivenConfiguration, this$0) {
  return constructCallableReference(function *($completion) {
    var completedGame = yield* $serverDrivenConfiguration.l6l(get_onboardingReplayCode(), false, $completion);
    var tmp;
    if (completedGame == null) {
      println('Failed to find replay game with code ' + get_onboardingReplayCode().toString());
      tmp = Unit_instance;
    } else {
      performGameReplay(this$0, $serverDrivenConfiguration, completedGame, false);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda_8($gameDialog, this$0, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($completion) {
    $gameDialog.qlq();
    yield* /*#__NOINLINE__*/showQuixoteTournamentReplays(this$0, $sContainer, $serverDrivenConfiguration, $completion);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda$slambda_2(this$0, $sContainer, $serverDrivenConfiguration, $sandboxReplays) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    sandboxGamesOptions(this$0, $sContainer, $serverDrivenConfiguration, $sandboxReplays);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$topLevelScene$slambda_9($serverDrivenConfiguration, $sandboxReplays, this$0, $sContainer) {
  return constructCallableReference(function *($completion) {
    var tmp;
    var tmp_0;
    if (!($serverDrivenConfiguration == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$sandboxReplays.n1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$topLevelScene$slambda$slambda_2(this$0, $sContainer, $serverDrivenConfiguration, $sandboxReplays), $completion);
    } else {
      tmp = yield* /*#__NOINLINE__*/startNewSandbox(this$0, $serverDrivenConfiguration, $completion);
    }
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda_10($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($completion) {
    $gameDialog.qlq();
    openContentReference(this$0, $sContainer, new UrlContentReferenceParams('beast-bolgin'), true);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda_11($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($completion) {
    $gameDialog.qlq();
    showCommunityDialog(this$0, $sContainer);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda_12(this$0) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/initGame(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, NewGameSetup_instance, $completion);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda_13(this$0) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/initGame(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, LoadGameSetup_instance, $completion);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$topLevelScene$slambda_14($gameDialog) {
  return constructCallableReference(function *($completion) {
    $gameDialog.qlq();
    return Unit_instance;
  }, 0);
}
function MainMenuScene$openContentReference$slambda(this$0, $frame, $currentRoute) {
  return constructCallableReference(function *(it, $completion) {
    openContentReference(this$0, $frame, $currentRoute._v.wlq(), false);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$openContentReference$lambda($currentRoute) {
  return (route) => {
    var tmp;
    if (!route.equals($currentRoute._v)) {
      $currentRoute._v = route;
      setContentReferenceInUrl(route.wlq());
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function MainMenuScene$openContentReference$slambda_0(this$0, $frame) {
  return constructCallableReference(function *(it, $completion) {
    closeCurrentDialog(this$0);
    clearNavigationUrl(true);
    yield* this$0.bls($frame, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showCommunityDialog$slambda($it) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    openLinkInNewTab($it);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showCommunityDialog$slambda_0($dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $dialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function Container$_get_alpha_$ref_vzjrdr(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 548, VOID, [p0]);
}
function Container$_set_alpha_$ref_2opaz7(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 549, VOID, [p0]);
}
function MainMenuScene$startMenuBackground$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0 = this$0.dlq_1;
    var tmp = KMutableProperty0;
    var tmp_0 = Container$_get_alpha_$ref_vzjrdr(tmp0);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, Container$_set_alpha_$ref_2opaz7(tmp0));
    var tmp_1 = [new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    yield* tween(this$0.dlq_1, tmp_1, tmp$ret$1, VOID, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$startMenuBackground$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* yield_0($completion);
    var bitmap = yield* (yield* this$0.vlp_1.ile(GameMapId_NorthernExpanse_getInstance(), MapFormat_OriginalMap_getInstance(), $completion)).m1q($completion);
    // Inline function 'korlibs.korge.view.image' call
    var this_0 = this$0.dlq_1;
    var anchor = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(bitmap, anchor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var this_3 = Vector2D.a9k(get_gameLayout().el6_1, get_gameLayout().fl6_1);
    var tmp$ret$6 = Vector2D.t9g(this_3.r9g_1 / 2, this_3.s9g_1 / 2);
    this_2.fcw(tmp$ret$6);
    this_2.thy(false);
    var mapImage = this_2;
    // Inline function 'kotlin.collections.random' call
    var this_4 = get_northernExpanseMap().u44_1;
    var city = random(this_4, Default_getInstance()).r2v_1;
    var tmp = ensureNotNull(get_northernExpanseLogicalAndUiMapping().jl8(city)).ml8_1;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$9 = toDuration(6, DurationUnit_SECONDS_getInstance());
    var zoom = new MapZoomAnimation(mapImage, tmp, tmp$ret$9);
    // Inline function 'kotlin.apply' call
    var this_5 = shadowingCornersImage(Colors_getInstance().ac3_1);
    this_5.thy(false);
    this$0.dlq_1.uie(this_5);
    var tmp_0;
    if (get_gameConfiguration().olc_1) {
      zoom.v7e();
      this$0.dlq_1.sig(1.0);
      tmp_0 = Unit_instance;
    } else {
      yield* delay_0(new Long(1000, 0), $completion);
      launch($this$launch, VOID, VOID, MainMenuScene$startMenuBackground$slambda$slambda(this$0));
      tmp_0 = yield* zoom.hls($completion);
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showLoginDialog$lambda$slambda$slambda($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showLoginDialog$lambda$slambda($serverDrivenConfiguration, $inputText, this$0, $gameDialog, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.text.trim' call
    var this_0 = $inputText;
    var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var login = yield* $serverDrivenConfiguration.u6k(tmp$ret$0, $completion);
    var tmp;
    if (login instanceof Success) {
      tmp = yield* /*#__NOINLINE__*/applyAuthenticatedConfiguration(this$0, $serverDrivenConfiguration, login.c6j_1, $completion);
    } else {
      if (equals(login, Failure_getInstance())) {
        println('Access-code login failed');
        tmp = Unit_instance;
      } else {
        noWhenBranchMatchedException();
      }
    }
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$showLoginDialog$lambda$slambda$slambda($gameDialog, this$0, $sContainer), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showLoginDialog$lambda(this$0, $serverDrivenConfiguration, $gameDialog, $sContainer) {
  return (it) => {
    var inputText = it.dio();
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$showLoginDialog$lambda$slambda($serverDrivenConfiguration, inputText, this$0, $gameDialog, $sContainer));
    it.fio('');
    return Unit_instance;
  };
}
function MainMenuScene$showLoginDialog$slambda() {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    navigateToFullPage('/auth/discord/start?returnTo=%2F');
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showLoginDialog$slambda_0() {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    navigateToFullPage('/auth/steam/start?returnTo=%2F');
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showLoginDialog$slambda_1($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showPendingReplayConsents$respond$slambda($server, $consent, $approved, $dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var status = yield* $server.s6l($consent.b6o_1, $approved, $completion);
      var refreshed = yield* $server.r6l($completion);
      $dialog.qlq();
      showPendingReplayConsents(this$0, $sContainer, $server, refreshed);
      var tmp_0;
      if (status.equals(ReplaySharingStatus_Shared_getInstance())) {
        showSharedCode($sContainer, $consent.b6o_1, $server, false);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          var tmp0_elvis_lhs = e_0.message;
          showErrorDialog($sContainer, tmp0_elvis_lhs == null ? 'Failed to save consent' : tmp0_elvis_lhs);
          tmp_1 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }, 1);
}
function showPendingReplayConsents$respond(this$0, $server, consent, dialog, $sContainer, approved) {
  launch(this$0.wlp_1, VOID, VOID, MainMenuScene$showPendingReplayConsents$respond$slambda($server, consent, approved, dialog, this$0, $sContainer));
}
function MainMenuScene$showPendingReplayConsents$slambda(this$0, $server, $consent, $dialog, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showPendingReplayConsents$respond(this$0, $server, $consent, $dialog, $sContainer, true);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showPendingReplayConsents$slambda_0(this$0, $server, $consent, $dialog, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showPendingReplayConsents$respond(this$0, $server, $consent, $dialog, $sContainer, false);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showPendingReplayConsents$slambda_1($dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $dialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showUserSettingsDialog$slambda$slambda($update) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $update($completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showUserSettingsDialog$slambda(this$0) {
  return constructCallableReference(function *(update, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$showUserSettingsDialog$slambda$slambda(update));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showUserSettingsDialog$slambda$slambda_0($gameDialog, this$0, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    tmp.qlq();
    showUserSettingsDialog(this$0, $sContainer, $serverDrivenConfiguration);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showUserSettingsDialog$slambda_0(this$0, $gameDialog, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($completion) {
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$showUserSettingsDialog$slambda$slambda_0($gameDialog, this$0, $sContainer, $serverDrivenConfiguration), $completion);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$showUserSettingsDialog$slambda_1($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    tmp.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 0);
}
function *createGameOptions$create(creating, problemText, $server, dialog, this$0, $sContainer, name, $completion) {
  if (creating._v)
    return Unit_instance;
  if (!(name == null) && isBlank(name)) {
    problemText.fio('Enter a public game name');
    return Unit_instance;
  }
  creating._v = true;
  try {
    var tmp;
    if (name == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp = toString(trim(isCharSequence(name) ? name : THROW_CCE()));
    }
    var setup = yield* $server.d6l(tmp, $completion);
    if (!(setup == null)) {
      dialog.qlq();
      connectOrCreateGame(this$0, $sContainer, setup);
    } else {
      problemText.fio('A game with that name is already in progress');
    }
  }finally {
    creating._v = false;
  }
  return Unit_instance;
}
function MainMenuScene$createGameOptions$slambda($creating, $problemText, $server, $dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/createGameOptions$create($creating, $problemText, $server, $dialog, this$0, $sContainer, null, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$createGameOptions$lambda$slambda($input, $creating, $problemText, $server, $dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/createGameOptions$create($creating, $problemText, $server, $dialog, this$0, $sContainer, $input.dio(), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$createGameOptions$lambda(this$0, $creating, $problemText, $server, $dialog, $sContainer) {
  return (input) => {
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = input.dio();
    if (!isBlank(this_0)) {
      launch(this$0, VOID, VOID, MainMenuScene$createGameOptions$lambda$slambda(input, $creating, $problemText, $server, $dialog, this$0, $sContainer));
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function MainMenuScene$createGameOptions$slambda_0($gameNameInput, $creating, $problemText, $server, $dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/createGameOptions$create($creating, $problemText, $server, $dialog, this$0, $sContainer, $gameNameInput.dio(), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$createGameOptions$lambda_0($createPublicButton, $gameNameInput) {
  return (it) => {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = $gameNameInput.dio();
    var tmp$ret$0 = !isBlank(this_0);
    $createPublicButton.ils(tmp$ret$0);
    return Unit_instance;
  };
}
function MainMenuScene$createGameOptions$slambda_1($creating, $dialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($creating._v) {
      return Unit_instance;
    }
    $dialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$joinLobbyOptions$slambda($joinInProgress, $gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($joinInProgress._v) {
      return Unit_instance;
    }
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function *joinLobbyOptions$joinPrivate(joinInProgress, privateCodeInput, problemText, $serverDrivenConfiguration, gameDialog, this$0, $sContainer, $completion) {
  if (joinInProgress._v)
    return Unit_instance;
  // Inline function 'kotlin.text.trim' call
  var this_0 = privateCodeInput.dio();
  var code = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(code) === 0) {
    problemText.fio('Enter a private game code');
    return Unit_instance;
  }
  joinInProgress._v = true;
  try {
    var setup = yield* $serverDrivenConfiguration.e6l(new GameCode(code), $completion);
    if (!(setup == null)) {
      gameDialog.qlq();
      connectOrCreateGame(this$0, $sContainer, setup);
    } else {
      problemText.fio('No open private lobby has that code');
    }
  }finally {
    joinInProgress._v = false;
  }
  return Unit_instance;
}
function MainMenuScene$joinLobbyOptions$lambda$slambda($joinInProgress, $privateCodeInput, $problemText, $serverDrivenConfiguration, $gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/joinLobbyOptions$joinPrivate($joinInProgress, $privateCodeInput, $problemText, $serverDrivenConfiguration, $gameDialog, this$0, $sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$joinLobbyOptions$lambda(this$0, $joinInProgress, $privateCodeInput, $problemText, $serverDrivenConfiguration, $gameDialog, $sContainer) {
  return (it) => {
    launch(this$0, VOID, VOID, MainMenuScene$joinLobbyOptions$lambda$slambda($joinInProgress, $privateCodeInput, $problemText, $serverDrivenConfiguration, $gameDialog, this$0, $sContainer));
    return Unit_instance;
  };
}
function MainMenuScene$joinLobbyOptions$slambda_0($joinInProgress, $privateCodeInput, $problemText, $serverDrivenConfiguration, $gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/joinLobbyOptions$joinPrivate($joinInProgress, $privateCodeInput, $problemText, $serverDrivenConfiguration, $gameDialog, this$0, $sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$joinLobbyOptions$slambda_1($joinInProgress, $sContainer, $serverDrivenConfiguration, $lobby, $gameDialog, this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($joinInProgress._v) {
      return Unit_instance;
    }
    $joinInProgress._v = true;
    var waitDialog = showSingleTextDialog($sContainer, 'Joining lobby...');
    try {
      var setup = yield* $serverDrivenConfiguration.e6l($lobby.f6q_1, $completion);
      waitDialog.qlq();
      if (!(setup == null)) {
        $gameDialog.qlq();
        connectOrCreateGame(this$0, $sContainer, setup);
      } else {
        showSingleTextDialog($sContainer, 'Lobby ' + $lobby.e6q_1 + ' is no longer available');
      }
    }finally {
      $joinInProgress._v = false;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$tryToReconnectByUrl$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/startFromMainMenu(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$tryToReconnectByUrl$slambda(this$0, $replayParams, $serverDrivenConfiguration, $sandboxCode, $urlParams) {
  return constructCallableReference(function *($this$launch, $completion) {
    this$0.ulp_1.odx();
    var ok = yield* /*#__NOINLINE__*/tryReconnectByParams(this$0, $replayParams, $serverDrivenConfiguration, $sandboxCode, $urlParams, $completion);
    var tmp;
    if (!ok) {
      clearNavigationUrl();
      tmp = yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$tryToReconnectByUrl$slambda$slambda(this$0), $completion);
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$navigateByCurrentUrl$slambda(this$0, $frame) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* this$0.bls($frame, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$navigateByCurrentUrl$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/startFromMainMenu(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$navigateByCurrentUrl$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$navigateByCurrentUrl$slambda$slambda(this$0), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$tryReconnectByParams$slambda(this$0, $setup) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/initGame(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, new ServerDuelSetup($setup), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$reconnectToSandbox$slambda(this$0, $gameRules, $sandboxCode) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/initGame(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, new ReconnectSandboxSetup($gameRules, $sandboxCode), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$reconnectToSandbox$slambda_0(this$0, $reconnectResult) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/initGame(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, new SandboxSetup($reconnectResult), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$reconnectOptions$slambda($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$reconnectOptions$slambda_0($reconnectInProgress, $sContainer, $serverDrivenConfiguration, $gameCode, $gameTeam, $gameDialog, this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($reconnectInProgress._v) {
      return Unit_instance;
    }
    $reconnectInProgress._v = true;
    var waitDialog = showSingleTextDialog($sContainer, 'Reconnecting...');
    try {
      var tmp0_safe_receiver = yield* $serverDrivenConfiguration.m6l(new BeastResourceLookupRequest(BeastResourceKind_Game_getInstance(), $gameCode, VOID, $gameTeam), $completion);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        navigateToFullPage(tmp0_safe_receiver.n6n_1);
        return Unit_instance;
      }
      var reconnect = get_clientSetupOrNull(yield* $serverDrivenConfiguration.g6l($gameCode, $gameTeam, VOID, $completion));
      waitDialog.qlq();
      if (!(reconnect == null)) {
        $gameDialog.qlq();
        yield* /*#__NOINLINE__*/initGame(this$0.ulp_1, this$0.vlp_1, this$0.wlp_1, new ServerDuelSetup(reconnect), $completion);
      } else {
        showSingleTextDialog($sContainer, 'Failed to reconnect as ' + get_gameI18n().m70($gameTeam));
      }
    }finally {
      $reconnectInProgress._v = false;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$reconnectOptions$slambda_1($reconnectInProgress, $sContainer, $serverDrivenConfiguration, $gameCode, $sessionInfo, $gameDialog, this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($reconnectInProgress._v) {
      return Unit_instance;
    }
    $reconnectInProgress._v = true;
    var waitDialog = showSingleTextDialog($sContainer, 'Reloading game...');
    var tmp_0;
    try {
      var tmp_1 = BeastResourceKind_Game_getInstance();
      var tmp_2 = first_0($sessionInfo.y6p_1);
      var tmp0_safe_receiver = yield* $serverDrivenConfiguration.m6l(new BeastResourceLookupRequest(tmp_1, $gameCode, VOID, tmp_2 == null ? null : tmp_2.r3p_1), $completion);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        navigateToFullPage(tmp0_safe_receiver.n6n_1);
        return Unit_instance;
      }
      yield* $serverDrivenConfiguration.a6m($gameCode, $completion);
      $gameDialog.qlq();
      tmp_0 = yield* this$0.cls($sContainer, $completion);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Exception) {
          var e_0 = $p;
          var tmp1_elvis_lhs = e_0.message;
          showErrorDialog($sContainer, tmp1_elvis_lhs == null ? 'Game reload failed' : tmp1_elvis_lhs);
          tmp_3 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp_0 = tmp_3;
    }
    finally {
      waitDialog.qlq();
      $reconnectInProgress._v = false;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$reconnectOptions$slambda_2($reconnectInProgress, $serverDrivenConfiguration, $gameCode, $gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($reconnectInProgress._v) {
      return Unit_instance;
    }
    yield* $serverDrivenConfiguration.h6l($gameCode, $completion);
    $gameDialog.qlq();
    yield* this$0.cls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$showQuixoteTournamentReplays$slambda(this$0, $sContainer, $serverDrivenConfiguration, $tournamentGames) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* /*#__NOINLINE__*/duelGameReplayOptions(this$0, $sContainer, $serverDrivenConfiguration, $tournamentGames, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda($gameDialog, this$0, $sContainer, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* /*#__NOINLINE__*/showQuixoteTournamentReplays(this$0, $sContainer, $serverDrivenConfiguration, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda_0($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda_1($gameDialog, this$0, $serverDrivenConfiguration, $completedGame) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    performGameReplay(this$0, $serverDrivenConfiguration, $completedGame, false);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda$slambda($serverDrivenConfiguration, $completedGame, this$0, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var handoff = yield* $serverDrivenConfiguration.m6l(new BeastResourceLookupRequest(BeastResourceKind_Replay_getInstance(), $completedGame.c6n_1), $completion);
      if (!(handoff == null)) {
        navigateToFullPage(handoff.n6n_1);
        return Unit_instance;
      }
      tmp = yield* /*#__NOINLINE__*/requestPublicReplaySharing(this$0, $sContainer, $serverDrivenConfiguration, $completedGame.c6n_1, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          var tmp0_elvis_lhs = e_0.message;
          showErrorDialog($sContainer, tmp0_elvis_lhs == null ? 'Failed to share replay' : tmp0_elvis_lhs);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda_2(this$0, $serverDrivenConfiguration, $completedGame, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda$slambda($serverDrivenConfiguration, $completedGame, this$0, $sContainer));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda$slambda$slambda($sContainer, $outcomeMessage) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    showSingleTextDialog($sContainer, $outcomeMessage);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda$slambda_0($serverDrivenConfiguration, $completedGame, this$0, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.with' call
    var outcome = yield* checkReplayFromServer(PrintingGameRuntimeDiagnostics_instance, $serverDrivenConfiguration, $completedGame.c6n_1, $completion);
    var tmp;
    if (equals(outcome, GameIsNotFound_instance)) {
      tmp = 'Replay game ' + $completedGame.c6n_1.toString() + ' was not found';
    } else {
      if (outcome instanceof GameIsEnded) {
        tmp = 'Replay check passed: winner is ' + get_gameI18n().m70(outcome.t6t_1);
      } else {
        if (equals(outcome, IncompleteGame_instance)) {
          tmp = 'Replay check finished, but the game outcome is incomplete';
        } else {
          if (outcome instanceof ExceptionInReplaying) {
            // Inline function 'kotlin.text.buildString' call
            // Inline function 'kotlin.apply' call
            var this_0 = StringBuilder.l1();
            this_0.m1('Replay check failed: ');
            var tmp0_elvis_lhs = getKClassFromExpression(outcome.u6t_1).j1();
            this_0.m1(tmp0_elvis_lhs == null ? 'Unknown error' : tmp0_elvis_lhs);
            var tmp1_safe_receiver = outcome.u6t_1.message;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              this_0.m1(' - ');
              this_0.m1(tmp1_safe_receiver);
            }
            tmp = this_0.toString();
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var outcomeMessage = tmp;
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$duelGameReplayOptions$slambda$slambda$slambda($sContainer, outcomeMessage), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$duelGameReplayOptions$slambda_3(this$0, $serverDrivenConfiguration, $completedGame, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$duelGameReplayOptions$slambda$slambda_0($serverDrivenConfiguration, $completedGame, this$0, $sContainer));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda($gameDialog, this$0, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* /*#__NOINLINE__*/startNewSandbox(this$0, $serverDrivenConfiguration, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda_0($gameDialog, this$0, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    yield* this$0.bls($sContainer, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda_1($gameDialog, this$0, $serverDrivenConfiguration, $sandboxGame) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    performGameReplay(this$0, $serverDrivenConfiguration, $sandboxGame, true);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda$slambda(this$0, $serverDrivenConfiguration, $sandboxGame) {
  return constructCallableReference(function *($this$launch, $completion) {
    var ok = yield* /*#__NOINLINE__*/reconnectToSandbox(this$0, $serverDrivenConfiguration, $sandboxGame.c6n_1, $completion);
    var tmp;
    if (!ok) {
      tmp = yield* get_gameProblemReporter().jls('Failed to continue sandbox game replay ' + $sandboxGame.c6n_1.toString(), $completion);
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda_2(this$0, $serverDrivenConfiguration, $sandboxGame) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda$slambda(this$0, $serverDrivenConfiguration, $sandboxGame));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda$slambda_0($serverDrivenConfiguration, $sandboxGame, $sContainer) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      yield* $serverDrivenConfiguration.p6l($sandboxGame.c6n_1, $completion);
      showSharedCode($sContainer, $sandboxGame.c6n_1, $serverDrivenConfiguration, true);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function MainMenuScene$sandboxGamesOptions$slambda_3(this$0, $serverDrivenConfiguration, $sandboxGame, $sContainer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.wlp_1, VOID, VOID, MainMenuScene$sandboxGamesOptions$slambda$slambda_0($serverDrivenConfiguration, $sandboxGame, $sContainer));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$slambda($loadingProgress, this$0) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var loadingText = PlainText($loadingProgress.ols(), get_gameLayout().vl5_1);
    $loadingProgress.pls(loadingText);
    $loadingProgress.qls(showSingleTextDialog_0(this$0.ulp_1.plo_1, loadingText));
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$lambda(this$0, $serverDrivenConfiguration) {
  return () => {
    navigateByCurrentUrl(this$0, $serverDrivenConfiguration);
    return Unit_instance;
  };
}
function MainMenuScene$performGameReplay$slambda$slambda$slambda($loadingProgress, $currentAnswerIndex) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    $loadingProgress.alt($currentAnswerIndex);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$slambda_0(this$0, $loadingProgress) {
  return constructCallableReference(function *(currentAnswerIndex, $completion) {
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$performGameReplay$slambda$slambda$slambda($loadingProgress, currentAnswerIndex), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$slambda$slambda_0($loadingProgress) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    $loadingProgress.v7e();
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$slambda_1(this$0, $loadingProgress) {
  return constructCallableReference(function *($completion) {
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$performGameReplay$slambda$slambda$slambda_0($loadingProgress), $completion);
    return Unit_instance;
  }, 0);
}
function MainMenuScene$performGameReplay$slambda$lambda_0($infoStep, $gameCode, $isSandboxGame, $switchingGameTeamProvider) {
  return (it) => {
    var tmp;
    if (!($infoStep == null)) {
      tmp = KorgeOnboardingGameFlowListener_getInstance().sdy_1;
    } else {
      tmp = null;
    }
    var adjusted = tmp;
    var tmp_0;
    if ($switchingGameTeamProvider._v == null) {
      throwUninitializedPropertyAccessException('switchingGameTeamProvider');
    } else {
      tmp_0 = $switchingGameTeamProvider._v;
    }
    setReplayCodeInUrl($gameCode, $isSandboxGame, it, adjusted, tmp_0.ze0_1);
    return Unit_instance;
  };
}
function MainMenuScene$performGameReplay$slambda$lambda$slambda($gameReplayDriver) {
  return constructCallableReference(function *(it, $completion) {
    yield* $gameReplayDriver.a98(it, $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$lambda_1($gameReplayDriver) {
  return ($this$createSharedTeamsScene) => {
    $this$createSharedTeamsScene.sl2_1 = true;
    $this$createSharedTeamsScene.blt(MainMenuScene$performGameReplay$slambda$lambda$slambda($gameReplayDriver));
    return Unit_instance;
  };
}
function MainMenuScene$performGameReplay$slambda$slambda$slambda_1($loadingProgress) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    $loadingProgress.v7e();
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda$slambda_2(this$0, $loadingProgress) {
  return constructCallableReference(function *($this$withContext, $completion) {
    yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$performGameReplay$slambda$slambda$slambda_1($loadingProgress), $completion);
    return Unit_instance;
  }, 1);
}
function MainMenuScene$performGameReplay$slambda($serverDrivenConfiguration, $completedGame, $isSandboxGame, this$0, $infoStep, $startFromAnswer, $replayVisibility, $gameMapId, $updateUrlOnStart, $loadingProgress) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var tmp0_safe_receiver = yield* $serverDrivenConfiguration.m6l(new BeastResourceLookupRequest(BeastResourceKind_Replay_getInstance(), $completedGame.c6n_1, $isSandboxGame), $completion);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        navigateToFullPage(tmp0_safe_receiver.n6n_1);
        return Unit_instance;
      }
      yield* insideScope(this$0.ulp_1.plo_1, MainMenuScene$performGameReplay$slambda$slambda($loadingProgress, this$0), $completion);
      var gameCode = $completedGame.c6n_1;
      var gameReplayDriver = yield* $serverDrivenConfiguration.n6l(gameCode, $isSandboxGame, $completion);
      if (gameReplayDriver == null) {
        println('Failed to start sandbox replay for game code ' + gameCode.toString());
        return Unit_instance;
      }
      if (gameCode.equals(get_onboardingReplayCode())) {
        var tmp1_elvis_lhs = $infoStep;
        applyOnboardingGlobalMode(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, $startFromAnswer);
      } else {
        clearOnboardingGlobalMode();
      }
      var switchingGameTeamProvider = {_v: null};
      var menuManagement = new MainMenuScene$performGameReplay$1$menuManagement$1(gameReplayDriver, $isSandboxGame, $completedGame, this$0, $serverDrivenConfiguration, gameCode, switchingGameTeamProvider);
      setNavigationUrlChangeListener(MainMenuScene$performGameReplay$slambda$lambda(this$0, $serverDrivenConfiguration));
      var tmp_0 = get_beastsGameTeam();
      var tmp_1 = replayStartShowAnswerFrom($startFromAnswer, $infoStep);
      var tmp_2 = MainMenuScene$performGameReplay$slambda$slambda_0(this$0, $loadingProgress);
      var tmp_3 = MainMenuScene$performGameReplay$slambda$slambda_1(this$0, $loadingProgress);
      switchingGameTeamProvider._v = new SwitchingGameTeamProvider(tmp_0, tmp_1, tmp_2, tmp_3, MainMenuScene$performGameReplay$slambda$lambda_0($infoStep, gameCode, $isSandboxGame, switchingGameTeamProvider));
      var tmp_4;
      if (switchingGameTeamProvider._v == null) {
        throwUninitializedPropertyAccessException('switchingGameTeamProvider');
      } else {
        tmp_4 = switchingGameTeamProvider._v;
      }
      tmp_4.ze0_1 = $replayVisibility;
      var tmp_5;
      if (switchingGameTeamProvider._v == null) {
        throwUninitializedPropertyAccessException('switchingGameTeamProvider');
      } else {
        tmp_5 = switchingGameTeamProvider._v;
      }
      var tmp2_safe_receiver = tmp_5.ae1();
      var tmp_6 = tmp2_safe_receiver;
      if ((tmp_6 == null ? null : new GameTeam(tmp_6)) == null)
        null;
      else {
        var tmp_7 = tmp2_safe_receiver;
        // Inline function 'kotlin.let' call
        var it = (tmp_7 == null ? null : new GameTeam(tmp_7)).r3p_1;
        var tmp_8;
        if (switchingGameTeamProvider._v == null) {
          throwUninitializedPropertyAccessException('switchingGameTeamProvider');
        } else {
          tmp_8 = switchingGameTeamProvider._v;
        }
        tmp_8.qe0_1 = it;
      }
      var mapFormat = requiredMapFormat($completedGame.g6n_1);
      var tmp_9;
      if (switchingGameTeamProvider._v == null) {
        throwUninitializedPropertyAccessException('switchingGameTeamProvider');
      } else {
        tmp_9 = switchingGameTeamProvider._v;
      }
      var tmp_10 = tmp_9;
      var shared = yield* createSharedTeamsScene(this$0.ulp_1.plo_1, this$0.vlp_1, tmp_10, menuManagement, $gameMapId, mapFormat, VOID, MainMenuScene$performGameReplay$slambda$lambda_1(gameReplayDriver), $completion);
      var tmp_11 = get_beastsGameTeam();
      var tmp_12;
      if (switchingGameTeamProvider._v == null) {
        throwUninitializedPropertyAccessException('switchingGameTeamProvider');
      } else {
        tmp_12 = switchingGameTeamProvider._v;
      }
      var beastAgentControl = new SameScreenControlAgent(tmp_11, tmp_12, shared, this$0.ulp_1, this$0.vlp_1);
      var tmp_13 = get_huntersGameTeam();
      var tmp_14;
      if (switchingGameTeamProvider._v == null) {
        throwUninitializedPropertyAccessException('switchingGameTeamProvider');
      } else {
        tmp_14 = switchingGameTeamProvider._v;
      }
      var huntersAgentControl = new SameScreenControlAgent(tmp_13, tmp_14, shared, this$0.ulp_1, this$0.vlp_1);
      var savedAnswersSource = new SimpleSavedAnswersSource();
      beastAgentControl.se2(savedAnswersSource);
      huntersAgentControl.se2(savedAnswersSource);
      yield* $serverDrivenConfiguration.i6l(beastAgentControl, get_beastsGameTeam(), $completion);
      yield* $serverDrivenConfiguration.i6l(huntersAgentControl, get_huntersGameTeam(), $completion);
      if ($updateUrlOnStart) {
        var tmp_15;
        if (switchingGameTeamProvider._v == null) {
          throwUninitializedPropertyAccessException('switchingGameTeamProvider');
        } else {
          tmp_15 = switchingGameTeamProvider._v;
        }
        setReplayCodeInUrl(gameCode, $isSandboxGame, $startFromAnswer, VOID, tmp_15.ze0_1);
      }
      tmp = yield* gameReplayDriver.v6t($completion);
    } catch ($p) {
      var tmp_16;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var t = $p;
          printStackTrace(t);
          tmp_16 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_16;
    }
    finally {
      var tmp_17 = NonCancellable_getInstance();
      yield* withContext(tmp_17, MainMenuScene$performGameReplay$slambda$slambda_2(this$0, $loadingProgress), $completion);
      if (this$0.xlp_1 === $this$launch.d1m().ae(Key_instance)) {
        this$0.xlp_1 = null;
      }
      if (this$0.ulp_1.mdx_1 === $this$launch.d1m().ae(Key_instance)) {
        this$0.ulp_1.mdx_1 = null;
      }
    }
    return Unit_instance;
  }, 1);
}
function *initSingleKorgeAgent(hotSeatSceneManager, images, menuManagement, team, gameMapId, mapFormat, $completion) {
  var provider = new SwitchingGameTeamProvider(team, VOID, VOID, VOID, VOID, false);
  var shared = yield* createSharedTeamsScene(hotSeatSceneManager.plo_1, images, provider, menuManagement, gameMapId, mapFormat, false, VOID, $completion);
  var korgeAgent = new SameScreenControlAgent(team, provider, shared, hotSeatSceneManager, images);
  hotSeatSceneManager.ldx_1 = team;
  yield* shared.plu(hotSeatSceneManager.plo_1, $completion);
  return korgeAgent;
}
function showSingleTextDialog(frame, message) {
  _init_properties_BeastUiMain_kt__6hf30m();
  return showSingleTextDialog_0(frame, PlainText(message, get_gameLayout().vl5_1));
}
function *createAgents(images, menuManagement, hotSeatSceneManager, gameMapId, mapFormat, $completion) {
  var tmp;
  switch (get_gameConfiguration().llc_1.w1_1) {
    case 0:
    case 1:
      var switchingGameTeamProvider = new SwitchingGameTeamProvider(get_beastsGameTeam());
      var shared = yield* createSharedTeamsScene(hotSeatSceneManager.plo_1, images, switchingGameTeamProvider, menuManagement, gameMapId, mapFormat, VOID, VOID, $completion);
      tmp = to(new SameScreenControlAgent(get_beastsGameTeam(), switchingGameTeamProvider, shared, hotSeatSceneManager, images, get_gameConfiguration().llc_1.equals(ScreenSwitchMode_SWITCH_SIDES_getInstance())), new SameScreenControlAgent(get_huntersGameTeam(), switchingGameTeamProvider, shared, hotSeatSceneManager, images, get_gameConfiguration().llc_1.equals(ScreenSwitchMode_SWITCH_SIDES_getInstance())));
      break;
    case 2:
      var huntersAgent = yield* /*#__NOINLINE__*/initSingleKorgeAgent(hotSeatSceneManager, images, menuManagement, get_huntersGameTeam(), gameMapId, mapFormat, $completion);
      tmp = to(ensureNotNull(get_gameConfiguration().dld_1).qlu(), huntersAgent);
      break;
    case 3:
      var beastsAgent = yield* /*#__NOINLINE__*/initSingleKorgeAgent(hotSeatSceneManager, images, menuManagement, get_beastsGameTeam(), gameMapId, mapFormat, $completion);
      tmp = to(beastsAgent, ensureNotNull(get_gameConfiguration().dld_1).qlu());
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function showSingleTextDialog_0(frame, text) {
  _init_properties_BeastUiMain_kt__6hf30m();
  var panel = new ControlPanelY();
  addTo_0(text, panel);
  var gameDialog = GameDialog.xlq(frame, panel.xlb_1, VOID, get_gameDialogClose());
  gameDialog.ylq();
  return gameDialog;
}
function startKorgeUi$slambda($logicScope) {
  return constructCallableReference(function *($this$start, $completion) {
    yield* /*#__NOINLINE__*/initEngineGame($this$start, $logicScope, $completion);
    return Unit_instance;
  }, 1);
}
function startKorgeUi$slambda_0($logicScope) {
  return constructCallableReference(function *($this$Korge, $completion) {
    yield* /*#__NOINLINE__*/initEngineGame($this$Korge, $logicScope, $completion);
    return Unit_instance;
  }, 1);
}
function initEngineGame$slambda$lambda(it) {
  _init_properties_BeastUiMain_kt__6hf30m();
  return it instanceof FixedSizeContainer;
}
function initEngineGame$slambda$lambda_0($sceneInjector, $ui) {
  return ($this$mapPrototype) => new BeastGameScene($ui);
}
function initEngineGame$slambda($this_initEngineGame, $logicScope) {
  return constructCallableReference(function *(images, hotSeatSceneManager, $completion) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this_initEngineGame;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_14()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_10().c9s_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var views_0 = yield* views($completion);
    var width = size.jm();
    var height = size.km();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp = findFirstAscendant(this_0, initEngineGame$slambda$lambda);
      var base = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
      var tmp1_elvis_lhs = base == null ? null : base.w9z();
      rwidth = tmp1_elvis_lhs == null ? views_0.pho_1.w9z() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.x9z();
      rheight = tmp3_elvis_lhs == null ? views_0.pho_1.x9z() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.mhu(views_0, defaultTransition, name, Size2D.y9p(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    var sceneContainer = addTo(this_1, this_0);
    var tmp0_subject = get_gameConfiguration().zlb_1;
    switch (tmp0_subject == null ? -1 : tmp0_subject.w1_1) {
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        var ui = yield* createBeastGameUi(sceneContainer, images, new JustGameTeamProvider(get_beastsGameTeam()), BindingTestMenuManagement_instance, GameMapId_LowerShatteredIsles_getInstance(), MapFormat_OriginalMap_getInstance(), VOID, $completion);
        // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call

        var injects = [];
        // Inline function 'korlibs.time.seconds' call

        // Inline function 'korlibs.time.seconds' call

        var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
        var transition = sceneContainer.hhu_1;
        var tmp2 = getKClass(BeastGameScene);
        // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call

        var injects_0 = injects.slice();
        var sceneInjector = sceneContainer.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), sceneContainer).qe4(getKClass(Resources), new Resources(sceneContainer.d1m(), sceneContainer.ghu_1.whu().wbw_1, sceneContainer.ghu_1.whu()));
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n = 0;
        while (n < injects_0.length) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var inject = injects_0[_unary__edvuaz];
          var tmp_0 = getKClassFromExpression(inject);
          sceneInjector.qe4(isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE(), inject);
        }

        var newScene = new BeastGameScene(ui);
        // Inline function 'korlibs.logger.Logger.info' call

        var tmp0 = Companion_getInstance_5().mi5_1;
        // Inline function 'korlibs.logger.Logger.log' call

        var level = Level_INFO_getInstance();
        if (tmp0.obj(level)) {
          var tmp$ret$14 = 'Changing scene to... ' + toString(tmp2) + ' ... ' + toString(newScene);
          tmp0.pbj(level, tmp$ret$14);
        }

        if (true) {
          newScene.be5(sceneInjector);
          var tmp_1 = getKClassFromExpression(newScene);
          var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
          sceneContainer.ghu_1.fhn_1.ue4(tmp_2, initEngineGame$slambda$lambda_0(sceneInjector, ui));
        }

        yield* sceneContainer.oi5(newScene, time, transition, $completion);
        break;
      case 2:
        yield* /*#__NOINLINE__*/initGame(hotSeatSceneManager, images, $logicScope, new OfflineRecordedGameSetup(get_gameConfiguration().klc_1), $completion);
        break;
      default:
        var hotSeatSceneManager_0 = new HotSeatSceneManager(sceneContainer);
        yield* /*#__NOINLINE__*/startFromMainMenu(hotSeatSceneManager_0, images, $logicScope, $completion);
        break;
    }
    return Unit_instance;
  }, 2);
}
function commonInitGame$slambda$slambda() {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* get_globalLoadingResourceManager().rlu($completion);
    return Unit_instance;
  }, 1);
}
function commonInitGame$slambda$lambda(it) {
  _init_properties_BeastUiMain_kt__6hf30m();
  return it instanceof FixedSizeContainer;
}
function commonInitGame$slambda$slambda$slambda$slambda($dismissedMessageIds, $message) {
  return constructCallableReference(function *($completion) {
    var tmp0 = $dismissedMessageIds;
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.update' call
      while (true) {
        var prevValue = tmp0.k3();
        var nextValue = plus_1(prevValue, $message.j6u());
        if (tmp0.q25(prevValue, nextValue)) {
          break $l$block;
        }
      }
    }
    return Unit_instance;
  }, 0);
}
function commonInitGame$slambda$slambda$slambda$slambda_0($cancelIcon) {
  return constructCallableReference(function *(it, $completion) {
    yield* $cancelIcon.clx(true, $completion);
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_over_$ref_7juzhw() {
  return constructCallableReference((p0) => p0.whw_1, 1, 0, 550);
}
function commonInitGame$slambda$slambda$slambda$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function commonInitGame$slambda$slambda$slambda$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, commonInitGame$slambda$slambda$slambda$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function commonInitGame$slambda$slambda$slambda$slambda_1($cancelIcon) {
  return constructCallableReference(function *(it, $completion) {
    yield* $cancelIcon.clx(false, $completion);
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_out_$ref_qyed9w() {
  return constructCallableReference((p0) => p0.xhw_1, 1, 0, 551);
}
function commonInitGame$slambda$slambda$slambda$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function commonInitGame$slambda$slambda$slambda$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, commonInitGame$slambda$slambda$slambda$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function commonInitGame$slambda$slambda$slambda$slambda_2($dismissedMessageIds, $message) {
  return constructCallableReference(function *(it, $completion) {
    var tmp0 = $dismissedMessageIds;
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.update' call
      while (true) {
        var prevValue = tmp0.k3();
        var nextValue = plus_1(prevValue, $message.j6u());
        if (tmp0.q25(prevValue, nextValue)) {
          break $l$block;
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_click_$ref_klwzrm() {
  return constructCallableReference((p0) => p0.vhw_1, 1, 0, 552);
}
function commonInitGame$slambda$slambda$slambda$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function commonInitGame$slambda$slambda$slambda$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, commonInitGame$slambda$slambda$slambda$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function commonInitGame$slambda$slambda$slambda($banner, $cancelBitmap, $dismissedMessageIds) {
  return constructCallableReference(function *(messages, $completion) {
    $banner.tie();
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$0 = !messages.n1();
    $banner.ngk(tmp$ret$0);
    var tmp;
    if (messages.n1()) {
      return Unit_instance;
    }
    var tmp0 = $banner;
    var tmp2 = get_gameLayout().el6_1;
    var tmp4 = imul(messages.s2(), 28) + 8 | 0;
    // Inline function 'korlibs.korge.view.solidRect' call
    var color = Colors_getInstance().qci('#6b4800');
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = SolidRect.mkf(Size2D.l9i(tmp2, tmp4), color);
    // Inline function 'kotlin.apply' call
    addTo(this_0, tmp0);
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(messages, 10));
    var index = 0;
    var _iterator__ex2g4s = messages.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      // Inline function 'korlibs.korge.view.container' call
      var this_1 = $banner;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_2 = Container.fi2(false);
      // Inline function 'kotlin.apply' call
      var this_3 = addTo(this_2, this_1);
      this_3.sif(8.0 + imul(index_0, 28));
      var tmp2_0 = get_gameLayout().el6_1;
      // Inline function 'korlibs.korge.view.solidRect' call
      var color_0 = Colors_getInstance().qci('#6b4800');
      // Inline function 'korlibs.korge.view.addTo' call
      var this_4 = SolidRect.mkf(Size2D.l9i(tmp2_0, 28), color_0);
      // Inline function 'kotlin.apply' call
      addTo(this_4, this_3);
      var row = this_3;
      // Inline function 'korlibs.korge.view.text' call
      var color_1 = Colors_getInstance().zc2_1;
      var font = get_DefaultTtfFontAsBitmap();
      var alignment = Companion_getInstance_16().ucr_1;
      var renderer = get_DefaultStringTextRenderer();
      var autoScaling = Companion_instance_0.zj5_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_5 = Text.aj6('', numberToDouble(18.0), color_1, font, alignment, renderer, autoScaling, null, null);
      // Inline function 'kotlin.apply' call
      var this_6 = addTo(this_5, row);
      this_6.rif(12.0);
      var notice = this_6;
      // Inline function 'kotlin.apply' call
      var this_7 = addTo(DialogCancelIcon.dlx($cancelBitmap, 20.0, commonInitGame$slambda$slambda$slambda$slambda($dismissedMessageIds, item)), row);
      this_7.rif(get_gameLayout().el6_1 - this_7.w9z() - 12.0);
      this_7.sif(2.0);
      var cancelIcon = this_7;
      var tmp2_1 = get_gameLayout().el6_1;
      var tmp4_0 = index_0 === 0 ? 36 : 28;
      // Inline function 'korlibs.korge.view.solidRect' call
      var color_2 = Colors_getInstance().ec3_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_8 = SolidRect.mkf(Size2D.l9i(tmp2_1, tmp4_0), color_2);
      // Inline function 'kotlin.apply' call
      var this_9 = addTo(this_8, row);
      if (index_0 === 0) {
        this_9.sif(-8.0);
      }
      var mouseArea = this_9;
      // Inline function 'korlibs.korge.input.mouse' call
      // Inline function 'kotlin.run' call
      var $this$mouse = get_mouse(mouseArea);
      // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
      var handler = commonInitGame$slambda$slambda$slambda$slambda_0(cancelIcon);
      var tmp_0 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_1 = getPropertyCallableRef('over', 1, tmp_0, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
      tmp_1.v9y(commonInitGame$slambda$slambda$slambda$lambda($this$mouse, handler));
      // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
      var handler_0 = commonInitGame$slambda$slambda$slambda$slambda_1(cancelIcon);
      var tmp_2 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_3 = getPropertyCallableRef('out', 1, tmp_2, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
      tmp_3.v9y(commonInitGame$slambda$slambda$slambda$lambda_0($this$mouse, handler_0));
      // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
      var handler_1 = commonInitGame$slambda$slambda$slambda$slambda_2($dismissedMessageIds, item);
      var tmp_4 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_5 = getPropertyCallableRef('click', 1, tmp_4, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
      tmp_5.v9y(commonInitGame$slambda$slambda$slambda$lambda_1($this$mouse, handler_1));
      var tmp$ret$7 = to(notice, cancelIcon.wea() - notice.wea() - 8.0);
      destination.d2(tmp$ret$7);
    }
    var notices = destination;
    $l$loop: while (true) {
      var now = System_instance.xu().ov();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = zip(messages, notices).p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        var message = element.jm();
        var noticeLayout = element.km();
        var notice_0 = noticeLayout.jm();
        var availableWidth = noticeLayout.km();
        notice_0.fio(displayText(message, now));
        notice_0.uif(1.0);
        if (notice_0.w9z() > availableWidth) {
          notice_0.uif(availableWidth / notice_0.w9z());
        }
      }
      var tmp$ret$37;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_6;
        if (isInterface(messages, Collection)) {
          tmp_6 = messages.n1();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$37 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s_1 = messages.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_0 = _iterator__ex2g4s_1.r1();
          if (element_0 instanceof Maintenance) {
            tmp$ret$37 = false;
            break $l$block_0;
          }
        }
        tmp$ret$37 = true;
      }
      if (tmp$ret$37)
        break $l$loop;
      yield* delay_0(new Long(1000, 0), $completion);
    }
    return Unit_instance;
  }, 1);
}
function commonInitGame$slambda$slambda_0($server, $dismissedMessageIds, $banner, $cancelBitmap) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = visibleServerMessages($server.s6k(), $dismissedMessageIds);
    yield* collectLatest(tmp, commonInitGame$slambda$slambda$slambda($banner, $cancelBitmap, $dismissedMessageIds), $completion);
    return Unit_instance;
  }, 1);
}
function commonInitGame$slambda($this_commonInitGame, $fn) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    launch($this$coroutineScope, VOID, VOID, commonInitGame$slambda$slambda());
    var loadingResourceReporter = new LoadingResourceReporter($this_commonInitGame, new Long(200, 0), new Long(500, 0));
    var images = new BeastGameImages($this_commonInitGame.phw(), loadingResourceReporter);
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this_commonInitGame;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_14()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_10().c9s_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var views_0 = yield* views($completion);
    var width = size.jm();
    var height = size.km();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp = findFirstAscendant(this_0, commonInitGame$slambda$lambda);
      var base = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
      var tmp1_elvis_lhs = base == null ? null : base.w9z();
      rwidth = tmp1_elvis_lhs == null ? views_0.pho_1.w9z() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.x9z();
      rheight = tmp3_elvis_lhs == null ? views_0.pho_1.x9z() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.mhu(views_0, defaultTransition, name, Size2D.y9p(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    var sceneContainer = addTo(this_1, this_0);
    var hotSeatSceneManager = new HotSeatSceneManager(sceneContainer);
    yield* $fn(images, hotSeatSceneManager, $completion);
    var tmp0_safe_receiver = get_gameConfiguration().flc_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      var cancelBitmap = yield* (yield* images.tld(InterfaceIcon_Cancel_getInstance(), $completion)).m1q($completion);
      var dismissedMessageIds = MutableStateFlow(emptySet());
      // Inline function 'korlibs.korge.view.container' call
      var this_2 = $this_commonInitGame;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = Container.fi2(false);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, this_2);
      this_4.ngk(false);
      var banner = this_4;
      tmp_0 = launch($this$coroutineScope, VOID, VOID, commonInitGame$slambda$slambda_0(tmp0_safe_receiver, dismissedMessageIds, banner, cancelBitmap));
    }
    return tmp_0;
  }, 1);
}
function startFromMainMenu$lambda($sceneInjector, $hotSeatSceneManager, $images, $logicScope) {
  return ($this$mapPrototype) => new MainMenuScene($hotSeatSceneManager, $images, $logicScope);
}
function initGame$awaitReload$slambda$slambda$slambda($serverDrivenConfiguration) {
  return constructCallableReference(function *($completion) {
    yield* $serverDrivenConfiguration.z6l($completion);
    return Unit_instance;
  }, 0);
}
function initGame$awaitReload$slambda$slambda$slambda$slambda$lambda($sceneInjector, $menuManagement, $requestServerReload) {
  return ($this$mapPrototype) => new AwaitingGameReloadScene($menuManagement, $requestServerReload ? 'Reloading game...' : 'Reconnecting to game...');
}
function initGame$awaitReload$slambda$slambda$slambda$slambda($hotSeatSceneManager, $menuManagement, $requestServerReload) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    $hotSeatSceneManager.ra8();
    var tmp0 = $hotSeatSceneManager.plo_1;
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
    var transition = tmp0.hhu_1;
    var tmp2 = getKClass(AwaitingGameReloadScene);
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var injects_0 = injects.slice();
    var sceneInjector = tmp0.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), tmp0).qe4(getKClass(Resources), new Resources(tmp0.d1m(), tmp0.ghu_1.whu().wbw_1, tmp0.ghu_1.whu()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects_0.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects_0[_unary__edvuaz];
      var tmp = getKClassFromExpression(inject);
      sceneInjector.qe4(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
    }
    var newScene = new AwaitingGameReloadScene($menuManagement, $requestServerReload ? 'Reloading game...' : 'Reconnecting to game...');
    // Inline function 'korlibs.logger.Logger.info' call
    var tmp0_0 = Companion_getInstance_5().mi5_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_INFO_getInstance();
    if (tmp0_0.obj(level)) {
      var tmp$ret$9 = 'Changing scene to... ' + toString(tmp2) + ' ... ' + toString(newScene);
      tmp0_0.pbj(level, tmp$ret$9);
    }
    if (true) {
      newScene.be5(sceneInjector);
      var tmp_0 = getKClassFromExpression(newScene);
      var tmp_1 = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
      tmp0.ghu_1.fhn_1.ue4(tmp_1, initGame$awaitReload$slambda$slambda$slambda$slambda$lambda(sceneInjector, $menuManagement, $requestServerReload));
    }
    yield* tmp0.oi5(newScene, time, transition, $completion);
    return Unit_instance;
  }, 1);
}
function initGame$awaitReload$slambda$slambda$slambda_0($hotSeatSceneManager, $menuManagement, $requestServerReload) {
  return constructCallableReference(function *($completion) {
    yield* insideScope($hotSeatSceneManager.plo_1, initGame$awaitReload$slambda$slambda$slambda$slambda($hotSeatSceneManager, $menuManagement, $requestServerReload), $completion);
    return Unit_instance;
  }, 0);
}
function initGame$awaitReload$slambda$slambda$slambda_1($serverDrivenConfiguration, $reconnectedSetup, $setup) {
  return constructCallableReference(function *($completion) {
    yield* $serverDrivenConfiguration.c6l($completion);
    $reconnectedSetup._v = get_clientSetupOrNull(yield* $serverDrivenConfiguration.f6l($setup.o6q_1, $setup.p6q_1, null, $completion));
    // Inline function 'kotlin.check' call
    if (!!($reconnectedSetup._v == null)) {
      var message = 'Cannot reconnect to reloaded game ' + $setup.o6q_1.toString();
      throw IllegalStateException.o(toString(message));
    }
    return Unit_instance;
  }, 0);
}
function initGame$awaitReload$slambda$slambda$slambda$slambda_0($hotSeatSceneManager, $reconnectJob, $images, $logicScope, $reconnectedSetup) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var tmp;
    var tmp_0 = $hotSeatSceneManager.mdx_1;
    var tmp_1;
    if ($reconnectJob._v == null) {
      throwUninitializedPropertyAccessException('reconnectJob');
    } else {
      tmp_1 = $reconnectJob._v;
    }
    if (tmp_0 === tmp_1) {
      $hotSeatSceneManager.mdx_1 = null;
      // Inline function 'kotlin.requireNotNull' call
      var tmp0 = $reconnectedSetup._v;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message = 'Required value was null.';
          throw IllegalArgumentException.h2(toString(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var tmp$ret$0 = tmp$ret$1;
      tmp = yield* /*#__NOINLINE__*/initGame_0($hotSeatSceneManager, $images, $logicScope, new ServerDuelSetup(tmp$ret$0), false, $completion);
    }
    return Unit_instance;
  }, 1);
}
function initGame$awaitReload$slambda$slambda$slambda_2($hotSeatSceneManager, $reconnectJob, $images, $logicScope, $reconnectedSetup) {
  return constructCallableReference(function *($completion) {
    yield* insideScope($hotSeatSceneManager.plo_1, initGame$awaitReload$slambda$slambda$slambda$slambda_0($hotSeatSceneManager, $reconnectJob, $images, $logicScope, $reconnectedSetup), $completion);
    return Unit_instance;
  }, 0);
}
function initGame$awaitReload$slambda$slambda$slambda_3($hotSeatSceneManager, $e) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var tmp0_elvis_lhs = $e.message;
    showErrorDialog($hotSeatSceneManager.plo_1, tmp0_elvis_lhs == null ? 'Game reload failed' : tmp0_elvis_lhs);
    return Unit_instance;
  }, 1);
}
function initGame$awaitReload$slambda$slambda($sessionJob, $requestServerReload, $hotSeatSceneManager, $serverDrivenConfiguration, $menuManagement, $setup, $reconnectJob, $images, $logicScope) {
  return constructCallableReference(function *($this$launch, $completion) {
    var reconnectedSetup = {_v: null};
    var tmp;
    try {
      var tmp_0;
      if ($sessionJob._v == null) {
        throwUninitializedPropertyAccessException('sessionJob');
      } else {
        tmp_0 = $sessionJob._v;
      }
      var tmp_1 = tmp_0;
      var tmp_2;
      if ($requestServerReload) {
        tmp_2 = initGame$awaitReload$slambda$slambda$slambda($serverDrivenConfiguration);
      } else {
        tmp_2 = null;
      }
      var tmp_3 = tmp_2;
      var tmp_4 = initGame$awaitReload$slambda$slambda$slambda_0($hotSeatSceneManager, $menuManagement, $requestServerReload);
      var tmp_5 = initGame$awaitReload$slambda$slambda$slambda_1($serverDrivenConfiguration, reconnectedSetup, $setup);
      tmp = yield* reconnectClientAfterReload(tmp_1, tmp_3, tmp_4, tmp_5, initGame$awaitReload$slambda$slambda$slambda_2($hotSeatSceneManager, $reconnectJob, $images, $logicScope, reconnectedSetup), $completion);
    } catch ($p) {
      var tmp_6;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Exception) {
          var e_0 = $p;
          tmp_6 = yield* insideScope($hotSeatSceneManager.plo_1, initGame$awaitReload$slambda$slambda$slambda_3($hotSeatSceneManager, e_0), $completion);
        } else {
          throw $p;
        }
      }
      tmp = tmp_6;
    }
    return Unit_instance;
  }, 1);
}
function initGame$awaitReload$slambda($hotSeatSceneManager, $sessionJob, $logicScope, $requestServerReload, $serverDrivenConfiguration, $menuManagement, $setup, $images) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    var tmp_0 = $hotSeatSceneManager.mdx_1;
    var tmp_1;
    if ($sessionJob._v == null) {
      throwUninitializedPropertyAccessException('sessionJob');
    } else {
      tmp_1 = $sessionJob._v;
    }
    if (!(tmp_0 === tmp_1)) {
      return Unit_instance;
    }
    var reconnectJob = {_v: null};
    var tmp_2 = CoroutineStart_LAZY_getInstance();
    reconnectJob._v = launch($logicScope, VOID, tmp_2, initGame$awaitReload$slambda$slambda($sessionJob, $requestServerReload, $hotSeatSceneManager, $serverDrivenConfiguration, $menuManagement, $setup, reconnectJob, $images, $logicScope));
    var tmp_3 = $hotSeatSceneManager;
    var tmp_4;
    if (reconnectJob._v == null) {
      throwUninitializedPropertyAccessException('reconnectJob');
    } else {
      tmp_4 = reconnectJob._v;
    }
    tmp_3.mdx_1 = tmp_4;
    var tmp_5;
    if (reconnectJob._v == null) {
      throwUninitializedPropertyAccessException('reconnectJob');
    } else {
      tmp_5 = reconnectJob._v;
    }
    tmp_5.b1n();
    return Unit_instance;
  }, 1);
}
function initGame$lambda() {
  _init_properties_BeastUiMain_kt__6hf30m();
  return Unit_instance;
}
function initGame$o$restartCallback$slambda($hotSeatSceneManager, $images, $logicScope) {
  return constructCallableReference(function *($this$launch, $completion) {
    $hotSeatSceneManager.odx();
    clearNavigationUrl();
    yield* /*#__NOINLINE__*/startFromMainMenu($hotSeatSceneManager, $images, $logicScope, $completion);
    return Unit_instance;
  }, 1);
}
function initGame$awaitReload($hotSeatSceneManager, sessionJob, $logicScope, serverDrivenConfiguration, menuManagement, setup, $images, requestServerReload) {
  launch($hotSeatSceneManager.plo_1, VOID, VOID, initGame$awaitReload$slambda($hotSeatSceneManager, sessionJob, $logicScope, requestServerReload, serverDrivenConfiguration, menuManagement, setup, $images));
}
function initGame$lambda_0($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images) {
  return () => {
    initGame$awaitReload($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images, true);
    return Unit_instance;
  };
}
function initGame$slambda$lambda($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images) {
  return () => {
    initGame$awaitReload($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images, false);
    return Unit_instance;
  };
}
function initGame$slambda$slambda$slambda($hotSeatSceneManager, $setup, $images, $logicScope) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    showSingleTextDialog($hotSeatSceneManager.plo_1, 'Cannot connect to created game ' + $setup.o6q_1.toString());
    clearNavigationUrl();
    yield* /*#__NOINLINE__*/startFromMainMenu($hotSeatSceneManager, $images, $logicScope, $completion);
    return Unit_instance;
  }, 1);
}
function initGame$slambda$slambda($hotSeatSceneManager, $setup, $images, $logicScope) {
  return constructCallableReference(function *($completion) {
    yield* insideScope($hotSeatSceneManager.plo_1, initGame$slambda$slambda$slambda($hotSeatSceneManager, $setup, $images, $logicScope), $completion);
    return Unit_instance;
  }, 0);
}
function initGame$slambda$slambda$lambda($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images) {
  return () => {
    initGame$awaitReload($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images, false);
    return Unit_instance;
  };
}
function initGame$slambda$slambda$lambda_0($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images) {
  return () => {
    initGame$awaitReload($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images, true);
    return Unit_instance;
  };
}
function initGame$slambda$slambda_0($hotSeatSceneManager, $sessionJob, $e, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var tmp;
    var tmp_0 = $hotSeatSceneManager.mdx_1;
    var tmp_1;
    if ($sessionJob._v == null) {
      throwUninitializedPropertyAccessException('sessionJob');
    } else {
      tmp_1 = $sessionJob._v;
    }
    if (tmp_0 === tmp_1) {
      var tmp0_elvis_lhs = $e.message;
      var tmp_2 = tmp0_elvis_lhs == null ? 'Unknown game session error' : tmp0_elvis_lhs;
      var tmp_3 = initGame$slambda$slambda$lambda($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images);
      showGameSessionErrorDialog($hotSeatSceneManager.plo_1, tmp_2, tmp_3, initGame$slambda$slambda$lambda_0($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images));
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function initGame$slambda($serverDrivenConfiguration, $setup, $reconnectNetworkSession, $hotSeatSceneManager, $sessionJob, $logicScope, $menuManagement, $images) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var tmp_0 = initGame$slambda$lambda($hotSeatSceneManager, $sessionJob, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images);
      tmp = yield* processDuelSession($serverDrivenConfiguration, $setup, $reconnectNetworkSession, tmp_0, initGame$slambda$slambda($hotSeatSceneManager, $setup, $images, $logicScope), $completion);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof GameSessionReloadRequiredException) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = Unit_instance;
      } else {
        if ($p instanceof CancellationException) {
          var e = $p;
          throw e;
        } else {
          if ($p instanceof Error) {
            var e_0 = $p;
            tmp_1 = yield* insideScope($hotSeatSceneManager.plo_1, initGame$slambda$slambda_0($hotSeatSceneManager, $sessionJob, e_0, $logicScope, $serverDrivenConfiguration, $menuManagement, $setup, $images), $completion);
          } else {
            throw $p;
          }
        }
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }, 1);
}
function initGame$lambda_1($sceneInjector, $chooseScenarioScene) {
  return ($this$mapPrototype) => $chooseScenarioScene;
}
function initGame$slambda$lambda_0(sandboxCode) {
  _init_properties_BeastUiMain_kt__6hf30m();
  setSandboxCodeInUrl(sandboxCode);
  return Unit_instance;
}
function initGame$slambda_0($gameSetup, $images, $menuManagement, $hotSeatSceneManager, $newGameSetupState) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var tmp0_subject = $gameSetup;
      var tmp_0;
      if (tmp0_subject instanceof OfflineRecordedGameSetup) {
        var offlineReplayGameManager = ensureNotNull(get_gameConfiguration().dld_1);
        var tmp_1;
        if ($gameSetup.pdx_1) {
          var gameSession = yield* offlineReplayGameManager.llx(0, $completion);
          var gameState = offlineReplayGameManager.mlx(gameSession);
          var tmp_2 = gameState.h47();
          var gameMapId = (tmp_2 instanceof GameMapImpl ? tmp_2 : THROW_CCE()).l44_1;
          var mapFormat = requiredMapFormat(gameState.x40());
          var _destruct__k2r9zo = yield* /*#__NOINLINE__*/createAgents($images, $menuManagement, $hotSeatSceneManager, gameMapId, mapFormat, $completion);
          var beastAgentControl = _destruct__k2r9zo.jm();
          var huntersAgentControl = _destruct__k2r9zo.km();
          tmp_1 = yield* offlineReplayGameManager.olx(beastAgentControl, huntersAgentControl, $completion);
        } else {
          var finishReplayOnAnswerNumber = $gameSetup.qdx_1;
          var gameSession_0 = yield* offlineReplayGameManager.llx(finishReplayOnAnswerNumber, $completion);
          var gameState_0 = offlineReplayGameManager.mlx(gameSession_0);
          var gameMapId_0 = gameState_0.x40().h3a();
          var mapFormat_0 = requiredMapFormat(gameState_0.x40());
          var _destruct__k2r9zo_0 = yield* /*#__NOINLINE__*/createAgents($images, $menuManagement, $hotSeatSceneManager, gameMapId_0, mapFormat_0, $completion);
          var beastAgentControl_0 = _destruct__k2r9zo_0.jm();
          var huntersAgentControl_0 = _destruct__k2r9zo_0.km();
          tmp_1 = yield* offlineReplayGameManager.nlx(beastAgentControl_0, huntersAgentControl_0, gameSession_0, $completion);
        }
        tmp_0 = tmp_1;
      } else {
        if (tmp0_subject instanceof NewGameSetup) {
          var gameSetupState = yield* ensureNotNull($newGameSetupState).m1q($completion);
          var gameRules = ensureNotNull(gameSetupState.y4j_1);
          var gameMapId_1 = gameRules.h3a();
          var mapFormat_1 = requiredMapFormat(gameRules);
          var _destruct__k2r9zo_1 = yield* /*#__NOINLINE__*/createAgents($images, $menuManagement, $hotSeatSceneManager, gameMapId_1, mapFormat_1, $completion);
          var beastAgentControl_1 = _destruct__k2r9zo_1.jm();
          var huntersAgentControl_1 = _destruct__k2r9zo_1.km();
          tmp_0 = yield* ensureNotNull(get_gameConfiguration().ylc_1)(beastAgentControl_1, huntersAgentControl_1, gameRules, true, $completion);
        } else {
          if (tmp0_subject instanceof SandboxSetup) {
            tmp_0 = yield* playSandboxMode($newGameSetupState, $images, $menuManagement, $hotSeatSceneManager, $gameSetup.ydx_1, initGame$slambda$lambda_0, $completion);
          } else {
            if (tmp0_subject instanceof ReconnectSandboxSetup) {
              setSandboxCodeInUrl($gameSetup.ady_1);
              tmp_0 = yield* reconnectSandbox($images, $menuManagement, $hotSeatSceneManager, $gameSetup, $completion);
            } else {
              if (tmp0_subject instanceof LoadGameSetup) {
                var _destruct__k2r9zo_2 = yield* /*#__NOINLINE__*/createAgents($images, $menuManagement, $hotSeatSceneManager, GameMapId_NorthernExpanse_getInstance(), MapFormat_OriginalMap_getInstance(), $completion);
                var beastAgentControl_2 = _destruct__k2r9zo_2.jm();
                var huntersAgentControl_2 = _destruct__k2r9zo_2.km();
                tmp_0 = ensureNotNull(get_gameConfiguration().zlc_1)(beastAgentControl_2, huntersAgentControl_2);
              }
            }
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_3;
      if ($p instanceof CancellationException) {
        var e = $p;
        println('Game was canceled');
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          printStackTrace(e_0);
          tmp_3 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_3;
    }
    return Unit_instance;
  }, 1);
}
var properties_initialized_BeastUiMain_kt_30faas;
function _init_properties_BeastUiMain_kt__6hf30m() {
  if (!properties_initialized_BeastUiMain_kt_30faas) {
    properties_initialized_BeastUiMain_kt_30faas = true;
    gameI18n = new BeastGameI18n();
  }
}
function _get_gameState__b96etq($this) {
  return $this.xlm().t6h();
}
function findLocationAreaForLocalPoint($this, posLocal) {
  var inductionVariable = -4;
  if (inductionVariable <= 4)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = -5;
      if (inductionVariable_0 <= 5)
        $l$loop_0: do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var position = _BoardPosition___init__impl__1nizgq(x, y);
          var tmp0_elvis_lhs = $this.fl7_1.jl8(position);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var area = tmp;
          // Inline function 'korlibs.math.geom.Vector2D.minus' call
          var this_0 = area.ml8_1;
          if (Vector2D.t9g(this_0.r9g_1 - posLocal.r9g_1, this_0.s9g_1 - posLocal.s9g_1).h9t() > area.nl8_1 * area.nl8_1)
            continue $l$loop_0;
          return area;
        }
         while (inductionVariable_0 <= 5);
    }
     while (inductionVariable <= 4);
  return null;
}
function *installHoveredUi($this, area, $completion) {
  if (!!($this.il7_1 == null)) {
    return Unit_instance;
  }
  var position = area.kl8_1;
  installSandboxRelatedHovers($this, area, position);
  yield* installSnareHover($this, position, $completion);
  yield* installRuinHover($this, position, $completion);
  return Unit_instance;
}
function installSandboxRelatedHovers($this, area, position) {
  if (!$this.se3())
    return Unit_instance;
  var tmp0 = $this.hl7_1;
  // Inline function 'korlibs.korge.view.circle' call
  var radius = area.nl8_1;
  var fill = new RGBA(Colors_getInstance().zc2_1);
  var stroke = new RGBA(Colors_getInstance().zc2_1);
  var renderer = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Circle.ajq(numberToDouble(radius), fill, stroke, numberToDouble(0.0), true, renderer);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, tmp0);
  this_1.ijb(Companion_getInstance_7().o9g());
  this_1.fcw(area.ml8_1);
  this_1.zjp(RGBA__withA_impl_vogscm(Colors_getInstance().zc2_1, 100));
  var sandboxHoverView = this_1;
  $this.gl8_1.d2(new BeastUiMap$installSandboxRelatedHovers$1($this, position, sandboxHoverView));
}
function *installRuinHover($this, position, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _get_gameState__b96etq($this);
  var gameMapId = $this$with.x40().h3a();
  var tmp;
  switch (gameMapId.w1_1) {
    case 0:
    case 1:
      if (!get_gameContentVersion($this$with.x40()).h4g() || !$this$with.h47().i3d().w2(new BoardPosition(position)))
        return Unit_instance;
      // Inline function 'kotlin.collections.filterIsInstance' call

      var tmp0 = $this$with.q4k().v4n_1;
      // Inline function 'kotlin.collections.filterIsInstanceTo' call

      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!(element == null) ? isInterface(element, AshRuin) : false) {
          destination.d2(element);
        }
      }

      // Inline function 'kotlin.collections.map' call

      // Inline function 'kotlin.collections.mapTo' call

      var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
      var _iterator__ex2g4s_0 = destination.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var item = _iterator__ex2g4s_0.r1();
        var tmp_0 = Image.lk7(yield* (yield* $this.pl6().lle(item, $completion)).m1q($completion));
        var tmp$ret$6 = toHeight(CardUi.ilo(tmp_0, VOID, item, false, false, VOID, BeastUiMap$installRuinHover$slambda()), get_gameLayout().ol5_1 * 1.3);
        destination_0.d2(tmp$ret$6);
      }

      tmp = destination_0;
      break;
    case 3:
    case 2:
      if (!$this$with.h47().i3d().w2(new BoardPosition(position)))
        return Unit_instance;
      var tmp1_elvis_lhs = shatteredIslesRuinInfoRect(gameMapId, position);
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }

      var rect = tmp_1;
      var contract = yield* (yield* $this.pl6().jle($this$with.x40(), $completion)).m1q($completion);
      var tmp_2 = Image.lk7($this.pl6().alf(contract, rect));
      tmp = listOf_0(toHeight(CardUi.ilo(tmp_2, VOID, VOID, false, false, VOID, BeastUiMap$installRuinHover$slambda_0()), get_gameLayout().ol5_1 * 1.3));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var ruinCards = tmp;
  if (ruinCards.n1())
    return Unit_instance;
  var ruinsPanel = new ControlPanelX();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = ruinCards.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_0 = _iterator__ex2g4s_1.r1();
    addTo_0(element_0, ruinsPanel);
  }
  $this.xlm().plx(ruinsPanel.xlb_1, OverPanelUiHoverPosition_OverArsenalHover_getInstance());
  $this.gl8_1.d2(new BeastUiMap$installRuinHover$2(ruinsPanel));
  return Unit_instance;
}
function *installSnareHover($this, position, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _get_gameState__b96etq($this);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_allSnaresOnMap($this$with);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.s2w($this$with) === position) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = BeastUiMap$installSnareHover$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp);
  var snares = sortedWith(destination, tmp$ret$6);
  if (!$this.me0() && $this.k3q() === get_huntersGameTeam() && snares.n1())
    return Unit_instance;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = get_allSnaresOnMap($this$with);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = tmp0_0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (get_trapPositions($this$with, element_0).w2(new BoardPosition(position))) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = BeastUiMap$installSnareHover$lambda_0;
  var tmp$ret$11 = new sam$kotlin_Comparator$0_0(tmp_0);
  var snareTraps = sortedWith(destination_0, tmp$ret$11);
  if (snares.n1() && snareTraps.n1())
    return Unit_instance;
  var snareHover = yield* buildSnareHoverUi($this, snares, snareTraps, $completion);
  $this.xlm().plx(snareHover, OverPanelUiHoverPosition_OverMainPanelTopHover_getInstance());
  $this.gl8_1.d2(new BeastUiMap$installSnareHover$2(snareHover));
  return Unit_instance;
}
function *buildSnareHoverUi($this, snares, snareTraps, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _get_gameState__b96etq($this);
  var result = Container.fi2();
  var content = Container.fi2();
  var iconSize = get_gameLayout().sl5_1 * 1.7;
  var step = get_gameLayout().yl5_1 / 2;
  var currentY = {_v: 0.0};
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!snares.n1()) {
    var snareItem = yield* (yield* $this.pl6().ple(SnareTokenType_getInstance(), _get_gameState__b96etq($this), $completion)).m1q($completion);
    buildSnareHoverUi$addTitle(content, currentY, step, 'Snares');
    var _iterator__ex2g4s = snares.p1();
    while (_iterator__ex2g4s.q1()) {
      var snare = _iterator__ex2g4s.r1();
      buildSnareHoverUi$addRow(content, iconSize, currentY, step, splitCamelCase(get_snareType($this$with, snare).v1_1), snareItem);
    }
  }
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!snareTraps.n1()) {
    tmp = $this.be1(get_beastsGameTeam());
  } else {
    tmp = false;
  }
  if (tmp) {
    var snareTrapItem = yield* (yield* $this.pl6().vle(GeneralTokens_SnareTrap_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!snares.n1()) {
      currentY._v = currentY._v + step / 2;
    }
    buildSnareHoverUi$addTitle(content, currentY, step, 'Snare Traps');
    var _iterator__ex2g4s_0 = snareTraps.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var snare_0 = _iterator__ex2g4s_0.r1();
      buildSnareHoverUi$addRow(content, iconSize, currentY, step, splitCamelCase(get_snareType($this$with, snare_0).v1_1), snareTrapItem);
    }
  }
  var padding = get_gameLayout().yl5_1;
  var tmp2 = content.nig().f9s(Size2D.y9p(padding * 2, padding * 2));
  Companion_getInstance_11();
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var corner = get_gameLayout().sl5_1 / 4;
  var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  var tmp6 = new RGBA(get_gameColors().ylx_1);
  var tmp8 = new RGBA(Colors_getInstance().zc2_1);
  // Inline function 'korlibs.korge.view.roundRect' call
  var strokeThickness = get_gameLayout().rl5_1 / 2;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = RoundRect.rka(tmp2, tmp4, tmp6, tmp8, strokeThickness, true);
  // Inline function 'kotlin.apply' call
  addTo(this_0, result);
  addTo(content, result);
  content.fcw(Vector2D.t9g(padding, padding));
  return result;
}
function *deinstallHoveredUi($this, $completion) {
  var _iterator__ex2g4s = $this.gl8_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var mapHoveredUi = _iterator__ex2g4s.r1();
    yield* mapHoveredUi.zlx($completion);
  }
  $this.gl8_1.a5();
  return Unit_instance;
}
function hiddenPathEntryRotation($this, direction) {
  var tmp;
  if (direction.equals(Companion_getInstance_0().f3l_1)) {
    tmp = 3.141592653589793;
  } else if (direction.equals(Companion_getInstance_0().g3l_1)) {
    tmp = -3.141592653589793 / 2;
  } else if (direction.equals(Companion_getInstance_0().h3l_1)) {
    tmp = 0.0;
  } else if (direction.equals(Companion_getInstance_0().i3l_1)) {
    tmp = 3.141592653589793 / 2;
  } else {
    // Inline function 'kotlin.error' call
    var message = 'Unsupported hidden path direction ' + direction.toString();
    throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function barrierRotation($this, direction) {
  var tmp;
  if (direction.equals(Companion_getInstance_0().f3l_1)) {
    tmp = -3.141592653589793 / 2;
  } else if (direction.equals(Companion_getInstance_0().g3l_1)) {
    tmp = 0.0;
  } else if (direction.equals(Companion_getInstance_0().h3l_1)) {
    tmp = 3.141592653589793 / 2;
  } else if (direction.equals(Companion_getInstance_0().i3l_1)) {
    tmp = 3.141592653589793;
  } else {
    // Inline function 'kotlin.error' call
    var message = 'Unsupported barrier direction ' + direction.toString();
    throw IllegalStateException.o(toString(message));
  }
  return tmp;
}
function *collectUiUpdate($this, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _get_gameState__b96etq($this);
  yield* updatePaths($this, $this$with, $completion);
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  var tmp_5;
  if (equals($this$with.d4k(), PreGamePhase_getInstance())) {
    tmp_5 = true;
  } else {
    var tmp_6 = $this$with.d4k();
    tmp_5 = tmp_6 instanceof InitialPhase;
  }
  if (tmp_5) {
    tmp_4 = get_gameContentVersion($this$with.x40()).h4g();
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = $this$with.x40().c3a().z4f_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = get_aliveBeasts($this$with).s2() === 1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_1 = !$this$with.h47().a45().n1();
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = !$this.be1(get_beastsGameTeam()) || single(get_aliveBeasts($this$with)).s2w($this$with) === _BoardPosition___init__impl__1nizgq(0, 0);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = get_allBoats($this$with).n1();
  } else {
    tmp = false;
  }
  var needAlternativeBeastSetupPlaceholders = tmp;
  var alternativeBeastSetupPlaceholderBeast = singleOrNull(get_aliveBeasts($this$with));
  // Inline function 'kotlin.collections.mutableMapOf' call
  var positionToObjects = LinkedHashMap.m7();
  var tmp_7 = $this$with.f4l();
  var tmp0 = $this$with.h4k();
  var tmp$ret$4;
  $l$block_1: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single_0 = null;
    var found = false;
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$6;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp_8 = get_objectType($this$with, element);
        if (tmp_8 instanceof Draug) {
          tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
          break $l$block;
        }
        tmp$ret$6 = null;
      }
      var tmp0_safe_receiver = tmp$ret$6;
      var tmp_9;
      if (tmp0_safe_receiver == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_9 = (get_draugWillRespawn($this$with, tmp0_safe_receiver) && get_isDead($this$with, tmp0_safe_receiver));
      }
      if (tmp_9 === true) {
        if (found) {
          tmp$ret$4 = null;
          break $l$block_1;
        }
        single_0 = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$4 = null;
      break $l$block_1;
    }
    tmp$ret$4 = single_0;
  }
  var needToPaintObjects = plus(tmp_7, listOfNotNull(tmp$ret$4));
  var _iterator__ex2g4s_0 = needToPaintObjects.p1();
  $l$loop: while (_iterator__ex2g4s_0.q1()) {
    var objectOnBoard = _iterator__ex2g4s_0.r1();
    var tmp_10;
    if (needAlternativeBeastSetupPlaceholders) {
      var tmp_11 = get_objectType($this$with, objectOnBoard);
      tmp_10 = isInterface(tmp_11, BeastCharacter);
    } else {
      tmp_10 = false;
    }
    if (tmp_10) {
      $this.xl7_1.c5(objectOnBoard);
      continue $l$loop;
    }
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'steelart.beast.cast' call
      var tmp_12 = get_objectType($this$with, objectOnBoard);
      if (isInterface(tmp_12, BeastCharacter)) {
        tmp$ret$9 = objectOnBoard instanceof ObjectOnBoard ? objectOnBoard : THROW_CCE();
        break $l$block_2;
      }
      tmp$ret$9 = null;
    }
    var beast = tmp$ret$9;
    var tmp_13;
    if (!$this.be1(get_beastsGameTeam())) {
      var tmp1_elvis_lhs = beast == null ? null : get_lastSeenPosition($this$with, beast);
      var tmp_14;
      var tmp_15 = tmp1_elvis_lhs;
      if ((tmp_15 == null ? null : new BoardPosition(tmp_15)) == null) {
        tmp_14 = objectOnBoard.s2w($this$with);
      } else {
        tmp_14 = tmp1_elvis_lhs;
      }
      tmp_13 = tmp_14;
    } else {
      var tmp_16 = $this.jl7_1.w4(objectOnBoard);
      var tmp2_elvis_lhs = tmp_16 == null ? null : tmp_16.r2v_1;
      var tmp_17;
      var tmp_18 = tmp2_elvis_lhs;
      if ((tmp_18 == null ? null : new BoardPosition(tmp_18)) == null) {
        tmp_17 = objectOnBoard.s2w($this$with);
      } else {
        tmp_17 = tmp2_elvis_lhs;
      }
      tmp_13 = tmp_17;
    }
    var position = tmp_13;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = new BoardPosition(position);
    var value = positionToObjects.w4(key);
    var tmp_19;
    if (value == null) {
      // Inline function 'kotlin.collections.mutableSetOf' call
      var answer = LinkedHashSet.v2();
      positionToObjects.b5(key, answer);
      tmp_19 = answer;
    } else {
      tmp_19 = value;
    }
    tmp_19.d2(objectOnBoard);
  }
  var charactersInOrder = $this$with.h4k();
  var tmp_20 = $this$with.h47();
  var gameMapImpl = tmp_20 instanceof GameMapImpl ? tmp_20 : THROW_CCE();
  var _iterator__ex2g4s_1 = get_activeRuinPositions($this$with).p1();
  $l$loop_0: while (_iterator__ex2g4s_1.q1()) {
    var position_0 = _iterator__ex2g4s_1.r1().r2v_1;
    var tmp_21 = $this$with.u4j().w4(new BoardPosition(position_0));
    var claimedTeam = tmp_21 == null ? null : tmp_21.r3p_1;
    if ($this$with.x40().h3a().equals(GameMapId_LowerShatteredIsles_getInstance()) || $this$with.x40().h3a().equals(GameMapId_UpperShatteredIsles_getInstance())) {
      var tmp_22 = claimedTeam;
      if ((tmp_22 == null ? null : new GameTeam(tmp_22)) == null) {
        continue $l$loop_0;
      }
    }
    var tmp_23 = claimedTeam;
    var tmp_24 = to(new BoardPosition(position_0), tmp_23 == null ? null : new GameTeam(tmp_23));
    yield* $this.nl7_1.zln(tmp_24, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda($this, position_0, claimedTeam), $completion);
  }
  var _iterator__ex2g4s_2 = $this$with.y4k().p1();
  while (_iterator__ex2g4s_2.q1()) {
    var position_1 = _iterator__ex2g4s_2.r1().r2v_1;
    yield* $this.pl7_1.zln(new BoardPosition(position_1), VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_0($this, position_1), $completion);
  }
  var _iterator__ex2g4s_3 = get_hazePositions($this$with).p1();
  while (_iterator__ex2g4s_3.q1()) {
    var position_2 = _iterator__ex2g4s_3.r1().r2v_1;
    yield* $this.rl7_1.zln(new BoardPosition(position_2), VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_1($this, position_2), $completion);
  }
  if ($this.be1(get_beastsGameTeam())) {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_0 = get_allSnaresOnMap($this$with);
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s_4 = tmp0_0.p1();
    while (_iterator__ex2g4s_4.q1()) {
      var element_0 = _iterator__ex2g4s_4.r1();
      var list = get_trapPositions($this$with, element_0);
      addAll(destination, list);
    }
    var _iterator__ex2g4s_5 = distinct(destination).p1();
    while (_iterator__ex2g4s_5.q1()) {
      var position_3 = _iterator__ex2g4s_5.r1().r2v_1;
      yield* $this.ql7_1.zln(new BoardPosition(position_3), VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_2($this, position_3), $completion);
    }
  }
  var _iterator__ex2g4s_6 = gameMapImpl.b45().p1();
  $l$loop_1: while (_iterator__ex2g4s_6.q1()) {
    var position_4 = _iterator__ex2g4s_6.r1().r2v_1;
    var tmp3_elvis_lhs = positionToObjects.w4(new BoardPosition(position_4));
    var objects = tmp3_elvis_lhs == null ? emptySet() : tmp3_elvis_lhs;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_7 = charactersInOrder.p1();
    while (_iterator__ex2g4s_7.q1()) {
      var element_1 = _iterator__ex2g4s_7.r1();
      if (objects.w2(element_1)) {
        destination_0.d2(element_1);
      }
    }
    var tmp_25 = destination_0;
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_1 = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_8 = objects.p1();
    while (_iterator__ex2g4s_8.q1()) {
      var element_2 = _iterator__ex2g4s_8.r1();
      var tmp$ret$25;
      $l$block_3: {
        // Inline function 'steelart.beast.cast' call
        var tmp_26 = get_objectType($this$with, element_2);
        if (isInterface(tmp_26, SummonType)) {
          tmp$ret$25 = element_2 instanceof ObjectOnBoard ? element_2 : THROW_CCE();
          break $l$block_3;
        }
        tmp$ret$25 = null;
      }
      var tmp0_safe_receiver_0 = tmp$ret$25;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_1.d2(tmp0_safe_receiver_0);
      }
    }
    var primaryObjectsInLocation = plus(tmp_25, destination_1);
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = minus(objects, primaryObjectsInLocation);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList.p2();
    var _iterator__ex2g4s_9 = tmp0_1.p1();
    while (_iterator__ex2g4s_9.q1()) {
      var element_3 = _iterator__ex2g4s_9.r1();
      var tmp_27;
      var tmp_28;
      var tmp_29 = get_objectType($this$with, element_3);
      if (!(tmp_29 instanceof WatchtowerType)) {
        var tmp_30 = get_objectType($this$with, element_3);
        tmp_28 = !(tmp_30 instanceof BoatType);
      } else {
        tmp_28 = false;
      }
      if (tmp_28) {
        var tmp_31 = get_objectType($this$with, element_3);
        tmp_27 = !(tmp_31 instanceof BarrierSideType);
      } else {
        tmp_27 = false;
      }
      if (tmp_27) {
        destination_2.d2(element_3);
      }
    }
    var objectsBelow = destination_2;
    var tmp4_safe_receiver = gameMapImpl.p44_1.w4(new BoardPosition(position_4));
    var isOriginallyTownLocation = equals(tmp4_safe_receiver == null ? null : tmp4_safe_receiver.k45_1, LocationType_Settlement_getInstance());
    var init = gameMapImpl.p44_1.w4(new BoardPosition(position_4));
    var locationType = get_locationType($this$with, position_4);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.n2(collectionSizeOrDefault(objects, 10));
    var _iterator__ex2g4s_10 = objects.p1();
    while (_iterator__ex2g4s_10.q1()) {
      var item = _iterator__ex2g4s_10.r1();
      var tmp$ret$33 = get_objectType($this$with, item);
      destination_3.d2(tmp$ret$33);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_4 = ArrayList.p2();
    var _iterator__ex2g4s_11 = destination_3.p1();
    while (_iterator__ex2g4s_11.q1()) {
      var element_4 = _iterator__ex2g4s_11.r1();
      if (!(element_4 == null) ? isInterface(element_4, AnimalType) : false) {
        destination_4.d2(element_4);
      }
    }
    var animals = toSet(destination_4);
    var needPaintSimpleObjectField = isOriginallyTownLocation || objectsBelow.s2() > 1 || get_isCompoundLocationForPainting(locationType);
    var tmp_32;
    if (locationType.q45()) {
      var tmp_33;
      if (!locationType.equals(init == null ? null : init.k45_1)) {
        tmp_33 = true;
      } else {
        tmp_33 = (!needPaintSimpleObjectField && !equals(animals, toSet(init.l45_1)));
      }
      tmp_32 = tmp_33;
    } else {
      tmp_32 = false;
    }
    var needPaintLocationType = tmp_32;
    var tmp6_elvis_lhs = $this.fl7_1.jl8(position_4);
    var tmp_34;
    if (tmp6_elvis_lhs == null) {
      continue $l$loop_1;
    } else {
      tmp_34 = tmp6_elvis_lhs;
    }
    var area = tmp_34;
    var animalRectangleWidth = $this.fl7_1.nll().alo_1 * 2;
    if (needPaintLocationType) {
      var tmp_35 = to(new BoardPosition(position_4), locationType);
      yield* $this.ll7_1.zln(tmp_35, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_3($this, locationType, area), $completion);
    }
    if (needPaintSimpleObjectField) {
      yield* $this.sl7_1.zln(new BoardPosition(position_4), VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_4(animalRectangleWidth, $this, isOriginallyTownLocation, area), $completion);
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_5 = LinkedHashMap.m7();
    var _iterator__ex2g4s_12 = objects.p1();
    while (_iterator__ex2g4s_12.q1()) {
      var element_5 = _iterator__ex2g4s_12.r1();
      var key_0 = get_objectType($this$with, element_5);
      // Inline function 'kotlin.collections.getOrPut' call
      var value_0 = destination_5.w4(key_0);
      var tmp_36;
      if (value_0 == null) {
        var answer_0 = ArrayList.p2();
        destination_5.b5(key_0, answer_0);
        tmp_36 = answer_0;
      } else {
        tmp_36 = value_0;
      }
      var list_0 = tmp_36;
      list_0.d2(element_5);
    }
    var byObjectType = destination_5;
    var tmp7_safe_receiver = byObjectType.w4(WatchtowerType_getInstance());
    var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.s2();
    var watchtowerNumber = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
    if (watchtowerNumber > 0) {
      var tmp_37 = to(new BoardPosition(position_4), watchtowerNumber);
      yield* $this.ul7_1.zln(tmp_37, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_5($this, area), $completion);
    }
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key_1 = BoatType_getInstance();
    if ((isInterface(byObjectType, KtMap) ? byObjectType : THROW_CCE()).u4(key_1)) {
      yield* $this.tl7_1.zln(new BoardPosition(position_4), VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_6($this, area), $completion);
    }
    if (needAlternativeBeastSetupPlaceholders && $this$with.h47().a45().w2(new BoardPosition(position_4))) {
      var tmp_38;
      if (alternativeBeastSetupPlaceholderBeast == null) {
        // Inline function 'kotlin.error' call
        var message = 'Alternative Beast setup placeholder requires a Beast';
        throw IllegalStateException.o(toString(message));
      } else {
        tmp_38 = alternativeBeastSetupPlaceholderBeast;
      }
      var placeholderBeast = tmp_38;
      var tmp_39 = new AlternativeBeastSetupPlaceholder(position_4, placeholderBeast);
      yield* $this.vl7_1.zln(tmp_39, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_7($this, $this$with, placeholderBeast, area), $completion);
    }
    var iterator = primaryObjectsInLocation.p1();
    var index = 0;
    while (iterator.q1()) {
      var i = index;
      index = index + 1 | 0;
      var characterObject = iterator.r1();
      var locationSideSize = $this.fl7_1.nll().alo_1;
      var tmp_40;
      if (get_objectType($this$with, characterObject) instanceof EggType) {
        tmp_40 = locationSideSize * 0.5;
      } else {
        tmp_40 = locationSideSize * 0.75;
      }
      var standeeHeight = tmp_40;
      var objectX = primaryObjectsInLocation.s2() === 1 ? 0 : -area.nl8_1 + i * (2 * area.nl8_1 / (primaryObjectsInLocation.s2() - 1 | 0));
      var tmp0_2 = area.ml8_1;
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_12();
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var that = Vector2D.t9g(numberToDouble(objectX), numberToDouble(0));
      var where = Vector2D.t9g(tmp0_2.r9g_1 + that.r9g_1, tmp0_2.s9g_1 + that.s9g_1);
      var bitmap = yield* (yield* $this.pl6().ole($this$with, characterObject, $completion)).m1q($completion);
      var tmp$ret$46;
      $l$block_4: {
        // Inline function 'steelart.beast.cast' call
        var tmp_41 = get_objectType($this$with, characterObject);
        if (tmp_41 instanceof FeatheredKing) {
          tmp$ret$46 = characterObject instanceof ObjectOnBoard ? characterObject : THROW_CCE();
          break $l$block_4;
        }
        tmp$ret$46 = null;
      }
      var tmp11_safe_receiver = tmp$ret$46;
      var isRebornFeatheredKing = (tmp11_safe_receiver == null ? null : get_isReborn($this$with, tmp11_safe_receiver)) === true;
      var tmp$ret$47;
      $l$block_5: {
        // Inline function 'steelart.beast.cast' call
        var tmp_42 = get_objectType($this$with, characterObject);
        if (tmp_42 instanceof Draug) {
          tmp$ret$47 = characterObject instanceof ObjectOnBoard ? characterObject : THROW_CCE();
          break $l$block_5;
        }
        tmp$ret$47 = null;
      }
      var tmp12_safe_receiver = tmp$ret$47;
      var isWouldBeRespawnDraug = (tmp12_safe_receiver == null ? null : get_draugWillRespawn($this$with, tmp12_safe_receiver)) === true;
      var isAlternativeView = isRebornFeatheredKing || isWouldBeRespawnDraug;
      var key_2 = GroupedObjectsInfo_0($this$with, characterObject, isAlternativeView);
      // Inline function 'kotlin.collections.set' call
      $this.xl7_1.b5(characterObject, key_2);
      var primaryObjectView = yield* $this.wl7_1.zln(key_2, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_8($this, bitmap, standeeHeight, isWouldBeRespawnDraug, $this$with, characterObject), $completion);
      $this.wl7_1.aly(key_2, Vector2D.t9g(where.r9g_1 - primaryObjectView.pig() / 2, where.s9g_1 - primaryObjectView.rig() / 2));
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_6 = LinkedHashMap.m7();
    var _iterator__ex2g4s_13 = objectsBelow.p1();
    while (_iterator__ex2g4s_13.q1()) {
      var element_6 = _iterator__ex2g4s_13.r1();
      var key_3 = get_objectType($this$with, element_6);
      // Inline function 'kotlin.collections.getOrPut' call
      var value_1 = destination_6.w4(key_3);
      var tmp_43;
      if (value_1 == null) {
        var answer_1 = ArrayList.p2();
        destination_6.b5(key_3, answer_1);
        tmp_43 = answer_1;
      } else {
        tmp_43 = value_1;
      }
      var list_1 = tmp_43;
      list_1.d2(element_6);
    }
    var belowByType = destination_6;
    // Inline function 'kotlin.collections.mutableListOf' call
    var simpleTypeElements = ArrayList.p2();
    var shouldBeHeight = $this.fl7_1.nll().alo_1 * (!isOriginallyTownLocation && belowByType.s2() === 1 ? 0.75 : isOriginallyTownLocation ? 0.7 : 0.6);
    var limitSimpleObjects = 4;
    var tmp_44;
    if (objectsBelow.s2() <= limitSimpleObjects) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_7 = ArrayList.n2(collectionSizeOrDefault(objectsBelow, 10));
      var _iterator__ex2g4s_14 = objectsBelow.p1();
      while (_iterator__ex2g4s_14.q1()) {
        var item_0 = _iterator__ex2g4s_14.r1();
        var tmp$ret$57 = to(get_objectType($this$with, item_0), listOf_0(item_0));
        destination_7.d2(tmp$ret$57);
      }
      tmp_44 = destination_7;
    } else {
      tmp_44 = toList(belowByType);
    }
    var adjustedBelowByType = tmp_44;
    var _iterator__ex2g4s_15 = adjustedBelowByType.p1();
    while (_iterator__ex2g4s_15.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_15.r1();
      var type = _destruct__k2r9zo.jm();
      var elements = _destruct__k2r9zo.km();
      if (!isInterface(type, SimpleObjectType)) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Unexpected object type: ' + toString(type);
        throw IllegalStateException.o(toString(message_0));
      }
      // Inline function 'kotlin.collections.maxOf' call
      var iterator_0 = elements.p1();
      if (!iterator_0.q1())
        throw NoSuchElementException.w7();
      var it = iterator_0.r1();
      var maxValue = get_wounds($this$with, it);
      while (iterator_0.q1()) {
        var it_0 = iterator_0.r1();
        var v = get_wounds($this$with, it_0);
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      var maxWounds = maxValue;
      // Inline function 'kotlin.collections.minOf' call
      var iterator_1 = elements.p1();
      if (!iterator_1.q1())
        throw NoSuchElementException.w7();
      var it_1 = iterator_1.r1();
      var minValue = get_armor($this$with, it_1);
      while (iterator_1.q1()) {
        var it_2 = iterator_1.r1();
        var v_0 = get_armor($this$with, it_2);
        if (compareTo(minValue, v_0) > 0) {
          minValue = v_0;
        }
      }
      var minArmor = minValue;
      var bitmap_0 = yield* (yield* $this.pl6().qle(type, VOID, $completion)).m1q($completion);
      var key_4 = new GroupedObjectsInfo(get_objectType($this$with, first(elements)), toSet(elements), maxWounds, minArmor);
      var _iterator__ex2g4s_16 = elements.p1();
      while (_iterator__ex2g4s_16.q1()) {
        var element_7 = _iterator__ex2g4s_16.r1();
        // Inline function 'kotlin.collections.set' call
        $this.xl7_1.b5(element_7, key_4);
      }
      var sameTypeContainer = yield* $this.wl7_1.zln(key_4, null, shouldBeHeight, VOID, BeastUiMap$collectUiUpdate$slambda_9(bitmap_0, elements, type, $this, minArmor, maxWounds), $completion);
      simpleTypeElements.d2(to(key_4, sameTypeContainer));
    }
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_17 = simpleTypeElements.p1();
    while (_iterator__ex2g4s_17.q1()) {
      var element_8 = _iterator__ex2g4s_17.r1();
      var tmp_45 = sum;
      sum = tmp_45 + element_8.qm_1.pig();
    }
    var simpleTypeElementsWidth = sum;
    if (simpleTypeElementsWidth > animalRectangleWidth) {
      $this.sln('Adjust simpleTypeElementsWidth to fit size');
    }
    var tmp0_3 = area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_0 = Vector2D.e9t(0, area.nl8_1);
    var tmp0_4 = Vector2D.t9g(tmp0_3.r9g_1 + that_0.r9g_1, tmp0_3.s9g_1 + that_0.s9g_1);
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var this_0 = Vector2D.t9g(simpleTypeElementsWidth, shouldBeHeight);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that_1 = Vector2D.t9g(this_0.r9g_1 / 2.0, this_0.s9g_1 / 2.0);
    var neededPosition = Vector2D.t9g(tmp0_4.r9g_1 - that_1.r9g_1, tmp0_4.s9g_1 - that_1.s9g_1);
    var _iterator__ex2g4s_18 = simpleTypeElements.p1();
    while (_iterator__ex2g4s_18.q1()) {
      var _destruct__k2r9zo_0 = _iterator__ex2g4s_18.r1();
      var key_5 = _destruct__k2r9zo_0.jm();
      var view = _destruct__k2r9zo_0.km();
      $this.wl7_1.aly(key_5, neededPosition);
      var tmp0_5 = neededPosition;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var that_2 = Vector2D.d9t(view.pig(), 0);
      neededPosition = Vector2D.t9g(tmp0_5.r9g_1 + that_2.r9g_1, tmp0_5.s9g_1 + that_2.s9g_1);
    }
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0_6 = get_aliveBeasts($this$with);
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_8 = ArrayList.p2();
  var _iterator__ex2g4s_19 = tmp0_6.p1();
  while (_iterator__ex2g4s_19.q1()) {
    var element_9 = _iterator__ex2g4s_19.r1();
    var tmp_46;
    if ($this.be1(get_beastsGameTeam())) {
      var trailCounts = toMutableMap(get_possibleTrailMaxCounts($this$with, element_9));
      var tmp2 = new BoardPosition(get_lastSeenPosition($this$with, element_9));
      // Inline function 'kotlin.collections.getOrElse' call
      var key_6 = new BoardPosition(get_lastSeenPosition($this$with, element_9));
      var tmp0_elvis_lhs = trailCounts.w4(key_6);
      var tmp_47;
      if (tmp0_elvis_lhs == null) {
        tmp_47 = 0;
      } else {
        tmp_47 = tmp0_elvis_lhs;
      }
      // Inline function 'kotlin.collections.set' call
      var value_2 = tmp_47 + 1 | 0;
      trailCounts.b5(tmp2, value_2);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_9 = ArrayList.p2();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_20 = trailCounts.i3().p1();
      while (_iterator__ex2g4s_20.q1()) {
        var element_10 = _iterator__ex2g4s_20.r1();
        var tmp$ret$83;
        $l$block_6: {
          // Inline function 'kotlin.collections.component1' call
          var position_5 = element_10.j3().r2v_1;
          // Inline function 'kotlin.collections.component2' call
          var count = element_10.k3();
          if (position_5 === element_9.s2w($this$with)) {
            tmp$ret$83 = null;
            break $l$block_6;
          }
          var tmp0_elvis_lhs_0 = get_foundTrails($this$with, element_9).w4(new BoardPosition(position_5));
          var foundTrails = tmp0_elvis_lhs_0 == null ? 0 : tmp0_elvis_lhs_0;
          tmp$ret$83 = new TrailRenderInfo(element_9, position_5, count - foundTrails | 0, foundTrails);
        }
        var tmp0_safe_receiver_1 = tmp$ret$83;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_9.d2(tmp0_safe_receiver_1);
        }
      }
      tmp_46 = destination_9;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_1 = get_foundTrails($this$with, element_9);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_10 = ArrayList.n2(this_1.s2());
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_21 = this_1.i3().p1();
      while (_iterator__ex2g4s_21.q1()) {
        var item_1 = _iterator__ex2g4s_21.r1();
        // Inline function 'kotlin.collections.component1' call
        var position_6 = item_1.j3().r2v_1;
        // Inline function 'kotlin.collections.component2' call
        var foundTrails_0 = item_1.k3();
        var tmp$ret$91 = new TrailRenderInfo(element_9, position_6, 0, foundTrails_0);
        destination_10.d2(tmp$ret$91);
      }
      tmp_46 = destination_10;
    }
    var list_2 = tmp_46;
    addAll(destination_8, list_2);
  }
  var trailsToRender = destination_8;
  // Inline function 'kotlin.collections.groupingBy' call
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.aggregate' call
  var tmp0_7 = new BeastUiMap$collectUiUpdate$$inlined$with$12(trailsToRender);
  // Inline function 'kotlin.collections.mutableMapOf' call
  // Inline function 'kotlin.collections.aggregateTo' call
  var destination_11 = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_22 = tmp0_7.n7();
  while (_iterator__ex2g4s_22.q1()) {
    var e = _iterator__ex2g4s_22.r1();
    var key_7 = tmp0_7.o7(e);
    var accumulator = destination_11.w4(key_7);
    // Inline function 'kotlin.collections.set' call
    var value_3 = ((accumulator == null && !destination_11.u4(key_7) ? 0 : accumulator) + e.dly_1 | 0) + e.ely_1 | 0;
    destination_11.b5(key_7, value_3);
  }
  var totalTrailsByPosition = destination_11;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var renderedTrailsByPosition = LinkedHashMap.m7();
  var _iterator__ex2g4s_23 = trailsToRender.p1();
  while (_iterator__ex2g4s_23.q1()) {
    var _destruct__k2r9zo_1 = _iterator__ex2g4s_23.r1();
    var beast_0 = _destruct__k2r9zo_1.jm();
    var position_7 = _destruct__k2r9zo_1.fly();
    var hiddenTrails = _destruct__k2r9zo_1.fx();
    var foundTrails_1 = _destruct__k2r9zo_1.gly();
    var trailPicture = yield* (yield* $this.pl6().nle(get_objectType($this$with, beast_0), $completion)).m1q($completion);
    var area_0 = ensureNotNull($this.fl7_1.jl8(position_7));
    var needBigTrail = position_7 === get_lastSeenPosition($this$with, beast_0) && $this.be1(get_beastsGameTeam());
    // Inline function 'kotlin.collections.getOrElse' call
    var key_8 = new BoardPosition(position_7);
    var tmp0_elvis_lhs_1 = renderedTrailsByPosition.w4(key_8);
    var tmp_48;
    if (tmp0_elvis_lhs_1 == null) {
      tmp_48 = 0;
    } else {
      tmp_48 = tmp0_elvis_lhs_1;
    }
    var trailOffset = tmp_48;
    var totalTrails = getValue(totalTrailsByPosition, new BoardPosition(position_7));
    var trailKey = new TrailInfoKey(get_objectType($this$with, beast_0), position_7, hiddenTrails, foundTrails_1, needBigTrail, trailOffset, totalTrails);
    yield* $this.yl7_1.zln(trailKey, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_10($this, trailPicture, area_0, hiddenTrails, foundTrails_1, needBigTrail, trailOffset, totalTrails), $completion);
    var tmp2_0 = new BoardPosition(position_7);
    // Inline function 'kotlin.collections.set' call
    var value_4 = (trailOffset + hiddenTrails | 0) + foundTrails_1 | 0;
    renderedTrailsByPosition.b5(tmp2_0, value_4);
  }
  if (false) {
    yield* updateMovementCards($this, $this$with, charactersInOrder, $completion);
  }
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_24 = $this$with.w4k().i3().p1();
  $l$loop_2: while (_iterator__ex2g4s_24.q1()) {
    var _destruct__k2r9zo_2 = _iterator__ex2g4s_24.r1();
    // Inline function 'kotlin.collections.component1' call
    var zone = _destruct__k2r9zo_2.j3();
    // Inline function 'kotlin.collections.component2' call
    var traps = _destruct__k2r9zo_2.k3();
    var trapsCount = traps.s2();
    if (trapsCount === 0 && !$this.se3()) {
      continue $l$loop_2;
    }
    var info = new PlacedTrapsZoneInfo(zone, trapsCount);
    yield* $this.al8_1.zln(info, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda_11($this$with, traps, trapsCount, $this, zone), $completion);
  }
  return Unit_instance;
}
function *updatePaths($this, $receiver, $completion) {
  if ($receiver.h47().y44().equals(GameMapId_DrenchedLands_getInstance()) || ($receiver.h47().y44().equals(GameMapId_NorthernExpanse_getInstance()) && get_gameContentVersion($receiver.x40()).h4g())) {
    var tmp = $receiver.h47();
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = (tmp instanceof GameMapImpl ? tmp : THROW_CCE()).t44_1.i3();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!($this.fl7_1.jl8(element.j3().d45_1) == null)) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap.m7();
    var _iterator__ex2g4s_0 = destination.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var key = setOf_0([new BoardPosition(element_0.j3().d45_1), new BoardPosition(element_0.k3().d45_1)]);
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_0.w4(key);
      var tmp_0;
      if (value == null) {
        var answer = ArrayList.p2();
        destination_0.b5(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.d2(element_0);
    }
    var hiddenPathEntries = destination_0.y4();
    var iterator = hiddenPathEntries.p1();
    var index = 0;
    while (iterator.q1()) {
      var pathNumber = index;
      index = index + 1 | 0;
      var hiddenPathPairEntries = iterator.r1();
      var _iterator__ex2g4s_1 = hiddenPathPairEntries.p1();
      $l$loop: while (_iterator__ex2g4s_1.q1()) {
        var hiddenPathEntry = _iterator__ex2g4s_1.r1();
        var position = hiddenPathEntry.j3().d45_1;
        var tmp0_elvis_lhs = $this.fl7_1.jl8(position);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var area = tmp_1;
        var direction = hiddenPathEntry.j3().e45_1;
        yield* $this.ml7_1.zln(new BoardPosition(position), VOID, VOID, VOID, BeastUiMap$updatePaths$slambda($this, pathNumber, area, direction), $completion);
      }
    }
  }
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = $receiver.f4l();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = tmp0_0.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var element_1 = _iterator__ex2g4s_2.r1();
    var tmp$ret$14;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp_2 = get_objectType($receiver, element_1);
      if (tmp_2 instanceof BarrierSideType) {
        tmp$ret$14 = element_1 instanceof ObjectOnBoard ? element_1 : THROW_CCE();
        break $l$block;
      }
      tmp$ret$14 = null;
    }
    var tmp0_safe_receiver = tmp$ret$14;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.d2(tmp0_safe_receiver);
    }
  }
  var _iterator__ex2g4s_3 = destination_1.p1();
  $l$loop_0: while (_iterator__ex2g4s_3.q1()) {
    var barrier = _iterator__ex2g4s_3.r1();
    var position_0 = barrier.s2w($receiver);
    var tmp1_elvis_lhs = $this.fl7_1.jl8(position_0);
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var area_0 = tmp_3;
    var direction_0 = get_objectType($receiver, barrier).q4f_1;
    var tmp_4 = to(new BoardPosition(position_0), direction_0);
    yield* $this.ol7_1.zln(tmp_4, VOID, VOID, VOID, BeastUiMap$updatePaths$slambda_0($this, area_0, direction_0), $completion);
  }
  return Unit_instance;
}
function *updateMovementCards($this, $context_GameState_t6qee5, charactersInOrder, $completion) {
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = charactersInOrder.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($context_GameState_t6qee5, element);
      if (isInterface(tmp, BeastCharacter)) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var iterator = destination.p1();
  var index = 0;
  while (iterator.q1()) {
    var index_0 = index;
    index = index + 1 | 0;
    var beast = iterator.r1();
    var tmp_0 = $this.xlm();
    yield* addMovementCardElement(tmp_0, beast, $this.zl7_1, VOID, BeastUiMap$updateMovementCards$lambda($this, index_0), $completion);
  }
  return Unit_instance;
}
function trailPictures($this, trailPicture, area, hiddenTrails, revealedTrails, needBigTrail, trailOffset, totalTrails) {
  needBigTrail = needBigTrail === VOID ? false : needBigTrail;
  trailOffset = trailOffset === VOID ? 0 : trailOffset;
  totalTrails = totalTrails === VOID ? hiddenTrails + revealedTrails | 0 : totalTrails;
  var width = area.nl8_1 * 2 / 3;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p2();
  var allTrails = hiddenTrails + revealedTrails | 0;
  var inductionVariable = 0;
  if (inductionVariable < allTrails)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var isBigTrail = needBigTrail && i === 0;
      // Inline function 'kotlin.apply' call
      var this_1 = Image.lk7(trailPicture);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      var tmp0 = area.ml8_1;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var that = Vector2D.t9g((0.5 + trailOffset + i - totalTrails / 2.0) * width, -area.nl8_1);
      var tmp$ret$7 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
      position_0(this_1, tmp$ret$7);
      if (isBigTrail) {
        toWidth(this_1, width * 2);
      } else {
        toWidth(this_1, width);
      }
      if (i < hiddenTrails && !isBigTrail) {
        this_1.sig(0.7);
      }
      this_0.d2(this_1);
    }
     while (inductionVariable < allTrails);
  return this_0.g9();
}
function addCustomHighlightingAreaIfNeeded($this) {
  if (!$this.cl8_1.xi1_1.n1())
    return Unit_instance;
  var inductionVariable = -4;
  if (inductionVariable <= 4)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = -5;
      if (inductionVariable_0 <= 5)
        $l$loop: do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var position = _BoardPosition___init__impl__1nizgq(x, y);
          var tmp = $this.fl7_1.h47();
          var tmp0_safe_receiver = (tmp instanceof GameMapImpl ? tmp : THROW_CCE()).p44_1.w4(new BoardPosition(position));
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k45_1) == null)
            continue $l$loop;
          var tmp2_safe_receiver = $this.fl7_1.jl8(position);
          if (tmp2_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.apply' call
            var this_0 = BeastUiMap$addCustomHighlightingAreaIfNeeded$1.im1();
            this_0.yjp(tmp2_safe_receiver.nl8_1);
            this_0.cjq(new RGBA(Colors_getInstance().pc8_1));
            // Inline function 'korlibs.korge.view.anchor' call
            anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
            position_0(this_0, tmp2_safe_receiver.ml8_1);
            addTo(this_0, $this.cl8_1);
            var tmp_0 = this_0;
            addClickOption(tmp_0, BeastUiMap$addCustomHighlightingAreaIfNeeded$slambda(position));
          }
        }
         while (inductionVariable_0 <= 5);
    }
     while (inductionVariable <= 4);
}
function addCoordinatesOnMap($this) {
  var inductionVariable = -4;
  if (inductionVariable <= 4)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = -5;
      if (inductionVariable_0 <= 5)
        $l$loop: do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var position = _BoardPosition___init__impl__1nizgq(x, y);
          var tmp0_elvis_lhs = $this.fl7_1.jl8(position);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var locationArea = tmp;
          var t = Text.aj6('(' + x + ',' + y + ')', $this.fl7_1.nll().alo_1 / 2 | 0, Colors_getInstance().zc2_1);
          var tmp0 = locationArea.ml8_1;
          // Inline function 'korlibs.math.geom.Vector2D.minus' call
          var that = toPoint(t.s2().l9s(2));
          var tmp0_0 = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
          // Inline function 'korlibs.math.geom.Vector2D.minus' call
          var that_0 = Vector2D.a9k(0, $this.fl7_1.nll().alo_1 / 2 | 0);
          var p = Vector2D.t9g(tmp0_0.r9g_1 - that_0.r9g_1, tmp0_0.s9g_1 - that_0.s9g_1);
          t.fcw(p);
          var tmp0_1 = $this.hl7_1;
          var tmp2 = t.s2();
          // Inline function 'korlibs.korge.view.solidRect' call
          var color = Colors_getInstance().ac3_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_0 = SolidRect.mkf(tmp2, color);
          // Inline function 'kotlin.apply' call
          addTo(this_0, tmp0_1).fcw(p);
          $this.hl7_1.uie(t);
        }
         while (inductionVariable_0 <= 5);
    }
     while (inductionVariable <= 4);
}
function BeastUiMap$positionAndScaleAdjuster$slambda() {
  return constructCallableReference(function *(_unused_var__etf5q3, _unused_var__etf5q3_0, $completion) {
    return Unit_instance;
  }, 2);
}
function BeastUiMap$installRuinHover$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function BeastUiMap$installRuinHover$slambda_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function BeastUiMap$installSnareHover$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = _EntityId___get_id__impl__v6colh(a.r2w_1);
  var tmp$ret$2 = _EntityId___get_id__impl__v6colh(b.r2w_1);
  return compareValues(tmp, tmp$ret$2);
}
function BeastUiMap$installSnareHover$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = _EntityId___get_id__impl__v6colh(a.r2w_1);
  var tmp$ret$2 = _EntityId___get_id__impl__v6colh(b.r2w_1);
  return compareValues(tmp, tmp$ret$2);
}
function buildSnareHoverUi$addTitle(content, currentY, step, text) {
  // Inline function 'kotlin.also' call
  var this_0 = addTo(BorderedText(text, get_gameLayout().sl5_1), content);
  this_0.sif(currentY._v);
  currentY._v = currentY._v + (this_0.x9z() + step / 2);
}
function buildSnareHoverUi$addRow(content, iconSize, currentY, step, text, itemImage) {
  var row = addTo(Container.fi2(), content);
  addTo(toHeight(Image.lk7(itemImage), iconSize), row);
  // Inline function 'kotlin.also' call
  var this_0 = addTo(PlainText(text, get_gameLayout().sl5_1), row);
  this_0.rif(iconSize + step);
  // Inline function 'kotlin.math.max' call
  var b = (iconSize - this_0.x9z()) / 2;
  var tmp$ret$2 = Math.max(0.0, b);
  this_0.sif(tmp$ret$2);
  row.sif(currentY._v);
  var tmp = currentY._v;
  // Inline function 'kotlin.math.max' call
  var b_0 = row.x9z();
  currentY._v = tmp + (Math.max(iconSize, b_0) + step);
}
function BeastUiMap$addMouseHoverOptions$slambda(this$0) {
  return constructCallableReference(function *(mouseEvent, $completion) {
    var pos = mouseEvent.uhy();
    var area = findLocationAreaForLocalPoint(this$0, pos);
    var tmp;
    if (!(area == null)) {
      var position = area.kl8_1;
      var tmp_0 = this$0.fl8_1;
      if (equals(tmp_0 == null ? null : new BoardPosition(tmp_0), new BoardPosition(position)))
        return Unit_instance;
      this$0.fl8_1 = position;
      tmp = yield* /*#__NOINLINE__*/installHoveredUi(this$0, area, $completion);
    } else {
      this$0.fl8_1 = null;
      tmp = yield* /*#__NOINLINE__*/deinstallHoveredUi(this$0, $completion);
    }
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_move_$ref_mt1fcf() {
  return constructCallableReference((p0) => p0.ghx_1, 1, 0, 553);
}
function BeastUiMap$addMouseHoverOptions$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function BeastUiMap$addMouseHoverOptions$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, BeastUiMap$addMouseHoverOptions$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function BeastUiMap$addMouseHoverOptions$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.fl8_1 = null;
    yield* /*#__NOINLINE__*/deinstallHoveredUi(this$0, $completion);
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_moveOutside_$ref_f8k8ca() {
  return constructCallableReference((p0) => p0.ihx_1, 1, 0, 554);
}
function BeastUiMap$addMouseHoverOptions$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function BeastUiMap$addMouseHoverOptions$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, BeastUiMap$addMouseHoverOptions$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function BeastUiMap$addMouseHoverOptions$slambda_1(this$0) {
  return constructCallableReference(function *(it, $completion) {
    var _iterator__ex2g4s = toList_0(this$0.gl8_1).p1();
    while (_iterator__ex2g4s.q1()) {
      var mapHoveredUi = _iterator__ex2g4s.r1();
      yield* mapHoveredUi.om1($completion);
    }
    return Unit_instance;
  }, 1);
}
function BeastUiMap$addMouseHoverOptions$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function BeastUiMap$addMouseHoverOptions$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, BeastUiMap$addMouseHoverOptions$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function BeastUiMap$getViewForObjectOnBoard$lambda($w, $$this$with) {
  return (it) => equals(new BoardPosition($w.s2w($$this$with)), it.pm_1);
}
function BeastUiMap$collectUiUpdate$slambda(this$0, $position, $claimedTeam) {
  return constructCallableReference(function *($completion) {
    var area = ensureNotNull(this$0.fl7_1.jl8($position));
    var tmp0_subject = $claimedTeam;
    var tmp;
    var tmp_0 = tmp0_subject;
    if ((tmp_0 == null ? null : new GameTeam(tmp_0)) == null) {
      tmp = GeneralTokens_RuinNeutral_getInstance();
    } else {
      var tmp_1 = tmp0_subject;
      if (equals(tmp_1 == null ? null : new GameTeam(tmp_1), new GameTeam(get_beastsGameTeam()))) {
        tmp = GeneralTokens_RuinBeast_getInstance();
      } else {
        var tmp_2 = tmp0_subject;
        if (equals(tmp_2 == null ? null : new GameTeam(tmp_2), new GameTeam(get_huntersGameTeam()))) {
          tmp = GeneralTokens_RuinHunter_getInstance();
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Unsupported game team ' + GameTeam__toString_impl_wfw0a6($claimedTeam);
          throw IllegalStateException.o(toString(message));
        }
      }
    }
    var token = tmp;
    var ruinBitmap = yield* (yield* this$0.pl6().vle(token, $completion)).m1q($completion);
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(ruinBitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var tmp0 = area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(area.nl8_1 * 0.84, -area.nl8_1 * 0.5);
    var tmp$ret$4 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$4);
    toHeight(this_0, area.nl8_1 * 2);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_0(this$0, $position) {
  return constructCallableReference(function *($completion) {
    var area = ensureNotNull(this$0.fl7_1.jl8($position));
    var fireBitmap = yield* (yield* this$0.pl6().vle(GeneralTokens_Fire_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(fireBitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var tmp0 = area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(-area.nl8_1 * 0.84, -area.nl8_1 * 0.5);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$3);
    toHeight(this_0, area.nl8_1 * 2);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_1(this$0, $position) {
  return constructCallableReference(function *($completion) {
    var area = ensureNotNull(this$0.fl7_1.jl8($position));
    var snareTrapBitmap = yield* (yield* this$0.pl6().vle(GeneralTokens_Haze_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(snareTrapBitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var tmp0 = area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(area.nl8_1 * 0.84, -area.nl8_1 * 0.5);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$3);
    toHeight(this_0, area.nl8_1 * 1.5);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_2(this$0, $position) {
  return constructCallableReference(function *($completion) {
    var area = ensureNotNull(this$0.fl7_1.jl8($position));
    var snareTrapBitmap = yield* (yield* this$0.pl6().vle(GeneralTokens_SnareTrap_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(snareTrapBitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var tmp0 = area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(-area.nl8_1 * 0.84, -area.nl8_1 * 0.5);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$3);
    toHeight(this_0, area.nl8_1 * 1.5);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_3(this$0, $locationType, $area) {
  return constructCallableReference(function *($completion) {
    var locationBitmap = yield* (yield* this$0.pl6().hle($locationType, $completion)).m1q($completion);
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(locationBitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    this_0.fcw($area.ml8_1);
    toHeight(this_0, $area.nl8_1 * 2);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_4($animalRectangleWidth, this$0, $isOriginallyTownLocation, $area) {
  return constructCallableReference(function *($completion) {
    var tmp = Size2D.y9p($animalRectangleWidth, this$0.fl7_1.nll().alo_1 * ($isOriginallyTownLocation ? 0.85 : 0.75));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(30), numberToDouble(30), numberToDouble(30), numberToDouble(30));
    // Inline function 'kotlin.apply' call
    var this_0 = RoundRect.rka(tmp, tmp$ret$0);
    var tmp0 = $area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.e9t(0, $area.nl8_1);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$3);
    this_0.cjq(new RGBA(Companion_getInstance_15().pci(150, 150, 150)));
    this_0.djq(new RGBA(Colors_getInstance().ac3_1));
    this_0.ska(20.0);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_5(this$0, $area) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(yield* (yield* this$0.pl6().qle(WatchtowerType_getInstance(), VOID, $completion)).m1q($completion));
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var tmp0 = $area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = Vector2D.e9t(0, $area.nl8_1);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
    position_0(this_0, tmp$ret$3);
    toHeight(this_0, this$0.fl7_1.nll().alo_1);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_6(this$0, $area) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(yield* (yield* this$0.pl6().qle(BoatType_getInstance(), VOID, $completion)).m1q($completion));
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var tmp0 = $area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = Vector2D.e9t(0, $area.nl8_1);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
    position_0(this_0, tmp$ret$3);
    toWidth(this_0, this$0.fl7_1.nll().alo_1 * 1.5);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_7(this$0, $$this$with, $placeholderBeast, $area) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = yield* imageWithOutline(this$0, yield* (yield* this$0.pl6().qle(get_objectType($$this$with, $placeholderBeast), VOID, $completion)).m1q($completion), $completion);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    this_0.fcw($area.ml8_1);
    toHeight(this_0, this$0.fl7_1.nll().alo_1 * 0.75);
    this_0.sig(0.8);
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_8(this$0, $bitmap, $standeeHeight, $isWouldBeRespawnDraug, $$this$with, $characterObject) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = Container.fi2();
    // Inline function 'kotlin.apply' call
    var this_1 = yield* imageWithOutline(this$0, $bitmap, $completion);
    toHeight(this_1, $standeeHeight);
    if ($isWouldBeRespawnDraug) {
      this_1.sif(this_1.rig());
      this_1.yif(-this_1.zif());
    }
    addTo(this_1, this_0);
    var tmp = get_objectType($$this$with, $characterObject);
    if (isInterface(tmp, SummonType)) {
      yield* addWoundsToSimpleObjects(this$0.pl6(), this_0, get_wounds($$this$with, $characterObject), VOID, $completion);
    }
    return this_0;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_9($bitmap, $elements, $type, this$0, $minArmor, $maxWounds) {
  return constructCallableReference(function *($completion) {
    var sameTypeContainer = Container.fi2();
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7($bitmap);
    addTo(this_0, sameTypeContainer);
    var tmp;
    if ($elements.s2() > 1) {
      var tmp0_text = $elements.s2().toString();
      var tmp1_color = Colors_getInstance().ac3_1;
      var tmp2_textSize = $bitmap.tc1_1 * 0.5;
      addTo(PlainText(tmp0_text, tmp2_textSize, tmp1_color), sameTypeContainer);
      tmp = Unit_instance;
    }
    yield* addArmorToSimpleObjects($type, this$0.pl6(), sameTypeContainer, $minArmor, $completion);
    yield* addWoundsToSimpleObjects(this$0.pl6(), sameTypeContainer, $maxWounds, VOID, $completion);
    return sameTypeContainer;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda_10(this$0, $trailPicture, $area, $hiddenTrails, $foundTrails, $needBigTrail, $trailOffset, $totalTrails) {
  return constructCallableReference(function *($completion) {
    return toContainerOrSelf(trailPictures(this$0, $trailPicture, $area, $hiddenTrails, $foundTrails, $needBigTrail, $trailOffset, $totalTrails));
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda$lambda($$this$with) {
  return (a, b) => {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'kotlin.collections.get' call
    var this_0 = $$this$with.x4k();
    var tmp$ret$2 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w4(a);
    var tmp = ensureNotNull(tmp$ret$2).k4o_1;
    // Inline function 'kotlin.collections.get' call
    var this_1 = $$this$with.x4k();
    var tmp$ret$4 = (isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).w4(b);
    var tmp$ret$3 = ensureNotNull(tmp$ret$4).k4o_1;
    return compareValues(tmp, tmp$ret$3);
  };
}
function BeastUiMap$collectUiUpdate$slambda$slambda$slambda(this$0, $zone) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* sandboxAddTrapAction(this$0.xlm(), $zone, $completion);
    return Unit_instance;
  }, 1);
}
function BeastUiMap$collectUiUpdate$slambda$slambda$slambda$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda$slambda$slambda$slambda_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function BeastUiMap$collectUiUpdate$slambda$slambda$slambda_0(this$0, $$this$with) {
  return constructCallableReference(function *(card, $completion) {
    var tmp;
    var tmp_0;
    var tmp_1 = this$0.xlm().sm1();
    if (tmp_1 instanceof SandboxInit) {
      tmp_0 = true;
    } else {
      tmp_0 = this$0.be1(get_huntersGameTeam());
    }
    if (tmp_0) {
      var picture = yield* (yield* this$0.pl6().mle(card, $completion)).m1q($completion);
      // Inline function 'kotlin.collections.get' call
      var this_0 = $$this$with.x4k();
      var tmp$ret$0 = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w4(card);
      var locationType = ensureNotNull(tmp$ret$0).h4o_1;
      // Inline function 'kotlin.require' call
      if (!locationType.q45()) {
        var message = 'Trap location type must be simple type: ' + locationType.toString();
        throw IllegalArgumentException.h2(toString(message));
      }
      var locationPicture = yield* (yield* this$0.pl6().hle(locationType, $completion)).m1q($completion);
      var trapViewContainer = Container.fi2();
      trapViewContainer.uie(Image.lk7(picture));
      // Inline function 'kotlin.let' call
      var it = Image.lk7(locationPicture);
      toWidth(it, picture.sc1_1 * 0.3);
      it.fcw(Vector2D.t9g((picture.sc1_1 / 2 | 0) - it.pig() / 2, picture.tc1_1 * 0.58 - it.rig() / 2));
      trapViewContainer.uie(it);
      tmp = CardUi.ilo(trapViewContainer, VOID, VOID, false, VOID, VOID, BeastUiMap$collectUiUpdate$slambda$slambda$slambda$slambda());
    } else {
      var picture_0 = yield* (yield* this$0.pl6().kle(card, $completion)).m1q($completion);
      tmp = CardUi.tm1(picture_0, VOID, VOID, false, VOID, BeastUiMap$collectUiUpdate$slambda$slambda$slambda$slambda_0());
    }
    return tmp;
  }, 1);
}
function BeastUiMap$collectUiUpdate$slambda$slambda(this$0, $traps, $$this$with, $orderedTraps, $zone) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if (this$0.se3() && $traps.s2() < get_maxTrapsInZone($$this$with)) {
      tmp = listOf_0(ActionButton.vlb('Add Trap', VOID, VOID, VOID, VOID, VOID, BeastUiMap$collectUiUpdate$slambda$slambda$slambda(this$0, $zone)));
    } else {
      tmp = emptyList();
    }
    var additionalViews = tmp;
    var tmp_0 = this$0.xlm();
    var tmp_1 = 'Traps from ' + $zone.toString();
    yield* justShowCardsPanel(tmp_0, $orderedTraps, tmp_1, additionalViews, VOID, BeastUiMap$collectUiUpdate$slambda$slambda$slambda_0(this$0, $$this$with), $completion);
    return Unit_instance;
  }, 1);
}
function BeastUiMap$collectUiUpdate$slambda_11($$this$with, $traps, $trapsCount, this$0, $zone) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $$this$with.x40().y3a();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (contains($traps, element)) {
        destination.d2(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = BeastUiMap$collectUiUpdate$slambda$lambda($$this$with);
    var tmp$ret$4 = new sam$kotlin_Comparator$0_1(tmp);
    var orderedTraps = sortedWith(destination, tmp$ret$4);
    var tmp_0 = 'Traps: ' + $trapsCount;
    var tmp_1 = this$0.fl7_1.nll().glo_1;
    var tmp_2 = this$0.fl7_1.nll().glo_1.k9i_1 * 0.75;
    // Inline function 'kotlin.also' call
    var this_0 = ActionButton.vlb(tmp_0, VOID, VOID, VOID, tmp_1, tmp_2, BeastUiMap$collectUiUpdate$slambda$slambda(this$0, $traps, $$this$with, orderedTraps, $zone));
    this_0.fcw(ensureNotNull(this$0.fl7_1.nll().hlo_1.w4($zone)));
    return this_0;
  }, 0);
}
function BeastUiMap$updatePaths$slambda(this$0, $pathNumber, $area, $direction) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(yield* (yield* this$0.pl6().rle($pathNumber, $completion)).m1q($completion));
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    toWidth(this_0, $area.nl8_1 * 2.5);
    var tmp0 = $area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g($direction.m3l_1 * $area.nl8_1, $direction.n3l_1 * $area.nl8_1);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$3);
    this_0.eig(get_radians(hiddenPathEntryRotation(this$0, $direction)));
    return this_0;
  }, 0);
}
function BeastUiMap$updatePaths$slambda_0(this$0, $area, $direction) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(yield* (yield* this$0.pl6().sle($completion)).m1q($completion));
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    toWidth(this_0, $area.nl8_1 * 1.0);
    var tmp0 = $area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g($direction.m3l_1 * $area.nl8_1 * 1.5, $direction.n3l_1 * $area.nl8_1 * 1.5);
    var tmp$ret$3 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    this_0.fcw(tmp$ret$3);
    this_0.eig(get_radians(barrierRotation(this$0, $direction)));
    return this_0;
  }, 0);
}
function BeastUiMap$updateMovementCards$lambda(this$0, $index) {
  return (it) => {
    position_0(it, this$0.fl7_1.nll().elo_1.u2($index));
    toWidth(it, this$0.fl7_1.nll().flo_1);
    return Unit_instance;
  };
}
function View$_get_pos_$ref_lp2nil(p0) {
  return constructCallableReference(() => p0.wb5(), 0, 0, 555, VOID, [p0]);
}
function View$_set_pos_$ref_npt43j(p0) {
  return constructCallableReference((p0_0) => {
    p0.fcw(p0_0);
    return Unit_instance;
  }, 1, 0, 556, VOID, [p0]);
}
function Circle$_get_alpha_$ref_4k3rbm(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 557, VOID, [p0]);
}
function Circle$_set_alpha_$ref_xuy7q6(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 558, VOID, [p0]);
}
function BeastUiMap$highlightCharacterObjectAndSummons$slambda$slambda$slambda($pingingView) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      while (true) {
        var tmp_0 = KMutableProperty0;
        var tmp_1 = Circle$_get_alpha_$ref_4k3rbm($pingingView);
        // Inline function 'korlibs.korge.tween.get' call
        var this_0 = getPropertyCallableRef('alpha', 0, tmp_0, tmp_1, Circle$_set_alpha_$ref_xuy7q6($pingingView));
        var tmp_2 = [new V2(this_0, 0.0, 0.7, _interpolate$ref(), true)];
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        yield* tween($pingingView, tmp_2, tmp$ret$1, VOID, VOID, VOID, VOID, VOID, $completion);
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$2 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$2, $completion);
        var tmp_3 = KMutableProperty0;
        var tmp_4 = Circle$_get_alpha_$ref_4k3rbm($pingingView);
        // Inline function 'korlibs.korge.tween.get' call
        var this_1 = getPropertyCallableRef('alpha', 0, tmp_3, tmp_4, Circle$_set_alpha_$ref_xuy7q6($pingingView));
        var tmp_5 = [new V2(this_1, 0.7, 0.0, _interpolate$ref(), true)];
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$4 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        yield* tween($pingingView, tmp_5, tmp$ret$4, VOID, VOID, VOID, VOID, VOID, $completion);
      }
      tmp = Unit_instance;
    }finally {
      $pingingView.uih();
    }
    return Unit_instance;
  }, 1);
}
function BeastUiMap$highlightCharacterObjectAndSummons$slambda$slambda($objectsOnBoard, this$0, $additional) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var _iterator__ex2g4s = $objectsOnBoard.p1();
    $l$loop_0: while (_iterator__ex2g4s.q1()) {
      var toHighlight = _iterator__ex2g4s.r1();
      var tmp0_elvis_lhs = this$0.fln(toHighlight);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var view = tmp;
      var tmp1_elvis_lhs = view.x1m();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var viewParent = tmp_0;
      var _destruct__k2r9zo = get_centerAndSize(view);
      var center = _destruct__k2r9zo.jm();
      var size = _destruct__k2r9zo.km();
      var radius = size.j9i_1 * 1.5;
      var color = $additional.w2(toHighlight) ? Colors_getInstance().rc5_1 : Colors_getInstance().wc5_1;
      // Inline function 'korlibs.korge.view.circle' call
      var fill = new RGBA(color);
      var stroke = new RGBA(Colors_getInstance().zc2_1);
      var renderer = GraphicsRenderer_GPU_getInstance();
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = Circle.ajq(numberToDouble(radius), fill, stroke, numberToDouble(0.0), true, renderer);
      // Inline function 'kotlin.apply' call
      var tmp_1 = addTo(this_0, viewParent);
      // Inline function 'korlibs.math.geom.Vector2D.minus' call
      var that = Vector2D.t9g(radius, radius);
      var tmp$ret$4 = Vector2D.t9g(center.r9g_1 - that.r9g_1, center.s9g_1 - that.s9g_1);
      var pingingView = xy_0(tmp_1, tmp$ret$4);
      launch($this$coroutineScope, VOID, VOID, BeastUiMap$highlightCharacterObjectAndSummons$slambda$slambda$slambda(pingingView));
    }
    return Unit_instance;
  }, 1);
}
function BeastUiMap$highlightCharacterObjectAndSummons$slambda($objectsOnBoard, this$0, $additional) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* coroutineScope(BeastUiMap$highlightCharacterObjectAndSummons$slambda$slambda($objectsOnBoard, this$0, $additional), $completion);
    return Unit_instance;
  }, 1);
}
function BeastUiMap$highlightMovingObject$slambda$lambda($glow, $center, $radius) {
  return (it) => {
    var angle = 3.141592653589793 * 2.0 * it;
    var tmp0 = $center;
    // Inline function 'kotlin.math.cos' call
    var tmp = Math.cos(angle) * $radius;
    // Inline function 'kotlin.math.sin' call
    var tmp$ret$1 = Math.sin(angle);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(tmp, tmp$ret$1 * $radius);
    var tmp$ret$2 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    $glow.fcw(tmp$ret$2);
    return Unit_instance;
  };
}
function BeastUiMap$highlightMovingObject$slambda($glow, $viewParent, $size, $center) {
  return constructCallableReference(function *($this$launch, $completion) {
    addTo($glow, $viewParent);
    // Inline function 'korlibs.korge.view.anchor' call
    var this_0 = $glow;
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    toHeight($glow, $size.k9i_1 * 0.75);
    var radius = $size.j9i_1 * 0.7;
    while (true) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp = toDuration(8, DurationUnit_SECONDS_getInstance());
      var tmp_0 = LinearEasing_instance;
      yield* tween($glow, [], tmp, tmp_0, VOID, VOID, VOID, BeastUiMap$highlightMovingObject$slambda$lambda($glow, $center, radius), $completion);
    }
    return Unit_instance;
  }, 1);
}
function BeastUiMap$highlightMovingObject$lambda($glow) {
  return (it) => {
    $glow.uih();
    return Unit_instance;
  };
}
function BeastUiMap$addLocationVariants$lambda(it) {
  return it;
}
function BeastUiMap$addLocationVariants$slambda($onChoose, $position, $uiVariants, this$0) {
  return constructCallableReference(function *($completion) {
    yield* $onChoose(new BoardPosition($position), $completion);
    var _iterator__ex2g4s = $uiVariants.p1();
    while (_iterator__ex2g4s.q1()) {
      var uiVariant = _iterator__ex2g4s.r1();
      this$0.hl7_1.cif(uiVariant);
    }
    return Unit_instance;
  }, 0);
}
function BeastUiMap$addLocationVariants$slambda_0($c) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* $c.vm4($completion);
    }finally {
      $c.uih();
    }
    return Unit_instance;
  }, 1);
}
function BeastUiMap$addCustomHighlightingAreaIfNeeded$slambda($position) {
  return constructCallableReference(function *($completion) {
    println(new BoardPosition($position));
    return Unit_instance;
  }, 0);
}
function Circle$_get_scale_$ref_npgby6(p0) {
  return constructCallableReference(() => p0.vif(), 0, 0, 559, VOID, [p0]);
}
function Circle$_set_scale_$ref_i0t9me(p0) {
  return constructCallableReference((p0_0) => {
    p0.uif(p0_0);
    return Unit_instance;
  }, 1, 0, 560, VOID, [p0]);
}
function BeastUiMap$pingLocation$slambda(this$0, $position) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0_elvis_lhs = this$0.fl7_1.jl8($position);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var area = tmp;
    var tmp0 = this$0.hl7_1;
    var tmp2 = area.nl8_1;
    // Inline function 'korlibs.korge.view.circle' call
    var fill = new RGBA(RGBA__withAd_impl_cralao(Colors_getInstance().pc8_1, 0.5));
    var stroke = new RGBA(Colors_getInstance().zc2_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Circle.ajq(numberToDouble(tmp2), fill, stroke, numberToDouble(0.0), true, renderer);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, tmp0);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    position_0(this_1, area.ml8_1);
    var pingCircle = this_1;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = Circle$_get_scale_$ref_npgby6(pingCircle);
    // Inline function 'korlibs.korge.tween.get' call
    var this_2 = getPropertyCallableRef('scale', 0, tmp_0, tmp_1, Circle$_set_scale_$ref_i0t9me(pingCircle));
    var tmp_2 = this_2.get();
    var tmp_3 = new V2(this_2, tmp_2, 2.0, _interpolate$ref(), false);
    var tmp_4 = KMutableProperty0;
    var tmp_5 = Circle$_get_alpha_$ref_4k3rbm(pingCircle);
    // Inline function 'korlibs.korge.tween.get' call
    var this_3 = getPropertyCallableRef('alpha', 0, tmp_4, tmp_5, Circle$_set_alpha_$ref_xuy7q6(pingCircle));
    var tmp_6 = this_3.get();
    var tmp_7 = [tmp_3, new V2(this_3, tmp_6, 0.0, _interpolate$ref(), false)];
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$7 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(pingCircle, tmp_7, tmp$ret$7, VOID, VOID, VOID, VOID, VOID, $completion);
    pingCircle.uih();
    return Unit_instance;
  }, 1);
}
function get_isCompoundLocationForPainting(_this__u8e3s4) {
  switch (_this__u8e3s4.w1_1) {
    case 10:
    case 8:
    case 9:
      return true;
    default:
      return false;
  }
}
function *imageWithOutline(_this__u8e3s4, bitmap, $completion) {
  return yield* imageWithOutline_0(bitmap, _this__u8e3s4.pl6(), $completion);
}
function GroupedObjectsInfo_0($context_GameState_t6qee5, obj, isAlternativeView) {
  return new GroupedObjectsInfo(get_objectType($context_GameState_t6qee5, obj), setOf(obj), get_wounds($context_GameState_t6qee5, obj), get_armor($context_GameState_t6qee5, obj), isAlternativeView);
}
function createHoveredIconAction(neededHeight, iconPicture, hint, textColor, onPress) {
  hint = hint === VOID ? null : hint;
  textColor = textColor === VOID ? Colors_getInstance().ac3_1 : textColor;
  var borderSize = neededHeight / 8;
  // Inline function 'kotlin.apply' call
  var this_0 = Image.lk7(iconPicture);
  position(this_0, borderSize, borderSize);
  toHeight(this_0, neededHeight - borderSize * 2);
  var image = this_0;
  var neededHoverSize = image.nig();
  var tmp = neededHoverSize.f9s(Size2D.y9p(borderSize * 2, borderSize * 2));
  Companion_getInstance_11();
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var corner = borderSize * 2;
  var tmp$ret$2 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  var r = RoundRect.rka(tmp, tmp$ret$2, new RGBA(Colors_getInstance().bc3_1));
  var tmp_0;
  if (hint == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_textSize = neededHeight * 0.75;
    tmp_0 = PlainText(hint, tmp0_textSize, textColor);
  }
  var text = tmp_0;
  var buttonContainer = Container.fi2();
  var result = {_v: null};
  var tmp_1 = createHoveredIconAction$roundRect$1.km8(r, text, result);
  var roundRect = addClickOption(tmp_1, createHoveredIconAction$slambda(onPress, result));
  result._v = createHoveredIconAction$1.uma(roundRect);
  if (text == null)
    null;
  else {
    text.fcw(Vector2D.t9g(roundRect.pig() + get_gameLayout().yl5_1, get_gameLayout().yl5_1));
  }
  addTo(roundRect, buttonContainer);
  addTo(image, buttonContainer);
  toHeight(buttonContainer, neededHeight);
  var tmp_2;
  if (result._v == null) {
    throwUninitializedPropertyAccessException('result');
  } else {
    tmp_2 = result._v;
  }
  tmp_2.uie(buttonContainer);
  var tmp_3;
  if (result._v == null) {
    throwUninitializedPropertyAccessException('result');
  } else {
    tmp_3 = result._v;
  }
  return tmp_3;
}
function *showFullCard(_this__u8e3s4, card, $completion) {
  var picture = yield* (yield* _this__u8e3s4.pl6().mle(card, $completion)).m1q($completion);
  var cardUi = toHeight(CardUi.tm1(picture, VOID, VOID, false, VOID, showFullCard$slambda()), get_gameLayout().fl6_1 * 0.8);
  var gameDialog = GameDialog.xlq(_this__u8e3s4.nl2_1, cardUi, VOID, get_gameDialogClose());
  yield* gameDialog.vma($completion);
  return Unit_instance;
}
function createHoveredIconAction$slambda($onPress, $result) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if ($result._v == null) {
      throwUninitializedPropertyAccessException('result');
    } else {
      tmp = $result._v;
    }
    yield* $onPress(tmp, $completion);
    return Unit_instance;
  }, 0);
}
function showFullCard$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function getBorderColor($this) {
  return $this.nlh_1 ? Colors_getInstance().bc3_1 : $this.olh_1;
}
function CardUi$_init_$slambda_g2mqa0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function CardUi$_init_$slambda_g2mqa0_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function CardUi$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.nlh_1 = true;
    this$0.ql8();
    return Unit_instance;
  }, 1);
}
function CardUi$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function CardUi$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, CardUi$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function CardUi$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.nlh_1 = false;
    this$0.ql8();
    return Unit_instance;
  }, 1);
}
function CardUi$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function CardUi$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, CardUi$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function CardUi$slambda_1(this$0) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    switch (it.xhy().w1_1) {
      case 0:
        tmp = yield* this$0.llh_1($completion);
        break;
      case 2:
        tmp = yield* this$0.klh_1($completion);
        break;
      default:
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  }, 1);
}
function CardUi$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function CardUi$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, CardUi$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function *showUpgradeCharacterBoard(_this__u8e3s4, characterObjects, selectableUpgrades, result, mayUpgradeNothing, questionContext, hideAction, $completion) {
  _this__u8e3s4.yl2_1 = new UpgradeRequest(characterObjects, selectableUpgrades, result, mayUpgradeNothing, questionContext);
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  yield* showCharacterBoardImpl($this$with, _this__u8e3s4, characterObjects, VOID, selectableUpgrades, result, mayUpgradeNothing, questionContext, VOID, VOID, VOID, VOID, hideAction, $completion);
  return Unit_instance;
}
function *showUrgullMoltEggsToReturnBoard(_this__u8e3s4, question, result, hideAction, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  yield* showCharacterBoardImpl($this$with, _this__u8e3s4, listOf_0(get_urgullBeast($this$with)), VOID, VOID, VOID, VOID, VOID, VOID, new UrgullMoltEggsToReturnBoardData(question, result), VOID, VOID, hideAction, $completion);
  return Unit_instance;
}
function *showCharacterInfoBoard(_this__u8e3s4, characterObject, showAbilitySwitcher, useRightSided, $completion) {
  showAbilitySwitcher = showAbilitySwitcher === VOID ? true : showAbilitySwitcher;
  useRightSided = useRightSided === VOID ? false : useRightSided;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp0_safe_receiver = _this__u8e3s4.yl2_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver.gmd_1.w2(characterObject)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_safe_receiver = tmp;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return ensureNotNull(yield* showCharacterBoardImpl($this$with, _this__u8e3s4, tmp1_safe_receiver.gmd_1, characterObject, tmp1_safe_receiver.hmd_1, tmp1_safe_receiver.imd_1, tmp1_safe_receiver.jmd_1, tmp1_safe_receiver.kmd_1, VOID, VOID, VOID, VOID, _this__u8e3s4.jl4_1, $completion));
  }
  return ensureNotNull(yield* showCharacterBoardImpl($this$with, _this__u8e3s4, listOf_0(characterObject), VOID, VOID, VOID, VOID, VOID, VOID, VOID, showAbilitySwitcher, useRightSided, get_gameDialogClose(), $completion));
}
function *showCharacterUpgradingAnimation(_this__u8e3s4, characterObject, upgradeChange, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  yield* showCharacterBoardImpl($this$with, _this__u8e3s4, listOf_0(characterObject), VOID, VOID, VOID, VOID, VOID, upgradeChange, VOID, VOID, VOID, VOID, $completion);
  return Unit_instance;
}
function *showCharacterBoardImpl($context_GameState_t6qee5, _this__u8e3s4, characterObjects, initialCharacterObject, selectableUpgrades, result, mayUpgradeNothing, questionContext, upgradeChange, characterSpecificData, showAbilitySwitcher, useRightSided, onClickOnEmpty, $completion) {
  initialCharacterObject = initialCharacterObject === VOID ? characterObjects.u2(0) : initialCharacterObject;
  selectableUpgrades = selectableUpgrades === VOID ? null : selectableUpgrades;
  result = result === VOID ? null : result;
  mayUpgradeNothing = mayUpgradeNothing === VOID ? false : mayUpgradeNothing;
  questionContext = questionContext === VOID ? null : questionContext;
  upgradeChange = upgradeChange === VOID ? null : upgradeChange;
  characterSpecificData = characterSpecificData === VOID ? null : characterSpecificData;
  showAbilitySwitcher = showAbilitySwitcher === VOID ? false : showAbilitySwitcher;
  useRightSided = useRightSided === VOID ? false : useRightSided;
  onClickOnEmpty = onClickOnEmpty === VOID ? null : onClickOnEmpty;
  var characterObject = {_v: initialCharacterObject};
  var tmp = get_objectType($context_GameState_t6qee5, characterObject._v);
  var isHunters = isInterface(tmp, HunterCharacter);
  var tmp_0;
  if (isHunters) {
    tmp_0 = new ControlPanelY();
  } else {
    tmp_0 = new ControlPanelX();
  }
  var containerPanel = tmp_0;
  var closing = CompletableDeferred_0();
  var dialogDeferred = CompletableDeferred_0();
  var tmp_1;
  if (onClickOnEmpty == null) {
    tmp_1 = showCharacterBoardImpl$slambda(closing);
  } else {
    tmp_1 = onClickOnEmpty;
  }
  var onClick = tmp_1;
  var boardViewport = VerticalScrollViewport.amg();
  var boardContainer = boardViewport.xmf_1;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  if (selectableUpgrades == null && isHunters && characterObjects.s2() > 1) {
    var huntersPanel = new ControlPanelX();
    var _iterator__ex2g4s = characterObjects.p1();
    while (_iterator__ex2g4s.q1()) {
      var c = _iterator__ex2g4s.r1();
      var cardContent = Container.fi2();
      var characterInfo = new CharacterVisualInfoAndContainer(get_visualInfo($context_GameState_t6qee5, c), cardContent);
      yield* addCharacterInfo($context_GameState_t6qee5, _this__u8e3s4.pl6(), characterInfo, $completion);
      var characterUI = addTo_0(toHeight(CardUi.ilo(cardContent, VOID, VOID, VOID, VOID, VOID, showCharacterBoardImpl$slambda_0(characterObject, c, boardContainer, $context_GameState_t6qee5, _this__u8e3s4, characterSpecificData, m, selectableUpgrades, boardViewport, dialogDeferred, result)), get_gameLayout().ol5_1), huntersPanel);
    }
    addTo_0(huntersPanel.xlb_1, containerPanel);
  }
  if (characterSpecificData instanceof UrgullMoltEggsToReturnBoardData) {
    var tmp_2 = get_gameI18n().c6z_1;
    // Inline function 'kotlin.also' call
    var this_0 = addTo_0(ActionButton.vlb(tmp_2, VOID, VOID, VOID, VOID, VOID, showCharacterBoardImpl$slambda_1(characterSpecificData)), containerPanel);
    // Inline function 'kotlin.collections.set' call
    var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
    m.b5(0, value);
  }
  addTo_0(boardViewport, containerPanel);
  yield* showCharacterBoardImpl$installCharacterBoard($context_GameState_t6qee5, characterObject, boardContainer, _this__u8e3s4, characterSpecificData, m, selectableUpgrades, boardViewport, dialogDeferred, result, $completion);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!m.n1()) {
    _this__u8e3s4.rln(m);
  }
  var mainContentContainer = containerPanel.xlb_1;
  var dialogLayout = useRightSided ? new BigRightSided(mainContentContainer.pig() / 10) : BigCenter_instance;
  var tmp_3;
  if (!(result == null)) {
    tmp_3 = true;
  } else {
    tmp_3 = !((characterSpecificData == null ? null : characterSpecificData.bmg()) == null);
  }
  if (tmp_3) {
    var tmp_4;
    if (!(characterSpecificData == null)) {
      tmp_4 = get_gameI18n().h71(characterSpecificData.t3o());
    } else {
      var tmp1_elvis_lhs = get_gameI18n().h71(questionContext);
      tmp_4 = tmp1_elvis_lhs == null ? get_gameI18n().f6z_1 : tmp1_elvis_lhs;
    }
    var message = tmp_4;
    var tmp_5;
    if (!(result == null) && !(selectableUpgrades == null)) {
      var tmp0 = get_objectType($context_GameState_t6qee5, characterObject._v).t35();
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_6;
        if (isInterface(tmp0, Collection)) {
          tmp_6 = tmp0.n1();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element = _iterator__ex2g4s_0.r1();
          if (selectableUpgrades.w2(element)) {
            tmp$ret$5 = true;
            break $l$block_0;
          }
        }
        tmp$ret$5 = false;
      }
      var canUpgradeCurrentCharacter = tmp$ret$5;
      var tmp_7 = characterObject._v;
      var tmp_8 = abilityAndInfoSwitcher(_this__u8e3s4, characterObject._v);
      // Inline function 'kotlin.with' call
      var tmp_9 = _this__u8e3s4.t6h().i38_1;
      var tmp_10;
      if (mayUpgradeNothing && canUpgradeCurrentCharacter) {
        tmp_10 = showCharacterBoardImpl$slambda_2(result);
      } else {
        tmp_10 = null;
      }
      var tmp_11 = tmp_10;
      var tmp_12;
      var tmp_13 = get_objectType($context_GameState_t6qee5, first(characterObjects));
      if (isInterface(tmp_13, HunterCharacter)) {
        tmp_12 = get_gameI18n().h6z_1;
      } else {
        if (get_gameRules($context_GameState_t6qee5).j3a() === 2) {
          tmp_12 = get_gameI18n().i6z_1;
        } else {
          tmp_12 = get_gameI18n().g6z_1;
        }
      }
      var tmp_14 = tmp_12;
      var tmp_15 = showCharacterBoardImpl$slambda_3($context_GameState_t6qee5, _this__u8e3s4, characterObjects, selectableUpgrades, result, mayUpgradeNothing, questionContext, onClickOnEmpty);
      tmp_5 = yield* handCardsCornerView(_this__u8e3s4, tmp_7, false, message, tmp_8, false, tmp_9, selectableUpgrades, m, tmp_11, tmp_14, tmp_15, showCharacterBoardImpl$slambda_4(), $completion);
    } else {
      tmp_5 = dialogCornerText(message);
    }
    var switcherView = tmp_5;
    _this__u8e3s4.rln(m);
    var dialogContent = DialogContent.cmg(mainContentContainer, switcherView, dialogLayout);
    var gameDialog = yield* _this__u8e3s4.dmg(dialogContent, VOID, VOID, $completion);
    dialogDeferred.l1t(gameDialog);
    return gameDialog;
  } else {
    if (upgradeChange == null) {
      var tmp_16;
      if (showAbilitySwitcher) {
        var message_0 = 'Character board for ' + get_gameI18n().s70(get_objectType($context_GameState_t6qee5, characterObject._v));
        var tmp_17 = characterObject._v;
        var tmp_18 = abilityAndInfoSwitcher(_this__u8e3s4, characterObject._v);
        // Inline function 'kotlin.collections.isNotEmpty' call
        var tmp_19 = !get_discardedAbilityCards($context_GameState_t6qee5, characterObject._v).n1();
        tmp_16 = yield* handCardsCornerView(_this__u8e3s4, tmp_17, false, message_0, tmp_18, tmp_19, VOID, VOID, VOID, VOID, VOID, VOID, showCharacterBoardImpl$slambda_5(_this__u8e3s4, characterObject, onClickOnEmpty), $completion);
      } else {
        tmp_16 = null;
      }
      var switcherView_0 = tmp_16;
      var dialogContent_0 = DialogContent.cmg(mainContentContainer, switcherView_0, dialogLayout);
      var gameDialog_0 = yield* _this__u8e3s4.dmg(dialogContent_0, get_gameDialogClose(), VOID, $completion);
      dialogDeferred.l1t(gameDialog_0);
      return gameDialog_0;
    } else {
      var gameDialog_1 = GameDialog.xlq(_this__u8e3s4.nl2_1, mainContentContainer, VOID, onClick);
      dialogDeferred.l1t(gameDialog_1);
      yield* gameDialog_1.vma($completion);
      // Inline function 'kotlin.require' call
      if (!(characterObjects.s2() === 1)) {
        var message_1 = 'Character objects size must be 1';
        throw IllegalArgumentException.h2(toString(message_1));
      }
      var upgradesPlacing = getCharacterUpgradePlacing($context_GameState_t6qee5, get_objectType($context_GameState_t6qee5, characterObjects.u2(0)));
      yield* waitWithPossibilityToCancel(closing, showCharacterBoardImpl$slambda_6(upgradesPlacing, upgradeChange, boardContainer), $completion);
      gameDialog_1.qlq();
      return gameDialog_1;
    }
  }
}
function *specificCharacterRendering(gsCtx, _this__u8e3s4, character, boardContainer, characterSpecificData, autoHighlights, $completion) {
  if (character instanceof Rhagner) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = get_rhagnerBoardHoardPlacing().i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var card = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var placing = _destruct__k2r9zo.k3();
      // Inline function 'kotlin.repeat' call
      var times = hoardLevel(gsCtx, get_rhagnerBeast(gsCtx), card);
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0 = placing.u2(index);
          // Inline function 'korlibs.math.geom.Vector2D.minus' call
          var that = Vector2D.a9k(get_rhagnerBoardHoardGrudgeDiametr() / 2 | 0, get_rhagnerBoardHoardGrudgeDiametr() / 2 | 0);
          var point = Vector2D.t9g(tmp0.r9g_1 - that.r9g_1, tmp0.s9g_1 - that.s9g_1);
          // Inline function 'korlibs.korge.view.image' call
          var texture = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_OneGrudge_getInstance(), $completion)).m1q($completion);
          var anchor_0 = Companion_getInstance_7().c9g_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_0 = Image.lk7(texture, anchor_0);
          // Inline function 'kotlin.apply' call
          var this_1 = addTo(this_0, boardContainer);
          xy_0(this_1, point);
          var tmp2 = get_rhagnerBoardHoardGrudgeDiametr();
          // Inline function 'korlibs.korge.view.size' call
          var height = get_rhagnerBoardHoardGrudgeDiametr();
          size(this_1, numberToDouble(tmp2), numberToDouble(height));
        }
         while (inductionVariable < times);
    }
  }
  if (character instanceof Urgull) {
    var firstVisibleEggIndex = 7 - get_remainMoltEggsOnCounter(gsCtx, get_urgullBeast(gsCtx)) | 0;
    var eggImage = yield* (yield* _this__u8e3s4.pl6().ple(EggType_getInstance(), gsCtx, $completion)).m1q($completion);
    var inductionVariable_0 = firstVisibleEggIndex;
    if (inductionVariable_0 < 7)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.view.image' call
        var anchor_1 = Companion_getInstance_7().c9g_1;
        // Inline function 'korlibs.korge.view.addTo' call
        var this_2 = Image.lk7(eggImage, anchor_1);
        // Inline function 'kotlin.apply' call
        var this_3 = addTo(this_2, boardContainer);
        // Inline function 'korlibs.korge.view.anchor' call
        anchor(this_3, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
        var tmp0_0 = get_urgullBoardFirstEagPlacing();
        // Inline function 'korlibs.math.geom.Vector2D.plus' call
        var that_0 = Vector2D.a9k(imul(index_0, get_urgullBoardEagDistance()), 0);
        var tmp$ret$16 = Vector2D.t9g(tmp0_0.r9g_1 + that_0.r9g_1, tmp0_0.s9g_1 + that_0.s9g_1);
        position_0(this_3, tmp$ret$16);
        this_3.uif(get_urgullBoardEagHeight() / eggImage.tc1_1);
      }
       while (inductionVariable_0 < 7);
    var moltEggsToReturnData = characterSpecificData instanceof UrgullMoltEggsToReturnBoardData ? characterSpecificData : null;
    if (!(moltEggsToReturnData == null)) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a = moltEggsToReturnData.emg_1.z6a_1;
      var maxToReturn = Math.min(a, firstVisibleEggIndex);
      var inductionVariable_1 = maxToReturn;
      if (1 <= inductionVariable_1)
        do {
          var eggsToReturn = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var firstHighlightedIndex = firstVisibleEggIndex - eggsToReturn | 0;
          var tmp0_1 = get_urgullBoardFirstEagPlacing();
          // Inline function 'korlibs.math.geom.Vector2D.plus' call
          var that_1 = Vector2D.a9k(imul(firstHighlightedIndex, get_urgullBoardEagDistance()), 0);
          var firstSlotCenter = Vector2D.t9g(tmp0_1.r9g_1 + that_1.r9g_1, tmp0_1.s9g_1 + that_1.s9g_1);
          // Inline function 'kotlin.apply' call
          var this_4 = Container.fi2();
          this_4.sig(0.0);
          var highlight = addTo(this_4, boardContainer);
          // Inline function 'kotlin.repeat' call
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < eggsToReturn)
            do {
              var index_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              // Inline function 'kotlin.apply' call
              var this_5 = Circle.ajq(get_urgullBoardEagHeight() / 2 | 0, new RGBA(Colors_getInstance().zc2_1));
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(this_5, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
              // Inline function 'korlibs.math.geom.Vector2D.plus' call
              var that_2 = Vector2D.a9k(imul(index_1, get_urgullBoardEagDistance()), 0);
              var tmp$ret$26 = Vector2D.t9g(firstSlotCenter.r9g_1 + that_2.r9g_1, firstSlotCenter.s9g_1 + that_2.s9g_1);
              position_0(this_5, tmp$ret$26);
              addTo(this_5, highlight);
            }
             while (inductionVariable_2 < eggsToReturn);
          // Inline function 'kotlin.apply' call
          var this_6 = CircleWithHover.wm4();
          this_6.xm4(0.1);
          this_6.yjp(get_urgullBoardEagHeight() / 2.0);
          this_6.cjq(new RGBA(Companion_getInstance_15().pci(150, 100, 150)));
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_6, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          position_0(this_6, firstSlotCenter);
          var hitArea = addTo(this_6, boardContainer);
          var pulseJob = launch(_this__u8e3s4.jl2_1, VOID, VOID, specificCharacterRendering$slambda(hitArea));
          moltEggsToReturnData.fmg_1.g1n(specificCharacterRendering$lambda(pulseJob));
          // Inline function 'korlibs.korge.input.mouse' call
          // Inline function 'kotlin.run' call
          var $this$mouse = get_mouse(hitArea);
          // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
          var handler = specificCharacterRendering$slambda_0(moltEggsToReturnData, eggsToReturn);
          var tmp = KProperty1;
          // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
          var tmp_0 = getPropertyCallableRef('click', 1, tmp, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
          tmp_0.v9y(specificCharacterRendering$lambda_0($this$mouse, handler));
          // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
          var handler_0 = specificCharacterRendering$slambda_1(highlight);
          var tmp_1 = KProperty1;
          // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
          var tmp_2 = getPropertyCallableRef('over', 1, tmp_1, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
          tmp_2.v9y(specificCharacterRendering$lambda_1($this$mouse, handler_0));
          // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
          var handler_1 = specificCharacterRendering$slambda_2(highlight);
          var tmp_3 = KProperty1;
          // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
          var tmp_4 = getPropertyCallableRef('out', 1, tmp_3, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
          tmp_4.v9y(specificCharacterRendering$lambda_2($this$mouse, handler_1));
          var tmp_5 = toPoint(hitArea.s2().l9s(2));
          // Inline function 'kotlin.collections.set' call
          var value = new AutoHighlight(hitArea, tmp_5, specificCharacterRendering$slambda_3(highlight));
          autoHighlights.b5(eggsToReturn, value);
        }
         while (1 <= inductionVariable_1);
    }
  }
  return Unit_instance;
}
function rectangleForUpgrade(r) {
  var tmp = r.s2();
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_11();
  var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
  // Inline function 'kotlin.apply' call
  var this_0 = RoundRectWithHover.gmg(tmp, tmp$ret$0);
  position_0(this_0, r.n9i());
  return this_0;
}
function upgradePin(c) {
  // Inline function 'kotlin.apply' call
  var this_0 = Circle.ajq(c.t9i_1);
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
  position_0(this_0, c.s9i_1);
  return this_0;
}
function showCharacterBoardImpl$installCharacterBoard$slambda($this_showCharacterBoardImpl, $dialogDeferred, $$context_GameState_nmk48x, $u, $characterObject, $result) {
  return constructCallableReference(function *($completion) {
    if ($this_showCharacterBoardImpl.bm5()) {
      (yield* $dialogDeferred.m1q($completion)).qlq();
      if (!get_upgraded($$context_GameState_nmk48x, $u)) {
        yield* submitSandboxUpgrade($this_showCharacterBoardImpl, $characterObject._v, $u, $completion);
      } else {
        yield* removeSandboxUpgrade($this_showCharacterBoardImpl, $characterObject._v, $u, $completion);
      }
    } else {
      ensureNotNull($result).l1t($u);
    }
    return Unit_instance;
  }, 0);
}
function showCharacterBoardImpl$slambda($closing) {
  return constructCallableReference(function *(it, $completion) {
    $closing.l1t(Unit_instance);
    return Unit_instance;
  }, 1);
}
function *showCharacterBoardImpl$installCharacterBoard($$context_GameState_nmk48x, characterObject, boardContainer, $this_showCharacterBoardImpl, $characterSpecificData, m, $selectableUpgrades, boardViewport, dialogDeferred, $result, $completion) {
  var character = get_objectType($$context_GameState_nmk48x, characterObject._v);
  var upgradesPlacing = getCharacterUpgradePlacing($$context_GameState_nmk48x, character);
  // Inline function 'korlibs.korge.view.image' call
  var texture = yield* (yield* $this_showCharacterBoardImpl.pl6().tle(character, $this_showCharacterBoardImpl.t6h(), $completion)).m1q($completion);
  var anchor = Companion_getInstance_7().c9g_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.lk7(texture, anchor);
  // Inline function 'kotlin.apply' call
  addTo(this_0, boardContainer);
  yield* /*#__NOINLINE__*/specificCharacterRendering($$context_GameState_nmk48x, $this_showCharacterBoardImpl, character, boardContainer, $characterSpecificData, m, $completion);
  if ($this_showCharacterBoardImpl.bm5() || !($selectableUpgrades == null)) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = upgradesPlacing.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var u = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var pair = _destruct__k2r9zo.k3();
      var r = pair.jm();
      if ($this_showCharacterBoardImpl.bm5() || ensureNotNull($selectableUpgrades).w2(u)) {
        var tmp = rectangleForUpgrade(r);
        // Inline function 'kotlin.also' call
        var this_1 = addTo(addClickOption(tmp, showCharacterBoardImpl$installCharacterBoard$slambda($this_showCharacterBoardImpl, dialogDeferred, $$context_GameState_nmk48x, u, characterObject, $result)), boardContainer);
        // Inline function 'kotlin.collections.set' call
        var value = new AutoHighlight(this_1, toPoint(this_1.s2().l9s(2)));
        m.b5(u, value);
      }
    }
  }
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = upgradesPlacing.i3().p1();
  while (_iterator__ex2g4s_0.q1()) {
    var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.r1();
    // Inline function 'kotlin.collections.component1' call
    var upgrade = _destruct__k2r9zo_0.j3();
    // Inline function 'kotlin.collections.component2' call
    var u_0 = _destruct__k2r9zo_0.k3();
    if (get_upgraded($$context_GameState_nmk48x, upgrade)) {
      // Inline function 'kotlin.apply' call
      var this_2 = upgradePin(u_0.qm_1);
      this_2.zjp(get_gameColors().xlx_1);
      addTo(this_2, boardContainer);
    }
  }
  if (isInterface(character, HunterCharacter)) {
    toWidth(boardContainer, get_gameLayout().el6_1 * 0.6);
  } else {
    toWidth(boardContainer, get_gameLayout().el6_1 * 0.6);
  }
  var tmp0 = boardContainer.rig();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_gameLayout().fl6_1 * get_gameLayout().pl5_1;
  var viewportHeight = Math.min(tmp0, b);
  var tmp_0;
  if (boardContainer.rig() > viewportHeight) {
    tmp_0 = coerceIn(get_gameLayout().fl6_1 * (1 - get_gameLayout().pl5_1) / viewportHeight, 0.001, 0.5);
  } else {
    tmp_0 = null;
  }
  var edgeFadeRatio = tmp_0;
  var tmp0_safe_receiver = topCharacterBoardScrollingY(character);
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = tmp0_safe_receiver * boardContainer.zif();
  }
  boardViewport.hmg(viewportHeight, edgeFadeRatio, tmp_1);
  return Unit_instance;
}
function *showCharacterBoardImpl$changeCharacter(characterObject, c, boardContainer, $$context_GameState_nmk48x, $this_showCharacterBoardImpl, $characterSpecificData, m, $selectableUpgrades, boardViewport, dialogDeferred, $result, $completion) {
  characterObject._v = c;
  boardContainer.tie();
  yield* /*#__NOINLINE__*/showCharacterBoardImpl$installCharacterBoard($$context_GameState_nmk48x, characterObject, boardContainer, $this_showCharacterBoardImpl, $characterSpecificData, m, $selectableUpgrades, boardViewport, dialogDeferred, $result, $completion);
  return Unit_instance;
}
function showCharacterBoardImpl$slambda_0($characterObject, $c, $boardContainer, $$context_GameState_nmk48x, $this_showCharacterBoardImpl, $characterSpecificData, $m, $selectableUpgrades, $boardViewport, $dialogDeferred, $result) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showCharacterBoardImpl$changeCharacter($characterObject, $c, $boardContainer, $$context_GameState_nmk48x, $this_showCharacterBoardImpl, $characterSpecificData, $m, $selectableUpgrades, $boardViewport, $dialogDeferred, $result, $completion);
    return Unit_instance;
  }, 0);
}
function showCharacterBoardImpl$slambda_1($characterSpecificData) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $characterSpecificData.fmg_1.l1t(0);
    return Unit_instance;
  }, 1);
}
function showCharacterBoardImpl$slambda_2($result) {
  return constructCallableReference(function *($completion) {
    $result.l1t(null);
    return Unit_instance;
  }, 0);
}
function showCharacterBoardImpl$slambda_3($$context_GameState_nmk48x, $this_showCharacterBoardImpl, $characterObjects, $selectableUpgrades, $result, $mayUpgradeNothing, $questionContext, $onClickOnEmpty) {
  return constructCallableReference(function *(selectedCharacterObject, $completion) {
    yield* /*#__NOINLINE__*/showCharacterBoardImpl($$context_GameState_nmk48x, $this_showCharacterBoardImpl, $characterObjects, selectedCharacterObject, $selectableUpgrades, $result, $mayUpgradeNothing, $questionContext, VOID, VOID, VOID, VOID, $onClickOnEmpty, $completion);
    return Unit_instance;
  }, 1);
}
function showCharacterBoardImpl$slambda_4() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function showCharacterBoardImpl$slambda_5($this_showCharacterBoardImpl, $characterObject, $onClickOnEmpty) {
  return constructCallableReference(function *($completion) {
    yield* showCardsInHand($this_showCharacterBoardImpl, $characterObject._v, $onClickOnEmpty, $completion);
    return Unit_instance;
  }, 0);
}
function Circle$_get_color_$ref_y7a19z(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.qd9());
  }, 0, 0, 428, VOID, [p0]);
}
function Circle$_set_color_$ref_7izkal(p0) {
  return constructCallableReference((p0_0) => {
    p0.zjp(p0_0.sci_1);
    return Unit_instance;
  }, 1, 0, 429, VOID, [p0]);
}
function _interpolateColor$ref() {
  return constructCallableReference((p0, p1, p2) => new RGBA(_interpolateColor(p0.v9f_1, p1.sci_1, p2.sci_1)), 3, 0, 561, '_interpolateColor');
}
function showCharacterBoardImpl$slambda_6($upgradesPlacing, $upgradeChange, $boardContainer) {
  return constructCallableReference(function *($completion) {
    var _destruct__k2r9zo = ensureNotNull($upgradesPlacing.w4($upgradeChange.j4x_1));
    var r = _destruct__k2r9zo.jm();
    var c = _destruct__k2r9zo.km();
    // Inline function 'kotlin.apply' call
    var this_0 = rectangleForUpgrade(r);
    this_0.sig(0.0);
    var upgradeArea = addTo(this_0, $boardContainer);
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < 2) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_0 = KMutableProperty0;
        var tmp_1 = RoundRectWithHover$_get_alpha_$ref_dj8v26(upgradeArea);
        // Inline function 'korlibs.korge.tween.get' call
        var this_1 = getPropertyCallableRef('alpha', 0, tmp_0, tmp_1, RoundRectWithHover$_set_alpha_$ref_s70qie(upgradeArea));
        var tmp$ret$2 = new V2(this_1, 0.0, 0.5, _interpolate$ref(), true);
        yield* tween(upgradeArea, [tmp$ret$2], get_gameAnimations().vl4_1, get_EASE_IN(Companion_getInstance_14()), VOID, VOID, VOID, VOID, $completion);
        var tmp_2 = KMutableProperty0;
        var tmp_3 = RoundRectWithHover$_get_alpha_$ref_dj8v26(upgradeArea);
        // Inline function 'korlibs.korge.tween.get' call
        var this_2 = getPropertyCallableRef('alpha', 0, tmp_2, tmp_3, RoundRectWithHover$_set_alpha_$ref_s70qie(upgradeArea));
        var tmp$ret$3 = new V2(this_2, 0.5, 0.0, _interpolate$ref(), true);
        yield* tween(upgradeArea, [tmp$ret$3], get_gameAnimations().vl4_1, get_EASE_IN(Companion_getInstance_14()), VOID, VOID, VOID, VOID, $completion);
      }
       while (inductionVariable < 2);
      tmp = Unit_instance;
    }
    // Inline function 'kotlin.apply' call
    var this_3 = upgradePin(c);
    this_3.zjp(Colors_getInstance().ec3_1);
    var pin = addTo(this_3, $boardContainer);
    var tmp_4 = KMutableProperty0;
    var tmp_5 = Circle$_get_color_$ref_y7a19z(pin);
    var tmp0 = getPropertyCallableRef('color', 0, tmp_4, tmp_5, Circle$_set_color_$ref_7izkal(pin));
    var tmp2 = Colors_getInstance().ec3_1;
    // Inline function 'korlibs.korge.tween.get' call
    var end = get_gameColors().xlx_1;
    var tmp$ret$6 = new V2(tmp0, new RGBA(tmp2), new RGBA(end), _interpolateColor$ref(), true);
    yield* tween(pin, [tmp$ret$6], get_gameAnimations().wl4_1, get_EASE_OUT_QUAD(Companion_getInstance_14()), VOID, VOID, VOID, VOID, $completion);
    yield* delay(get_gameAnimations().xl4_1, $completion);
    return Unit_instance;
  }, 0);
}
function specificCharacterRendering$slambda($hitArea) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $hitArea.vm4($completion);
    return Unit_instance;
  }, 1);
}
function specificCharacterRendering$lambda($pulseJob) {
  return (it) => {
    $pulseJob.o1n();
    return Unit_instance;
  };
}
function specificCharacterRendering$slambda_0($moltEggsToReturnData, $eggsToReturn) {
  return constructCallableReference(function *(it, $completion) {
    $moltEggsToReturnData.fmg_1.l1t($eggsToReturn);
    return Unit_instance;
  }, 1);
}
function specificCharacterRendering$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function specificCharacterRendering$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, specificCharacterRendering$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function specificCharacterRendering$slambda_1($highlight) {
  return constructCallableReference(function *(it, $completion) {
    $highlight.sig(0.45);
    return Unit_instance;
  }, 1);
}
function specificCharacterRendering$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function specificCharacterRendering$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, specificCharacterRendering$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function specificCharacterRendering$slambda_2($highlight) {
  return constructCallableReference(function *(it, $completion) {
    $highlight.sig(0.0);
    return Unit_instance;
  }, 1);
}
function specificCharacterRendering$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function specificCharacterRendering$lambda_2($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, specificCharacterRendering$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function specificCharacterRendering$slambda_3($highlight) {
  return constructCallableReference(function *($completion) {
    $highlight.sig(0.45);
    return Unit_instance;
  }, 0);
}
function *createCard(_this__u8e3s4, picture, card, configuration, $completion) {
  var cardContent = Container.fi2();
  // Inline function 'korlibs.korge.view.image' call
  var anchor = Companion_getInstance_7().c9g_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.lk7(picture, anchor);
  // Inline function 'kotlin.apply' call
  addTo(this_0, cardContent);
  yield* adjustParticularCardPainting(_this__u8e3s4, card, picture, cardContent, $completion);
  if (configuration instanceof ShowDiscardedCard) {
    addTo(yield* discardedCardOverlay(_this__u8e3s4, picture.tc1_1, $completion), cardContent);
  }
  var showClick = createCard$slambda(card, _this__u8e3s4);
  var rightClick = showClick;
  var tmp;
  if (equals(configuration, JustShowTheCard_instance)) {
    tmp = showClick;
  } else {
    if (configuration instanceof ShowDiscardedCard) {
      tmp = showClick;
    } else {
      if (configuration instanceof ShowTheCardWithAdditionalButtons) {
        tmp = showClick;
      } else {
        if (configuration instanceof ShowTheCardWithAction) {
          tmp = configuration.img_1;
        } else {
          if (configuration instanceof PlayTheCard) {
            tmp = showClick;
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  var onClick = tmp;
  var tmp1_safe_receiver = (!(card == null) ? isInterface(card, PlayableInTurnCard) : false) ? card : null;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = new PlayCardVariant(tmp1_safe_receiver);
  }
  var playCardVariant = tmp_0;
  if (configuration instanceof PlayTheCard) {
    if (configuration.nmg_1) {
      onClick = createCard$slambda_0(configuration, playCardVariant);
    }
    var leftTopY = 0.0;
    if (configuration.mmg_1) {
      var boatPicture = yield* (yield* _this__u8e3s4.pl6().qle(BoatType_getInstance(), VOID, $completion)).m1q($completion);
      var discardToUseBoatVariant = new DiscardToUseBoatVariant(ensureNotNull(card));
      var onBoatPress = createCard$slambda_1(configuration, discardToUseBoatVariant);
      var tmp_1 = picture.s2().p9s_1 * 0.15;
      var boatAction = createHoveredIconAction(tmp_1, boatPicture, 'Use Boat', VOID, createCard$slambda_2(onBoatPress));
      boatAction.sif(leftTopY);
      cardContent.uie(boatAction);
      leftTopY = leftTopY + boatAction.rig();
      var tmp0 = configuration.kmg_1;
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(boatAction, toPoint(boatAction.s2().l9s(2)));
      tmp0.b5(discardToUseBoatVariant, value);
    }
    if (configuration.lmg_1) {
      var fleePicture = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_Flee_getInstance(), $completion)).m1q($completion);
      var discardToMoveVariant = new DiscardToMoveVariant(ensureNotNull(card));
      var onFleePress = createCard$slambda_3(configuration, discardToMoveVariant);
      var tmp_2 = picture.s2().p9s_1 * 0.15;
      var fleeAction = createHoveredIconAction(tmp_2, fleePicture, 'Flee', VOID, createCard$slambda_4(onFleePress));
      fleeAction.sif(leftTopY);
      cardContent.uie(fleeAction);
      var tmp0_0 = configuration.kmg_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = new AutoHighlight(fleeAction, toPoint(fleeAction.s2().l9s(2)));
      tmp0_0.b5(discardToMoveVariant, value_0);
    }
    if (!get_gameConfiguration().rlc_1 && configuration.nmg_1) {
      var strictPlay = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_StrictPlay_getInstance(), $completion)).m1q($completion);
      var tmp_3 = picture.s2().p9s_1 * 0.15;
      var tmp_4 = Colors_getInstance().zc2_1;
      var strictAction = createHoveredIconAction(tmp_3, strictPlay, 'Strictly Play', tmp_4, createCard$slambda_5(_this__u8e3s4, card, configuration, playCardVariant));
      var tmp_5;
      if (!(card == null) ? isInterface(card, DraftActionCard) : false) {
        tmp_5 = 0.4;
      } else {
        tmp_5 = 0.5;
      }
      strictAction.sif(picture.tc1_1 * tmp_5);
      cardContent.uie(strictAction);
    }
  }
  if (configuration instanceof ShowTheCardWithAdditionalButtons) {
    var leftTopY_0 = 0.0;
    var _iterator__ex2g4s = configuration.omg_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var button = _iterator__ex2g4s.r1();
      var buttonPicture = yield* (yield* _this__u8e3s4.pl6().tld(button.pmg_1, $completion)).m1q($completion);
      var tmp_6;
      if (!(button.smg_1 == null)) {
        var tmp_7 = picture.tc1_1 * 0.15;
        tmp_6 = createHoveredIconAction(tmp_7, buttonPicture, button.qmg_1, button.rmg_1, createCard$slambda_6(button));
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = Image.lk7(buttonPicture);
        this_1.kci(button.rmg_1);
        toHeight(this_1, picture.tc1_1 * 0.15);
        tmp_6 = this_1;
      }
      var buttonView = tmp_6;
      // Inline function 'kotlin.also' call
      buttonView.sif(leftTopY_0);
      leftTopY_0 = leftTopY_0 + buttonView.rig();
      addTo(buttonView, cardContent);
    }
  }
  if (!(card == null)) {
    var magnifyingGlassIcon = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_MagnifyingGlass_getInstance(), $completion)).m1q($completion);
    var tmp_8 = picture.tc1_1 * 0.15;
    // Inline function 'kotlin.also' call
    var this_2 = createHoveredIconAction(tmp_8, magnifyingGlassIcon, VOID, VOID, createCard$slambda_7(_this__u8e3s4, card));
    this_2.rif(picture.sc1_1 - this_2.pig());
    addTo(this_2, cardContent);
  }
  var tmp_9;
  var tmp_10;
  if (configuration instanceof PlayTheCard) {
    tmp_10 = configuration.nmg_1;
  } else {
    tmp_10 = false;
  }
  if (tmp_10) {
    tmp_9 = true;
  } else {
    tmp_9 = configuration instanceof ShowTheCardWithAction;
  }
  var isHoverable = tmp_9;
  var cardUi = CardUi.ilo(cardContent, VOID, card, !(configuration instanceof ShowDiscardedCard), isHoverable, rightClick, onClick);
  if (configuration instanceof PlayTheCard) {
    if (configuration.nmg_1) {
      var tmp0_1 = configuration.kmg_1;
      var tmp2 = ensureNotNull(playCardVariant);
      // Inline function 'kotlin.collections.set' call
      var value_1 = new AutoHighlight(cardUi, toPoint(cardUi.s2().l9s(2)));
      tmp0_1.b5(tmp2, value_1);
    }
  }
  return cardUi;
}
var JustShowTheCard_instance;
function JustShowTheCard_getInstance() {
  return JustShowTheCard_instance;
}
var ShowDiscardedCard_instance;
function ShowDiscardedCard_getInstance() {
  return ShowDiscardedCard_instance;
}
function *addCharacterInfo(gsCtx, images, info, $completion) {
  var characterPicture = yield* (yield* images.ple(info.zmg_1.tmg_1, gsCtx, $completion)).m1q($completion);
  // Inline function 'korlibs.korge.view.image' call
  var this_0 = info.amh_1;
  var anchor = Companion_getInstance_7().c9g_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Image.lk7(characterPicture, anchor);
  // Inline function 'kotlin.apply' call
  var characterImage = addTo(this_1, this_0);
  var woundY = {_v: 0.0};
  yield* addCharacterInfo$addWounds(info, images, woundY, GeneralTokens_ThreeDamages_getInstance(), info.zmg_1.vmg_1 / 3 | 0, characterImage.x9z() * 0.33, $completion);
  yield* addCharacterInfo$addWounds(info, images, woundY, GeneralTokens_OneDamage_getInstance(), info.zmg_1.vmg_1 % 3 | 0, characterImage.x9z() * 0.25, $completion);
  var grudgeX = {_v: 0.0};
  yield* addCharacterInfo$addGrudges(info, images, grudgeX, characterImage, GeneralTokens_ThreeGrudges_getInstance(), info.zmg_1.xmg_1 / 3 | 0, characterImage.w9z() * get_gameLayout().bl6_1, $completion);
  yield* addCharacterInfo$addGrudges(info, images, grudgeX, characterImage, GeneralTokens_OneGrudge_getInstance(), info.zmg_1.xmg_1 % 3 | 0, characterImage.w9z() * get_gameLayout().al6_1, $completion);
  var neededAncientPowerX = characterImage.w9z() * 0.2;
  var ancientPowerX = characterImage.w9z() - neededAncientPowerX;
  var inductionVariable = 0;
  var last = info.zmg_1.wmg_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = info.amh_1;
      // Inline function 'korlibs.korge.view.image' call
      var texture = yield* (yield* images.vle(GeneralTokens_AncientPower_getInstance(), $completion)).m1q($completion);
      var anchor_0 = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_2 = Image.lk7(texture, anchor_0);
      // Inline function 'kotlin.apply' call
      var this_3 = addTo(this_2, tmp0);
      toWidth(this_3, neededAncientPowerX);
      this_3.rif(ancientPowerX);
      ancientPowerX = ancientPowerX - neededAncientPowerX;
    }
     while (inductionVariable < last);
  if (info.zmg_1.ymg_1 >= 0) {
    var resourceWidth = characterImage.w9z() * 0.28;
    var tmp0_subject = info.zmg_1.tmg_1;
    var tmp;
    if (tmp0_subject instanceof Draug) {
      tmp = yield* images.vle(GeneralTokens_LifeForce_getInstance(), $completion);
    } else {
      if (tmp0_subject instanceof Lydan) {
        tmp = yield* images.vle(GeneralTokens_LifeForce_getInstance(), $completion);
      } else {
        if (tmp0_subject instanceof Vacker) {
          tmp = yield* images.nle(Vacker_getInstance(), $completion);
        } else {
          if (tmp0_subject instanceof Valdi) {
            tmp = yield* images.vle(GeneralTokens_BloodDrop_getInstance(), $completion);
          } else {
            return Unit_instance;
          }
        }
      }
    }
    var image = tmp;
    var tmp0_0 = info.amh_1;
    // Inline function 'korlibs.korge.view.image' call
    var texture_0 = yield* image.m1q($completion);
    var anchor_1 = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Image.lk7(texture_0, anchor_1);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, tmp0_0);
    toWidth(this_5, resourceWidth);
    this_5.rif(characterImage.w9z() - resourceWidth);
    this_5.sif(characterImage.x9z() - this_5.rig());
    var resourceImage = this_5;
    // Inline function 'kotlin.also' call
    var this_6 = BorderedText(info.zmg_1.ymg_1.toString(), resourceWidth);
    addTo(this_6, info.amh_1);
    this_6.rif(resourceImage.wea() + (resourceImage.pig() - this_6.pig()) / 2);
    this_6.sif(resourceImage.xea() + resourceImage.rig() - this_6.rig());
  }
  return Unit_instance;
}
function characterArea(_this__u8e3s4, characterContent, characterObject) {
  var tmp = characterArea$slambda(_this__u8e3s4, characterObject);
  return CardUi.ilo(characterContent, VOID, VOID, VOID, VOID, tmp, characterArea$slambda_0(_this__u8e3s4, characterObject));
}
function *showDiscardWithSwitcher(_this__u8e3s4, cardsToShow, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.run' call
  var controlPanelY = new ControlPanelY();
  addTo_0(PlainText('Discarded', get_gameLayout().sl5_1), controlPanelY);
  var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  addTo_0(ActionButton.vlb('Action Cards', VOID, VOID, VOID, VOID, VOID, showDiscardWithSwitcher$slambda(_this__u8e3s4)), actions);
  addTo_0(ActionButton.vlb('Hunter Items', VOID, VOID, VOID, VOID, VOID, showDiscardWithSwitcher$slambda_0(_this__u8e3s4)), actions);
  addTo_0(ActionButton.vlb('Beastly talents', VOID, VOID, VOID, VOID, VOID, showDiscardWithSwitcher$slambda_1(_this__u8e3s4)), actions);
  if (get_gameContentVersion($this$with.y37_1).h4g()) {
    addTo_0(ActionButton.vlb('Ruins', VOID, VOID, VOID, VOID, VOID, showDiscardWithSwitcher$slambda_2(_this__u8e3s4)), actions);
  }
  addTo_0(actions.xlb_1, controlPanelY);
  var switcher = controlPanelY.xlb_1;
  var tmp;
  switch (cardsToShow.w1_1) {
    case 0:
      tmp = $this$with.n38_1;
      break;
    case 1:
      tmp = $this$with.z37_1.e4n_1;
      break;
    case 2:
      tmp = $this$with.a38_1.v2y_1;
      break;
    case 3:
      tmp = $this$with.b38_1.w4n_1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var cards = toList_0(tmp);
  yield* justShowCardsPanel_0(_this__u8e3s4, cards, switcher, VOID, VOID, showDiscardWithSwitcher$slambda_3(_this__u8e3s4), $completion);
  return Unit_instance;
}
var DiscardCardsType_DraftActionCards_instance;
var DiscardCardsType_HunterItems_instance;
var DiscardCardsType_BeastlyTalents_instance;
var DiscardCardsType_AshRuins_instance;
var DiscardCardsType_entriesInitialized;
function DiscardCardsType_initEntries() {
  if (DiscardCardsType_entriesInitialized)
    return Unit_instance;
  DiscardCardsType_entriesInitialized = true;
  DiscardCardsType_DraftActionCards_instance = new DiscardCardsType('DraftActionCards', 0);
  DiscardCardsType_HunterItems_instance = new DiscardCardsType('HunterItems', 1);
  DiscardCardsType_BeastlyTalents_instance = new DiscardCardsType('BeastlyTalents', 2);
  DiscardCardsType_AshRuins_instance = new DiscardCardsType('AshRuins', 3);
}
function *justShowCardsPanel(_this__u8e3s4, cards, message, additionalViews, onClickOnEmpty, cardUisMap, $completion) {
  additionalViews = additionalViews === VOID ? emptyList() : additionalViews;
  onClickOnEmpty = onClickOnEmpty === VOID ? null : onClickOnEmpty;
  yield* justShowCardsPanel_0(_this__u8e3s4, cards, dialogCornerText(message), additionalViews, onClickOnEmpty, cardUisMap, $completion);
  return Unit_instance;
}
function *showCardsInHand(_this__u8e3s4, characterObject, onClickOnEmpty, $completion) {
  onClickOnEmpty = onClickOnEmpty === VOID ? null : onClickOnEmpty;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var isSameTeam = _this__u8e3s4.be1(get_gameTeam($this$with, characterObject));
  var discardedAbilityCards = get_discardedAbilityCards($this$with, characterObject);
  var tmp0_safe_receiver = _this__u8e3s4.xl2_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver.bmh_1.equals(characterObject)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var currentQuestionRequest = tmp;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var tmp_1;
  if (!(currentQuestionRequest == null)) {
    var variants = currentQuestionRequest.cmh_1;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = variants.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp0_safe_receiver_0 = element instanceof PlayCardVariant ? element : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d4f_1;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        var tmp2_safe_receiver = element instanceof DiscardToMoveVariant ? element : null;
        tmp_2 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s4e_1;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var tmp3_elvis_lhs = tmp_2;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        var tmp4_safe_receiver = element instanceof DiscardToUseBoatVariant ? element : null;
        tmp_3 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.x4e_1;
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var tmp0_safe_receiver_1 = tmp_3;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver_1);
      }
    }
    var variantsCards = toSet(destination);
    var tmp_4 = plus(orderedCards(variantsCards), orderedCards(minus(get_hand($this$with, characterObject), variantsCards)));
    // Inline function 'kotlin.takeIf' call
    var tmp_5;
    if (_this__u8e3s4.wl2_1) {
      tmp_5 = discardedAbilityCards;
    } else {
      tmp_5 = null;
    }
    var tmp1_elvis_lhs_0 = tmp_5;
    tmp_1 = plus(tmp_4, orderedCards(tmp1_elvis_lhs_0 == null ? emptySet() : tmp1_elvis_lhs_0));
  } else {
    var tmp_6 = orderedCards(get_hand($this$with, characterObject));
    // Inline function 'kotlin.takeIf' call
    var tmp_7;
    if (_this__u8e3s4.wl2_1) {
      tmp_7 = discardedAbilityCards;
    } else {
      tmp_7 = null;
    }
    var tmp2_elvis_lhs = tmp_7;
    tmp_1 = plus(tmp_6, orderedCards(tmp2_elvis_lhs == null ? emptySet() : tmp2_elvis_lhs));
  }
  var orderedCards_0 = tmp_1;
  var sandboxAddingCard = _this__u8e3s4.bm5() ? createAddCardUiForSandbox(_this__u8e3s4, characterObject) : null;
  var tmp_8;
  if (currentQuestionRequest == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_9;
    var tmp0 = currentQuestionRequest.cmh_1;
    var tmp$ret$18;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_10;
      if (isInterface(tmp0, Collection)) {
        tmp_10 = tmp0.n1();
      } else {
        tmp_10 = false;
      }
      if (tmp_10) {
        tmp$ret$18 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = tmp0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        if (element_0 instanceof PassVariant) {
          tmp$ret$18 = true;
          break $l$block_0;
        }
      }
      tmp$ret$18 = false;
    }
    if (tmp$ret$18) {
      var text = _this__u8e3s4.t6h().c39_1 === 0 ? get_gameI18n().x6y_1 : get_gameI18n().y6y_1;
      var tmp_11 = !_this__u8e3s4.emh() || equals(_this__u8e3s4.fmh(), PassVariant_getInstance());
      // Inline function 'kotlin.also' call
      var this_0 = ActionButton.vlb(text, tmp_11, VOID, VOID, VOID, VOID, showCardsInHand$slambda(currentQuestionRequest));
      var tmp2 = PassVariant_getInstance();
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
      m.b5(tmp2, value);
      tmp_9 = this_0;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var nothingButton = tmp_8;
  var tmp_12;
  if (currentQuestionRequest == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_12 = get_gameI18n().j6z_1;
  }
  var tmp5_elvis_lhs = tmp_12;
  var tmp_13;
  if (tmp5_elvis_lhs == null) {
    // Inline function 'kotlin.with' call
    var $this$with_0 = _this__u8e3s4.t6h();
    tmp_13 = 'Hand of ' + get_gameI18n().s70(get_objectType($this$with_0, characterObject));
  } else {
    tmp_13 = tmp5_elvis_lhs;
  }
  var message = tmp_13;
  var tmp_14 = abilityAndInfoSwitcher(_this__u8e3s4, characterObject);
  // Inline function 'kotlin.collections.isNotEmpty' call
  var tmp_15 = !get_discardedAbilityCards($this$with, characterObject).n1();
  var cornerView = yield* handCardsCornerView(_this__u8e3s4, characterObject, true, message, tmp_14, tmp_15, VOID, VOID, VOID, VOID, VOID, VOID, showCardsInHand$slambda_0(_this__u8e3s4, characterObject, onClickOnEmpty), $completion);
  _this__u8e3s4.rln(m);
  var actualOnClickOnEmpty = onClickOnEmpty == null ? !(currentQuestionRequest == null) ? _this__u8e3s4.jl4_1 : get_gameDialogClose() : onClickOnEmpty;
  var tmp_16 = listOfNotNull_0([sandboxAddingCard, nothingButton]);
  yield* justShowCardsPanel_0(_this__u8e3s4, orderedCards_0, cornerView, tmp_16, actualOnClickOnEmpty, showCardsInHand$slambda_1(_this__u8e3s4, isSameTeam, $this$with, characterObject, discardedAbilityCards, currentQuestionRequest, m), $completion);
  return Unit_instance;
}
function orderedCards(cards) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = cards.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!(element == null) ? isInterface(element, AbilityCard) : false) {
      destination.d2(element);
    }
  }
  var abilityCards = destination;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = cards.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (!(element_0 == null) ? isInterface(element_0, DraftActionCard) : false) {
      destination_0.d2(element_0);
    }
  }
  var draftCards = destination_0;
  var otherCards = minus_0(cards, plus(abilityCards, draftCards));
  var orderedCards = plus(plus(abilityCards, draftCards), otherCards);
  return orderedCards;
}
function *createCardsPanel(cards, additionalViews, cardUisMap, $completion) {
  var _destruct__k2r9zo = cards.s2() <= 18 ? to(get_gameLayout().ol5_1, 6) : to(get_gameLayout().ol5_1 * 0.66, 11);
  var shouldBeHeight = _destruct__k2r9zo.jm();
  var maxCardInRow = _destruct__k2r9zo.km();
  var elementsNumber = cards.s2() + additionalViews.s2() | 0;
  var rowsNumber = 1 + (elementsNumber / maxCardInRow | 0) | 0;
  var cardsInRowNumber = elementsNumber / rowsNumber | 0;
  var rowsWithExtraCardNumber = elementsNumber % rowsNumber | 0;
  var cardIndex = 0;
  var resultContainer = null;
  var controlPanelY = null;
  var calculatedCardUiMap = yield* coroutineScope(createCardsPanel$slambda(cards, cardUisMap), $completion);
  var inductionVariable = 0;
  if (inductionVariable < rowsNumber)
    do {
      var rowI = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var cardsInThisRowNumber = rowI < (rowsNumber - rowsWithExtraCardNumber | 0) ? cardsInRowNumber : cardsInRowNumber + 1 | 0;
      var controlPanelX = new ControlPanelX();
      if (rowI === 0) {
        var tmp;
        if (rowsNumber > 1) {
          controlPanelY = new ControlPanelY();
          var tmp_0;
          if (controlPanelY == null) {
            throwUninitializedPropertyAccessException('controlPanelY');
          } else {
            tmp_0 = controlPanelY;
          }
          tmp = tmp_0;
        } else {
          tmp = controlPanelX;
        }
        var panel = tmp;
        resultContainer = panel.xlb_1;
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < cardsInThisRowNumber)
        do {
          var columnI = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (cardIndex >= cards.s2()) {
            var view = additionalViews.u2(cardIndex - cards.s2() | 0);
            addTo_0(view, controlPanelX);
          } else {
            var card = cards.u2(cardIndex);
            var cardUi = ensureNotNull(calculatedCardUiMap.w4(card));
            addTo_0(toHeight(cardUi, shouldBeHeight), controlPanelX);
          }
          cardIndex = cardIndex + 1 | 0;
        }
         while (inductionVariable_0 < cardsInThisRowNumber);
      if (rowsNumber > 1) {
        var tmp_1;
        if (controlPanelY == null) {
          throwUninitializedPropertyAccessException('controlPanelY');
        } else {
          tmp_1 = controlPanelY;
        }
        addTo_0(controlPanelX.xlb_1, tmp_1);
      }
    }
     while (inductionVariable < rowsNumber);
  var tmp_2;
  if (resultContainer == null) {
    throwUninitializedPropertyAccessException('resultContainer');
  } else {
    tmp_2 = resultContainer;
  }
  return tmp_2;
}
function *imageWithOutline_0(bitmap, images, $completion) {
  return Image.lk7(yield* images.zle(yield* images.zle(bitmap, Companion_getInstance_15().pci(35, 85, 85), 0.05, $completion), Colors_getInstance().zc2_1, 0.03, $completion));
}
function *adjustParticularCardPainting(_this__u8e3s4, card, picture, cardContent, $completion) {
  if (card instanceof FlickerCard) {
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.t6h();
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this$with.i38_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$8;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp = get_objectType($this$with, element);
        if (tmp instanceof Mara) {
          tmp$ret$8 = element instanceof ObjectOnBoard ? element : THROW_CCE();
          break $l$block;
        }
        tmp$ret$8 = null;
      }
      var tmp0_safe_receiver = tmp$ret$8;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
    var mara = singleOrNull(destination);
    if (!(mara == null)) {
      // Inline function 'kotlin.with' call
      var $this$with_0 = _this__u8e3s4.t6h();
      var stepsNumber = card.s5q($this$with_0, mara);
      var stepsText = '' + stepsNumber + ' ' + (stepsNumber === 1 ? 'step' : 'steps');
      // Inline function 'kotlin.apply' call
      var this_0 = BorderedText(stepsText, picture.tc1_1 * 0.08);
      this_0.rif((picture.sc1_1 - this_0.w9z()) / 2);
      this_0.sif(picture.tc1_1 * 0.04);
      addTo(this_0, cardContent);
    }
    return Unit_instance;
  }
  if (!(card == null) ? isInterface(card, SigridAbilityCard) : false) {
    // Inline function 'kotlin.with' call
    var $this$with_1 = _this__u8e3s4.t6h();
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_0 = get_allHunters($this$with_1);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      var tmp$ret$23;
      $l$block_0: {
        // Inline function 'steelart.beast.cast' call
        var tmp_0 = get_objectType($this$with_1, element_0);
        if (tmp_0 instanceof Sigrid) {
          tmp$ret$23 = element_0 instanceof ObjectOnBoard ? element_0 : THROW_CCE();
          break $l$block_0;
        }
        tmp$ret$23 = null;
      }
      var tmp0_safe_receiver_0 = tmp$ret$23;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.d2(tmp0_safe_receiver_0);
      }
    }
    var tmp0_safe_receiver_1 = singleOrNull(destination_0);
    var tmp0_elvis_lhs = tmp0_safe_receiver_1 == null ? null : pactTerrain($this$with_1, tmp0_safe_receiver_1, card);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var pactTerrain_0 = tmp_1;
    var markerSize = picture.tc1_1 * 0.16;
    // Inline function 'korlibs.korge.view.image' call
    var texture = yield* (yield* _this__u8e3s4.pl6().hle(pactTerrain_0, $completion)).m1q($completion);
    var anchor = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(texture, anchor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, cardContent);
    toWidth(this_2, markerSize);
    this_2.rif(picture.sc1_1 * 0.07);
    this_2.sif(picture.tc1_1 * 0.07);
    return Unit_instance;
  }
  if (!(!(card == null) ? isInterface(card, RhagnerCard) : false))
    return Unit_instance;
  // Inline function 'kotlin.with' call
  var $this$with_2 = _this__u8e3s4.t6h();
  var hoardLevel_0 = hoardLevel($this$with_2, get_rhagnerBeast($this$with_2), card);
  if (hoardLevel_0 <= 0)
    return Unit_instance;
  var grudgeSize = picture.tc1_1 * 0.18;
  var grudgeRightOffset = picture.sc1_1 * 0.06;
  var grudgeX = picture.sc1_1 - grudgeSize - grudgeRightOffset;
  var grudgeTopOffset = picture.tc1_1 * 0.08;
  var grudgeShiftY = grudgeSize * 0.72;
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < hoardLevel_0)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.view.image' call
      var texture_0 = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_OneGrudge_getInstance(), $completion)).m1q($completion);
      var anchor_0 = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = Image.lk7(texture_0, anchor_0);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, cardContent);
      toWidth(this_4, grudgeSize);
      this_4.rif(grudgeX);
      this_4.sif(grudgeTopOffset + index * grudgeShiftY);
    }
     while (inductionVariable < hoardLevel_0);
  return Unit_instance;
}
function *discardedCardOverlay(_this__u8e3s4, pictureHeight, $completion) {
  var inaccessibleIcon = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_Inaccessible_getInstance(), $completion)).m1q($completion);
  var neededHeight = pictureHeight * 0.15;
  var borderSize = neededHeight / 8;
  // Inline function 'kotlin.apply' call
  var this_0 = Image.lk7(inaccessibleIcon);
  position(this_0, borderSize, borderSize);
  toHeight(this_0, neededHeight - borderSize * 2);
  return this_0;
}
function *justShowCardsPanel_0(_this__u8e3s4, cards, cornerView, additionalViews, onClickOnEmpty, cardUisMap, $completion) {
  additionalViews = additionalViews === VOID ? emptyList() : additionalViews;
  onClickOnEmpty = onClickOnEmpty === VOID ? null : onClickOnEmpty;
  var resultContainer = yield* /*#__NOINLINE__*/createCardsPanel(cards, additionalViews, cardUisMap, $completion);
  yield* _this__u8e3s4.gmh(resultContainer, cornerView, onClickOnEmpty == null ? get_gameDialogClose() : onClickOnEmpty, $completion);
  return Unit_instance;
}
function *handCardsCornerView(_this__u8e3s4, currentCharacterObject, isHandMode, message, cornerView, hasDiscardedAbilityCards, characters, selectableUpgrades, autoHighlights, onFinishUpgrades, finishUpgradesText, onSelectCharacterObject, onToggleDiscardedAbilityCards, $completion) {
  message = message === VOID ? null : message;
  cornerView = cornerView === VOID ? null : cornerView;
  characters = characters === VOID ? _this__u8e3s4.t6h().i38_1 : characters;
  selectableUpgrades = selectableUpgrades === VOID ? null : selectableUpgrades;
  autoHighlights = autoHighlights === VOID ? null : autoHighlights;
  onFinishUpgrades = onFinishUpgrades === VOID ? null : onFinishUpgrades;
  finishUpgradesText = finishUpgradesText === VOID ? get_gameI18n().g6z_1 : finishUpgradesText;
  onSelectCharacterObject = onSelectCharacterObject === VOID ? null : onSelectCharacterObject;
  if (message == null && cornerView == null && !hasDiscardedAbilityCards && characters.s2() <= 1 && onFinishUpgrades == null)
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new ControlPanelY();
  var tmp0_safe_receiver = dialogCornerText(message);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.mlr(tmp0_safe_receiver);
  }
  if (cornerView == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.mlr(cornerView);
  }
  if (characters.s2() > 1) {
    var portraitsPanel = new ControlPanelY();
    var _iterator__ex2g4s = characters.p1();
    while (_iterator__ex2g4s.q1()) {
      var characterObject = _iterator__ex2g4s.r1();
      var isSelected = characterObject.equals(currentCharacterObject);
      // Inline function 'kotlin.apply' call
      var this_1 = yield* _this__u8e3s4.hmh(characterObject, isHandMode, onSelectCharacterObject, $completion);
      this_1.sig(isSelected ? 1.0 : 0.5);
      var portrait = toHeight(this_1, get_gameLayout().nl6_1);
      portraitsPanel.mlr(portrait);
      if (!isSelected && !(selectableUpgrades == null) && !(autoHighlights == null)) {
        // Inline function 'kotlin.with' call
        var $this$with = _this__u8e3s4.t6h();
        var characterUpgrades = get_objectType($this$with, characterObject).t35();
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList.p2();
        var _iterator__ex2g4s_0 = selectableUpgrades.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element = _iterator__ex2g4s_0.r1();
          if (characterUpgrades.w2(element)) {
            destination.d2(element);
          }
        }
        var _iterator__ex2g4s_1 = destination.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var upgrade = _iterator__ex2g4s_1.r1();
          var tmp = toPoint(portrait.s2().l9s(2));
          // Inline function 'kotlin.collections.set' call
          var value = new AutoHighlight(portrait, tmp, handCardsCornerView$slambda(onSelectCharacterObject, characterObject));
          autoHighlights.b5(upgrade, value);
        }
      }
    }
    if (isHandMode) {
      // Inline function 'kotlin.with' call
      var $this$with_0 = _this__u8e3s4.t6h();
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$with_0.i38_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList.p2();
      var _iterator__ex2g4s_2 = tmp0.p1();
      while (_iterator__ex2g4s_2.q1()) {
        var element_0 = _iterator__ex2g4s_2.r1();
        if (get_gameTeam($this$with_0, element_0) === _this__u8e3s4.k3q()) {
          destination_0.d2(element_0);
        }
      }
      var teamCharacters = destination_0;
      if (teamCharacters.s2() > 1) {
        addTo_0(ActionButton.vlb('Team', VOID, VOID, VOID, VOID, VOID, handCardsCornerView$slambda_0(_this__u8e3s4)), portraitsPanel);
      }
      addTo_0(ActionButton.vlb('All', VOID, VOID, VOID, VOID, VOID, handCardsCornerView$slambda_1(_this__u8e3s4)), portraitsPanel);
    }
    this_0.mlr(portraitsPanel.xlb_1);
  }
  if (!(onFinishUpgrades == null)) {
    // Inline function 'kotlin.also' call
    var this_2 = addTo_0(ActionButton.vlb(finishUpgradesText, VOID, VOID, VOID, VOID, VOID, handCardsCornerView$slambda_2(onFinishUpgrades)), this_0);
    if (autoHighlights == null)
      null;
    else {
      // Inline function 'kotlin.collections.set' call
      var value_0 = new AutoHighlight(this_2, toPoint(this_2.s2().l9s(2)));
      autoHighlights.b5(NullVariant_instance, value_0);
    }
  }
  if (hasDiscardedAbilityCards) {
    var inaccessibleIcon = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_Inaccessible_getInstance(), $completion)).m1q($completion);
    var tmp_0 = get_gameLayout().tl5_1;
    var tmp_1 = _this__u8e3s4.wl2_1 ? 'Hide discarded ability cards' : 'Show discarded ability cards';
    var tmp_2 = Colors_getInstance().zc2_1;
    // Inline function 'kotlin.apply' call
    var this_3 = createHoveredIconAction(tmp_0, inaccessibleIcon, tmp_1, tmp_2, handCardsCornerView$slambda_3(_this__u8e3s4, onToggleDiscardedAbilityCards));
    this_3.sig(_this__u8e3s4.wl2_1 ? 1.0 : 0.7);
    // Inline function 'kotlin.let' call
    this_0.mlr(this_3);
  }
  return this_0.xlb_1;
}
function abilityAndInfoSwitcher(_this__u8e3s4, characterObject) {
  var controlPanelX = new ButtonRow();
  addTo_0(ActionButton.vlb('Hand', VOID, VOID, VOID, VOID, VOID, abilityAndInfoSwitcher$slambda(_this__u8e3s4, characterObject)), controlPanelX);
  addTo_0(ActionButton.vlb('Info', VOID, VOID, VOID, VOID, VOID, abilityAndInfoSwitcher$slambda_0(_this__u8e3s4, characterObject)), controlPanelX);
  return controlPanelX.xlb_1;
}
function *showHands(_this__u8e3s4, characters, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0 = _this__u8e3s4.t6h();
  $l$block: {
    if (characters.n1()) {
      break $l$block;
    }
    // Inline function 'kotlin.collections.mutableMapOf' call
    var m = LinkedHashMap.m7();
    var tmp0_safe_receiver = _this__u8e3s4.xl2_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (characters.w2(tmp0_safe_receiver.bmh_1)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var activeQuestionRequest = tmp;
    var gap = get_gameLayout().zl5_1;
    var rowsWidth = get_gameLayout().kl6_1 - gap * 4;
    var rowsHeight = get_gameLayout().fl6_1 * get_gameLayout().pl5_1 - gap * 2;
    var contentWidth = rowsWidth + gap * 2;
    var contentHeight = rowsHeight + gap * 2;
    var content = Container.fi2();
    // Inline function 'korlibs.korge.view.solidRect' call
    var color = Colors_getInstance().ec3_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = SolidRect.mkf(Size2D.y9p(contentWidth, contentHeight), color);
    // Inline function 'kotlin.apply' call
    addTo(this_0, content);
    var rowsPanel = new ControlPanelY(VOID, gap, gap);
    var rowHeight = (rowsHeight - get_gameLayout().yl5_1 * (characters.s2() - 1 | 0)) / characters.s2();
    // Inline function 'kotlin.collections.mutableListOf' call
    var handRows = ArrayList.p2();
    var _iterator__ex2g4s = characters.p1();
    while (_iterator__ex2g4s.q1()) {
      var characterObject = _iterator__ex2g4s.r1();
      var rowPanel = new ControlPanelX(Size2D.y9p(rowsWidth, rowHeight));
      var tmp0_0 = rowPanel.xlb_1;
      // Inline function 'korlibs.korge.view.solidRect' call
      var color_0 = Colors_getInstance().ec3_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = SolidRect.mkf(Size2D.y9p(rowsWidth, rowHeight), color_0);
      // Inline function 'kotlin.apply' call
      addTo(this_1, tmp0_0);
      var portrait = addTo_0(toHeight(yield* _this__u8e3s4.imh(characterObject, true, VOID, $completion), get_gameLayout().nl6_1), rowPanel);
      var portraitWidth = portrait.pig();
      var cardsAreaWidth = rowsWidth - portraitWidth - get_gameLayout().yl5_1;
      var discardedAbilityCards = get_discardedAbilityCards(tmp0, characterObject);
      var tmp_1;
      if (activeQuestionRequest == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        if (activeQuestionRequest.bmh_1.equals(characterObject)) {
          tmp_2 = activeQuestionRequest;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      }
      var currentQuestionRequest = tmp_1;
      var tmp_3;
      if (!(currentQuestionRequest == null)) {
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0_1 = currentQuestionRequest.cmh_1;
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList.p2();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = tmp0_1.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element = _iterator__ex2g4s_0.r1();
          var tmp0_safe_receiver_0 = element instanceof PlayCardVariant ? element : null;
          var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d4f_1;
          var tmp_4;
          if (tmp1_elvis_lhs == null) {
            var tmp2_safe_receiver = element instanceof DiscardToMoveVariant ? element : null;
            tmp_4 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s4e_1;
          } else {
            tmp_4 = tmp1_elvis_lhs;
          }
          var tmp3_elvis_lhs = tmp_4;
          var tmp_5;
          if (tmp3_elvis_lhs == null) {
            var tmp4_safe_receiver = element instanceof DiscardToUseBoatVariant ? element : null;
            tmp_5 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.x4e_1;
          } else {
            tmp_5 = tmp3_elvis_lhs;
          }
          var tmp0_safe_receiver_1 = tmp_5;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.d2(tmp0_safe_receiver_1);
          }
        }
        var variantsCards = toSet(destination);
        var tmp_6 = plus(orderedCards(variantsCards), orderedCards(minus(get_hand(tmp0, characterObject), variantsCards)));
        // Inline function 'kotlin.takeIf' call
        var tmp_7;
        if (_this__u8e3s4.wl2_1) {
          tmp_7 = discardedAbilityCards;
        } else {
          tmp_7 = null;
        }
        var tmp2_elvis_lhs = tmp_7;
        tmp_3 = plus(tmp_6, orderedCards(tmp2_elvis_lhs == null ? emptySet() : tmp2_elvis_lhs));
      } else {
        var tmp_8 = orderedCards(get_hand(tmp0, characterObject));
        // Inline function 'kotlin.takeIf' call
        var tmp_9;
        if (_this__u8e3s4.wl2_1) {
          tmp_9 = discardedAbilityCards;
        } else {
          tmp_9 = null;
        }
        var tmp3_elvis_lhs_0 = tmp_9;
        tmp_3 = plus(tmp_8, orderedCards(tmp3_elvis_lhs_0 == null ? emptySet() : tmp3_elvis_lhs_0));
      }
      var cardsToShow = tmp_3;
      var cardsPanel = new ControlPanelX();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.n2(collectionSizeOrDefault(cardsToShow, 10));
      var _iterator__ex2g4s_1 = cardsToShow.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var item = _iterator__ex2g4s_1.r1();
        var tmp_10;
        var tmp_11;
        if (_this__u8e3s4.bm5() || _this__u8e3s4.be1(get_gameTeam(tmp0, characterObject))) {
          tmp_11 = true;
        } else {
          tmp_11 = isInterface(item, AbilityCard);
        }
        if (tmp_11) {
          tmp_10 = true;
        } else {
          var tmp0_safe_receiver_2 = tmp0.d39_1.w4(new GameTeam(_this__u8e3s4.k3q()));
          var tmp1_safe_receiver = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.e4o_1;
          var tmp2_safe_receiver_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w4(new HandPlace(characterObject));
          tmp_10 = (tmp2_safe_receiver_0 == null ? null : tmp2_safe_receiver_0.w2(item)) === true;
        }
        var needFront = tmp_10;
        var picture = needFront ? (yield* (yield* _this__u8e3s4.pl6().mle(item, $completion)).m1q($completion)) : (yield* (yield* _this__u8e3s4.pl6().kle(item, $completion)).m1q($completion));
        var tmp_12;
        if (needFront && discardedAbilityCards.w2(item)) {
          tmp_12 = ShowDiscardedCard_instance;
        } else if (!(currentQuestionRequest == null) && needFront) {
          var variants = currentQuestionRequest.cmh_1;
          var tmp$ret$30;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_13;
            if (isInterface(variants, Collection)) {
              tmp_13 = variants.n1();
            } else {
              tmp_13 = false;
            }
            if (tmp_13) {
              tmp$ret$30 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s_2 = variants.p1();
            while (_iterator__ex2g4s_2.q1()) {
              var element_0 = _iterator__ex2g4s_2.r1();
              var tmp_14;
              if (element_0 instanceof DiscardToMoveVariant) {
                tmp_14 = equals(element_0.s4e_1, item);
              } else {
                tmp_14 = false;
              }
              if (tmp_14) {
                tmp$ret$30 = true;
                break $l$block_1;
              }
            }
            tmp$ret$30 = false;
          }
          var tmp_15 = tmp$ret$30;
          var tmp$ret$32;
          $l$block_3: {
            // Inline function 'kotlin.collections.any' call
            var tmp_16;
            if (isInterface(variants, Collection)) {
              tmp_16 = variants.n1();
            } else {
              tmp_16 = false;
            }
            if (tmp_16) {
              tmp$ret$32 = false;
              break $l$block_3;
            }
            var _iterator__ex2g4s_3 = variants.p1();
            while (_iterator__ex2g4s_3.q1()) {
              var element_1 = _iterator__ex2g4s_3.r1();
              var tmp_17;
              if (element_1 instanceof DiscardToUseBoatVariant) {
                tmp_17 = equals(element_1.x4e_1, item);
              } else {
                tmp_17 = false;
              }
              if (tmp_17) {
                tmp$ret$32 = true;
                break $l$block_3;
              }
            }
            tmp$ret$32 = false;
          }
          var tmp_18 = tmp$ret$32;
          var tmp$ret$34;
          $l$block_5: {
            // Inline function 'kotlin.collections.any' call
            var tmp_19;
            if (isInterface(variants, Collection)) {
              tmp_19 = variants.n1();
            } else {
              tmp_19 = false;
            }
            if (tmp_19) {
              tmp$ret$34 = false;
              break $l$block_5;
            }
            var _iterator__ex2g4s_4 = variants.p1();
            while (_iterator__ex2g4s_4.q1()) {
              var element_2 = _iterator__ex2g4s_4.r1();
              var tmp_20;
              if (element_2 instanceof PlayCardVariant) {
                tmp_20 = equals(element_2.d4f_1, item);
              } else {
                tmp_20 = false;
              }
              if (tmp_20) {
                tmp$ret$34 = true;
                break $l$block_5;
              }
            }
            tmp$ret$34 = false;
          }
          tmp_12 = new PlayTheCard(currentQuestionRequest.dmh_1, m, tmp_15, tmp_18, tmp$ret$34);
        } else {
          tmp_12 = JustShowTheCard_instance;
        }
        var cardConfiguration = tmp_12;
        // Inline function 'kotlin.takeIf' call
        var tmp_21;
        if (needFront) {
          tmp_21 = item;
        } else {
          tmp_21 = null;
        }
        var tmp$ret$36 = tmp_21;
        var tmp$ret$29 = toHeight(yield* /*#__NOINLINE__*/createCard(_this__u8e3s4, picture, tmp$ret$36, cardConfiguration, $completion), get_gameLayout().ol5_1);
        destination_0.d2(tmp$ret$29);
      }
      var cardViews = destination_0;
      fitCardsToPanel(cardsPanel, cardViews, cardsAreaWidth, rowHeight);
      var cardsArea = Container.fi2();
      // Inline function 'korlibs.korge.view.solidRect' call
      var color_1 = Colors_getInstance().ec3_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_2 = SolidRect.mkf(Size2D.y9p(cardsAreaWidth, rowHeight), color_1);
      // Inline function 'kotlin.apply' call
      addTo(this_2, cardsArea);
      addTo(cardsPanel.xlb_1, cardsArea);
      addTo_0(cardsArea, rowPanel);
      // Inline function 'kotlin.collections.plusAssign' call
      var element_3 = new showHands$HandRow(rowPanel, cardsPanel, cardsAreaWidth);
      handRows.d2(element_3);
    }
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = handRows.p1();
    if (!iterator.q1())
      throw NoSuchElementException.w7();
    var maxValue = iterator.r1().kmh_1.xlb_1.pig();
    while (iterator.q1()) {
      var v = iterator.r1().kmh_1.xlb_1.pig();
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    var maxCardsWidth = maxValue;
    var _iterator__ex2g4s_5 = handRows.p1();
    while (_iterator__ex2g4s_5.q1()) {
      var handRow = _iterator__ex2g4s_5.r1();
      xy(handRow.kmh_1.xlb_1, coerceAtLeast((handRow.lmh_1 - maxCardsWidth) / 2, 0.0), coerceAtLeast((rowHeight - handRow.kmh_1.xlb_1.rig()) / 2, 0.0));
      handRow.jmh_1.flr();
      addTo_0(handRow.jmh_1.xlb_1, rowsPanel);
    }
    addTo(rowsPanel.xlb_1, content);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!m.n1()) {
      _this__u8e3s4.rln(m);
    }
    yield* _this__u8e3s4.gmh(content, (null == null ? true : null instanceof View) ? null : THROW_CCE(), get_gameDialogClose(), $completion);
  }
  return Unit_instance;
}
function createCard$slambda($card, $this_createCard) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if (!($card == null)) {
      tmp = yield* showFullCard($this_createCard, $card, $completion);
    }
    return Unit_instance;
  }, 0);
}
function createCard$slambda_0($configuration, $playCardVariant) {
  return constructCallableReference(function *($completion) {
    $configuration.jmg_1.l1t(ensureNotNull($playCardVariant));
    return Unit_instance;
  }, 0);
}
function createCard$slambda_1($configuration, $discardToUseBoatVariant) {
  return constructCallableReference(function *($completion) {
    $configuration.jmg_1.l1t($discardToUseBoatVariant);
    return Unit_instance;
  }, 0);
}
function createCard$slambda_2($onBoatPress) {
  return constructCallableReference(function *(it, $completion) {
    yield* $onBoatPress($completion);
    return Unit_instance;
  }, 1);
}
function createCard$slambda_3($configuration, $discardToMoveVariant) {
  return constructCallableReference(function *($completion) {
    $configuration.jmg_1.l1t($discardToMoveVariant);
    return Unit_instance;
  }, 0);
}
function createCard$slambda_4($onFleePress) {
  return constructCallableReference(function *(it, $completion) {
    yield* $onFleePress($completion);
    return Unit_instance;
  }, 1);
}
function createCard$slambda_5($this_createCard, $card, $configuration, $playCardVariant) {
  return constructCallableReference(function *(it, $completion) {
    $this_createCard.mmh(ensureNotNull($card));
    $configuration.jmg_1.l1t(ensureNotNull($playCardVariant));
    return Unit_instance;
  }, 1);
}
function createCard$slambda_6($button) {
  return constructCallableReference(function *(it, $completion) {
    yield* $button.smg_1($completion);
    return Unit_instance;
  }, 1);
}
function createCard$slambda_7($this_createCard, $card) {
  return constructCallableReference(function *(it, $completion) {
    yield* showFullCard($this_createCard, $card, $completion);
    return Unit_instance;
  }, 1);
}
function *addCharacterInfo$addWounds($info, $images, woundY, token, number, neededWoundHeight, $completion) {
  var inductionVariable = 0;
  if (inductionVariable < number)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = $info.amh_1;
      // Inline function 'korlibs.korge.view.image' call
      var texture = yield* (yield* $images.vle(token, $completion)).m1q($completion);
      var anchor = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = Image.lk7(texture, anchor);
      // Inline function 'kotlin.apply' call
      var this_1 = addTo(this_0, tmp0);
      toHeight(this_1, neededWoundHeight);
      this_1.sif(woundY._v);
      woundY._v = woundY._v + neededWoundHeight * 0.8;
    }
     while (inductionVariable < number);
  return Unit_instance;
}
function *addCharacterInfo$addGrudges($info, $images, grudgeX, characterImage, token, number, neededGrudgeWidth, $completion) {
  var inductionVariable = 0;
  if (inductionVariable < number)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0 = $info.amh_1;
      // Inline function 'korlibs.korge.view.image' call
      var texture = yield* (yield* $images.vle(token, $completion)).m1q($completion);
      var anchor = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_0 = Image.lk7(texture, anchor);
      // Inline function 'kotlin.apply' call
      var this_1 = addTo(this_0, tmp0);
      toWidth(this_1, neededGrudgeWidth);
      this_1.rif(grudgeX._v);
      this_1.sif(characterImage.x9z() - neededGrudgeWidth);
      grudgeX._v = grudgeX._v + ($info.zmg_1.xmg_1 < 9 ? neededGrudgeWidth * 0.8 : $info.zmg_1.xmg_1 < 13 ? neededGrudgeWidth * 0.5 : neededGrudgeWidth * 0.3);
    }
     while (inductionVariable < number);
  return Unit_instance;
}
function characterArea$slambda($this_characterArea, $characterObject) {
  return constructCallableReference(function *($completion) {
    yield* showCharacterInfoBoard($this_characterArea, $characterObject, VOID, VOID, $completion);
    return Unit_instance;
  }, 0);
}
function characterArea$slambda_0($this_characterArea, $characterObject) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showCardsInHand($this_characterArea, $characterObject, VOID, $completion);
    return Unit_instance;
  }, 0);
}
function showDiscardWithSwitcher$slambda($this_showDiscardWithSwitcher) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showDiscardWithSwitcher($this_showDiscardWithSwitcher, DiscardCardsType_DraftActionCards_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function showDiscardWithSwitcher$slambda_0($this_showDiscardWithSwitcher) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showDiscardWithSwitcher($this_showDiscardWithSwitcher, DiscardCardsType_HunterItems_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function showDiscardWithSwitcher$slambda_1($this_showDiscardWithSwitcher) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showDiscardWithSwitcher($this_showDiscardWithSwitcher, DiscardCardsType_BeastlyTalents_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function showDiscardWithSwitcher$slambda_2($this_showDiscardWithSwitcher) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showDiscardWithSwitcher($this_showDiscardWithSwitcher, DiscardCardsType_AshRuins_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function showDiscardWithSwitcher$slambda$slambda($this_showDiscardWithSwitcher, $card) {
  return constructCallableReference(function *($completion) {
    yield* showFullCard($this_showDiscardWithSwitcher, $card, $completion);
    return Unit_instance;
  }, 0);
}
function showDiscardWithSwitcher$slambda$slambda_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function showDiscardWithSwitcher$slambda_3($this_showDiscardWithSwitcher) {
  return constructCallableReference(function *(card, $completion) {
    var picture = yield* (yield* $this_showDiscardWithSwitcher.pl6().mle(card, $completion)).m1q($completion);
    var tmp = Image.lk7(picture);
    var tmp_0 = showDiscardWithSwitcher$slambda$slambda($this_showDiscardWithSwitcher, card);
    return CardUi.ilo(tmp, VOID, card, false, VOID, tmp_0, showDiscardWithSwitcher$slambda$slambda_0());
  }, 1);
}
function showCardsInHand$sigridPactButton$slambda($this_showCardsInHand, $card) {
  return constructCallableReference(function *($completion) {
    var result = CompletableDeferred_0();
    yield* $this_showCardsInHand.nmh(setOf_0([LocationType_Forest_getInstance(), LocationType_Cave_getInstance(), LocationType_Swamp_getInstance()]), true, result, $completion);
    yield* submitSpecialSetupEvent($this_showCardsInHand, new SigridPactChangeEvent($card, yield* result.m1q($completion)), $completion);
    return Unit_instance;
  }, 0);
}
function showCardsInHand$sigridPactButton($this_showCardsInHand, card) {
  var tmp;
  if (!$this_showCardsInHand.se3()) {
    tmp = true;
  } else {
    tmp = !isInterface(card, SigridAbilityCard);
  }
  if (tmp)
    return null;
  var tmp_0 = InterfaceIcon_Play_getInstance();
  return new AdditionalButton(tmp_0, 'Set pact location', VOID, showCardsInHand$sigridPactButton$slambda($this_showCardsInHand, card));
}
function showCardsInHand$slambda($request) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $request.dmh_1.l1t(PassVariant_getInstance());
    return Unit_instance;
  }, 1);
}
function showCardsInHand$slambda_0($this_showCardsInHand, $characterObject, $onClickOnEmpty) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showCardsInHand($this_showCardsInHand, $characterObject, $onClickOnEmpty, $completion);
    return Unit_instance;
  }, 0);
}
function showCardsInHand$slambda$slambda($this_showCardsInHand, $card, $characterObject) {
  return constructCallableReference(function *($completion) {
    yield* submitSpecialSetupEvent($this_showCardsInHand, GeneralCardMoveEvent.s53($card, new HandPlace($characterObject)), $completion);
    return Unit_instance;
  }, 0);
}
function showCardsInHand$slambda$slambda_0($this_showCardsInHand, $characterObject, $card) {
  return constructCallableReference(function *($completion) {
    yield* submitSpecialSetupEvent($this_showCardsInHand, MoveCardToDiscardEvent.d56($characterObject, $card), $completion);
    return Unit_instance;
  }, 0);
}
function showCardsInHand$slambda_1($this_showCardsInHand, $isSameTeam, $$this$with, $characterObject, $discardedAbilityCards, $currentQuestionRequest, $m) {
  return constructCallableReference(function *(card, $completion) {
    var tmp;
    var tmp_0;
    if ($this_showCardsInHand.bm5() || $isSameTeam) {
      tmp_0 = true;
    } else {
      tmp_0 = isInterface(card, AbilityCard);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $$this$with.d39_1.w4(new GameTeam($this_showCardsInHand.k3q()));
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e4o_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w4(new HandPlace($characterObject));
      tmp = (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w2(card)) === true;
    }
    var needFront = tmp;
    var picture = yield* (needFront ? (yield* $this_showCardsInHand.pl6().mle(card, $completion)) : (yield* $this_showCardsInHand.pl6().kle(card, $completion))).m1q($completion);
    var tmp_1;
    if (needFront && $discardedAbilityCards.w2(card)) {
      var tmp_2;
      if ($this_showCardsInHand.bm5()) {
        var tmp_3 = new AdditionalButton(InterfaceIcon_Inaccessible_getInstance(), 'Discarded', VOID, null);
        var tmp_4 = InterfaceIcon_Back_getInstance();
        tmp_2 = new ShowTheCardWithAdditionalButtons(listOfNotNull_0([tmp_3, new AdditionalButton(tmp_4, 'Return to hand', VOID, showCardsInHand$slambda$slambda($this_showCardsInHand, card, $characterObject)), showCardsInHand$sigridPactButton($this_showCardsInHand, card)]));
      } else {
        tmp_2 = ShowDiscardedCard_instance;
      }
      tmp_1 = tmp_2;
    } else if (!($currentQuestionRequest == null) && needFront) {
      var variants = $currentQuestionRequest.cmh_1;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_5;
        if (isInterface(variants, Collection)) {
          tmp_5 = variants.n1();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = variants.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp_6;
          if (element instanceof PlayCardVariant) {
            tmp_6 = equals(element.d4f_1, card);
          } else {
            tmp_6 = false;
          }
          if (tmp_6) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      var isPlayable = tmp$ret$0;
      var tmp$ret$2;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_7;
        if (isInterface(variants, Collection)) {
          tmp_7 = variants.n1();
        } else {
          tmp_7 = false;
        }
        if (tmp_7) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = variants.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          var tmp_8;
          if (element_0 instanceof DiscardToMoveVariant) {
            tmp_8 = equals(element_0.s4e_1, card);
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
        }
        tmp$ret$2 = false;
      }
      var isDiscardable = tmp$ret$2;
      var tmp$ret$4;
      $l$block_4: {
        // Inline function 'kotlin.collections.any' call
        var tmp_9;
        if (isInterface(variants, Collection)) {
          tmp_9 = variants.n1();
        } else {
          tmp_9 = false;
        }
        if (tmp_9) {
          tmp$ret$4 = false;
          break $l$block_4;
        }
        var _iterator__ex2g4s_1 = variants.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_1 = _iterator__ex2g4s_1.r1();
          var tmp_10;
          if (element_1 instanceof DiscardToUseBoatVariant) {
            tmp_10 = equals(element_1.x4e_1, card);
          } else {
            tmp_10 = false;
          }
          if (tmp_10) {
            tmp$ret$4 = true;
            break $l$block_4;
          }
        }
        tmp$ret$4 = false;
      }
      var canUseBoatVariant = tmp$ret$4;
      tmp_1 = new PlayTheCard($currentQuestionRequest.dmh_1, $m, isDiscardable, canUseBoatVariant, isPlayable);
    } else if ($this_showCardsInHand.bm5() && needFront && get_hand($$this$with, $characterObject).w2(card)) {
      var tmp_11 = InterfaceIcon_Inaccessible_getInstance();
      tmp_1 = new ShowTheCardWithAdditionalButtons(listOfNotNull_0([new AdditionalButton(tmp_11, 'Discard', VOID, showCardsInHand$slambda$slambda_0($this_showCardsInHand, $characterObject, card)), showCardsInHand$sigridPactButton($this_showCardsInHand, card)]));
    } else {
      tmp_1 = JustShowTheCard_instance;
    }
    var cardConfiguration = tmp_1;
    // Inline function 'kotlin.takeIf' call
    var tmp_12;
    if (needFront) {
      tmp_12 = card;
    } else {
      tmp_12 = null;
    }
    var tmp$ret$6 = tmp_12;
    return yield* /*#__NOINLINE__*/createCard($this_showCardsInHand, picture, tmp$ret$6, cardConfiguration, $completion);
  }, 1);
}
function createCardsPanel$slambda$slambda($it, $cardUisMap) {
  return constructCallableReference(function *($this$async, $completion) {
    return to($it, yield* $cardUisMap($it, $completion));
  }, 1);
}
function createCardsPanel$slambda($cards, $cardUisMap) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $cards;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = async($this$coroutineScope, VOID, VOID, createCardsPanel$slambda$slambda(item, $cardUisMap));
      destination.d2(tmp$ret$2);
    }
    return toMap(yield* awaitAll(destination, $completion));
  }, 1);
}
function handCardsCornerView$slambda($onSelectCharacterObject, $characterObject) {
  return constructCallableReference(function *($completion) {
    var tmp0_safe_receiver = $onSelectCharacterObject;
    if (tmp0_safe_receiver == null)
      null;
    else
      yield* tmp0_safe_receiver($characterObject, $completion);
    return Unit_instance;
  }, 0);
}
function handCardsCornerView$slambda_0($this_handCardsCornerView) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    // Inline function 'kotlin.with' call
    var $this$with = $this_handCardsCornerView.t6h();
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$with.i38_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (get_gameTeam($this$with, element) === $this_handCardsCornerView.k3q()) {
        destination.d2(element);
      }
    }
    yield* /*#__NOINLINE__*/showHands($this_handCardsCornerView, destination, $completion);
    return Unit_instance;
  }, 1);
}
function handCardsCornerView$slambda_1($this_handCardsCornerView) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showHands($this_handCardsCornerView, $this_handCardsCornerView.t6h().i38_1, $completion);
    return Unit_instance;
  }, 1);
}
function handCardsCornerView$slambda_2($onFinishUpgrades) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $onFinishUpgrades($completion);
    return Unit_instance;
  }, 1);
}
function handCardsCornerView$slambda_3($this_handCardsCornerView, $onToggleDiscardedAbilityCards) {
  return constructCallableReference(function *(it, $completion) {
    $this_handCardsCornerView.wl2_1 = !$this_handCardsCornerView.wl2_1;
    yield* $onToggleDiscardedAbilityCards($completion);
    return Unit_instance;
  }, 1);
}
function abilityAndInfoSwitcher$slambda($this_abilityAndInfoSwitcher, $characterObject) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showCardsInHand($this_abilityAndInfoSwitcher, $characterObject, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function abilityAndInfoSwitcher$slambda_0($this_abilityAndInfoSwitcher, $characterObject) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* showCharacterInfoBoard($this_abilityAndInfoSwitcher, $characterObject, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function DiscardCardsType_DraftActionCards_getInstance() {
  DiscardCardsType_initEntries();
  return DiscardCardsType_DraftActionCards_instance;
}
function DiscardCardsType_HunterItems_getInstance() {
  DiscardCardsType_initEntries();
  return DiscardCardsType_HunterItems_instance;
}
function DiscardCardsType_BeastlyTalents_getInstance() {
  DiscardCardsType_initEntries();
  return DiscardCardsType_BeastlyTalents_instance;
}
function DiscardCardsType_AshRuins_getInstance() {
  DiscardCardsType_initEntries();
  return DiscardCardsType_AshRuins_instance;
}
function _get_gameDialog__617axb($this) {
  var tmp = $this.ilp_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('gameDialog');
  }
}
function *showScenarioSelectionDialog($this, currentContract, sContainer, $completion) {
  if (!($this.ilp_1 == null)) {
    _get_gameDialog__617axb($this).qlq();
  }
  var contracts = availableContracts($this);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = contracts.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (getKClassFromExpression(element).equals(getKClassFromExpression(currentContract))) {
        if (found) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        single = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    tmp$ret$0 = single;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var initialContract = tmp0_elvis_lhs == null ? currentContract : tmp0_elvis_lhs;
  var tmp = ChooseScenarioScene$showScenarioSelectionDialog$slambda($this);
  // Inline function 'kotlin.also' call
  $this.ilp_1 = yield* showContractSelectionDialog($this.dlp_1, sContainer, $this.clp_1, contracts, initialContract, 'Choose scenario', 'Cancel', tmp, ChooseScenarioScene$showScenarioSelectionDialog$slambda_0($this), $completion);
  return Unit_instance;
}
function availableContracts($this) {
  var selectedVersion = $this.glp_1.gdy();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.elp_1 ? get_gameConfiguration().omh() : get_gameConfiguration().tlc_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.w3a().i4g(selectedVersion)) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var tmp$ret$5 = withGameContentVersion(item, selectedVersion);
    destination_0.d2(tmp$ret$5);
  }
  return destination_0;
}
function *pickCharacters($this, gameRules, $completion) {
  yield* pickFromCharacters($this, availableBeasts(get_gameContentVersion(gameRules)), gameRules.j3a(), $this.flp_1.a4k_1, $completion);
  yield* pickFromCharacters($this, availableHunters(get_gameContentVersion(gameRules)), gameRules.k3a(), $this.flp_1.b4k_1, $completion);
  $this.jlp_1.l1t($this.flp_1);
  _get_gameDialog__617axb($this).qlq();
  return Unit_instance;
}
function *pickFromCharacters($this, characters, numberToPick, resultList, $completion) {
  var variants = toMutableList(characters);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < numberToPick)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var result = CompletableDeferred_0();
      var cancel = ActionButton.vlb('Cancel', VOID, VOID, VOID, VOID, VOID, ChooseScenarioScene$pickFromCharacters$slambda($this));
      var tmp = toSet(variants);
      var tmp_0 = listOf_0(cancel);
      yield* chooseCharacter_0($this.clp_1, tmp, result, tmp_0, ChooseScenarioScene$pickFromCharacters$slambda_0($this), $completion);
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.collections.first' call
        var _iterator__ex2g4s = variants.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (equals(element, yield* result.m1q($completion))) {
            tmp$ret$2 = element;
            break $l$block;
          }
        }
        throw NoSuchElementException.a2('Collection contains no element matching the predicate.');
      }
      var selectedCharacter = tmp$ret$2;
      variants.z4(selectedCharacter);
      resultList.d2(selectedCharacter);
    }
     while (inductionVariable < numberToPick);
  return Unit_instance;
}
function installCharacterDialogContent($this, dialogContent) {
  var controlPanelY = new ControlPanelY();
  addTo_0(ensureNotNull(dialogCornerText('Pick character')), controlPanelY);
  var tmp0_safe_receiver = dialogContent.flt_1.w4(DialogCorner_LEFT_TOP_getInstance());
  if (tmp0_safe_receiver == null)
    null;
  else
    addTo_0(tmp0_safe_receiver, controlPanelY);
  _get_gameDialog__617axb($this).pmh(DialogContent.cmg(dialogContent.elt_1, controlPanelY.xlb_1, dialogContent.glt_1));
}
function ChooseScenarioScene$sceneInit$slambda$slambda$slambda(this$0, $contract) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* this$0.clp_1.jle($contract, $completion);
  }, 1);
}
function ChooseScenarioScene$sceneInit$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var _iterator__ex2g4s = get_gameConfiguration().tlc_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var contract = _iterator__ex2g4s.r1();
      async($this$coroutineScope, VOID, VOID, ChooseScenarioScene$sceneInit$slambda$slambda$slambda(this$0, contract));
    }
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$sceneInit$slambda$slambda$slambda_0(this$0, $beast) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* this$0.clp_1.qle($beast, VOID, $completion);
  }, 1);
}
function ChooseScenarioScene$sceneInit$slambda$slambda_0(this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var _iterator__ex2g4s = availableBeasts(Companion_getInstance_2().w39_1).p1();
    while (_iterator__ex2g4s.q1()) {
      var beast = _iterator__ex2g4s.r1();
      async($this$coroutineScope, VOID, VOID, ChooseScenarioScene$sceneInit$slambda$slambda$slambda_0(this$0, beast));
    }
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$sceneInit$slambda$slambda$slambda_1(this$0, $hunter) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* this$0.clp_1.qle($hunter, VOID, $completion);
  }, 1);
}
function ChooseScenarioScene$sceneInit$slambda$slambda_1(this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var _iterator__ex2g4s = availableHunters(Companion_getInstance_2().w39_1).p1();
    while (_iterator__ex2g4s.q1()) {
      var hunter = _iterator__ex2g4s.r1();
      async($this$coroutineScope, VOID, VOID, ChooseScenarioScene$sceneInit$slambda$slambda$slambda_1(this$0, hunter));
    }
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$sceneInit$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* coroutineScope(ChooseScenarioScene$sceneInit$slambda$slambda(this$0), $completion);
    yield* coroutineScope(ChooseScenarioScene$sceneInit$slambda$slambda_0(this$0), $completion);
    yield* coroutineScope(ChooseScenarioScene$sceneInit$slambda$slambda_1(this$0), $completion);
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$sceneInit$lambda$slambda(this$0, $this_sceneInit) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/showScenarioSelectionDialog(this$0, first(availableContracts(this$0)), $this_sceneInit, $completion);
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$sceneInit$lambda(this$0, $this_sceneInit) {
  return (newState) => {
    this$0.glp_1 = newState;
    launch(this$0.dlp_1, VOID, VOID, ChooseScenarioScene$sceneInit$lambda$slambda(this$0, $this_sceneInit));
    return Unit_instance;
  };
}
function ChooseScenarioScene$showScenarioSelectionDialog$slambda$slambda(this$0, $contract) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/pickCharacters(this$0, $contract, $completion);
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$showScenarioSelectionDialog$slambda(this$0) {
  return constructCallableReference(function *(contract, $completion) {
    this$0.flp_1.y4j_1 = contract;
    if (this$0.elp_1) {
      launch(this$0.dlp_1, VOID, VOID, ChooseScenarioScene$showScenarioSelectionDialog$slambda$slambda(this$0, contract));
    } else {
      this$0.jlp_1.l1t(this$0.flp_1);
    }
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$showScenarioSelectionDialog$slambda_0(this$0) {
  return constructCallableReference(function *($completion) {
    yield* startFromMainMenu(this$0.blp_1, this$0.clp_1, this$0.dlp_1, $completion);
    return Unit_instance;
  }, 0);
}
function ChooseScenarioScene$pickFromCharacters$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* startFromMainMenu(this$0.blp_1, this$0.clp_1, this$0.dlp_1, $completion);
    return Unit_instance;
  }, 1);
}
function ChooseScenarioScene$pickFromCharacters$slambda_0(this$0) {
  return constructCallableReference(function *(dialogContent, $completion) {
    installCharacterDialogContent(this$0, dialogContent);
    return Unit_instance;
  }, 1);
}
function createAndShowContentReferenceDialog(coroutineScope, frame, images, gameContentVersion, initialRoute, onRouteChanged, backCallback) {
  initialRoute = initialRoute === VOID ? null : initialRoute;
  onRouteChanged = onRouteChanged === VOID ? null : onRouteChanged;
  var text = PlainText('Loading...', get_gameLayout().vl5_1);
  var gameDialog = GameDialog.xlq(frame, text);
  gameDialog.ylq();
  var tmp1_elvis_lhs = initialRoute == null ? null : initialRoute.ulq_1;
  var tmp4_gameContentVersion = tmp1_elvis_lhs == null ? gameContentVersion : tmp1_elvis_lhs;
  var tmp3_elvis_lhs = initialRoute == null ? null : initialRoute.tlq_1;
  var tmp5_content = tmp3_elvis_lhs == null ? new Beast(Bolgin_getInstance()) : tmp3_elvis_lhs;
  // Inline function 'kotlin.also' call
  var this_0 = new ContentReferenceDialogState(coroutineScope, frame, gameDialog, images, tmp4_gameContentVersion, backCallback, tmp5_content, onRouteChanged);
  this_0.dmi(text);
  this_0.emi(initialRoute == null ? null : initialRoute.vlq_1);
  return gameDialog;
}
function showContentVersionSelectionDialog(frame, initialState, allowedExpansions, onClose) {
  allowedExpansions = allowedExpansions === VOID ? toSet(get_entries()) : allowedExpansions;
  var currentState = {_v: initialState.idy(allowedExpansions)};
  var gameDialog = {_v: null};
  var tmp = currentState._v;
  var tmp_0 = showContentVersionSelectionDialog$applyState$ref(currentState);
  gameDialog._v = GameDialog.mlt(frame, DialogContent.llt(createContentVersionSelectionView(tmp, allowedExpansions, tmp_0, showContentVersionSelectionDialog$lambda(gameDialog, onClose, currentState)), VOID, new FitContent()));
  var tmp_1;
  if (gameDialog._v == null) {
    throwUninitializedPropertyAccessException('gameDialog');
  } else {
    tmp_1 = gameDialog._v;
  }
  tmp_1.ylq();
  var tmp_2;
  if (gameDialog._v == null) {
    throwUninitializedPropertyAccessException('gameDialog');
  } else {
    tmp_2 = gameDialog._v;
  }
  return tmp_2;
}
function _get_selectedGameContentVersion__ag1vtr($this) {
  return $this.cmi_1.gdy();
}
function *showContent($this, $completion) {
  $this.vmh_1 = normalizedContent($this, $this.vmh_1);
  var itemElements = switchButtons($this);
  var currentContent = $this.vmh_1;
  if (currentContent instanceof Beast) {
    var tmp = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = currentContent.hmi_1.s36();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = yield* $this.tmh_1.mle(item, $completion);
      destination.d2(tmp$ret$2);
    }
    tmp.ami_1 = yield* awaitAll(destination, $completion);
    var tmp_0 = ContentReferenceDialogState$showFullCard$ref($this);
    var mainContent = yield* createBeastsInfoView(currentContent.hmi_1, $this.tmh_1, tmp_0, ContentReferenceDialogState$showContent$slambda($this, currentContent), VOID, $completion);
    reinstallContentReferenceDialog($this, mainContent, VOID, itemElements);
  } else {
    if (currentContent instanceof Hunter) {
      var infoView = yield* createHuntersInfoView($this, currentContent.gmi_1, $completion);
      reinstallContentReferenceDialog($this, infoView, VOID, itemElements);
    } else {
      if (currentContent instanceof Cards) {
        yield* showCards($this, currentContent, itemElements, $completion);
      } else {
        if (currentContent instanceof Contract) {
          var contractView = yield* createContractInfoView(currentContent.fmi_1, $this.tmh_1, true, ContentReferenceDialogState$showContractBoard$ref($this), $completion);
          var dialogLayout = new BigRightSided(contractView.pig() / 40);
          reinstallContentReferenceDialog($this, contractView, dialogLayout, itemElements);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  yield* restoreSelection($this, $completion);
  notifyRouteChanged($this);
  return Unit_instance;
}
function notifyRouteChanged($this) {
  var tmp0_safe_receiver = $this.wmh_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver(new ContentReferenceRoute($this.vmh_1, _get_selectedGameContentVersion__ag1vtr($this), $this.bmi_1));
}
function *restoreSelection($this, $completion) {
  var tmp0_elvis_lhs = $this.bmi_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var selection = tmp;
  var route = new ContentReferenceRoute($this.vmh_1, _get_selectedGameContentVersion__ag1vtr($this));
  if (!availableSelections(route).w2(selection)) {
    $this.bmi_1 = null;
    return Unit_instance;
  }
  if (startsWith(selection, 'card-')) {
    var tmp0 = referenceCards(route);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        if (get_referenceSelection(item) === selection) {
          tmp$ret$0 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$0 = -1;
    }
    var index_0 = tmp$ret$0;
    yield* showCardFromList($this, $this.ami_1, index_0, VOID, $completion);
    return Unit_instance;
  }
  var current = $this.vmh_1;
  if (current instanceof Beast) {
    var reborn = selection === 'board-reborn';
    var tmp_0;
    var tmp_1 = current.hmi_1;
    if (tmp_1 instanceof FeatheredKing) {
      tmp_0 = yield* (yield* $this.tmh_1.ule(current.hmi_1, reborn ? '-reborn' : '-unborn', $completion)).m1q($completion);
    } else {
      tmp_0 = yield* (yield* $this.tmh_1.tle(current.hmi_1, null, $completion)).m1q($completion);
    }
    var bitmap = tmp_0;
    yield* showBeastBoard($this, current.hmi_1, bitmap, reborn, $completion);
  } else {
    if (current instanceof Hunter)
      yield* showHunterBoard($this, yield* (yield* $this.tmh_1.tle(current.gmi_1, null, $completion)).m1q($completion), $completion);
    else {
      if (current instanceof Contract)
        yield* showContractBoard($this, yield* (yield* $this.tmh_1.jle(current.fmi_1, $completion)).m1q($completion), $completion);
      else {
        if (!(current instanceof Cards)) {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  return Unit_instance;
}
function *showCards($this, currentContent, itemElements, $completion) {
  var tmp;
  switch (currentContent.imi_1.w1_1) {
    case 0:
      tmp = getDraftActionCardDeck($this.cmi_1.bdy_1);
      break;
    case 1:
      tmp = getHunterItemCardDeck($this.cmi_1.bdy_1);
      break;
    case 2:
      tmp = getBeastTalentCardDeck($this.cmi_1.bdy_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var cards = tmp;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap.m7();
  var _iterator__ex2g4s = cards.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var key = getKClassFromExpression(element);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.w4(key);
    var tmp_0;
    if (value == null) {
      var answer = ArrayList.p2();
      destination.b5(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var list = tmp_0;
    list.d2(element);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(destination.s2());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = destination.i3().p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var tmp$ret$8 = to(first(item.k3()), item.k3().s2());
    destination_0.d2(tmp$ret$8);
  }
  var preparedItems = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.n2(collectionSizeOrDefault(preparedItems, 10));
  var _iterator__ex2g4s_1 = preparedItems.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var item_0 = _iterator__ex2g4s_1.r1();
    var tmp$ret$11 = to(yield* $this.tmh_1.mle(item_0.pm_1, $completion), item_0.qm_1);
    destination_1.d2(tmp$ret$11);
  }
  var bitmapDeferredList = destination_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.n2(collectionSizeOrDefault(bitmapDeferredList, 10));
  var _iterator__ex2g4s_2 = bitmapDeferredList.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var item_1 = _iterator__ex2g4s_2.r1();
    var tmp$ret$14 = item_1.pm_1;
    destination_2.d2(tmp$ret$14);
  }
  yield* awaitAll(destination_2, $completion);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList.n2(collectionSizeOrDefault(bitmapDeferredList, 10));
  var _iterator__ex2g4s_3 = bitmapDeferredList.p1();
  while (_iterator__ex2g4s_3.q1()) {
    var item_2 = _iterator__ex2g4s_3.r1();
    var tmp$ret$17 = to(yield* item_2.pm_1.m1q($completion), item_2.qm_1);
    destination_3.d2(tmp$ret$17);
  }
  var bitmapsAndNumbers = destination_3;
  var tmp_1 = $this;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList.n2(collectionSizeOrDefault(bitmapsAndNumbers, 10));
  var _iterator__ex2g4s_4 = bitmapsAndNumbers.p1();
  while (_iterator__ex2g4s_4.q1()) {
    var item_3 = _iterator__ex2g4s_4.r1();
    var tmp$ret$20 = item_3.pm_1;
    destination_4.d2(tmp$ret$20);
  }
  tmp_1.ami_1 = destination_4;
  var tmp_2;
  switch (currentContent.imi_1.w1_1) {
    case 0:
      tmp_2 = $this.cmi_1.bdy_1 ? 7 : 6;
      break;
    case 1:
      tmp_2 = $this.cmi_1.bdy_1 ? 8 : 5;
      break;
    case 2:
      tmp_2 = $this.cmi_1.bdy_1 ? 7 : 5;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var cardsInRow = tmp_2;
  var zoom = cardsInRow < 7 ? 1.0 : cardsInRow === 7 ? 0.9 : 0.8;
  var rows = chunked(bitmapsAndNumbers, cardsInRow);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList.n2(collectionSizeOrDefault(rows, 10));
  var _iterator__ex2g4s_5 = rows.p1();
  while (_iterator__ex2g4s_5.q1()) {
    var item_4 = _iterator__ex2g4s_5.r1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_6 = ArrayList.n2(collectionSizeOrDefault(item_4, 10));
    var _iterator__ex2g4s_6 = item_4.p1();
    while (_iterator__ex2g4s_6.q1()) {
      var item_5 = _iterator__ex2g4s_6.r1();
      var bitmap = item_5.jm();
      var number = item_5.km();
      var image = Image.lk7(bitmap);
      var tmp_3;
      if (number > 1) {
        toHeight(image, get_gameLayout().ol5_1 * zoom);
        var c = Container.fi2();
        var s = image.pig() / 4;
        addTo(image, c);
        xy(addTo(BorderedText('' + number + 'X', s), c), s / 4, s / 6);
        tmp_3 = c;
      } else {
        tmp_3 = image;
      }
      var view = tmp_3;
      var tmp$ret$26 = CardUi.ilo(view, VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$showCards$slambda($this, bitmap));
      destination_6.d2(tmp$ret$26);
    }
    destination_5.d2(destination_6);
  }
  var images = destination_5;
  var cardsPanel = cardViewsByRows(zoom, images);
  var dialogLayout = new BigRightSided(shiftForCards(zoom));
  reinstallContentReferenceDialog($this, cardsPanel.xlb_1, dialogLayout, itemElements);
  return Unit_instance;
}
function *createHuntersInfoView($this, currentHunter, $completion) {
  var abilityCards = toList_0(currentHunter.s36());
  var boardDeferred = yield* $this.tmh_1.tle(currentHunter, null, $completion);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(abilityCards, 10));
  var _iterator__ex2g4s = abilityCards.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = yield* $this.tmh_1.mle(item, $completion);
    destination.d2(tmp$ret$2);
  }
  var bitmapDeferredList = destination;
  var bitmaps = yield* awaitAll(bitmapDeferredList, $completion);
  $this.ami_1 = bitmaps;
  var zoom = 1.0;
  var tmp = listOf_0(listOf([bitmaps.u2(0), bitmaps.u2(1), bitmaps.u2(2)]));
  var cardsPanel = cardPicturesByRows(zoom, tmp, ContentReferenceDialogState$showFullCard$ref($this));
  var boardBitmap = yield* boardDeferred.m1q($completion);
  var hunterImage = toWidth(CardUi.tm1(boardBitmap, 10.0, VOID, VOID, VOID, ContentReferenceDialogState$createHuntersInfoView$slambda($this, boardBitmap)), get_gameLayout().el6_1 * 0.6);
  var controlPanelY = new ControlPanelY();
  addTo_0(cardsPanel.xlb_1, controlPanelY);
  addTo_0(hunterImage, controlPanelY);
  controlPanelY.flr();
  return controlPanelY.xlb_1;
}
function *showFullCard_0($this, bitmap, $completion) {
  var index = $this.ami_1.y2(bitmap);
  if (index >= 0) {
    yield* showCardFromList($this, $this.ami_1, index, VOID, $completion);
  } else {
    yield* showCardFromList($this, listOf_0(bitmap), 0, VOID, $completion);
  }
  return Unit_instance;
}
function *showCardFromList($this, bitmaps, index, reuseDialog, $completion) {
  reuseDialog = reuseDialog === VOID ? false : reuseDialog;
  var bitmap = bitmaps.u2(index);
  var card = toHeight(Image.lk7(bitmap), get_gameLayout().fl6_1 * 0.8);
  var buttonSize = get_gameLayout().tl5_1 * 2.25;
  var sideSpace = buttonSize * 1.5;
  var maxWidth = get_gameLayout().el6_1 * get_gameLayout().pl5_1 - sideSpace * 2;
  if (card.pig() > maxWidth) {
    toWidth(card, maxWidth);
  }
  var panel = Container.fi2();
  var tmp2 = card.pig() + sideSpace * 2;
  // Inline function 'kotlin.comparisons.maxOf' call
  var a = card.rig();
  var tmp4 = Math.max(a, buttonSize);
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().ec3_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.mkf(Size2D.y9p(tmp2, tmp4), color);
  // Inline function 'kotlin.apply' call
  addTo(this_0, panel);
  xy(addTo(card, panel), sideSpace, 0.0);
  if (index > 0) {
    xy(addTo(createCardNavigationArrow($this, false, buttonSize, ContentReferenceDialogState$showCardFromList$slambda($this, bitmaps, index)), panel), 0.0, (card.rig() - buttonSize) / 2);
  }
  if (index < get_lastIndex(bitmaps)) {
    xy(addTo(createCardNavigationArrow($this, true, buttonSize, ContentReferenceDialogState$showCardFromList$slambda_0($this, bitmaps, index)), panel), panel.w9z() - buttonSize, (card.rig() - buttonSize) / 2);
  }
  yield* showEnlargedView($this, panel, reuseDialog, $completion);
  var tmp = $this;
  var tmp0_safe_receiver = getOrNull(referenceCards(new ContentReferenceRoute($this.vmh_1, _get_selectedGameContentVersion__ag1vtr($this))), index);
  tmp.bmi_1 = tmp0_safe_receiver == null ? null : get_referenceSelection(tmp0_safe_receiver);
  notifyRouteChanged($this);
  return Unit_instance;
}
function createCardNavigationArrow($this, forward, size, onClick) {
  // Inline function 'kotlin.apply' call
  var this_0 = Container.fi2();
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().ec3_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = SolidRect.mkf(Size2D.y9p(size, size), color);
  // Inline function 'kotlin.apply' call
  addTo(this_1, this_0);
  var tipX = size * (forward ? 0.7 : 0.3);
  var thickness = size * 0.1;
  var angles = forward ? listOf([135, 225]) : listOf([-45, 45]);
  // Inline function 'kotlin.collections.mutableListOf' call
  var strokes = ArrayList.p2();
  var _iterator__ex2g4s = angles.p1();
  while (_iterator__ex2g4s.q1()) {
    var angle = _iterator__ex2g4s.r1();
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Container.fi2(false);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, this_0);
    var tmp2 = Size2D.y9p(size * 0.5 + thickness, thickness);
    Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var corner = thickness / 2;
    var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    // Inline function 'korlibs.korge.view.roundRect' call
    var fill = new RGBA(Colors_getInstance().vc5_1);
    var stroke = new RGBA(Colors_getInstance().zc2_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = RoundRect.rka(tmp2, tmp4, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, this_3);
    // Inline function 'kotlin.also' call
    var this_6 = xy(this_5, -thickness / 2, -thickness / 2);
    // Inline function 'kotlin.collections.plusAssign' call
    strokes.d2(this_6);
    this_3.eig(get_degrees(angle));
    xy(this_3, tipX, size * 0.5);
  }
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  var $this$mouse = get_mouse(this_0);
  // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
  var handler = ContentReferenceDialogState$createCardNavigationArrow$slambda(strokes);
  var tmp = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_0 = getPropertyCallableRef('over', 1, tmp, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
  tmp_0.v9y(ContentReferenceDialogState$createCardNavigationArrow$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
  var handler_0 = ContentReferenceDialogState$createCardNavigationArrow$slambda_0(strokes);
  var tmp_1 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_2 = getPropertyCallableRef('out', 1, tmp_1, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
  tmp_2.v9y(ContentReferenceDialogState$createCardNavigationArrow$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
  var handler_1 = ContentReferenceDialogState$createCardNavigationArrow$slambda_1(onClick);
  var tmp_3 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_4 = getPropertyCallableRef('click', 1, tmp_3, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
  tmp_4.v9y(ContentReferenceDialogState$createCardNavigationArrow$lambda_1($this$mouse, handler_1));
  return this_0;
}
function *showHunterBoard($this, bitmap, $completion) {
  var board = toWidth(Image.lk7(bitmap), get_gameLayout().el6_1 * get_gameLayout().pl5_1 * 0.9);
  var maxHeight = get_gameLayout().fl6_1 * get_gameLayout().pl5_1 * 0.9;
  if (board.rig() > maxHeight) {
    toHeight(board, maxHeight);
  }
  yield* showEnlargedView($this, board, VOID, $completion);
  $this.bmi_1 = 'board';
  notifyRouteChanged($this);
  return Unit_instance;
}
function *showBeastBoard($this, beast, bitmap, reborn, $completion) {
  reborn = reborn === VOID ? false : reborn;
  yield* showScrollableBoard($this, bitmap, topCharacterBoardScrollingY(beast), $completion);
  $this.bmi_1 = reborn ? 'board-reborn' : 'board';
  notifyRouteChanged($this);
  return Unit_instance;
}
function *showContractBoard($this, bitmap, $completion) {
  yield* showScrollableBoard($this, bitmap, 0, $completion);
  $this.bmi_1 = 'contract';
  notifyRouteChanged($this);
  return Unit_instance;
}
function *showScrollableBoard($this, bitmap, initialTopY, $completion) {
  var viewport = VerticalScrollViewport.amg();
  addTo(Image.lk7(bitmap), viewport.xmf_1);
  toWidth(viewport.xmf_1, get_gameLayout().el6_1 * 0.6);
  var tmp0 = viewport.xmf_1.rig();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_gameLayout().fl6_1 * get_gameLayout().pl5_1;
  var viewportHeight = Math.min(tmp0, b);
  var tmp;
  if (viewport.xmf_1.rig() > viewportHeight) {
    tmp = coerceIn(get_gameLayout().fl6_1 * (1 - get_gameLayout().pl5_1) / viewportHeight, 0.001, 0.5);
  } else {
    tmp = null;
  }
  var edgeFadeRatio = tmp;
  var tmp_0;
  if (initialTopY == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = initialTopY * viewport.xmf_1.zif();
  }
  viewport.hmg(viewportHeight, edgeFadeRatio, tmp_0);
  yield* showEnlargedView($this, viewport, VOID, $completion);
  return Unit_instance;
}
function *showEnlargedView($this, view, reuseDialog, $completion) {
  reuseDialog = reuseDialog === VOID ? false : reuseDialog;
  var dialog = {_v: null};
  var tmp = yield* (yield* $this.tmh_1.tld(InterfaceIcon_Cancel_getInstance(), $completion)).m1q($completion);
  var cancelIcon = DialogCancelIcon.dlx(tmp, VOID, ContentReferenceDialogState$showEnlargedView$slambda(dialog));
  var dialogContent = DialogContent.llt(view).jmi(DialogCorner_RIGHT_TOP_getInstance(), cancelIcon);
  var existingDialog = $this.zmh_1;
  var tmp_0;
  if (reuseDialog) {
    tmp_0 = (existingDialog == null ? null : existingDialog.kmi()) === true;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    dialog._v = existingDialog;
    var tmp_1;
    if (dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp_1 = dialog._v;
    }
    tmp_1.pmh(dialogContent);
    return Unit_instance;
  }
  if (existingDialog == null)
    null;
  else {
    existingDialog.qlq();
  }
  dialog._v = GameDialog.mlt($this.rmh_1, dialogContent, ContentReferenceDialogState$showEnlargedView$slambda_0($this));
  var tmp_2 = $this;
  var tmp_3;
  if (dialog._v == null) {
    throwUninitializedPropertyAccessException('dialog');
  } else {
    tmp_3 = dialog._v;
  }
  tmp_2.zmh_1 = tmp_3;
  var tmp_4;
  if (dialog._v == null) {
    throwUninitializedPropertyAccessException('dialog');
  } else {
    tmp_4 = dialog._v;
  }
  yield* tmp_4.vma($completion);
  return Unit_instance;
}
function reinstallContentReferenceDialog($this, mainContent, dialogLayout, itemElements) {
  dialogLayout = dialogLayout === VOID ? BigCenter_instance : dialogLayout;
  itemElements = itemElements === VOID ? emptyList() : itemElements;
  var itemsPanel = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var _iterator__ex2g4s = itemElements.p1();
  while (_iterator__ex2g4s.q1()) {
    var view = _iterator__ex2g4s.r1();
    addTo_0(view, itemsPanel);
  }
  var dialogContent = DialogContent.cmg(mainContent, itemsPanel.xlb_1, dialogLayout);
  if (!($this.umh_1 == null)) {
    addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$reinstallContentReferenceDialog$slambda($this)), itemsPanel);
  }
  $this.smh_1.pmh(dialogContent);
}
function switchButtons($this) {
  var tmp = $this.cmi_1;
  var tmp_0 = createContentVersionActionButton(tmp, ContentReferenceDialogState$switchButtons$lambda($this));
  var tmp_1 = ActionButton.vlb('Action Cards', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$switchButtons$slambda($this));
  var tmp_2 = ActionButton.vlb('Hunter Items', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$switchButtons$slambda_0($this));
  var tmp_3 = ActionButton.vlb('Beastly Talents', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$switchButtons$slambda_1($this));
  var topLevelButtons = listOf([tmp_0, tmp_1, tmp_2, tmp_3, ActionButton.vlb('Contracts', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$switchButtons$slambda_2($this))]);
  return plus(topLevelButtons, characterButtons($this));
}
function characterButtons($this) {
  var beasts = availableBeasts(_get_selectedGameContentVersion__ag1vtr($this));
  var hunters = availableHunters(_get_selectedGameContentVersion__ag1vtr($this));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(beasts, 10));
  var _iterator__ex2g4s = beasts.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp = toString(item);
    var tmp$ret$2 = ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$characterButtons$slambda($this, item));
    destination.d2(tmp$ret$2);
  }
  var beastButtons = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(hunters, 10));
  var _iterator__ex2g4s_0 = hunters.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item_0 = _iterator__ex2g4s_0.r1();
    var tmp_0 = toString(item_0);
    var tmp$ret$5 = ActionButton.vlb(tmp_0, VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$characterButtons$slambda_0($this, item_0));
    destination_0.d2(tmp$ret$5);
  }
  var hunterButtons = destination_0;
  var tmp0_safe_receiver = firstOrNull(beasts);
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = ActionButton.vlb('Beasts', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$characterButtons$slambda_1($this, tmp0_safe_receiver));
  }
  var beastsButton = listOfNotNull(tmp_1);
  var tmp1_safe_receiver = firstOrNull(hunters);
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = ActionButton.vlb('Hunters', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$characterButtons$slambda_2($this, tmp1_safe_receiver));
  }
  var huntersButton = listOfNotNull(tmp_2);
  var contracts = availableGameRules($this);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.n2(collectionSizeOrDefault(contracts, 10));
  var _iterator__ex2g4s_1 = contracts.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var item_1 = _iterator__ex2g4s_1.r1();
    var tmp_3 = get_gameI18n().d71(item_1);
    var tmp$ret$12 = ActionButton.vlb(tmp_3, VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$characterButtons$slambda_3($this, item_1));
    destination_1.d2(tmp$ret$12);
  }
  var contractButtons = destination_1;
  var tmp2_safe_receiver = firstOrNull(contracts);
  var tmp_4;
  if (tmp2_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = ActionButton.vlb('Contracts', VOID, VOID, VOID, VOID, VOID, ContentReferenceDialogState$characterButtons$slambda_4($this, tmp2_safe_receiver));
  }
  var contractsButton = listOfNotNull(tmp_4);
  var tmp3_subject = $this.vmh_1;
  var tmp_5;
  if (tmp3_subject instanceof Beast) {
    tmp_5 = plus(plus(huntersButton, contractsButton), beastButtons);
  } else {
    if (tmp3_subject instanceof Hunter) {
      tmp_5 = plus(plus(beastsButton, contractsButton), hunterButtons);
    } else {
      if (tmp3_subject instanceof Cards) {
        tmp_5 = plus(plus(beastsButton, huntersButton), contractsButton);
      } else {
        if (tmp3_subject instanceof Contract) {
          tmp_5 = plus(plus(beastsButton, huntersButton), contractButtons);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  return tmp_5;
}
function availableGameRules($this) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_gameConfiguration().tlc_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (get_gameContentVersion(element).i4g(_get_selectedGameContentVersion__ag1vtr($this))) {
      destination.d2(element);
    }
  }
  return destination;
}
function normalizedContent($this, content) {
  var beasts = availableBeasts(_get_selectedGameContentVersion__ag1vtr($this));
  var hunters = availableHunters(_get_selectedGameContentVersion__ag1vtr($this));
  var tmp;
  if (content instanceof Beast) {
    tmp = beasts.w2(content.hmi_1) ? content : new Beast(first(beasts));
  } else {
    if (content instanceof Hunter) {
      tmp = hunters.w2(content.gmi_1) ? content : new Hunter(first(hunters));
    } else {
      if (content instanceof Contract) {
        var tmp_0;
        if (availableGameRules($this).w2(content.fmi_1)) {
          tmp_0 = content;
        } else {
          var tmp1_safe_receiver = firstOrNull(availableGameRules($this));
          var tmp_1;
          if (tmp1_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_1 = new Contract(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          tmp_0 = tmp2_elvis_lhs == null ? new Beast(Bolgin_getInstance()) : tmp2_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        tmp = content;
      }
    }
  }
  return tmp;
}
function showBeast($this, beast) {
  $this.vmh_1 = new Beast(beast);
  $this.lmi();
}
function showHunter($this, hunter) {
  $this.vmh_1 = new Hunter(hunter);
  $this.lmi();
}
function showCards_0($this, kind) {
  $this.vmh_1 = new Cards(kind);
  $this.lmi();
}
function showContract($this, gameRules) {
  $this.vmh_1 = new Contract(gameRules);
  $this.lmi();
}
function showVersionSelection($this) {
  var tmp = $this;
  var tmp_0 = $this.cmi_1;
  var tmp_1 = get_gameConfiguration().dlc_1;
  tmp.ymh_1 = showContentVersionSelectionDialog($this.rmh_1, tmp_0, tmp_1, ContentReferenceDialogState$showVersionSelection$lambda($this));
}
function ContentReferenceDialogState$lambda(this$0) {
  return (it) => {
    var tmp0_safe_receiver = this$0.zmh_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    return Unit_instance;
  };
}
function ContentReferenceDialogState$lambda_0(this$0) {
  return (it) => {
    var tmp0_safe_receiver = this$0.ymh_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    return Unit_instance;
  };
}
function ContentReferenceDialogState$requestShowContent$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* /*#__NOINLINE__*/showContent(this$0, $completion);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$showFullCard$ref(p0) {
  return constructCallableReference(function *(p0_0, $completion) {
    var tmp0 = p0;
    return yield* /*#__NOINLINE__*/showFullCard_0(tmp0, p0_0, $completion);
  }, 1, 1, 562, 'showFullCard', [p0]);
}
function ContentReferenceDialogState$showContent$slambda(this$0, $currentContent) {
  return constructCallableReference(function *(bitmap, reborn, $completion) {
    yield* /*#__NOINLINE__*/showBeastBoard(this$0, $currentContent.hmi_1, bitmap, reborn, $completion);
    return Unit_instance;
  }, 2);
}
function ContentReferenceDialogState$showContractBoard$ref(p0) {
  return constructCallableReference(function *(p0_0, $completion) {
    var tmp0 = p0;
    return yield* /*#__NOINLINE__*/showContractBoard(tmp0, p0_0, $completion);
  }, 1, 1, 563, 'showContractBoard', [p0]);
}
function ContentReferenceDialogState$showCards$slambda(this$0, $bitmap) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showFullCard_0(this$0, $bitmap, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$createHuntersInfoView$slambda(this$0, $boardBitmap) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showHunterBoard(this$0, $boardBitmap, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$showCardFromList$slambda(this$0, $bitmaps, $index) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showCardFromList(this$0, $bitmaps, $index - 1 | 0, true, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$showCardFromList$slambda_0(this$0, $bitmaps, $index) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showCardFromList(this$0, $bitmaps, $index + 1 | 0, true, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$createCardNavigationArrow$slambda($strokes) {
  return constructCallableReference(function *(it, $completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $strokes.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.cjq(new RGBA(Colors_getInstance().bc3_1));
    }
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$createCardNavigationArrow$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$createCardNavigationArrow$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, ContentReferenceDialogState$createCardNavigationArrow$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function ContentReferenceDialogState$createCardNavigationArrow$slambda_0($strokes) {
  return constructCallableReference(function *(it, $completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $strokes.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.cjq(new RGBA(Colors_getInstance().vc5_1));
    }
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$createCardNavigationArrow$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$createCardNavigationArrow$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, ContentReferenceDialogState$createCardNavigationArrow$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function ContentReferenceDialogState$createCardNavigationArrow$slambda_1($onClick) {
  return constructCallableReference(function *(it, $completion) {
    if (it.xhy().equals(MouseButton_LEFT_getInstance()))
      yield* $onClick($completion);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$createCardNavigationArrow$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$createCardNavigationArrow$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, ContentReferenceDialogState$createCardNavigationArrow$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function ContentReferenceDialogState$showEnlargedView$slambda($dialog) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if ($dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp = $dialog._v;
    }
    var tmp_0 = tmp.hlq_1;
    var tmp_1;
    if ($dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp_1 = $dialog._v;
    }
    yield* tmp_0(tmp_1, $completion);
    return Unit_instance;
  }, 0);
}
function ContentReferenceDialogState$showEnlargedView$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    it.qlq();
    this$0.bmi_1 = null;
    notifyRouteChanged(this$0);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$reinstallContentReferenceDialog$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp0_safe_receiver = this$0.zmh_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    yield* this$0.umh_1(this$0.smh_1, $completion);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$switchButtons$lambda(this$0) {
  return () => {
    showVersionSelection(this$0);
    return Unit_instance;
  };
}
function ContentReferenceDialogState$switchButtons$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showCards_0(this$0, ContentReferenceDialogCardsKind_DraftAction_getInstance());
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$switchButtons$slambda_0(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showCards_0(this$0, ContentReferenceDialogCardsKind_HunterItems_getInstance());
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$switchButtons$slambda_1(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showCards_0(this$0, ContentReferenceDialogCardsKind_BeastlyTalents_getInstance());
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$switchButtons$slambda_2(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp0_safe_receiver = firstOrNull(availableGameRules(this$0));
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      showContract(this$0, tmp0_safe_receiver);
    }
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$characterButtons$slambda(this$0, $character) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showBeast(this$0, $character);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$characterButtons$slambda_0(this$0, $character) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showHunter(this$0, $character);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$characterButtons$slambda_1(this$0, $firstBeast) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showBeast(this$0, $firstBeast);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$characterButtons$slambda_2(this$0, $firstHunter) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showHunter(this$0, $firstHunter);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$characterButtons$slambda_3(this$0, $contract) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showContract(this$0, $contract);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$characterButtons$slambda_4(this$0, $firstContract) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    showContract(this$0, $firstContract);
    return Unit_instance;
  }, 1);
}
function ContentReferenceDialogState$showVersionSelection$lambda(this$0) {
  return (newState) => {
    this$0.ymh_1 = null;
    var tmp;
    if (!get_isActive(this$0.qmh_1)) {
      return Unit_instance;
    }
    this$0.cmi_1 = newState;
    this$0.vmh_1 = normalizedContent(this$0, this$0.vmh_1);
    this$0.lmi();
    return Unit_instance;
  };
}
function createContentVersionSelectionView(initialState, allowedExpansions, onStateChangedExternal, onDone) {
  onDone = onDone === VOID ? null : onDone;
  var controlPanelY = new ControlPanelY();
  var state = {_v: initialState};
  createContentVersionSelectionView$updatePanel(controlPanelY, allowedExpansions, state, onDone, onStateChangedExternal);
  return controlPanelY.xlb_1;
}
function createContentVersionActionButton(state, onClick) {
  var tmp = 'Version: ' + state.hdy();
  return ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, createContentVersionActionButton$slambda(onClick));
}
function showContentVersionSelectionDialog$applyState(currentState, newState) {
  currentState._v = newState;
}
function showContentVersionSelectionDialog$applyState$ref($currentState) {
  return constructCallableReference((p0) => {
    showContentVersionSelectionDialog$applyState($currentState, p0);
    return Unit_instance;
  }, 1, 0, 564, 'applyState', [$currentState]);
}
function showContentVersionSelectionDialog$lambda($gameDialog, $onClose, $currentState) {
  return () => {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    tmp.qlq();
    $onClose($currentState._v);
    return Unit_instance;
  };
}
function createContentVersionSelectionView$updatePanel$toggleRow$slambda($action, $controlPanelY, $allowedExpansions, $state, $onDone, $onStateChangedExternal) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $action();
    createContentVersionSelectionView$updatePanel($controlPanelY, $allowedExpansions, $state, $onDone, $onStateChangedExternal);
    return Unit_instance;
  }, 1);
}
function createContentVersionSelectionView$updatePanel$toggleRow(actions, controlPanelY, $allowedExpansions, state, $onDone, $onStateChangedExternal, text, isEnabled, action) {
  var tmp = (isEnabled ? '[x]' : '[ ]') + ' ' + text;
  addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, createContentVersionSelectionView$updatePanel$toggleRow$slambda(action, controlPanelY, $allowedExpansions, state, $onDone, $onStateChangedExternal)), actions);
}
function createContentVersionSelectionView$updatePanel$lambda($state, $onStateChangedExternal) {
  return () => {
    createContentVersionSelectionView$onStateChanged($state, $onStateChangedExternal, $state._v.kdy(!$state._v.bdy_1));
    return Unit_instance;
  };
}
function createContentVersionSelectionView$updatePanel$lambda_0($state, $onStateChangedExternal) {
  return () => {
    createContentVersionSelectionView$onStateChanged($state, $onStateChangedExternal, $state._v.kdy(VOID, !$state._v.cdy_1));
    return Unit_instance;
  };
}
function createContentVersionSelectionView$updatePanel$lambda_1($state, $onStateChangedExternal) {
  return () => {
    createContentVersionSelectionView$onStateChanged($state, $onStateChangedExternal, $state._v.kdy(VOID, VOID, !$state._v.ddy_1));
    return Unit_instance;
  };
}
function createContentVersionSelectionView$updatePanel$slambda($it) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $it();
    return Unit_instance;
  }, 1);
}
function createContentVersionSelectionView$onStateChanged(state, $onStateChangedExternal, newState) {
  state._v = newState;
  $onStateChangedExternal(newState);
}
function createContentVersionSelectionView$updatePanel(controlPanelY, $allowedExpansions, state, $onDone, $onStateChangedExternal) {
  controlPanelY.dlr_1 = 0.0;
  controlPanelY.xlb_1.tie();
  addTo_0(BorderedText('Content Versions', get_gameLayout().vl5_1), controlPanelY);
  var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  if ($allowedExpansions.w2(BeastGameExpansions_ShatteredIsles_getInstance())) {
    var tmp = state._v.bdy_1;
    createContentVersionSelectionView$updatePanel$toggleRow(actions, controlPanelY, $allowedExpansions, state, $onDone, $onStateChangedExternal, 'Shattered Isles', tmp, createContentVersionSelectionView$updatePanel$lambda(state, $onStateChangedExternal));
  }
  if ($allowedExpansions.w2(BeastGameExpansions_TheGreatHunt_getInstance())) {
    var tmp_0 = state._v.cdy_1;
    createContentVersionSelectionView$updatePanel$toggleRow(actions, controlPanelY, $allowedExpansions, state, $onDone, $onStateChangedExternal, 'The Great Hunt', tmp_0, createContentVersionSelectionView$updatePanel$lambda_0(state, $onStateChangedExternal));
  }
  if ($allowedExpansions.w2(BeastGameExpansions_Ashfall_getInstance())) {
    var tmp_1 = state._v.ddy_1;
    createContentVersionSelectionView$updatePanel$toggleRow(actions, controlPanelY, $allowedExpansions, state, $onDone, $onStateChangedExternal, 'Ashfall', tmp_1, createContentVersionSelectionView$updatePanel$lambda_1(state, $onStateChangedExternal));
  }
  if ($onDone == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    addTo_0(ActionButton.vlb('Done', VOID, VOID, VOID, VOID, VOID, createContentVersionSelectionView$updatePanel$slambda($onDone)), actions);
  }
  addTo_0(actions.xlb_1, controlPanelY);
  controlPanelY.flr();
}
function createContentVersionActionButton$slambda($onClick) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $onClick();
    return Unit_instance;
  }, 1);
}
function resolveContentReference(params, allowedExpansions, contracts) {
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = params.nmi_1;
  var tmp$ret$0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = split(tmp$ret$0, charArrayOf([_Char___init__impl__6a9atx(46)]));
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(element) > 0) {
      destination.d2(element);
    }
  }
  var requestedExpansions = destination;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = get_entries();
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = tmp0_0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (allowedExpansions.w2(element_0) && requestedExpansions.w2(get_slug(element_0))) {
      destination_0.d2(element_0);
    }
  }
  var expansions = toSet(destination_0);
  var version = GameContentVersion.v3d(expansions);
  var tmp;
  if (startsWith(params.mmi_1, 'beast-')) {
    var tmp0_1 = availableBeasts(version);
    var tmp$ret$8;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_1 = tmp0_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (get_slug_0(element_1) === removePrefix(params.mmi_1, 'beast-')) {
          tmp$ret$8 = element_1;
          break $l$block;
        }
      }
      tmp$ret$8 = null;
    }
    var tmp0_safe_receiver = tmp$ret$8;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new Beast(tmp0_safe_receiver);
    }
    tmp = tmp_0;
  } else if (startsWith(params.mmi_1, 'hunter-')) {
    var tmp0_2 = availableHunters(version);
    var tmp$ret$12;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_2 = tmp0_2.p1();
      while (_iterator__ex2g4s_2.q1()) {
        var element_2 = _iterator__ex2g4s_2.r1();
        if (get_slug_0(element_2) === removePrefix(params.mmi_1, 'hunter-')) {
          tmp$ret$12 = element_2;
          break $l$block_0;
        }
      }
      tmp$ret$12 = null;
    }
    var tmp1_safe_receiver = tmp$ret$12;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = new Hunter(tmp1_safe_receiver);
    }
    tmp = tmp_1;
  } else if (startsWith(params.mmi_1, 'cards-')) {
    var tmp0_3 = get_entries_7();
    var tmp$ret$16;
    $l$block_1: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_3 = tmp0_3.p1();
      while (_iterator__ex2g4s_3.q1()) {
        var element_3 = _iterator__ex2g4s_3.r1();
        if (get_slug_1(element_3) === removePrefix(params.mmi_1, 'cards-')) {
          tmp$ret$16 = element_3;
          break $l$block_1;
        }
      }
      tmp$ret$16 = null;
    }
    var tmp2_safe_receiver = tmp$ret$16;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = new Cards(tmp2_safe_receiver);
    }
    tmp = tmp_2;
  } else if (startsWith(params.mmi_1, 'contract-')) {
    var tmp$ret$20;
    $l$block_2: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_4 = contracts.p1();
      while (_iterator__ex2g4s_4.q1()) {
        var element_4 = _iterator__ex2g4s_4.r1();
        if (get_slug_2(element_4) === removePrefix(params.mmi_1, 'contract-') && get_gameContentVersion(element_4).i4g(version)) {
          tmp$ret$20 = element_4;
          break $l$block_2;
        }
      }
      tmp$ret$20 = null;
    }
    var tmp3_safe_receiver = tmp$ret$20;
    var tmp_3;
    if (tmp3_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = new Contract(tmp3_safe_receiver);
    }
    tmp = tmp_3;
  } else {
    tmp = null;
  }
  var content = tmp;
  var route = new ContentReferenceRoute(content == null ? new Beast(Bolgin_getInstance()) : content, version);
  var tmp5_safe_receiver = params.omi_1;
  var tmp_4;
  if (tmp5_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_5;
    if (!(content == null) && availableSelections(route).w2(tmp5_safe_receiver)) {
      tmp_5 = tmp5_safe_receiver;
    } else {
      tmp_5 = null;
    }
    tmp_4 = tmp_5;
  }
  var tmp_6 = route.pmi(VOID, VOID, tmp_4);
  var tmp_7;
  var tmp_8;
  if (content == null) {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = params.mmi_1;
    tmp_8 = charSequenceLength(this_0) > 0;
  } else {
    tmp_8 = false;
  }
  if (tmp_8) {
    tmp_7 = true;
  } else {
    var tmp$ret$27;
    $l$block_4: {
      // Inline function 'kotlin.collections.any' call
      var tmp_9;
      if (isInterface(requestedExpansions, Collection)) {
        tmp_9 = requestedExpansions.n1();
      } else {
        tmp_9 = false;
      }
      if (tmp_9) {
        tmp$ret$27 = false;
        break $l$block_4;
      }
      var _iterator__ex2g4s_5 = requestedExpansions.p1();
      while (_iterator__ex2g4s_5.q1()) {
        var element_5 = _iterator__ex2g4s_5.r1();
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList.n2(collectionSizeOrDefault(expansions, 10));
        var _iterator__ex2g4s_6 = expansions.p1();
        while (_iterator__ex2g4s_6.q1()) {
          var item = _iterator__ex2g4s_6.r1();
          var tmp$ret$31 = get_slug(item);
          destination_1.d2(tmp$ret$31);
        }
        if (!destination_1.w2(element_5)) {
          tmp$ret$27 = true;
          break $l$block_4;
        }
      }
      tmp$ret$27 = false;
    }
    tmp_7 = tmp$ret$27;
  }
  return new ResolvedContentReference(tmp_6, tmp_7);
}
function ContentReferenceRoute$toUrlParams$lambda(it) {
  return get_slug(it);
}
function get_slug(_this__u8e3s4) {
  return toSlug(_this__u8e3s4.v1_1);
}
function get_slug_0(_this__u8e3s4) {
  return toSlug(ensureNotNull(getKClassFromExpression(_this__u8e3s4).j1()));
}
var ContentReferenceDialogCardsKind_DraftAction_instance;
var ContentReferenceDialogCardsKind_HunterItems_instance;
var ContentReferenceDialogCardsKind_BeastlyTalents_instance;
function values_0() {
  return [ContentReferenceDialogCardsKind_DraftAction_getInstance(), ContentReferenceDialogCardsKind_HunterItems_getInstance(), ContentReferenceDialogCardsKind_BeastlyTalents_getInstance()];
}
function get_entries_7() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var ContentReferenceDialogCardsKind_entriesInitialized;
function ContentReferenceDialogCardsKind_initEntries() {
  if (ContentReferenceDialogCardsKind_entriesInitialized)
    return Unit_instance;
  ContentReferenceDialogCardsKind_entriesInitialized = true;
  ContentReferenceDialogCardsKind_DraftAction_instance = new ContentReferenceDialogCardsKind('DraftAction', 0);
  ContentReferenceDialogCardsKind_HunterItems_instance = new ContentReferenceDialogCardsKind('HunterItems', 1);
  ContentReferenceDialogCardsKind_BeastlyTalents_instance = new ContentReferenceDialogCardsKind('BeastlyTalents', 2);
}
var $ENTRIES_0;
function get_slug_1(_this__u8e3s4) {
  return toSlug(_this__u8e3s4.v1_1);
}
function get_slug_2(_this__u8e3s4) {
  return toSlug(removeSuffix(ensureNotNull(getKClassFromExpression(_this__u8e3s4).j1()), 'Contract'));
}
function availableSelections(_this__u8e3s4) {
  var current = _this__u8e3s4.tlq_1;
  var tmp;
  if (current instanceof Beast) {
    var tmp_0;
    var tmp_1 = current.hmi_1;
    if (tmp_1 instanceof FeatheredKing) {
      tmp_0 = listOf(['board', 'board-reborn']);
    } else {
      tmp_0 = listOf_0('board');
    }
    tmp = tmp_0;
  } else {
    if (current instanceof Hunter) {
      tmp = listOf_0('board');
    } else {
      if (current instanceof Contract) {
        tmp = listOf_0('contract');
      } else {
        if (current instanceof Cards) {
          tmp = emptyList();
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  var boards = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = referenceCards(_this__u8e3s4);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = get_referenceSelection(item);
    destination.d2(tmp$ret$2);
  }
  return plus(destination, boards);
}
function toSlug(_this__u8e3s4) {
  // Inline function 'kotlin.text.replace' call
  var tmp0 = Regex.hi('([A-Z])([A-Z][a-z])').mi(_this__u8e3s4, '$1-$2');
  // Inline function 'kotlin.text.replace' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return Regex.hi('([a-z0-9])([A-Z])').mi(tmp0, '$1-$2').toLowerCase();
}
function referenceCards(_this__u8e3s4) {
  var current = _this__u8e3s4.tlq_1;
  var tmp;
  if (current instanceof Beast) {
    tmp = toList_0(current.hmi_1.s36());
  } else {
    if (current instanceof Hunter) {
      tmp = toList_0(current.gmi_1.s36());
    } else {
      if (current instanceof Cards) {
        var shatteredIsles = _this__u8e3s4.ulq_1.q3d_1.w2(BeastGameExpansions_ShatteredIsles_getInstance());
        var tmp_0;
        switch (current.imi_1.w1_1) {
          case 0:
            tmp_0 = getDraftActionCardDeck(shatteredIsles);
            break;
          case 1:
            tmp_0 = getHunterItemCardDeck(shatteredIsles);
            break;
          case 2:
            tmp_0 = getBeastTalentCardDeck(shatteredIsles);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'kotlin.collections.distinctBy' call
        var this_0 = tmp_0;
        var set = HashSet.mb();
        var list = ArrayList.p2();
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var e = _iterator__ex2g4s.r1();
          var key = getKClassFromExpression(e);
          if (set.d2(key)) {
            list.d2(e);
          }
        }
        tmp = list;
      } else {
        if (current instanceof Contract) {
          tmp = emptyList();
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  return tmp;
}
function get_referenceSelection(_this__u8e3s4) {
  return 'card-' + toSlug(removeSuffix(ensureNotNull(getKClassFromExpression(_this__u8e3s4).j1()), 'Card'));
}
function ContentReferenceDialogCardsKind_DraftAction_getInstance() {
  ContentReferenceDialogCardsKind_initEntries();
  return ContentReferenceDialogCardsKind_DraftAction_instance;
}
function ContentReferenceDialogCardsKind_HunterItems_getInstance() {
  ContentReferenceDialogCardsKind_initEntries();
  return ContentReferenceDialogCardsKind_HunterItems_instance;
}
function ContentReferenceDialogCardsKind_BeastlyTalents_getInstance() {
  ContentReferenceDialogCardsKind_initEntries();
  return ContentReferenceDialogCardsKind_BeastlyTalents_instance;
}
function *announcePhase(_this__u8e3s4, phase, $completion) {
  if (get_gameConfiguration().olc_1)
    return Unit_instance;
  if (phase instanceof PlayerTurnPhase) {
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.t6h();
    get_gameConfiguration().xlc_1.rmi($this$with, phase.x4g_1);
  }
  if (equals(phase, PreGamePhase_getInstance()) || equals(phase, StartOfDayPhase_getInstance()))
    return Unit_instance;
  // Inline function 'kotlin.with' call
  var $this$with_0 = _this__u8e3s4.t6h();
  var tmp;
  if (phase instanceof PlayerTurnPhase) {
    tmp = get_hand($this$with_0, phase.x4g_1).n1();
  } else {
    tmp = false;
  }
  if (tmp) {
    return Unit_instance;
  }
  // Inline function 'kotlin.with' call
  var $this$with_1 = _this__u8e3s4.t6h();
  var tmp0_elvis_lhs = get_gameI18n().z70($this$with_1, phase);
  var string = tmp0_elvis_lhs == null ? ensureNotNull(getKClassFromExpression(phase).j1()) : tmp0_elvis_lhs;
  yield* animateNotification(_this__u8e3s4, string, $completion);
  return Unit_instance;
}
function *animateChangesBeforeWholeUpdate(_this__u8e3s4, stateChanges, notification, $completion) {
  if (get_gameConfiguration().olc_1)
    return Unit_instance;
  yield* filterAndAnimateGrudgesChanges(_this__u8e3s4, stateChanges, animateChangesBeforeWholeUpdate$lambda, $completion);
  yield* filterAndAnimateAncientPowersChanges(_this__u8e3s4, stateChanges, animateChangesBeforeWholeUpdate$lambda_0, $completion);
  yield* filterAndAnimateValdiBloodChanges(_this__u8e3s4, stateChanges, animateChangesBeforeWholeUpdate$lambda_1, $completion);
  yield* filterAndAnimateDraugCorruptionChanges(_this__u8e3s4, stateChanges, animateChangesBeforeWholeUpdate$lambda_2, $completion);
  yield* filterAndAnimateLydanHarvestChanges(_this__u8e3s4, stateChanges, animateChangesBeforeWholeUpdate$lambda_3, $completion);
  yield* animateCardsMoveChanges(_this__u8e3s4, stateChanges, notification, $completion);
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var stateChange = _iterator__ex2g4s.r1();
    if (!isInterface(stateChange, TechnicalGameStateChangeEvent)) {
      var tmp;
      var tmp_0;
      if (stateChange instanceof GrudgesChange) {
        tmp_0 = true;
      } else {
        tmp_0 = stateChange instanceof ValdiBloodChangeEvent;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        var tmp_1;
        if (stateChange instanceof DraugCorruptionChangeEvent) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (stateChange instanceof LydanHarvestChangeEvent) {
            tmp_2 = true;
          } else {
            tmp_2 = stateChange instanceof CardsMoveChange;
          }
          tmp_1 = tmp_2;
        }
        tmp = tmp_1;
      }
      if (!tmp) {
        if (stateChange instanceof RuinClaimedChangeEvent)
          yield* animateRuinClaimedChange(_this__u8e3s4, stateChange, $completion);
        else {
          if (stateChange instanceof UpgradeChange)
            yield* animateUpgradeChange(_this__u8e3s4, stateChange, $completion);
          else {
            if (stateChange instanceof MovementChange)
              yield* animateMovement(_this__u8e3s4, stateChange, $completion);
            else {
              if (stateChange instanceof AddObjectChange)
                yield* animateAddObjectChange(_this__u8e3s4, stateChange, $completion);
              else {
                if (stateChange instanceof BeastMovementInfoChange)
                  yield* animateBeastMovementInfoChange(_this__u8e3s4, stateChange, $completion);
                else {
                  if (stateChange instanceof RevealLastMovementsChange)
                    yield* animateRevealLastMovementsChange(_this__u8e3s4, stateChange, $completion);
                  else {
                    if (stateChange instanceof TransformLocationsChange)
                      yield* animateTransformLocationsChange(_this__u8e3s4, stateChange, $completion);
                    else {
                      if (stateChange instanceof HpChange) {
                        if (stateChange.e4u_1 < 0)
                          yield* animateHpChange(_this__u8e3s4, stateChange, $completion);
                      } else {
                        if (stateChange instanceof ClearingAfterRevealChange)
                          yield* animateBeastMovementRevealChange(_this__u8e3s4, stateChange, $completion);
                        else {
                          if (stateChange instanceof TrailsRevealedChange)
                            yield* animateTrailsRevealed(_this__u8e3s4, stateChange, $completion);
                          else {
                            if (stateChange instanceof DestroyedChange) {
                              var d = stateChange.s4u_1;
                              var tmp1_safe_receiver = _this__u8e3s4.gl2_1.fln(d);
                              var centerAndSize = tmp1_safe_receiver == null ? null : get_centerAndSize(tmp1_safe_receiver);
                              if (!(centerAndSize == null)) {
                                // Inline function 'kotlin.collections.set' call
                                _this__u8e3s4.ll3_1.b5(d, centerAndSize);
                              } else {
                                reportWarning(_this__u8e3s4, 'No view for ' + d.toString());
                              }
                            } else {
                              _this__u8e3s4.sln('Not implemented before change ' + toString(stateChange));
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return Unit_instance;
}
function *animateChangesAfterWholeUpdate(_this__u8e3s4, stateChanges, $completion) {
  if (get_gameConfiguration().olc_1)
    return Unit_instance;
  yield* filterAndAnimateGrudgesChanges(_this__u8e3s4, stateChanges, animateChangesAfterWholeUpdate$lambda, $completion);
  yield* filterAndAnimateAncientPowersChanges(_this__u8e3s4, stateChanges, animateChangesAfterWholeUpdate$lambda_0, $completion);
  yield* filterAndAnimateValdiBloodChanges(_this__u8e3s4, stateChanges, animateChangesAfterWholeUpdate$lambda_1, $completion);
  yield* filterAndAnimateDraugCorruptionChanges(_this__u8e3s4, stateChanges, animateChangesAfterWholeUpdate$lambda_2, $completion);
  yield* filterAndAnimateLydanHarvestChanges(_this__u8e3s4, stateChanges, animateChangesAfterWholeUpdate$lambda_3, $completion);
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var stateChange = _iterator__ex2g4s.r1();
    if (!isInterface(stateChange, TechnicalGameStateChangeEvent)) {
      var tmp;
      var tmp_0;
      if (stateChange instanceof UpgradeChange) {
        tmp_0 = true;
      } else {
        tmp_0 = stateChange instanceof MovementChange;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        var tmp_1;
        if (stateChange instanceof BeastMovementInfoChange) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (stateChange instanceof CardsMoveChange) {
            tmp_2 = true;
          } else {
            tmp_2 = stateChange instanceof TransformLocationsChange;
          }
          tmp_1 = tmp_2;
        }
        tmp = tmp_1;
      }
      if (!tmp) {
        var tmp_3;
        var tmp_4;
        if (stateChange instanceof GrudgesChange) {
          tmp_4 = true;
        } else {
          tmp_4 = stateChange instanceof ValdiBloodChangeEvent;
        }
        if (tmp_4) {
          tmp_3 = true;
        } else {
          var tmp_5;
          if (stateChange instanceof DraugCorruptionChangeEvent) {
            tmp_5 = true;
          } else {
            tmp_5 = stateChange instanceof LydanHarvestChangeEvent;
          }
          tmp_3 = tmp_5;
        }
        if (!tmp_3) {
          if (stateChange instanceof HpChange) {
            if (stateChange.e4u_1 > 0)
              yield* animateHpChange(_this__u8e3s4, stateChange, $completion);
          } else {
            if (stateChange instanceof DestroyedChange)
              yield* animateDestroyChange(_this__u8e3s4, stateChange, $completion);
            else {
              if (stateChange instanceof ClearingAfterRevealChange)
                yield* animateClearingAfterRevealChange(_this__u8e3s4, stateChange, $completion);
              else {
                _this__u8e3s4.sln('Not implemented after change ' + toString(stateChange));
              }
            }
          }
        }
      }
    }
  }
  return Unit_instance;
}
function *animateOfflineReplayEndOfGame(_this__u8e3s4, winnerTeam, $completion) {
  var shadowingCornersImage_0 = shadowingCornersImage(winnerTeam === get_beastsGameTeam() ? Colors_getInstance().lc4_1 : Colors_getInstance().yc3_1);
  shadowingCornersImage_0.sig(0.0);
  yield* animateNotification(_this__u8e3s4, get_gameI18n().b71(winnerTeam), $completion);
  _this__u8e3s4.ml2_1.uie(shadowingCornersImage_0);
  var tmp0 = _this__u8e3s4.ml2_1;
  var tmp2 = get_gameLayout().el6_1;
  var tmp4 = get_gameLayout().fl6_1;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = get_gameColors().qlx_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.mkf(Size2D.l9i(tmp2, tmp4), color);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, tmp0);
  // Inline function 'kotlin.also' call
  this_1.sig(0.0);
  var r = this_1;
  yield* coroutineScope(animateOfflineReplayEndOfGame$slambda(_this__u8e3s4, shadowingCornersImage_0, r), $completion);
  return Unit_instance;
}
function *animateNotification(_this__u8e3s4, string, $completion) {
  if (_this__u8e3s4.fl4_1 === string && equals(_this__u8e3s4.gl4_1, _this__u8e3s4.t6h().c38_1)) {
    return Unit_instance;
  }
  _this__u8e3s4.fl4_1 = string;
  _this__u8e3s4.gl4_1 = _this__u8e3s4.t6h().c38_1;
  var view = notificationElement(string);
  // Inline function 'korlibs.korge.view.container' call
  var this_0 = _this__u8e3s4.ml2_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Container.fi2(false);
  // Inline function 'kotlin.apply' call
  var c = addTo(this_1, this_0);
  var tmp2 = get_gameLayout().gl6_1;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().ec3_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.mkf(tmp2, color);
  // Inline function 'kotlin.apply' call
  addTo(this_2, c);
  var closing = CompletableDeferred_0();
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = animateNotification$lambda(closing);
  var tmp = KProperty1;
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = getPropertyCallableRef('click', 1, tmp, MouseEvents$_get_click_$ref_klwzrm(), null);
  var tmp1_safe_receiver = c == null ? null : c.eif();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.u2(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp_0 = prop.get(tmp1_safe_receiver_0);
        tmp_0.v9y(animateNotification$lambda_0(handler));
      }
    }
  }
  yield* waitWithPossibilityToCancel(closing, animateNotification$slambda(c, view), $completion);
  _this__u8e3s4.ml2_1.cif(c);
  return Unit_instance;
}
function *filterAndAnimateGrudgesChanges(_this__u8e3s4, stateChanges, p, $completion) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof GrudgesChange) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (p(element_0)) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination_0.n1()) {
    tmp = destination_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    yield* animateGrudgesChanges(_this__u8e3s4, tmp0_safe_receiver, $completion);
  }
  return Unit_instance;
}
function *filterAndAnimateAncientPowersChanges(_this__u8e3s4, stateChanges, p, $completion) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof AncientPowersChangeEvent) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (p(element_0)) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination_0.n1()) {
    tmp = destination_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    yield* animateAncientPowersChange(_this__u8e3s4, tmp0_safe_receiver, $completion);
  }
  return Unit_instance;
}
function *filterAndAnimateValdiBloodChanges(_this__u8e3s4, stateChanges, p, $completion) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ValdiBloodChangeEvent) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (p(element_0)) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination_0.n1()) {
    tmp = destination_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    yield* animateValdiBloodChanges(_this__u8e3s4, tmp0_safe_receiver, $completion);
  }
  return Unit_instance;
}
function *filterAndAnimateDraugCorruptionChanges(_this__u8e3s4, stateChanges, p, $completion) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof DraugCorruptionChangeEvent) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (p(element_0)) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination_0.n1()) {
    tmp = destination_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    yield* animateDraugCorruptionChanges(_this__u8e3s4, tmp0_safe_receiver, $completion);
  }
  return Unit_instance;
}
function *filterAndAnimateLydanHarvestChanges(_this__u8e3s4, stateChanges, p, $completion) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof LydanHarvestChangeEvent) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (p(element_0)) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination_0.n1()) {
    tmp = destination_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    yield* animateLydanHarvestChanges(_this__u8e3s4, tmp0_safe_receiver, $completion);
  }
  return Unit_instance;
}
function *animateCardsMoveChanges(_this__u8e3s4, stateChanges, notification, $completion) {
  var tmp = notification.x3p_1;
  if (tmp instanceof DraftResultEvent)
    return Unit_instance;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = stateChanges.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof CardsMoveChange) {
      destination.d2(element);
    }
  }
  var changesToAnimate = destination;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap.m7();
  var _iterator__ex2g4s_0 = changesToAnimate.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var key = element_0.a4v_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.w4(key);
    var tmp_0;
    if (value == null) {
      var answer = ArrayList.p2();
      destination_0.b5(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var list = tmp_0;
    list.d2(element_0);
  }
  var groups = destination_0;
  var _iterator__ex2g4s_1 = groups.y4().p1();
  while (_iterator__ex2g4s_1.q1()) {
    var changes = _iterator__ex2g4s_1.r1();
    yield* animateCardsMoveChangesImpl(_this__u8e3s4, changes, $completion);
  }
  return Unit_instance;
}
function *animateRuinClaimedChange(_this__u8e3s4, stateChange, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  $l$block: {
    var tmp0_elvis_lhs = _this__u8e3s4.gl2_1.fl7_1.jl8(stateChange.d53_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$block;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var area = tmp;
    var tmp1_subject = stateChange.e53_1;
    var tmp_0;
    var tmp_1 = tmp1_subject;
    if (equals(tmp_1 == null ? null : new GameTeam(tmp_1), new GameTeam(get_beastsGameTeam()))) {
      tmp_0 = GeneralTokens_RuinBeast_getInstance();
    } else {
      var tmp_2 = tmp1_subject;
      if (equals(tmp_2 == null ? null : new GameTeam(tmp_2), new GameTeam(get_huntersGameTeam()))) {
        tmp_0 = GeneralTokens_RuinHunter_getInstance();
      } else {
        var tmp_3 = stateChange.e53_1;
        // Inline function 'kotlin.error' call
        var message = 'Unsupported game team ' + toString_0(tmp_3 == null ? null : new GameTeam(tmp_3));
        throw IllegalStateException.o(toString(message));
      }
    }
    var token = tmp_0;
    var ruinBitmap = yield* (yield* _this__u8e3s4.pl6().vle(token, $completion)).m1q($completion);
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(ruinBitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var view = this_0;
    // Inline function 'kotlin.let' call
    var it = get_gameLayout().ol5_1;
    var sizeAtSupply = Size2D.y9p(it * ruinBitmap.sc1_1 / ruinBitmap.tc1_1, it);
    var tmp0 = area.ml8_1;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(area.nl8_1 * 0.84, -area.nl8_1 * 0.5);
    var tmp$ret$8 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    var targetPoint = _this__u8e3s4.gl2_1.hl7_1.oih(tmp$ret$8);
    var neededSize = scaleToHeight(view.s2(), area.nl8_1 * 2).b9q(_this__u8e3s4.smi());
    yield* runAnimations(listOf_0(animationWithSupply(true, sizeAtSupply, targetPoint, neededSize, view, _this__u8e3s4.ml2_1, true)), $completion);
  }
  return Unit_instance;
}
function *animateUpgradeChange(_this__u8e3s4, upgradeChange, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  if (!(get_gameTeam($this$with, upgradeChange.i4x_1) === _this__u8e3s4.k3q())) {
    yield* showCharacterUpgradingAnimation(_this__u8e3s4, upgradeChange.i4x_1, upgradeChange, $completion);
  }
  return Unit_instance;
}
function *animateMovement(_this__u8e3s4, movementChange, $completion) {
  if (movementChange.r4v_1.n1()) {
    reportWarning(_this__u8e3s4, 'Empty movement path, ' + movementChange.toString());
    return Unit_instance;
  }
  if (movementChange.r4v_1.s2() === 1) {
    yield* animateAddingNewObject(_this__u8e3s4, movementChange.q4v_1, $completion);
  } else {
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.t6h();
    var tmp2 = movementChange.q4v_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($this$with, tmp2);
      if (isInterface(tmp, BeastCharacter)) {
        tmp$ret$2 = tmp2 instanceof ObjectOnBoard ? tmp2 : THROW_CCE();
        break $l$block;
      }
      tmp$ret$2 = null;
    }
    var movedObject = tmp$ret$2;
    var tmp_0;
    if (_this__u8e3s4.be1(get_beastsGameTeam()) || movedObject == null) {
      tmp_0 = true;
    } else {
      var tmp_1;
      if (get_isRevealed($this$with, movedObject)) {
        // Inline function 'kotlin.with' call
        var $this$with_0 = _this__u8e3s4.w6h();
        tmp_1 = get_isRevealed($this$with_0, movedObject);
      } else {
        tmp_1 = false;
      }
      tmp_0 = tmp_1;
    }
    if (tmp_0) {
      yield* _this__u8e3s4.gl2_1.gln(movementChange, $completion);
    }
  }
  return Unit_instance;
}
function *animateAddObjectChange(_this__u8e3s4, addObjectChange, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp0 = $this$with.f4l();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.maxBy' call
    var iterator = tmp0.p1();
    if (!iterator.q1())
      throw NoSuchElementException.w7();
    var maxElem = iterator.r1();
    if (!iterator.q1()) {
      tmp$ret$2 = maxElem;
      break $l$block;
    }
    var it = maxElem;
    var maxValue = _EntityId___get_id__impl__v6colh(it.r2w_1);
    do {
      var e = iterator.r1();
      var v = _EntityId___get_id__impl__v6colh(e.r2w_1);
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.q1());
    tmp$ret$2 = maxElem;
  }
  var added = tmp$ret$2;
  // Inline function 'kotlin.require' call
  if (!equals(get_objectType($this$with, added), addObjectChange.w4t_1)) {
    var message = 'Last is ' + added.toString() + ' with ' + toString(get_objectType($this$with, added)) + ' but added was ' + toString(addObjectChange.w4t_1);
    throw IllegalArgumentException.h2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(added.s2w($this$with) === addObjectChange.x4t_1)) {
    var message_0 = 'Last is ' + added.toString() + ' with ' + BoardPosition__toString_impl_v4mn82(added.s2w($this$with)) + ' but added to ' + BoardPosition__toString_impl_v4mn82(addObjectChange.x4t_1);
    throw IllegalArgumentException.h2(toString(message_0));
  }
  yield* animateAddingNewObject(_this__u8e3s4, added, $completion);
  return Unit_instance;
}
function *animateBeastMovementInfoChange(_this__u8e3s4, beastMovementInfoChange, $completion) {
  var beast = beastMovementInfoChange.x4v_1;
  var size = beastMovementInfoChange.a4w_1;
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList.n2(size);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      list.d2(null);
    }
     while (inductionVariable < size);
  var movements = list;
  var isComingFromSupply = true;
  yield* animateMovementCards(_this__u8e3s4, movements, beast, isComingFromSupply, $completion);
  return Unit_instance;
}
function *animateRevealLastMovementsChange(_this__u8e3s4, revealLastMovementsChange, $completion) {
  var indexOfMovementCard = revealLastMovementsChange.w4w_1;
  var beast = revealLastMovementsChange.v4w_1;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var newMovement = getOrNull(get_beastMovements($this$with, beast), indexOfMovementCard);
  // Inline function 'kotlin.with' call
  var $this$with_0 = _this__u8e3s4.w6h();
  var oldMovement = getOrNull(get_beastMovements($this$with_0, beast), indexOfMovementCard);
  if (oldMovement == null) {
    reportWarning(_this__u8e3s4, 'No movement card #' + indexOfMovementCard + ' for ' + toString(get_objectType($this$with_0, beast)));
    return Unit_instance;
  }
  if (oldMovement.k3g_1 === (newMovement == null ? null : newMovement.k3g_1)) {
    return Unit_instance;
  }
  if (oldMovement.i3g_1.s2() > 1) {
    _this__u8e3s4.sln('Need implement IU here');
    return Unit_instance;
  }
  var movementCardsCount = get_beastMovements($this$with_0, beast).s2();
  var key = new BeastMovementsKey(get_objectType($this$with_0, beast), movementCardsCount, last(get_beastMovements($this$with_0, beast)));
  var movementCardView = _this__u8e3s4.vl2_1.im5(key);
  if (movementCardView == null) {
    reportWarning(_this__u8e3s4, 'No movement card view for ' + key.toString());
    return Unit_instance;
  }
  var startPoint = plus_4(movementCardView.wb5(), movementCardView.nig().l9s(2));
  var startSize = movementCardView.nig();
  var centerPoint = toPoint(get_gameLayout().gl6_1.k9s(2.0));
  var centerSize = scaleToHeight(startSize, get_gameLayout().ol5_1);
  var tmp = _this__u8e3s4.pl6();
  // Inline function 'kotlin.takeIf' call
  var tmp_0;
  if (oldMovement.k3g_1) {
    tmp_0 = oldMovement;
  } else {
    tmp_0 = null;
  }
  var tmp1_safe_receiver = tmp_0;
  var startBitmap = yield* (yield* tmp.wle(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n3g(), $completion)).m1q($completion);
  var tmp_1 = _this__u8e3s4.pl6();
  // Inline function 'kotlin.takeIf' call
  var tmp_2;
  if (revealLastMovementsChange.x4w_1) {
    tmp_2 = oldMovement;
  } else {
    tmp_2 = null;
  }
  var tmp2_safe_receiver = tmp_2;
  var endBitmap = yield* (yield* tmp_1.wle(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n3g(), $completion)).m1q($completion);
  // Inline function 'kotlin.apply' call
  var this_0 = Image.lk7(startBitmap);
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
  var startImage = this_0;
  // Inline function 'kotlin.apply' call
  var this_1 = Image.lk7(endBitmap);
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
  var endImage = this_1;
  yield* runAnimations(listOf_0(new AnimationInfo(endImage, animateRevealLastMovementsChange$slambda(_this__u8e3s4, startImage, startPoint, startSize, centerPoint, centerSize, endImage))), $completion);
  return Unit_instance;
}
function *animateTransformLocationsChange(_this__u8e3s4, stateChange, $completion) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = stateChange.d4x_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tmp0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.component1' call
      var position = element.j3().r2v_1;
      // Inline function 'kotlin.collections.component2' call
      var locationType = element.k3();
      if (!locationType.q45()) {
        tmp$ret$5 = null;
        break $l$block;
      }
      var bitmap = yield* (yield* _this__u8e3s4.pl6().hle(locationType, $completion)).m1q($completion);
      var originalBitmapSize = toDouble(bitmap.s2());
      var sizeAtSupply = scaleToHeight(originalBitmapSize, get_gameLayout().ol5_1);
      var locationArea = ensureNotNull(_this__u8e3s4.gl2_1.fl7_1.jl8(position));
      var targetPoint = _this__u8e3s4.gl2_1.hl7_1.oih(locationArea.ml8_1);
      var neededSize = scaleToWidth(originalBitmapSize, _this__u8e3s4.smi() * locationArea.nl8_1);
      // Inline function 'kotlin.apply' call
      var this_0 = Image.lk7(bitmap);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      var view = this_0;
      tmp$ret$5 = animationWithSupply(true, sizeAtSupply, targetPoint, neededSize, view, _this__u8e3s4.ml2_1, true);
    }
    var tmp0_safe_receiver = tmp$ret$5;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  yield* runAnimations(destination, $completion);
  return Unit_instance;
}
function *animateHpChange(_this__u8e3s4, stateChange, $completion) {
  var holder = stateChange.d4u_1;
  var hpChange = stateChange.e4u_1;
  if (hpChange === 0) {
    reportWarning(_this__u8e3s4, 'Zero hp change, ' + stateChange.toString());
    return Unit_instance;
  }
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var size = abs(hpChange);
  var list = ArrayList.n2(size);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var bitmap = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_OneDamage_getInstance(), $completion)).m1q($completion);
      var originalBitmapSize = toDouble(bitmap.s2());
      var sizeAtSupply = scaleToHeight(originalBitmapSize, get_gameLayout().ol5_1);
      var tmp0_safe_receiver = _this__u8e3s4.gl2_1.fln(holder);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_centerAndSize(tmp0_safe_receiver);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        reportWarning(_this__u8e3s4, 'No view for holder ' + holder.toString());
        // Inline function 'kotlin.run' call
        return Unit_instance;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var centerAndSize = tmp;
      // Inline function 'kotlin.with' call
      var $this$with = _this__u8e3s4.t6h();
      var tmp$ret$10;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp_0 = get_objectType($this$with, holder);
        if (isInterface(tmp_0, Character)) {
          tmp$ret$10 = holder instanceof ObjectOnBoard ? holder : THROW_CCE();
          break $l$block;
        }
        tmp$ret$10 = null;
      }
      var characterObject = tmp$ret$10;
      var tmp_1;
      if (!(characterObject == null)) {
        var character = get_objectType($this$with, characterObject);
        tmp_1 = _this__u8e3s4.tmi(character);
      } else {
        tmp_1 = new CenterAndSize(_this__u8e3s4.gl2_1.hl7_1.oih(centerAndSize.um1_1), scaleToHeight(originalBitmapSize, _this__u8e3s4.smi() * centerAndSize.vm1_1.k9i_1));
      }
      var _destruct__k2r9zo = tmp_1;
      var targetPoint = _destruct__k2r9zo.jm();
      var neededSize = _destruct__k2r9zo.km();
      // Inline function 'kotlin.apply' call
      var this_0 = Image.lk7(bitmap);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      var view = this_0;
      var tmp$ret$5 = animationWithSupply(hpChange < 0, sizeAtSupply, targetPoint, neededSize, view, _this__u8e3s4.ml2_1, true);
      list.d2(tmp$ret$5);
    }
     while (inductionVariable < size);
  yield* runAnimations(list, $completion);
  return Unit_instance;
}
function *animateBeastMovementRevealChange(_this__u8e3s4, stateChange, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.w6h();
  var beast = stateChange.q4w_1;
  yield* /*#__NOINLINE__*/animateNotification(_this__u8e3s4, get_gameI18n().y70(get_objectType($this$with, beast)), $completion);
  if (!_this__u8e3s4.be1(get_gameTeam($this$with, beast))) {
    _this__u8e3s4.sln('improve animation to show false steps also!');
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_beastPath($this$with, beast);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = new BoardPosition(item.c3g().v3g_1);
      destination.d2(tmp$ret$4);
    }
    yield* _this__u8e3s4.gl2_1.hln(beast, destination, $completion);
  }
  return Unit_instance;
}
function *animateTrailsRevealed(_this__u8e3s4, stateChange, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.mutableListOf' call
  var animations = ArrayList.p2();
  var trailBitmap = yield* (yield* _this__u8e3s4.pl6().nle(get_objectType($this$with, stateChange.d4t_1), $completion)).m1q($completion);
  // Inline function 'kotlin.with' call
  var $this$with_0 = _this__u8e3s4.w6h();
  var alreadyFoundTrails = get_foundTrails($this$with_0, stateChange.d4t_1);
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = stateChange.e4t_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tmp0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var position = element.j3().r2v_1;
    // Inline function 'kotlin.collections.component2' call
    var count = element.k3();
    // Inline function 'kotlin.collections.getOrElse' call
    var key = new BoardPosition(position);
    var tmp0_elvis_lhs = alreadyFoundTrails.w4(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var alreadyFoundHere = tmp;
    var tmp_0;
    if (count > alreadyFoundHere) {
      tmp_0 = to(new BoardPosition(position), count - alreadyFoundHere | 0);
    } else {
      tmp_0 = null;
    }
    var tmp0_safe_receiver = tmp_0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var newlyRevealed = toMap(destination);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = newlyRevealed.i3().p1();
  while (_iterator__ex2g4s_0.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_0.r1();
    // Inline function 'kotlin.collections.component1' call
    var position_0 = _destruct__k2r9zo.j3().r2v_1;
    // Inline function 'kotlin.collections.component2' call
    var number = _destruct__k2r9zo.k3();
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < number)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $l$block: {
          // Inline function 'kotlin.apply' call
          var this_0 = Image.lk7(trailBitmap);
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          var view = this_0;
          var sizeAtSupply = scaleToHeight(view.s2(), get_gameLayout().ol5_1);
          var tmp0_elvis_lhs_0 = _this__u8e3s4.gl2_1.fl7_1.jl8(position_0);
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var area = tmp_1;
          var targetPoint = _this__u8e3s4.gl2_1.hl7_1.oih(area.ml8_1);
          var neededSize = scaleToHeight(view.s2(), area.nl8_1).b9q(_this__u8e3s4.smi());
          animations.d2(animationWithSupply(true, sizeAtSupply, targetPoint, neededSize, view, _this__u8e3s4.ml2_1, true));
        }
      }
       while (inductionVariable < number);
  }
  yield* runAnimations(animations, $completion);
  return Unit_instance;
}
function *animateDestroyChange(_this__u8e3s4, destroyedChange, $completion) {
  var destroyed = destroyedChange.s4u_1;
  var centerAndSize = _this__u8e3s4.ll3_1.w4(destroyed);
  if (centerAndSize == null) {
    reportWarning(_this__u8e3s4, 'No view for ' + destroyed.toString());
    return Unit_instance;
  }
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList.n2(1);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < 1)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.with' call
      var $this$with = _this__u8e3s4.w6h();
      var bitmap = yield* (yield* _this__u8e3s4.pl6().ole($this$with, destroyed, $completion)).m1q($completion);
      var originalBitmapSize = toDouble(bitmap.s2());
      var sizeAtSupply = scaleToHeight(originalBitmapSize, get_gameLayout().ol5_1);
      var targetPoint = _this__u8e3s4.gl2_1.hl7_1.oih(centerAndSize.um1_1);
      var neededSize = scaleToHeight(originalBitmapSize, _this__u8e3s4.smi() * centerAndSize.vm1_1.k9i_1);
      // Inline function 'kotlin.apply' call
      var this_0 = Image.lk7(bitmap);
      // Inline function 'korlibs.korge.view.anchor' call
      anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
      var view = this_0;
      var tmp$ret$4 = animationWithSupply(false, sizeAtSupply, targetPoint, neededSize, view, _this__u8e3s4.ml2_1, true);
      list.d2(tmp$ret$4);
    }
     while (inductionVariable < 1);
  yield* runAnimations(list, $completion);
  return Unit_instance;
}
function *animateClearingAfterRevealChange(_this__u8e3s4, stateChange, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.w6h();
  var beast = stateChange.q4w_1;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_beastMovements($this$with, beast);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$4 = item.i3g_1;
    destination.d2(tmp$ret$4);
  }
  var movements = reversed(flatten(destination));
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!get_foundTrails($this$with, beast).n1()) {
    _this__u8e3s4.sln('Implement animation of foundTrails');
  }
  yield* animateMovementCards(_this__u8e3s4, movements, beast, false, $completion);
  return Unit_instance;
}
function *animateGrudgesChanges(_this__u8e3s4, grudgesChanges, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0 = _this__u8e3s4.t6h();
  $l$block: {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(grudgesChanges, 10));
    var _iterator__ex2g4s = grudgesChanges.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      if (item.l4v_1 === 0) {
        reportWarning(_this__u8e3s4, 'Zero grudges change, ' + item.toString());
        break $l$block;
      }
      var _destruct__k2r9zo = _this__u8e3s4.tmi(get_objectType(tmp0, item.k4v_1));
      var pointAtCharacter = _destruct__k2r9zo.jm();
      var neededSize = _destruct__k2r9zo.km();
      // Inline function 'kotlin.let' call
      var it = get_gameLayout().ol5_1;
      var sizeAtSupply = Size2D.y9p(it, it);
      var grudgeBitmap = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_OneGrudge_getInstance(), $completion)).m1q($completion);
      var isComingFromSupply = item.l4v_1 > 0;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = item.l4v_1;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = abs(this_0);
      var list = ArrayList.n2(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_1 = Image.lk7(grudgeBitmap);
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          var view = this_1;
          var tmp$ret$12 = animationWithSupply(isComingFromSupply, sizeAtSupply, pointAtCharacter, neededSize, view, _this__u8e3s4.ml2_1, true);
          list.d2(tmp$ret$12);
        }
         while (inductionVariable < size);
      destination.d2(list);
    }
    var elements = flatten(destination);
    yield* runAnimations(elements, $completion);
  }
  return Unit_instance;
}
function *animateAncientPowersChange(_this__u8e3s4, ancientPowerChanges, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0 = _this__u8e3s4.t6h();
  $l$block: {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(ancientPowerChanges, 10));
    var _iterator__ex2g4s = ancientPowerChanges.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      if (item.d4q_1 === 0) {
        reportWarning(_this__u8e3s4, 'Zero ancient power change, ' + item.toString());
        break $l$block;
      }
      var _destruct__k2r9zo = _this__u8e3s4.tmi(get_objectType(tmp0, item.c4q_1));
      var pointAtCharacter = _destruct__k2r9zo.jm();
      var neededSize = _destruct__k2r9zo.km();
      var ancientPowerBitmap = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_AncientPower_getInstance(), $completion)).m1q($completion);
      // Inline function 'kotlin.let' call
      var it = get_gameLayout().ol5_1;
      var sizeAtSupply = Size2D.y9p(it * ancientPowerBitmap.sc1_1 / ancientPowerBitmap.tc1_1, it);
      var isComingFromSupply = item.d4q_1 > 0;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = item.d4q_1;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = abs(this_0);
      var list = ArrayList.n2(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_1 = Image.lk7(ancientPowerBitmap);
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          var view = this_1;
          var tmp$ret$12 = animationWithSupply(isComingFromSupply, sizeAtSupply, pointAtCharacter, neededSize, view, _this__u8e3s4.ml2_1, true);
          list.d2(tmp$ret$12);
        }
         while (inductionVariable < size);
      destination.d2(list);
    }
    var elements = flatten(destination);
    yield* runAnimations(elements, $completion);
  }
  return Unit_instance;
}
function *animateValdiBloodChanges(_this__u8e3s4, valdiBloodChanges, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  $l$block: {
    var valdiBloodBitmap = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_BloodDrop_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(valdiBloodChanges, 10));
    var _iterator__ex2g4s = valdiBloodChanges.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      if (item.i6g_1 === 0) {
        reportWarning(_this__u8e3s4, 'Zero valdi blood change, ' + item.toString());
        break $l$block;
      }
      var _destruct__k2r9zo = _this__u8e3s4.tmi(Valdi_getInstance());
      var pointAtCharacter = _destruct__k2r9zo.jm();
      var neededSize = _destruct__k2r9zo.km();
      // Inline function 'kotlin.let' call
      var it = get_gameLayout().ol5_1;
      var sizeAtSupply = Size2D.y9p(it * valdiBloodBitmap.sc1_1 / valdiBloodBitmap.tc1_1, it);
      var isComingFromSupply = item.i6g_1 > 0;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = item.i6g_1;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = abs(this_0);
      var list = ArrayList.n2(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_1 = Image.lk7(valdiBloodBitmap);
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          var view = this_1;
          var tmp$ret$12 = animationWithSupply(isComingFromSupply, sizeAtSupply, pointAtCharacter, neededSize, view, _this__u8e3s4.ml2_1, true);
          list.d2(tmp$ret$12);
        }
         while (inductionVariable < size);
      destination.d2(list);
    }
    var elements = flatten(destination);
    yield* runAnimations(elements, $completion);
  }
  return Unit_instance;
}
function *animateDraugCorruptionChanges(_this__u8e3s4, draugCorruptionChanges, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  $l$block: {
    var lifeForceBitmap = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_LifeForce_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(draugCorruptionChanges, 10));
    var _iterator__ex2g4s = draugCorruptionChanges.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      if (item.c3w_1 === 0) {
        reportWarning(_this__u8e3s4, 'Zero Draug corruption change, ' + item.toString());
        break $l$block;
      }
      var _destruct__k2r9zo = _this__u8e3s4.tmi(Draug_getInstance());
      var pointAtCharacter = _destruct__k2r9zo.jm();
      var neededSize = _destruct__k2r9zo.km();
      // Inline function 'kotlin.let' call
      var it = get_gameLayout().ol5_1;
      var sizeAtSupply = Size2D.y9p(it * lifeForceBitmap.sc1_1 / lifeForceBitmap.tc1_1, it);
      var isComingFromSupply = item.c3w_1 > 0;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = item.c3w_1;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = abs(this_0);
      var list = ArrayList.n2(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_1 = Image.lk7(lifeForceBitmap);
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          var view = this_1;
          var tmp$ret$12 = animationWithSupply(isComingFromSupply, sizeAtSupply, pointAtCharacter, neededSize, view, _this__u8e3s4.ml2_1, true);
          list.d2(tmp$ret$12);
        }
         while (inductionVariable < size);
      destination.d2(list);
    }
    var elements = flatten(destination);
    yield* runAnimations(elements, $completion);
  }
  return Unit_instance;
}
function *animateLydanHarvestChanges(_this__u8e3s4, lydanHarvestChanges, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  $l$block: {
    var lifeForceBitmap = yield* (yield* _this__u8e3s4.pl6().vle(GeneralTokens_LifeForce_getInstance(), $completion)).m1q($completion);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(lydanHarvestChanges, 10));
    var _iterator__ex2g4s = lydanHarvestChanges.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      if (item.b5p_1 === 0) {
        reportWarning(_this__u8e3s4, 'Zero Lydan harvest change, ' + item.toString());
        break $l$block;
      }
      var _destruct__k2r9zo = _this__u8e3s4.tmi(Lydan_getInstance());
      var pointAtCharacter = _destruct__k2r9zo.jm();
      var neededSize = _destruct__k2r9zo.km();
      // Inline function 'kotlin.let' call
      var it = get_gameLayout().ol5_1;
      var sizeAtSupply = Size2D.y9p(it * lifeForceBitmap.sc1_1 / lifeForceBitmap.tc1_1, it);
      var isComingFromSupply = item.b5p_1 > 0;
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = item.b5p_1;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = abs(this_0);
      var list = ArrayList.n2(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_1 = Image.lk7(lifeForceBitmap);
          // Inline function 'korlibs.korge.view.anchor' call
          anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
          var view = this_1;
          var tmp$ret$12 = animationWithSupply(isComingFromSupply, sizeAtSupply, pointAtCharacter, neededSize, view, _this__u8e3s4.ml2_1, true);
          list.d2(tmp$ret$12);
        }
         while (inductionVariable < size);
      destination.d2(list);
    }
    var elements = flatten(destination);
    yield* runAnimations(elements, $completion);
  }
  return Unit_instance;
}
function *animateCardsMoveChangesImpl(_this__u8e3s4, changesToAnimate, $completion) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(changesToAnimate, 10));
  var _iterator__ex2g4s = changesToAnimate.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = item.c4v_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      var tmp$ret$7;
      $l$block_7: {
        var fromPlace = item.a4v_1;
        var toPlace = item.b4v_1;
        var bothPlaces = listOf([fromPlace, toPlace]);
        var tmp;
        if (!_this__u8e3s4.me0()) {
          var tmp_0;
          var tmp_1 = _this__u8e3s4.sm1();
          if (tmp_1 instanceof MasterFixing) {
            tmp_0 = true;
          } else {
            var tmp_2;
            var tmp_3 = _this__u8e3s4.sm1();
            if (!(tmp_3 instanceof SandboxInit)) {
              // Inline function 'kotlin.with' call
              var $this$with = _this__u8e3s4.t6h();
              var tmp_4;
              var tmp_5;
              var tmp_6;
              var tmp$ret$10;
              $l$block_0: {
                // Inline function 'kotlin.collections.none' call
                var tmp_7;
                if (isInterface(bothPlaces, Collection)) {
                  tmp_7 = bothPlaces.n1();
                } else {
                  tmp_7 = false;
                }
                if (tmp_7) {
                  tmp$ret$10 = true;
                  break $l$block_0;
                }
                var _iterator__ex2g4s_1 = bothPlaces.p1();
                while (_iterator__ex2g4s_1.q1()) {
                  var element_0 = _iterator__ex2g4s_1.r1();
                  if (element_0 instanceof DiscardPlace) {
                    tmp$ret$10 = false;
                    break $l$block_0;
                  }
                }
                tmp$ret$10 = true;
              }
              if (tmp$ret$10) {
                var tmp$ret$12;
                $l$block_2: {
                  // Inline function 'kotlin.collections.none' call
                  var tmp_8;
                  if (isInterface(bothPlaces, Collection)) {
                    tmp_8 = bothPlaces.n1();
                  } else {
                    tmp_8 = false;
                  }
                  if (tmp_8) {
                    tmp$ret$12 = true;
                    break $l$block_2;
                  }
                  var _iterator__ex2g4s_2 = bothPlaces.p1();
                  while (_iterator__ex2g4s_2.q1()) {
                    var element_1 = _iterator__ex2g4s_2.r1();
                    if (element_1 instanceof InPlayPlace) {
                      tmp$ret$12 = false;
                      break $l$block_2;
                    }
                  }
                  tmp$ret$12 = true;
                }
                tmp_6 = tmp$ret$12;
              } else {
                tmp_6 = false;
              }
              if (tmp_6) {
                var tmp$ret$14;
                $l$block_4: {
                  // Inline function 'kotlin.collections.none' call
                  var tmp_9;
                  if (isInterface(bothPlaces, Collection)) {
                    tmp_9 = bothPlaces.n1();
                  } else {
                    tmp_9 = false;
                  }
                  if (tmp_9) {
                    tmp$ret$14 = true;
                    break $l$block_4;
                  }
                  var _iterator__ex2g4s_3 = bothPlaces.p1();
                  while (_iterator__ex2g4s_3.q1()) {
                    var element_2 = _iterator__ex2g4s_3.r1();
                    var tmp_10;
                    if (element_2 instanceof HandPlace) {
                      tmp_10 = get_gameTeam($this$with, element_2.f4p_1) === _this__u8e3s4.k3q();
                    } else {
                      tmp_10 = false;
                    }
                    if (tmp_10) {
                      tmp$ret$14 = false;
                      break $l$block_4;
                    }
                  }
                  tmp$ret$14 = true;
                }
                tmp_5 = tmp$ret$14;
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                var tmp$ret$16;
                $l$block_6: {
                  // Inline function 'kotlin.collections.any' call
                  var tmp_11;
                  if (isInterface(bothPlaces, Collection)) {
                    tmp_11 = bothPlaces.n1();
                  } else {
                    tmp_11 = false;
                  }
                  if (tmp_11) {
                    tmp$ret$16 = false;
                    break $l$block_6;
                  }
                  var _iterator__ex2g4s_4 = bothPlaces.p1();
                  while (_iterator__ex2g4s_4.q1()) {
                    var element_3 = _iterator__ex2g4s_4.r1();
                    if (element_3 instanceof HandPlace) {
                      tmp$ret$16 = true;
                      break $l$block_6;
                    }
                  }
                  tmp$ret$16 = false;
                }
                tmp_4 = tmp$ret$16;
              } else {
                tmp_4 = false;
              }
              tmp_2 = tmp_4;
            } else {
              tmp_2 = false;
            }
            tmp_0 = tmp_2;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        var isHiddenMovementForCards = tmp;
        var bitmap = yield* (isHiddenMovementForCards ? (yield* _this__u8e3s4.pl6().kle(element, $completion)) : (yield* _this__u8e3s4.pl6().mle(element, $completion))).m1q($completion);
        var sizeAtCenter = scaleToHeight(toDouble(bitmap.s2()), get_gameLayout().ol5_1);
        var existedView = _this__u8e3s4.vl2_1.im5(new CardAtSidePanelElement(element, true));
        var tmp_12;
        if (existedView == null) {
          // Inline function 'kotlin.takeIf' call
          var tmp_13;
          if (!isHiddenMovementForCards) {
            tmp_13 = element;
          } else {
            tmp_13 = null;
          }
          var tmp$ret$18 = tmp_13;
          tmp_12 = yield* createCard(_this__u8e3s4, bitmap, tmp$ret$18, JustShowTheCard_instance, $completion);
        } else {
          tmp_12 = existedView;
        }
        var view = tmp_12;
        var start = findPointAndSizeForCard(_this__u8e3s4, fromPlace, element, view);
        var end = findPointAndSizeForCard(_this__u8e3s4, toPlace, element, view);
        var tmp_14;
        if (start == null || end == null) {
          var x = start == null ? end : start;
          if (x == null) {
            reportWarning(_this__u8e3s4, 'Cannot animate card ' + toString(element) + ' from ' + toString(fromPlace) + ' to ' + toString(toPlace));
            tmp$ret$7 = null;
            break $l$block_7;
          }
          var tmp_15;
          var tmp_16;
          if (get_gameConfiguration().wlc_1 && !_this__u8e3s4.se3()) {
            tmp_16 = toPlace instanceof HandPlace;
          } else {
            tmp_16 = false;
          }
          if (tmp_16) {
            tmp_15 = fromPlace instanceof ComingArsenalPlace;
          } else {
            tmp_15 = false;
          }
          var holdInCenter = tmp_15;
          var tmp2_isComingFromSupply = start == null;
          var tmp3_pointAtTarget = x.pm_1;
          var tmp4_neededSize = x.qm_1;
          var tmp5_needRemoveAfter = existedView == null;
          var tmp6_animationContainer = _this__u8e3s4.ml2_1;
          tmp_14 = animationWithSupply(tmp2_isComingFromSupply, sizeAtCenter, tmp3_pointAtTarget, tmp4_neededSize, view, tmp6_animationContainer, tmp5_needRemoveAfter, holdInCenter);
        } else {
          tmp_14 = new AnimationInfo(view, animateCardsMoveChangesImpl$slambda(sizeAtCenter, _this__u8e3s4, view, start, end));
        }
        tmp$ret$7 = tmp_14;
      }
      var tmp0_safe_receiver = tmp$ret$7;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.d2(tmp0_safe_receiver);
      }
    }
    destination.d2(destination_0);
  }
  var allAnimations = flatten(destination);
  yield* runAnimations(allAnimations, $completion);
  return Unit_instance;
}
function *runAnimations(elements, $completion) {
  yield* coroutineScope(runAnimations$slambda(elements), $completion);
  var _iterator__ex2g4s = elements.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_safe_receiver = element.umi_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.x1m();
      tmp0_safe_receiver_0 == null || tmp0_safe_receiver_0.cif(tmp0_safe_receiver);
    }
  }
  return Unit_instance;
}
function animationWithSupply(isComingFromSupply, sizeAtSupply, pointAtTarget, neededSize, view, animationContainer, needRemoveAfter, holdInCenter, pointInCenter) {
  holdInCenter = holdInCenter === VOID ? false : holdInCenter;
  pointInCenter = pointInCenter === VOID ? null : pointInCenter;
  // Inline function 'kotlin.takeIf' call
  var tmp;
  if (needRemoveAfter) {
    tmp = view;
  } else {
    tmp = null;
  }
  var tmp_0 = tmp;
  return new AnimationInfo(tmp_0, animationWithSupply$slambda(animationContainer, view, pointInCenter, isComingFromSupply, sizeAtSupply, holdInCenter, needRemoveAfter, pointAtTarget, neededSize));
}
function *animateAddingNewObject(_this__u8e3s4, movedObject, $completion) {
  var view = _this__u8e3s4.gl2_1.fln(movedObject);
  if (view == null) {
    reportWarning(_this__u8e3s4, 'No view for ' + movedObject.toString());
    return Unit_instance;
  }
  if (!(view.x1m() == null)) {
    reportWarning(_this__u8e3s4, 'It should be movement instead of adding for ' + movedObject.toString());
    return Unit_instance;
  }
  var backupPosition = view.wb5();
  var backupScaledSize = view.nig();
  var targetPoint = _this__u8e3s4.gl2_1.hl7_1.oih(backupPosition);
  var sizeAtSupply = scaleToHeight(backupScaledSize, get_gameLayout().ol5_1);
  var neededSize = view.nig().b9q(_this__u8e3s4.smi());
  yield* /*#__NOINLINE__*/runAnimations(listOf_0(animationWithSupply(true, sizeAtSupply, targetPoint, neededSize, view, _this__u8e3s4.ml2_1, true)), $completion);
  view.fcw(backupPosition);
  view.mig(backupScaledSize);
  return Unit_instance;
}
function *animateMovementCards(_this__u8e3s4, movements, beast, isComingFromSupply, $completion) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(movements, 10));
  var _iterator__ex2g4s = movements.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var bitmap = yield* (yield* _this__u8e3s4.pl6().wle(item, $completion)).m1q($completion);
    var originalBitmapSize = toDouble(bitmap.s2());
    var sizeAtSupply = scaleToHeight(originalBitmapSize, get_gameLayout().ol5_1);
    var movementCardWidth = _this__u8e3s4.gl2_1.fl7_1.nll().flo_1;
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.t6h();
    // Inline function 'steelart.beast.castFilter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this$with.i38_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      var tmp$ret$11;
      $l$block: {
        // Inline function 'steelart.beast.cast' call
        var tmp = get_objectType($this$with, element);
        if (isInterface(tmp, BeastCharacter)) {
          tmp$ret$11 = element instanceof ObjectOnBoard ? element : THROW_CCE();
          break $l$block;
        }
        tmp$ret$11 = null;
      }
      var tmp0_safe_receiver = tmp$ret$11;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.d2(tmp0_safe_receiver);
      }
    }
    var index = destination_0.y2(beast);
    var tmp_0;
    if (false) {
      tmp_0 = to(_this__u8e3s4.gl2_1.hl7_1.oih(plus_4(_this__u8e3s4.gl2_1.fl7_1.nll().elo_1.u2(index), scaleToWidth(originalBitmapSize, movementCardWidth).l9s(2))), scaleToWidth(originalBitmapSize, _this__u8e3s4.smi() * movementCardWidth));
    } else {
      var tmp_1;
      if (_this__u8e3s4.t6h().i38_1.s2() === 5) {
        // Inline function 'kotlin.with' call
        var $this$with_0 = _this__u8e3s4.t6h();
        var beastCharacter = get_objectType($this$with_0, beast);
        var view = ensureNotNull(_this__u8e3s4.vl2_1.hm5(animateMovementCards$lambda(beastCharacter)));
        var neededSize = scaleToWidth(get_gameLayout().jl6_1, view.pig());
        tmp_1 = to(plus_4(view.wb5(), neededSize.l9s(2)), neededSize);
      } else {
        var _destruct__k2r9zo = movementCardLayoutForAboveMap(_this__u8e3s4, index);
        var position = _destruct__k2r9zo.jm();
        var height = _destruct__k2r9zo.km();
        var neededSize_0 = scaleToHeight(originalBitmapSize, height);
        tmp_1 = to(plus_4(position, neededSize_0.l9s(2)), neededSize_0);
      }
      tmp_0 = tmp_1;
    }
    var _destruct__k2r9zo_0 = tmp_0;
    var targetPoint = _destruct__k2r9zo_0.jm();
    var neededSize_1 = _destruct__k2r9zo_0.km();
    // Inline function 'kotlin.apply' call
    var this_0 = Image.lk7(bitmap);
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
    var view_0 = this_0;
    var tmp0_animationContainer = _this__u8e3s4.ll2_1;
    var tmp$ret$2 = animationWithSupply(isComingFromSupply, sizeAtSupply, targetPoint, neededSize_1, view_0, tmp0_animationContainer, true);
    destination.d2(tmp$ret$2);
  }
  yield* /*#__NOINLINE__*/runAnimations(destination, $completion);
  return Unit_instance;
}
function *runFromPointToPointAnimation(view, startPoint, startSize, endPoint, endSize, $completion) {
  var tmp = KMutableProperty0;
  var tmp_0 = View$_get_pos_$ref_lp2nil(view);
  var tmp_1 = get(getPropertyCallableRef('pos', 0, tmp, tmp_0, View$_set_pos_$ref_npt43j(view)), startPoint, endPoint);
  var tmp_2 = KMutableProperty0;
  var tmp_3 = View$_get_scaledSize_$ref_ewcnoe(view);
  yield* tween(view, [tmp_1, get_0(getPropertyCallableRef('scaledSize', 0, tmp_2, tmp_3, View$_set_scaledSize_$ref_amqsd2(view)), startSize, endSize)], get_gameAnimations().nl4_1, VOID, VOID, VOID, VOID, VOID, $completion);
  return Unit_instance;
}
function findPointAndSizeForCard(_this__u8e3s4, place, card, cardView) {
  var tmp;
  if (place instanceof DiscardPlace) {
    tmp = findPointAndSizeForCard$holderPlace(_this__u8e3s4, cardView, DiscardButtonElement_instance);
  } else {
    if (place instanceof HandPlace) {
      tmp = findPointAndSizeForCard$holderPlace(_this__u8e3s4, cardView, new CharacterElement(place.f4p_1));
    } else {
      if (equals(place, InPlayPlace_getInstance()) || (equals(place, PendingTriggerPlace_getInstance()) || equals(place, RevealedArsenalPlace_getInstance()))) {
        var tmp1_safe_receiver = _this__u8e3s4.vl2_1.im5(new CardAtSidePanelElement(card, true));
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = to(tmp1_safe_receiver.wb5(), tmp1_safe_receiver.nig());
        }
        tmp = tmp_0;
      } else {
        if (place instanceof ComingArsenalPlace) {
          tmp = null;
        } else {
          var tmp_1;
          var tmp_2;
          if (place instanceof UnusedDraftActionCardPlace) {
            tmp_2 = true;
          } else {
            tmp_2 = place instanceof DraftOfferPlace;
          }
          if (tmp_2) {
            tmp_1 = true;
          } else {
            var tmp_3;
            if (place instanceof DraftPickedPlace) {
              tmp_3 = true;
            } else {
              tmp_3 = place instanceof DraftRemovedPlace;
            }
            tmp_1 = tmp_3;
          }
          if (tmp_1) {
            tmp = null;
          } else {
            if (place instanceof TrapZonePlace) {
              var destination = _this__u8e3s4.gl2_1.hl7_1.oih(ensureNotNull(_this__u8e3s4.gl2_1.fl7_1.nll().hlo_1.w4(place.n4p_1)));
              var size = scaleToWidth(cardView.nig(), _this__u8e3s4.gl2_1.fl7_1.nll().glo_1.j9i_1 * _this__u8e3s4.smi());
              tmp = to(destination, size);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function *runAnimationWithSupply(view, isComingFromSupply, pointInCenter, $completion) {
  pointInCenter = pointInCenter === VOID ? null : pointInCenter;
  var centerOfFrame = pointInCenter == null ? toPoint(get_gameLayout().gl6_1.k9s(2.0)) : pointInCenter;
  var transparentPoint = Vector2D.d9t(centerOfFrame.r9g_1, 0);
  if (isComingFromSupply) {
    var tmp = KMutableProperty0;
    var tmp_0 = View$_get_pos_$ref_lp2nil(view);
    var tmp_1 = get(getPropertyCallableRef('pos', 0, tmp, tmp_0, View$_set_pos_$ref_npt43j(view)), transparentPoint, centerOfFrame);
    var tmp_2 = KMutableProperty0;
    var tmp_3 = View$_get_alpha_$ref_oftner(view);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp_2, tmp_3, View$_set_alpha_$ref_4v0szt(view));
    var tmp1_vs = [tmp_1, new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
    var tmp2_easing = get_gameAnimations().ll4_1;
    var tmp3_time = get_gameAnimations().ml4_1;
    yield* tween(view, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
  } else {
    var tmp_4 = KMutableProperty0;
    var tmp_5 = View$_get_pos_$ref_lp2nil(view);
    var tmp_6 = get(getPropertyCallableRef('pos', 0, tmp_4, tmp_5, View$_set_pos_$ref_npt43j(view)), centerOfFrame, transparentPoint);
    var tmp_7 = KMutableProperty0;
    var tmp_8 = View$_get_alpha_$ref_oftner(view);
    // Inline function 'korlibs.korge.tween.get' call
    var this_1 = getPropertyCallableRef('alpha', 0, tmp_7, tmp_8, View$_set_alpha_$ref_4v0szt(view));
    var tmp4_vs = [tmp_6, new V2(this_1, 1.0, 0.0, _interpolate$ref(), true)];
    var tmp5_easing = get_gameAnimations().ll4_1;
    var tmp6_time = get_gameAnimations().ml4_1;
    yield* tween(view, tmp4_vs, tmp6_time, tmp5_easing, VOID, VOID, VOID, VOID, $completion);
  }
  return Unit_instance;
}
function animateChangesBeforeWholeUpdate$lambda(it) {
  return it.l4v_1 > 0;
}
function animateChangesBeforeWholeUpdate$lambda_0(it) {
  return it.d4q_1 > 0;
}
function animateChangesBeforeWholeUpdate$lambda_1(it) {
  return it.i6g_1 > 0;
}
function animateChangesBeforeWholeUpdate$lambda_2(it) {
  return it.c3w_1 > 0;
}
function animateChangesBeforeWholeUpdate$lambda_3(it) {
  return it.b5p_1 > 0;
}
function animateChangesAfterWholeUpdate$lambda(it) {
  return it.l4v_1 < 0;
}
function animateChangesAfterWholeUpdate$lambda_0(it) {
  return it.d4q_1 < 0;
}
function animateChangesAfterWholeUpdate$lambda_1(it) {
  return it.i6g_1 < 0;
}
function animateChangesAfterWholeUpdate$lambda_2(it) {
  return it.c3w_1 < 0;
}
function animateChangesAfterWholeUpdate$lambda_3(it) {
  return it.b5p_1 < 0;
}
function animateOfflineReplayEndOfGame$slambda$slambda($this_animateOfflineReplayEndOfGame, $shadowingCornersImage) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0_$receiver = $this_animateOfflineReplayEndOfGame.ml2_1;
    var tmp = KMutableProperty0;
    var tmp_0 = Image$_get_alpha_$ref_d2kncp($shadowingCornersImage);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, Image$_set_alpha_$ref_g89t1v($shadowingCornersImage));
    var tmp1_vs = [new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
    var tmp2_easing = get_gameAnimations().ll4_1;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp3_time = toDuration(1500, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function SolidRect$_get_alpha_$ref_vqiepf(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 565, VOID, [p0]);
}
function SolidRect$_set_alpha_$ref_9zr6v5(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 566, VOID, [p0]);
}
function animateOfflineReplayEndOfGame$slambda$slambda_0($this_animateOfflineReplayEndOfGame, $r) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    var tmp0_$receiver = $this_animateOfflineReplayEndOfGame.ml2_1;
    var tmp = KMutableProperty0;
    var tmp_0 = SolidRect$_get_alpha_$ref_vqiepf($r);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, SolidRect$_set_alpha_$ref_9zr6v5($r));
    var tmp1_vs = [new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
    var tmp2_easing = get_gameAnimations().ll4_1;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp3_time = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(tmp0_$receiver, tmp1_vs, tmp3_time, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function animateOfflineReplayEndOfGame$slambda($this_animateOfflineReplayEndOfGame, $shadowingCornersImage, $r) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    launch($this$coroutineScope, VOID, VOID, animateOfflineReplayEndOfGame$slambda$slambda($this_animateOfflineReplayEndOfGame, $shadowingCornersImage));
    return launch($this$coroutineScope, VOID, VOID, animateOfflineReplayEndOfGame$slambda$slambda_0($this_animateOfflineReplayEndOfGame, $r));
  }, 1);
}
function animateNotification$lambda($closing) {
  return (it) => {
    $closing.l1t(Unit_instance);
    return Unit_instance;
  };
}
function animateNotification$lambda_0($handler) {
  return (it) => {
    $handler(it);
    return Unit_instance;
  };
}
function View$_get_alpha_$ref_oftner(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 567, VOID, [p0]);
}
function View$_set_alpha_$ref_4v0szt(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 568, VOID, [p0]);
}
function View$_get_scaledSize_$ref_ewcnoe(p0) {
  return constructCallableReference(() => p0.nig(), 0, 0, 569, VOID, [p0]);
}
function View$_set_scaledSize_$ref_amqsd2(p0) {
  return constructCallableReference((p0_0) => {
    p0.mig(p0_0);
    return Unit_instance;
  }, 1, 0, 570, VOID, [p0]);
}
function animateNotification$slambda($c, $view) {
  return constructCallableReference(function *($completion) {
    var whereStopNotification = Vector2D.t9g($c.s2().j9i_1 / 2, $c.s2().k9i_1 / 4);
    var transparentPoint = Vector2D.d9t(whereStopNotification.r9g_1, 0);
    position_0($view, transparentPoint);
    $c.uie($view);
    var tmp = KMutableProperty0;
    var tmp_0 = View$_get_pos_$ref_lp2nil($view);
    var tmp_1 = get(getPropertyCallableRef('pos', 0, tmp, tmp_0, View$_set_pos_$ref_npt43j($view)), transparentPoint, whereStopNotification);
    var tmp_2 = KMutableProperty0;
    var tmp_3 = View$_get_alpha_$ref_oftner($view);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp_2, tmp_3, View$_set_alpha_$ref_4v0szt($view));
    var tmp0_vs = [tmp_1, new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
    var tmp1_easing = get_gameAnimations().ll4_1;
    var tmp2_time = get_gameAnimations().sl4_1;
    yield* tween($view, tmp0_vs, tmp2_time, tmp1_easing, VOID, VOID, VOID, VOID, $completion);
    yield* delay(get_gameAnimations().tl4_1, $completion);
    var original = $view.nig();
    var tmp_4 = KMutableProperty0;
    var tmp_5 = View$_get_scaledSize_$ref_ewcnoe($view);
    var tmp_6 = get_0(getPropertyCallableRef('scaledSize', 0, tmp_4, tmp_5, View$_set_scaledSize_$ref_amqsd2($view)), original, original.i9s(2));
    var tmp_7 = KMutableProperty0;
    var tmp_8 = View$_get_alpha_$ref_oftner($view);
    // Inline function 'korlibs.korge.tween.get' call
    var this_1 = getPropertyCallableRef('alpha', 0, tmp_7, tmp_8, View$_set_alpha_$ref_4v0szt($view));
    var tmp3_vs = [tmp_6, new V2(this_1, 1.0, 0.0, _interpolate$ref(), true)];
    var tmp4_easing = get_gameAnimations().ll4_1;
    var tmp5_time = get_gameAnimations().ul4_1;
    yield* tween($view, tmp3_vs, tmp5_time, tmp4_easing, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 0);
}
function animateRevealLastMovementsChange$slambda($this_animateRevealLastMovementsChange, $startImage, $startPoint, $startSize, $centerPoint, $centerSize, $endImage) {
  return constructCallableReference(function *($completion) {
    $this_animateRevealLastMovementsChange.ml2_1.uie($startImage);
    yield* /*#__NOINLINE__*/runFromPointToPointAnimation($startImage, $startPoint, $startSize, $centerPoint, $centerSize, $completion);
    $this_animateRevealLastMovementsChange.ml2_1.cif($startImage);
    $this_animateRevealLastMovementsChange.ml2_1.uie($endImage);
    $endImage.hig($centerSize);
    $endImage.fcw($centerPoint);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    yield* /*#__NOINLINE__*/runFromPointToPointAnimation($endImage, $centerPoint, $centerSize, $startPoint, $startSize, $completion);
    return Unit_instance;
  }, 0);
}
function animateCardsMoveChangesImpl$slambda($sizeAtCenter, $this_animateCardsMoveChangesImpl, $view, $start, $end) {
  return constructCallableReference(function *($completion) {
    var centerOfFrame = toPoint(get_gameLayout().gl6_1.e9s($sizeAtCenter).k9s(2.0));
    $this_animateCardsMoveChangesImpl.ml2_1.uie($view);
    yield* /*#__NOINLINE__*/runFromPointToPointAnimation($view, $start.pm_1, $start.qm_1, centerOfFrame, $sizeAtCenter, $completion);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    yield* /*#__NOINLINE__*/runFromPointToPointAnimation($view, centerOfFrame, $sizeAtCenter, $end.pm_1, $end.qm_1, $completion);
    return Unit_instance;
  }, 0);
}
function runAnimations$slambda$slambda($e) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $e.vmi_1($completion);
    return Unit_instance;
  }, 1);
}
function runAnimations$slambda($elements) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var iterator = $elements.p1();
    var index = 0;
    while (iterator.q1()) {
      var i = index;
      index = index + 1 | 0;
      var e = iterator.r1();
      if (i > 0) {
        yield* delay(get_gameAnimations().ol4_1, $completion);
      }
      launch($this$coroutineScope, VOID, VOID, runAnimations$slambda$slambda(e));
    }
    return Unit_instance;
  }, 1);
}
function animationWithSupply$slambda$slambda($deferred) {
  return constructCallableReference(function *(it, $completion) {
    $deferred.l1t(Unit_instance);
    return Unit_instance;
  }, 1);
}
function animationWithSupply$slambda$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function animationWithSupply$slambda$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, animationWithSupply$slambda$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function animationWithSupply$slambda($animationContainer, $view, $pointInCenter, $isComingFromSupply, $sizeAtSupply, $holdInCenter, $needRemoveAfter, $pointAtTarget, $neededSize) {
  return constructCallableReference(function *($completion) {
    $animationContainer.uie($view);
    var tmp0_elvis_lhs = $pointInCenter;
    var centerOfFrame = tmp0_elvis_lhs == null ? toPoint(get_gameLayout().gl6_1.k9s(2.0)) : tmp0_elvis_lhs;
    var tmp;
    if ($isComingFromSupply) {
      $view.mig($sizeAtSupply);
      yield* /*#__NOINLINE__*/runAnimationWithSupply($view, true, centerOfFrame, $completion);
      if ($holdInCenter && $needRemoveAfter) {
        if (get_gameConfiguration().jlc_1) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$0 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
          yield* delay(tmp$ret$0, $completion);
        } else {
          var deferred = CompletableDeferred_0();
          // Inline function 'korlibs.korge.input.mouse' call
          var this_0 = $view;
          // Inline function 'kotlin.run' call
          var tmp0 = get_mouse(this_0);
          // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
          var handler = animationWithSupply$slambda$slambda(deferred);
          var tmp_0 = KProperty1;
          // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
          var tmp_1 = getPropertyCallableRef('click', 1, tmp_0, MouseEvents$_get_click_$ref_klwzrm(), null).get(tmp0);
          tmp_1.v9y(animationWithSupply$slambda$lambda(tmp0, handler));
          yield* deferred.m1q($completion);
        }
      }
      tmp = yield* /*#__NOINLINE__*/runFromPointToPointAnimation($view, centerOfFrame, $sizeAtSupply, $pointAtTarget, $neededSize, $completion);
    } else {
      yield* /*#__NOINLINE__*/runFromPointToPointAnimation($view, $pointAtTarget, $neededSize, centerOfFrame, $sizeAtSupply, $completion);
      tmp = yield* /*#__NOINLINE__*/runAnimationWithSupply($view, false, centerOfFrame, $completion);
    }
    return Unit_instance;
  }, 0);
}
function animateMovementCards$lambda($beastCharacter) {
  return (it) => {
    var tmp;
    if (it instanceof BeastMovementsKey) {
      tmp = equals(it.jm5_1, $beastCharacter);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function findPointAndSizeForCard$holderPlace($this_findPointAndSizeForCard, $cardView, key) {
  var elementView = $this_findPointAndSizeForCard.vl2_1.im5(key);
  if (elementView == null) {
    reportWarning($this_findPointAndSizeForCard, 'No view for ' + toString(key));
    return null;
  }
  // Inline function 'kotlin.let' call
  return to(plus_4(elementView.wb5(), elementView.nig().l9s(2)), scaleToHeight($cardView.nig(), elementView.rig() / 10));
}
function render($this, rows) {
  var oldY = $this.fml_1.xmf_1.xea();
  $this.fml_1.xmf_1.tie();
  var tmp0 = $this.fml_1.xmf_1;
  var tmp2 = $this.eml_1;
  // Inline function 'korlibs.korge.view.solidRect' call
  var color = Colors_getInstance().ec3_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.mkf(Size2D.y9p(tmp2, 1.0), color);
  // Inline function 'kotlin.apply' call
  addTo(this_0, tmp0);
  addTo(rows.xlb_1, $this.fml_1.xmf_1);
  var tmp0_0 = rows.xlb_1.x9z();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_gameLayout().fl6_1 * 0.7;
  var tmp$ret$4 = Math.min(tmp0_0, b);
  $this.fml_1.hml(tmp$ret$4, VOID, -oldY);
}
function set_currentKorgeMode(_set____db54di) {
  _init_properties_KorgeControlAgent_kt__keev5q();
  currentKorgeMode = _set____db54di;
}
function get_currentKorgeMode() {
  _init_properties_KorgeControlAgent_kt__keev5q();
  return currentKorgeMode;
}
var currentKorgeMode;
var OtherControlAgentMode_instance;
function OtherControlAgentMode_getInstance() {
  return OtherControlAgentMode_instance;
}
function _set_shouldPlayNextQuestionStrictlyAfterRevert__vklew5($this, value) {
  _get_choiceFlow__u1vu9o($this).ydv_1 = value;
}
function _get_shouldPlayNextQuestionStrictlyAfterRevert__9tipeh($this) {
  return _get_choiceFlow__u1vu9o($this).ydv_1;
}
function _get_currentQuestionUiJob__7ts88v($this) {
  return _get_choiceFlow__u1vu9o($this).zdv_1;
}
function _set_postAnswerAnimations__a9wihi($this, value) {
  _get_choiceFlow__u1vu9o($this).wdv_1 = value;
}
function _get_postAnswerAnimations__o7z6hu($this) {
  return _get_choiceFlow__u1vu9o($this).wdv_1;
}
function *showPingElement($this, view, $completion) {
  var tmp0_safe_receiver = $this.rl3_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    yield* cancelAndJoin(tmp0_safe_receiver, $completion);
  var tmp1_safe_receiver = $this.sl3_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.uih();
  }
  position(view, get_gameLayout().zl5_1, get_gameLayout().zl5_1);
  $this.ol2_1.uie(view);
  $this.sl3_1 = view;
  var tmp = $this;
  tmp.rl3_1 = launch($this.jl2_1, VOID, VOID, KorgeControlAgent$showPingElement$slambda($this, view));
  return Unit_instance;
}
function cancelCurrentQuestionUi($this) {
  $this.xl2_1 = null;
  $this.mml();
  _get_choiceFlow__u1vu9o($this).cdx();
  $this.ol3_1 = null;
}
function hideStatusBarHoverPopup($this) {
  var tmp0_safe_receiver = $this.ql3_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.uih();
  }
  $this.ql3_1 = null;
}
function updateGameAnimationParameters($this, controllingActor) {
  // Inline function 'kotlin.with' call
  $this.t6h();
  var tmp;
  if (equals(controllingActor, ControllingByNothing_getInstance())) {
    tmp = null;
  } else {
    if (isInterface(controllingActor, ControllingActorWithTeam)) {
      tmp = controllingActor.k3q();
    } else {
      noWhenBranchMatchedException();
    }
  }
  var tmp_0 = tmp;
  var tmp_1 = tmp_0 == null ? null : new GameTeam(tmp_0);
  var controllingTeam = tmp_1 == null ? null : tmp_1.r3p_1;
  var tmp_2;
  var tmp_3 = controllingTeam;
  if (equals(tmp_3 == null ? null : new GameTeam(tmp_3), new GameTeam($this.k3q()))) {
    tmp_2 = new GameAnimationParams();
  } else {
    var tmp_4 = controllingTeam;
    if ((tmp_4 == null ? null : new GameTeam(tmp_4)) == null) {
      tmp_2 = get_slowAnimations();
    } else {
      tmp_2 = get_slowAnimations();
    }
  }
  set_gameAnimations(tmp_2);
}
function _set_eventWasApplied__3k751l($this, value) {
  _get_replayRevertFlow__95swe($this).ie1_1 = value;
}
function *awaitUiStateWithoutDialogs($this, $completion) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = 'Close dialog to continue the game';
  var tmp;
  if ($this.il2_1.rdx() && !$this.nml()) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var waitingMessage = tmp;
  $l$loop: while (true) {
    var tmp0_safe_receiver = $this.nl3_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      if (tmp0_safe_receiver.kmi()) {
        tmp_1 = tmp0_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var shownDialog = tmp_2;
    yield* shownDialog.oml(waitingMessage, $completion);
  }
  return Unit_instance;
}
function clearAnotherTeamNotification($this) {
  var tmp0_safe_receiver = $this.cl4_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.o1n();
    $this.cl4_1 = null;
    $this.ml2_1.tie();
  }
}
function updateStrictlyPlayingCardAfterRevert($this) {
  return _get_choiceFlow__u1vu9o($this).bdx();
}
function *updateBeastsMovementCards($this, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  if (get_gameLayout().jl5_1.equals(SidePanelLayout_Wide_getInstance())) {
    return Unit_instance;
  }
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = $this$with.i38_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$8;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType($this$with, element);
      if (isInterface(tmp, BeastCharacter)) {
        tmp$ret$8 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$8 = null;
    }
    var tmp0_safe_receiver = tmp$ret$8;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var iterator = destination.p1();
  var index = 0;
  while (iterator.q1()) {
    var index_0 = index;
    index = index + 1 | 0;
    var beast = iterator.r1();
    yield* addMovementCardElement($this, beast, $this.vl2_1, VOID, KorgeControlAgent$updateBeastsMovementCards$lambda($this, index_0), $completion);
  }
  return Unit_instance;
}
function *updateStatusBar($this, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this$with.a39_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$4 = item.o3a_1;
    destination.d2(tmp$ret$4);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    var tmp = get_objectType($this$with, element);
    if (isInterface(tmp, SettlerType)) {
      destination_0.d2(element);
    }
  }
  var deadSettlers = destination_0;
  // Inline function 'kotlin.with' call
  var $this$with_0 = $this.t6h();
  var tmp_0;
  var tmp_1 = $this$with_0.y37_1;
  if (tmp_1 instanceof RegentOfRuinsContract) {
    tmp_0 = to(get_regentBeastDominion($this$with_0), get_regentHunterDominion($this$with_0));
  } else {
    tmp_0 = to(0, 0);
  }
  var _destruct__k2r9zo = tmp_0;
  var beastDominion = _destruct__k2r9zo.jm();
  var hunterDominion = _destruct__k2r9zo.km();
  var tmp_2;
  var tmp_3 = $this.t6h().y37_1;
  if (tmp_3 instanceof RegentOfRuinsContract) {
    tmp_2 = to(beastDominion, hunterDominion);
  } else {
    tmp_2 = deadSettlers;
  }
  var additionalStatusInfo = tmp_2;
  var tmp_4 = $this.t6h().d38_1;
  var isTurnNow = tmp_4 instanceof PlayerTurnPhase;
  // Inline function 'kotlin.takeIf' call
  var this_1 = $this.t6h().f38_1;
  var tmp_5;
  if (isTurnNow) {
    tmp_5 = this_1;
  } else {
    tmp_5 = null;
  }
  var tmp0_elvis_lhs = tmp_5;
  var currentTurnNumber = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp_6 = new StatusBarKey($this.t6h().d38_1, $this.t6h().e38_1, currentTurnNumber, additionalStatusInfo);
  yield* $this.vl2_1.zln(tmp_6, VOID, VOID, VOID, KorgeControlAgent$updateStatusBar$slambda($this, deadSettlers, beastDominion, hunterDominion), $completion);
  return Unit_instance;
}
function *updateReplayControlElement($this, $completion) {
  if (get_gameConfiguration().rlc_1) {
    return Unit_instance;
  }
  if (!$this.nml()) {
    if (!($this.pl2_1 == null)) {
      $this.pln().cif($this.pl2_1);
    }
    return Unit_instance;
  }
  if (!($this.pl2_1 == null)) {
    return Unit_instance;
  }
  var playIcon = yield* (yield* $this.pl6().tld(InterfaceIcon_Play_getInstance(), $completion)).m1q($completion);
  var pauseIcon = yield* (yield* $this.pl6().tld(InterfaceIcon_Pause_getInstance(), $completion)).m1q($completion);
  var playStepIcon = yield* (yield* $this.pl6().tld(InterfaceIcon_PlayStep_getInstance(), $completion)).m1q($completion);
  var revertIcon = playStepIcon.kc9(SliceRotation_R180_getInstance());
  var controlPanelX = new ControlPanelX();
  var shouldBeReplayIcon = {_v: true};
  addTo_0(updateReplayControlElement$firstButton(controlPanelX, shouldBeReplayIcon, $this, pauseIcon, playIcon, playIcon), controlPanelX);
  var tmp = get_gameLayout().ml6_1;
  addTo_0(createHoveredIconAction(tmp, playStepIcon, VOID, VOID, KorgeControlAgent$updateReplayControlElement$slambda($this)), controlPanelX);
  var revert = $this.pml();
  if (!(revert == null)) {
    var tmp_0 = get_gameLayout().ml6_1;
    addTo_0(createHoveredIconAction(tmp_0, revertIcon, VOID, VOID, KorgeControlAgent$updateReplayControlElement$slambda_0($this)), controlPanelX);
  }
  var resultContainer = Container.fi2();
  var buttonsContainer = controlPanelX.xlb_1;
  buttonsContainer.fcw(Vector2D.t9g(get_gameLayout().yl5_1, get_gameLayout().yl5_1));
  var tmp2 = buttonsContainer.nig().f9s(Size2D.y9p(get_gameLayout().yl5_1 * 2, get_gameLayout().yl5_1 * 2));
  Companion_getInstance_11();
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var corner = get_gameLayout().sl5_1 / 4;
  var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  var tmp6 = new RGBA(get_gameColors().ylx_1);
  var tmp8 = new RGBA(Colors_getInstance().zc2_1);
  // Inline function 'korlibs.korge.view.roundRect' call
  var strokeThickness = get_gameLayout().rl5_1 / 2;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = RoundRect.rka(tmp2, tmp4, tmp6, tmp8, strokeThickness, true);
  // Inline function 'kotlin.apply' call
  addTo(this_0, resultContainer);
  addTo(buttonsContainer, resultContainer);
  // Inline function 'kotlin.also' call
  resultContainer.fcw(Vector2D.t9g((get_gameLayout().el6_1 - resultContainer.pig()) / 2, get_gameLayout().fl6_1 - resultContainer.rig() - get_gameLayout().yl5_1));
  $this.pln().uie(resultContainer);
  $this.pl2_1 = resultContainer;
  return Unit_instance;
}
function _get_replayRevertFlow__95swe($this) {
  var tmp0 = $this.el4_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('replayRevertFlow', 1, tmp, KorgeControlAgent$_get_replayRevertFlow_$ref_qj8jv3(), null);
  return tmp0.k3();
}
function *updateMainPanel($this, $completion) {
  $this.bl3_1 = $this.zl2_1;
  $this.cl3_1 = $this.al3_1;
  var characterNumber = $this.t6h().i38_1.s2();
  if (get_gameConfiguration().vlc_1) {
    $this.cl3_1 = $this.cl3_1 + get_gameLayout().yl5_1 / 2;
    var tmp = MenuButtonElement_instance;
    var view = yield* $this.vl2_1.zln(tmp, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda($this), $completion);
    updateMainPanel$placeAction($this, MenuButtonElement_instance, view);
  } else {
    $this.cl3_1 = $this.cl3_1 + get_gameLayout().sl5_1;
  }
  // Inline function 'kotlin.run' call
  var viewHeight = 0.0;
  var iterator = $this.t6h().i38_1.p1();
  var index = 0;
  while (iterator.q1()) {
    var i = index;
    index = index + 1 | 0;
    var characterObject = iterator.r1();
    if (i === 0 && characterNumber === 5) {
      $this.bl3_1 = $this.bl3_1 + get_sidePanelCardWidth() / 4;
    }
    var isActiveCharacter_0 = isActiveCharacter($this.t6h(), characterObject);
    var key = new CharacterElement(characterObject);
    var tmp_0 = yield* $this.vl2_1.zln(key, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda_0($this, characterObject), $completion);
    var view_0 = tmp_0 instanceof CardUi ? tmp_0 : THROW_CCE();
    var inactiveBorderColor = isActiveCharacter_0 ? Colors_getInstance().gc5_1 : Colors_getInstance().vc5_1;
    if (!(view_0.olh_1 === inactiveBorderColor)) {
      view_0.olh_1 = inactiveBorderColor;
      view_0.ql8();
    }
    viewHeight = view_0.rig();
    updateMainPanel$needPositionForKey($this, key);
    var shouldBeCardMovementWidth = view_0.pig() * 2 / 3;
    // Inline function 'kotlin.with' call
    var tmp0 = $this.t6h();
    var tmp$ret$4;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp_1 = get_objectType(tmp0, characterObject);
      if (isInterface(tmp_1, BeastCharacter)) {
        tmp$ret$4 = characterObject instanceof ObjectOnBoard ? characterObject : THROW_CCE();
        break $l$block;
      }
      tmp$ret$4 = null;
    }
    var beast = tmp$ret$4;
    if (characterNumber === 5 && !(beast == null)) {
      var mKey = yield* addMovementCardElement($this, beast, $this.vl2_1, true, KorgeControlAgent$updateMainPanel$lambda(shouldBeCardMovementWidth), $completion);
      $this.vl2_1.aly(mKey, Vector2D.t9g($this.bl3_1 + (view_0.pig() - shouldBeCardMovementWidth) / 2, $this.cl3_1 + viewHeight + get_gameLayout().yl5_1));
    }
    if (i === 0 && characterNumber === 5) {
      $this.bl3_1 = $this.bl3_1 + (view_0.pig() + get_gameLayout().yl5_1);
      var hpElementWidth = get_sidePanelCardWidth() / 2;
      // Inline function 'kotlin.with' call
      var $this$with = $this.t6h();
      var commonBeastsWounds = get_sharedBeastWounds($this$with);
      var twoBeastsHpElementKey = new TwoBeastsHpElement(commonBeastsWounds);
      var hpView = yield* $this.vl2_1.zln(twoBeastsHpElementKey, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda_1($this, commonBeastsWounds, hpElementWidth), $completion);
      $this.vl2_1.aly(twoBeastsHpElementKey, Vector2D.t9g($this.bl3_1, $this.cl3_1 + (view_0.rig() - hpView.rig()) / 2));
      $this.bl3_1 = $this.bl3_1 + (hpView.pig() + 2 * get_gameLayout().yl5_1);
    }
    switch (characterNumber) {
      case 1:
      case 2:
      case 3:
      case 4:
        if ((i % 2 | 0) === 0) {
          $this.bl3_1 = $this.bl3_1 + (view_0.pig() + get_gameLayout().yl5_1);
        } else {
          $this.cl3_1 = $this.cl3_1 + (viewHeight + get_gameLayout().yl5_1);
          $this.bl3_1 = $this.zl2_1;
        }

        break;
      case 5:
        switch (i) {
          case 0:
            break;
          case 1:
            $this.cl3_1 = $this.cl3_1 + (viewHeight + get_gameLayout().yl5_1 * 2 + shouldBeCardMovementWidth * get_gameLayout().jl6_1.k9i_1 / get_gameLayout().jl6_1.j9i_1);
            $this.bl3_1 = $this.zl2_1;
            break;
          case 4:
            $this.cl3_1 = $this.cl3_1 + (viewHeight + get_gameLayout().yl5_1);
            $this.bl3_1 = $this.zl2_1;
            break;
          default:
            $this.bl3_1 = $this.bl3_1 + (view_0.pig() + get_gameLayout().yl5_1);
            break;
        }

        break;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Unsupported layout for ' + characterNumber + ' characters';
        throw IllegalStateException.o(toString(message));
    }
  }
  if (characterNumber === 1 || characterNumber === 3) {
    $this.cl3_1 = $this.cl3_1 + (viewHeight + get_gameLayout().yl5_1);
    $this.bl3_1 = $this.zl2_1;
  }
  // Inline function 'kotlin.run' call
  if (get_gameContentVersion($this.t6h().y37_1).h4g()) {
    var tmp_2 = DiscardButtonElement_instance;
    var discardButton = yield* $this.vl2_1.zln(tmp_2, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda_2($this), $completion);
    var tmp_3 = RuinButtonElement_instance;
    var ruinButton = yield* $this.vl2_1.zln(tmp_3, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda_3($this), $completion);
    var fullLen = discardButton.pig() + ruinButton.pig() + get_gameLayout().yl5_1;
    var x = $this.hl2_1.r9g_1 + (get_gameLayout().el6_1 - $this.hl2_1.r9g_1 - fullLen) / 2;
    $this.vl2_1.aly(DiscardButtonElement_instance, Vector2D.t9g(x, $this.cl3_1));
    x = x + (discardButton.pig() + get_gameLayout().yl5_1);
    $this.vl2_1.aly(RuinButtonElement_instance, Vector2D.t9g(x, $this.cl3_1));
    $this.cl3_1 = $this.cl3_1 + (discardButton.rig() + get_gameLayout().yl5_1);
  } else {
    var tmp_4 = DiscardButtonElement_instance;
    var view_1 = yield* $this.vl2_1.zln(tmp_4, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda_4($this), $completion);
    updateMainPanel$placeAction($this, DiscardButtonElement_instance, view_1);
  }
  var isWide = characterNumber === 5;
  // Inline function 'kotlin.run' call
  var offsetYAtStart = $this.cl3_1;
  var maxHeight = 0.0;
  var iterator_0 = get_entries_0().p1();
  var index_0 = 0;
  while (iterator_0.q1()) {
    var index_1 = index_0;
    index_0 = index_0 + 1 | 0;
    var arsenalType = iterator_0.r1();
    if (isWide) {
      $this.bl3_1 = $this.zl2_1;
    } else {
      $this.bl3_1 = index_1 * get_sidePanelCardWidth() + $this.zl2_1;
      $this.cl3_1 = offsetYAtStart;
    }
    var arsenal = $this.t6h().m4l(arsenalType);
    var iterator_1 = arsenal.e36().p1();
    var index_2 = 0;
    while (iterator_1.q1()) {
      var cardIndex = index_2;
      index_2 = index_2 + 1 | 0;
      var card = iterator_1.r1();
      var key_0 = new CardAtSidePanelElement(card, true);
      var view_2 = yield* $this.vl2_1.zln(key_0, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda_5($this, card, arsenal, arsenalType), $completion);
      updateMainPanel$needPositionForKey($this, key_0);
      if (isWide) {
        $this.bl3_1 = $this.bl3_1 + (get_sidePanelCardWidth() + get_gameLayout().yl5_1);
        if (cardIndex === (arsenal.e36().s2() - 1 | 0)) {
          $this.cl3_1 = $this.cl3_1 + (view_2.rig() + get_gameLayout().yl5_1);
        }
      } else {
        $this.cl3_1 = $this.cl3_1 + (view_2.rig() + get_gameLayout().yl5_1);
      }
    }
    var tmp0_0 = maxHeight;
    // Inline function 'kotlin.math.max' call
    var b = $this.cl3_1;
    maxHeight = Math.max(tmp0_0, b);
  }
  $this.bl3_1 = $this.zl2_1;
  $this.cl3_1 = maxHeight + $this.al3_1;
  return Unit_instance;
}
function *updateAdditionalPanel($this, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  $this.fl3_1 = $this.dl3_1;
  $this.gl3_1 = $this.el3_1;
  // Inline function 'kotlin.collections.mutableListOf' call
  var processedCards = ArrayList.p2();
  var _iterator__ex2g4s = $this.t6h().c38_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var context = _iterator__ex2g4s.r1();
    var tmp;
    if (context instanceof CardResolvingScope) {
      tmp = !processedCards.w2(context.p4h_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      if (!equals(last($this.t6h().c38_1), context)) {
        yield* addCardToScope($this, context.p4h_1, $completion);
        processedCards.d2(context.p4h_1);
      }
    }
    if (context instanceof CardApplyingScope) {
      var playableCard = context.i4h_1;
      var tmp_0;
      if (isInterface(playableCard, OverloadedCard)) {
        tmp_0 = playableCard.y3k();
      } else {
        tmp_0 = playableCard;
      }
      var card = tmp_0;
      if (!processedCards.w2(card)) {
        yield* addCardToScope($this, card, $completion);
        processedCards.d2(card);
      }
    }
    if (isInterface(context, ItselfGameScope)) {
      yield* processItselfGameScope($this, $this$with, context, $completion);
    }
    if (context instanceof NightlyRewardScope) {
      var text = get_gameI18n().a71(context.c4j_1);
      yield* processTextGameStateElement($this, context, text, get_gameColors().slx_1, $completion);
    }
    if (context instanceof EventTriggeredByEffectSourceScope) {
      var text_0 = actionSourceText(context.f4i_1);
      yield* processTextGameStateElement($this, context, text_0, get_gameColors().tlx_1, $completion);
    }
  }
  var _iterator__ex2g4s_0 = minus($this$with.l38_1.x4(), processedCards).p1();
  while (_iterator__ex2g4s_0.q1()) {
    var card_0 = _iterator__ex2g4s_0.r1();
    yield* addCardToScope($this, card_0, $completion);
  }
  var _iterator__ex2g4s_1 = minus($this$with.k38_1, processedCards).p1();
  while (_iterator__ex2g4s_1.q1()) {
    var card_1 = _iterator__ex2g4s_1.r1();
    yield* addCardToScope($this, card_1, $completion);
  }
  if ($this.bm5()) {
    yield* updateSpecialSetupAdditionalPanel($this, $completion);
  }
  return Unit_instance;
}
function *updateSpecialSetupAdditionalPanel($this, $completion) {
  var specialSetupMode = $this.sm1();
  if (equals(specialSetupMode, SandboxInit_instance)) {
    yield* addTemporaryView($this, ActionButton.vlb('Start sandbox game', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$updateSpecialSetupAdditionalPanel$slambda($this)), $completion);
  } else {
    if (specialSetupMode instanceof MasterFixing) {
      yield* addTemporaryView($this, ActionButton.vlb('Finish master fixing', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$updateSpecialSetupAdditionalPanel$slambda_0($this)), $completion);
    } else {
      if (specialSetupMode != null) {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function *processItselfGameScope($this, $context_GameState_t6qee5, context, $completion) {
  if (context instanceof InAnyOrderStatement)
    return Unit_instance;
  if (context instanceof ReceiveSelfDamageStatement)
    return Unit_instance;
  var tmp;
  if (isInterface(context, ActionStatement)) {
    tmp = withStateRuntime($context_GameState_t6qee5, $this, KorgeControlAgent$processItselfGameScope$lambda(context));
  } else {
    if (isInterface(context, GamePhase)) {
      tmp = phaseText($context_GameState_t6qee5, context);
    } else {
      if (context instanceof PhaseRecoveryScope) {
        tmp = 'Phase recovery: ' + phaseText($context_GameState_t6qee5, context.u4i_1);
      } else {
        if (context instanceof EffectRecoveryScope) {
          var failedScope = context.k4i_1;
          var tmp_0;
          if (failedScope instanceof CardResolvingScope) {
            tmp_0 = 'Card effect recovery';
          } else {
            if (failedScope instanceof EventTriggeredByEffectSourceScope) {
              tmp_0 = 'Trigger recovery';
            } else {
              if (failedScope instanceof EffectsAfterEventScope) {
                tmp_0 = 'Event effects recovery';
              } else {
                if (failedScope instanceof PerformForEachHunter) {
                  tmp_0 = 'Character effect recovery';
                } else {
                  if (failedScope instanceof NightlyRewardScope) {
                    tmp_0 = 'Night reward recovery: ' + get_gameI18n().m70(failedScope.c4j_1);
                  } else {
                    if (failedScope instanceof TextItselfGameScope) {
                      tmp_0 = 'Recovery: ' + failedScope.y4i_1;
                    } else {
                      tmp_0 = 'Effect recovery';
                    }
                  }
                }
              }
            }
          }
          tmp = tmp_0;
        } else {
          if (context instanceof ChooseSettlerForFlareScope) {
            tmp = get_gameI18n().s6z_1;
          } else {
            if (context instanceof TextItselfGameScope) {
              tmp = context.y4i_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  var text = tmp;
  yield* processTextGameStateElement($this, context, text, get_gameColors().slx_1, $completion);
  return Unit_instance;
}
function *processTextGameStateElement($this, context, text, background, $completion) {
  var key = new TextGameScopeElement(context);
  var where = Vector2D.t9g($this.fl3_1, $this.gl3_1);
  var animation = KorgeControlAgent$processTextGameStateElement$slambda($this);
  var view = yield* $this.vl2_1.zln(key, where, VOID, animation, KorgeControlAgent$processTextGameStateElement$slambda_0($this, text, background), $completion);
  $this.gl3_1 = $this.gl3_1 + (view.rig() + get_gameLayout().yl5_1);
  return Unit_instance;
}
function notificationSideTextElement($this, text, background) {
  return toHeight(notificationElement(text, background, false), get_gameLayout().vl5_1);
}
function *addCardToScope($this, card, $completion) {
  var isInPlayArea = $this.t6h().l38_1.u4(card);
  var key = new CardAtSidePanelElement(card, isInPlayArea);
  var view = yield* $this.vl2_1.zln(key, VOID, VOID, VOID, KorgeControlAgent$addCardToScope$slambda($this, card), $completion);
  if (!isInPlayArea) {
    view.sig(0.5);
  }
  $this.vl2_1.aly(key, Vector2D.t9g($this.fl3_1, $this.gl3_1));
  $this.gl3_1 = $this.gl3_1 + (view.rig() + get_gameLayout().yl5_1);
  return Unit_instance;
}
function *addTemporaryView($this, $receiver, $completion) {
  position_0($receiver, Vector2D.t9g($this.fl3_1, $this.gl3_1));
  $this.ml2_1.uie($receiver);
  yield* animateSideElement($this, $receiver, $this.gl3_1, $completion);
  $this.gl3_1 = $this.gl3_1 + ($receiver.rig() + get_gameLayout().yl5_1);
  $this.ul2_1.d2($receiver);
  return $receiver;
}
function *animateSideElement($this, view, endYOffset, $completion) {
  if (get_gameConfiguration().olc_1)
    return Unit_instance;
  var tmp = KMutableProperty0;
  var tmp_0 = View$_get_y_$ref_usqum0(view);
  // Inline function 'korlibs.korge.tween.get' call
  var tmp0 = getPropertyCallableRef('y', 0, tmp, tmp_0, View$_set_y_$ref_18dlvg(view));
  var tmp2 = numberToDouble(0);
  // Inline function 'korlibs.korge.tween.get' call
  var end = numberToDouble(endYOffset);
  var tmp_1 = new V2(tmp0, tmp2, end, _interpolate$ref(), true);
  var tmp_2 = KMutableProperty0;
  var tmp_3 = View$_get_alpha_$ref_oftner(view);
  // Inline function 'korlibs.korge.tween.get' call
  var this_0 = getPropertyCallableRef('alpha', 0, tmp_2, tmp_3, View$_set_alpha_$ref_4v0szt(view));
  var tmp0_vs = [tmp_1, new V2(this_0, 0.0, 1.0, _interpolate$ref(), true)];
  var tmp1_easing = get_gameAnimations().ll4_1;
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp2_time = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  yield* tween(view, tmp0_vs, tmp2_time, tmp1_easing, VOID, VOID, VOID, VOID, $completion);
  return Unit_instance;
}
function removeTemporaryView($this, v) {
  $this.ml2_1.cif(v);
}
function _get_choiceFlow__u1vu9o($this) {
  var tmp0 = $this.hl4_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('choiceFlow', 1, tmp, KorgeControlAgent$_get_choiceFlow_$ref_dowiyj(), null);
  return tmp0.k3();
}
function *chooseInternal($this, $context_GameStateRuntime_604ce3, gameQuestion, mayNothing, onInstalled, $completion) {
  updateGameAnimationParameters($this, new ControllingByTeam($this.k3q()));
  return yield* _get_choiceFlow__u1vu9o($this).kdx($context_GameStateRuntime_604ce3, gameQuestion, mayNothing, VOID, onInstalled, $completion);
}
function *showWrongAnswerMessage($this, $completion) {
  var awaitDeferred = CompletableDeferred_0();
  var panel = new ControlPanelY();
  addTo_0(PlainText('The replay has another answer', get_gameLayout().vl5_1), panel);
  addTo_0(PlainText('It can be replayed by the buttons below', get_gameLayout().vl5_1), panel);
  var tmp = $this.pln();
  var gameDialog = GameDialog.xlq(tmp, panel.xlb_1, VOID, KorgeControlAgent$showWrongAnswerMessage$slambda(awaitDeferred));
  gameDialog.ylq();
  yield* awaitDeferred.m1q($completion);
  return Unit_instance;
}
function *addRestoreDialogButtonIfNeeded($this, highlightCoroutineScope, $completion) {
  highlightCoroutineScope = highlightCoroutineScope === VOID ? $this.jl2_1 : highlightCoroutineScope;
  var tmp0 = $this.ul2_1;
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.bhq_1 === get_gameI18n().w6y_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  if (tmp$ret$0)
    return Unit_instance;
  // Inline function 'kotlin.apply' call
  var this_0 = ActionButton.vlb('Answer Dialog', VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$addRestoreDialogButtonIfNeeded$slambda($this));
  this_0.bhq_1 = get_gameI18n().w6y_1;
  var button = yield* /*#__NOINLINE__*/addTemporaryView($this, this_0, $completion);
  launch(highlightCoroutineScope, VOID, VOID, KorgeControlAgent$addRestoreDialogButtonIfNeeded$slambda_0($this, button));
  return Unit_instance;
}
function *chooseAncientPowerNumber($this, ancientPowerNumber, result, $completion) {
  var controlPanelX = new ControlPanelX();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var inductionVariable = 0;
  if (inductionVariable <= ancientPowerNumber)
    do {
      var ap = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (ap === 0) {
        var tmp = get_gameI18n().c6z_1;
        // Inline function 'kotlin.also' call
        var this_0 = addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$chooseAncientPowerNumber$slambda(result, ap)), controlPanelX);
        var tmp2 = ap;
        // Inline function 'kotlin.collections.set' call
        var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
        m.b5(tmp2, value);
      } else {
        var picture = yield* (yield* $this.pl6().vle(GeneralTokens_AncientPower_getInstance(), $completion)).m1q($completion);
        var image = Image.lk7(picture, Companion_getInstance_7().f9g_1);
        var s = image.s2();
        var add = s.l9s(10);
        var tmp_0 = s.f9s(add);
        Companion_getInstance_11();
        // Inline function 'korlibs.math.geom.Companion.invoke' call
        var corner = s.j9i_1 / 5;
        var tmp$ret$4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
        var r = RoundRect.rka(tmp_0, tmp$ret$4);
        r.ijb(Companion_getInstance_7().f9g_1);
        var tmp_1 = KorgeControlAgent$chooseAncientPowerNumber$clickable$1.bmo(r);
        // Inline function 'kotlin.also' call
        var this_1 = addClickOption(tmp_1, KorgeControlAgent$chooseAncientPowerNumber$slambda_0(result, ap));
        var tmp2_0 = ap;
        // Inline function 'kotlin.collections.set' call
        var value_0 = new AutoHighlight(this_1, Vector2D.d9t(this_1.s2().j9i_1 / 2, 0));
        m.b5(tmp2_0, value_0);
        var clickable = this_1;
        // Inline function 'kotlin.apply' call
        var this_2 = Container.fi2();
        this_2.uie(clickable);
        this_2.uie(image);
        image.rif(add.j9i_1 / 2);
        addTo_0(toHeight(this_2, get_gameLayout().ol5_1), controlPanelX);
      }
    }
     while (!(ap === ancientPowerNumber));
  $this.rln(m);
  yield* $this.cmo(controlPanelX.xlb_1, get_gameI18n().d6z_1, VOID, $completion);
  return Unit_instance;
}
function *chooseTrapByNumberNumber($this, gameQuestion, result, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var numberOfTrapsInZone = gameQuestion.h4b_1;
  var inductionVariable = 1;
  if (inductionVariable <= numberOfTrapsInZone)
    do {
      var trapNumber = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = get_gameI18n().w70(trapNumber);
      // Inline function 'kotlin.also' call
      var this_0 = addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$chooseTrapByNumberNumber$slambda(result, trapNumber)), controlPanelY);
      var tmp2 = trapNumber;
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
      m.b5(tmp2, value);
    }
     while (!(trapNumber === numberOfTrapsInZone));
  $this.rln(m);
  yield* $this.cmo(controlPanelY.xlb_1, get_gameI18n().r6z_1, VOID, $completion);
  return Unit_instance;
}
function *chooseZoneQuestion($this, variants, mayNothing, result, questionContext, $completion) {
  if (!$this.t6h().y37_1.h3a().equals(GameMapId_NorthernExpanse_getInstance()) && !$this.t6h().y37_1.h3a().equals(GameMapId_DrenchedLands_getInstance())) {
    reportWarning($this, 'Zone question is not supported for current map');
    yield* playDefaultVariant($this, variants, mayNothing, result, questionContext, $completion);
    return Unit_instance;
  }
  var tmp;
  switch ($this.t6h().y37_1.h3a().w1_1) {
    case 1:
      tmp = listOf([listOf_0(Zone_Barum_getInstance()), listOf_0(Zone_Vildmark_getInstance())]);
      break;
    case 0:
      tmp = listOf([listOf([Zone_Barum_getInstance(), Zone_NewElda_getInstance()]), listOf([Zone_Vildmark_getInstance(), Zone_Jarlland_getInstance()])]);
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Unknown map';
      throw IllegalStateException.o(toString(message));
  }
  var zones = tmp;
  // Inline function 'kotlin.require' call
  if (!flatten(zones).r4(variants)) {
    var message_0 = 'Variants ' + toString(variants) + ' are not supported';
    throw IllegalArgumentException.h2(toString(message_0));
  }
  var controlPanelX = new ControlPanelX();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var _iterator__ex2g4s = zones.p1();
  while (_iterator__ex2g4s.q1()) {
    var column = _iterator__ex2g4s.r1();
    var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
    var _iterator__ex2g4s_0 = column.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var zone = _iterator__ex2g4s_0.r1();
      var tmp_0 = get_gameI18n().c71(zone);
      var tmp_1 = variants.w2(zone);
      // Inline function 'kotlin.also' call
      var this_0 = addTo_0(ActionButton.vlb(tmp_0, tmp_1, VOID, VOID, VOID, VOID, KorgeControlAgent$chooseZoneQuestion$slambda(result, zone)), controlPanelY);
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
      m.b5(zone, value);
    }
    addTo_0(controlPanelY.xlb_1, controlPanelX);
  }
  if (mayNothing) {
    var tmp_2 = get_gameI18n().c6z_1;
    // Inline function 'kotlin.also' call
    var this_1 = addTo_0(ActionButton.vlb(tmp_2, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$chooseZoneQuestion$slambda_0(result)), controlPanelX);
    // Inline function 'kotlin.collections.set' call
    var value_0 = new AutoHighlight(this_1, toPoint(this_1.s2().l9s(2)));
    m.b5(NullVariant_instance, value_0);
  }
  $this.rln(m);
  yield* $this.cmo(controlPanelX.xlb_1, get_gameI18n().k6z_1, VOID, $completion);
  return Unit_instance;
}
function *chooseCharacter($this, variants, result, $completion) {
  var tmp = $this.pl6();
  yield* chooseCharacter_0(tmp, variants, result, VOID, KorgeControlAgent$chooseCharacter$slambda($this), $completion);
  return Unit_instance;
}
function *simpleChooseCharacter($this, variants, result, $completion) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var _iterator__ex2g4s = variants.p1();
  while (_iterator__ex2g4s.q1()) {
    var character = _iterator__ex2g4s.r1();
    yield* $this.pl6().qle(character, VOID, $completion);
  }
  var controlPanelX = new ControlPanelX();
  var _iterator__ex2g4s_0 = variants.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var character_0 = _iterator__ex2g4s_0.r1();
    var controlPanelY = new ControlPanelY();
    var characterPicture = yield* (yield* $this.pl6().qle(character_0, VOID, $completion)).m1q($completion);
    // Inline function 'kotlin.also' call
    var this_0 = addTo_0(toHeight(CardUi.tm1(characterPicture, VOID, VOID, VOID, VOID, KorgeControlAgent$simpleChooseCharacter$slambda(result, character_0)), get_gameLayout().ol5_1), controlPanelY);
    // Inline function 'kotlin.collections.set' call
    var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
    m.b5(character_0, value);
    controlPanelY.mlr(BorderedText(toString(character_0), get_gameLayout().vl5_1));
    controlPanelY.flr();
    addTo_0(controlPanelY.xlb_1, controlPanelX);
  }
  $this.rln(m);
  yield* $this.cmo(controlPanelX.xlb_1, 'Pick character', VOID, $completion);
  return Unit_instance;
}
function *playTriggersVariant($this, gameQuestion, mayNothing, result, $completion) {
  var variants = gameQuestion.m4b_1;
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!variants.n1()) {
    tmp = 'Choose trigger to play';
  } else {
    tmp = 'No trigger to play but it theoretically might be';
  }
  var text = tmp;
  var tmp_0;
  if (variants.n1()) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = gameQuestion.n4b_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$3 = item.s4c_1;
      destination.d2(tmp$ret$3);
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = distinct(destination);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var tmp_1;
      if (isInterface(item_0, ReactionCardTriggerEffectSource)) {
        var picture = yield* (yield* $this.pl6().mle(item_0.s3w(), $completion)).m1q($completion);
        var tmp_2 = item_0.s3w();
        // Inline function 'kotlin.also' call
        var this_2 = toHeight(CardUi.tm1(picture, VOID, tmp_2, false, VOID, KorgeControlAgent$playTriggersVariant$slambda()), get_gameLayout().ol5_1);
        this_2.sig(0.6);
        tmp_1 = this_2;
      } else {
        if (item_0 instanceof PossibleTrapEffectSource) {
          var picture_0 = yield* (yield* $this.pl6().vle(GeneralTokens_TrapSign_getInstance(), $completion)).m1q($completion);
          // Inline function 'kotlin.also' call
          var this_3 = toHeight(CardUi.tm1(picture_0, VOID, VOID, false, VOID, KorgeControlAgent$playTriggersVariant$slambda_0()), get_gameLayout().ol5_1);
          this_3.sig(0.6);
          tmp_1 = this_3;
        } else {
          if (item_0 instanceof PossibleMistShroudEffectSource) {
            var picture_1 = yield* (yield* $this.pl6().mle(MistShroudCard_getInstance(), $completion)).m1q($completion);
            var tmp_3 = MistShroudCard_getInstance();
            // Inline function 'kotlin.also' call
            var this_4 = toHeight(CardUi.tm1(picture_1, VOID, tmp_3, false, VOID, KorgeControlAgent$playTriggersVariant$slambda_1()), get_gameLayout().ol5_1);
            this_4.sig(0.6);
            tmp_1 = this_4;
          } else {
            if (item_0 instanceof PossibleSnareEffectSource) {
              var picture_2 = yield* (yield* $this.pl6().vle(GeneralTokens_SnareTrap_getInstance(), $completion)).m1q($completion);
              // Inline function 'kotlin.also' call
              var this_5 = new ControlPanelX();
              // Inline function 'kotlin.also' call
              addTo_0(toHeight(Image.lk7(picture_2), get_gameLayout().ul5_1), this_5).sig(0.6);
              addTo_0(BorderedText('Snare Trap', get_gameLayout().ul5_1), this_5);
              this_5.flr();
              tmp_1 = this_5.xlb_1;
            } else {
              tmp_1 = BorderedText(splitCamelCase(toString_0(getKClassFromExpression(item_0).j1())), get_gameLayout().ul5_1);
            }
          }
        }
      }
      var tmp$ret$6 = tmp_1;
      destination_0.d2(tmp$ret$6);
    }
    tmp_0 = destination_0;
  } else {
    tmp_0 = emptyList();
  }
  var additionalViews = tmp_0;
  var cornerText = ensureNotNull(dialogCornerText(text));
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!additionalViews.n1()) {
    var controlPanelY = new ControlPanelY();
    addTo_0(cornerText, controlPanelY);
    var _iterator__ex2g4s_1 = additionalViews.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var additional = _iterator__ex2g4s_1.r1();
      addTo_0(additional, controlPanelY);
    }
    tmp_4 = controlPanelY.xlb_1;
  } else {
    tmp_4 = cornerText;
  }
  var cornerView = tmp_4;
  yield* playDefaultVariantImpl($this, variants, mayNothing, result, cornerView, $completion);
  return Unit_instance;
}
function *playBooleanVariant($this, variants, mayNothing, result, text, $completion) {
  yield* playDefaultVariantImpl($this, variants, mayNothing, result, dialogCornerText(text), $completion);
  return Unit_instance;
}
function *playDefaultVariant($this, variants, mayNothing, result, questionContext, $completion) {
  var tmp;
  if (questionContext == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = dialogCornerText(get_gameI18n().h71(questionContext));
  }
  var cornerView = tmp;
  yield* playDefaultVariantImpl($this, variants, mayNothing, result, cornerView, $completion);
  return Unit_instance;
}
function *playDefaultVariantImpl($this, variants, mayNothing, result, cornerTextView, $completion) {
  var cornerView = cornerTextView;
  var controlPanelY = new ControlPanelY();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = variants.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof TriggerOption) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp;
    var tmp_0 = element_0.l4c_1;
    if (isInterface(tmp_0, ApplyingReactionStatement)) {
      tmp = true;
    } else {
      var tmp_1 = element_0.l4c_1;
      tmp = tmp_1 instanceof ActivateTrapStatement;
    }
    if (tmp) {
      destination_0.d2(element_0);
    }
  }
  var applyReactionVariants = destination_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!applyReactionVariants.n1()) {
    var controlPanelX = new ControlPanelX();
    var _iterator__ex2g4s_1 = applyReactionVariants.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var applyReactionVariant = _iterator__ex2g4s_1.r1();
      var actionStatement = applyReactionVariant.l4c_1;
      var tmp0_safe_receiver = isInterface(actionStatement, ApplyingReactionStatement) ? actionStatement : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2t();
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        tmp_2 = (actionStatement instanceof ActivateTrapStatement ? actionStatement : THROW_CCE()).v2s_1;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var cardToShow = tmp_2;
      var tmp_3 = yield* (yield* $this.pl6().mle(cardToShow, $completion)).m1q($completion);
      // Inline function 'kotlin.also' call
      var this_0 = addTo_0(toHeight(CardUi.tm1(tmp_3, VOID, cardToShow, VOID, VOID, KorgeControlAgent$playDefaultVariantImpl$slambda(result, applyReactionVariant)), get_gameLayout().ol5_1), controlPanelX);
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
      m.b5(applyReactionVariant, value);
    }
    addTo_0(controlPanelX.xlb_1, controlPanelY);
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = $this.t6h().c38_1;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_1 = ArrayList.p2();
    var _iterator__ex2g4s_2 = tmp0.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_1 = _iterator__ex2g4s_2.r1();
      if (element_1 instanceof EffectsAfterEventScope) {
        destination_1.d2(element_1);
      }
    }
    var tmp0_safe_receiver_0 = lastOrNull(destination_1);
    var event = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.a4i_1;
    if (event instanceof SubmitDamageEvent) {
      cornerView = yield* damageCornerMessage($this, event.y5a_1, $completion);
    }
    if (event instanceof AssignDamageEvent) {
      cornerView = yield* damageCornerMessage($this, event.f54_1, $completion);
    }
  }
  var justGeneralVariants = minus(variants, applyReactionVariants);
  var tmp_4;
  if (mayNothing) {
    tmp_4 = listOf_0(null);
  } else {
    // Inline function 'kotlin.collections.listOf' call
    tmp_4 = emptyList();
  }
  var _iterator__ex2g4s_3 = plus_2(justGeneralVariants, tmp_4).p1();
  while (_iterator__ex2g4s_3.q1()) {
    var variant = _iterator__ex2g4s_3.r1();
    var tmp_5;
    if (variant instanceof SummonSignStatement) {
      var tmp_6 = yield* (yield* $this.pl6().vle(GeneralTokens_SummonActivation_getInstance(), $completion)).m1q($completion);
      tmp_5 = toHeight(CardUi.tm1(tmp_6, VOID, VOID, VOID, VOID, KorgeControlAgent$playDefaultVariantImpl$slambda_0(result, variant)), get_gameLayout().sl5_1 * 3);
    } else {
      var tmp_7 = variantToString($this, variant);
      tmp_5 = ActionButton.vlb(tmp_7, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$playDefaultVariantImpl$slambda_1(result, variant));
    }
    // Inline function 'kotlin.also' call
    var this_1 = addTo_0(tmp_5, controlPanelY);
    var tmp2 = variant == null ? NullVariant_instance : variant;
    // Inline function 'kotlin.collections.set' call
    var value_0 = new AutoHighlight(this_1, toPoint(this_1.s2().l9s(2)));
    m.b5(tmp2, value_0);
  }
  $this.rln(m);
  yield* $this.dmo(controlPanelY.xlb_1, cornerView, VOID, $completion);
  return Unit_instance;
}
function *damageCornerMessage($this, dealingDamage, $completion) {
  var controlPanelY = new ControlPanelY();
  var _iterator__ex2g4s = dealingDamage.e3s_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var hitInstance = _iterator__ex2g4s.r1();
    var controlPanelX = new ControlPanelX();
    var messageHeight = get_gameLayout().ul5_1;
    // Inline function 'kotlin.with' call
    var $this$with = $this.t6h();
    var targetImage = yield* (yield* $this.pl6().ole($this$with, hitInstance.r3s_1, $completion)).m1q($completion);
    addTo_0(toHeight(Image.lk7(targetImage), messageHeight), controlPanelX);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!dealingDamage.e3s_1.n1()) {
      addTo_0(BorderedText('will be damaged for', messageHeight), controlPanelX);
    }
    // Inline function 'kotlin.repeat' call
    var times = hitInstance.s3s_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        addTo_0(toHeight(Image.lk7(yield* (yield* $this.pl6().vle(GeneralTokens_OneDamage_getInstance(), $completion)).m1q($completion)), messageHeight), controlPanelX);
      }
       while (inductionVariable < times);
    addTo_0(controlPanelX.xlb_1, controlPanelY);
  }
  return controlPanelY.xlb_1;
}
function *choosePlayOrDiscardVariant($this, characterObject, variants, result, $completion) {
  $this.xl2_1 = new TurnVariantRequest(characterObject, variants, result);
  yield* showCardsInHand($this, characterObject, VOID, $completion);
  return Unit_instance;
}
function *chooseObjectVariant($this, targets, mayNothing, result, questionContext, questionCoroutineScope, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap.m7();
  var _iterator__ex2g4s = targets.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var key = new BoardPosition(element.s2w($this$with));
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.w4(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList.p2();
      destination.b5(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.d2(element);
  }
  var targetPositions = destination;
  var tmp_0;
  var tmp_1;
  if (targetPositions.s2() === 1) {
    tmp_1 = true;
  } else {
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_2;
      if (isInterface(targets, Collection)) {
        tmp_2 = targets.n1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$7 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = targets.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        var tmp_3 = get_objectType($this$with, element_0);
        if (!isInterface(tmp_3, Character)) {
          tmp$ret$7 = false;
          break $l$block_0;
        }
      }
      tmp$ret$7 = true;
    }
    tmp_1 = tmp$ret$7;
  }
  if (tmp_1) {
    yield* targetsDialog($this, $this$with, targets, result, mayNothing, questionContext, $completion);
    tmp_0 = true;
  } else {
    var moveButton = {_v: null};
    if (mayNothing) {
      var tmp_4 = get_gameI18n().a6z_1;
      moveButton._v = yield* /*#__NOINLINE__*/addTemporaryView($this, ActionButton.vlb(tmp_4, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$chooseObjectVariant$slambda($this, result)), $completion);
    }
    $this.emo();
    var tmp_5 = targetPositions.x4();
    var tmp_6 = KorgeControlAgent$chooseObjectVariant$lambda(targetPositions);
    $this.gl2_1.lln(questionCoroutineScope, tmp_5, tmp_6, KorgeControlAgent$chooseObjectVariant$slambda_0(targetPositions, moveButton, $this, result, $this$with, questionContext));
    var contextLabelText = get_gameI18n().h71(questionContext);
    if (!(contextLabelText == null)) {
      yield* /*#__NOINLINE__*/addTemporaryView($this, notificationSideTextElement($this, contextLabelText, get_gameColors().slx_1), $completion);
    }
    tmp_0 = false;
  }
  return tmp_0;
}
function *targetsDialog($this, $receiver, targets, result, needAddNothingVariant, questionContext, $completion) {
  var controlPanelX = new ControlPanelX();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var _iterator__ex2g4s = targets.p1();
  while (_iterator__ex2g4s.q1()) {
    var target = _iterator__ex2g4s.r1();
    var container = yield* targetObjectView($receiver, $this, target, $completion);
    // Inline function 'kotlin.also' call
    var this_0 = addTo_0(toHeight(RoundButton.fmo(container, VOID, VOID, VOID, KorgeControlAgent$targetsDialog$slambda(result, target)), get_gameLayout().ll6_1), controlPanelX);
    // Inline function 'kotlin.collections.set' call
    var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
    m.b5(target, value);
  }
  if (needAddNothingVariant) {
    addNothingVariant($this, result, controlPanelX, m);
  }
  $this.rln(m);
  yield* $this.cmo(controlPanelX.xlb_1, get_gameI18n().h71(questionContext), VOID, $completion);
  return Unit_instance;
}
function addNothingVariant($this, result, controlPanelX, m, nothingText) {
  nothingText = nothingText === VOID ? get_gameI18n().a6z_1 : nothingText;
  var nothingButton = addTo_0(ActionButton.vlb(nothingText, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$addNothingVariant$slambda(result)), controlPanelX);
  // Inline function 'kotlin.collections.set' call
  var value = new AutoHighlight(nothingButton, toPoint(nothingButton.s2().l9s(2)));
  m.b5(NullVariant_instance, value);
}
function *chooseLocationVariant($this, locationQuestion, mayNothing, result, questionCoroutineScope, $completion) {
  var tmp;
  if (locationQuestion instanceof TransformLocationQuestion) {
    tmp = new Pair(get_gameI18n().l6z_1, get_gameI18n().m6z_1);
  } else {
    if (locationQuestion instanceof PlaceNewObjectQuestion) {
      tmp = new Pair(get_gameI18n().r70(locationQuestion.r49_1), get_gameI18n().m6z_1);
    } else {
      if (locationQuestion instanceof GrapnelQuestion) {
        tmp = new Pair(get_gameI18n().n6z_1, get_gameI18n().m6z_1);
      } else {
        if (locationQuestion instanceof SearchLocationQuestion) {
          tmp = new Pair(get_gameI18n().o6z_1, get_gameI18n().m6z_1);
        } else {
          if (locationQuestion instanceof BarrierConnectedLocationQuestion) {
            tmp = new Pair('Choose a connected location to place a Barrier between', get_gameI18n().m6z_1);
          } else {
            tmp = new Pair(get_gameI18n().h71(locationQuestion.t3o()), get_gameI18n().m6z_1);
          }
        }
      }
    }
  }
  var _destruct__k2r9zo = tmp;
  var text = _destruct__k2r9zo.jm();
  var enoughText = _destruct__k2r9zo.km();
  var locationVariants = locationQuestion.s3o();
  yield* chooseLocation($this, text, mayNothing, enoughText, result, locationVariants, questionCoroutineScope, VOID, $completion);
  return Unit_instance;
}
function *chooseMovementVariant($this, gameQuestion, mayNothing, result, questionCoroutineScope, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  var movedObject = gameQuestion.y48_1;
  var currentPosition = movedObject == null ? null : movedObject.s2w($this$with);
  var intermediatePosition = last(gameQuestion.z48_1).r2v_1;
  var tmp;
  var tmp_0 = currentPosition;
  if (!((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null)) {
    var tmp_1 = currentPosition;
    tmp = !equals(tmp_1 == null ? null : new BoardPosition(tmp_1), new BoardPosition(intermediatePosition));
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* $this.gl2_1.iln(movedObject, intermediatePosition, $completion);
  }
  if (!(movedObject == null)) {
    $this.gl2_1.kln(movedObject, questionCoroutineScope);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = gameQuestion.x48_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$4 = new BoardPosition(item.v3g_1);
    destination.d2(tmp$ret$4);
  }
  var locationVariants = toSet(destination);
  // Inline function 'kotlin.takeIf' call
  var this_1 = get_gameI18n().q6z_1;
  var tmp_2;
  if (gameQuestion.a49_1) {
    tmp_2 = this_1;
  } else {
    tmp_2 = null;
  }
  var tmp$ret$5 = tmp_2;
  yield* chooseLocation($this, tmp$ret$5, mayNothing, get_gameI18n().z6y_1, result, locationVariants, questionCoroutineScope, gameQuestion.a49_1, $completion);
  return Unit_instance;
}
function *chooseLocation($this, text, mayNothing, enoughText, result, locationVariants, questionCoroutineScope, showTextWhenMoving, $completion) {
  showTextWhenMoving = showTextWhenMoving === VOID ? false : showTextWhenMoving;
  // Inline function 'kotlin.let' call
  var it = last($this.t6h().c38_1);
  var tmp;
  var tmp_0;
  if (isInterface(it, ObjectMovementStatement)) {
    tmp_0 = true;
  } else {
    tmp_0 = it instanceof PlaceNewSummonStatement;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = it instanceof RelocationToSettlementStatement;
  }
  var isMovingStatementAlready = tmp;
  var infoText = isMovingStatementAlready && !showTextWhenMoving || text == null ? null : (yield* /*#__NOINLINE__*/addTemporaryView($this, notificationSideTextElement($this, text, get_gameColors().slx_1), $completion));
  var enoughButton = {_v: null};
  if (mayNothing) {
    enoughButton._v = yield* /*#__NOINLINE__*/addTemporaryView($this, ActionButton.vlb(enoughText, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$chooseLocation$slambda(infoText, $this, result)), $completion);
  }
  $this.emo();
  $this.gl2_1.mln(questionCoroutineScope, locationVariants, VOID, KorgeControlAgent$chooseLocation$slambda_0(infoText, $this, enoughButton, result));
  return Unit_instance;
}
function *showDraftWaitingDialog($this, $completion) {
  var tmp0_elvis_lhs = $this.t6h().p38_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    $this.dl4_1 = null;
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var draft = tmp;
  if (get_isObserver($this.k3q())) {
    // Inline function 'kotlin.with' call
    var $this$with = $this.t6h();
    var tmp_0 = get_gameI18n();
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$with.i38_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$6 = new GameTeam(get_gameTeam($this$with, item));
      destination.d2(tmp$ret$6);
    }
    var message = tmp_0.o70(draft, destination);
    if (!(message === $this.dl4_1)) {
      $this.dl4_1 = message;
      yield* animateNotification($this, message, $completion);
    }
    return Unit_instance;
  }
  if (!(_get_currentQuestionUiJob__7ts88v($this) == null))
    return Unit_instance;
  // Inline function 'kotlin.with' call
  var $this$with_0 = $this.t6h();
  var tmp_1;
  if (!(draft.u4m_1 == null)) {
    tmp_1 = 'Draft in progress';
  } else {
    if (draft.r4m_1.n1()) {
      tmp_1 = 'Draft choices complete';
    } else {
      var tmp0 = draft.r4m_1;
      var tmp$ret$9;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_2;
        if (isInterface(tmp0, Collection)) {
          tmp_2 = tmp0.n1();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$9 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element = _iterator__ex2g4s_0.r1();
          if (get_gameTeam($this$with_0, $this$with_0.i38_1.u2(element)) === $this.k3q()) {
            tmp$ret$9 = false;
            break $l$block_0;
          }
        }
        tmp$ret$9 = true;
      }
      if (tmp$ret$9) {
        tmp_1 = get_gameI18n().l70(get_anotherTeam($this.k3q()));
      } else {
        tmp_1 = 'Draft in progress';
      }
    }
  }
  var message_0 = tmp_1;
  yield* showDraftDialog($this, draft, message_0, VOID, VOID, $completion);
  $this.yl3_1 = true;
  var tmp_3 = $this;
  tmp_3.il4_1 = KorgeControlAgent$showDraftWaitingDialog$slambda($this);
  yield* /*#__NOINLINE__*/addRestoreDialogButtonIfNeeded($this, VOID, $completion);
  return Unit_instance;
}
function draftDialogMessage($this, draft, message) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  var tmp;
  var tmp_0;
  if (draft.u4m_1 == null) {
    var tmp0 = draft.r4m_1;
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection)) {
        tmp_1 = tmp0.n1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$2 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (get_gameTeam($this$with, $this$with.i38_1.u2(element)) === get_anotherTeam($this.k3q())) {
          tmp$ret$2 = false;
          break $l$block_0;
        }
      }
      tmp$ret$2 = true;
    }
    tmp_0 = tmp$ret$2;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = message + '\n' + get_gameI18n().n70(get_anotherTeam($this.k3q()));
  } else {
    tmp = message;
  }
  return tmp;
}
function *draftCardsDialog($this, gameQuestion, result, $completion) {
  $this.ol3_1 = toSet(gameQuestion.g48_1);
  var tmp0 = $this.t6h().p38_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = 'Draft question without draft state';
      throw IllegalArgumentException.h2(toString(message));
    } else {
      tmp$ret$0 = tmp0;
      break $l$block;
    }
  }
  var draft = tmp$ret$0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = sorted(draft.r4m_1);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var availableCards = draft.s4m_1 ? draft.p4m_1.u2(element) : draft.o4m_1.u2(element);
    var tmp;
    // Inline function 'kotlin.with' call
    var $this$with = $this.t6h();
    if (get_gameTeam($this$with, $this$with.i38_1.u2(element)) === $this.k3q()) {
      var tmp$ret$7;
      $l$block_1: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(availableCards, Collection)) {
          tmp_0 = availableCards.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$7 = false;
          break $l$block_1;
        }
        var _iterator__ex2g4s_0 = availableCards.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (gameQuestion.g48_1.w2(element_0)) {
            tmp$ret$7 = true;
            break $l$block_1;
          }
        }
        tmp$ret$7 = false;
      }
      tmp = tmp$ret$7;
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.d2(element);
    }
  }
  var candidateIndices = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!!candidateIndices.n1()) {
    var message_0 = 'Draft question has no candidate character rows';
    throw IllegalArgumentException.h2(toString(message_0));
  }
  // Inline function 'kotlin.with' call
  var $this$with_0 = $this.t6h();
  var targetName = equals(draft.u4m_1, TwoPlayerDraftStage_Collecting_getInstance()) && $this.k3q() === get_huntersGameTeam() ? 'Hunters' : candidateIndices.s2() > 1 ? get_gameI18n().m70($this.k3q()) : get_gameI18n().s70(get_objectType($this$with_0, $this$with_0.i38_1.u2(first(candidateIndices))));
  var tmp_1;
  if (draft.s4m_1) {
    tmp_1 = draft.t4m_1 ? get_gameI18n().q70(targetName) : get_gameI18n().p70(targetName);
  } else {
    tmp_1 = get_gameI18n().k70(targetName);
  }
  var message_1 = tmp_1;
  yield* showDraftDialog($this, draft, message_1, gameQuestion.g48_1, KorgeControlAgent$draftCardsDialog$lambda(result), $completion);
  return Unit_instance;
}
function *showDraftDialog($this, draft, message, variants, onChoose, $completion) {
  variants = variants === VOID ? emptySet() : variants;
  var tmp;
  if (onChoose === VOID) {
    tmp = KorgeControlAgent$showDraftDialog$lambda;
  } else {
    tmp = onChoose;
  }
  onChoose = tmp;
  var previousPositions = $this.wl3_1;
  var previousCards = $this.xl3_1;
  var rows = new ControlPanelY();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var currentCards = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var highlights = LinkedHashMap.m7();
  var isTransitioning = {_v: true};
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  var iterator = $this$with.i38_1.p1();
  var index = 0;
  $l$loop_0: while (iterator.q1()) {
    var index_0 = index;
    index = index + 1 | 0;
    var character = iterator.r1();
    if (!(get_gameTeam($this$with, character) === $this.k3q()))
      continue $l$loop_0;
    if (equals(draft.u4m_1, TwoPlayerDraftStage_Collecting_getInstance()) && index_0 === 2)
      continue $l$loop_0;
    var row = new ControlPanelX();
    if (!equals(draft.u4m_1, TwoPlayerDraftStage_Collecting_getInstance())) {
      addTo_0(toHeight(yield* $this.imh(character, true, VOID, $completion), get_gameLayout().ol5_1), row);
    }
    yield* showDraftDialog$cards(draft, variants, $this, currentCards, highlights, isTransitioning, onChoose, index_0, draft.p4m_1.u2(index_0), row, draft.s4m_1, $completion);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!draft.o4m_1.u2(index_0).n1()) {
      showDraftDialog$separator(row);
      yield* showDraftDialog$cards(draft, variants, $this, currentCards, highlights, isTransitioning, onChoose, index_0, draft.o4m_1.u2(index_0), row, !draft.s4m_1, $completion);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!draft.q4m_1.u2(index_0).n1()) {
      showDraftDialog$separator(row);
      var discarded = new ControlPanelY();
      addTo_0(PlainText('Discarded', get_gameLayout().vl5_1), discarded);
      var discardedCards = new ControlPanelX();
      yield* showDraftDialog$cards(draft, variants, $this, currentCards, highlights, isTransitioning, onChoose, index_0, draft.q4m_1.u2(index_0), discardedCards, false, $completion);
      addTo_0(discardedCards.xlb_1, discarded);
      addTo_0(discarded.xlb_1, row);
    }
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_hand($this$with, character);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp_0;
      if (isInterface(element, ArsenalCard)) {
        tmp_0 = true;
      } else {
        tmp_0 = isInterface(element, DraftActionCard);
      }
      if (tmp_0) {
        destination.d2(element);
      }
    }
    var handCards = orderedCards(destination);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!handCards.n1()) {
      showDraftDialog$separator(row);
      var _iterator__ex2g4s_0 = handCards.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var card = _iterator__ex2g4s_0.r1();
        addTo_0(toHeight(yield* createCard($this, yield* (yield* $this.pl6().mle(card, $completion)).m1q($completion), card, JustShowTheCard_instance, $completion), get_gameLayout().ol5_1), row);
      }
    }
    if (row.xlb_1.w9z() > get_gameLayout().kl6_1) {
      var scale = get_gameLayout().kl6_1 / row.xlb_1.w9z();
      row.xlb_1.wif(scale);
      row.xlb_1.yif(scale);
    }
    addTo_0(row.xlb_1, rows);
  }
  $this.rln(highlights);
  $this.xl3_1 = currentCards;
  $this.yl3_1 = false;
  var cancelView = yield* createDialogCancelView($this, KorgeControlAgent$showDraftDialog$slambda($this), $completion);
  $this.pl3_1 = message;
  var content = DialogContent.cmg(rows.xlb_1, dialogCornerText(draftDialogMessage($this, draft, message))).jmi(DialogCorner_RIGHT_TOP_getInstance(), cancelView);
  var dialog = $this.nl3_1;
  if (!(dialog == null) && dialog.kmi()) {
    dialog.pmh(content);
  } else {
    var tmp_1 = $this;
    // Inline function 'kotlin.also' call
    var this_0 = GameDialog.mlt($this.nl2_1, content, get_gameDialogClose());
    this_0.ylq();
    tmp_1.nl3_1 = this_0;
  }
  var tmp_2 = $this;
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_0 = LinkedHashMap.cd(mapCapacity(currentCards.s2()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_1 = currentCards.i3().p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_0 = _iterator__ex2g4s_1.r1();
    var tmp_3 = element_0.j3();
    // Inline function 'kotlin.collections.component2' call
    var view = element_0.k3();
    var tmp$ret$16 = view.oih(Companion_getInstance_12().g9h_1);
    destination_0.b5(tmp_3, tmp$ret$16);
  }
  tmp_2.wl3_1 = destination_0;
  var tmp_4;
  if (!get_gameConfiguration().olc_1) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_4 = !previousPositions.n1();
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var moves = ArrayList.p2();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = currentCards.i3().p1();
    while (_iterator__ex2g4s_2.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.collections.component1' call
      var card_0 = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var view_0 = _destruct__k2r9zo.k3();
      var destination_1 = view_0.wb5();
      var tmp0_safe_receiver = previousPositions.w4(card_0);
      var tmp_5;
      if (tmp0_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_5 = ensureNotNull(view_0.x1m()).vhy(tmp0_safe_receiver);
      }
      var origin = tmp_5;
      var tmp_6;
      if (!(origin == null)) {
        var tmp_7;
        // Inline function 'kotlin.math.abs' call
        var x = origin.r9g_1 - destination_1.r9g_1;
        if (Math.abs(x) > 0.5) {
          tmp_7 = true;
        } else {
          // Inline function 'kotlin.math.abs' call
          var x_0 = origin.s9g_1 - destination_1.s9g_1;
          tmp_7 = Math.abs(x_0) > 0.5;
        }
        tmp_6 = tmp_7;
      } else {
        tmp_6 = false;
      }
      if (tmp_6) {
        var tmp_8 = KMutableProperty0;
        var tmp_9 = View$_get_pos_$ref_lp2nil(view_0);
        moves.d2(get(getPropertyCallableRef('pos', 0, tmp_8, tmp_9, View$_set_pos_$ref_npt43j(view_0)), origin, destination_1));
      } else {
        if (origin == null) {
          var tmp_10 = KMutableProperty0;
          var tmp_11 = View$_get_pos_$ref_lp2nil(view_0);
          moves.d2(get(getPropertyCallableRef('pos', 0, tmp_10, tmp_11, View$_set_pos_$ref_npt43j(view_0)), Vector2D.t9g(destination_1.r9g_1, destination_1.s9g_1 - view_0.rig()), destination_1));
          var tmp_12 = KMutableProperty0;
          var tmp_13 = View$_get_alpha_$ref_oftner(view_0);
          // Inline function 'korlibs.korge.tween.get' call
          var this_1 = getPropertyCallableRef('alpha', 0, tmp_12, tmp_13, View$_set_alpha_$ref_4v0szt(view_0));
          var tmp$ret$27 = new V2(this_1, 0.0, 1.0, _interpolate$ref(), true);
          moves.d2(tmp$ret$27);
        }
      }
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var outgoing = ArrayList.p2();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = previousCards.i3().p1();
    $l$loop_2: while (_iterator__ex2g4s_3.q1()) {
      var _destruct__k2r9zo_0 = _iterator__ex2g4s_3.r1();
      // Inline function 'kotlin.collections.component1' call
      var card_1 = _destruct__k2r9zo_0.j3();
      // Inline function 'kotlin.collections.component2' call
      var view_1 = _destruct__k2r9zo_0.k3();
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      if ((isInterface(currentCards, KtMap) ? currentCards : THROW_CCE()).u4(card_1))
        continue $l$loop_2;
      var tmp1_elvis_lhs = previousPositions.w4(card_1);
      var tmp_14;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_2;
      } else {
        tmp_14 = tmp1_elvis_lhs;
      }
      var origin_0 = tmp_14;
      var tmp0_0 = view_1.oih(Vector2D.t9g(view_1.w9z(), view_1.x9z()));
      // Inline function 'korlibs.math.geom.Vector2D.minus' call
      var that = view_1.oih(Companion_getInstance_12().g9h_1);
      var globalSize = Vector2D.t9g(tmp0_0.r9g_1 - that.r9g_1, tmp0_0.s9g_1 - that.s9g_1);
      view_1.uih();
      addTo(view_1, rows.xlb_1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$35 = Vector2D.t9g(origin_0.r9g_1 + globalSize.r9g_1, origin_0.s9g_1 + globalSize.s9g_1);
      var tmp0_1 = rows.xlb_1.vhy(tmp$ret$35);
      // Inline function 'korlibs.math.geom.Vector2D.minus' call
      var that_0 = rows.xlb_1.vhy(origin_0);
      var localSize = Vector2D.t9g(tmp0_1.r9g_1 - that_0.r9g_1, tmp0_1.s9g_1 - that_0.s9g_1);
      view_1.wif(localSize.r9g_1 / view_1.w9z());
      view_1.yif(localSize.s9g_1 / view_1.x9z());
      view_1.fcw(rows.xlb_1.vhy(origin_0));
      outgoing.d2(view_1);
      var tmp_15 = KMutableProperty0;
      var tmp_16 = View$_get_y_$ref_usqum0(view_1);
      var tmp0_2 = getPropertyCallableRef('y', 0, tmp_15, tmp_16, View$_set_y_$ref_18dlvg(view_1));
      var tmp2 = view_1.xea();
      // Inline function 'korlibs.korge.tween.get' call
      var end = view_1.xea() + get_gameLayout().ol5_1;
      var tmp$ret$37 = new V2(tmp0_2, tmp2, end, _interpolate$ref(), true);
      moves.d2(tmp$ret$37);
      var tmp_17 = KMutableProperty0;
      var tmp_18 = View$_get_alpha_$ref_oftner(view_1);
      // Inline function 'korlibs.korge.tween.get' call
      var this_2 = getPropertyCallableRef('alpha', 0, tmp_17, tmp_18, View$_set_alpha_$ref_4v0szt(view_1));
      var tmp$ret$38 = new V2(this_2, 1.0, 0.0, _interpolate$ref(), true);
      moves.d2(tmp$ret$38);
    }
    try {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!moves.n1()) {
        var tmp2_$receiver = $this.nl2_1;
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp3_vs = copyToArray(moves).slice();
        var tmp4_easing = get_gameAnimations().ll4_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp5_time = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        yield* tween(tmp2_$receiver, tmp3_vs, tmp5_time, tmp4_easing, VOID, VOID, VOID, VOID, $completion);
      }
    }finally {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_4 = outgoing.p1();
      while (_iterator__ex2g4s_4.q1()) {
        var element_1 = _iterator__ex2g4s_4.r1();
        element_1.uih();
      }
    }
  }
  isTransitioning._v = false;
  return Unit_instance;
}
function *generalCardsDialog($this, variants, result, mayNothing, questionContext, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0 = $this.t6h();
  var tmp$ret$1;
  $l$block_2: {
    var tmp0_0 = tmp0.i38_1;
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s = tmp0_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (get_hand(tmp0, element).r4(variants)) {
          if (found) {
            tmp$ret$2 = null;
            break $l$block_0;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$2 = null;
        break $l$block_0;
      }
      tmp$ret$2 = single;
    }
    var tmp0_elvis_lhs = tmp$ret$2;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp$ret$1 = emptySet();
      break $l$block_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var fromCharacter = tmp;
    if ($this.be1(get_gameTeam(tmp0, fromCharacter))) {
      tmp$ret$1 = get_hand(tmp0, fromCharacter);
      break $l$block_2;
    }
    var tmp1_safe_receiver = tmp0.d39_1.w4(new GameTeam($this.k3q()));
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e4o_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w4(new HandPlace(fromCharacter));
    var cards = tmp3_elvis_lhs == null ? emptySet() : tmp3_elvis_lhs;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_1 = get_hand(tmp0, fromCharacter);
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s_0 = tmp0_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (!(element_0 == null) ? isInterface(element_0, AbilityCard) : false) {
        destination.d2(element_0);
      }
    }
    tmp$ret$1 = plus_2(cards, destination);
  }
  var additionalCards = tmp$ret$1;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var m = LinkedHashMap.m7();
  var cardUisMap = KorgeControlAgent$generalCardsDialog$slambda($this, variants, m, result);
  var tmp_0;
  if (mayNothing) {
    var tmp_1 = get_gameI18n().b6z_1;
    // Inline function 'kotlin.also' call
    var this_0 = ActionButton.vlb(tmp_1, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$generalCardsDialog$slambda_0(result));
    var tmp2 = PassVariant_getInstance();
    // Inline function 'kotlin.collections.set' call
    var value = new AutoHighlight(this_0, toPoint(this_0.s2().l9s(2)));
    m.b5(tmp2, value);
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  var nothingButton = tmp_0;
  var resultContainer = yield* createCardsPanel(toList_0(plus_2(variants, additionalCards)), listOfNotNull(nothingButton), cardUisMap, $completion);
  $this.rln(m);
  yield* $this.cmo(resultContainer, get_gameI18n().h71(questionContext), VOID, $completion);
  return Unit_instance;
}
function *createDialogCancelView($this, onClick, $completion) {
  var cancelIcon = yield* (yield* $this.pl6().tld(InterfaceIcon_Cancel_getInstance(), $completion)).m1q($completion);
  return DialogCancelIcon.dlx(cancelIcon, VOID, onClick);
}
function variantToString($this, variant) {
  // Inline function 'kotlin.with' call
  var $this$with = $this.t6h();
  var tmp;
  if (!(variant == null) ? isInterface(variant, GamePhase) : false) {
    tmp = phaseText($this$with, variant);
  } else {
    if (!(variant == null) ? typeof variant === 'boolean' : false) {
      tmp = variant ? 'Yes' : 'No';
    } else {
      if (variant instanceof TriggerOption) {
        var tmp_0;
        var tmp_1 = variant.k4c_1;
        if (tmp_1 instanceof ClaimRuinEffectSource) {
          var tmp_2 = variant.l4c_1;
          var claimRuinStatement = tmp_2 instanceof ClaimRuinStatement ? tmp_2 : null;
          var ruinPosition = claimRuinStatement == null ? null : claimRuinStatement.q2v_1;
          tmp_0 = get_gameI18n().e71($this$with, ruinPosition);
        } else {
          var tmp_3 = variant.k4c_1;
          if (tmp_3 instanceof PossibleSnareEffectSource) {
            var tmp_4 = variant.l4c_1;
            var activateSnareStatement = tmp_4 instanceof ActivateSnareStatement ? tmp_4 : null;
            var tmp3_safe_receiver = activateSnareStatement == null ? null : activateSnareStatement.f5u_1;
            var snareType = tmp3_safe_receiver == null ? null : get_snareType($this$with, tmp3_safe_receiver);
            tmp_0 = 'Activate ' + toString_0(snareType) + ' Snare';
          } else {
            var tmp_5 = actionSourceText(variant.k4c_1) + ' : ';
            tmp_0 = tmp_5 + withStateRuntime_0($this, $this$with, KorgeControlAgent$variantToString$lambda(variant));
          }
        }
        tmp = tmp_0;
      } else {
        if (variant instanceof InAnyOrderStatement) {
          // Inline function 'kotlin.collections.map' call
          var this_0 = variant.s2o_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            var tmp$ret$4 = variantToString($this, item);
            destination.d2(tmp$ret$4);
          }
          tmp = joinToString(destination, ' and ');
        } else {
          if (!(variant == null) ? isInterface(variant, ActionStatement) : false) {
            tmp = withStateRuntime_0($this, $this$with, KorgeControlAgent$variantToString$lambda_0(variant));
          } else {
            if (variant instanceof BeastMovementCardVariant) {
              tmp = toString(get_objectType($this$with, variant.d4c_1)) + ' movement #' + (variant.e4c_1 + 1 | 0);
            } else {
              if (variant == null) {
                tmp = get_gameI18n().v6z_1;
              } else {
                $this.sln('Improve output variant presentation for ' + toString(variant));
                var tmp_6;
                if (variant instanceof ObjectOnBoard) {
                  tmp_6 = ensureNotNull(getKClassFromExpression(get_objectType($this$with, variant)).j1()) + ', hp = ' + get_hp($this$with, variant);
                } else {
                  tmp_6 = toString(variant);
                }
                tmp = tmp_6;
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function *showOnboardingMenu($this, $completion) {
  var underlyingDialog = $this.nl3_1;
  $this.nl3_1 = null;
  try {
    yield* $this.gmo($completion);
    $l$loop_0: while (true) {
      var tmp0_elvis_lhs = $this.nl3_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var menuDialog = tmp;
      yield* menuDialog.hmo(VOID, $completion);
      if ($this.nl3_1 === menuDialog)
        break $l$loop_0;
    }
  }finally {
    $this.nl3_1 = underlyingDialog;
  }
  return Unit_instance;
}
function *showUserSettings($this, $completion) {
  // Inline function 'kotlin.requireNotNull' call
  var tmp0 = get_gameConfiguration().flc_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = 'Required value was null.';
      throw IllegalArgumentException.h2(toString(message));
    } else {
      tmp$ret$1 = tmp0;
      break $l$block;
    }
  }
  var serverDrivenConfiguration = tmp$ret$1;
  var tmp = KorgeControlAgent$showUserSettings$slambda($this);
  var settingsPanel = createUserSettingsPanel(serverDrivenConfiguration, VOID, tmp, KorgeControlAgent$showUserSettings$slambda_0($this));
  yield* $this.imo(settingsPanel, 'User settings', KorgeControlAgent$showUserSettings$slambda_1($this), $completion);
  return Unit_instance;
}
function MenuManagement$_get_answerIndexBeforeAnotherAnswerChosen_$ref_e9q8pw(p0) {
  return constructCallableReference(() => p0.vdw(), 0, 0, 571, VOID, [p0]);
}
function MenuManagement$_set_answerIndexBeforeAnotherAnswerChosen_$ref_3cws4o(p0) {
  return constructCallableReference((p0_0) => {
    p0.pdw(p0_0);
    return Unit_instance;
  }, 1, 0, 572, VOID, [p0]);
}
function KorgeControlAgent$specialSetupFlow$delegate$lambda$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* this$0.gl2_1.aln($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$specialSetupFlow$delegate$lambda$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    yield* insideScope(this$0.jl2_1, KorgeControlAgent$specialSetupFlow$delegate$lambda$slambda$slambda(this$0), $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$specialSetupFlow$delegate$lambda$slambda_0(this$0) {
  return constructCallableReference(function *($completion) {
    yield* this$0.oe1($completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$specialSetupFlow$delegate$lambda(this$0) {
  return () => {
    var tmp = KorgeControlAgent$specialSetupFlow$delegate$lambda$slambda(this$0);
    return new SpecialSetupFlow(this$0, tmp, KorgeControlAgent$specialSetupFlow$delegate$lambda$slambda_0(this$0));
  };
}
function KorgeControlAgent$_get_specialSetupFlow_$ref_2s83y0() {
  return constructCallableReference((p0) => p0.jmo(), 1, 0, 573);
}
function KorgeControlAgent$sandboxSetupFlow$delegate$lambda$slambda() {
  return constructCallableReference(function *(code, number, before, event, $completion) {
    return yield* ensureNotNull(get_gameConfiguration().cld_1).h6w(code, number, before, event, $completion);
  }, 4);
}
function KorgeControlAgent$sandboxSetupFlow$delegate$lambda$slambda$slambda(this$0, $notification) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    yield* this$0.r6t($notification, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$sandboxSetupFlow$delegate$lambda$slambda_0(this$0) {
  return constructCallableReference(function *(notification, $completion) {
    yield* insideScope(this$0.jl2_1, KorgeControlAgent$sandboxSetupFlow$delegate$lambda$slambda$slambda(this$0, notification), $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$sandboxSetupFlow$delegate$lambda(this$0) {
  return () => {
    var tmp = this$0.jmo();
    var tmp_0 = KorgeControlAgent$sandboxSetupFlow$delegate$lambda$slambda();
    return new SandboxSetupFlow(this$0, tmp, tmp_0, KorgeControlAgent$sandboxSetupFlow$delegate$lambda$slambda_0(this$0));
  };
}
function KorgeControlAgent$_get_sandboxSetupFlow_$ref_do5rwa() {
  return constructCallableReference((p0) => p0.kmo(), 1, 0, 574);
}
function KorgeControlAgent$pingElement$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$showPingElement$slambda(this$0, $view) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(1500, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    var tmp;
    if (equals(this$0.sl3_1, $view)) {
      this$0.sl3_1 = null;
      $view.uih();
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$hideCurrentQuestionGameDialog$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$clearRestoreDialogButton$lambda(it) {
  var tmp;
  if (it instanceof ActionButton) {
    tmp = it.bhq_1 === get_gameI18n().w6y_1;
  } else {
    tmp = false;
  }
  return tmp;
}
function KorgeControlAgent$notifyAboutGameEvent$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'korlibs.korge.view.container' call
    var this_0 = this$0.ml2_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Container.fi2(false);
    // Inline function 'kotlin.apply' call
    var c = addTo(this_1, this_0);
    var x = notificationElement('Another team making turn', VOID, true);
    x.sif(100.0);
    x.rif(get_gameLayout().el6_1 / 2.0);
    c.uie(x);
    var tmp = KMutableProperty0;
    var tmp_0 = Container$_get_alpha_$ref_vzjrdr(c);
    // Inline function 'korlibs.korge.tween.get' call
    var this_2 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, Container$_set_alpha_$ref_2opaz7(c));
    var tmp0_vs = [new V2(this_2, 0.0, 1.0, _interpolate$ref(), true)];
    var tmp1_easing = get_gameAnimations().ll4_1;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp2_time = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    yield* tween(c, tmp0_vs, tmp2_time, tmp1_easing, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateBeastsMovementCards$lambda(this$0, $index) {
  return (it) => {
    var _destruct__k2r9zo = movementCardLayoutForAboveMap(this$0, $index);
    var position = _destruct__k2r9zo.jm();
    var height = _destruct__k2r9zo.km();
    position_0(it, position);
    toHeight(it, height);
    return Unit_instance;
  };
}
function KorgeControlAgent$updateStatusBar$slambda$slambda(this$0, $c) {
  return constructCallableReference(function *(it, $completion) {
    hideStatusBarHoverPopup(this$0);
    var popup = yield* createStatusHoverPopup(this$0, $c, $completion);
    this$0.nl2_1.uie(popup);
    this$0.ql3_1 = popup;
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateStatusBar$slambda$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$updateStatusBar$slambda$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$updateStatusBar$slambda$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$updateStatusBar$slambda$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    hideStatusBarHoverPopup(this$0);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateStatusBar$slambda$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$updateStatusBar$slambda$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$updateStatusBar$slambda$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$updateStatusBar$slambda$slambda_1(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.dll(VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateStatusBar$slambda$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$updateStatusBar$slambda$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$updateStatusBar$slambda$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$updateStatusBar$slambda(this$0, $deadSettlers, $beastDominion, $hunterDominion) {
  return constructCallableReference(function *($completion) {
    var c = Container.fi2();
    var statusContentContainer = Container.fi2();
    var currentX = 0.0;
    var tmp = this$0.t6h().y37_1;
    var tmp0_safe_receiver = tmp instanceof KillingSettlersClassicGameRules ? tmp : null;
    var settlersKillNumber = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l3a();
    var tmp_0;
    if (!(settlersKillNumber == null)) {
      var goalStartX = currentX;
      // Inline function 'kotlin.also' call
      var this_0 = PlainText('Beast goal:', get_gameLayout().sl5_1);
      this_0.rif(currentX);
      currentX = currentX + this_0.w9z();
      addTo(this_0, statusContentContainer);
      currentX = currentX + get_gameLayout().yl5_1;
      var contour = yield* (yield* this$0.pl6().vle(GeneralTokens_SettlerContour_getInstance(), $completion)).m1q($completion);
      // Inline function 'kotlin.with' call
      var $this$with = this$0.t6h();
      var inductionVariable = 0;
      if (inductionVariable < settlersKillNumber)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp_1;
          if (i < $deadSettlers.s2()) {
            tmp_1 = yield* (yield* this$0.pl6().qle(get_objectType($this$with, $deadSettlers.u2(i)), VOID, $completion)).m1q($completion);
          } else {
            tmp_1 = contour;
          }
          var picture = tmp_1;
          // Inline function 'korlibs.korge.view.image' call
          var anchor = Companion_getInstance_7().c9g_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_1 = Image.lk7(picture, anchor);
          // Inline function 'kotlin.apply' call
          var this_2 = addTo(this_1, statusContentContainer);
          // Inline function 'kotlin.also' call
          this_2.rif(currentX);
          this_2.sif(get_gameLayout().yl5_1 / 2);
          toHeight(this_2, get_gameLayout().sl5_1);
          currentX = currentX + this_2.pig();
        }
         while (inductionVariable < settlersKillNumber);
      currentX = currentX + get_gameLayout().yl5_1 * 2;
      tmp_0 = Unit_instance;
    }
    var tmp_2;
    var tmp_3 = this$0.t6h().y37_1;
    if (tmp_3 instanceof RegentOfRuinsContract) {
      // Inline function 'kotlin.also' call
      var this_3 = PlainText('Dominion: ' + $beastDominion + ':' + $hunterDominion, get_gameLayout().sl5_1);
      this_3.rif(currentX);
      currentX = currentX + (this_3.w9z() + get_gameLayout().yl5_1);
      addTo(this_3, statusContentContainer);
      currentX = currentX + get_gameLayout().yl5_1 * 2;
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.korge.input.mouse' call
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse(c);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = KorgeControlAgent$updateStatusBar$slambda$slambda(this$0, c);
    var tmp_4 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_5 = getPropertyCallableRef('over', 1, tmp_4, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
    tmp_5.v9y(KorgeControlAgent$updateStatusBar$slambda$lambda($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = KorgeControlAgent$updateStatusBar$slambda$slambda_0(this$0);
    var tmp_6 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_7 = getPropertyCallableRef('out', 1, tmp_6, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
    tmp_7.v9y(KorgeControlAgent$updateStatusBar$slambda$lambda_0($this$mouse, handler_0));
    // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
    var handler_1 = KorgeControlAgent$updateStatusBar$slambda$slambda_1(this$0);
    var tmp_8 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_9 = getPropertyCallableRef('click', 1, tmp_8, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
    tmp_9.v9y(KorgeControlAgent$updateStatusBar$slambda$lambda_1($this$mouse, handler_1));
    // Inline function 'kotlin.also' call
    var this_4 = PlainText('Day:', get_gameLayout().sl5_1);
    this_4.rif(currentX);
    var dayText = this_4;
    var dayOffsetRight = PlainText('4', get_gameLayout().sl5_1).w9z() + get_gameLayout().yl5_1;
    var turnText = PlainText('Turn:', get_gameLayout().sl5_1);
    var turnOffsetRight = PlainText('19', get_gameLayout().sl5_1).w9z() + get_gameLayout().yl5_1;
    var wholeWidthForDayAndTurn = dayText.w9z() + dayOffsetRight + get_gameLayout().yl5_1 * 2 + turnText.w9z() + turnOffsetRight;
    var tmp_10;
    var tmp_11 = this$0.t6h().d38_1;
    if (tmp_11 instanceof PlayerTurnPhase) {
      var startX = currentX;
      statusContentContainer.uie(dayText);
      currentX = currentX + dayText.w9z();
      // Inline function 'kotlin.also' call
      var this_5 = PlainText(this$0.t6h().e38_1.toString(), get_gameLayout().sl5_1);
      this_5.rif(currentX + get_gameLayout().yl5_1);
      addTo(this_5, statusContentContainer);
      currentX = currentX + dayOffsetRight;
      currentX = currentX + get_gameLayout().yl5_1 * 2;
      turnText.rif(currentX);
      currentX = currentX + turnText.w9z();
      statusContentContainer.uie(turnText);
      // Inline function 'kotlin.also' call
      var this_6 = PlainText(this$0.t6h().f38_1.toString(), get_gameLayout().sl5_1);
      this_6.rif(currentX + get_gameLayout().yl5_1);
      currentX = currentX + turnOffsetRight;
      addTo(this_6, statusContentContainer);
      var d = wholeWidthForDayAndTurn - (currentX - startX);
      // Inline function 'kotlin.require' call
      if (!(d < 0.01 * wholeWidthForDayAndTurn)) {
        var message = 'd = ' + d + ', wholeWidthForDayAndTurn = ' + wholeWidthForDayAndTurn + ', currentX = ' + currentX + ', startX = ' + startX;
        throw IllegalArgumentException.h2(toString(message));
      }
      tmp_10 = Unit_instance;
    } else {
      var tmp1_subject = this$0.t6h().d38_1;
      var tmp_12;
      if (tmp1_subject instanceof NightPhase) {
        tmp_12 = 'Night ' + this$0.t6h().e38_1;
      } else {
        var tmp_13;
        if (tmp1_subject instanceof InitialPhase) {
          tmp_13 = true;
        } else {
          var tmp_14;
          if (isInterface(tmp1_subject, ContractInitPhase)) {
            tmp_14 = true;
          } else {
            tmp_14 = tmp1_subject instanceof PreGamePhase;
          }
          tmp_13 = tmp_14;
        }
        if (tmp_13) {
          tmp_12 = 'Setup';
        } else {
          if (tmp1_subject instanceof DawnPhase) {
            tmp_12 = 'Dawn ' + this$0.t6h().e38_1;
          } else {
            if (tmp1_subject instanceof StartOfDayPhase) {
              tmp_12 = 'Start of Day ' + this$0.t6h().e38_1;
            } else {
              tmp_12 = '';
            }
          }
        }
      }
      var text = tmp_12;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(text) > 0) {
        // Inline function 'korlibs.korge.view.text' call
        var textSize = get_gameLayout().sl5_1;
        var color = Colors_getInstance().zc2_1;
        var font = get_DefaultTtfFontAsBitmap();
        var alignment = Companion_getInstance_16().ucr_1;
        var renderer = get_DefaultStringTextRenderer();
        var autoScaling = Companion_instance_0.zj5_1;
        // Inline function 'korlibs.korge.view.addTo' call
        var this_7 = Text.aj6(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
        // Inline function 'kotlin.apply' call
        var this_8 = addTo(this_7, statusContentContainer);
        // Inline function 'kotlin.also' call
        this_8.rif(currentX + (wholeWidthForDayAndTurn - this_8.w9z()) / 2);
      }
      currentX = currentX + wholeWidthForDayAndTurn;
      tmp_10 = Unit_instance;
    }
    var contentSize = Size2D.y9p(currentX, statusContentContainer.x9z());
    var tmp2 = contentSize.f9s(Size2D.y9p(get_gameLayout().yl5_1 * 2, get_gameLayout().yl5_1 * 1.5));
    Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var corner = get_gameLayout().sl5_1 / 4;
    var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp6 = new RGBA(get_gameColors().ylx_1);
    var tmp8 = new RGBA(Colors_getInstance().zc2_1);
    // Inline function 'korlibs.korge.view.roundRect' call
    var strokeThickness = get_gameLayout().rl5_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_9 = RoundRect.rka(tmp2, tmp4, tmp6, tmp8, strokeThickness, true);
    // Inline function 'kotlin.apply' call
    addTo(this_9, c);
    c.uie(statusContentContainer);
    statusContentContainer.fcw(Vector2D.t9g(get_gameLayout().yl5_1, get_gameLayout().yl5_1 / 2));
    c.sif(get_gameLayout().yl5_1);
    c.rif((get_gameLayout().el6_1 / 2 | 0) - c.w9z() / 2);
    return c;
  }, 0);
}
function KorgeControlAgent$updateReplayControlElement$onClickFirstButton$slambda($controlPanelX, $shouldBeReplayIcon, this$0, $pauseIcon, $playIcon) {
  return constructCallableReference(function *(it, $completion) {
    yield* updateReplayControlElement$onClickFirstButton($controlPanelX, $shouldBeReplayIcon, this$0, $pauseIcon, $playIcon, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateReplayControlElement$onClickFirstButton$slambda_0($controlPanelX, $shouldBeReplayIcon, this$0, $pauseIcon, $playIcon) {
  return constructCallableReference(function *(it, $completion) {
    yield* updateReplayControlElement$onClickFirstButton($controlPanelX, $shouldBeReplayIcon, this$0, $pauseIcon, $playIcon, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateReplayControlElement$firstButton$slambda($controlPanelX, $shouldBeReplayIcon, this$0, $pauseIcon, $playIcon) {
  return constructCallableReference(function *(it, $completion) {
    yield* updateReplayControlElement$onClickFirstButton($controlPanelX, $shouldBeReplayIcon, this$0, $pauseIcon, $playIcon, $completion);
    return Unit_instance;
  }, 1);
}
function *updateReplayControlElement$onClickFirstButton(controlPanelX, shouldBeReplayIcon, this$0, pauseIcon, playIcon, $completion) {
  var c = controlPanelX.xlb_1;
  if (shouldBeReplayIcon._v) {
    shouldBeReplayIcon._v = false;
    this$0.tl2_1 = true;
    yield* this$0.plk($completion);
    var tmp = first(c.xi1_1);
    var tmp_0 = get_gameLayout().ml6_1;
    c.dif(tmp, createHoveredIconAction(tmp_0, pauseIcon, VOID, VOID, KorgeControlAgent$updateReplayControlElement$onClickFirstButton$slambda(controlPanelX, shouldBeReplayIcon, this$0, pauseIcon, playIcon)));
  } else {
    shouldBeReplayIcon._v = true;
    this$0.tl2_1 = false;
    var tmp_1 = first(c.xi1_1);
    var tmp_2 = get_gameLayout().ml6_1;
    c.dif(tmp_1, createHoveredIconAction(tmp_2, playIcon, VOID, VOID, KorgeControlAgent$updateReplayControlElement$onClickFirstButton$slambda_0(controlPanelX, shouldBeReplayIcon, this$0, pauseIcon, playIcon)));
  }
  return Unit_instance;
}
function updateReplayControlElement$firstButton(controlPanelX, shouldBeReplayIcon, this$0, pauseIcon, playIcon, picture) {
  var tmp = get_gameLayout().ml6_1;
  return createHoveredIconAction(tmp, picture, VOID, VOID, KorgeControlAgent$updateReplayControlElement$firstButton$slambda(controlPanelX, shouldBeReplayIcon, this$0, pauseIcon, playIcon));
}
function KorgeControlAgent$updateReplayControlElement$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.plk($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateReplayControlElement$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.pe1(RevertMode_RevertFirstForSure_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$replayRevertFlow$delegate$lambda$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    cancelCurrentQuestionUi(this$0);
    this$0.lmo();
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$replayRevertFlow$delegate$lambda$lambda() {
  return get_gameConfiguration().slc_1;
}
function KorgeControlAgent$replayRevertFlow$delegate$lambda$lambda_0() {
  return new ReplayRevertConfiguration(get_gameConfiguration().rlc_1, get_gameConfiguration().plc_1);
}
function KorgeControlAgent$replayRevertFlow$delegate$lambda(this$0) {
  return () => {
    var tmp = _get_choiceFlow__u1vu9o(this$0);
    var tmp_0 = KorgeControlAgent$replayRevertFlow$delegate$lambda$slambda(this$0);
    var tmp_1 = KorgeControlAgent$replayRevertFlow$delegate$lambda$lambda;
    return new ReplayRevertFlow(this$0, tmp, tmp_0, tmp_1, KorgeControlAgent$replayRevertFlow$delegate$lambda$lambda_0);
  };
}
function KorgeControlAgent$_get_replayRevertFlow_$ref_qj8jv3() {
  return constructCallableReference((p0) => _get_replayRevertFlow__95swe(p0), 1, 0, 575);
}
function KorgeControlAgent$pointAndSizeAtCharacter$lambda(it) {
  return it instanceof TwoBeastsHpElement;
}
function updateMainPanel$needPositionForKey(this$0, key) {
  return this$0.vl2_1.aly(key, Vector2D.t9g(this$0.bl3_1, this$0.cl3_1));
}
function updateMainPanel$centeredX(this$0, view) {
  return this$0.hl2_1.r9g_1 + (get_gameLayout().el6_1 - this$0.hl2_1.r9g_1 - view.pig()) / 2;
}
function updateMainPanel$placeAction(this$0, key, view) {
  this$0.vl2_1.aly(key, Vector2D.t9g(updateMainPanel$centeredX(this$0, view), this$0.cl3_1));
  this$0.cl3_1 = this$0.cl3_1 + (view.rig() + get_gameLayout().yl5_1);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* this$0.gmo($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    var tmp = get_gameI18n().q6y_1;
    return ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda$slambda(this$0));
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda_0($$this$run, $characterObject) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if ($$this$run.kl3_1.w4($characterObject) == null) {
      var tmp0 = $$this$run.kl3_1;
      var tmp2 = $characterObject;
      // Inline function 'kotlin.collections.set' call
      var value = $$this$run.gl2_1.jln($characterObject);
      tmp0.b5(tmp2, value);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$updateMainPanel$slambda$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$updateMainPanel$slambda$slambda_1($$this$run, $characterObject) {
  return constructCallableReference(function *(it, $completion) {
    var tmp0_safe_receiver = $$this$run.kl3_1.c5($characterObject);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o1n();
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$updateMainPanel$slambda$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$updateMainPanel$slambda_0($$this$run, $characterObject) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.with' call
    var $this$with = $$this$run.t6h();
    var cardContent = Container.fi2();
    var info = new CharacterVisualInfoAndContainer(get_visualInfo($this$with, $characterObject), cardContent);
    yield* addCharacterInfo($this$with, $$this$run.pl6(), info, $completion);
    var tmp0 = $$this$run.jl3_1;
    // Inline function 'kotlin.collections.set' call
    var key = get_objectType($this$with, $characterObject);
    tmp0.b5(key, info);
    // Inline function 'korlibs.korge.input.mouse' call
    var this_0 = toWidth(characterArea($$this$run, cardContent, $characterObject), get_sidePanelCardWidth());
    // Inline function 'kotlin.run' call
    var $this$mouse = get_mouse(this_0);
    // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
    var handler = KorgeControlAgent$updateMainPanel$slambda$slambda_0($$this$run, $characterObject);
    var tmp = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_0 = getPropertyCallableRef('over', 1, tmp, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
    tmp_0.v9y(KorgeControlAgent$updateMainPanel$slambda$lambda($this$mouse, handler));
    // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
    var handler_0 = KorgeControlAgent$updateMainPanel$slambda$slambda_1($$this$run, $characterObject);
    var tmp_1 = KProperty1;
    // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
    var tmp_2 = getPropertyCallableRef('out', 1, tmp_1, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
    tmp_2.v9y(KorgeControlAgent$updateMainPanel$slambda$lambda_0($this$mouse, handler_0));
    return this_0;
  }, 0);
}
function KorgeControlAgent$updateMainPanel$lambda($shouldBeCardMovementWidth) {
  return (it) => {
    toWidth(it, $shouldBeCardMovementWidth);
    return Unit_instance;
  };
}
function KorgeControlAgent$updateMainPanel$slambda_1($$this$run, $commonBeastsWounds, $hpElementWidth) {
  return constructCallableReference(function *($completion) {
    var hpBackground = yield* (yield* $$this$run.pl6().yle('TwoBeastsHp.png', $completion)).m1q($completion);
    // Inline function 'kotlin.also' call
    var this_0 = Container.fi2();
    // Inline function 'korlibs.korge.view.image' call
    var anchor = Companion_getInstance_7().c9g_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.lk7(hpBackground, anchor);
    // Inline function 'kotlin.apply' call
    addTo(this_1, this_0);
    yield* addWoundsToSimpleObjects($$this$run.pl6(), this_0, $commonBeastsWounds, 2.5, $completion);
    return toWidth(this_0, $hpElementWidth);
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda_2($$this$run) {
  return constructCallableReference(function *(it, $completion) {
    yield* showDiscardWithSwitcher($$this$run, DiscardCardsType_DraftActionCards_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda_2($$this$run) {
  return constructCallableReference(function *($completion) {
    var discardImage = yield* (yield* $$this$run.pl6().tld(InterfaceIcon_Inaccessible_getInstance(), $completion)).m1q($completion);
    var tmp = get_gameLayout().tl5_1;
    return createHoveredIconAction(tmp, discardImage, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda$slambda_2($$this$run));
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda_3($$this$run) {
  return constructCallableReference(function *(it, $completion) {
    yield* showRuinsDialog($$this$run, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda_3($$this$run) {
  return constructCallableReference(function *($completion) {
    var ruinImage = yield* (yield* $$this$run.pl6().vle(GeneralTokens_RuinNeutral_getInstance(), $completion)).m1q($completion);
    var tmp = get_gameLayout().tl5_1;
    return createHoveredIconAction(tmp, ruinImage, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda$slambda_3($$this$run));
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda_4($$this$run) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* showDiscardWithSwitcher($$this$run, DiscardCardsType_DraftActionCards_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda_4($$this$run) {
  return constructCallableReference(function *($completion) {
    var tmp = get_gameI18n().t6y_1;
    return ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda$slambda_4($$this$run));
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda$slambda($$this$run) {
  return constructCallableReference(function *(arsenalCard, $completion) {
    var arsenalCardPicture = yield* (yield* $$this$run.pl6().mle(arsenalCard, $completion)).m1q($completion);
    return yield* createCard($$this$run, arsenalCardPicture, arsenalCard, JustShowTheCard_instance, $completion);
  }, 1);
}
function KorgeControlAgent$updateMainPanel$slambda$slambda_5($$this$run, $arsenal, $arsenalType) {
  return constructCallableReference(function *($completion) {
    var tmp = toList_0($arsenal.e36());
    var tmp_0 = splitCamelCase($arsenalType.toString());
    yield* justShowCardsPanel($$this$run, tmp, tmp_0, VOID, VOID, KorgeControlAgent$updateMainPanel$slambda$slambda$slambda($$this$run), $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$updateMainPanel$slambda_5($$this$run, $card, $arsenal, $arsenalType) {
  return constructCallableReference(function *($completion) {
    var tmp = yield* (yield* $$this$run.pl6().mle($card, $completion)).m1q($completion);
    return toWidth(yield* createCard($$this$run, tmp, $card, new ShowTheCardWithAction(KorgeControlAgent$updateMainPanel$slambda$slambda_5($$this$run, $arsenal, $arsenalType)), $completion), get_sidePanelCardWidth());
  }, 0);
}
function KorgeControlAgent$updateSpecialSetupAdditionalPanel$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* installStartSandboxDialog(this$0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateSpecialSetupAdditionalPanel$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    if (!(yield* this$0.jmo().ae4($completion))) {
      showErrorDialog(this$0.nl2_1, 'Cannot finish master fixing');
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$updateSpecialSetupAdditionalPanel$slambda_0(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.jl2_1, VOID, VOID, KorgeControlAgent$updateSpecialSetupAdditionalPanel$slambda$slambda(this$0));
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$processItselfGameScope$lambda($context) {
  return ($this$withStateRuntime) => actionStatementText($this$withStateRuntime, $context, false);
}
function KorgeControlAgent$processTextGameStateElement$slambda(this$0) {
  return constructCallableReference(function *(view, $completion) {
    yield* /*#__NOINLINE__*/animateSideElement(this$0, view, view.xea(), $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$processTextGameStateElement$slambda_0(this$0, $text, $background) {
  return constructCallableReference(function *($completion) {
    return notificationSideTextElement(this$0, $text, $background);
  }, 0);
}
function KorgeControlAgent$addCardToScope$slambda$slambda($hasElement, this$0, $card) {
  return constructCallableReference(function *($completion) {
    if ($hasElement)
      yield* showFullCard(this$0, $card, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$addCardToScope$slambda$slambda_0($hasElement, this$0, $card) {
  return constructCallableReference(function *($completion) {
    if ($hasElement)
      yield* showFullCard(this$0, $card, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$addCardToScope$slambda(this$0, $card) {
  return constructCallableReference(function *($completion) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (!this$0.bm5()) {
      tmp_2 = isInterface($card, TrapCard);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = !this$0.be1(get_huntersGameTeam());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = !flatten(ensureNotNull(this$0.t6h().d39_1.w4(new GameTeam(this$0.k3q()))).e4o_1.y4()).w2($card);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = to(yield* (yield* this$0.pl6().kle($card, $completion)).m1q($completion), null);
    } else {
      tmp = to(yield* (yield* this$0.pl6().mle($card, $completion)).m1q($completion), $card);
    }
    var _destruct__k2r9zo = tmp;
    var image = _destruct__k2r9zo.jm();
    var element = _destruct__k2r9zo.km();
    var hasElement = !(element == null);
    var tmp_3 = KorgeControlAgent$addCardToScope$slambda$slambda(hasElement, this$0, $card);
    return toWidth(CardUi.tm1(image, VOID, element, hasElement, tmp_3, KorgeControlAgent$addCardToScope$slambda$slambda_0(hasElement, this$0, $card)), get_sidePanelCardWidth());
  }, 0);
}
function View$_get_y_$ref_usqum0(p0) {
  return constructCallableReference(() => p0.xea(), 0, 0, 576, VOID, [p0]);
}
function View$_set_y_$ref_18dlvg(p0) {
  return constructCallableReference((p0_0) => {
    p0.sif(p0_0);
    return Unit_instance;
  }, 1, 0, 577, VOID, [p0]);
}
function KorgeControlAgent$choose$slambda(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, $onInstalled) {
  return constructCallableReference(function *($completion) {
    return yield* /*#__NOINLINE__*/chooseInternal(this$0, $$context_GameStateRuntime_ogzdp3, $gameQuestion, $mayNothing, $onInstalled, $completion);
  }, 0);
}
function KorgeControlAgent$choose$slambda_0(this$0) {
  return constructCallableReference(function *($completion) {
    cancelCurrentQuestionUi(this$0);
    this$0.lmo();
    this$0.mmo();
    this$0.rln(emptyMap());
    this$0.gl2_1.il8();
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$choose$slambda$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showDraftWaitingDialog(this$0, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$choose$slambda_1($gameQuestion, this$0) {
  return constructCallableReference(function *($completion) {
    var tmp;
    var tmp_0;
    if ($gameQuestion instanceof ChooseCardOnDraftQuestion) {
      tmp_0 = !(this$0.t6h().p38_1 == null);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      this$0.yl3_1 = true;
      var tmp_1 = this$0;
      tmp_1.il4_1 = KorgeControlAgent$choose$slambda$slambda(this$0);
      tmp = Unit_instance;
    } else {
      this$0.emo();
      tmp = Unit_instance;
    }
    _get_choiceFlow__u1vu9o(this$0).ydw();
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$choiceFlow$delegate$lambda$lambda() {
  return get_gameConfiguration().slc_1;
}
function KorgeControlAgent$choiceFlow$delegate$lambda$lambda_0() {
  return new ChoiceFlowConfiguration(get_gameConfiguration().plc_1, get_gameConfiguration().nlc_1, VOID, get_gameConfiguration().olc_1, get_gameConfiguration().qlc_1, get_gameConfiguration().eld_1, get_gameConfiguration().rlc_1);
}
function KorgeControlAgent$choiceFlow$delegate$lambda(this$0) {
  return () => {
    var tmp = new KorgeControlAgent$choiceFlow$2$1(this$0);
    var tmp_0 = KorgeControlAgent$choiceFlow$delegate$lambda$lambda;
    return new ChoiceFlow(this$0, tmp, this$0.il2_1, tmp_0, KorgeControlAgent$choiceFlow$delegate$lambda$lambda_0);
  };
}
function KorgeControlAgent$_get_choiceFlow_$ref_dowiyj() {
  return constructCallableReference((p0) => _get_choiceFlow__u1vu9o(p0), 1, 0, 578);
}
function KorgeControlAgent$showWrongAnswerMessage$slambda($awaitDeferred) {
  return constructCallableReference(function *(it, $completion) {
    it.qlq();
    $awaitDeferred.l1t(Unit_instance);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$restoreDialogCallback$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$addRestoreDialogButtonIfNeeded$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* this$0.il4_1($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$addRestoreDialogButtonIfNeeded$slambda$slambda($button) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $button.klo($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$addRestoreDialogButtonIfNeeded$slambda_0(this$0, $button) {
  return constructCallableReference(function *($this$launch, $completion) {
    var highlightJob = null;
    var tmp;
    try {
      while (this$0.ul2_1.w2($button)) {
        var tmp0_safe_receiver = this$0.nl3_1;
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kmi()) === true)) {
          if (highlightJob == null) {
            highlightJob = launch($this$launch, VOID, VOID, KorgeControlAgent$addRestoreDialogButtonIfNeeded$slambda$slambda($button));
          }
        } else {
          if (!(highlightJob == null)) {
            yield* cancelAndJoin(highlightJob, $completion);
            highlightJob = null;
            $button.pl8(false);
            $button.ql8();
          }
        }
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(250, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
      }
      tmp = Unit_instance;
    }finally {
      var tmp1_safe_receiver = highlightJob;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.o1n();
      }
      $button.pl8(false);
      $button.ql8();
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$installChooseVariants$slambda($result) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t(true);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$installChooseVariants$slambda_0($positionDeferred, $gameQuestion, $result, this$0, $mayNothing) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = yield* $positionDeferred.m1q($completion);
    var position = tmp == null ? null : tmp.r2v_1;
    var tmp_0 = position;
    if (!((tmp_0 == null ? null : new BoardPosition(tmp_0)) == null)) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $gameQuestion.x48_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_1 = position;
        if (equals(new BoardPosition(element.v3g_1), tmp_1 == null ? null : new BoardPosition(tmp_1))) {
          destination.d2(element);
        }
      }
      var possibleMovements = destination;
      var singleMoveVariant = singleOrNull(possibleMovements);
      if (!(singleMoveVariant == null)) {
        $result.l1t(singleMoveVariant);
      } else {
        yield* /*#__NOINLINE__*/playDefaultVariant(this$0, toSet(possibleMovements), $mayNothing, $result, $gameQuestion.t3o(), $completion);
      }
    } else {
      $result.l1t(null);
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseAncientPowerNumber$slambda($result, $ap) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t($ap);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseAncientPowerNumber$slambda_0($result, $ap) {
  return constructCallableReference(function *($completion) {
    $result.l1t($ap);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$chooseTrapByNumberNumber$slambda($result, $trapNumber) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t($trapNumber);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseLocationTypeQuestion$slambda($result, $locationType) {
  return constructCallableReference(function *($completion) {
    $result.l1t($locationType);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$chooseZoneQuestion$slambda($result, $zone) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t($zone);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseZoneQuestion$slambda_0($result) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t(null);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseCharacter$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.dmg(it, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$simpleChooseCharacter$slambda($result, $character) {
  return constructCallableReference(function *($completion) {
    $result.l1t($character);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$playTriggersVariant$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$playTriggersVariant$slambda_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$playTriggersVariant$slambda_1() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$playDefaultVariantImpl$slambda($result, $applyReactionVariant) {
  return constructCallableReference(function *($completion) {
    $result.l1t($applyReactionVariant);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$playDefaultVariantImpl$slambda_0($result, $variant) {
  return constructCallableReference(function *($completion) {
    $result.l1t($variant);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$playDefaultVariantImpl$slambda_1($result, $variant) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t($variant);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseObjectVariant$slambda(this$0, $result) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    removeTemporaryView(this$0, $this$ActionButton);
    $result.l1t(null);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseObjectVariant$lambda($targetPositions) {
  return (it) => {
    var tmp0_safe_receiver = $targetPositions.w4(it);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : singleOrNull(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? it : tmp1_elvis_lhs;
  };
}
function KorgeControlAgent$chooseObjectVariant$slambda_0($targetPositions, $moveButton, this$0, $result, $$this$with, $questionContext) {
  return constructCallableReference(function *(it, $completion) {
    var targetsInPosition = ensureNotNull($targetPositions.w4(it));
    var tmp0_safe_receiver = $moveButton._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      removeTemporaryView(this$0, tmp0_safe_receiver);
    }
    if (targetsInPosition.s2() === 1) {
      $result.l1t(single(targetsInPosition));
    } else {
      yield* /*#__NOINLINE__*/targetsDialog(this$0, $$this$with, toSet(targetsInPosition), $result, false, $questionContext, $completion);
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$targetsDialog$slambda($result, $target) {
  return constructCallableReference(function *($completion) {
    $result.l1t($target);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$addNothingVariant$slambda($result) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t(null);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseLocation$slambda($infoText, this$0, $result) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp0_safe_receiver = $infoText;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      removeTemporaryView(this$0, tmp0_safe_receiver);
    }
    removeTemporaryView(this$0, $this$ActionButton);
    $result.l1t(null);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$chooseLocation$slambda_0($infoText, this$0, $enoughButton, $result) {
  return constructCallableReference(function *(it, $completion) {
    var tmp0_safe_receiver = $infoText;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      removeTemporaryView(this$0, tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = $enoughButton._v;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      removeTemporaryView(this$0, tmp1_safe_receiver);
    }
    $result.l1t(it);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showDraftWaitingDialog$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showDraftWaitingDialog(this$0, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$draftCardsDialog$lambda($result) {
  return (it) => {
    $result.l1t(it);
    return Unit_instance;
  };
}
function KorgeControlAgent$showDraftDialog$lambda(it) {
  return Unit_instance;
}
function KorgeControlAgent$showDraftDialog$cards$slambda(this$0, $card) {
  return constructCallableReference(function *($completion) {
    yield* showFullCard(this$0, $card, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$showDraftDialog$cards$slambda_0($isPlayable, $isTransitioning, $onChoose, $card) {
  return constructCallableReference(function *($completion) {
    if ($isPlayable && !$isTransitioning._v)
      $onChoose($card);
    return Unit_instance;
  }, 0);
}
function showDraftDialog$separator(row) {
  var tmp = Size2D.y9p(get_gameLayout().ol5_1 / 40, get_gameLayout().ol5_1 / 2);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_11();
  var tmp$ret$0 = new RectCorners(numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
  // Inline function 'kotlin.apply' call
  var this_0 = addTo_0(RoundRect.rka(tmp, tmp$ret$0, new RGBA(get_gameColors().tlx_1)), row);
  this_0.sif(this_0.xea() + get_gameLayout().ol5_1 * 0.27);
}
function *showDraftDialog$cards($draft, $variants, this$0, currentCards, highlights, isTransitioning, $onChoose, index, cards, panel, selectable, $completion) {
  var _iterator__ex2g4s = cards.p1();
  while (_iterator__ex2g4s.q1()) {
    var card = _iterator__ex2g4s.r1();
    var isPlayable = selectable && $draft.r4m_1.w2(index) && $variants.w2(card);
    var tmp = yield* (yield* this$0.pl6().mle(card, $completion)).m1q($completion);
    var tmp_0 = KorgeControlAgent$showDraftDialog$cards$slambda(this$0, card);
    var cardUi = addTo_0(toHeight(CardUi.tm1(tmp, VOID, card, isPlayable, tmp_0, KorgeControlAgent$showDraftDialog$cards$slambda_0(isPlayable, isTransitioning, $onChoose, card)), get_gameLayout().ol5_1), panel);
    // Inline function 'kotlin.collections.set' call
    currentCards.b5(card, cardUi);
    if (isPlayable) {
      // Inline function 'kotlin.collections.set' call
      var value = new AutoHighlight(cardUi, toPoint(cardUi.s2().l9s(2)));
      highlights.b5(card, value);
    }
  }
  return Unit_instance;
}
function KorgeControlAgent$showDraftDialog$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    var tmp0_safe_receiver = this$0.nl3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$createCharacterPortrait$slambda($onSelectCharacterObject, $characterObject, $isHandMode, this$0) {
  return constructCallableReference(function *($completion) {
    if (!($onSelectCharacterObject == null)) {
      yield* $onSelectCharacterObject($characterObject, $completion);
    } else if ($isHandMode) {
      yield* showCardsInHand(this$0, $characterObject, VOID, $completion);
    } else {
      yield* showCharacterInfoBoard(this$0, $characterObject, VOID, VOID, $completion);
    }
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$generalCardsDialog$slambda$slambda($result, $card) {
  return constructCallableReference(function *($completion) {
    $result.l1t($card);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$generalCardsDialog$slambda(this$0, $variants, $m, $result) {
  return constructCallableReference(function *(card, $completion) {
    var picture = yield* (yield* this$0.pl6().mle(card, $completion)).m1q($completion);
    var tmp;
    if (this$0.emh() && !equals(this$0.fmh(), card)) {
      tmp = false;
    } else {
      tmp = $variants.w2(card);
    }
    var isPlayable = tmp;
    var cardUi = toHeight(yield* createCard(this$0, picture, card, new ShowTheCardWithAction(KorgeControlAgent$generalCardsDialog$slambda$slambda($result, card)), $completion), get_gameLayout().ol5_1);
    var tmp0 = $m;
    // Inline function 'kotlin.collections.set' call
    var value = new AutoHighlight(cardUi, toPoint(cardUi.s2().l9s(2)));
    tmp0.b5(card, value);
    return cardUi;
  }, 1);
}
function KorgeControlAgent$generalCardsDialog$slambda_0($result) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $result.l1t(null);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$installCurrentGameDialog$slambda($gameDialog) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    var tmp_0 = tmp.hlq_1;
    var tmp_1;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp_1 = $gameDialog._v;
    }
    yield* tmp_0(tmp_1, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$installCurrentGameDialog$slambda_0($dialog) {
  return constructCallableReference(function *($completion) {
    yield* $dialog.hlq_1($dialog, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$variantToString$lambda($variant) {
  return ($this$withStateRuntime) => actionStatementText($this$withStateRuntime, $variant.l4c_1, true);
}
function KorgeControlAgent$variantToString$lambda_0($variant) {
  return ($this$withStateRuntime) => actionStatementText($this$withStateRuntime, $variant, true);
}
function KorgeControlAgent$approveMasterFixing$slambda($answer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $answer.l1t(true);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$approveMasterFixing$slambda_0($answer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $answer.l1t(false);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$approveMasterFixing$slambda_1($answer) {
  return constructCallableReference(function *(it, $completion) {
    $answer.l1t(false);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$approveRevert$slambda($answer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $answer.l1t(true);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$approveRevert$slambda_0($answer) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $answer.l1t(false);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$approveRevert$slambda_1($answer) {
  return constructCallableReference(function *(it, $completion) {
    $answer.l1t(false);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$createOnboardingMenuButton$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showOnboardingMenu(this$0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$createOnboardingMenuButton$slambda_0($$this$apply) {
  return constructCallableReference(function *(it, $completion) {
    $$this$apply.sig(1.0);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$createOnboardingMenuButton$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$createOnboardingMenuButton$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$createOnboardingMenuButton$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$createOnboardingMenuButton$slambda_1($$this$apply) {
  return constructCallableReference(function *(it, $completion) {
    $$this$apply.sig(0.0);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$createOnboardingMenuButton$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$createOnboardingMenuButton$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, KorgeControlAgent$createOnboardingMenuButton$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function KorgeControlAgent$showMenu$slambda(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* this$0.il2_1.udx($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_0(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* this$0.dll(VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_1(this$0, $switchingProvider) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* showReplayVisibilityMenu(this$0, $switchingProvider, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* this$0.il2_1.tdx($completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          var tmp0_elvis_lhs = e_0.message;
          showErrorDialog(this$0.nl2_1, tmp0_elvis_lhs == null ? 'Failed to share replay' : tmp0_elvis_lhs);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_2(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.jl2_1, VOID, VOID, KorgeControlAgent$showMenu$slambda$slambda(this$0));
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.gmo($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_3(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    // Inline function 'kotlin.requireNotNull' call
    var tmp0 = this$0.nl3_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalArgumentException.h2(toString(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var menuDialog = tmp$ret$1;
    var tmp = this$0.pl6();
    var tmp_0 = get_gameContentVersion(this$0.t6h().y37_1);
    var contentReferenceDialog = createAndShowContentReferenceDialog(this$0.jl2_1, this$0.nl2_1, tmp, tmp_0, VOID, VOID, KorgeControlAgent$showMenu$slambda$slambda_0(this$0));
    this$0.nl3_1 = contentReferenceDialog;
    menuDialog.qlq();
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_4(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showUserSettings(this$0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda$slambda$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    it.qlq();
    yield* this$0.il2_1.udx($completion);
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda$slambda_1($mode, this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var serverDrivenConfiguration = ensureNotNull(get_gameConfiguration().flc_1);
      var gameCode = $mode.lml_1;
      yield* serverDrivenConfiguration.p6l(gameCode, $completion);
      var tmp_0 = this$0.pln();
      showSharedCode(tmp_0, gameCode, serverDrivenConfiguration, true, KorgeControlAgent$showMenu$slambda$slambda$slambda(this$0));
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_1 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_5(this$0, $mode) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.jl2_1, VOID, VOID, KorgeControlAgent$showMenu$slambda$slambda_1($mode, this$0));
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda$slambda_2(this$0, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0_safe_receiver = this$0.nl3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    var tmp;
    if (this$0.il2_1.rdx()) {
      // Inline function 'kotlin.also' call
      var this_0 = GameDialog.xlq(this$0.nl2_1, PlainText("Waiting for the other team's approval (up to 60 seconds)", get_gameLayout().sl5_1), 'Master fixing');
      this_0.ylq();
      tmp = this_0;
    } else {
      tmp = null;
    }
    var waitingDialog = tmp;
    var tmp_0;
    try {
      tmp_0 = yield* $serverDrivenConfiguration.b6m($completion);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        var tmp1_elvis_lhs = e.message;
        showErrorDialog(this$0.nl2_1, tmp1_elvis_lhs == null ? 'Master fixing is unavailable: game is not running' : tmp1_elvis_lhs);
        tmp_1 = Unit_instance;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    finally {
      if (waitingDialog == null)
        null;
      else {
        waitingDialog.qlq();
      }
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_6(this$0, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.jl2_1, VOID, VOID, KorgeControlAgent$showMenu$slambda$slambda_2(this$0, $serverDrivenConfiguration));
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda$slambda_3(this$0, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0_safe_receiver = this$0.nl3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    var tmp;
    if (this$0.il2_1.rdx()) {
      // Inline function 'kotlin.also' call
      var this_0 = GameDialog.xlq(this$0.nl2_1, PlainText("Waiting for the other team's revert consent (up to 60 seconds)", get_gameLayout().sl5_1), 'Revert turn');
      this_0.ylq();
      tmp = this_0;
    } else {
      tmp = null;
    }
    var waitingDialog = tmp;
    var tmp_0;
    try {
      tmp_0 = yield* $serverDrivenConfiguration.y6l($completion);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          var tmp1_elvis_lhs = e_0.message;
          tmp_1 = new InternalRevertError(tmp1_elvis_lhs == null ? 'Request failed' : tmp1_elvis_lhs);
        } else {
          throw $p;
        }
      }
      tmp_0 = tmp_1;
    }
    finally {
      if (waitingDialog == null)
        null;
      else {
        waitingDialog.qlq();
      }
    }
    var result = tmp_0;
    var tmp_2;
    if (result instanceof InternalRevertError) {
      showErrorDialog(this$0.nl2_1, 'Revert turn is unavailable: ' + result.o6p_1);
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_7(this$0, $serverDrivenConfiguration) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch(this$0.jl2_1, VOID, VOID, KorgeControlAgent$showMenu$slambda$slambda_3(this$0, $serverDrivenConfiguration));
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_8(this$0) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    this$0.il2_1.vdx();
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showMenu$slambda_9($dialog, $controlPanelY, $presenceConfiguration, $presencePanel) {
  return constructCallableReference(function *($this$launch, $completion) {
    while ($dialog.kmi() && $dialog.s2f() === $controlPanelY.xlb_1) {
      try {
        // Inline function 'kotlin.requireNotNull' call
        var tmp0 = $presenceConfiguration;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0 == null) {
            var message = 'Required value was null.';
            throw IllegalArgumentException.h2(toString(message));
          } else {
            tmp$ret$1 = tmp0;
            break $l$block;
          }
        }
        var presence = yield* tmp$ret$1.x6l($completion);
        if (!(presence == null)) {
          $presencePanel.kml(presence);
        } else {
          $presencePanel.jml('Connected clients unavailable');
        }
      } catch ($p) {
        if ($p instanceof CancellationException) {
          var e = $p;
          throw e;
        } else {
          if ($p instanceof Exception) {
            var _unused_var__etf5q3 = $p;
            $presencePanel.jml('Connected clients unavailable');
          } else {
            throw $p;
          }
        }
      }
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$3 = toDuration(2000, DurationUnit_MILLISECONDS_getInstance());
      yield* delay(tmp$ret$3, $completion);
    }
    return Unit_instance;
  }, 1);
}
function KorgeControlAgent$showUserSettings$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/showUserSettings(this$0, $completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$showUserSettings$slambda_0(this$0) {
  return constructCallableReference(function *($completion) {
    yield* this$0.gmo($completion);
    return Unit_instance;
  }, 0);
}
function KorgeControlAgent$showUserSettings$slambda_1(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.gmo($completion);
    return Unit_instance;
  }, 1);
}
function get_sidePanelCardWidth() {
  _init_properties_KorgeControlAgent_kt__keev5q();
  var tmp;
  switch (get_gameLayout().jl5_1.w1_1) {
    case 1:
      tmp = (get_gameLayout().ml5_1 - get_gameLayout().yl5_1 * 4) / 3;
      break;
    case 0:
      tmp = (get_gameLayout().ml5_1 - get_gameLayout().yl5_1 * 4) / 2;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function get_visualInfo($context_GameState_t6qee5, _this__u8e3s4) {
  _init_properties_KorgeControlAgent_kt__keev5q();
  var tmp;
  var tmp_0;
  if (get_charactersInOrder($context_GameState_t6qee5).s2() === 5) {
    var tmp_1 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
    tmp_0 = isInterface(tmp_1, BeastCharacter);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = 0;
  } else {
    tmp = get_wounds($context_GameState_t6qee5, _this__u8e3s4);
  }
  var woundsToRender = tmp;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'steelart.beast.cast' call
    var tmp_2 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
    if (tmp_2 instanceof Draug) {
      tmp$ret$0 = _this__u8e3s4 instanceof ObjectOnBoard ? _this__u8e3s4 : THROW_CCE();
      break $l$block;
    }
    tmp$ret$0 = null;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_draugCorruptionLevel($context_GameState_t6qee5, tmp0_safe_receiver);
  var tmp_3;
  if (tmp1_elvis_lhs == null) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'steelart.beast.cast' call
      var tmp_4 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
      if (tmp_4 instanceof Lydan) {
        tmp$ret$1 = _this__u8e3s4 instanceof ObjectOnBoard ? _this__u8e3s4 : THROW_CCE();
        break $l$block_0;
      }
      tmp$ret$1 = null;
    }
    var tmp2_safe_receiver = tmp$ret$1;
    tmp_3 = tmp2_safe_receiver == null ? null : get_lydanHarvest($context_GameState_t6qee5, tmp2_safe_receiver);
  } else {
    tmp_3 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_3;
  var tmp_5;
  if (tmp3_elvis_lhs == null) {
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'steelart.beast.cast' call
      var tmp_6 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
      if (tmp_6 instanceof Valdi) {
        tmp$ret$2 = _this__u8e3s4 instanceof ObjectOnBoard ? _this__u8e3s4 : THROW_CCE();
        break $l$block_1;
      }
      tmp$ret$2 = null;
    }
    var tmp4_safe_receiver = tmp$ret$2;
    tmp_5 = tmp4_safe_receiver == null ? null : get_valdiBlood($context_GameState_t6qee5, tmp4_safe_receiver);
  } else {
    tmp_5 = tmp3_elvis_lhs;
  }
  var tmp5_elvis_lhs = tmp_5;
  var tmp_7;
  if (tmp5_elvis_lhs == null) {
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'steelart.beast.cast' call
      var tmp_8 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
      if (tmp_8 instanceof Vacker) {
        tmp$ret$3 = _this__u8e3s4 instanceof ObjectOnBoard ? _this__u8e3s4 : THROW_CCE();
        break $l$block_2;
      }
      tmp$ret$3 = null;
    }
    var tmp6_safe_receiver = tmp$ret$3;
    tmp_7 = tmp6_safe_receiver == null ? null : get_activeSouls($context_GameState_t6qee5, tmp6_safe_receiver);
  } else {
    tmp_7 = tmp5_elvis_lhs;
  }
  var tmp7_elvis_lhs = tmp_7;
  var uniqueResourceNumber = tmp7_elvis_lhs == null ? -1 : tmp7_elvis_lhs;
  var tmp_9 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
  var tmp_10;
  var tmp$ret$4;
  $l$block_3: {
    // Inline function 'steelart.beast.cast' call
    var tmp_11 = get_objectType($context_GameState_t6qee5, _this__u8e3s4);
    if (tmp_11 instanceof FeatheredKing) {
      tmp$ret$4 = _this__u8e3s4 instanceof ObjectOnBoard ? _this__u8e3s4 : THROW_CCE();
      break $l$block_3;
    }
    tmp$ret$4 = null;
  }
  if (!(tmp$ret$4 == null)) {
    tmp_10 = get_isReborn($context_GameState_t6qee5, _this__u8e3s4);
  } else {
    tmp_10 = false;
  }
  return new CharacterVisualInfo(tmp_9, tmp_10, woundsToRender, get_ancientPowerNumber($context_GameState_t6qee5, _this__u8e3s4), get_grudgesNumber($context_GameState_t6qee5, _this__u8e3s4), uniqueResourceNumber);
}
var MenuButtonElement_instance;
function MenuButtonElement_getInstance() {
  return MenuButtonElement_instance;
}
var DiscardButtonElement_instance;
function DiscardButtonElement_getInstance() {
  return DiscardButtonElement_instance;
}
var RuinButtonElement_instance;
function RuinButtonElement_getInstance() {
  return RuinButtonElement_instance;
}
var OverPanelUiHoverPosition_OverArsenalHover_instance;
var OverPanelUiHoverPosition_OverMainPanelTopHover_instance;
var OverPanelUiHoverPosition_entriesInitialized;
function OverPanelUiHoverPosition_initEntries() {
  if (OverPanelUiHoverPosition_entriesInitialized)
    return Unit_instance;
  OverPanelUiHoverPosition_entriesInitialized = true;
  OverPanelUiHoverPosition_OverArsenalHover_instance = new OverPanelUiHoverPosition('OverArsenalHover', 0);
  OverPanelUiHoverPosition_OverMainPanelTopHover_instance = new OverPanelUiHoverPosition('OverMainPanelTopHover', 1);
}
function OverPanelUiHoverPosition_OverArsenalHover_getInstance() {
  OverPanelUiHoverPosition_initEntries();
  return OverPanelUiHoverPosition_OverArsenalHover_instance;
}
function OverPanelUiHoverPosition_OverMainPanelTopHover_getInstance() {
  OverPanelUiHoverPosition_initEntries();
  return OverPanelUiHoverPosition_OverMainPanelTopHover_instance;
}
var properties_initialized_KorgeControlAgent_kt_4qssnw;
function _init_properties_KorgeControlAgent_kt__keev5q() {
  if (!properties_initialized_KorgeControlAgent_kt_4qssnw) {
    properties_initialized_KorgeControlAgent_kt_4qssnw = true;
    currentKorgeMode = OtherControlAgentMode_instance;
  }
}
function fitCardsToPanel(topLevelCardPanel, views, allowedWidth, allowedHeight) {
  if (views.n1() || allowedWidth <= 0.0 || allowedHeight <= 0.0)
    return Unit_instance;
  var numberOfCards = views.s2();
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = numberRangeToNumber(1, numberOfCards);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = tmp0.n3_1;
  var last = tmp0.o3_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_0 = element;
      var tmp$ret$4;
      $l$block: {
        var cardsInRow = ((numberOfCards + tmp0_0 | 0) - 1 | 0) / tmp0_0 | 0;
        var cellWidth = (allowedWidth - get_gameLayout().yl5_1 * (cardsInRow - 1 | 0)) / cardsInRow;
        var cellHeight = (allowedHeight - get_gameLayout().yl5_1 * (tmp0_0 - 1 | 0)) / tmp0_0;
        if (cellWidth <= 0.0 || cellHeight <= 0.0) {
          tmp$ret$4 = null;
          break $l$block;
        }
        // Inline function 'kotlin.collections.minOf' call
        var iterator = views.p1();
        if (!iterator.q1())
          throw NoSuchElementException.w7();
        var view = iterator.r1();
        var widthScale = view.pig() > cellWidth ? cellWidth / view.pig() : 1.0;
        var heightScale = view.rig() > cellHeight ? cellHeight / view.rig() : 1.0;
        // Inline function 'kotlin.comparisons.minOf' call
        var minValue = Math.min(widthScale, heightScale);
        while (iterator.q1()) {
          var view_0 = iterator.r1();
          var widthScale_0 = view_0.pig() > cellWidth ? cellWidth / view_0.pig() : 1.0;
          var heightScale_0 = view_0.rig() > cellHeight ? cellHeight / view_0.rig() : 1.0;
          // Inline function 'kotlin.comparisons.minOf' call
          var v = Math.min(widthScale_0, heightScale_0);
          // Inline function 'kotlin.comparisons.minOf' call
          var a = minValue;
          minValue = Math.min(a, v);
        }
        var minViewScale = minValue;
        tmp$ret$4 = new CardsGridPlacing(tmp0_0, cardsInRow, cellWidth, cellHeight, minViewScale);
      }
      var tmp0_safe_receiver = tmp$ret$4;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
     while (!(element === last));
  var tmp = destination;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = fitCardsToPanel$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_2(tmp_0);
  var tmp_1 = fitCardsToPanel$lambda_0(this_0);
  var tmp$ret$14 = new sam$kotlin_Comparator$0_2(tmp_1);
  var tmp0_elvis_lhs = maxWithOrNull(tmp, tmp$ret$14);
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  var gridPlacing = tmp_2;
  var cardIndex = {_v: 0};
  if (gridPlacing.kmp_1 === 1) {
    // Inline function 'kotlin.repeat' call
    var times = gridPlacing.lmp_1;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < times)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        fitCardsToPanel$addCard(cardIndex, views, gridPlacing, topLevelCardPanel);
      }
       while (inductionVariable_0 < times);
  } else {
    var allRowsPanel = new ControlPanelY();
    // Inline function 'kotlin.repeat' call
    var times_0 = gridPlacing.kmp_1;
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < times_0)
      do {
        var index_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var rowPanel = new ControlPanelX();
        // Inline function 'kotlin.repeat' call
        var times_1 = gridPlacing.lmp_1;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < times_1)
          do {
            var index_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            fitCardsToPanel$addCard(cardIndex, views, gridPlacing, rowPanel);
          }
           while (inductionVariable_2 < times_1);
        addTo_0(rowPanel.xlb_1, allRowsPanel);
      }
       while (inductionVariable_1 < times_0);
    addTo_0(allRowsPanel.xlb_1, topLevelCardPanel);
  }
}
function fitCardsToPanel$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.omp_1;
  var tmp$ret$2 = b.omp_1;
  return compareValues(tmp, tmp$ret$2);
}
function fitCardsToPanel$lambda_0($this) {
  return (a, b) => {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = -a.kmp_1 | 0;
      var tmp$ret$2 = -b.kmp_1 | 0;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function fitCardsToPanel$addCard(cardIndex, $views, gridPlacing, targetPanel) {
  if (cardIndex._v < $views.s2()) {
    var view = $views.u2(cardIndex._v);
    cardIndex._v = cardIndex._v + 1 | 0;
    if (view.pig() > gridPlacing.mmp_1 || view.rig() > gridPlacing.nmp_1) {
      var tmp0 = gridPlacing.mmp_1 / view.pig();
      // Inline function 'kotlin.comparisons.minOf' call
      var b = gridPlacing.nmp_1 / view.rig();
      var scale = Math.min(tmp0, b);
      view.wif(view.xif() * scale);
      view.yif(view.zif() * scale);
    }
    addTo_0(view, targetPanel);
  }
}
var EmptyKorgeStateLogging_instance;
function EmptyKorgeStateLogging_getInstance() {
  return EmptyKorgeStateLogging_instance;
}
function anchor_0($this, point) {
  return Anchor2D.p9g(point.r9g_1 / $this.dls_1.w9z(), point.s9g_1 / $this.dls_1.x9z());
}
function Image$_get_anchor_$ref_nch4q6(p0) {
  return constructCallableReference(() => p0.jjb(), 0, 0, 579, VOID, [p0]);
}
function Image$_set_anchor_$ref_wmec3q(p0) {
  return constructCallableReference((p0_0) => {
    p0.ijb(p0_0);
    return Unit_instance;
  }, 1, 0, 580, VOID, [p0]);
}
function Image$_get_scale_$ref_62rx9v(p0) {
  return constructCallableReference(() => p0.vif(), 0, 0, 581, VOID, [p0]);
}
function Image$_set_scale_$ref_zdmdof(p0) {
  return constructCallableReference((p0_0) => {
    p0.uif(p0_0);
    return Unit_instance;
  }, 1, 0, 582, VOID, [p0]);
}
function actionSourceText(effectSource) {
  return splitCamelCase(ensureNotNull(getKClassFromExpression(effectSource).j1()));
}
function actionStatementText($context_GameStateRuntime_604ce3, statement, isVariantChoose) {
  var tmp;
  if (statement instanceof RecoveryTestStatement) {
    tmp = 'Recovery test: ' + statement.u5y_1.y5z_1;
  } else {
    if (statement instanceof RecoveryTestForEachHunterStatement) {
      tmp = 'Recovery test: each Hunter';
    } else {
      if (statement instanceof InAnyOrderStatement) {
        var lastScope = last(get_gameScopes($context_GameStateRuntime_604ce3));
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (lastScope instanceof CardApplyingScope) {
          tmp_2 = equals(lastScope.i4h_1, PursuitCard_getInstance());
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          var tmp_3 = lastScope.k4h_1;
          tmp_1 = tmp_3 instanceof ChooseOneOfStatement;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp_4;
          var tmp0 = statement.v2o($context_GameStateRuntime_604ce3);
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_5;
            if (isInterface(tmp0, Collection)) {
              tmp_5 = tmp0.n1();
            } else {
              tmp_5 = false;
            }
            if (tmp_5) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.p1();
            while (_iterator__ex2g4s.q1()) {
              var element = _iterator__ex2g4s.r1();
              if (element instanceof SearchForBeastStatement) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          if (tmp$ret$0) {
            tmp_4 = get_gameI18n().t6z_1;
          } else {
            tmp_4 = get_gameI18n().u6z_1;
          }
          tmp_0 = tmp_4;
        } else {
          reportWarning($context_GameStateRuntime_604ce3, 'InAnyOrderStatement');
          tmp_0 = 'in Any Order';
        }
        tmp = tmp_0;
      } else {
        if (statement instanceof RelocationToSettlementStatement) {
          tmp = get_gameI18n().x70($context_GameStateRuntime_604ce3, statement.t33_1);
        } else {
          if (isInterface(statement, ObjectMovementStatement)) {
            var name = nameOfObject($context_GameStateRuntime_604ce3, statement.f2p());
            tmp = isVariantChoose ? get_gameI18n().u70(name) : get_gameI18n().t70(name);
          } else {
            if (statement instanceof AttackStatement) {
              tmp = get_gameI18n().v70($context_GameStateRuntime_604ce3, statement);
            } else {
              if (statement instanceof SummonSignStatement) {
                tmp = get_gameI18n().x6z_1;
              } else {
                tmp = removeSuffix(splitCamelCase(ensureNotNull(getKClassFromExpression(statement).j1())), ' Statement');
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function phaseText($context_GameState_t6qee5, phase) {
  var tmp0_elvis_lhs = get_gameI18n().z70($context_GameState_t6qee5, phase);
  return tmp0_elvis_lhs == null ? removeSuffix(splitCamelCase(ensureNotNull(getKClassFromExpression(phase).j1())), ' Phase') : tmp0_elvis_lhs;
}
function nameOfObject($context_GameState_t6qee5, movingObject) {
  var name = get_gameI18n().s70(get_objectType($context_GameState_t6qee5, movingObject));
  return name;
}
function connectOrCreateGame(_this__u8e3s4, sContainer, connectNewGame) {
  var controlPanelY = new ControlPanelY();
  // Inline function 'kotlin.apply' call
  var this_0 = new ControlPanelY();
  this_0.mlr(PlainText('Connected users:', get_gameLayout().sl5_1));
  var clientsPanel = this_0;
  var gameDialog = GameDialog.mlt(sContainer, DialogContent.llt(controlPanelY.xlb_1, mapOf(to(DialogCorner_RIGHT_TOP_getInstance(), clientsPanel.xlb_1))));
  var contentVersionSelectionState = {_v: ContentVersionSelectionState.fdy(Companion_getInstance_2().w39_1)};
  var allowedExpansions = get_gameConfiguration().dlc_1;
  if (!connectNewGame.f97()) {
    var tmp0_safe_receiver = connectNewGame.e97();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(tmp0_safe_receiver)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addTo_0(PlainText('Game name: ' + tmp1_safe_receiver, get_gameLayout().sl5_1), controlPanelY);
    }
  }
  if (connectNewGame.f97()) {
    var code = connectNewGame.d97();
    var copyResult = PlainText('', get_gameLayout().sl5_1);
    var tmp_1 = 'Private game code: ' + code.o6k_1 + ' (click to copy)';
    addTo_0(ActionButton.vlb(tmp_1, VOID, VOID, VOID, VOID, VOID, connectOrCreateGame$slambda(copyResult, code)), controlPanelY);
    addTo_0(copyResult, controlPanelY);
  }
  var chosenSideText = connectOrCreateGame$newInfoText(controlPanelY);
  var chosenScenarioText = connectOrCreateGame$newInfoText(controlPanelY);
  var alternativeSetupText = connectOrCreateGame$newInfoText(controlPanelY);
  var chosenContentVersionText = connectOrCreateGame$newInfoText(controlPanelY);
  var recordingGameModeText = get_gameConfiguration().elc_1 ? connectOrCreateGame$newInfoText(controlPanelY) : null;
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList.n2(2);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < 2)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$11 = connectOrCreateGame$newInfoText(controlPanelY);
      list.d2(tmp$ret$11);
    }
     while (inductionVariable < 2);
  var gameTeams = list;
  var avatarSize = get_gameLayout().sl5_1 * 1.5;
  var displayedClients = {_v: emptyList()};
  // Inline function 'kotlin.collections.mutableListOf' call
  var avatarJobs = ArrayList.p2();
  var currentRules = {_v: null};
  var isRecordingGameMode = {_v: false};
  var isPubliclyObserved = {_v: !connectNewGame.f97()};
  var tmp_2 = get_gameI18n().l6y_1;
  var startGameButton = ActionButton.vlb(tmp_2, false, VOID, VOID, VOID, VOID, connectOrCreateGame$slambda_0(connectNewGame));
  var eventsJob = {_v: null};
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList.p2();
  this_1.d2(new TextAndAction('Back', connectOrCreateGame$slambda_1(gameDialog, eventsJob, avatarJobs, _this__u8e3s4, sContainer)));
  this_1.d2(new TextAndAction('Pick Beast', connectOrCreateGame$slambda_2(connectNewGame)));
  this_1.d2(new TextAndAction('Pick Hunters', connectOrCreateGame$slambda_3(connectNewGame)));
  this_1.d2(new TextAndAction('Observer', connectOrCreateGame$slambda_4(connectNewGame)));
  this_1.d2(new TextAndAction('Full Observer', connectOrCreateGame$slambda_5(connectNewGame)));
  this_1.d2(new TextAndAction('Select content version', connectOrCreateGame$slambda_6(sContainer, contentVersionSelectionState, allowedExpansions, _this__u8e3s4, currentRules, startGameButton, chosenScenarioText, chosenContentVersionText, connectNewGame)));
  this_1.d2(new TextAndAction('Select contract', connectOrCreateGame$slambda_7(currentRules, _this__u8e3s4, contentVersionSelectionState, sContainer, connectNewGame)));
  if (get_gameConfiguration().elc_1) {
    this_1.d2(new TextAndAction('Switch recording game mode', connectOrCreateGame$slambda_8(_this__u8e3s4, connectNewGame, isRecordingGameMode)));
  }
  var actions = this_1.g9();
  var actionColumn = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  // Inline function 'kotlin.collections.associateWith' call
  var this_2 = listOf([true, false]);
  var result = LinkedHashMap.cd(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s = this_2.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp_3 = (element ? '[x]' : '[ ]') + ' Publicly observed';
    // Inline function 'kotlin.apply' call
    var this_3 = ActionButton.vlb(tmp_3, VOID, VOID, VOID, VOID, VOID, connectOrCreateGame$slambda_9(connectNewGame, isPubliclyObserved));
    this_3.ngk(element === isPubliclyObserved._v);
    result.b5(element, this_3);
  }
  var observationButtons = result;
  var observerButton = {_v: null};
  var _iterator__ex2g4s_0 = actions.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var action = _iterator__ex2g4s_0.r1();
    if (action.smp_1 === 'Observer') {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = observationButtons.y4().p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_0 = _iterator__ex2g4s_1.r1();
        addTo_0(element_0, actionColumn);
      }
    }
    var button = addTo_0(ActionButton.xlt(action, connectOrCreateGame$slambda_10()), actionColumn);
    if (action.smp_1 === 'Observer') {
      observerButton._v = button;
    }
  }
  var tmp_4 = get_gameI18n().z6z_1;
  var modifyButton = addTo_0(ActionButton.vlb(tmp_4, VOID, VOID, VOID, VOID, VOID, connectOrCreateGame$slambda_11(currentRules, sContainer, connectNewGame)), actionColumn);
  modifyButton.ngk(false);
  addTo_0(startGameButton, actionColumn);
  addTo_0(actionColumn.xlb_1, controlPanelY);
  connectOrCreateGame$updateSetupUi(isPubliclyObserved, observationButtons, observerButton, contentVersionSelectionState, allowedExpansions, chosenSideText, currentRules, modifyButton, actionColumn, chosenScenarioText, alternativeSetupText, isRecordingGameMode, recordingGameModeText, startGameButton, gameTeams, chosenContentVersionText, displayedClients, avatarJobs, clientsPanel, _this__u8e3s4, avatarSize, gameDialog, new ServerDuelSetupGameData(VOID, VOID, VOID, VOID, emptyMap(), 0, VOID, !connectNewGame.f97()));
  eventsJob._v = launch(_this__u8e3s4.wlp_1, VOID, VOID, connectOrCreateGame$slambda_12(connectNewGame, _this__u8e3s4, sContainer, isPubliclyObserved, observationButtons, observerButton, contentVersionSelectionState, allowedExpansions, chosenSideText, currentRules, modifyButton, actionColumn, chosenScenarioText, alternativeSetupText, isRecordingGameMode, recordingGameModeText, startGameButton, gameTeams, chosenContentVersionText, displayedClients, avatarJobs, clientsPanel, avatarSize, gameDialog));
  var tmp_5;
  if (eventsJob._v == null) {
    throwUninitializedPropertyAccessException('eventsJob');
  } else {
    tmp_5 = eventsJob._v;
  }
  var tmp_6 = tmp_5;
  tmp_6.g1n(connectOrCreateGame$lambda(avatarJobs));
  gameDialog.ylq();
}
function showModifyRulesDialog(sContainer, rules, connectNewGame) {
  var controlPanelY = new ControlPanelY(VOID, VOID, VOID, 5.0);
  var gameDialog = GameDialog.xlq(sContainer, controlPanelY.xlb_1);
  var currentRulesParameters = {_v: rules.c3a()};
  showModifyRulesDialog$updateDialog(controlPanelY, rules, currentRulesParameters, connectNewGame, gameDialog);
  gameDialog.ylq();
}
function connectOrCreateGame$submitContract$slambda($connectNewGame, $contract, $contentVersionSelectionState) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $connectNewGame.h97(withGameContentVersion($contract, connectOrCreateGame$selectedContentVersion($contentVersionSelectionState, $contract)), $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$showContractSelectionDialog$slambda$slambda($this_connectOrCreateGame, $connectNewGame, $contentVersionSelectionState) {
  return constructCallableReference(function *(contract, $completion) {
    connectOrCreateGame$submitContract($this_connectOrCreateGame, $connectNewGame, $contentVersionSelectionState, contract);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$showContractSelectionDialog$slambda($this_connectOrCreateGame, $sContainer, $contracts, $initialContract, $connectNewGame, $contentVersionSelectionState) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* showContractSelectionDialog($this_connectOrCreateGame.wlp_1, $sContainer, $this_connectOrCreateGame.vlp_1, $contracts, $initialContract, 'Choose contract', 'Back', connectOrCreateGame$showContractSelectionDialog$slambda$slambda($this_connectOrCreateGame, $connectNewGame, $contentVersionSelectionState), VOID, $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$newInfoText(controlPanelY) {
  return addTo_0(PlainText('', get_gameLayout().sl5_1), controlPanelY);
}
function connectOrCreateGame$availableContracts(contentVersionSelectionState) {
  var selectedVersion = contentVersionSelectionState._v.gdy();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_gameConfiguration().tlc_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.w3a().i4g(selectedVersion)) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var tmp$ret$5 = withGameContentVersion(item, selectedVersion);
    destination_0.d2(tmp$ret$5);
  }
  return destination_0;
}
function connectOrCreateGame$selectedContentVersion(contentVersionSelectionState, contract) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = contract.w3a();
  var tmp;
  if (!this_0.i4g(contentVersionSelectionState._v.gdy())) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? contentVersionSelectionState._v.gdy() : tmp0_elvis_lhs;
}
function connectOrCreateGame$submitContract($this_connectOrCreateGame, $connectNewGame, contentVersionSelectionState, contract) {
  launch($this_connectOrCreateGame.wlp_1, VOID, VOID, connectOrCreateGame$submitContract$slambda($connectNewGame, contract, contentVersionSelectionState));
}
function connectOrCreateGame$showContractSelectionDialog($this_connectOrCreateGame, contentVersionSelectionState, $sContainer, $connectNewGame, currentContract) {
  var contracts = connectOrCreateGame$availableContracts(contentVersionSelectionState);
  var tmp;
  if (currentContract == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s = contracts.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (getKClassFromExpression(element).equals(getKClassFromExpression(currentContract))) {
          if (found) {
            tmp$ret$2 = null;
            break $l$block_0;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$2 = null;
        break $l$block_0;
      }
      tmp$ret$2 = single;
    }
    tmp = tmp$ret$2;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? firstOrNull(contracts) : tmp1_elvis_lhs;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var initialContract = tmp_0;
  launch($this_connectOrCreateGame.wlp_1, VOID, VOID, connectOrCreateGame$showContractSelectionDialog$slambda($this_connectOrCreateGame, $sContainer, contracts, initialContract, $connectNewGame, contentVersionSelectionState));
}
function connectOrCreateGame$slambda($copyResult, $code) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    setText($copyResult, copyToClipboard($code.o6k_1) ? 'Copied to clipboard' : 'Failed to copy code');
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$updateConnectedClients(displayedClients, avatarJobs, clientsPanel, $this_connectOrCreateGame, avatarSize, gameDialog, clients) {
  if (equals(clients, displayedClients._v))
    return Unit_instance;
  displayedClients._v = toList_0(clients);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = avatarJobs.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.o1n();
  }
  avatarJobs.a5();
  clientsPanel.xlb_1.tie();
  clientsPanel.dlr_1 = 0.0;
  clientsPanel.mlr(PlainText('Connected users:', get_gameLayout().sl5_1));
  var _iterator__ex2g4s_0 = clients.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var client = _iterator__ex2g4s_0.r1();
    var userInfo = new UserInfoView($this_connectOrCreateGame.ulp_1.plo_1, client.t6s_1, client.v6s_1, get_gameLayout().sl5_1, avatarSize, client.u6s_1);
    addTo_0(userInfo.clt_1, clientsPanel);
    var tmp0_safe_receiver = userInfo.dlt_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.plusAssign' call
      avatarJobs.d2(tmp0_safe_receiver);
    }
  }
  if (gameDialog.kmi()) {
    clientsPanel.xlb_1.rif(gameDialog.ylt().w9z() - get_gameLayout().ql5_1 - clientsPanel.xlb_1.pig());
  }
}
function connectOrCreateGame$slambda_0($connectNewGame) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $connectNewGame.l97($completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$updateChosenContentVersionText(chosenContentVersionText, contentVersionSelectionState) {
  setText(chosenContentVersionText, 'Selected content version: ' + contentVersionSelectionState._v.hdy());
}
function connectOrCreateGame$slambda_1($gameDialog, $eventsJob, $avatarJobs, $this_connectOrCreateGame, $sContainer) {
  return constructCallableReference(function *($completion) {
    $gameDialog.qlq();
    var tmp;
    if ($eventsJob._v == null) {
      throwUninitializedPropertyAccessException('eventsJob');
    } else {
      tmp = $eventsJob._v;
    }
    tmp.o1n();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $avatarJobs.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.o1n();
    }
    yield* $this_connectOrCreateGame.bls($sContainer, $completion);
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_2($connectNewGame) {
  return constructCallableReference(function *($completion) {
    yield* $connectNewGame.i97(get_beastsGameTeam(), $completion);
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_3($connectNewGame) {
  return constructCallableReference(function *($completion) {
    yield* $connectNewGame.i97(get_huntersGameTeam(), $completion);
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_4($connectNewGame) {
  return constructCallableReference(function *($completion) {
    yield* $connectNewGame.i97(get_observerGameTeamMarker(), $completion);
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_5($connectNewGame) {
  return constructCallableReference(function *($completion) {
    yield* $connectNewGame.i97(get_fullObserverGameTeamMarker(), $completion);
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda$lambda$slambda($connectNewGame, $newState) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $connectNewGame.g97($newState.gdy(), $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$slambda$lambda$slambda_0($connectNewGame) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $connectNewGame.h97(null, $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$slambda$lambda($contentVersionSelectionState, $this_connectOrCreateGame, $currentRules, $startGameButton, $chosenScenarioText, $chosenContentVersionText, $connectNewGame) {
  return (newState) => {
    $contentVersionSelectionState._v = newState;
    connectOrCreateGame$updateChosenContentVersionText($chosenContentVersionText, $contentVersionSelectionState);
    launch($this_connectOrCreateGame.wlp_1, VOID, VOID, connectOrCreateGame$slambda$lambda$slambda($connectNewGame, newState));
    var tmp;
    var tmp0_safe_receiver = $currentRules._v;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w3a();
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i4g(newState.gdy())) === false) {
      $currentRules._v = null;
      $startGameButton.ils(false);
      setText($chosenScenarioText, 'The contract is not chosen yet');
      launch($this_connectOrCreateGame.wlp_1, VOID, VOID, connectOrCreateGame$slambda$lambda$slambda_0($connectNewGame));
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function connectOrCreateGame$slambda_6($sContainer, $contentVersionSelectionState, $allowedExpansions, $this_connectOrCreateGame, $currentRules, $startGameButton, $chosenScenarioText, $chosenContentVersionText, $connectNewGame) {
  return constructCallableReference(function *($completion) {
    var tmp = $contentVersionSelectionState._v;
    showContentVersionSelectionDialog($sContainer, tmp, $allowedExpansions, connectOrCreateGame$slambda$lambda($contentVersionSelectionState, $this_connectOrCreateGame, $currentRules, $startGameButton, $chosenScenarioText, $chosenContentVersionText, $connectNewGame));
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_7($currentRules, $this_connectOrCreateGame, $contentVersionSelectionState, $sContainer, $connectNewGame) {
  return constructCallableReference(function *($completion) {
    connectOrCreateGame$showContractSelectionDialog($this_connectOrCreateGame, $contentVersionSelectionState, $sContainer, $connectNewGame, $currentRules._v);
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda$slambda($connectNewGame, $isRecordingGameMode) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $connectNewGame.j97(!$isRecordingGameMode._v, $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$slambda_8($this_connectOrCreateGame, $connectNewGame, $isRecordingGameMode) {
  return constructCallableReference(function *($completion) {
    launch($this_connectOrCreateGame.wlp_1, VOID, VOID, connectOrCreateGame$slambda$slambda($connectNewGame, $isRecordingGameMode));
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_9($connectNewGame, $isPubliclyObserved) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $connectNewGame.k97(!$isPubliclyObserved._v, $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$slambda_10() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function connectOrCreateGame$slambda_11($currentRules, $sContainer, $connectNewGame) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp0_safe_receiver = $currentRules._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      showModifyRulesDialog($sContainer, tmp0_safe_receiver, $connectNewGame);
    }
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$updateSetupUi(isPubliclyObserved, observationButtons, observerButton, contentVersionSelectionState, allowedExpansions, chosenSideText, currentRules, modifyButton, actionColumn, chosenScenarioText, alternativeSetupText, isRecordingGameMode, recordingGameModeText, startGameButton, gameTeams, chosenContentVersionText, displayedClients, avatarJobs, clientsPanel, $this_connectOrCreateGame, avatarSize, gameDialog, update) {
  isPubliclyObserved._v = update.p6s_1;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = observationButtons.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var checked = element.j3();
    // Inline function 'kotlin.collections.component2' call
    var button = element.k3();
    button.ngk(checked === isPubliclyObserved._v);
  }
  var tmp;
  if (observerButton._v == null) {
    throwUninitializedPropertyAccessException('observerButton');
  } else {
    tmp = observerButton._v;
  }
  tmp.ils(!isPubliclyObserved._v);
  contentVersionSelectionState._v = ContentVersionSelectionState.fdy(update.i6s_1).idy(allowedExpansions);
  connectOrCreateGame$updateChosenContentVersionText(chosenContentVersionText, contentVersionSelectionState);
  var myGameTeam = update.k6s_1;
  var tmp_0;
  var tmp_1 = myGameTeam;
  if (equals(tmp_1 == null ? null : new GameTeam(tmp_1), new GameTeam(get_fullObserverGameTeamMarker()))) {
    tmp_0 = 'You will watch the game with full visibility';
  } else {
    var tmp_2 = myGameTeam;
    if (equals(tmp_2 == null ? null : new GameTeam(tmp_2), new GameTeam(get_observerGameTeamMarker()))) {
      tmp_0 = 'You will watch the game';
    } else {
      var tmp_3 = myGameTeam;
      if (!((tmp_3 == null ? null : new GameTeam(tmp_3)) == null)) {
        tmp_0 = 'Your side will be ' + get_gameI18n().m70(myGameTeam);
      } else {
        tmp_0 = "You haven't chosen the team yet";
      }
    }
  }
  var gameTeamStr = tmp_0;
  setText(chosenSideText, gameTeamStr);
  var rules = update.j6s_1;
  currentRules._v = rules;
  modifyButton.ngk(!(rules == null));
  actionColumn.flr();
  var tmp_4;
  if (!(rules == null)) {
    var tmp0 = get_gameConfiguration().tlc_1;
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s_0 = tmp0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        if (getKClassFromExpression(element_0).equals(getKClassFromExpression(rules))) {
          if (found) {
            tmp$ret$5 = null;
            break $l$block_0;
          }
          single = element_0;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      tmp$ret$5 = single;
    }
    var defaultContract = tmp$ret$5;
    var tmp_5;
    if (defaultContract == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_5 = defaultContract.u3a(defaultContract.c3a().d4g(VOID, get_gameContentVersion(rules)));
    }
    var versionAdjustedDefaultContract = tmp_5;
    var suffix = equals(versionAdjustedDefaultContract, rules) ? '' : defaultContract == null ? ' (strange rules)' : ' (modified)';
    tmp_4 = 'The contract will be ' + ensureNotNull(getKClassFromExpression(rules).j1()) + suffix;
  } else {
    tmp_4 = 'The contract is not chosen yet';
  }
  var contractStr = tmp_4;
  setText(chosenScenarioText, contractStr);
  var tmp_6;
  if (rules == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_6 = get_gameI18n().f71(rules);
  }
  var tmp2_elvis_lhs = tmp_6;
  setText(alternativeSetupText, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
  isRecordingGameMode._v = update.l6s_1;
  if (recordingGameModeText == null)
    null;
  else {
    setText(recordingGameModeText, 'Recording game mode: ' + (isRecordingGameMode._v ? 'ON' : 'OFF'));
  }
  var gameTeamPickMap = update.m6s_1;
  var tmp_7;
  var tmp_8;
  if (!(rules == null)) {
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    var this_0 = gameTeamPickMap.w4(new GameTeam(get_beastsGameTeam()));
    tmp_8 = !(this_0 == null || this_0.n1());
  } else {
    tmp_8 = false;
  }
  if (tmp_8) {
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    var this_1 = gameTeamPickMap.w4(new GameTeam(get_huntersGameTeam()));
    tmp_7 = !(this_1 == null || this_1.n1());
  } else {
    tmp_7 = false;
  }
  startGameButton.ils(tmp_7);
  var _iterator__ex2g4s_1 = listOf([new GameTeam(get_beastsGameTeam()), new GameTeam(get_huntersGameTeam())]).p1();
  while (_iterator__ex2g4s_1.q1()) {
    var gameTeam = _iterator__ex2g4s_1.r1().r3p_1;
    var tmp4_safe_receiver = gameTeamPickMap.w4(new GameTeam(gameTeam));
    var tmp_9;
    if (tmp4_safe_receiver == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_10;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!tmp4_safe_receiver.n1()) {
        tmp_10 = tmp4_safe_receiver;
      } else {
        tmp_10 = null;
      }
      tmp_9 = tmp_10;
    }
    var tmp5_safe_receiver = tmp_9;
    var names = tmp5_safe_receiver == null ? null : joinToString(tmp5_safe_receiver, ', ');
    var tmp_11 = ' ' + get_gameI18n().m70(gameTeam) + ': ';
    var message = tmp_11 + (names == null ? 'Not picked yet' : names);
    setText(gameTeams.u2(_GameTeam___get_teamId__impl__chxeb3(gameTeam)), message);
  }
  connectOrCreateGame$updateConnectedClients(displayedClients, avatarJobs, clientsPanel, $this_connectOrCreateGame, avatarSize, gameDialog, update.o6s_1);
}
function connectOrCreateGame$slambda$slambda$slambda($update, $sContainer, $this_connectOrCreateGame, $isPubliclyObserved, $observationButtons, $observerButton, $contentVersionSelectionState, $allowedExpansions, $chosenSideText, $currentRules, $modifyButton, $actionColumn, $chosenScenarioText, $alternativeSetupText, $isRecordingGameMode, $recordingGameModeText, $startGameButton, $gameTeams, $chosenContentVersionText, $displayedClients, $avatarJobs, $clientsPanel, $avatarSize, $gameDialog) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    var tmp0_subject = $update;
    var tmp;
    if (tmp0_subject instanceof NotFoundSetupSession) {
      showErrorDialog($sContainer, 'Not found game setup. Try to reload.');
      tmp = Unit_instance;
    } else {
      if (tmp0_subject instanceof SetupEnded) {
        showErrorDialog($sContainer, 'Game setup ended: ' + $update.z6r_1.toString() + '. Try to reload.');
        tmp = Unit_instance;
      } else {
        if (tmp0_subject instanceof SetupUpdate) {
          connectOrCreateGame$updateSetupUi($isPubliclyObserved, $observationButtons, $observerButton, $contentVersionSelectionState, $allowedExpansions, $chosenSideText, $currentRules, $modifyButton, $actionColumn, $chosenScenarioText, $alternativeSetupText, $isRecordingGameMode, $recordingGameModeText, $startGameButton, $gameTeams, $chosenContentVersionText, $displayedClients, $avatarJobs, $clientsPanel, $this_connectOrCreateGame, $avatarSize, $gameDialog, $update.d6s_1);
          tmp = Unit_instance;
        } else {
          if (tmp0_subject instanceof GameStarted) {
            var setup = $update.s6r_1;
            var tmp_0;
            if (!(setup == null)) {
              tmp_0 = yield* initGame($this_connectOrCreateGame.ulp_1, $this_connectOrCreateGame.vlp_1, $this_connectOrCreateGame.wlp_1, new ServerDuelSetup(setup), $completion);
            } else {
              tmp_0 = yield* $this_connectOrCreateGame.bls($sContainer, $completion);
            }
            tmp = tmp_0;
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$slambda$slambda_0($this_connectOrCreateGame, $sContainer, $isPubliclyObserved, $observationButtons, $observerButton, $contentVersionSelectionState, $allowedExpansions, $chosenSideText, $currentRules, $modifyButton, $actionColumn, $chosenScenarioText, $alternativeSetupText, $isRecordingGameMode, $recordingGameModeText, $startGameButton, $gameTeams, $chosenContentVersionText, $displayedClients, $avatarJobs, $clientsPanel, $avatarSize, $gameDialog) {
  return constructCallableReference(function *(update, $completion) {
    yield* insideScope($this_connectOrCreateGame.ulp_1.plo_1, connectOrCreateGame$slambda$slambda$slambda(update, $sContainer, $this_connectOrCreateGame, $isPubliclyObserved, $observationButtons, $observerButton, $contentVersionSelectionState, $allowedExpansions, $chosenSideText, $currentRules, $modifyButton, $actionColumn, $chosenScenarioText, $alternativeSetupText, $isRecordingGameMode, $recordingGameModeText, $startGameButton, $gameTeams, $chosenContentVersionText, $displayedClients, $avatarJobs, $clientsPanel, $avatarSize, $gameDialog), $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$slambda_12($connectNewGame, $this_connectOrCreateGame, $sContainer, $isPubliclyObserved, $observationButtons, $observerButton, $contentVersionSelectionState, $allowedExpansions, $chosenSideText, $currentRules, $modifyButton, $actionColumn, $chosenScenarioText, $alternativeSetupText, $isRecordingGameMode, $recordingGameModeText, $startGameButton, $gameTeams, $chosenContentVersionText, $displayedClients, $avatarJobs, $clientsPanel, $avatarSize, $gameDialog) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $connectNewGame.m97(connectOrCreateGame$slambda$slambda_0($this_connectOrCreateGame, $sContainer, $isPubliclyObserved, $observationButtons, $observerButton, $contentVersionSelectionState, $allowedExpansions, $chosenSideText, $currentRules, $modifyButton, $actionColumn, $chosenScenarioText, $alternativeSetupText, $isRecordingGameMode, $recordingGameModeText, $startGameButton, $gameTeams, $chosenContentVersionText, $displayedClients, $avatarJobs, $clientsPanel, $avatarSize, $gameDialog), $completion);
    return Unit_instance;
  }, 1);
}
function connectOrCreateGame$lambda($avatarJobs) {
  return (it) => {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $avatarJobs.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      element.o1n();
    }
    return Unit_instance;
  };
}
function showModifyRulesDialog$updateDialog$bonusRow$slambda($update, $current, $controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $update(coerceAtLeast_0($current - 1 | 0, 0));
    showModifyRulesDialog$updateDialog($controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog);
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog$bonusRow$slambda_0($update, $current, $controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $update($current + 1 | 0);
    showModifyRulesDialog$updateDialog($controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog);
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog$slambda($currentRulesParameters, $balanceVersion, $controlPanelY, $rules, $connectNewGame, $gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $currentRulesParameters._v = $currentRulesParameters._v.d4g($balanceVersion);
    showModifyRulesDialog$updateDialog($controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog);
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog$updateBonuses(currentRulesParameters, $rules, bonuses) {
  var tmp = currentRulesParameters._v;
  // Inline function 'kotlin.takeUnless' call
  var tmp_0;
  if (!bonuses.equals($rules.g3a())) {
    tmp_0 = bonuses;
  } else {
    tmp_0 = null;
  }
  var tmp$ret$0 = tmp_0;
  currentRulesParameters._v = tmp.d4g(VOID, VOID, tmp$ret$0);
}
function showModifyRulesDialog$updateDialog$bonusRow(controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog, label, current, update) {
  var row = new ButtonRow();
  addTo_0(BorderedText(label, get_gameLayout().sl5_1), row);
  addTo_0(ActionButton.vlb('-', VOID, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$bonusRow$slambda(update, current, controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog)), row);
  addTo_0(PlainText(current.toString(), get_gameLayout().sl5_1), row);
  addTo_0(ActionButton.vlb('+', VOID, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$bonusRow$slambda_0(update, current, controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog)), row);
  row.flr();
  addTo_0(row.xlb_1, controlPanelY);
}
function showModifyRulesDialog$updateDialog$lambda($currentBonuses, $currentRulesParameters, $rules) {
  return (it) => {
    showModifyRulesDialog$updateDialog$updateBonuses($currentRulesParameters, $rules, $currentBonuses.q4g(it));
    return Unit_instance;
  };
}
function showModifyRulesDialog$updateDialog$lambda_0($currentBonuses, $currentRulesParameters, $rules) {
  return (it) => {
    showModifyRulesDialog$updateDialog$updateBonuses($currentRulesParameters, $rules, $currentBonuses.q4g(VOID, it));
    return Unit_instance;
  };
}
function showModifyRulesDialog$updateDialog$lambda_1($currentBonuses, $currentRulesParameters, $rules) {
  return (it) => {
    showModifyRulesDialog$updateDialog$updateBonuses($currentRulesParameters, $rules, $currentBonuses.q4g(VOID, VOID, it));
    return Unit_instance;
  };
}
function showModifyRulesDialog$updateDialog$slambda_0($currentRulesParameters, $controlPanelY, $rules, $connectNewGame, $gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $currentRulesParameters._v = $currentRulesParameters._v.d4g(VOID, VOID, VOID, VOID, !$currentRulesParameters._v.a4g_1);
    showModifyRulesDialog$updateDialog($controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog);
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog$slambda_1($currentRulesParameters, $controlPanelY, $rules, $connectNewGame, $gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $currentRulesParameters._v = $currentRulesParameters._v.d4g(VOID, VOID, VOID, !$currentRulesParameters._v.z4f_1);
    showModifyRulesDialog$updateDialog($controlPanelY, $rules, $currentRulesParameters, $connectNewGame, $gameDialog);
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog$slambda_2($rules, $currentRulesParameters, $connectNewGame, $gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var newRules = $rules.u3a($currentRulesParameters._v);
    yield* $connectNewGame.h97(newRules, $completion);
    $gameDialog.qlq();
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog$slambda_3($gameDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $gameDialog.qlq();
    return Unit_instance;
  }, 1);
}
function showModifyRulesDialog$updateDialog(controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog) {
  controlPanelY.xlb_1.tie();
  controlPanelY.dlr_1 = 0.0;
  if ($rules.w3a().q3d_1.n1()) {
    var balanceVersionPanel = new ButtonRow();
    addTo_0(BorderedText(get_gameI18n().a70_1, get_gameLayout().sl5_1), balanceVersionPanel);
    var _iterator__ex2g4s = get_entries_1().p1();
    while (_iterator__ex2g4s.q1()) {
      var balanceVersion = _iterator__ex2g4s.r1();
      var tmp;
      switch (balanceVersion.w1_1) {
        case 0:
          tmp = 'Official V1';
          break;
        case 1:
          tmp = 'Official V2';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var label = tmp;
      var tmp_0 = !currentRulesParameters._v.w4f_1.equals(balanceVersion);
      addTo_0(ActionButton.vlb(label, tmp_0, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$slambda(currentRulesParameters, balanceVersion, controlPanelY, $rules, $connectNewGame, gameDialog)), balanceVersionPanel);
    }
    balanceVersionPanel.flr();
    addTo_0(balanceVersionPanel.xlb_1, controlPanelY);
  }
  // Inline function 'kotlin.run' call
  var tmp0_elvis_lhs = currentRulesParameters._v.y4f_1;
  var currentBonuses = tmp0_elvis_lhs == null ? $rules.g3a() : tmp0_elvis_lhs;
  var tmp_1 = get_gameI18n().c70_1;
  showModifyRulesDialog$updateDialog$bonusRow(controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog, tmp_1, currentBonuses.l4g_1, showModifyRulesDialog$updateDialog$lambda(currentBonuses, currentRulesParameters, $rules));
  var tmp_2 = get_gameI18n().d70_1;
  showModifyRulesDialog$updateDialog$bonusRow(controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog, tmp_2, currentBonuses.m4g_1, showModifyRulesDialog$updateDialog$lambda_0(currentBonuses, currentRulesParameters, $rules));
  var tmp_3 = get_gameI18n().e70_1;
  showModifyRulesDialog$updateDialog$bonusRow(controlPanelY, $rules, currentRulesParameters, $connectNewGame, gameDialog, tmp_3, currentBonuses.n4g_1, showModifyRulesDialog$updateDialog$lambda_1(currentBonuses, currentRulesParameters, $rules));
  if (($rules.j3a() + $rules.k3a() | 0) === 3) {
    var draftRow = new ButtonRow();
    addTo_0(BorderedText(get_gameI18n().f70_1, get_gameLayout().sl5_1), draftRow);
    var tmp_4 = currentRulesParameters._v.a4g_1 ? '[x]' : '[ ]';
    addTo_0(ActionButton.vlb(tmp_4, true, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$slambda_0(currentRulesParameters, controlPanelY, $rules, $connectNewGame, gameDialog)), draftRow);
    addTo_0(draftRow.xlb_1, controlPanelY);
  }
  if (currentRulesParameters._v.x4f_1.h4g()) {
    var alternativeSetupRow = new ButtonRow();
    addTo_0(BorderedText('Alternative Beast setup', get_gameLayout().sl5_1), alternativeSetupRow);
    var tmp_5 = currentRulesParameters._v.z4f_1 ? '[x]' : '[ ]';
    addTo_0(ActionButton.vlb(tmp_5, true, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$slambda_1(currentRulesParameters, controlPanelY, $rules, $connectNewGame, gameDialog)), alternativeSetupRow);
    addTo_0(alternativeSetupRow.xlb_1, controlPanelY);
  }
  var footer = new ButtonRow();
  var tmp_6 = get_gameI18n().g70_1;
  addTo_0(ActionButton.vlb(tmp_6, VOID, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$slambda_2($rules, currentRulesParameters, $connectNewGame, gameDialog)), footer);
  var tmp_7 = get_gameI18n().t6y_1;
  addTo_0(ActionButton.vlb(tmp_7, VOID, VOID, VOID, VOID, VOID, showModifyRulesDialog$updateDialog$slambda_3(gameDialog)), footer);
  addTo_0(footer.xlb_1, controlPanelY);
}
function placingLocationUtility(beastUiMap, uiPlacing) {
  var p = Vector2D.a9k(4154, 2573);
  var tmp0 = beastUiMap.hl7_1;
  var tmp2 = uiPlacing.blo_1 / 2.0;
  var tmp4 = new RGBA(Companion_getInstance_15().ich(255, 255, 255, 255));
  // Inline function 'korlibs.korge.view.circle' call
  var stroke = new RGBA(Colors_getInstance().cc3_1);
  var renderer = GraphicsRenderer_GPU_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Circle.ajq(numberToDouble(tmp2), tmp4, stroke, numberToDouble(0.0), true, renderer);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, tmp0);
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_1, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
  this_1.sig(0.6);
  position_0(this_1, p);
  var testImage = this_1;
  movePlacing(beastUiMap, testImage);
}
function *placingMovementUtility(beastUiMap, uiPlacing, images, $completion) {
  var tmp = yield* (yield* images.wle(null, $completion)).m1q($completion);
  // Inline function 'kotlin.apply' call
  var this_0 = CardUi.tm1(tmp, VOID, VOID, VOID, VOID, placingMovementUtility$slambda());
  position_0(this_0, uiPlacing.elo_1.u2(0));
  toWidth(this_0, uiPlacing.flo_1);
  var card = addTo(this_0, beastUiMap.hl7_1);
  movePlacing(beastUiMap, card);
  return Unit_instance;
}
function *placingRuinUtility(beastUiMap, uiPlacing, images, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = Image.lk7(yield* (yield* images.vle(GeneralTokens_RuinHunter_getInstance(), $completion)).m1q($completion));
  // Inline function 'korlibs.korge.view.anchor' call
  anchor(this_0, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
  position_0(this_0, uiPlacing.elo_1.u2(0));
  toWidth(this_0, uiPlacing.flo_1);
  var card = addTo(this_0, beastUiMap.hl7_1);
  movePlacing(beastUiMap, card);
  return Unit_instance;
}
function movePlacing(beastUiMap, view) {
  var p1 = {_v: view.wb5()};
  // Inline function 'kotlin.apply' call
  var this_0 = beastUiMap.hl7_1;
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  get_mouse(this_0).vhw_1.w9y(movePlacing$lambda(p1, view));
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  var $this$keys = get_keys(this_0);
  var shift = 10.0 * beastUiMap.hl7_1.vif();
  var tmp = Key_LEFT_getInstance();
  $this$keys.ohv(tmp, movePlacing$lambda_0(p1, shift, view));
  var tmp_0 = Key_RIGHT_getInstance();
  $this$keys.ohv(tmp_0, movePlacing$lambda_1(p1, shift, view));
  var tmp_1 = Key_UP_getInstance();
  $this$keys.ohv(tmp_1, movePlacing$lambda_2(p1, shift, view));
  var tmp_2 = Key_DOWN_getInstance();
  $this$keys.ohv(tmp_2, movePlacing$lambda_3(p1, shift, view));
  var tmp_3 = Key_Q_getInstance();
  $this$keys.ohv(tmp_3, movePlacing$lambda_4(view));
  var tmp_4 = Key_W_getInstance();
  $this$keys.ohv(tmp_4, movePlacing$lambda_5(view));
}
function placingMovementUtility$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function movePlacing$updateMe($view, p1) {
  position_0($view, p1._v);
  println('position: ' + roundToInt(p1._v.r9g_1) + ' to ' + roundToInt(p1._v.s9g_1));
}
function movePlacing$lambda($p1, $view) {
  return (it) => {
    $p1._v = it.uhy();
    position_0($view, $p1._v);
    return Unit_instance;
  };
}
function movePlacing$lambda_0($p1, $shift, $view) {
  return (it) => {
    $p1._v = Vector2D.t9g($p1._v.r9g_1 - $shift, $p1._v.s9g_1);
    movePlacing$updateMe($view, $p1);
    return Unit_instance;
  };
}
function movePlacing$lambda_1($p1, $shift, $view) {
  return (it) => {
    $p1._v = Vector2D.t9g($p1._v.r9g_1 + $shift, $p1._v.s9g_1);
    movePlacing$updateMe($view, $p1);
    return Unit_instance;
  };
}
function movePlacing$lambda_2($p1, $shift, $view) {
  return (it) => {
    $p1._v = Vector2D.t9g($p1._v.r9g_1, $p1._v.s9g_1 - $shift);
    movePlacing$updateMe($view, $p1);
    return Unit_instance;
  };
}
function movePlacing$lambda_3($p1, $shift, $view) {
  return (it) => {
    $p1._v = Vector2D.t9g($p1._v.r9g_1, $p1._v.s9g_1 + $shift);
    movePlacing$updateMe($view, $p1);
    return Unit_instance;
  };
}
function movePlacing$lambda_4($view) {
  return (it) => {
    $view.uif($view.vif() * 1.1);
    println('scaledWidth: ' + $view.pig());
    return Unit_instance;
  };
}
function movePlacing$lambda_5($view) {
  return (it) => {
    $view.uif($view.vif() * 0.9);
    println('scaledWidth: ' + $view.pig());
    return Unit_instance;
  };
}
function shadowingCornersImage(shadowColor) {
  var bitmap = Bitmap32.lc1(get_gameLayout().el6_1, get_gameLayout().fl6_1);
  // Inline function 'korlibs.math.geom.Vector2D.div' call
  // Inline function 'korlibs.math.geom.Vector2D.div' call
  var this_0 = Vector2D.a9k(get_gameLayout().el6_1, get_gameLayout().fl6_1);
  var c = Vector2D.t9g(this_0.r9g_1 / 2, this_0.s9g_1 / 2);
  var tmp0 = get_gameLayout().el6_1;
  // Inline function 'kotlin.math.min' call
  var b = get_gameLayout().fl6_1;
  var tmp$ret$2 = Math.min(tmp0, b);
  var r = imul(tmp$ret$2, 3) / 16 | 0;
  var rM = c.a();
  var ext = rM - r;
  var inductionVariable = 0;
  var last = bitmap.sc1_1;
  if (inductionVariable < last)
    do {
      var x = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = bitmap.tc1_1;
      if (inductionVariable_0 < last_0)
        do {
          var y = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.math.geom.Vector2D.minus' call
          var this_1 = Vector2D.a9k(x, y);
          var len = Vector2D.t9g(this_1.r9g_1 - c.r9g_1, this_1.s9g_1 - c.s9g_1).a();
          var tmp;
          if (len < r) {
            tmp = Colors_getInstance().ec3_1;
          } else {
            var d = (len - r) / ext;
            var k = 0.5;
            var tmp_0 = 1 - d;
            // Inline function 'kotlin.math.exp' call
            var x_0 = -k * d;
            var a = d / (d + tmp_0 * Math.exp(x_0));
            tmp = RGBA__withAd_impl_cralao(shadowColor, a);
          }
          var color = tmp;
          bitmap.gcb(x, y, color);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  var maskImage = Image.lk7(bitmap);
  return maskImage;
}
function *fangrirIllustration(images, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = Image.lk7(yield* (yield* images.xle('Fangrir-game-1.jpg', $completion)).m1q($completion));
  var tmp2 = get_gameLayout().el6_1;
  // Inline function 'korlibs.korge.view.size' call
  var height = get_gameLayout().fl6_1;
  size(this_0, numberToDouble(tmp2), numberToDouble(height));
  this_0.sig(0.0);
  return this_0;
}
function *animatePreAnswer(_this__u8e3s4, insertion, $completion) {
  if (insertion instanceof MapUiScalingAndPosition) {
    yield* _this__u8e3s4.gl2_1.kl7_1(Vector2D.a9k(insertion.q6x_1, insertion.r6x_1), insertion.s6x_1, $completion);
    return Unit_instance;
  }
  if (insertion instanceof LogicalAnimationInsertion) {
    var isFirst = true;
    var _iterator__ex2g4s = insertion.ump_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var animation = _iterator__ex2g4s.r1();
      if (isFirst) {
        isFirst = false;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(300, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
      }
      if (animation instanceof ShowLocationAnimation) {
        yield* moveCursorOverLocationAndHighlight(_this__u8e3s4, animation.xmp_1, $completion);
      } else {
        if (animation instanceof ShowFromPossibleAnswer) {
          yield* showFromAutoHighlightMap(_this__u8e3s4, animation.wmp_1, $completion);
        } else {
          if (animation instanceof ShowFromDraft) {
            yield* showHuntersDraftCard(_this__u8e3s4, animation.vmp_1, $completion);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  return Unit_instance;
}
function *showFromAutoHighlightMap(_this__u8e3s4, value, $completion) {
  var view = ensureNotNull(_this__u8e3s4.dl5().w4(value)).el5_1;
  yield* showView(_this__u8e3s4, view, $completion);
  return Unit_instance;
}
function *showHuntersDraftCard(_this__u8e3s4, draftActionCard, $completion) {
  var view = ensureNotNull(_this__u8e3s4.zmo(draftActionCard));
  yield* showView(_this__u8e3s4, view, $completion);
  return Unit_instance;
}
function *showView(_this__u8e3s4, view, $completion) {
  var x = view.gig().r9g_1;
  var yTop = view.gig().s9g_1;
  yield* showArea(_this__u8e3s4, x + view.pig() / 2, yTop, yTop + view.rig(), view.pig() / 2, VOID, VOID, $completion);
  return Unit_instance;
}
function *showArea(_this__u8e3s4, xEclipseCenter, yTop, yBottom, rX, animationTime, timesToRepeat, $completion) {
  var tmp;
  if (animationTime === VOID) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp = toDuration(2000, DurationUnit_MILLISECONDS_getInstance());
  } else {
    tmp = animationTime;
  }
  animationTime = tmp;
  timesToRepeat = timesToRepeat === VOID ? 1 : timesToRepeat;
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_12();
  var upper = Vector2D.t9g(numberToDouble(xEclipseCenter), numberToDouble(yTop));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_12();
  var lower = Vector2D.t9g(numberToDouble(xEclipseCenter), numberToDouble(yBottom));
  yield* moveCursor(_this__u8e3s4, upper, VOID, VOID, $completion);
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  // Inline function 'korlibs.math.geom.Vector2D.div' call
  // Inline function 'korlibs.math.geom.Vector2D.div' call
  var this_0 = Vector2D.t9g(upper.r9g_1 + lower.r9g_1, upper.s9g_1 + lower.s9g_1);
  var center = Vector2D.t9g(this_0.r9g_1 / 2, this_0.s9g_1 / 2);
  // Inline function 'korlibs.math.geom.Vector2D.minus' call
  // Inline function 'korlibs.math.geom.Vector2D.div' call
  // Inline function 'korlibs.math.geom.Vector2D.div' call
  var this_1 = Vector2D.t9g(lower.r9g_1 - upper.r9g_1, lower.s9g_1 - upper.s9g_1);
  var h = Vector2D.t9g(this_1.r9g_1 / 2, this_1.s9g_1 / 2).s9g_1;
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < timesToRepeat)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_$receiver = _this__u8e3s4.kl4();
      var tmp1_vs = [V2Callback(VOID, showArea$lambda(_this__u8e3s4, center, rX, h))];
      var tmp2_easing = get_gameAnimations().ll4_1;
      yield* tween(tmp0_$receiver, tmp1_vs, animationTime, tmp2_easing, VOID, VOID, VOID, VOID, $completion);
    }
     while (inductionVariable < timesToRepeat);
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$11 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
  yield* delay(tmp$ret$11, $completion);
  return Unit_instance;
}
function showArea$lambda($this_showArea, $center, $rX, $h) {
  return (r) => {
    var alpha = (-_Ratio___get_value__impl__57cli6(r.v9f_1) - 0.25) * 2 * 3.141592653589793;
    var tmp = $this_showArea.kl4();
    var tmp0 = $center;
    var tmp_0 = numberToDouble($rX);
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_8();
    // Inline function 'korlibs.math.geom.cos' call
    var angle = _Angle___init__impl__g23q1m(alpha);
    var up = Companion_getInstance_12().k9h_1;
    var tmp_1 = tmp_0 * Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_8();
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = _Angle___init__impl__g23q1m(alpha);
    var up_0 = Companion_getInstance_12().k9h_1;
    var tmp$ret$3 = Angle__sine_impl_3l11xv(angle_0, up_0);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.t9g(tmp_1, $h * tmp$ret$3);
    var tmp$ret$4 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    tmp.fcw(tmp$ret$4);
    return Unit_instance;
  };
}
function updateText($this) {
  var tmp0_safe_receiver = $this.mls_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fio($this.ols());
  }
}
function *showReplayVisibilityMenu(_this__u8e3s4, switchingProvider, $completion) {
  var panel = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var _iterator__ex2g4s = get_entries_5().p1();
  while (_iterator__ex2g4s.q1()) {
    var visibility = _iterator__ex2g4s.r1();
    var tmp = !switchingProvider.ze0_1.equals(visibility);
    addTo_0(ActionButton.vlb(visibility.pe0_1, tmp, VOID, VOID, VOID, VOID, showReplayVisibilityMenu$slambda(switchingProvider, visibility, _this__u8e3s4)), panel);
  }
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, showReplayVisibilityMenu$slambda_0(_this__u8e3s4)), panel);
  yield* _this__u8e3s4.cmo(panel.xlb_1, VOID, get_gameDialogClose(), $completion);
  return Unit_instance;
}
function addJumpInTimelineButtonIfNeeded(_this__u8e3s4, controlPanelY) {
  var tmp0_elvis_lhs = _this__u8e3s4.il2_1.z97();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = _this__u8e3s4.ql2_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a6y();
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.with' call
      var $this$with = _this__u8e3s4.t6h();
      // Inline function 'kotlin.collections.associateWith' call
      var this_0 = $this$with.i38_1;
      var result = LinkedHashMap.cd(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
      // Inline function 'kotlin.collections.associateWithTo' call
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp$ret$6 = get_objectType($this$with, element);
        result.b5(element, tmp$ret$6);
      }
      var charactersByObject = result;
      tmp_0 = replayTimelineFromSavedAnswers(tmp2_safe_receiver, Map$get$ref(charactersByObject));
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var replayTimeline = tmp;
  var tmp_1;
  if (_this__u8e3s4.nml()) {
    var tmp4_safe_receiver = replayTimeline == null ? null : replayTimeline.i6v_1;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_2 = !tmp4_safe_receiver.n1();
    }
    tmp_1 = tmp_2 === true;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    addTo_0(ActionButton.vlb('Jump in Timeline', VOID, VOID, VOID, VOID, VOID, addJumpInTimelineButtonIfNeeded$slambda(_this__u8e3s4, replayTimeline)), controlPanelY);
  }
}
function reinstallCurrentReplayQuestion(_this__u8e3s4, switchingProvider) {
  var tmp0_safe_receiver = switchingProvider.xe0_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  _this__u8e3s4.emo();
  _this__u8e3s4.mml();
  _this__u8e3s4.mmo();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.dl5().y4().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.el5_1.uih();
  }
  _this__u8e3s4.rln(emptyMap());
  _this__u8e3s4.tmo();
}
function *showReplayTimelineDays(_this__u8e3s4, timeline, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  addTo_0(ActionButton.vlb('From Start', VOID, VOID, VOID, VOID, VOID, showReplayTimelineDays$slambda(_this__u8e3s4)), controlPanelY);
  var _iterator__ex2g4s = timeline.i6v_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var day = _iterator__ex2g4s.r1();
    var tmp = 'Day ' + day.j6v_1;
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, showReplayTimelineDays$slambda_0(_this__u8e3s4, day)), controlPanelY);
  }
  yield* _this__u8e3s4.imo(controlPanelY.xlb_1, 'Jump in Timeline', get_gameDialogClose(), $completion);
  return Unit_instance;
}
function *jumpInReplayTimeline(_this__u8e3s4, answerIndex, $completion) {
  _this__u8e3s4.tl2_1 = false;
  var tmp0_safe_receiver = _this__u8e3s4.nl3_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.qlq();
  }
  yield* _this__u8e3s4.il2_1.wdx(answerIndex, $completion);
  return Unit_instance;
}
function *showReplayTimelineDay(_this__u8e3s4, day, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var tmp0_safe_receiver = day.k6v_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    addTo_0(ActionButton.vlb('From Dawn', VOID, VOID, VOID, VOID, VOID, showReplayTimelineDay$slambda(_this__u8e3s4, tmp0_safe_receiver)), controlPanelY);
  }
  var _iterator__ex2g4s = day.l6v_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var turn = _iterator__ex2g4s.r1();
    var tmp = 'Turn ' + turn.n6v_1;
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, showReplayTimelineDay$slambda_0(_this__u8e3s4, day, turn)), controlPanelY);
  }
  var tmp1_safe_receiver = day.m6v_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    addTo_0(ActionButton.vlb('Night', VOID, VOID, VOID, VOID, VOID, showReplayTimelineDay$slambda_1(_this__u8e3s4, tmp1_safe_receiver)), controlPanelY);
  }
  yield* _this__u8e3s4.imo(controlPanelY.xlb_1, 'Day ' + day.j6v_1, get_gameDialogClose(), $completion);
  return Unit_instance;
}
function *showReplayTimelineTurn(_this__u8e3s4, dayNumber, turn, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var _iterator__ex2g4s = turn.o6v_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var character = _iterator__ex2g4s.r1();
    var tmp = toString(character.p6v_1);
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, showReplayTimelineTurn$slambda(_this__u8e3s4, character)), controlPanelY);
  }
  yield* _this__u8e3s4.imo(controlPanelY.xlb_1, 'Day ' + dayNumber + ', Turn ' + turn.n6v_1 + ': choose starting character', get_gameDialogClose(), $completion);
  return Unit_instance;
}
function showReplayVisibilityMenu$slambda($switchingProvider, $visibility, $this_showReplayVisibilityMenu) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var questionTeam = $switchingProvider.ye0_1;
    $switchingProvider.ze0_1 = $visibility;
    setReplayVisibilityInUrl($visibility);
    var tmp = $switchingProvider;
    var tmp0_elvis_lhs = $switchingProvider.ae1();
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new GameTeam(tmp_1)) == null) {
      tmp_0 = questionTeam;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp1_elvis_lhs;
    if ((tmp_3 == null ? null : new GameTeam(tmp_3)) == null) {
      tmp_2 = $switchingProvider.qe0_1;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    tmp.qe0_1 = tmp_2;
    var tmp_4;
    if (!($switchingProvider.xe0_1 == null)) {
      reinstallCurrentReplayQuestion($this_showReplayVisibilityMenu, $switchingProvider);
      tmp_4 = Unit_instance;
    } else {
      $this_showReplayVisibilityMenu.lmo();
      tmp_4 = Unit_instance;
    }
    yield* $this_showReplayVisibilityMenu.wmo($completion);
    yield* $this_showReplayVisibilityMenu.gmo($completion);
    return Unit_instance;
  }, 1);
}
function showReplayVisibilityMenu$slambda_0($this_showReplayVisibilityMenu) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $this_showReplayVisibilityMenu.gmo($completion);
    return Unit_instance;
  }, 1);
}
function Map$get$ref(p0) {
  return constructCallableReference((p0_0) => p0.w4(p0_0), 1, 0, 583, 'get', [p0]);
}
function addJumpInTimelineButtonIfNeeded$slambda($this_addJumpInTimelineButtonIfNeeded, $replayTimeline) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showReplayTimelineDays($this_addJumpInTimelineButtonIfNeeded, $replayTimeline, $completion);
    return Unit_instance;
  }, 1);
}
function showReplayTimelineDays$slambda($this_showReplayTimelineDays) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/jumpInReplayTimeline($this_showReplayTimelineDays, 0, $completion);
    return Unit_instance;
  }, 1);
}
function showReplayTimelineDays$slambda_0($this_showReplayTimelineDays, $day) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showReplayTimelineDay($this_showReplayTimelineDays, $day, $completion);
    return Unit_instance;
  }, 1);
}
function showReplayTimelineDay$slambda($this_showReplayTimelineDay, $answerIndex) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/jumpInReplayTimeline($this_showReplayTimelineDay, $answerIndex, $completion);
    return Unit_instance;
  }, 1);
}
function showReplayTimelineDay$slambda_0($this_showReplayTimelineDay, $day, $turn) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/showReplayTimelineTurn($this_showReplayTimelineDay, $day.j6v_1, $turn, $completion);
    return Unit_instance;
  }, 1);
}
function showReplayTimelineDay$slambda_1($this_showReplayTimelineDay, $answerIndex) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/jumpInReplayTimeline($this_showReplayTimelineDay, $answerIndex, $completion);
    return Unit_instance;
  }, 1);
}
function showReplayTimelineTurn$slambda($this_showReplayTimelineTurn, $character) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/jumpInReplayTimeline($this_showReplayTimelineTurn, $character.q6v_1, $completion);
    return Unit_instance;
  }, 1);
}
function SameScreenControlAgent$_init_$o$inScope$slambda_v7irhk($block) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    return yield* $block($completion);
  }, 1);
}
function SameScreenControlAgent$_init_$lambda_7uc4gh() {
  var tmp = get_gameConfiguration().glc_1;
  var tmp_0 = get_gameConfiguration().slc_1;
  var tmp_1 = get_gameConfiguration().jlc_1;
  var tmp_2 = get_gameConfiguration().mlc_1;
  return new UiFlowConfiguration(tmp, tmp_0, tmp_1, tmp_2, SameScreenControlAgent$_init_$lambda$lambda_ulv5b0);
}
function SameScreenControlAgent$_init_$lambda$lambda_ulv5b0($context_GameState_t6qee5, question, answer) {
  get_gameConfiguration().xlc_1.qmp($context_GameState_t6qee5, question, answer);
  return Unit_instance;
}
function SharedTeamsScene$show$slambda$lambda($sceneInjector, this$0) {
  return ($this$mapPrototype) => this$0;
}
function SharedTeamsScene$show$slambda(this$0, $sceneContainer) {
  return constructCallableReference(function *($this$insideScope, $completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.nlu_1;
    yield* this_0.y2a(null, $completion);
    try {
      if (!this$0.olu_1) {
        var tmp0 = $sceneContainer;
        // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
        var injects = [];
        // Inline function 'korlibs.time.seconds' call
        // Inline function 'korlibs.time.seconds' call
        var time = toDuration_0(0, DurationUnit_SECONDS_getInstance());
        var transition = tmp0.hhu_1;
        var tmp2 = getKClass(SharedTeamsScene);
        // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
        var injects_0 = injects.slice();
        var sceneInjector = tmp0.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), tmp0).qe4(getKClass(Resources), new Resources(tmp0.d1m(), tmp0.ghu_1.whu().wbw_1, tmp0.ghu_1.whu()));
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < injects_0.length) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var inject = injects_0[_unary__edvuaz];
          var tmp = getKClassFromExpression(inject);
          sceneInjector.qe4(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
        }
        var newScene = this$0;
        // Inline function 'korlibs.logger.Logger.info' call
        var tmp0_0 = Companion_getInstance_5().mi5_1;
        // Inline function 'korlibs.logger.Logger.log' call
        var level = Level_INFO_getInstance();
        if (tmp0_0.obj(level)) {
          var tmp$ret$11 = 'Changing scene to... ' + toString(tmp2) + ' ... ' + toString(newScene);
          tmp0_0.pbj(level, tmp$ret$11);
        }
        if (true) {
          newScene.be5(sceneInjector);
          var tmp_0 = getKClassFromExpression(newScene);
          var tmp_1 = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
          tmp0.ghu_1.fhn_1.ue4(tmp_1, SharedTeamsScene$show$slambda$lambda(sceneInjector, this$0));
        }
        yield* tmp0.oi5(newScene, time, transition, $completion);
        this$0.olu_1 = true;
      }
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }, 1);
}
function SharedTeamsScene$handover$slambda$slambda$slambda($confirmation) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $confirmation.l1t(Unit_instance);
    return Unit_instance;
  }, 1);
}
function SharedTeamsScene$handover$slambda$slambda$slambda_0($illustration) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = KMutableProperty0;
    var tmp_0 = Image$_get_alpha_$ref_d2kncp($illustration);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, Image$_set_alpha_$ref_g89t1v($illustration));
    var tmp_1 = [new V2(this_0, 1.0, 0.0, _interpolate$ref(), true)];
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    yield* tween($illustration, tmp_1, tmp$ret$1, VOID, VOID, VOID, VOID, VOID, $completion);
    $illustration.uih();
    return Unit_instance;
  }, 1);
}
function SharedTeamsScene$handover$slambda$slambda($team, $showIllustration, this$0, $illustrationAnimation, $this_coroutineScope, $confirmation) {
  return constructCallableReference(function *(overlay, $completion) {
    var panel = new ControlPanelY();
    var tmp = $team === get_beastsGameTeam() ? get_gameI18n().u6y_1 : get_gameI18n().v6y_1;
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, SharedTeamsScene$handover$slambda$slambda$slambda($confirmation)), panel);
    GameDialog.xlq(overlay, panel.xlb_1).ylq();
    var tmp_0;
    if ($showIllustration) {
      var illustration = yield* fangrirIllustration(this$0.mlk_1.ill_1, $completion);
      overlay.uie(illustration);
      $illustrationAnimation._v = launch($this_coroutineScope, VOID, VOID, SharedTeamsScene$handover$slambda$slambda$slambda_0(illustration));
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function SharedTeamsScene$handover$slambda(this$0, $updatePerspective, $team, $showIllustration) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var confirmation = CompletableDeferred_0();
    this$0.olk_1 = confirmation;
    var illustrationAnimation = {_v: null};
    var tmp;
    try {
      var tmp_0 = this$0.ei2();
      tmp = yield* withHotSeatHandover(tmp_0, confirmation, SharedTeamsScene$handover$slambda$slambda($team, $showIllustration, this$0, illustrationAnimation, $this$coroutineScope, confirmation), $updatePerspective, $completion);
    }finally {
      var tmp0_safe_receiver = illustrationAnimation._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.o1n();
      }
      this$0.olk_1 = null;
    }
    return Unit_instance;
  }, 1);
}
function *createSharedTeamsScene(scope, images, switchingGameTeamProvider, menuManagement, gameMapId, mapFormat, controlsBothTeams, configureAgent, $completion) {
  controlsBothTeams = controlsBothTeams === VOID ? true : controlsBothTeams;
  var tmp;
  if (configureAgent === VOID) {
    tmp = createSharedTeamsScene$lambda;
  } else {
    tmp = configureAgent;
  }
  configureAgent = tmp;
  // Inline function 'kotlin.check' call
  if (!get_gameConfiguration().mll()) {
    var message = 'Shared teams require a gameplay UI';
    throw IllegalStateException.o(toString(message));
  }
  var ui = yield* createBeastGameUi(scope, images, switchingGameTeamProvider, menuManagement, gameMapId, mapFormat, createSharedTeamsScene$lambda_0(controlsBothTeams, configureAgent), $completion);
  // Inline function 'kotlin.checkNotNull' call
  var tmp0 = ui.hll_1;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.checkNotNull' call
    if (tmp0 == null) {
      var message_0 = 'Required value was null.';
      throw IllegalStateException.o(toString(message_0));
    } else {
      tmp$ret$3 = tmp0;
      break $l$block;
    }
  }
  var tmp$ret$2 = tmp$ret$3;
  return new SharedTeamsScene(ui, tmp$ret$2);
}
function *withHotSeatHandover(_this__u8e3s4, confirmation, install, updatePerspective, $completion) {
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = toList_0(_this__u8e3s4.xi1_1);
  var result = LinkedHashMap.cd(coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$2 = element.yig();
    result.b5(element, tmp$ret$2);
  }
  var hiddenViews = result;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Container.fi2(false);
  // Inline function 'kotlin.apply' call
  var overlay = addTo(this_1, _this__u8e3s4);
  try {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = hiddenViews.x4().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      element_0.ngk(false);
    }
    var tmp2 = get_gameLayout().el6_1;
    var tmp4 = get_gameLayout().fl6_1;
    // Inline function 'korlibs.korge.view.solidRect' call
    var color = Colors_getInstance().ac3_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = SolidRect.mkf(Size2D.l9i(tmp2, tmp4), color);
    // Inline function 'kotlin.apply' call
    addTo(this_2, overlay);
    yield* install(overlay, $completion);
    yield* confirmation.m1q($completion);
    yield* updatePerspective($completion);
  }finally {
    overlay.uih();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = hiddenViews.i3().p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_1 = _iterator__ex2g4s_1.r1();
      // Inline function 'kotlin.collections.component1' call
      var view = element_1.j3();
      // Inline function 'kotlin.collections.component2' call
      var visible = element_1.k3();
      view.ngk(visible);
    }
  }
  return Unit_instance;
}
function createSharedTeamsScene$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function createSharedTeamsScene$lambda_0($controlsBothTeams, $configureAgent) {
  return ($this$createBeastGameUi) => {
    $this$createBeastGameUi.bl4_1 = !$controlsBothTeams;
    $configureAgent($this$createBeastGameUi);
    return Unit_instance;
  };
}
function *playSandboxMode(newGameSetupState, images, menuManagement, hotSeatSceneManager, reconnectSandboxData, sandboxIdUpdate, $completion) {
  var tmp;
  if (!(reconnectSandboxData == null)) {
    tmp = new Triple(reconnectSandboxData.k6o_1.y4l(), reconnectSandboxData.j6o_1, reconnectSandboxData.l6o_1);
  } else {
    var gameSetupState = yield* ensureNotNull(newGameSetupState).m1q($completion);
    var initSandboxResult = yield* ensureNotNull(get_gameConfiguration().cld_1).g6w(gameSetupState, $completion);
    sandboxIdUpdate(initSandboxResult.n6w_1);
    // Inline function 'kotlin.takeIf' call
    var this_0 = initSandboxResult.n6w_1;
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_1 = this_0.o6k_1;
    if (charSequenceLength(this_1) > 0) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp$ret$0 = tmp_0;
    tmp = new Triple(initSandboxResult.o6w_1, tmp$ret$0, 0);
  }
  var _destruct__k2r9zo = tmp;
  var gameState = _destruct__k2r9zo.jm();
  var gameCode = _destruct__k2r9zo.km();
  var numberOfAppliedEvents = _destruct__k2r9zo.fx();
  var mapFormat = requiredMapFormat(gameState.y37_1);
  var gameMapId = gameState.y37_1.h3a();
  var sceneForPrepare = yield* createSharedTeamsScene(hotSeatSceneManager.plo_1, images, new SwitchingGameTeamProvider(get_beastsGameTeam()), menuManagement, gameMapId, mapFormat, VOID, VOID, $completion);
  yield* sceneForPrepare.plu(hotSeatSceneManager.plo_1, $completion);
  var korgeControlAgent = sceneForPrepare.mlu_1;
  var prepared = yield* korgeControlAgent.kmo().we3(gameState, gameCode, numberOfAppliedEvents, reconnectSandboxData == null, $completion);
  if (!(gameCode == null)) {
    set_currentKorgeMode(new SandboxGamePlaying(gameCode));
  }
  var _destruct__k2r9zo_0 = yield* createAgents(images, menuManagement, hotSeatSceneManager, gameMapId, mapFormat, $completion);
  var beastAgentControl = _destruct__k2r9zo_0.jm();
  var huntersAgentControl = _destruct__k2r9zo_0.km();
  yield* ensureNotNull(get_gameConfiguration().cld_1).j6w(beastAgentControl, huntersAgentControl, prepared.ue2_1, prepared.ve2_1, prepared.we2_1, prepared.xe2_1, sandboxIdUpdate, false, VOID, $completion);
  return Unit_instance;
}
function *reconnectSandbox(images, menuManagement, hotSeatSceneManager, gameSetup, $completion) {
  var gameMapId = gameSetup.zdx_1.h3a();
  var gameCode = gameSetup.ady_1;
  var _destruct__k2r9zo = yield* createAgents(images, menuManagement, hotSeatSceneManager, gameMapId, requiredMapFormat(gameSetup.zdx_1), $completion);
  var beastAgentControl = _destruct__k2r9zo.jm();
  var huntersAgentControl = _destruct__k2r9zo.km();
  set_currentKorgeMode(new SandboxGamePlaying(gameCode));
  yield* ensureNotNull(get_gameConfiguration().cld_1).k6w(beastAgentControl, huntersAgentControl, gameCode, $completion);
  return Unit_instance;
}
function *installStartSandboxDialog(_this__u8e3s4, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this$with.i38_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$4 = new PlayerTurnPhase(item);
    destination.d2(tmp$ret$4);
  }
  var playerTurnPhases = destination;
  var tmp;
  var tmp_0 = $this$with.y37_1;
  if (tmp_0 instanceof RecoveryTestContract) {
    tmp = listOf_0($this$with.y37_1.m3a());
  } else {
    tmp = emptyList();
  }
  var contractSetup = tmp;
  var phases = plus_0(plus(plus(contractSetup, listOf([new DawnPhase(false), new DawnPhase(true), StartOfDayPhase_getInstance()])), playerTurnPhases), NightPhase_getInstance());
  var _iterator__ex2g4s_0 = phases.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var phaseToStart = _iterator__ex2g4s_0.r1();
    var tmp_1 = ensureNotNull(get_gameI18n().z70($this$with, phaseToStart));
    addTo_0(ActionButton.vlb(tmp_1, VOID, VOID, VOID, VOID, VOID, installStartSandboxDialog$slambda(_this__u8e3s4, phaseToStart)), controlPanelY);
  }
  yield* _this__u8e3s4.imo(controlPanelY.xlb_1, 'Choose phase to start play', get_gameDialogClose(), $completion);
  return Unit_instance;
}
function *showVariantsForLocation(_this__u8e3s4, position, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var gameDialog = {_v: null};
  var objects = objectsAt($this$with, position);
  var controlPanelX = new ControlPanelX();
  var availableBarrierConnectedLocations_0 = availableBarrierConnectedLocations($this$with, position);
  var tmp0_safe_receiver = singleOrNull(get_aliveBeasts($this$with));
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (equals(get_objectType($this$with, tmp0_safe_receiver), Omma_getInstance())) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var ommaBeast = tmp;
  // Inline function 'kotlin.also' call
  var this_0 = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  if (get_allWatchtowers($this$with).s2() < $this$with.y37_1.p39()) {
    addTo_0(ActionButton.vlb('Watchtower', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda(_this__u8e3s4, position)), this_0);
  }
  var beast = singleOrNull(get_aliveBeasts($this$with));
  addTo_0(ActionButton.vlb('Transform', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_0($this$with, beast, _this__u8e3s4, position)), this_0);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!availableBarrierConnectedLocations_0.n1()) {
    addTo_0(ActionButton.vlb('Barrier', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_1(gameDialog, _this__u8e3s4, availableBarrierConnectedLocations_0, $this$with, position)), this_0);
  }
  if (!(beast == null)) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = objects.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (equals(get_objectType($this$with, element), BoatType_getInstance())) {
        destination.d2(element);
      }
    }
    var boatsOnPosition = destination;
    var _iterator__ex2g4s_0 = get_objectType($this$with, beast).t36().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var summonType = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$with.f4l();
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList.p2();
      var _iterator__ex2g4s_1 = tmp0.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_0 = _iterator__ex2g4s_1.r1();
        if (equals(get_objectType($this$with, element_0), summonType)) {
          destination_0.d2(element_0);
        }
      }
      var summonsOnBoard = destination_0;
      if (summonsOnBoard.s2() < get_objectType($this$with, beast).u36()) {
        var tmp0_safe_receiver_0 = getKClassFromExpression(summonType).j1();
        var tmp_1 = 'Summon ' + (tmp0_safe_receiver_0 == null ? null : removeSuffix(tmp0_safe_receiver_0, 'Type'));
        addTo_0(ActionButton.vlb(tmp_1, VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_2(_this__u8e3s4, summonType, position)), this_0);
      }
    }
    if ($this$with.h47().z44().w2(new BoardPosition(position)) && boatsOnPosition.n1() && get_gameContentVersion($this$with.y37_1).h4g()) {
      addTo_0(ActionButton.vlb('Boat', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_3(_this__u8e3s4, position)), this_0);
    }
    var tmp_2;
    var tmp_3 = _this__u8e3s4.sm1();
    if (!(tmp_3 instanceof MasterFixing)) {
      tmp_2 = true;
    } else {
      tmp_2 = _this__u8e3s4.k3q() === get_beastsGameTeam();
    }
    if (tmp_2) {
      var tmp1_safe_receiver = get_possibleTrailMaxCounts($this$with, beast).w4(new BoardPosition(position));
      var tmp_4;
      if (tmp1_safe_receiver == null) {
        tmp_4 = null;
      } else {
        var tmp2_elvis_lhs = get_foundTrails($this$with, beast).w4(new BoardPosition(position));
        tmp_4 = tmp1_safe_receiver - (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
      }
      var tmp3_elvis_lhs = tmp_4;
      var missingTrailCount = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
      if (missingTrailCount > 0) {
        addTo_0(ActionButton.vlb('Trail', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_4(_this__u8e3s4, beast, position)), this_0);
      }
    }
  }
  if (!(ommaBeast == null)) {
    addTo_0(ActionButton.vlb('Snare', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_5(_this__u8e3s4, position, ommaBeast)), this_0);
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = $this$with.i38_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = tmp0_0.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var element_1 = _iterator__ex2g4s_2.r1();
    var tmp_5 = get_objectType($this$with, element_1);
    var tmp0_safe_receiver_1 = isInterface(tmp_5, HunterCharacter) ? tmp_5 : null;
    var tmp0_safe_receiver_2 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.i3e();
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.d2(tmp0_safe_receiver_2);
    }
  }
  var hunterCompanionTypes = distinct(destination_1);
  var _iterator__ex2g4s_3 = hunterCompanionTypes.p1();
  while (_iterator__ex2g4s_3.q1()) {
    var hunterCompanionType = _iterator__ex2g4s_3.r1();
    var tmp0_1 = $this$with.f4l();
    var tmp$ret$20;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_6;
      if (isInterface(tmp0_1, Collection)) {
        tmp_6 = tmp0_1.n1();
      } else {
        tmp_6 = false;
      }
      if (tmp_6) {
        tmp$ret$20 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_4 = tmp0_1.p1();
      while (_iterator__ex2g4s_4.q1()) {
        var element_2 = _iterator__ex2g4s_4.r1();
        if (equals(get_objectType($this$with, element_2), hunterCompanionType)) {
          tmp$ret$20 = false;
          break $l$block_0;
        }
      }
      tmp$ret$20 = true;
    }
    if (tmp$ret$20) {
      var tmp4_safe_receiver = getKClassFromExpression(hunterCompanionType).j1();
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : removeSuffix(tmp4_safe_receiver, 'Type');
      var tmp_7 = tmp5_elvis_lhs == null ? 'Hunter Companion' : tmp5_elvis_lhs;
      addTo_0(ActionButton.vlb(tmp_7, VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_6(_this__u8e3s4, hunterCompanionType, position)), this_0);
    }
  }
  addTo_0(this_0.xlb_1, controlPanelX);
  var _iterator__ex2g4s_5 = objects.p1();
  $l$loop: while (_iterator__ex2g4s_5.q1()) {
    var objectOnBoard = _iterator__ex2g4s_5.r1();
    var tmp_8;
    var tmp_9;
    var tmp_10 = _this__u8e3s4.sm1();
    if (tmp_10 instanceof MasterFixing) {
      tmp_9 = _this__u8e3s4.k3q() === get_huntersGameTeam();
    } else {
      tmp_9 = false;
    }
    if (tmp_9) {
      var tmp$ret$22;
      $l$block_1: {
        // Inline function 'steelart.beast.cast' call
        var tmp_11 = get_objectType($this$with, objectOnBoard);
        if (isInterface(tmp_11, BeastCharacter)) {
          tmp$ret$22 = objectOnBoard instanceof ObjectOnBoard ? objectOnBoard : THROW_CCE();
          break $l$block_1;
        }
        tmp$ret$22 = null;
      }
      var tmp1_safe_receiver_0 = tmp$ret$22;
      tmp_8 = (tmp1_safe_receiver_0 == null ? null : get_isHidden($this$with, tmp1_safe_receiver_0)) === true;
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      continue $l$loop;
    }
    // Inline function 'kotlin.also' call
    var this_1 = new ControlPanelY();
    addTo_0(toHeight(yield* targetObjectView($this$with, _this__u8e3s4, objectOnBoard, $completion), get_gameLayout().ll6_1), this_1);
    var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
    addTo_0(actions.xlb_1, this_1);
    var tmp0_safe_receiver_3 = healButton(_this__u8e3s4, objectOnBoard);
    if (tmp0_safe_receiver_3 == null)
      null;
    else
      addTo_0(tmp0_safe_receiver_3, actions);
    var tmp1_safe_receiver_1 = woundButton(_this__u8e3s4, objectOnBoard);
    if (tmp1_safe_receiver_1 == null)
      null;
    else
      addTo_0(tmp1_safe_receiver_1, actions);
    var tmp2_safe_receiver = killButton(_this__u8e3s4, objectOnBoard);
    if (tmp2_safe_receiver == null)
      null;
    else
      addTo_0(tmp2_safe_receiver, actions);
    var tmp$ret$25;
    $l$block_2: {
      // Inline function 'steelart.beast.cast' call
      var tmp_12 = get_objectType($this$with, objectOnBoard);
      if (isInterface(tmp_12, BeastCharacter)) {
        tmp$ret$25 = objectOnBoard instanceof ObjectOnBoard ? objectOnBoard : THROW_CCE();
        break $l$block_2;
      }
      tmp$ret$25 = null;
    }
    var beast_0 = tmp$ret$25;
    var tmp_13;
    if (beast_0 == null) {
      tmp_13 = true;
    } else {
      var tmp0_2 = _this__u8e3s4.t6h().c38_1;
      var tmp$ret$26;
      $l$block_4: {
        // Inline function 'kotlin.collections.none' call
        var tmp_14;
        if (isInterface(tmp0_2, Collection)) {
          tmp_14 = tmp0_2.n1();
        } else {
          tmp_14 = false;
        }
        if (tmp_14) {
          tmp$ret$26 = true;
          break $l$block_4;
        }
        var _iterator__ex2g4s_6 = tmp0_2.p1();
        while (_iterator__ex2g4s_6.q1()) {
          var element_3 = _iterator__ex2g4s_6.r1();
          if (element_3 instanceof BeastMovementStatement) {
            tmp$ret$26 = false;
            break $l$block_4;
          }
        }
        tmp$ret$26 = true;
      }
      tmp_13 = tmp$ret$26;
    }
    var mayChangeLocation = tmp_13;
    if (mayChangeLocation) {
      addTo_0(ActionButton.vlb('Relocate', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_7(gameDialog, _this__u8e3s4, $this$with, objectOnBoard)), actions);
    }
    if (!(beast_0 == null) && mayChangeLocation) {
      addTo_0(ActionButton.vlb('Move', VOID, VOID, VOID, VOID, VOID, showVariantsForLocation$slambda_8(gameDialog, _this__u8e3s4, position, $this$with, beast_0)), actions);
    }
    addTo_0(this_1.xlb_1, controlPanelX);
  }
  gameDialog._v = yield* _this__u8e3s4.cmo(controlPanelX.xlb_1, VOID, get_gameDialogClose(), $completion);
  return Unit_instance;
}
function *sandboxAddTrapAction(_this__u8e3s4, zone, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = $this$with.y37_1.y3a();
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!(element == null) ? isInterface(element, TrapCard) : false) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    // Inline function 'kotlin.let' call
    var it = get_place($this$with, element_0);
    var tmp;
    if (it instanceof ComingArsenalPlace) {
      tmp = true;
    } else {
      tmp = it instanceof RevealedArsenalPlace;
    }
    if (tmp) {
      destination_0.d2(element_0);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_1 = LinkedHashMap.m7();
  var _iterator__ex2g4s_1 = destination_0.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_1 = _iterator__ex2g4s_1.r1();
    var key = getKClassFromExpression(element_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_1.w4(key);
    var tmp_0;
    if (value == null) {
      var answer = ArrayList.p2();
      destination_1.b5(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var list = tmp_0;
    list.d2(element_1);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.n2(destination_1.s2());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = destination_1.i3().p1();
  while (_iterator__ex2g4s_2.q1()) {
    var item = _iterator__ex2g4s_2.r1();
    var tmp$ret$17 = first(item.k3());
    destination_2.d2(tmp$ret$17);
  }
  var variants = destination_2;
  var owner = first(get_aliveHunters($this$with));
  var tmp_1 = 'What trap to place into ' + zone.toString();
  yield* justShowCardsPanel(_this__u8e3s4, variants, tmp_1, VOID, VOID, sandboxAddTrapAction$slambda(_this__u8e3s4, zone, owner), $completion);
  return Unit_instance;
}
function *showSandboxChangeRuinDialog(_this__u8e3s4, oldAshRuin, $completion) {
  oldAshRuin = oldAshRuin === VOID ? null : oldAshRuin;
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$with.y37_1.a3b();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!$this$with.b38_1.v4n_1.w2(element)) {
      destination.d2(element);
    }
  }
  var unusedRuins = destination;
  yield* justShowCardsPanel(_this__u8e3s4, unusedRuins, 'Choose Ruin', VOID, VOID, showSandboxChangeRuinDialog$slambda(_this__u8e3s4, oldAshRuin), $completion);
  return Unit_instance;
}
function *submitSpecialSetupEvent(_this__u8e3s4, event, $completion) {
  _this__u8e3s4.emo();
  var tmp = _this__u8e3s4.jmo();
  if (!(yield* tmp.ye3(event, submitSpecialSetupEvent$slambda(_this__u8e3s4), $completion))) {
    showErrorDialog(_this__u8e3s4.nl2_1, 'Cannot submit master fixing event');
  }
  return Unit_instance;
}
function createAddCardUiForSandbox(_this__u8e3s4, characterObject) {
  var controlPanelY = new ControlPanelY();
  addTo_0(PlainText('Add', get_gameLayout().vl5_1), controlPanelY);
  var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  addTo_0(actions.xlb_1, controlPanelY);
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  addTo_0(ActionButton.vlb('Action Card', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda(_this__u8e3s4, $this$with, characterObject)), actions);
  addTo_0(ActionButton.vlb('Item Card', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_0($this$with, characterObject, _this__u8e3s4)), actions);
  addTo_0(ActionButton.vlb('Grudge', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_1(_this__u8e3s4, characterObject)), actions);
  var tmp = get_objectType($this$with, characterObject);
  if (tmp instanceof Rhagner) {
    var tmp0 = get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with));
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      if (tmp0.n1()) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = tmp0.i3().p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        // Inline function 'kotlin.collections.component2' call
        var level = element.k3();
        if (level > 0) {
          tmp$ret$2 = true;
          break $l$block_0;
        }
      }
      tmp$ret$2 = false;
    }
    if (tmp$ret$2) {
      addTo_0(ActionButton.vlb('Hoard to supply', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_2(_this__u8e3s4)), actions);
    }
    var freeGrudges = get_grudgesNumber($this$with, get_rhagnerBeast($this$with)) - sum(get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with)).y4()) | 0;
    var tmp_0;
    if (freeGrudges > 0) {
      var tmp0_0 = get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with));
      var tmp$ret$6;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        if (tmp0_0.n1()) {
          tmp$ret$6 = false;
          break $l$block_2;
        }
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_0 = tmp0_0.i3().p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          // Inline function 'kotlin.collections.component2' call
          var level_0 = element_0.k3();
          if (level_0 < 2) {
            tmp$ret$6 = true;
            break $l$block_2;
          }
        }
        tmp$ret$6 = false;
      }
      tmp_0 = tmp$ret$6;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      addTo_0(ActionButton.vlb('Supply to Hoard', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_3(_this__u8e3s4)), actions);
    }
  }
  var tmp$ret$10;
  $l$block_3: {
    // Inline function 'steelart.beast.cast' call
    var tmp_1 = get_objectType($this$with, characterObject);
    if (tmp_1 instanceof Valdi) {
      tmp$ret$10 = characterObject instanceof ObjectOnBoard ? characterObject : THROW_CCE();
      break $l$block_3;
    }
    tmp$ret$10 = null;
  }
  var valdi = tmp$ret$10;
  if (!(valdi == null)) {
    if (get_valdiBlood($this$with, valdi) < 4) {
      addTo_0(ActionButton.vlb('Blood', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_4(_this__u8e3s4)), actions);
    }
    if (get_valdiBlood($this$with, valdi) > 0) {
      addTo_0(ActionButton.vlb('Remove Blood', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_5(_this__u8e3s4)), actions);
    }
  }
  var tmp_2 = get_objectType($this$with, characterObject);
  if (tmp_2 instanceof Lydan) {
    addTo_0(ActionButton.vlb('Life Force', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_6(_this__u8e3s4)), actions);
  }
  var tmp_3 = get_objectType($this$with, characterObject);
  if (tmp_3 instanceof Draug) {
    addTo_0(ActionButton.vlb('Corruption', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_7(_this__u8e3s4)), actions);
  }
  var tmp$ret$11;
  $l$block_4: {
    // Inline function 'steelart.beast.cast' call
    var tmp_4 = get_objectType($this$with, characterObject);
    if (tmp_4 instanceof Urgull) {
      tmp$ret$11 = characterObject instanceof ObjectOnBoard ? characterObject : THROW_CCE();
      break $l$block_4;
    }
    tmp$ret$11 = null;
  }
  var urgull = tmp$ret$11;
  if (!(urgull == null)) {
    if (get_remainMoltEggsOnCounter($this$with, urgull) < 7) {
      addTo_0(ActionButton.vlb('Egg', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_8(_this__u8e3s4)), actions);
    }
    if (get_remainMoltEggsOnCounter($this$with, urgull) > 0) {
      addTo_0(ActionButton.vlb('Remove Egg', VOID, VOID, VOID, VOID, VOID, createAddCardUiForSandbox$slambda_9(_this__u8e3s4)), actions);
    }
  }
  var tmp0_safe_receiver = healButton(_this__u8e3s4, characterObject);
  if (tmp0_safe_receiver == null)
    null;
  else
    addTo_0(tmp0_safe_receiver, actions);
  var tmp1_safe_receiver = woundButton(_this__u8e3s4, characterObject);
  tmp1_safe_receiver == null || addTo_0(tmp1_safe_receiver, actions);
  return controlPanelY.xlb_1;
}
function *startGamePhase(_this__u8e3s4, phaseToStart, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var tmp = _this__u8e3s4.t6h().y37_1;
  var tmp0_safe_receiver = tmp instanceof ClassicGameRules ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var inductionVariable = 1;
    var last = tmp0_safe_receiver.i3a();
    if (inductionVariable <= last)
      do {
        var dayNumber = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_0 = 'Day ' + dayNumber;
        addTo_0(ActionButton.vlb(tmp_0, VOID, VOID, VOID, VOID, VOID, startGamePhase$slambda(_this__u8e3s4, phaseToStart, dayNumber)), controlPanelY);
      }
       while (!(dayNumber === last));
  }
  yield* _this__u8e3s4.imo(controlPanelY.xlb_1, 'Choose day to start', get_gameDialogClose(), $completion);
  return Unit_instance;
}
function availableBarrierConnectedLocations(gsCtx, position) {
  // Inline function 'steelart.beast.castFilter' call
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = gsCtx.f4l();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$6;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType(gsCtx, element);
      if (tmp instanceof BarrierSideType) {
        tmp$ret$6 = element instanceof ObjectOnBoard ? element : THROW_CCE();
        break $l$block;
      }
      tmp$ret$6 = null;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  var barriers = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = Companion_getInstance_0().j3l_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = tmp0_0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp$ret$13;
    $l$block_7: {
      var tmp0_elvis_lhs = gsCtx.h47().c45(position, element_0, true);
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new BoardPosition(tmp_1)) == null) {
        tmp$ret$13 = null;
        break $l$block_7;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var nearLocation = tmp_0;
      // Inline function 'kotlin.with' call
      var tmp1_elvis_lhs = direction(gsCtx, nearLocation, position);
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$13 = null;
        break $l$block_7;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var reverseDirection = tmp_2;
      var tmp$ret$16;
      $l$block_3: {
        // Inline function 'kotlin.collections.any' call
        var tmp_3;
        if (isInterface(barriers, Collection)) {
          tmp_3 = barriers.n1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$16 = false;
          break $l$block_3;
        }
        var _iterator__ex2g4s_1 = barriers.p1();
        while (_iterator__ex2g4s_1.q1()) {
          var element_1 = _iterator__ex2g4s_1.r1();
          if (element_1.s2w(gsCtx) === position && get_objectType(gsCtx, element_1).q4f_1.equals(element_0)) {
            tmp$ret$16 = true;
            break $l$block_3;
          }
        }
        tmp$ret$16 = false;
      }
      if (tmp$ret$16) {
        tmp$ret$13 = null;
        break $l$block_7;
      }
      var tmp$ret$18;
      $l$block_6: {
        // Inline function 'kotlin.collections.any' call
        var tmp_4;
        if (isInterface(barriers, Collection)) {
          tmp_4 = barriers.n1();
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp$ret$18 = false;
          break $l$block_6;
        }
        var _iterator__ex2g4s_2 = barriers.p1();
        while (_iterator__ex2g4s_2.q1()) {
          var element_2 = _iterator__ex2g4s_2.r1();
          if (element_2.s2w(gsCtx) === nearLocation && get_objectType(gsCtx, element_2).q4f_1.equals(reverseDirection)) {
            tmp$ret$18 = true;
            break $l$block_6;
          }
        }
        tmp$ret$18 = false;
      }
      if (tmp$ret$18) {
        tmp$ret$13 = null;
        break $l$block_7;
      }
      tmp$ret$13 = new BoardPosition(nearLocation);
    }
    var tmp0_safe_receiver_0 = tmp$ret$13;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.d2(tmp0_safe_receiver_0);
    }
  }
  return toSet(destination_0);
}
function *sandboxAddSnareAction(_this__u8e3s4, position, ommaBeast, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var _iterator__ex2g4s = get_entries_2().p1();
  while (_iterator__ex2g4s.q1()) {
    var snareType = _iterator__ex2g4s.r1();
    addTo_0(ActionButton.vlb(snareType.v1_1, VOID, VOID, VOID, VOID, VOID, sandboxAddSnareAction$slambda(_this__u8e3s4, position, ommaBeast, snareType)), controlPanelY);
  }
  return yield* _this__u8e3s4.cmo(controlPanelY.xlb_1, 'Choose snare type', VOID, $completion);
}
function healButton(_this__u8e3s4, objectOnBoard) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp;
  if (get_hp($this$with, objectOnBoard) < get_objectType($this$with, objectOnBoard).n2z($this$with)) {
    tmp = ActionButton.vlb('Heal', VOID, VOID, VOID, VOID, VOID, healButton$slambda(_this__u8e3s4, objectOnBoard));
  } else {
    tmp = null;
  }
  return tmp;
}
function woundButton(_this__u8e3s4, objectOnBoard) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp;
  if (get_hp($this$with, objectOnBoard) > 1) {
    tmp = ActionButton.vlb('Wound', VOID, VOID, VOID, VOID, VOID, woundButton$slambda(objectOnBoard, _this__u8e3s4));
  } else {
    tmp = null;
  }
  return tmp;
}
function killButton(_this__u8e3s4, objectOnBoard) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp;
  if (get_isDead($this$with, objectOnBoard)) {
    tmp = null;
  } else {
    tmp = ActionButton.vlb('Kill', VOID, VOID, VOID, VOID, VOID, killButton$slambda(_this__u8e3s4, objectOnBoard));
  }
  return tmp;
}
function *showPickCardVariants(_this__u8e3s4, cards, message, characterObject, $completion) {
  var tmp = emptyList();
  yield* justShowCardsPanel(_this__u8e3s4, cards, message, tmp, VOID, showPickCardVariants$slambda(_this__u8e3s4, characterObject), $completion);
  return Unit_instance;
}
function *addSandboxGrudge(_this__u8e3s4, characterObject, $completion) {
  yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, GainGrudgesEvent.x51(characterObject, 1), $completion);
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp = get_objectType($this$with, characterObject);
  if (!(tmp instanceof Rhagner))
    return Unit_instance;
  // Inline function 'kotlin.collections.filterValues' call
  var this_0 = get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with));
  var result = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var entry = _iterator__ex2g4s.r1();
    if (entry.k3() < 2) {
      result.b5(entry.j3(), entry.k3());
    }
  }
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = result.x4();
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s_0 = tmp0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    if (!(element == null) ? isInterface(element, RhagnerCard) : false) {
      destination.d2(element);
    }
  }
  var availableCards = toList_0(destination);
  if (availableCards.n1())
    return Unit_instance;
  yield* justShowCardsPanel(_this__u8e3s4, availableCards, 'Place Grudge to Hoard', VOID, VOID, addSandboxGrudge$slambda(_this__u8e3s4), $completion);
  return Unit_instance;
}
function *moveSandboxRhagnerHoardGrudgeToSupply(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.filterValues' call
  var this_0 = get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with));
  var result = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var entry = _iterator__ex2g4s.r1();
    if (entry.k3() > 0) {
      result.b5(entry.j3(), entry.k3());
    }
  }
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = result.x4();
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s_0 = tmp0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    if (!(element == null) ? isInterface(element, RhagnerCard) : false) {
      destination.d2(element);
    }
  }
  var availableCards = toList_0(destination);
  yield* justShowCardsPanel(_this__u8e3s4, availableCards, 'Move Grudge from Hoard', VOID, VOID, moveSandboxRhagnerHoardGrudgeToSupply$slambda(_this__u8e3s4), $completion);
  return Unit_instance;
}
function *moveSandboxRhagnerSupplyGrudgeToHoard(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var freeGrudges = get_grudgesNumber($this$with, get_rhagnerBeast($this$with)) - sum(get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with)).y4()) | 0;
  if (freeGrudges <= 0)
    return Unit_instance;
  // Inline function 'kotlin.collections.filterValues' call
  var this_0 = get_rhagnerHoardLevels($this$with, get_rhagnerBeast($this$with));
  var result = LinkedHashMap.m7();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var entry = _iterator__ex2g4s.r1();
    if (entry.k3() < 2) {
      result.b5(entry.j3(), entry.k3());
    }
  }
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = result.x4();
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s_0 = tmp0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    if (!(element == null) ? isInterface(element, RhagnerCard) : false) {
      destination.d2(element);
    }
  }
  var availableCards = toList_0(destination);
  yield* justShowCardsPanel(_this__u8e3s4, availableCards, 'Move Grudge to Hoard', VOID, VOID, moveSandboxRhagnerSupplyGrudgeToHoard$slambda(_this__u8e3s4), $completion);
  return Unit_instance;
}
function *installSandboxSnareTrapChoice(_this__u8e3s4, position, ommaBeast, snareType, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp0 = get_allSnaresOnMap($this$with);
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (get_snareType($this$with, element).equals(snareType)) {
        if (found) {
          tmp$ret$2 = null;
          break $l$block_0;
        }
        single = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$2 = null;
      break $l$block_0;
    }
    tmp$ret$2 = single;
  }
  var tmp0_safe_receiver = tmp$ret$2;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new ObjectRemoveForReplacingEvent(get_beastsGameTeam(), tmp0_safe_receiver), $completion);
    tmp = Unit_instance;
  }
  yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new NewSimpleObjectEvent(SnareTokenType_getInstance(), position), $completion);
  // Inline function 'kotlin.with' call
  var $this$with_0 = _this__u8e3s4.t6h();
  var tmp_0 = $this$with_0.l4l();
  var snare = tmp_0 instanceof ObjectOnBoard ? tmp_0 : THROW_CCE();
  var availableTrapLocations = plus_1(get_nearbyPositions($this$with_0, forBeast($this$with_0, position, ommaBeast)), new BoardPosition(position));
  var neededTrapCount = get_upgraded($this$with_0, DoubleUpgrade_getInstance()) ? 2 : 1;
  var _destruct__k2r9zo = new Triple(snare, availableTrapLocations, neededTrapCount);
  var snare_0 = _destruct__k2r9zo.jm();
  var availableTrapLocations_0 = _destruct__k2r9zo.km();
  var neededTrapCount_0 = _destruct__k2r9zo.fx();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var trapPositions = LinkedHashSet.v2();
  var trapLambda = {_v: null};
  trapLambda._v = installSandboxSnareTrapChoice$slambda(availableTrapLocations_0, trapPositions, neededTrapCount_0, _this__u8e3s4, trapLambda, snare_0, snareType);
  var tmp_1 = _this__u8e3s4.gl2_1;
  var tmp_2;
  if (trapLambda._v == null) {
    throwUninitializedPropertyAccessException('trapLambda');
  } else {
    tmp_2 = trapLambda._v;
  }
  tmp_1.el8_1 = tmp_2;
  return Unit_instance;
}
function *installSandboxKillTeamChoice(_this__u8e3s4, objectOnBoard, $completion) {
  var controlPanelY = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  var _iterator__ex2g4s = listOf([new GameTeam(get_beastsGameTeam()), new GameTeam(get_huntersGameTeam())]).p1();
  while (_iterator__ex2g4s.q1()) {
    var team = _iterator__ex2g4s.r1().r3p_1;
    var tmp = get_gameI18n().m70(team);
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, installSandboxKillTeamChoice$slambda(_this__u8e3s4, objectOnBoard, team)), controlPanelY);
  }
  yield* _this__u8e3s4.cmo(controlPanelY.xlb_1, 'Count kill for which team?', VOID, $completion);
  return Unit_instance;
}
function *sandboxKillObjectForTeam(_this__u8e3s4, objectOnBoard, team, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  if (get_isDead($this$with, objectOnBoard))
    return Unit_instance;
  // Inline function 'kotlin.with' call
  var $this$with_0 = _this__u8e3s4.t6h();
  var hit = new DealingDamage(null, SandboxDamage_getInstance(), DamageKind_Other_getInstance(), null, setOf(new DamageToTarget(objectOnBoard, get_hp($this$with_0, objectOnBoard) + get_armor($this$with_0, objectOnBoard) | 0)));
  yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new ApplyDamageEvent(hit), $completion);
  yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new CheckForDestroyEvent(team, hit), $completion);
  return Unit_instance;
}
function *submitSandboxUpgrade(_this__u8e3s4, characterObject, u, $completion) {
  yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new UpgradeEvent(characterObject, u), $completion);
  if (isInterface(u, ChargingUpgrade)) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new ChargingUpgradeChangeEvent(u, true), $completion);
  }
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp = get_objectType($this$with, characterObject);
  if (tmp instanceof FeatheredKing) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new ChangeFeatheredKingRebornStatusEvent(true), $completion);
  }
  return Unit_instance;
}
function *removeSandboxUpgrade(_this__u8e3s4, characterObject, u, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp;
  if (isInterface(u, ChargingUpgrade)) {
    tmp = get_charged($this$with, u);
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new ChargingUpgradeChangeEvent(u, false), $completion);
  }
  yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new RemoveUpgradeEvent(characterObject, u), $completion);
  // Inline function 'kotlin.with' call
  var $this$with_0 = _this__u8e3s4.t6h();
  var tmp_0;
  var tmp_1 = get_objectType($this$with_0, characterObject);
  if (tmp_1 instanceof FeatheredKing) {
    var tmp0 = get_objectType($this$with_0, characterObject).t35();
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_2;
      if (isInterface(tmp0, Collection)) {
        tmp_2 = tmp0.n1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$4 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (get_upgraded($this$with_0, element)) {
          tmp$ret$4 = false;
          break $l$block_0;
        }
      }
      tmp$ret$4 = true;
    }
    tmp_0 = tmp$ret$4;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent(_this__u8e3s4, new ChangeFeatheredKingRebornStatusEvent(false), $completion);
  }
  return Unit_instance;
}
function installStartSandboxDialog$slambda($this_installStartSandboxDialog, $phaseToStart) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/startGamePhase($this_installStartSandboxDialog, $phaseToStart, $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda($this_showVariantsForLocation, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, outpostEvent($position), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_0($$this$with, $beast, $this_showVariantsForLocation, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var result = CompletableDeferred_0();
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet.v2();
    this_0.t2(get_primaryLocations());
    var tmp0 = get_aliveBeasts($$this$with);
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$4 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var tmp_0 = get_objectType($$this$with, element);
        if (tmp_0 instanceof Akkeron) {
          tmp$ret$4 = true;
          break $l$block_0;
        }
      }
      tmp$ret$4 = false;
    }
    if (tmp$ret$4) {
      this_0.d2(LocationType_AbyssalSwamp_getInstance());
    }
    var tmp0_0 = get_aliveBeasts($$this$with);
    var tmp$ret$6;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(tmp0_0, Collection)) {
        tmp_1 = tmp0_0.n1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$6 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_0 = tmp0_0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element_0 = _iterator__ex2g4s_0.r1();
        if (equals(get_objectType($$this$with, element_0), Urgull_getInstance())) {
          tmp$ret$6 = true;
          break $l$block_2;
        }
      }
      tmp$ret$6 = false;
    }
    if (tmp$ret$6) {
      this_0.d2(LocationType_LivingWeb_getInstance());
    }
    var tmp_2 = $$this$with.y37_1;
    if (tmp_2 instanceof UnleashingTheAbyssContract) {
      var tmp0_safe_receiver = $beast;
      var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l32($$this$with);
      var tmp0_1 = tmp1_subject == null ? -1 : tmp1_subject.w1_1;
      this_0.d2(tmp0_1 === 1 ? LocationType_AbyssalSwamp_getInstance() : tmp0_1 === 2 ? LocationType_AbyssalForest_getInstance() : tmp0_1 === 3 ? LocationType_AbyssalSwamp_getInstance() : LocationType_AbyssalSwamp_getInstance());
    }
    var locations = this_0.g9();
    yield* $this_showVariantsForLocation.nmh(locations, false, result, $completion);
    var newLocationType = yield* result.m1q($completion);
    var tmp_3;
    if (!(newLocationType == null)) {
      tmp_3 = yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new TransformLocationsEvent(null, setOf(new BoardPosition($position)), newLocationType), $completion);
    }
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda$slambda($availableBarrierConnectedLocations, $$this$with, $position, $this_showVariantsForLocation) {
  return constructCallableReference(function *(connectedLocation, $completion) {
    var tmp;
    if (!$availableBarrierConnectedLocations.w2(connectedLocation)) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = direction($$this$with, $position, connectedLocation.r2v_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Connected barrier location ' + BoardPosition__toString_impl_v4mn82(connectedLocation.r2v_1) + ' is not adjacent to ' + BoardPosition__toString_impl_v4mn82($position);
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var direction_0 = tmp_0;
    var tmp1_elvis_lhs = direction($$this$with, connectedLocation.r2v_1, $position);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Connected barrier location ' + BoardPosition__toString_impl_v4mn82($position) + ' is not adjacent to ' + BoardPosition__toString_impl_v4mn82(connectedLocation.r2v_1);
      throw IllegalStateException.o(toString(message_0));
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var reverseDirection = tmp_1;
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new NewSimpleObjectEvent(new BarrierSideType(direction_0), $position), $completion);
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new NewSimpleObjectEvent(new BarrierSideType(reverseDirection), connectedLocation.r2v_1), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_1($gameDialog, $this_showVariantsForLocation, $availableBarrierConnectedLocations, $$this$with, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    tmp.qlq();
    var tmp_0 = $this_showVariantsForLocation.gl2_1;
    tmp_0.el8_1 = showVariantsForLocation$slambda$slambda($availableBarrierConnectedLocations, $$this$with, $position, $this_showVariantsForLocation);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_2($this_showVariantsForLocation, $summonType, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new NewSimpleObjectEvent($summonType, $position), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_3($this_showVariantsForLocation, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new NewSimpleObjectEvent(BoatType_getInstance(), $position), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_4($this_showVariantsForLocation, $beast, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new TrailsRevealedEvent(mapOf(to($beast, mapOf(to(new BoardPosition($position), 1))))), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_5($this_showVariantsForLocation, $position, $ommaBeast) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/sandboxAddSnareAction($this_showVariantsForLocation, $position, $ommaBeast, $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_6($this_showVariantsForLocation, $hunterCompanionType, $position) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new NewSimpleObjectEvent($hunterCompanionType, $position), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda$slambda_0($$this$with, $objectOnBoard, $this_showVariantsForLocation) {
  return constructCallableReference(function *(p, $completion) {
    var tmp0 = $$this$with;
    var tmp2 = $objectOnBoard;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'steelart.beast.cast' call
      var tmp = get_objectType(tmp0, tmp2);
      if (isInterface(tmp, BeastCharacter)) {
        tmp$ret$0 = tmp2 instanceof ObjectOnBoard ? tmp2 : THROW_CCE();
        break $l$block;
      }
      tmp$ret$0 = null;
    }
    var beast = tmp$ret$0;
    var tmp_0;
    if (!(beast == null) && get_isHidden($$this$with, beast)) {
      tmp_0 = yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new RevealBeastEvent(beast), $completion);
    }
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, MovementEvent($$this$with, $objectOnBoard, p.r2v_1, true, true), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_7($gameDialog, $this_showVariantsForLocation, $$this$with, $objectOnBoard) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    tmp.qlq();
    var tmp_0 = $this_showVariantsForLocation.gl2_1;
    tmp_0.el8_1 = showVariantsForLocation$slambda$slambda_0($$this$with, $objectOnBoard, $this_showVariantsForLocation);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda$slambda_1($position, $$this$with, $beast, $this_showVariantsForLocation) {
  return constructCallableReference(function *(next, $completion) {
    var tmp;
    if (!equals(next, new BoardPosition($position)) && direction($$this$with, $position, next.r2v_1) == null) {
      var tmp_0;
      if (get_locationType($$this$with, $position).r45() && get_locationType($$this$with, next.r2v_1).r45()) {
        tmp_0 = new MovementToLocation(next.r2v_1, MovementType_AbyssalSwampRelocation_getInstance());
      } else {
        return Unit_instance;
      }
      tmp = tmp_0;
    } else {
      tmp = new MovementToLocation(next.r2v_1, MovementType_SimpleMovement_getInstance());
    }
    var movementToNext = tmp;
    var hiddenBeastMovement = new HiddenBeastMovement($beast, listOf([BeastPathStep.b3g($position), BeastPathStep.a3g(listOf_0(movementToNext))]), false);
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showVariantsForLocation, new MovementEvent_0(setOf(hiddenBeastMovement)), $completion);
    return Unit_instance;
  }, 1);
}
function showVariantsForLocation$slambda_8($gameDialog, $this_showVariantsForLocation, $position, $$this$with, $beast) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    tmp.qlq();
    var tmp_0 = $this_showVariantsForLocation.gl2_1;
    tmp_0.el8_1 = showVariantsForLocation$slambda$slambda_1($position, $$this$with, $beast, $this_showVariantsForLocation);
    return Unit_instance;
  }, 1);
}
function sandboxAddTrapAction$slambda$slambda($this_sandboxAddTrapAction, $card, $zone, $owner) {
  return constructCallableReference(function *($completion) {
    var result = CompletableDeferred_0();
    yield* $this_sandboxAddTrapAction.nmh(toSet(get_primaryLocations()), false, result, $completion);
    var locationType = yield* result.m1q($completion);
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_sandboxAddTrapAction, new SetTrapEvent(isInterface($card, TrapCard) ? $card : THROW_CCE(), ensureNotNull(locationType), $zone, $owner, -1), $completion);
    return Unit_instance;
  }, 0);
}
function sandboxAddTrapAction$slambda($this_sandboxAddTrapAction, $zone, $owner) {
  return constructCallableReference(function *(card, $completion) {
    var picture = yield* (yield* $this_sandboxAddTrapAction.pl6().mle(card, $completion)).m1q($completion);
    return CardUi.tm1(picture, VOID, card, VOID, VOID, sandboxAddTrapAction$slambda$slambda($this_sandboxAddTrapAction, card, $zone, $owner));
  }, 1);
}
function showSandboxChangeRuinDialog$slambda$slambda($oldAshRuin, $this_showSandboxChangeRuinDialog, $ashRuin) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if (!($oldAshRuin == null)) {
      tmp = yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showSandboxChangeRuinDialog, GeneralCardMoveEvent.s53($oldAshRuin, ComingArsenalPlace_getInstance()), $completion);
    }
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showSandboxChangeRuinDialog, GeneralCardMoveEvent.s53($ashRuin, RevealedArsenalPlace_getInstance()), $completion);
    return Unit_instance;
  }, 0);
}
function showSandboxChangeRuinDialog$slambda($this_showSandboxChangeRuinDialog, $oldAshRuin) {
  return constructCallableReference(function *(card, $completion) {
    var ashRuin = isInterface(card, AshRuin) ? card : THROW_CCE();
    var picture = yield* (yield* $this_showSandboxChangeRuinDialog.pl6().lle(ashRuin, $completion)).m1q($completion);
    var tmp = Image.lk7(picture);
    return CardUi.ilo(tmp, VOID, ashRuin, VOID, VOID, VOID, showSandboxChangeRuinDialog$slambda$slambda($oldAshRuin, $this_showSandboxChangeRuinDialog, ashRuin));
  }, 1);
}
function submitSpecialSetupEvent$slambda($this_submitSpecialSetupEvent) {
  return constructCallableReference(function *(it, $completion) {
    yield* $this_submitSpecialSetupEvent.kmo().ue3(it, $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda($this_createAddCardUiForSandbox, $$this$with, $characterObject) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var cards = minus_0($this_createAddCardUiForSandbox.t6h().y37_1.b3b(), get_hand($$this$with, $characterObject));
    yield* /*#__NOINLINE__*/showPickCardVariants($this_createAddCardUiForSandbox, cards, 'Pick Action Card', $characterObject, $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_0($$this$with, $characterObject, $this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var fullArsenalDeck = get_fullArsenalDeck($$this$with, get_arsenalType($$this$with, $characterObject));
    var allCards = minus_0(fullArsenalDeck, get_hand($$this$with, $characterObject));
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap.m7();
    var _iterator__ex2g4s = allCards.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp;
      if (isInterface(element, RecoveryTestCard)) {
        tmp = element;
      } else {
        tmp = getKClassFromExpression(element);
      }
      var key = tmp;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.w4(key);
      var tmp_0;
      if (value == null) {
        var answer = ArrayList.p2();
        destination.b5(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.d2(element);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(destination.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = destination.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$8 = first(item.k3());
      destination_0.d2(tmp$ret$8);
    }
    var cards = destination_0;
    yield* /*#__NOINLINE__*/showPickCardVariants($this_createAddCardUiForSandbox, cards, 'Pick Arsenal Card', $characterObject, $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_1($this_createAddCardUiForSandbox, $characterObject) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/addSandboxGrudge($this_createAddCardUiForSandbox, $characterObject, $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_2($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/moveSandboxRhagnerHoardGrudgeToSupply($this_createAddCardUiForSandbox, $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_3($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/moveSandboxRhagnerSupplyGrudgeToHoard($this_createAddCardUiForSandbox, $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_4($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_createAddCardUiForSandbox, new ValdiBloodChangeEvent(1), $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_5($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_createAddCardUiForSandbox, new ValdiBloodChangeEvent(-1), $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_6($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_createAddCardUiForSandbox, new GainLydanHarvestEvent(1), $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_7($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_createAddCardUiForSandbox, new GainDraugCorruptionEvent(1), $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_8($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_createAddCardUiForSandbox, new UrgullMoltCounterChangeEvent(1), $completion);
    return Unit_instance;
  }, 1);
}
function createAddCardUiForSandbox$slambda_9($this_createAddCardUiForSandbox) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_createAddCardUiForSandbox, new UrgullMoltCounterChangeEvent(-1), $completion);
    return Unit_instance;
  }, 1);
}
function startGamePhase$slambda($this_startGamePhase, $phaseToStart, $dayNumber) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $this_startGamePhase.kmo().xe3(new SandboxStartParams($phaseToStart, $dayNumber), $completion);
    return Unit_instance;
  }, 1);
}
function sandboxAddSnareAction$slambda($this_sandboxAddSnareAction, $position, $ommaBeast, $snareType) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/installSandboxSnareTrapChoice($this_sandboxAddSnareAction, $position, $ommaBeast, $snareType, $completion);
    return Unit_instance;
  }, 1);
}
function healButton$slambda($this_healButton, $objectOnBoard) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_healButton, new HealEvent(setOf($objectOnBoard)), $completion);
    return Unit_instance;
  }, 1);
}
function woundButton$slambda($objectOnBoard, $this_woundButton) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var hit = new DealingDamage(null, SandboxDamage_getInstance(), DamageKind_Other_getInstance(), null, setOf(new DamageToTarget($objectOnBoard, 1)));
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_woundButton, new ApplyDamageEvent(hit), $completion);
    return Unit_instance;
  }, 1);
}
function killButton$slambda($this_killButton, $objectOnBoard) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/installSandboxKillTeamChoice($this_killButton, $objectOnBoard, $completion);
    return Unit_instance;
  }, 1);
}
function showPickCardVariants$slambda$slambda($this_showPickCardVariants, $card, $characterObject) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_showPickCardVariants, GeneralCardMoveEvent.s53($card, new HandPlace($characterObject)), $completion);
    return Unit_instance;
  }, 0);
}
function showPickCardVariants$slambda($this_showPickCardVariants, $characterObject) {
  return constructCallableReference(function *(card, $completion) {
    var picture = yield* (yield* $this_showPickCardVariants.pl6().mle(card, $completion)).m1q($completion);
    return CardUi.tm1(picture, VOID, card, VOID, VOID, showPickCardVariants$slambda$slambda($this_showPickCardVariants, card, $characterObject));
  }, 1);
}
function addSandboxGrudge$slambda$slambda($this_addSandboxGrudge, $rhagnerCard) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_addSandboxGrudge, new RhagnerHoardChangeEvent($rhagnerCard, 1), $completion);
    return Unit_instance;
  }, 0);
}
function addSandboxGrudge$slambda($this_addSandboxGrudge) {
  return constructCallableReference(function *(card, $completion) {
    var rhagnerCard = isInterface(card, RhagnerCard) ? card : THROW_CCE();
    var picture = yield* (yield* $this_addSandboxGrudge.pl6().mle(rhagnerCard, $completion)).m1q($completion);
    return yield* createCard($this_addSandboxGrudge, picture, rhagnerCard, new ShowTheCardWithAction(addSandboxGrudge$slambda$slambda($this_addSandboxGrudge, rhagnerCard)), $completion);
  }, 1);
}
function moveSandboxRhagnerHoardGrudgeToSupply$slambda$slambda($this_moveSandboxRhagnerHoardGrudgeToSupply, $rhagnerCard) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_moveSandboxRhagnerHoardGrudgeToSupply, new RhagnerHoardChangeEvent($rhagnerCard, -1), $completion);
    return Unit_instance;
  }, 0);
}
function moveSandboxRhagnerHoardGrudgeToSupply$slambda($this_moveSandboxRhagnerHoardGrudgeToSupply) {
  return constructCallableReference(function *(card, $completion) {
    var rhagnerCard = isInterface(card, RhagnerCard) ? card : THROW_CCE();
    var picture = yield* (yield* $this_moveSandboxRhagnerHoardGrudgeToSupply.pl6().mle(rhagnerCard, $completion)).m1q($completion);
    return yield* createCard($this_moveSandboxRhagnerHoardGrudgeToSupply, picture, rhagnerCard, new ShowTheCardWithAction(moveSandboxRhagnerHoardGrudgeToSupply$slambda$slambda($this_moveSandboxRhagnerHoardGrudgeToSupply, rhagnerCard)), $completion);
  }, 1);
}
function moveSandboxRhagnerSupplyGrudgeToHoard$slambda$slambda($this_moveSandboxRhagnerSupplyGrudgeToHoard, $rhagnerCard) {
  return constructCallableReference(function *($completion) {
    yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_moveSandboxRhagnerSupplyGrudgeToHoard, new RhagnerHoardChangeEvent($rhagnerCard, 1), $completion);
    return Unit_instance;
  }, 0);
}
function moveSandboxRhagnerSupplyGrudgeToHoard$slambda($this_moveSandboxRhagnerSupplyGrudgeToHoard) {
  return constructCallableReference(function *(card, $completion) {
    var rhagnerCard = isInterface(card, RhagnerCard) ? card : THROW_CCE();
    var picture = yield* (yield* $this_moveSandboxRhagnerSupplyGrudgeToHoard.pl6().mle(rhagnerCard, $completion)).m1q($completion);
    return yield* createCard($this_moveSandboxRhagnerSupplyGrudgeToHoard, picture, rhagnerCard, new ShowTheCardWithAction(moveSandboxRhagnerSupplyGrudgeToHoard$slambda$slambda($this_moveSandboxRhagnerSupplyGrudgeToHoard, rhagnerCard)), $completion);
  }, 1);
}
function installSandboxSnareTrapChoice$slambda($availableTrapLocations, $trapPositions, $neededTrapCount, $this_installSandboxSnareTrapChoice, $trapLambda, $snare, $snareType) {
  return constructCallableReference(function *(trapPosition, $completion) {
    var tmp;
    if (!$availableTrapLocations.w2(trapPosition)) {
      return Unit_instance;
    }
    $trapPositions.d2(trapPosition);
    var tmp_0;
    if ($trapPositions.s2() < $neededTrapCount) {
      var tmp_1 = $this_installSandboxSnareTrapChoice.gl2_1;
      var tmp_2;
      if ($trapLambda._v == null) {
        throwUninitializedPropertyAccessException('trapLambda');
      } else {
        tmp_2 = $trapLambda._v;
      }
      tmp_1.el8_1 = tmp_2;
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = yield* /*#__NOINLINE__*/submitSpecialSetupEvent($this_installSandboxSnareTrapChoice, new SetSnareMetadataChangeEvent($snare, $snareType, toSet($trapPositions)), $completion);
    }
    return Unit_instance;
  }, 1);
}
function installSandboxKillTeamChoice$slambda($this_installSandboxKillTeamChoice, $objectOnBoard, $team) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* /*#__NOINLINE__*/sandboxKillObjectForTeam($this_installSandboxKillTeamChoice, $objectOnBoard, $team, $completion);
    return Unit_instance;
  }, 1);
}
var lastInfoDialog;
function showErrorDialog(frame, message, onClickOnEmpty) {
  onClickOnEmpty = onClickOnEmpty === VOID ? get_gameDialogClose() : onClickOnEmpty;
  var text = PlainText(message, get_gameLayout().vl5_1, get_gameColors().rlx_1);
  var gameDialog = GameDialog.xlq(frame, text, 'Shared code', onClickOnEmpty);
  gameDialog.ylq();
}
function showGameSessionErrorDialog(frame, message, reconnect, requestServerReload) {
  var panel = new ControlPanelY();
  var dialog = GameDialog.xlq(frame, panel.xlb_1, 'Game session error', showGameSessionErrorDialog$slambda());
  addTo_0(PlainText('The game session stopped because of an error.', get_gameLayout().vl5_1), panel);
  var _iterator__ex2g4s = lines(message).p1();
  while (_iterator__ex2g4s.q1()) {
    var line = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.ifEmpty' call
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(line) === 0) {
      tmp = ' ';
    } else {
      tmp = line;
    }
    var tmp$ret$0 = tmp;
    var _iterator__ex2g4s_0 = chunked_0(tmp$ret$0, 90).p1();
    while (_iterator__ex2g4s_0.q1()) {
      var part = _iterator__ex2g4s_0.r1();
      addTo_0(PlainText(part, get_gameLayout().vl5_1), panel);
    }
  }
  addTo_0(PlainText('Reconnect to restore your client from the current server state.', get_gameLayout().sl5_1), panel);
  addTo_0(ActionButton.vlb('Reconnect to game', VOID, VOID, VOID, VOID, VOID, showGameSessionErrorDialog$slambda_0(dialog, reconnect)), panel);
  addTo_0(PlainText('Server reload rebuilds the game for all connected players.', get_gameLayout().sl5_1), panel);
  addTo_0(ActionButton.vlb('Request server reload', VOID, VOID, VOID, VOID, VOID, showGameSessionErrorDialog$slambda_1(dialog, requestServerReload)), panel);
  panel.flr();
  dialog.ylq();
}
function showSharedCode(frame, sharedCode, serverDrivenConfiguration, isSandbox, onClickOnEmpty) {
  onClickOnEmpty = onClickOnEmpty === VOID ? get_gameDialogClose() : onClickOnEmpty;
  var panel = new ControlPanelY();
  var gameDialog = GameDialog.xlq(frame, panel.xlb_1, 'Shared code', onClickOnEmpty);
  addTo_0(PlainText('Share this URL with others to replay this ' + (isSandbox ? 'sample' : 'game') + ':', get_gameLayout().sl5_1), panel);
  var host = serverDrivenConfiguration.q6k();
  var url = host + '/#' + (isSandbox ? 'sample' : 'replay') + '=' + sharedCode.o6k_1;
  addTo_0(createLinkText(url, url, get_gameLayout().sl5_1), panel);
  var resultText = PlainText('', get_gameLayout().sl5_1);
  addTo_0(ActionButton.vlb('Copy', VOID, VOID, VOID, VOID, VOID, showSharedCode$slambda(url, resultText)), panel);
  addTo_0(resultText, panel);
  gameDialog.ylq();
}
function createStatusLayer(scope, images, sContainer) {
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Container.fi2(false);
  // Inline function 'kotlin.apply' call
  var statusLayer = addTo(this_0, sContainer);
  var loadingResourceReporter = images.al7_1;
  var statusText = {_v: null};
  var fadingJob = {_v: null};
  var isDisconnected = {_v: false};
  var tmp0_safe_receiver = get_gameConfiguration().flc_1;
  var connectionStatus = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r6k();
  if (!(connectionStatus == null)) {
    var firstTime = {_v: true};
    launch(scope, VOID, VOID, createStatusLayer$slambda(connectionStatus, firstTime, isDisconnected, fadingJob, statusText, statusLayer, scope, loadingResourceReporter));
  }
  if (loadingResourceReporter == null)
    null;
  else {
    var tmp = loadingResourceReporter;
    tmp.jld_1 = new createStatusLayer$2(isDisconnected, fadingJob, statusText, statusLayer, scope, loadingResourceReporter);
  }
}
function closeLastInfoDialog() {
  var tmp0_safe_receiver = lastInfoDialog;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.qlq();
  }
  lastInfoDialog = null;
}
function *showInformationDialog(_this__u8e3s4, needAddNextButton, backButtonCallback, lines, dialogLayout, onboardingMenuButton, $completion) {
  dialogLayout = dialogLayout === VOID ? new FitContent() : dialogLayout;
  onboardingMenuButton = onboardingMenuButton === VOID ? null : onboardingMenuButton;
  var panel = new ControlPanelY();
  var _iterator__ex2g4s = lines.p1();
  while (_iterator__ex2g4s.q1()) {
    var string = _iterator__ex2g4s.r1();
    addTo_0(yield* createLineInDialog(_this__u8e3s4, string, $completion), panel);
  }
  var dialogColoringStyle = new DialogColoringStyle(Companion_getInstance_15().ich(0, 72, 82, 240), Companion_getInstance_15().pci(71, 112, 55));
  var awaitDeferred = CompletableDeferred_0();
  var resultDialogPanel = panel.xlb_1;
  var resultLayout = dialogLayout;
  if (!(backButtonCallback == null) && !needAddNextButton) {
    var xPanel = new ControlPanelX(VOID, VOID, VOID, VOID, get_gameLayout().yl5_1 * 2);
    var revertIcon = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_Back_getInstance(), $completion)).m1q($completion);
    var tmp = get_gameLayout().tl5_1;
    addTo_0(createHoveredIconAction(tmp, revertIcon, VOID, VOID, showInformationDialog$slambda(backButtonCallback)), xPanel);
    addTo_0(panel.xlb_1, xPanel);
    xPanel.flr();
    resultDialogPanel = xPanel.xlb_1;
    if (dialogLayout instanceof FitContent) {
      resultLayout = dialogLayout.smq(get_gameLayout().zl5_1);
    }
  } else if (needAddNextButton) {
    panel.dlr_1 = panel.dlr_1 + get_gameLayout().zl5_1;
    var buttonsPanel = FixedSizeContainer.pjs(Companion_getInstance_10().c9s_1, false);
    var tmp_0;
    if (!(backButtonCallback == null)) {
      var revertIcon_0 = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_Back_getInstance(), $completion)).m1q($completion);
      var tmp_1 = get_gameLayout().tl5_1;
      tmp_0 = addTo(createHoveredIconAction(tmp_1, revertIcon_0, VOID, VOID, showInformationDialog$slambda_0(buttonsPanel, backButtonCallback)), buttonsPanel);
    } else {
      tmp_0 = null;
    }
    var back = tmp_0;
    var next = addTo(ActionButton.vlb('Next', VOID, VOID, VOID, VOID, VOID, showInformationDialog$slambda_1(buttonsPanel, awaitDeferred)), buttonsPanel);
    var tmp0 = next.lmq().k9i_1;
    var tmp1_elvis_lhs = back == null ? null : back.rig();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    var height = Math.max(tmp0, b);
    var tmp_2;
    if (back == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = back.pig() + get_gameLayout().yl5_1;
    }
    var tmp3_elvis_lhs = tmp_2;
    var backSpace = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    var tmp0_0 = panel.xlb_1.w9z();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = next.lmq().j9i_1 + 2 * backSpace;
    var width = Math.max(tmp0_0, b_0);
    size_0(buttonsPanel, Size2D.y9p(width, height));
    xy(next, (width - next.w9z()) / 2, (height - next.lmq().k9i_1) / 2);
    if (back == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'korlibs.korge.view.xy' call
      var y = (height - back.rig()) / 2;
      xy(back, numberToDouble(0), numberToDouble(y));
    }
    addTo_0(buttonsPanel, panel);
  }
  var gameDialog = GameDialog.mlt(get_gameConfiguration().rlc_1 ? _this__u8e3s4.qln() : _this__u8e3s4.pln(), DialogContent.llt(resultDialogPanel, VOID, resultLayout, 20.0, dialogColoringStyle, false, needAddNextButton));
  var prevDialog = lastInfoDialog;
  if (!(prevDialog == null)) {
    yield* gameDialog.tmq(prevDialog, $completion);
  } else {
    yield* gameDialog.vma($completion);
  }
  lastInfoDialog = gameDialog;
  if (needAddNextButton) {
    if (onboardingMenuButton == null)
      null;
    else
      addTo(onboardingMenuButton, gameDialog.umq());
  }
  if (needAddNextButton) {
    yield* awaitDeferred.m1q($completion);
  }
  return Unit_instance;
}
function cardPicturesByRows(zoom, bitmapRows, onCardClick) {
  onCardClick = onCardClick === VOID ? null : onCardClick;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(bitmapRows, 10));
  var _iterator__ex2g4s = bitmapRows.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(item, 10));
    var _iterator__ex2g4s_0 = item.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var tmp = !(onCardClick == null);
      var tmp$ret$5 = CardUi.tm1(item_0, VOID, VOID, tmp, VOID, cardPicturesByRows$slambda(onCardClick, item_0));
      destination_0.d2(tmp$ret$5);
    }
    destination.d2(destination_0);
  }
  return cardViewsByRows(zoom, destination);
}
function *createLineInDialog(_this__u8e3s4, string, $completion) {
  var textColor = Companion_getInstance_15().pci(255, 240, 200);
  var textSize = get_gameLayout().vl5_1;
  var regex = Regex.hi('<([A-Za-z0-9]+)>');
  var allResults = regex.li(string);
  if (!allResults.p1().q1()) {
    return OutlinedText(string, textSize, textColor);
  }
  var panel = new ControlPanelX();
  var lastIndex = 0;
  var _iterator__ex2g4s = allResults.p1();
  $l$loop: while (_iterator__ex2g4s.q1()) {
    var m = _iterator__ex2g4s.r1();
    var range = m.oi();
    if (range.n3_1 > lastIndex) {
      createLineInDialog$addTextSegment(textSize, textColor, panel, substring(string, lastIndex, range.n3_1));
    }
    var tag = m.nj().u2(1);
    var bitmap = yield* getBitmapByStringTag(_this__u8e3s4, tag, $completion);
    if (bitmap == null) {
      createLineInDialog$addTextSegment(textSize, textColor, panel, '<' + tag + '>');
      continue $l$loop;
    }
    addTo_0(toHeight(Image.lk7(bitmap), textSize), panel);
    lastIndex = range.o3_1 + 1 | 0;
  }
  if (lastIndex < string.length) {
    createLineInDialog$addTextSegment(textSize, textColor, panel, substring_0(string, lastIndex));
  }
  return panel.xlb_1;
}
function cardViewsByRows(zoom, bitmapRows) {
  var controlPanelY = new ControlPanelY(VOID, VOID, VOID, shiftForCards(zoom));
  var _iterator__ex2g4s = bitmapRows.p1();
  while (_iterator__ex2g4s.q1()) {
    var row = _iterator__ex2g4s.r1();
    var controlPanelX = new ControlPanelX(VOID, VOID, VOID, VOID, shiftForCards(zoom));
    var _iterator__ex2g4s_0 = row.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var view = _iterator__ex2g4s_0.r1();
      addTo_0(toHeight(view, get_gameLayout().ol5_1 * zoom), controlPanelX);
    }
    controlPanelY.mlr(controlPanelX.xlb_1);
  }
  return controlPanelY;
}
function *getBitmapByStringTag(_this__u8e3s4, tag, $completion) {
  if (tag === 'Trail') {
    return yield* (yield* _this__u8e3s4.pl6().nle(Bolgin_getInstance(), $completion)).m1q($completion);
  }
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get_entries_3();
  var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cd(capacity);
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$2 = element.toString();
    destination.b5(tmp$ret$2, element);
  }
  var tmp0_safe_receiver = destination.w4(tag);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return yield* (yield* _this__u8e3s4.pl6().hle(tmp0_safe_receiver, $completion)).m1q($completion);
  }
  var types = setOf_0([SheepType_getInstance(), BoarType_getInstance(), BearType_getInstance(), NobleType_getInstance(), FarmerType_getInstance(), WatchtowerType_getInstance()]);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(types, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap.cd(capacity_0);
  var _iterator__ex2g4s_0 = types.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp$ret$7 = toString(element_0);
    destination_0.b5(tmp$ret$7, element_0);
  }
  var tmp1_safe_receiver = destination_0.w4(tag);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return yield* (yield* _this__u8e3s4.pl6().qle(tmp1_safe_receiver, VOID, $completion)).m1q($completion);
  }
  var tmp0 = get_entries_6();
  var tmp$ret$10;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s_1 = tmp0.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_1 = _iterator__ex2g4s_1.r1();
      if (equals_0(element_1.v1_1, tag, false)) {
        if (found) {
          tmp$ret$10 = null;
          break $l$block_0;
        }
        single = element_1;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$10 = null;
      break $l$block_0;
    }
    tmp$ret$10 = single;
  }
  var tmp2_safe_receiver = tmp$ret$10;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return yield* (yield* _this__u8e3s4.pl6().vle(tmp2_safe_receiver, $completion)).m1q($completion);
  }
  return null;
}
function shiftForCards(zoom) {
  return get_gameLayout().il6_1 * zoom / 8;
}
function *showContractSelectionDialog(coroutineScope, frame, images, contracts, initialContract, title, closeButtonText, onSelect, onCloseButton, $completion) {
  onCloseButton = onCloseButton === VOID ? null : onCloseButton;
  var contractDialog = {_v: null};
  yield* showContractSelectionDialog$installContractDialog(images, title, contracts, closeButtonText, contractDialog, frame, onSelect, coroutineScope, onCloseButton, initialContract, $completion);
  return ensureNotNull(contractDialog._v);
}
function *chooseCharacter_0(images, variants, result, additionalActions, installContentDialog, $completion) {
  additionalActions = additionalActions === VOID ? emptyList() : additionalActions;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(variants, 10));
  var _iterator__ex2g4s = variants.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp = toString(item);
    var tmp$ret$2 = to(tmp, chooseCharacter$slambda(item, images, result));
    destination.d2(tmp$ret$2);
  }
  var infoMap = destination;
  yield* chooseCharacter$installVariant(infoMap, additionalActions, installContentDialog, first(infoMap).qm_1, $completion);
  return Unit_instance;
}
function *showContractInfoImpl($context_GameState_t6qee5, _this__u8e3s4, useRightSided, showCancelIcon, $completion) {
  var boardContainer = yield* createJustContractInfoBoard(get_gameRules($context_GameState_t6qee5), _this__u8e3s4.pl6(), $completion);
  var dialogLayout = useRightSided ? new BigRightSided(boardContainer.pig() / 10) : BigCenter_instance;
  return yield* _this__u8e3s4.xmo(DialogContent.llt(boardContainer, VOID, dialogLayout), get_gameDialogClose(), showCancelIcon, $completion);
}
function *showGameWarningDialog(_this__u8e3s4, event, $completion) {
  var panel = new ControlPanelY();
  var lines_0 = plus(listOf(['Internal engine warning', 'The game engine encountered an internal problem.', 'Please check the game state before continuing.', 'Additional master fixing may be required to correct it.']), !(event.j53_1 == null) ? listOf_0('Problem report ID: ' + event.j53_1) : emptyList());
  var _iterator__ex2g4s = lines_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var line = _iterator__ex2g4s.r1();
    addTo_0(PlainText(line, get_gameLayout().vl5_1), panel);
  }
  var details = new ControlPanelY(VOID, VOID, VOID, 0.0);
  var _iterator__ex2g4s_0 = lines(event.i53_1).p1();
  while (_iterator__ex2g4s_0.q1()) {
    var line_0 = _iterator__ex2g4s_0.r1();
    // Inline function 'kotlin.text.ifEmpty' call
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(line_0) === 0) {
      tmp = ' ';
    } else {
      tmp = line_0;
    }
    var tmp$ret$0 = tmp;
    var _iterator__ex2g4s_1 = chunked_0(tmp$ret$0, 100).p1();
    while (_iterator__ex2g4s_1.q1()) {
      var part = _iterator__ex2g4s_1.r1();
      addTo_0(PlainText(part, get_gameLayout().vl5_1), details);
    }
  }
  var viewport = VerticalScrollViewport.amg();
  addTo(details.xlb_1, viewport.xmf_1);
  var tmp0 = details.xlb_1.x9z();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_gameLayout().fl6_1 * 0.35;
  var tmp$ret$3 = Math.min(tmp0, b);
  viewport.hml(tmp$ret$3, VOID, 0.0);
  addTo_0(viewport, panel);
  var acknowledged = CompletableDeferred_0();
  addTo_0(ActionButton.vlb('OK', VOID, VOID, VOID, VOID, VOID, showGameWarningDialog$slambda(acknowledged)), panel);
  var dialog = GameDialog.mlt(_this__u8e3s4.qln(), DialogContent.llt(panel.xlb_1, VOID, new FitContent()));
  try {
    dialog.ylq();
    yield* acknowledged.m1q($completion);
  }finally {
    dialog.qlq();
  }
  return Unit_instance;
}
function *showEndOfGameDialog(_this__u8e3s4, winnerTeam, $completion) {
  var text = PlainText(get_gameI18n().b71(winnerTeam), get_gameLayout().vl5_1, get_gameColors().rlx_1);
  var gameDialog = {_v: null};
  var tmp = yield* (yield* _this__u8e3s4.pl6().tld(InterfaceIcon_Cancel_getInstance(), $completion)).m1q($completion);
  var cancelIcon = DialogCancelIcon.dlx(tmp, VOID, showEndOfGameDialog$slambda(gameDialog));
  gameDialog._v = GameDialog.mlt(_this__u8e3s4.nl2_1, DialogContent.llt(text).jmi(DialogCorner_RIGHT_TOP_getInstance(), cancelIcon), _this__u8e3s4.jl4_1);
  var tmp_0;
  if (gameDialog._v == null) {
    throwUninitializedPropertyAccessException('gameDialog');
  } else {
    tmp_0 = gameDialog._v;
  }
  yield* tmp_0.vma($completion);
  return Unit_instance;
}
function *createStatusHoverPopup(_this__u8e3s4, mainStatusPart, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$with.a39_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.p3a_1 === get_beastsGameTeam()) {
      destination.d2(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var tmp$ret$7 = item.o3a_1;
    destination_0.d2(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList.p2();
  var _iterator__ex2g4s_1 = destination_0.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_0 = _iterator__ex2g4s_1.r1();
    var tmp;
    if (get_isAliveType(get_objectType($this$with, element_0))) {
      var tmp_0 = get_objectType($this$with, element_0);
      tmp = !isInterface(tmp_0, SummonType);
    } else {
      tmp = false;
    }
    if (tmp) {
      destination_1.d2(element_0);
    }
  }
  var victims = destination_1;
  var beastsNightRewardStatus = $this$with.y37_1.n3a($this$with, get_beastsGameTeam(), $this$with.e38_1);
  var huntersNightRewardStatus = $this$with.y37_1.n3a($this$with, get_huntersGameTeam(), $this$with.e38_1);
  var popupContent = Container.fi2();
  var popupWidth = 0.0;
  var popupY = 0.0;
  var killedRow = addTo(Container.fi2(), popupContent);
  var killedRowX = 0.0;
  // Inline function 'kotlin.also' call
  var this_0 = PlainText('Killed:', get_gameLayout().sl5_1);
  this_0.rif(killedRowX);
  killedRowX = killedRowX + this_0.w9z();
  addTo(this_0, killedRow);
  if (victims.n1()) {
    killedRowX = killedRowX + get_gameLayout().yl5_1;
    // Inline function 'kotlin.also' call
    var this_1 = PlainText('none', get_gameLayout().sl5_1);
    this_1.rif(killedRowX);
    addTo(this_1, killedRow);
  } else {
    killedRowX = killedRowX + get_gameLayout().yl5_1;
    var _iterator__ex2g4s_2 = victims.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var obj = _iterator__ex2g4s_2.r1();
      // Inline function 'korlibs.korge.view.image' call
      var texture = yield* (yield* _this__u8e3s4.pl6().qle(get_objectType($this$with, obj), VOID, $completion)).m1q($completion);
      var anchor = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_2 = Image.lk7(texture, anchor);
      // Inline function 'kotlin.apply' call
      var this_3 = addTo(this_2, killedRow);
      // Inline function 'kotlin.also' call
      this_3.rif(killedRowX);
      this_3.sif(get_gameLayout().yl5_1 / 2);
      toHeight(this_3, get_gameLayout().sl5_1);
      killedRowX = killedRowX + this_3.pig();
    }
    killedRowX = killedRowX + get_gameLayout().yl5_1;
  }
  var tmp0_0 = popupWidth;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = killedRowX;
  popupWidth = Math.max(tmp0_0, b);
  popupY = popupY + killedRow.x9z();
  popupY = popupY + get_gameLayout().yl5_1 / 2;
  // Inline function 'kotlin.also' call
  var this_4 = PlainText('Night ' + $this$with.e38_1 + ' rewards:', get_gameLayout().sl5_1);
  this_4.sif(popupY);
  var tmp0_1 = popupWidth;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_0 = this_4.w9z();
  popupWidth = Math.max(tmp0_1, b_0);
  var rewardsTitle = addTo(this_4, popupContent);
  popupY = popupY + rewardsTitle.x9z();
  popupY = popupY + get_gameLayout().yl5_1 / 4;
  var tmp0_2 = popupWidth;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_1 = createStatusHoverPopup$addNightRewardRow(popupContent, popupY, 'Beasts', beastsNightRewardStatus);
  popupWidth = Math.max(tmp0_2, b_1);
  popupY = popupY + (get_gameLayout().sl5_1 + get_gameLayout().yl5_1 / 4);
  var tmp0_3 = popupWidth;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_2 = createStatusHoverPopup$addNightRewardRow(popupContent, popupY, 'Hunters', huntersNightRewardStatus);
  popupWidth = Math.max(tmp0_3, b_2);
  popupY = popupY + get_gameLayout().sl5_1;
  // Inline function 'kotlin.also' call
  var this_5 = Container.fi2();
  var tmp2 = Size2D.y9p(popupWidth + get_gameLayout().yl5_1 * 2, popupY + get_gameLayout().yl5_1);
  Companion_getInstance_11();
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var corner = get_gameLayout().sl5_1 / 4;
  var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  var tmp6 = new RGBA(get_gameColors().ylx_1);
  var tmp8 = new RGBA(Colors_getInstance().zc2_1);
  // Inline function 'korlibs.korge.view.roundRect' call
  var strokeThickness = get_gameLayout().rl5_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = RoundRect.rka(tmp2, tmp4, tmp6, tmp8, strokeThickness, true);
  // Inline function 'kotlin.apply' call
  addTo(this_6, this_5);
  this_5.uie(popupContent);
  popupContent.fcw(Vector2D.t9g(get_gameLayout().yl5_1, get_gameLayout().yl5_1 / 2));
  this_5.rif(mainStatusPart.wea());
  this_5.sif(mainStatusPart.xea() + mainStatusPart.x9z() + get_gameLayout().yl5_1 / 2);
  var popup = this_5;
  return popup;
}
function *showRuinsDialog(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0 = _this__u8e3s4.t6h();
  $l$block_1: {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0_0 = tmp0.b38_1.v4n_1;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element == null) ? isInterface(element, AshRuin) : false) {
        destination.d2(element);
      }
    }
    var availableRuins = destination;
    var tmp;
    if (_this__u8e3s4.bm5() && availableRuins.s2() < tmp0.b38_1.x4n_1) {
      var tmp0_1 = tmp0.y37_1.a3b();
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0_1, Collection)) {
          tmp_0 = tmp0_1.n1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$4 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0_1.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          if (!tmp0.b38_1.v4n_1.w2(element_0)) {
            tmp$ret$4 = true;
            break $l$block_0;
          }
        }
        tmp$ret$4 = false;
      }
      tmp = tmp$ret$4;
    } else {
      tmp = false;
    }
    var canAddRuin = tmp;
    if (availableRuins.n1() && !canAddRuin) {
      yield* _this__u8e3s4.cmo(PlainText('No ruins', get_gameLayout().sl5_1), VOID, get_gameDialogClose(), $completion);
      break $l$block_1;
    }
    var controlPanelX = new ControlPanelX();
    var _iterator__ex2g4s_1 = availableRuins.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var ashRuin = _iterator__ex2g4s_1.r1();
      var picture = yield* (yield* _this__u8e3s4.pl6().lle(ashRuin, $completion)).m1q($completion);
      var tmp_1 = Image.lk7(picture);
      var tmp_2 = _this__u8e3s4.bm5();
      addTo_0(toHeight(CardUi.ilo(tmp_1, VOID, ashRuin, tmp_2, VOID, VOID, showRuinsDialog$slambda(_this__u8e3s4, ashRuin)), get_gameLayout().ol5_1 * 1.5), controlPanelX);
    }
    if (canAddRuin) {
      addTo_0(ActionButton.vlb('Add Ruin', VOID, VOID, VOID, VOID, VOID, showRuinsDialog$slambda_0(_this__u8e3s4)), controlPanelX);
    }
    yield* _this__u8e3s4.gmh(controlPanelX.xlb_1, dialogCornerText('Available Ruins'), get_gameDialogClose(), $completion);
  }
  return Unit_instance;
}
function *showChooseMovementCardDialog(_this__u8e3s4, gameQuestion, result, mayNothing, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0 = gameQuestion.t47_1;
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap.m7();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var key = element.d4c_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.w4(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList.p2();
      destination.b5(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.d2(element);
  }
  var variantsByBeast = destination;
  yield* showMovementCardsDialog(_this__u8e3s4, toList_0(variantsByBeast.x4()), variantsByBeast, result, mayNothing, $completion);
  return Unit_instance;
}
function *createBeastsInfoView(currentBeast, images, onCardClick, onBoardClick, pickAction, $completion) {
  onCardClick = onCardClick === VOID ? null : onCardClick;
  onBoardClick = onBoardClick === VOID ? null : onBoardClick;
  pickAction = pickAction === VOID ? null : pickAction;
  var abilityCards = toList_0(currentBeast.s36());
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(abilityCards, 10));
  var _iterator__ex2g4s = abilityCards.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = yield* images.mle(item, $completion);
    destination.d2(tmp$ret$2);
  }
  var bitmapDeferredList = destination;
  var bitmaps = yield* awaitAll(bitmapDeferredList, $completion);
  var zoom = 1.4;
  var cardsPanel = cardPicturesByRows(zoom, listOf([listOf([bitmaps.u2(0), bitmaps.u2(1)]), listOf([bitmaps.u2(2), bitmaps.u2(3)])]), onCardClick);
  var controlPanelX = new ControlPanelX(VOID, VOID, VOID, VOID, get_gameLayout().il6_1 * zoom / 4);
  var tmp;
  if (currentBeast instanceof FeatheredKing) {
    var boardSuffix = {_v: '-unborn'};
    var boardContainer = Container.fi2();
    yield* createBeastsInfoView$installBoard(boardContainer, images, currentBeast, boardSuffix, onBoardClick, $completion);
    tmp = boardContainer;
  } else {
    var bitmap = yield* (yield* images.tle(currentBeast, null, $completion)).m1q($completion);
    tmp = toHeight(createBeastsInfoView$boardView(onBoardClick, bitmap), get_gameLayout().fl6_1 * 0.9);
  }
  var boardPanel = tmp;
  addTo_0(boardPanel, controlPanelX);
  if (!(pickAction == null)) {
    addTo_0(ActionButton.vlb('Pick', VOID, VOID, VOID, VOID, VOID, createBeastsInfoView$slambda(pickAction, currentBeast)), controlPanelX);
  }
  addTo_0(cardsPanel.xlb_1, controlPanelX);
  controlPanelX.flr();
  return controlPanelX.xlb_1;
}
function *createContractInfoView(gameRules, images, needShowMap, onCardClick, $completion) {
  onCardClick = onCardClick === VOID ? null : onCardClick;
  var tmp;
  if (!(onCardClick == null)) {
    var bitmap = yield* (yield* images.jle(gameRules, $completion)).m1q($completion);
    tmp = toHeight(CardUi.tm1(bitmap, 10.0, VOID, VOID, VOID, createContractInfoView$slambda(onCardClick, bitmap)), get_gameLayout().fl6_1 * get_gameLayout().cl6_1);
  } else {
    tmp = yield* createJustContractInfoBoard(gameRules, images, $completion);
  }
  var contractItself = tmp;
  var controlPanelX = new ControlPanelX(VOID, VOID, VOID, VOID, contractItself.pig() / 20);
  addTo_0(contractItself, controlPanelX);
  if (needShowMap) {
    var mapImage = toWidth(Image.lk7(yield* (yield* images.ile(gameRules.h3a(), MapFormat_PreviewMap_getInstance(), $completion)).m1q($completion)), contractItself.pig() * 1.6);
    addTo_0(mapImage, controlPanelX);
  }
  controlPanelX.flr();
  return controlPanelX.xlb_1;
}
function *createHuntersInfoView_0(currentHunter, images, pickAction, $completion) {
  pickAction = pickAction === VOID ? null : pickAction;
  var abilityCards = toList_0(currentHunter.s36());
  var boardDeferred = yield* images.tle(currentHunter, null, $completion);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(abilityCards, 10));
  var _iterator__ex2g4s = abilityCards.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = yield* images.mle(item, $completion);
    destination.d2(tmp$ret$2);
  }
  var bitmapDeferredList = destination;
  var bitmaps = yield* awaitAll(bitmapDeferredList, $completion);
  var zoom = 1.0;
  var cardsPanel = cardPicturesByRows(zoom, listOf_0(listOf([bitmaps.u2(0), bitmaps.u2(1), bitmaps.u2(2)])));
  var hunterImage = toWidth(Image.lk7(yield* boardDeferred.m1q($completion)), get_gameLayout().el6_1 * 0.6);
  var controlPanelY = new ControlPanelY();
  addTo_0(cardsPanel.xlb_1, controlPanelY);
  addTo_0(hunterImage, controlPanelY);
  controlPanelY.flr();
  var tmp;
  if (!(pickAction == null)) {
    var controlPanelX = new ControlPanelX(VOID, VOID, VOID, VOID, get_gameLayout().il6_1 * zoom / 4);
    addTo_0(controlPanelY.xlb_1, controlPanelX);
    addTo_0(ActionButton.vlb('Pick', VOID, VOID, VOID, VOID, VOID, createHuntersInfoView$slambda(pickAction, currentHunter)), controlPanelX);
    controlPanelX.flr();
    tmp = controlPanelX.xlb_1;
  } else {
    tmp = controlPanelY.xlb_1;
  }
  var container = tmp;
  return container;
}
function *createJustContractInfoBoard(gameRules, images, $completion) {
  var boardContainer = Container.fi2();
  // Inline function 'korlibs.korge.view.image' call
  var texture = yield* (yield* images.jle(gameRules, $completion)).m1q($completion);
  var anchor = Companion_getInstance_7().c9g_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.lk7(texture, anchor);
  // Inline function 'kotlin.apply' call
  addTo(this_0, boardContainer);
  toHeight(boardContainer, get_gameLayout().fl6_1 * get_gameLayout().cl6_1);
  return boardContainer;
}
function *showMovementCardsDialog(_this__u8e3s4, beasts, variantsByBeast, result, mayNothing, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator = beasts.p1();
    if (!iterator.q1()) {
      tmp$ret$2 = null;
      break $l$block;
    }
    var it = iterator.r1();
    var maxValue = get_beastMovements($this$with, it).s2();
    while (iterator.q1()) {
      var it_0 = iterator.r1();
      var v = get_beastMovements($this$with, it_0).s2();
      if (compareTo(maxValue, v) < 0) {
        maxValue = v;
      }
    }
    tmp$ret$2 = maxValue;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var maxMovementCards = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var decrease = maxMovementCards <= 21 ? 1 : 2;
  var controlPanelY = new ControlPanelY(VOID, VOID, VOID, shiftForCards(1.0 / decrease));
  var gameDialog = null;
  gameDialog = GameDialog.xlq(_this__u8e3s4.nl2_1, controlPanelY.xlb_1, VOID, showMovementCardsDialog$slambda(result, mayNothing));
  // Inline function 'kotlin.collections.mutableMapOf' call
  var autoHighlights = LinkedHashMap.m7();
  var _iterator__ex2g4s = beasts.p1();
  while (_iterator__ex2g4s.q1()) {
    var beast = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs_0 = variantsByBeast.w4(beast);
    var tmp = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
    var tmp_0;
    if (gameDialog == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp_0 = gameDialog;
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = (yield* addMovementCardsDialogRows(_this__u8e3s4, beast, decrease, tmp, result, tmp_0, autoHighlights, beasts.s2() > 1, $completion)).p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      controlPanelY.mlr(element);
    }
  }
  _this__u8e3s4.rln(autoHighlights);
  var tmp_1;
  if (gameDialog == null) {
    throwUninitializedPropertyAccessException('gameDialog');
  } else {
    tmp_1 = gameDialog;
  }
  tmp_1.ylq();
  return Unit_instance;
}
function *addMovementCardsDialogRows(_this__u8e3s4, beast, decrease, variants, result, gameDialog, autoHighlights, needBeastHeader, $completion) {
  // Inline function 'kotlin.with' call
  var $this$with = _this__u8e3s4.t6h();
  var beastMovements = get_beastMovements($this$with, beast);
  var isBeastTeam = _this__u8e3s4.be1(get_beastsGameTeam());
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(variants, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cd(capacity);
  var _iterator__ex2g4s = variants.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp$ret$4 = element.e4c_1;
    destination.b5(tmp$ret$4, element);
  }
  var variantsByIndex = destination;
  // Inline function 'kotlin.collections.mutableListOf' call
  var rows = ArrayList.p2();
  if (needBeastHeader) {
    // Inline function 'kotlin.collections.plusAssign' call
    var element_0 = BorderedText(toString(get_objectType($this$with, beast)), get_gameLayout().sl5_1);
    rows.d2(element_0);
  }
  var _iterator__ex2g4s_0 = chunked(withIndex(beastMovements), imul(7, decrease)).p1();
  while (_iterator__ex2g4s_0.q1()) {
    var movementRow = _iterator__ex2g4s_0.r1();
    var controlPanelX = new ControlPanelX(VOID, VOID, VOID, VOID, shiftForCards(1.0 / decrease));
    // Inline function 'kotlin.collections.mutableListOf' call
    var locationMarkers = ArrayList.p2();
    var _iterator__ex2g4s_1 = movementRow.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_1.r1();
      var index = _destruct__k2r9zo.jm();
      var movement = _destruct__k2r9zo.km();
      var mainCardHeight = get_gameLayout().ol5_1 / decrease;
      var movementCardVariant = variantsByIndex.w4(index);
      var isChoosing = !(result == null);
      var isSelectable = !isChoosing || !(movementCardVariant == null);
      var tmp = index + 1 | 0;
      var card = addTo_0(yield* buildMovementCardContent(_this__u8e3s4, movement, tmp, isBeastTeam, isSelectable, isSelectable, true, mainCardHeight, addMovementCardsDialogRows$slambda(gameDialog, movementCardVariant, result), $completion), controlPanelX);
      if (!isSelectable) {
        card.sig(0.35);
      } else if (!(movementCardVariant == null)) {
        // Inline function 'kotlin.collections.set' call
        var value = new AutoHighlight(card, toPoint(card.s2().l9s(2)));
        autoHighlights.b5(movementCardVariant, value);
      }
      var leadToLocationType = movement.j3g_1;
      if (!(leadToLocationType == null) && leadToLocationType.q45()) {
        // Inline function 'kotlin.apply' call
        var this_0 = Image.lk7(yield* (yield* _this__u8e3s4.pl6().hle(leadToLocationType, $completion)).m1q($completion));
        toHeight(this_0, mainCardHeight * 0.25);
        position(this_0, card.pig() * 0.9 + card.wb5().r9g_1, card.xea() + (card.rig() - this_0.rig()) * 0.5);
        // Inline function 'kotlin.let' call
        locationMarkers.d2(this_0);
      }
    }
    var _iterator__ex2g4s_2 = locationMarkers.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var view = _iterator__ex2g4s_2.r1();
      controlPanelX.xlb_1.uie(view);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var element_1 = controlPanelX.xlb_1;
    rows.d2(element_1);
  }
  return rows;
}
function *showMovementCardsDialog_0(_this__u8e3s4, beast, $completion) {
  // Inline function 'kotlin.with' call
  _this__u8e3s4.t6h();
  yield* /*#__NOINLINE__*/showMovementCardsDialog(_this__u8e3s4, listOf_0(beast), emptyMap(), null, true, $completion);
  return Unit_instance;
}
function showGameSessionErrorDialog$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return Unit_instance;
  }, 1);
}
function showGameSessionErrorDialog$slambda_0($dialog, $reconnect) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $dialog.qlq();
    $reconnect();
    return Unit_instance;
  }, 1);
}
function showGameSessionErrorDialog$slambda_1($dialog, $requestServerReload) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $dialog.qlq();
    $requestServerReload();
    return Unit_instance;
  }, 1);
}
function showSharedCode$slambda($url, $resultText) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var ok = copyToClipboard($url);
    setText($resultText, ok ? 'Copied to clipboard' : 'Failed to copy. Please select and copy manually');
    return Unit_instance;
  }, 1);
}
function Text$_get_alpha_$ref_2hzaut(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 584, VOID, [p0]);
}
function Text$_set_alpha_$ref_vstr9d(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 585, VOID, [p0]);
}
function createStatusLayer$startFadeStatusNotification$slambda($t, $statusText, $fadingJob, $loadingResourceReporter) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = KMutableProperty0;
    var tmp_0 = Text$_get_alpha_$ref_2hzaut($t);
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, Text$_set_alpha_$ref_vstr9d($t));
    var tmp0_vs = [new V2(this_0, 1.0, 0.0, _interpolate$ref(), true)];
    var tmp1_easing = get_gameAnimations().ll4_1;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp2_time = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    yield* tween($t, tmp0_vs, tmp2_time, tmp1_easing, VOID, VOID, VOID, VOID, $completion);
    $statusText._v = null;
    $t.uih();
    $fadingJob._v = null;
    var tmp3_safe_receiver = $loadingResourceReporter;
    if (tmp3_safe_receiver == null)
      null;
    else
      yield* tmp3_safe_receiver.vmq($completion);
    return Unit_instance;
  }, 1);
}
function createStatusLayer$updateText(fadingJob, statusText, statusLayer, newText) {
  var tmp0_safe_receiver = fadingJob._v;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1n();
  }
  var tmp1_elvis_lhs = statusText._v;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.also' call
    var this_0 = addTo(PlainText('', get_gameLayout().sl5_1), statusLayer);
    this_0.rif(get_gameLayout().zl5_1);
    this_0.sif(get_gameLayout().fl6_1 - get_gameLayout().sl5_1 - get_gameLayout().zl5_1);
    statusText._v = this_0;
    tmp = this_0;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var t = tmp;
  t.fio(newText);
  t.sig(1.0);
}
function createStatusLayer$startFadeStatusNotification(statusText, fadingJob, $scope, loadingResourceReporter) {
  var tmp0_elvis_lhs = statusText._v;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var t = tmp;
  fadingJob._v = launch($scope, VOID, VOID, createStatusLayer$startFadeStatusNotification$slambda(t, statusText, fadingJob, loadingResourceReporter));
}
function createStatusLayer$slambda$slambda($firstTime, $isDisconnected, $fadingJob, $statusText, $statusLayer, $scope, $loadingResourceReporter) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    switch (it.w1_1) {
      case 0:
        var tmp_0;
        if (!$firstTime._v) {
          $isDisconnected._v = false;
          createStatusLayer$updateText($fadingJob, $statusText, $statusLayer, 'Reconnected');
          createStatusLayer$startFadeStatusNotification($statusText, $fadingJob, $scope, $loadingResourceReporter);
          tmp_0 = Unit_instance;
        } else {
          $firstTime._v = false;
          tmp_0 = Unit_instance;
        }

        tmp = tmp_0;
        break;
      case 1:
        if ($isDisconnected._v)
          return Unit_instance;
        var _unary__edvuaz = get_numberOfDisconnectionsSoFar();
        set_numberOfDisconnectionsSoFar(_unary__edvuaz + 1 | 0);
        $isDisconnected._v = true;
        createStatusLayer$updateText($fadingJob, $statusText, $statusLayer, 'Reconnecting...');
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  }, 1);
}
function createStatusLayer$slambda($connectionStatus, $firstTime, $isDisconnected, $fadingJob, $statusText, $statusLayer, $scope, $loadingResourceReporter) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = createStatusLayer$slambda$slambda($firstTime, $isDisconnected, $fadingJob, $statusText, $statusLayer, $scope, $loadingResourceReporter);
    yield* $connectionStatus.s25(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp), $completion);
    throwKotlinNothingValueException();
  }, 1);
}
function showInformationDialog$slambda($backButtonCallback) {
  return constructCallableReference(function *(it, $completion) {
    it.uih();
    $backButtonCallback();
    return Unit_instance;
  }, 1);
}
function showInformationDialog$slambda_0($buttonsPanel, $backButtonCallback) {
  return constructCallableReference(function *(it, $completion) {
    $buttonsPanel.uih();
    $backButtonCallback();
    return Unit_instance;
  }, 1);
}
function showInformationDialog$slambda_1($buttonsPanel, $awaitDeferred) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $buttonsPanel.uih();
    $awaitDeferred.l1t(Unit_instance);
    return Unit_instance;
  }, 1);
}
function cardPicturesByRows$slambda($onCardClick, $bitmap) {
  return constructCallableReference(function *($completion) {
    var tmp0_safe_receiver = $onCardClick;
    if (tmp0_safe_receiver == null)
      null;
    else
      yield* tmp0_safe_receiver($bitmap, $completion);
    return Unit_instance;
  }, 0);
}
function createLineInDialog$addTextSegment(textSize, textColor, panel, part) {
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(part) > 0) {
    addTo_0(OutlinedText(part, textSize, textColor), panel);
  }
}
function showContractSelectionDialog$installContractDialog$slambda($onSelect, $currentContract, $contractDialog) {
  return constructCallableReference(function *($completion) {
    yield* $onSelect($currentContract, $completion);
    var tmp0_safe_receiver = $contractDialog._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    return Unit_instance;
  }, 0);
}
function showContractSelectionDialog$installContractDialog$slambda$slambda($contract, $images, $title, $contracts, $closeButtonText, $contractDialog, $frame, $onSelect, $coroutineScope, $onCloseButton) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* showContractSelectionDialog$installContractDialog($images, $title, $contracts, $closeButtonText, $contractDialog, $frame, $onSelect, $coroutineScope, $onCloseButton, $contract, $completion);
    return Unit_instance;
  }, 1);
}
function showContractSelectionDialog$installContractDialog$slambda_0($coroutineScope, $contract, $images, $title, $contracts, $closeButtonText, $contractDialog, $frame, $onSelect, $onCloseButton) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    launch($coroutineScope, VOID, VOID, showContractSelectionDialog$installContractDialog$slambda$slambda($contract, $images, $title, $contracts, $closeButtonText, $contractDialog, $frame, $onSelect, $coroutineScope, $onCloseButton));
    return Unit_instance;
  }, 1);
}
function showContractSelectionDialog$installContractDialog$slambda$slambda_0($onCloseButton) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $onCloseButton($completion);
    return Unit_instance;
  }, 1);
}
function showContractSelectionDialog$installContractDialog$slambda_1($contractDialog, $onCloseButton, $coroutineScope) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp0_safe_receiver = $contractDialog._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qlq();
    }
    var tmp;
    if (!($onCloseButton == null)) {
      launch($coroutineScope, VOID, VOID, showContractSelectionDialog$installContractDialog$slambda$slambda_0($onCloseButton));
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function *showContractSelectionDialog$installContractDialog($images, $title, $contracts, $closeButtonText, contractDialog, $frame, $onSelect, $coroutineScope, $onCloseButton, currentContract, $completion) {
  var contractImage = yield* (yield* $images.jle(currentContract, $completion)).m1q($completion);
  var contractElement = toHeight(CardUi.tm1(contractImage, 10.0, VOID, VOID, VOID, showContractSelectionDialog$installContractDialog$slambda($onSelect, currentContract, contractDialog)), get_gameLayout().fl6_1 * get_gameLayout().cl6_1);
  var dialogControlPanelY = new ControlPanelY();
  addTo_0(ensureNotNull(dialogCornerText($title)), dialogControlPanelY);
  var actions = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  var _iterator__ex2g4s = $contracts.p1();
  while (_iterator__ex2g4s.q1()) {
    var contract = _iterator__ex2g4s.r1();
    var tmp = get_gameI18n().d71(contract);
    addTo_0(ActionButton.vlb(tmp, VOID, VOID, VOID, VOID, VOID, showContractSelectionDialog$installContractDialog$slambda_0($coroutineScope, contract, $images, $title, $contracts, $closeButtonText, contractDialog, $frame, $onSelect, $onCloseButton)), actions);
  }
  addTo_0(ActionButton.vlb($closeButtonText, VOID, VOID, VOID, VOID, VOID, showContractSelectionDialog$installContractDialog$slambda_1(contractDialog, $onCloseButton, $coroutineScope)), actions);
  addTo_0(actions.xlb_1, dialogControlPanelY);
  var tmp0_safe_receiver = contractDialog._v;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.qlq();
  }
  contractDialog._v = GameDialog.mlt($frame, DialogContent.cmg(contractElement, dialogControlPanelY.xlb_1));
  contractDialog._v.ylq();
  return Unit_instance;
}
function chooseCharacter$installVariant$slambda($fn, $infoMap, $additionalActions, $installContentDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* chooseCharacter$installVariant($infoMap, $additionalActions, $installContentDialog, $fn, $completion);
    return Unit_instance;
  }, 1);
}
function chooseCharacter$slambda$slambda($result) {
  return constructCallableReference(function *(it, $completion) {
    $result.l1t(it);
    return Unit_instance;
  }, 1);
}
function chooseCharacter$slambda$slambda_0($result) {
  return constructCallableReference(function *(it, $completion) {
    $result.l1t(it);
    return Unit_instance;
  }, 1);
}
function chooseCharacter$slambda($it, $images, $result) {
  return constructCallableReference(function *($completion) {
    var tmp0_subject = $it;
    var tmp;
    if (isInterface(tmp0_subject, BeastCharacter)) {
      tmp = yield* /*#__NOINLINE__*/createBeastsInfoView($it, $images, VOID, VOID, chooseCharacter$slambda$slambda($result), $completion);
    } else {
      if (isInterface(tmp0_subject, HunterCharacter)) {
        tmp = yield* /*#__NOINLINE__*/createHuntersInfoView_0($it, $images, chooseCharacter$slambda$slambda_0($result), $completion);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }, 0);
}
function *chooseCharacter$installVariant(infoMap, $additionalActions, $installContentDialog, viewFn, $completion) {
  var itemsPanel = new ButtonColumn(Companion_getInstance_10().c9s_1, 5.0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(infoMap, 10));
  var _iterator__ex2g4s = infoMap.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var s = item.jm();
    var fn = item.km();
    var tmp$ret$2 = ActionButton.vlb(s, VOID, VOID, VOID, VOID, VOID, chooseCharacter$installVariant$slambda(fn, infoMap, $additionalActions, $installContentDialog));
    destination.d2(tmp$ret$2);
  }
  var items = destination;
  var _iterator__ex2g4s_0 = items.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var view = _iterator__ex2g4s_0.r1();
    addTo_0(view, itemsPanel);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = $additionalActions.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element = _iterator__ex2g4s_1.r1();
    addTo_0(element, itemsPanel);
  }
  var dialogContent = DialogContent.cmg(yield* viewFn($completion), itemsPanel.xlb_1, new BigRightSided());
  yield* $installContentDialog(dialogContent, $completion);
  return Unit_instance;
}
function showGameWarningDialog$slambda($acknowledged) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    $acknowledged.l1t(Unit_instance);
    return Unit_instance;
  }, 1);
}
function showEndOfGameDialog$slambda($gameDialog) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp = $gameDialog._v;
    }
    var tmp_0 = tmp.hlq_1;
    var tmp_1;
    if ($gameDialog._v == null) {
      throwUninitializedPropertyAccessException('gameDialog');
    } else {
      tmp_1 = $gameDialog._v;
    }
    yield* tmp_0(tmp_1, $completion);
    return Unit_instance;
  }, 0);
}
function createStatusHoverPopup$nightRewardStatusText(status) {
  var tmp;
  switch (status.w1_1) {
    case 0:
      tmp = 'unavailable';
      break;
    case 1:
      tmp = 'already passed';
      break;
    case 2:
      tmp = 'not gained';
      break;
    case 3:
      tmp = 'failed';
      break;
    case 4:
      tmp = 'expected';
      break;
    case 5:
      tmp = 'ensured';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function createStatusHoverPopup$nightRewardStatusColor(status) {
  var tmp;
  switch (status.w1_1) {
    case 0:
    case 1:
    case 2:
      tmp = Colors_getInstance().vc5_1;
      break;
    case 3:
      tmp = Colors_getInstance().bc3_1;
      break;
    case 4:
      tmp = Colors_getInstance().ec5_1;
      break;
    case 5:
      tmp = Colors_getInstance().wc5_1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function createStatusHoverPopup$addNightRewardRow(_this__u8e3s4, rowY, teamName, status) {
  var rowX = 0.0;
  // Inline function 'kotlin.also' call
  var this_0 = PlainText(teamName + ':', get_gameLayout().sl5_1);
  this_0.rif(rowX);
  this_0.sif(rowY);
  rowX = rowX + (this_0.w9z() + get_gameLayout().yl5_1);
  addTo(this_0, _this__u8e3s4);
  var tmp0_text = createStatusHoverPopup$nightRewardStatusText(status);
  var tmp1_color = createStatusHoverPopup$nightRewardStatusColor(status);
  var tmp2_textSize = get_gameLayout().sl5_1;
  // Inline function 'kotlin.also' call
  var this_1 = PlainText(tmp0_text, tmp2_textSize, tmp1_color);
  this_1.rif(rowX);
  this_1.sif(rowY);
  rowX = rowX + this_1.w9z();
  addTo(this_1, _this__u8e3s4);
  return rowX;
}
function showRuinsDialog$slambda($this_showRuinsDialog, $ashRuin) {
  return constructCallableReference(function *($completion) {
    yield* showSandboxChangeRuinDialog($this_showRuinsDialog, $ashRuin, $completion);
    return Unit_instance;
  }, 0);
}
function showRuinsDialog$slambda_0($this_showRuinsDialog) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* showSandboxChangeRuinDialog($this_showRuinsDialog, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function createBeastsInfoView$boardView$slambda($onBoardClick, $bitmap, $reborn) {
  return constructCallableReference(function *($completion) {
    yield* $onBoardClick($bitmap, $reborn, $completion);
    return Unit_instance;
  }, 0);
}
function createBeastsInfoView$installBoard$slambda($boardSuffix, $boardContainer, $images, $currentBeast, $onBoardClick) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    var tmp;
    if ($boardSuffix._v === '-unborn') {
      tmp = '-reborn';
    } else {
      tmp = '-unborn';
    }
    $boardSuffix._v = tmp;
    yield* createBeastsInfoView$installBoard($boardContainer, $images, $currentBeast, $boardSuffix, $onBoardClick, $completion);
    return Unit_instance;
  }, 1);
}
function createBeastsInfoView$boardView($onBoardClick, bitmap, reborn) {
  reborn = reborn === VOID ? false : reborn;
  var tmp;
  if (!($onBoardClick == null)) {
    tmp = CardUi.tm1(bitmap, 10.0, VOID, VOID, VOID, createBeastsInfoView$boardView$slambda($onBoardClick, bitmap, reborn));
  } else {
    tmp = Image.lk7(bitmap);
  }
  return tmp;
}
function *createBeastsInfoView$installBoard(boardContainer, $images, $currentBeast, boardSuffix, $onBoardClick, $completion) {
  boardContainer.tie();
  var bitmap = yield* (yield* $images.ule($currentBeast, boardSuffix._v, $completion)).m1q($completion);
  var image = addTo(toHeight(createBeastsInfoView$boardView($onBoardClick, bitmap, boardSuffix._v === '-reborn'), get_gameLayout().fl6_1 * 0.9), boardContainer);
  // Inline function 'kotlin.apply' call
  var this_0 = ActionButton.vlb('Flip', VOID, VOID, VOID, VOID, VOID, createBeastsInfoView$installBoard$slambda(boardSuffix, boardContainer, $images, $currentBeast, $onBoardClick));
  this_0.sif(get_gameLayout().yl5_1);
  this_0.rif(image.pig() - this_0.pig() - get_gameLayout().yl5_1);
  addTo(this_0, boardContainer);
  return Unit_instance;
}
function createBeastsInfoView$slambda($pickAction, $currentBeast) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $pickAction($currentBeast, $completion);
    return Unit_instance;
  }, 1);
}
function createContractInfoView$slambda($onCardClick, $bitmap) {
  return constructCallableReference(function *($completion) {
    yield* $onCardClick($bitmap, $completion);
    return Unit_instance;
  }, 0);
}
function createHuntersInfoView$slambda($pickAction, $currentHunter) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $pickAction($currentHunter, $completion);
    return Unit_instance;
  }, 1);
}
function showMovementCardsDialog$slambda($result, $mayNothing) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if (!($result == null) && !$mayNothing) {
      return Unit_instance;
    }
    var tmp_0;
    if (!($result == null) && $mayNothing) {
      $result.l1t(null);
      tmp_0 = Unit_instance;
    }
    yield* get_gameDialogClose()(it, $completion);
    return Unit_instance;
  }, 1);
}
function addMovementCardsDialogRows$slambda($gameDialog, $movementCardVariant, $result) {
  return constructCallableReference(function *($completion) {
    $gameDialog.qlq();
    var tmp;
    if (!($movementCardVariant == null)) {
      var tmp0_safe_receiver = $result;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.l1t($movementCardVariant);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 0);
}
function get_sevenUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return sevenUpgradesChoose;
}
var sevenUpgradesChoose;
function get_sixUpgradesChooseTop() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return sixUpgradesChooseTop;
}
var sixUpgradesChooseTop;
function get_sixBigBotUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return sixBigBotUpgradesChoose;
}
var sixBigBotUpgradesChoose;
function get_akkeronUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return akkeronUpgradesChoose;
}
var akkeronUpgradesChoose;
function get_vackerUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return vackerUpgradesChoose;
}
var vackerUpgradesChoose;
function get_rhagnerUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return rhagnerUpgradesChoose;
}
var rhagnerUpgradesChoose;
function get_lydanUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return lydanUpgradesChoose;
}
var lydanUpgradesChoose;
function get_ommaUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return ommaUpgradesChoose;
}
var ommaUpgradesChoose;
function get_urgullUpgradesChoose() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return urgullUpgradesChoose;
}
var urgullUpgradesChoose;
function get_fangrirUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return fangrirUiUpgrades;
}
var fangrirUiUpgrades;
function get_raagaUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return raagaUiUpgrades;
}
var raagaUiUpgrades;
function get_esmeriaBeastUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return esmeriaBeastUiUpgrades;
}
var esmeriaBeastUiUpgrades;
function get_maraUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return maraUiUpgrades;
}
var maraUiUpgrades;
function get_hogbadUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return hogbadUiUpgrades;
}
var hogbadUiUpgrades;
function get_vackerUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return vackerUiUpgrades;
}
var vackerUiUpgrades;
function get_thaldukUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return thaldukUiUpgrades;
}
var thaldukUiUpgrades;
function get_akkeronUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return akkeronUiUpgrades;
}
var akkeronUiUpgrades;
function get_bolginUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return bolginUiUpgrades;
}
var bolginUiUpgrades;
function get_featheredKingUnbornUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return featheredKingUnbornUiUpgrades;
}
var featheredKingUnbornUiUpgrades;
function get_featheredKingRebornUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return featheredKingRebornUiUpgrades;
}
var featheredKingRebornUiUpgrades;
function get_rhagnerUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return rhagnerUiUpgrades;
}
var rhagnerUiUpgrades;
function get_rhagnerBoardHoardPlacing() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return rhagnerBoardHoardPlacing;
}
var rhagnerBoardHoardPlacing;
function get_rhagnerBoardHoardGrudgeDiametr() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return rhagnerBoardHoardGrudgeDiametr;
}
var rhagnerBoardHoardGrudgeDiametr;
function get_lydanUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return lydanUiUpgrades;
}
var lydanUiUpgrades;
function get_ommaUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return ommaUiUpgrades;
}
var ommaUiUpgrades;
function get_urgullUiUpgrades() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return urgullUiUpgrades;
}
var urgullUiUpgrades;
function get_urgullBoardFirstEagPlacing() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return urgullBoardFirstEagPlacing;
}
var urgullBoardFirstEagPlacing;
function get_urgullBoardEagDistance() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return urgullBoardEagDistance;
}
var urgullBoardEagDistance;
function get_urgullBoardEagHeight() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return urgullBoardEagHeight;
}
var urgullBoardEagHeight;
function get_huntersUpgradeOrder() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  return huntersUpgradeOrder;
}
var huntersUpgradeOrder;
function topCharacterBoardScrollingY(character) {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (character instanceof Fangrir) {
    tmp_1 = true;
  } else {
    var tmp_2;
    if (character instanceof Raaga) {
      tmp_2 = true;
    } else {
      tmp_2 = character instanceof EsmeriaBeast;
    }
    tmp_1 = tmp_2;
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    var tmp_3;
    if (character instanceof Mara) {
      tmp_3 = true;
    } else {
      var tmp_4;
      if (character instanceof Hogbad) {
        tmp_4 = true;
      } else {
        tmp_4 = character instanceof Bolgin;
      }
      tmp_3 = tmp_4;
    }
    tmp_0 = tmp_3;
  }
  if (tmp_0) {
    tmp = 1250;
  } else {
    var tmp_5;
    var tmp_6;
    if (character instanceof Vacker) {
      tmp_6 = true;
    } else {
      tmp_6 = character instanceof Thalduk;
    }
    if (tmp_6) {
      tmp_5 = true;
    } else {
      var tmp_7;
      if (character instanceof Akkeron) {
        tmp_7 = true;
      } else {
        tmp_7 = character instanceof FeatheredKing;
      }
      tmp_5 = tmp_7;
    }
    if (tmp_5) {
      tmp = 1250;
    } else {
      if (character instanceof Lydan) {
        tmp = 1250;
      } else {
        if (character instanceof Omma) {
          tmp = 1250;
        } else {
          var tmp_8;
          if (character instanceof Rhagner) {
            tmp_8 = true;
          } else {
            tmp_8 = character instanceof Urgull;
          }
          if (tmp_8) {
            tmp = 1085;
          } else {
            tmp = null;
          }
        }
      }
    }
  }
  return tmp;
}
function getCharacterUpgradePlacing($context_GameState_t6qee5, character) {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  if (isInterface(character, HunterCharacter)) {
    var tmp;
    if (character instanceof Bram) {
      tmp = get_bramUpgradesMap();
    } else {
      if (character instanceof Draug) {
        tmp = get_draugUpgradesMap();
      } else {
        if (character instanceof Sigrid) {
          tmp = get_sigridUpgradesMap();
        } else {
          if (character.t35().s2() === 3) {
            tmp = get_huntersThreeUpgradesMap();
          } else {
            if (character.t35().s2() === 4) {
              tmp = get_huntersFourUpgradesMap();
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Not implemented for ' + toString(character);
              throw IllegalStateException.o(toString(message));
            }
          }
        }
      }
    }
    var upgradeMap = tmp;
    return getHuntersUpgradePlacing(character, upgradeMap);
  }
  var tmp_0;
  if (character instanceof Fangrir) {
    tmp_0 = get_fangrirUiUpgrades();
  } else {
    if (character instanceof Raaga) {
      tmp_0 = get_raagaUiUpgrades();
    } else {
      if (character instanceof EsmeriaBeast) {
        tmp_0 = get_esmeriaBeastUiUpgrades();
      } else {
        if (character instanceof Mara) {
          tmp_0 = get_maraUiUpgrades();
        } else {
          if (character instanceof Hogbad) {
            tmp_0 = get_hogbadUiUpgrades();
          } else {
            if (character instanceof Bolgin) {
              tmp_0 = get_bolginUiUpgrades();
            } else {
              if (character instanceof Vacker) {
                tmp_0 = get_vackerUiUpgrades();
              } else {
                if (character instanceof Thalduk) {
                  tmp_0 = get_thaldukUiUpgrades();
                } else {
                  if (character instanceof Akkeron) {
                    tmp_0 = get_akkeronUiUpgrades();
                  } else {
                    if (character instanceof FeatheredKing) {
                      var tmp_1;
                      if (get_isReborn($context_GameState_t6qee5, get_featheredKingBeast($context_GameState_t6qee5))) {
                        tmp_1 = get_featheredKingRebornUiUpgrades();
                      } else {
                        tmp_1 = get_featheredKingUnbornUiUpgrades();
                      }
                      tmp_0 = tmp_1;
                    } else {
                      if (character instanceof Rhagner) {
                        tmp_0 = get_rhagnerUiUpgrades();
                      } else {
                        if (character instanceof Lydan) {
                          tmp_0 = get_lydanUiUpgrades();
                        } else {
                          if (character instanceof Omma) {
                            tmp_0 = get_ommaUiUpgrades();
                          } else {
                            if (character instanceof Urgull) {
                              tmp_0 = get_urgullUiUpgrades();
                            } else {
                              // Inline function 'kotlin.TODO' call
                              var reason = 'Not implemented for ' + toString(character);
                              throw NotImplementedError.le('An operation is not implemented: ' + reason);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp_0;
}
function get_bramUpgradesMap() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  var tmp = Companion_getInstance_9().i9i(Vector2D.a9k(1449, 405), Vector2D.a9k(1777, 623));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$0 = new Circle_0(Vector2D.t9g(numberToDouble(1385), numberToDouble(365)), numberToDouble(45));
  return plus(listOf_0(to(tmp, tmp$ret$0)), get_huntersThreeUpgradesMap());
}
function get_draugUpgradesMap() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  // Inline function 'kotlin.apply' call
  var this_0 = toMutableList(get_huntersThreeUpgradesMap());
  // Inline function 'kotlin.let' call
  var destruct = this_0.u2(0);
  var rectangle = destruct.jm();
  var circle = destruct.km();
  var tmp$ret$2 = to(Companion_getInstance_9().i9i(Vector2D.e9t(1940, rectangle.x9h()), rectangle.p9i()), circle);
  this_0.e5(0, tmp$ret$2);
  return this_0;
}
function get_sigridUpgradesMap() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  var tmp = Companion_getInstance_9().i9i(Vector2D.a9k(1860, 310), Vector2D.a9k(2195, 490));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$0 = new Circle_0(Vector2D.t9g(numberToDouble(2241), numberToDouble(275)), numberToDouble(45));
  var tmp_0 = to(tmp, tmp$ret$0);
  var tmp_1 = Companion_getInstance_9().i9i(Vector2D.a9k(1860, 585), Vector2D.a9k(2195, 765));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$1 = new Circle_0(Vector2D.t9g(numberToDouble(2241), numberToDouble(550)), numberToDouble(45));
  var tmp_2 = to(tmp_1, tmp$ret$1);
  var tmp_3 = Companion_getInstance_9().i9i(Vector2D.a9k(1860, 860), Vector2D.a9k(2195, 1037));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$2 = new Circle_0(Vector2D.t9g(numberToDouble(2241), numberToDouble(820)), numberToDouble(45));
  return listOf([tmp_0, tmp_2, to(tmp_3, tmp$ret$2)]);
}
function get_huntersThreeUpgradesMap() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  var tmp = Companion_getInstance_9().i9i(Vector2D.a9k(1848, 316), Vector2D.a9k(2178, 623));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$0 = new Circle_0(Vector2D.t9g(numberToDouble(2241), numberToDouble(282)), numberToDouble(45));
  var tmp_0 = to(tmp, tmp$ret$0);
  var tmp_1 = Companion_getInstance_9().i9i(Vector2D.a9k(1449, 720), Vector2D.a9k(1777, 1037));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$1 = new Circle_0(Vector2D.t9g(numberToDouble(1385), numberToDouble(685)), numberToDouble(45));
  var tmp_2 = to(tmp_1, tmp$ret$1);
  var tmp_3 = Companion_getInstance_9().i9i(Vector2D.a9k(1848, 720), Vector2D.a9k(2178, 1037));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$2 = new Circle_0(Vector2D.t9g(numberToDouble(2241), numberToDouble(685)), numberToDouble(45));
  return listOf([tmp_0, tmp_2, to(tmp_3, tmp$ret$2)]);
}
function get_huntersFourUpgradesMap() {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  var tmp = Companion_getInstance_9().i9i(Vector2D.a9k(1449, 316), Vector2D.a9k(1777, 623));
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var tmp$ret$0 = new Circle_0(Vector2D.t9g(numberToDouble(1385), numberToDouble(282)), numberToDouble(45));
  return plus(listOf_0(to(tmp, tmp$ret$0)), get_huntersThreeUpgradesMap());
}
function getHuntersUpgradePlacing(hunterCharacter, upgradeMap) {
  _init_properties_UiCharacterBoardPlacing_kt__ql1kip();
  var tmp0_elvis_lhs = get_huntersUpgradeOrder().w4(hunterCharacter);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not implemented for ' + toString(hunterCharacter);
    throw NotImplementedError.le('An operation is not implemented: ' + reason);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var upgrades = tmp;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(upgrades, 10));
  var index = 0;
  var _iterator__ex2g4s = upgrades.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$3 = to(item, upgradeMap.u2(index_0));
    destination.d2(tmp$ret$3);
  }
  return toMap(destination);
}
var properties_initialized_UiCharacterBoardPlacing_kt_gsuzh;
function _init_properties_UiCharacterBoardPlacing_kt__ql1kip() {
  if (!properties_initialized_UiCharacterBoardPlacing_kt_gsuzh) {
    properties_initialized_UiCharacterBoardPlacing_kt_gsuzh = true;
    var tmp = Companion_getInstance_9().i9i(Vector2D.a9k(120, 1631), Vector2D.a9k(491, 1956));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0 = new Circle_0(Vector2D.t9g(numberToDouble(93), numberToDouble(1597)), numberToDouble(45));
    var tmp_0 = to(tmp, tmp$ret$0);
    var tmp_1 = Companion_getInstance_9().i9i(Vector2D.a9k(566, 1631), Vector2D.a9k(937, 1956));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1 = new Circle_0(Vector2D.t9g(numberToDouble(750), numberToDouble(1670)), numberToDouble(45));
    var tmp_2 = to(tmp_1, tmp$ret$1);
    var tmp_3 = Companion_getInstance_9().i9i(Vector2D.a9k(1013, 1631), Vector2D.a9k(1384, 1956));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2 = new Circle_0(Vector2D.t9g(numberToDouble(1414), numberToDouble(1597)), numberToDouble(45));
    var tmp_4 = to(tmp_3, tmp$ret$2);
    var tmp_5 = Companion_getInstance_9().i9i(Vector2D.a9k(60, 2077), Vector2D.a9k(360, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$3 = new Circle_0(Vector2D.t9g(numberToDouble(211), numberToDouble(2442)), numberToDouble(45));
    var tmp_6 = to(tmp_5, tmp$ret$3);
    var tmp_7 = Companion_getInstance_9().i9i(Vector2D.a9k(416, 2049), Vector2D.a9k(716, 2387));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$4 = new Circle_0(Vector2D.t9g(numberToDouble(570), numberToDouble(2442)), numberToDouble(45));
    var tmp_8 = to(tmp_7, tmp$ret$4);
    var tmp_9 = Companion_getInstance_9().i9i(Vector2D.a9k(783, 2049), Vector2D.a9k(1083, 2387));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$5 = new Circle_0(Vector2D.t9g(numberToDouble(934), numberToDouble(2442)), numberToDouble(45));
    var tmp_10 = to(tmp_9, tmp$ret$5);
    var tmp_11 = Companion_getInstance_9().i9i(Vector2D.a9k(1144, 2077), Vector2D.a9k(1444, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$6 = new Circle_0(Vector2D.t9g(numberToDouble(1295), numberToDouble(2442)), numberToDouble(45));
    sevenUpgradesChoose = listOf([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, to(tmp_11, tmp$ret$6)]);
    var tmp_12 = Companion_getInstance_9().i9i(Vector2D.a9k(120, 1631), Vector2D.a9k(491, 1956));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_0 = new Circle_0(Vector2D.t9g(numberToDouble(80), numberToDouble(1585)), numberToDouble(45));
    var tmp_13 = to(tmp_12, tmp$ret$0_0);
    var tmp_14 = Companion_getInstance_9().i9i(Vector2D.a9k(566, 1631), Vector2D.a9k(937, 1956));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_0 = new Circle_0(Vector2D.t9g(numberToDouble(750), numberToDouble(1680)), numberToDouble(45));
    var tmp_15 = to(tmp_14, tmp$ret$1_0);
    var tmp_16 = Companion_getInstance_9().i9i(Vector2D.a9k(1013, 1631), Vector2D.a9k(1384, 1956));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_0 = new Circle_0(Vector2D.t9g(numberToDouble(1405), numberToDouble(1585)), numberToDouble(45));
    sixUpgradesChooseTop = listOf([tmp_13, tmp_15, to(tmp_16, tmp$ret$2_0)]);
    var tmp_17 = get_sixUpgradesChooseTop();
    var tmp_18 = Companion_getInstance_9().i9i(Vector2D.a9k(60, 2077), Vector2D.a9k(360, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_1 = new Circle_0(Vector2D.t9g(numberToDouble(211), numberToDouble(2442)), numberToDouble(45));
    var tmp_19 = to(tmp_18, tmp$ret$0_1);
    var tmp_20 = Companion_getInstance_9().i9i(Vector2D.a9k(422, 2032), Vector2D.a9k(1083, 2342));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_1 = new Circle_0(Vector2D.t9g(numberToDouble(754), numberToDouble(2467)), numberToDouble(45));
    var tmp_21 = to(tmp_20, tmp$ret$1_1);
    var tmp_22 = Companion_getInstance_9().i9i(Vector2D.a9k(1144, 2077), Vector2D.a9k(1444, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_1 = new Circle_0(Vector2D.t9g(numberToDouble(1295), numberToDouble(2442)), numberToDouble(45));
    sixBigBotUpgradesChoose = plus(tmp_17, listOf([tmp_19, tmp_21, to(tmp_22, tmp$ret$2_1)]));
    var tmp_23 = get_sixUpgradesChooseTop();
    var tmp_24 = Companion_getInstance_9().i9i(Vector2D.a9k(420, 2045), Vector2D.a9k(715, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_2 = new Circle_0(Vector2D.t9g(numberToDouble(565), numberToDouble(2436)), numberToDouble(45));
    var tmp_25 = to(tmp_24, tmp$ret$0_2);
    var tmp_26 = Companion_getInstance_9().i9i(Vector2D.a9k(780, 2045), Vector2D.a9k(1080, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_2 = new Circle_0(Vector2D.t9g(numberToDouble(930), numberToDouble(2436)), numberToDouble(45));
    var tmp_27 = to(tmp_26, tmp$ret$1_2);
    var tmp_28 = Companion_getInstance_9().i9i(Vector2D.a9k(1140, 2075), Vector2D.a9k(1444, 2388));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_2 = new Circle_0(Vector2D.t9g(numberToDouble(1290), numberToDouble(2436)), numberToDouble(45));
    akkeronUpgradesChoose = plus(tmp_23, listOf([tmp_25, tmp_27, to(tmp_28, tmp$ret$2_2)]));
    var tmp_29 = Companion_getInstance_9().i9i(Vector2D.a9k(115, 1430), Vector2D.a9k(490, 1755));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_3 = new Circle_0(Vector2D.t9g(numberToDouble(90), numberToDouble(1400)), numberToDouble(45));
    var tmp_30 = to(tmp_29, tmp$ret$0_3);
    var tmp_31 = Companion_getInstance_9().i9i(Vector2D.a9k(560, 1430), Vector2D.a9k(935, 1755));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_3 = new Circle_0(Vector2D.t9g(numberToDouble(750), numberToDouble(1490)), numberToDouble(45));
    var tmp_32 = to(tmp_31, tmp$ret$1_3);
    var tmp_33 = Companion_getInstance_9().i9i(Vector2D.a9k(1010, 1430), Vector2D.a9k(1384, 1755));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_3 = new Circle_0(Vector2D.t9g(numberToDouble(1415), numberToDouble(1400)), numberToDouble(45));
    var tmp_34 = to(tmp_33, tmp$ret$2_3);
    var tmp_35 = Companion_getInstance_9().i9i(Vector2D.a9k(415, 1850), Vector2D.a9k(715, 2190));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$3_0 = new Circle_0(Vector2D.t9g(numberToDouble(560), numberToDouble(2245)), numberToDouble(45));
    var tmp_36 = to(tmp_35, tmp$ret$3_0);
    var tmp_37 = Companion_getInstance_9().i9i(Vector2D.a9k(780, 1850), Vector2D.a9k(1080, 2190));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$4_0 = new Circle_0(Vector2D.t9g(numberToDouble(933), numberToDouble(2245)), numberToDouble(45));
    var tmp_38 = to(tmp_37, tmp$ret$4_0);
    var tmp_39 = Companion_getInstance_9().i9i(Vector2D.a9k(1140, 1875), Vector2D.a9k(1444, 2190));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$5_0 = new Circle_0(Vector2D.t9g(numberToDouble(1295), numberToDouble(2245)), numberToDouble(45));
    vackerUpgradesChoose = listOf([tmp_30, tmp_32, tmp_34, tmp_36, tmp_38, to(tmp_39, tmp$ret$5_0)]);
    var tmp_40 = Companion_getInstance_9().i9i(Vector2D.a9k(60, 1465), Vector2D.a9k(360, 1800));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_4 = new Circle_0(Vector2D.t9g(numberToDouble(220), numberToDouble(1840)), numberToDouble(45));
    var tmp_41 = to(tmp_40, tmp$ret$0_4);
    var tmp_42 = Companion_getInstance_9().i9i(Vector2D.a9k(416, 1465), Vector2D.a9k(716, 1800));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_4 = new Circle_0(Vector2D.t9g(numberToDouble(615), numberToDouble(1840)), numberToDouble(45));
    var tmp_43 = to(tmp_42, tmp$ret$1_4);
    var tmp_44 = Companion_getInstance_9().i9i(Vector2D.a9k(783, 1465), Vector2D.a9k(1083, 1800));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_4 = new Circle_0(Vector2D.t9g(numberToDouble(960), numberToDouble(1840)), numberToDouble(45));
    var tmp_45 = to(tmp_44, tmp$ret$2_4);
    var tmp_46 = Companion_getInstance_9().i9i(Vector2D.a9k(1144, 1465), Vector2D.a9k(1444, 1800));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$3_1 = new Circle_0(Vector2D.t9g(numberToDouble(1305), numberToDouble(1840)), numberToDouble(45));
    rhagnerUpgradesChoose = listOf([tmp_41, tmp_43, tmp_45, to(tmp_46, tmp$ret$3_1)]);
    var tmp_47 = Companion_getInstance_9().i9i(Vector2D.a9k(60, 1580), Vector2D.a9k(360, 1900));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_5 = new Circle_0(Vector2D.t9g(numberToDouble(220), numberToDouble(1960)), numberToDouble(45));
    var tmp_48 = to(tmp_47, tmp$ret$0_5);
    var tmp_49 = Companion_getInstance_9().i9i(Vector2D.a9k(416, 1580), Vector2D.a9k(716, 1900));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_5 = new Circle_0(Vector2D.t9g(numberToDouble(615), numberToDouble(1960)), numberToDouble(45));
    var tmp_50 = to(tmp_49, tmp$ret$1_5);
    var tmp_51 = Companion_getInstance_9().i9i(Vector2D.a9k(783, 1580), Vector2D.a9k(1083, 1900));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_5 = new Circle_0(Vector2D.t9g(numberToDouble(960), numberToDouble(1960)), numberToDouble(45));
    var tmp_52 = to(tmp_51, tmp$ret$2_5);
    var tmp_53 = Companion_getInstance_9().i9i(Vector2D.a9k(1144, 1580), Vector2D.a9k(1444, 1900));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$3_2 = new Circle_0(Vector2D.t9g(numberToDouble(1305), numberToDouble(1960)), numberToDouble(45));
    var tmp_54 = to(tmp_53, tmp$ret$3_2);
    var tmp_55 = Companion_getInstance_9().i9i(Vector2D.a9k(660, 2085), Vector2D.a9k(1025, 2410));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$4_1 = new Circle_0(Vector2D.t9g(numberToDouble(845), numberToDouble(2460)), numberToDouble(45));
    var tmp_56 = to(tmp_55, tmp$ret$4_1);
    var tmp_57 = Companion_getInstance_9().i9i(Vector2D.a9k(1080, 2085), Vector2D.a9k(1450, 2410));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$5_1 = new Circle_0(Vector2D.t9g(numberToDouble(1265), numberToDouble(2460)), numberToDouble(45));
    lydanUpgradesChoose = listOf([tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, to(tmp_57, tmp$ret$5_1)]);
    var tmp_58 = Companion_getInstance_9().i9i(Vector2D.a9k(100, 1630), Vector2D.a9k(500, 1970));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_6 = new Circle_0(Vector2D.t9g(numberToDouble(90), numberToDouble(1585)), numberToDouble(45));
    var tmp_59 = to(tmp_58, tmp$ret$0_6);
    var tmp_60 = Companion_getInstance_9().i9i(Vector2D.a9k(550, 1630), Vector2D.a9k(950, 1970));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_6 = new Circle_0(Vector2D.t9g(numberToDouble(750), numberToDouble(1680)), numberToDouble(45));
    var tmp_61 = to(tmp_60, tmp$ret$1_6);
    var tmp_62 = Companion_getInstance_9().i9i(Vector2D.a9k(1000, 1630), Vector2D.a9k(1400, 1970));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_6 = new Circle_0(Vector2D.t9g(numberToDouble(1410), numberToDouble(1585)), numberToDouble(45));
    var tmp_63 = to(tmp_62, tmp$ret$2_6);
    var tmp_64 = Companion_getInstance_9().i9i(Vector2D.a9k(770, 2050), Vector2D.a9k(1095, 2400));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$3_3 = new Circle_0(Vector2D.t9g(numberToDouble(930), numberToDouble(2435)), numberToDouble(45));
    var tmp_65 = to(tmp_64, tmp$ret$3_3);
    var tmp_66 = Companion_getInstance_9().i9i(Vector2D.a9k(1130, 2080), Vector2D.a9k(1455, 2400));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$4_2 = new Circle_0(Vector2D.t9g(numberToDouble(1290), numberToDouble(2435)), numberToDouble(45));
    ommaUpgradesChoose = listOf([tmp_59, tmp_61, tmp_63, tmp_65, to(tmp_66, tmp$ret$4_2)]);
    var tmp_67 = Companion_getInstance_9().i9i(Vector2D.a9k(60, 1835), Vector2D.a9k(360, 2160));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_7 = new Circle_0(Vector2D.t9g(numberToDouble(235), numberToDouble(2205)), numberToDouble(45));
    var tmp_68 = to(tmp_67, tmp$ret$0_7);
    var tmp_69 = Companion_getInstance_9().i9i(Vector2D.a9k(416, 1835), Vector2D.a9k(716, 2160));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$1_7 = new Circle_0(Vector2D.t9g(numberToDouble(615), numberToDouble(2205)), numberToDouble(45));
    var tmp_70 = to(tmp_69, tmp$ret$1_7);
    var tmp_71 = Companion_getInstance_9().i9i(Vector2D.a9k(783, 1835), Vector2D.a9k(1083, 2160));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$2_7 = new Circle_0(Vector2D.t9g(numberToDouble(960), numberToDouble(2205)), numberToDouble(45));
    var tmp_72 = to(tmp_71, tmp$ret$2_7);
    var tmp_73 = Companion_getInstance_9().i9i(Vector2D.a9k(1144, 1835), Vector2D.a9k(1444, 2160));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$3_4 = new Circle_0(Vector2D.t9g(numberToDouble(1305), numberToDouble(2205)), numberToDouble(45));
    urgullUpgradesChoose = listOf([tmp_68, tmp_70, tmp_72, to(tmp_73, tmp$ret$3_4)]);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = listOf([BloodLustUpgrade_getInstance(), EnragedUpgrade_getInstance(), GreatHowlUpgrade_getInstance(), HuntingGroundsUpgrade_getInstance(), KinsPursuitUpgrade_getInstance(), NaturalInstinctUpgrade_getInstance(), CullingUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$2_8 = to(item, get_sevenUpgradesChoose().u2(index_0));
      destination.d2(tmp$ret$2_8);
    }
    fangrirUiUpgrades = toMap(destination);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_1 = listOf([WrathOfEirtirUpgrade_getInstance(), LeviathanUpgrade_getInstance(), MendrsFuryUpgrade_getInstance(), DrownerUpgrade_getInstance(), TorrentialUpgrade_getInstance(), DevourerUpgrade_getInstance(), FatalGazeUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var index_1 = 0;
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var _unary__edvuaz_0 = index_1;
      index_1 = _unary__edvuaz_0 + 1 | 0;
      var index_2 = checkIndexOverflow(_unary__edvuaz_0);
      var tmp$ret$2_9 = to(item_0, get_sevenUpgradesChoose().u2(index_2));
      destination_0.d2(tmp$ret$2_9);
    }
    raagaUiUpgrades = toMap(destination_0);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_2 = listOf([EndlessStruggleUpgrade_getInstance(), AccursedWrathUpgrade_getInstance(), KillingsSpreeUpgrade_getInstance(), SinisterActUpgrade_getInstance(), MesmeriseUpgrade_getInstance(), TrueInstinctEsmeriaBeastUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_1 = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
    var index_3 = 0;
    var _iterator__ex2g4s_1 = this_2.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var item_1 = _iterator__ex2g4s_1.r1();
      var _unary__edvuaz_1 = index_3;
      index_3 = _unary__edvuaz_1 + 1 | 0;
      var index_4 = checkIndexOverflow(_unary__edvuaz_1);
      var tmp$ret$2_10 = to(item_1, get_sixBigBotUpgradesChoose().u2(index_4));
      destination_1.d2(tmp$ret$2_10);
    }
    esmeriaBeastUiUpgrades = toMap(destination_1);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_3 = listOf([DeathsLamentUpgrade_getInstance(), SoulHarvestUpgrade_getInstance(), PandemoniumUpgrade_getInstance(), SongOfTemptationUpgrade_getInstance(), VanishUpgrade_getInstance(), VoidPresenceUpgrade_getInstance(), FearTheNightUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_2 = ArrayList.n2(collectionSizeOrDefault(this_3, 10));
    var index_5 = 0;
    var _iterator__ex2g4s_2 = this_3.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var item_2 = _iterator__ex2g4s_2.r1();
      var _unary__edvuaz_2 = index_5;
      index_5 = _unary__edvuaz_2 + 1 | 0;
      var index_6 = checkIndexOverflow(_unary__edvuaz_2);
      var tmp$ret$2_11 = to(item_2, get_sevenUpgradesChoose().u2(index_6));
      destination_2.d2(tmp$ret$2_11);
    }
    maraUiUpgrades = toMap(destination_2);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_4 = listOf([RampageousUpgrade_getInstance(), InfernalTusksUpgrade_getInstance(), HordesMarchUpgrade_getInstance(), WildOdeUpgrade_getInstance(), ChiefsCommandUpgrade_getInstance(), PrimalInstinctsUpgrade_getInstance(), AmassUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_3 = ArrayList.n2(collectionSizeOrDefault(this_4, 10));
    var index_7 = 0;
    var _iterator__ex2g4s_3 = this_4.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var item_3 = _iterator__ex2g4s_3.r1();
      var _unary__edvuaz_3 = index_7;
      index_7 = _unary__edvuaz_3 + 1 | 0;
      var index_8 = checkIndexOverflow(_unary__edvuaz_3);
      var tmp$ret$2_12 = to(item_3, get_sevenUpgradesChoose().u2(index_8));
      destination_3.d2(tmp$ret$2_12);
    }
    hogbadUiUpgrades = toMap(destination_3);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_5 = listOf([MirrorBeastUpgrade_getInstance(), GoldenBeakUpgrade_getInstance(), SoulHarvestVackerUpgrade_getInstance(), SwiftKillUpgrade_getInstance(), EntrancingUpgrade_getInstance(), ReveranceUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_4 = ArrayList.n2(collectionSizeOrDefault(this_5, 10));
    var index_9 = 0;
    var _iterator__ex2g4s_4 = this_5.p1();
    while (_iterator__ex2g4s_4.q1()) {
      var item_4 = _iterator__ex2g4s_4.r1();
      var _unary__edvuaz_4 = index_9;
      index_9 = _unary__edvuaz_4 + 1 | 0;
      var index_10 = checkIndexOverflow(_unary__edvuaz_4);
      var tmp$ret$2_13 = to(item_4, get_vackerUpgradesChoose().u2(index_10));
      destination_4.d2(tmp$ret$2_13);
    }
    vackerUiUpgrades = toMap(destination_4);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_6 = listOf([CloudShiftUpgrade_getInstance(), BehornedUpgrade_getInstance(), StormBringerUpgrade_getInstance(), EruptionUpgrade_getInstance(), SuddenShockUpgrade_getInstance(), DischargeUpgrade_getInstance(), StarFallUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_5 = ArrayList.n2(collectionSizeOrDefault(this_6, 10));
    var index_11 = 0;
    var _iterator__ex2g4s_5 = this_6.p1();
    while (_iterator__ex2g4s_5.q1()) {
      var item_5 = _iterator__ex2g4s_5.r1();
      var _unary__edvuaz_5 = index_11;
      index_11 = _unary__edvuaz_5 + 1 | 0;
      var index_12 = checkIndexOverflow(_unary__edvuaz_5);
      var tmp$ret$2_14 = to(item_5, get_sevenUpgradesChoose().u2(index_12));
      destination_5.d2(tmp$ret$2_14);
    }
    thaldukUiUpgrades = toMap(destination_5);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_7 = listOf([VoidCallUpgrade_getInstance(), AbyssalBeastUpgrade_getInstance(), EchoUpgrade_getInstance(), EternityUpgrade_getInstance(), VoidStepUpgrade_getInstance(), DarkSpawnUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_6 = ArrayList.n2(collectionSizeOrDefault(this_7, 10));
    var index_13 = 0;
    var _iterator__ex2g4s_6 = this_7.p1();
    while (_iterator__ex2g4s_6.q1()) {
      var item_6 = _iterator__ex2g4s_6.r1();
      var _unary__edvuaz_6 = index_13;
      index_13 = _unary__edvuaz_6 + 1 | 0;
      var index_14 = checkIndexOverflow(_unary__edvuaz_6);
      var tmp$ret$2_15 = to(item_6, get_akkeronUpgradesChoose().u2(index_14));
      destination_6.d2(tmp$ret$2_15);
    }
    akkeronUiUpgrades = toMap(destination_6);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_8 = listOf([InfestationUpgrade_getInstance(), WitheringMawUpgrade_getInstance(), UnendingHungerUpgrade_getInstance(), BlightUpgrade_getInstance(), ExpandTheMarshUpgrade_getInstance(), LurkingDeadUpgrade_getInstance(), CascadeUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_7 = ArrayList.n2(collectionSizeOrDefault(this_8, 10));
    var index_15 = 0;
    var _iterator__ex2g4s_7 = this_8.p1();
    while (_iterator__ex2g4s_7.q1()) {
      var item_7 = _iterator__ex2g4s_7.r1();
      var _unary__edvuaz_7 = index_15;
      index_15 = _unary__edvuaz_7 + 1 | 0;
      var index_16 = checkIndexOverflow(_unary__edvuaz_7);
      var tmp$ret$2_16 = to(item_7, get_sevenUpgradesChoose().u2(index_16));
      destination_7.d2(tmp$ret$2_16);
    }
    bolginUiUpgrades = toMap(destination_7);
    var tmp_74 = ResurrectionUpgrade_getInstance();
    var tmp_75 = Companion_getInstance_9().i9i(Vector2D.a9k(120, 2070), Vector2D.a9k(1385, 2395));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    var tmp$ret$0_8 = new Circle_0(Vector2D.t9g(numberToDouble(750), numberToDouble(2425)), numberToDouble(45));
    featheredKingUnbornUiUpgrades = mapOf(to(tmp_74, to(tmp_75, tmp$ret$0_8)));
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_9 = listOf([OverlordUpgrade_getInstance(), RegalUpgrade_getInstance(), ProminenceUpgrade_getInstance(), EndlessDreamUpgrade_getInstance(), WorshipUpgrade_getInstance(), MartyrUpgrade_getInstance(), SoulCollectorUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_8 = ArrayList.n2(collectionSizeOrDefault(this_9, 10));
    var index_17 = 0;
    var _iterator__ex2g4s_8 = this_9.p1();
    while (_iterator__ex2g4s_8.q1()) {
      var item_8 = _iterator__ex2g4s_8.r1();
      var _unary__edvuaz_8 = index_17;
      index_17 = _unary__edvuaz_8 + 1 | 0;
      var index_18 = checkIndexOverflow(_unary__edvuaz_8);
      var tmp$ret$2_17 = to(item_8, get_sevenUpgradesChoose().u2(index_18));
      destination_8.d2(tmp$ret$2_17);
    }
    featheredKingRebornUiUpgrades = toMap(destination_8);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_10 = listOf([AbyssalHellFireUpgrade_getInstance(), BurnUpgrade_getInstance(), DraconicBondsUpgrade_getInstance(), AngerUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_9 = ArrayList.n2(collectionSizeOrDefault(this_10, 10));
    var index_19 = 0;
    var _iterator__ex2g4s_9 = this_10.p1();
    while (_iterator__ex2g4s_9.q1()) {
      var item_9 = _iterator__ex2g4s_9.r1();
      var _unary__edvuaz_9 = index_19;
      index_19 = _unary__edvuaz_9 + 1 | 0;
      var index_20 = checkIndexOverflow(_unary__edvuaz_9);
      var tmp$ret$2_18 = to(item_9, get_rhagnerUpgradesChoose().u2(index_20));
      destination_9.d2(tmp$ret$2_18);
    }
    rhagnerUiUpgrades = toMap(destination_9);
    rhagnerBoardHoardPlacing = mapOf_0([to(IncinerateCard_getInstance(), listOf([Vector2D.a9k(230, 2055), Vector2D.a9k(230, 2340)])), to(RiseCard_getInstance(), listOf([Vector2D.a9k(580, 2055), Vector2D.a9k(580, 2340)])), to(ScorchedEarthCard_getInstance(), listOf([Vector2D.a9k(930, 2055), Vector2D.a9k(930, 2340)])), to(SummonLindwyrmCard_getInstance(), listOf([Vector2D.a9k(1285, 2055), Vector2D.a9k(1285, 2340)]))]);
    rhagnerBoardHoardGrudgeDiametr = 260;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_11 = listOf([BeyondTheVeilUpgrade_getInstance(), AbundanceUpgrade_getInstance(), ReuniteUpgrade_getInstance(), DoomCallUpgrade_getInstance(), FleshboundUpgrade_getInstance(), SpiritboundUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_10 = ArrayList.n2(collectionSizeOrDefault(this_11, 10));
    var index_21 = 0;
    var _iterator__ex2g4s_10 = this_11.p1();
    while (_iterator__ex2g4s_10.q1()) {
      var item_10 = _iterator__ex2g4s_10.r1();
      var _unary__edvuaz_10 = index_21;
      index_21 = _unary__edvuaz_10 + 1 | 0;
      var index_22 = checkIndexOverflow(_unary__edvuaz_10);
      var tmp$ret$2_19 = to(item_10, get_lydanUpgradesChoose().u2(index_22));
      destination_10.d2(tmp$ret$2_19);
    }
    lydanUiUpgrades = toMap(destination_10);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_12 = listOf([DistractionUpgrade_getInstance(), DoubleUpgrade_getInstance(), ThickMistUpgrade_getInstance(), NightbindUpgrade_getInstance(), CursedLandUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_11 = ArrayList.n2(collectionSizeOrDefault(this_12, 10));
    var index_23 = 0;
    var _iterator__ex2g4s_11 = this_12.p1();
    while (_iterator__ex2g4s_11.q1()) {
      var item_11 = _iterator__ex2g4s_11.r1();
      var _unary__edvuaz_11 = index_23;
      index_23 = _unary__edvuaz_11 + 1 | 0;
      var index_24 = checkIndexOverflow(_unary__edvuaz_11);
      var tmp$ret$2_20 = to(item_11, get_ommaUpgradesChoose().u2(index_24));
      destination_11.d2(tmp$ret$2_20);
    }
    ommaUiUpgrades = toMap(destination_11);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_13 = listOf([BroodswellUpgrade_getInstance(), RuptureSeedsUpgrade_getInstance(), InfestUrgullUpgrade_getInstance(), LairUpgrade_getInstance()]);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_12 = ArrayList.n2(collectionSizeOrDefault(this_13, 10));
    var index_25 = 0;
    var _iterator__ex2g4s_12 = this_13.p1();
    while (_iterator__ex2g4s_12.q1()) {
      var item_12 = _iterator__ex2g4s_12.r1();
      var _unary__edvuaz_12 = index_25;
      index_25 = _unary__edvuaz_12 + 1 | 0;
      var index_26 = checkIndexOverflow(_unary__edvuaz_12);
      var tmp$ret$2_21 = to(item_12, get_urgullUpgradesChoose().u2(index_26));
      destination_12.d2(tmp$ret$2_21);
    }
    urgullUiUpgrades = toMap(destination_12);
    urgullBoardFirstEagPlacing = Vector2D.a9k(154, 1463);
    urgullBoardEagDistance = 196;
    urgullBoardEagHeight = 125;
    huntersUpgradeOrder = mapOf_0([to(Assar_getInstance(), listOf([ResonanceUpgrade_getInstance(), ExceptionalTrackerUpgrade_getInstance(), SeekerUpgrade_getInstance(), ExploreUpgrade_getInstance()])), to(Varja_getInstance(), listOf([HornOfValhUpgrade_getInstance(), HuntersBaneUpgrade_getInstance(), HeroicSpeechUpgrade_getInstance(), TacticalManouverUpgrade_getInstance()])), to(Iona_getInstance(), listOf([JointEffortUpgrade_getInstance(), BallistaUpgrade_getInstance(), CrepuscularUpgrade_getInstance(), AncientCallingUpgrade_getInstance()])), to(Helga_getInstance(), listOf([TormentingVisionsUpgrade_getInstance(), SoothsayerUpgrade_getInstance(), ClairvoyantUpgrade_getInstance(), AncientBondUpgrade_getInstance()])), to(Grimgeir_getInstance(), listOf([WatchtowerPassageUpgrade_getInstance(), RefugeUpgrade_getInstance(), TownswatchUpgrade_getInstance(), DefenderUpgrade_getInstance()])), to(Krim_getInstance(), listOf([ScavengerUpgrade_getInstance(), TrapLauncherUpgrade_getInstance(), PortableWorkshopUpgrade_getInstance(), ResourcefulnessUpgrade_getInstance()])), to(Fara_getInstance(), listOf([IgniteUpgrade_getInstance(), FlingUpgrade_getInstance(), DarkFlameUpgrade_getInstance(), RebirthByFireUpgrade_getInstance()])), to(Valdi_getInstance(), listOf([InfusionUpgrade_getInstance(), BloodCraftUpgrade_getInstance(), DissectionUpgrade_getInstance(), ExtractUpgrade_getInstance()])), to(Eivind_getInstance(), listOf([SkyMasterUpgrade_getInstance(), RopePullUpgrade_getInstance(), ReachUpgrade_getInstance()])), to(EsmeriaHuntress_getInstance(), listOf([HuntmasterUpgrade_getInstance(), BlackStarUpgrade_getInstance(), PredictUpgrade_getInstance(), TrueInstinctEsmeriaHuntressUpgrade_getInstance()])), to(Nora_getInstance(), listOf([AwarenessUpgrade_getInstance(), RevengeOfTheSheepUpgrade_getInstance(), WildbondUpgrade_getInstance(), BeastTongueUpgrade_getInstance()])), to(Bram_getInstance(), listOf([AbruptAssembleUpgrade_getInstance(), MassProductionUpgrade_getInstance(), LivingBlockadeUpgrade_getInstance(), TacticalInsightUpgrade_getInstance()])), to(Draug_getInstance(), listOf([BloodlessFuryUpgrade_getInstance(), PalebloodAxesUpgrade_getInstance(), SharedMadnessUpgrade_getInstance()])), to(Sigrid_getInstance(), listOf([EcholocationUpgrade_getInstance(), SwapUpgrade_getInstance(), PactReversalUpgrade_getInstance()]))]);
  }
}
function get_shatteredIslesRuinInfoX() {
  _init_properties_UiContractBoardPlacing_kt__1m937g();
  return shatteredIslesRuinInfoX;
}
var shatteredIslesRuinInfoX;
function get_yForShatteredIslesRuinInfo() {
  _init_properties_UiContractBoardPlacing_kt__1m937g();
  return yForShatteredIslesRuinInfo;
}
var yForShatteredIslesRuinInfo;
function get_shatteredIslesRuinInfoWidth() {
  _init_properties_UiContractBoardPlacing_kt__1m937g();
  return shatteredIslesRuinInfoWidth;
}
var shatteredIslesRuinInfoWidth;
function shatteredIslesRuinInfoRect(gameMapId, ruinPosition) {
  _init_properties_UiContractBoardPlacing_kt__1m937g();
  var tmp;
  switch (gameMapId.w1_1) {
    case 3:
      var tmp_0;
      if (ruinPosition === LowerShatteredRuins_getInstance().x5m_1) {
        tmp_0 = 0;
      } else if (ruinPosition === LowerShatteredRuins_getInstance().y5m_1) {
        tmp_0 = 1;
      } else if (ruinPosition === LowerShatteredRuins_getInstance().z5m_1) {
        tmp_0 = 2;
      } else {
        return null;
      }

      tmp = tmp_0;
      break;
    case 2:
      var tmp_1;
      if (ruinPosition === UpperShatteredRuins_getInstance().j6a_1) {
        tmp_1 = 0;
      } else if (ruinPosition === UpperShatteredRuins_getInstance().k6a_1) {
        tmp_1 = 1;
      } else if (ruinPosition === UpperShatteredRuins_getInstance().l6a_1) {
        tmp_1 = 2;
      } else {
        return null;
      }

      tmp = tmp_1;
      break;
    default:
      return null;
  }
  var index = tmp;
  return shatteredIslesRuinInfoRect_0(index);
}
function shatteredIslesRuinInfoRect_0(index) {
  _init_properties_UiContractBoardPlacing_kt__1m937g();
  var x = get_shatteredIslesRuinInfoX().u2(index);
  return RectangleInt.s9q(x, get_yForShatteredIslesRuinInfo(), get_shatteredIslesRuinInfoWidth(), 3000 - get_yForShatteredIslesRuinInfo() | 0);
}
var properties_initialized_UiContractBoardPlacing_kt_qzjv16;
function _init_properties_UiContractBoardPlacing_kt__1m937g() {
  if (!properties_initialized_UiContractBoardPlacing_kt_qzjv16) {
    properties_initialized_UiContractBoardPlacing_kt_qzjv16 = true;
    shatteredIslesRuinInfoX = listOf([55, 515, 980]);
    yForShatteredIslesRuinInfo = 2405;
    shatteredIslesRuinInfoWidth = 455;
  }
}
function get_noneLocation() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return noneLocation;
}
var noneLocation;
function get_northernExpanseLocations() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return northernExpanseLocations;
}
var northernExpanseLocations;
function get_drenchedLandsLocations() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return drenchedLandsLocations;
}
var drenchedLandsLocations;
function get_upperShatteredLocations() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return upperShatteredLocations;
}
var upperShatteredLocations;
function get_lowerShatteredLocations() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return lowerShatteredLocations;
}
var lowerShatteredLocations;
function get_northernExpanseUiPlacing() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return northernExpanseUiPlacing;
}
var northernExpanseUiPlacing;
function get_drenchedLandsUiPlacing() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return drenchedLandsUiPlacing;
}
var drenchedLandsUiPlacing;
function get_upperShatteredUiPlacing() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return upperShatteredUiPlacing;
}
var upperShatteredUiPlacing;
function get_lowerShatteredUiPlacing() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return lowerShatteredUiPlacing;
}
var lowerShatteredUiPlacing;
function get_northernExpanseLogicalAndUiMapping() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return northernExpanseLogicalAndUiMapping;
}
var northernExpanseLogicalAndUiMapping;
function get_drenchedLandsLogicalAndUiMapping() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return drenchedLandsLogicalAndUiMapping;
}
var drenchedLandsLogicalAndUiMapping;
function get_upperShatteredLogicalAndUiMapping() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return upperShatteredLogicalAndUiMapping;
}
var upperShatteredLogicalAndUiMapping;
function get_lowerShatteredLogicalAndUiMapping() {
  _init_properties_UiMapPlacing_kt__a03srg();
  return lowerShatteredLogicalAndUiMapping;
}
var lowerShatteredLogicalAndUiMapping;
function createLogicalAndUiMapping(logicalMap, placing) {
  _init_properties_UiMapPlacing_kt__a03srg();
  var i = 0;
  var inductionVariable = _BoardPosition___get_y__impl__tale2e(logicalMap.n44_1);
  var last = _BoardPosition___get_y__impl__tale2e(logicalMap.o44_1);
  if (inductionVariable <= last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = _BoardPosition___get_x__impl__gyx07(logicalMap.n44_1);
      var last_0 = _BoardPosition___get_x__impl__gyx07(logicalMap.o44_1);
      if (inductionVariable_0 <= last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var position = _BoardPosition___init__impl__1nizgq(x, y);
          var point = placing.dlo_1.u2(i);
          // Inline function 'kotlin.require' call
          if (!(point == null === (logicalMap.p44_1.w4(new BoardPosition(position)) == null))) {
            var message = 'point = ' + toString_0(point) + ', logicalMap.locationsInit[position] = ' + toString_0(logicalMap.p44_1.w4(new BoardPosition(position)));
            throw IllegalArgumentException.h2(toString(message));
          }
          i = i + 1 | 0;
        }
         while (!(x === last_0));
    }
     while (!(y === last));
  return new MapLogicalAndUiMappingImpl(logicalMap, placing);
}
var LocationUiType_commonLocation_instance;
var LocationUiType_townLocation_instance;
var LocationUiType_centerLocation_instance;
var LocationUiType_entriesInitialized;
function LocationUiType_initEntries() {
  if (LocationUiType_entriesInitialized)
    return Unit_instance;
  LocationUiType_entriesInitialized = true;
  LocationUiType_commonLocation_instance = new LocationUiType('commonLocation', 0);
  LocationUiType_townLocation_instance = new LocationUiType('townLocation', 1);
  LocationUiType_centerLocation_instance = new LocationUiType('centerLocation', 2);
}
var MapFormat_OriginalMap_instance;
var MapFormat_ShortMap_instance;
var MapFormat_PreviewMap_instance;
var MapFormat_entriesInitialized;
function MapFormat_initEntries() {
  if (MapFormat_entriesInitialized)
    return Unit_instance;
  MapFormat_entriesInitialized = true;
  MapFormat_OriginalMap_instance = new MapFormat('OriginalMap', 0);
  MapFormat_ShortMap_instance = new MapFormat('ShortMap', 1);
  MapFormat_PreviewMap_instance = new MapFormat('PreviewMap', 2);
}
function requiredMapFormat(gameRules) {
  _init_properties_UiMapPlacing_kt__a03srg();
  if (gameRules.j3a() === 2)
    return MapFormat_ShortMap_getInstance();
  return MapFormat_OriginalMap_getInstance();
}
function getMapLogicalAndUiMapping(gameMapId) {
  _init_properties_UiMapPlacing_kt__a03srg();
  var tmp;
  switch (gameMapId.w1_1) {
    case 0:
      tmp = get_northernExpanseLogicalAndUiMapping();
      break;
    case 1:
      tmp = get_drenchedLandsLogicalAndUiMapping();
      break;
    case 2:
      tmp = get_upperShatteredLogicalAndUiMapping();
      break;
    case 3:
      tmp = get_lowerShatteredLogicalAndUiMapping();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function LocationUiType_commonLocation_getInstance() {
  LocationUiType_initEntries();
  return LocationUiType_commonLocation_instance;
}
function LocationUiType_townLocation_getInstance() {
  LocationUiType_initEntries();
  return LocationUiType_townLocation_instance;
}
function LocationUiType_centerLocation_getInstance() {
  LocationUiType_initEntries();
  return LocationUiType_centerLocation_instance;
}
function MapFormat_OriginalMap_getInstance() {
  MapFormat_initEntries();
  return MapFormat_OriginalMap_instance;
}
function MapFormat_ShortMap_getInstance() {
  MapFormat_initEntries();
  return MapFormat_ShortMap_instance;
}
function MapFormat_PreviewMap_getInstance() {
  MapFormat_initEntries();
  return MapFormat_PreviewMap_instance;
}
var properties_initialized_UiMapPlacing_kt_z0kbge;
function _init_properties_UiMapPlacing_kt__a03srg() {
  if (!properties_initialized_UiMapPlacing_kt_z0kbge) {
    properties_initialized_UiMapPlacing_kt_z0kbge = true;
    noneLocation = null;
    // Inline function 'kotlin.collections.map' call
    var this_0 = listOf([to(847, 472), to(1566, 482), to(2107, 390), to(2653, 357), to(3249, 360), get_noneLocation(), to(4817, 388), to(5424, 428), to(6022, 488), to(6666, 458), to(7196, 489), to(923, 964), to(1345, 1032), to(2076, 952), to(2666, 918), to(3406, 855), to(4123, 837), to(4749, 837), to(5232, 918), to(6005, 955), to(6639, 967), to(7234, 962), to(868, 1523), to(1315, 1544), to(1979, 1639), to(2822, 1631), to(3493, 1478), to(4147, 1459), to(4622, 1415), to(5183, 1447), to(5841, 1628), to(6500, 1765), to(7140, 1723), to(872, 2232), to(1402, 2257), to(2016, 2269), to(2952, 2200), to(3540, 2083), to(4061, 2018), to(4619, 2114), to(5177, 2061), to(5760, 2369), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), to(3466, 2656), to(4154, 2573), to(4700, 2609), to(5123, 2565), get_noneLocation(), to(6475, 2304), to(6989, 2305), to(940, 2952), to(1443, 2950), to(2065, 3043), to(2669, 3009), to(3414, 3178), to(4138, 3156), to(4724, 3184), to(5312, 3032), to(6032, 3120), to(6667, 3112), to(7171, 3065), to(930, 3511), to(1504, 3438), to(2064, 3637), to(2697, 3693), to(3489, 3699), to(4123, 3706), to(4728, 3664), to(5334, 3677), to(6028, 3555), to(6672, 3647), to(7181, 3666), to(925, 4258), to(1527, 4142), to(2169, 4191), to(2719, 4363), to(3469, 4286), get_noneLocation(), to(4787, 4286), to(5294, 4348), to(6000, 4208), to(6650, 4266), to(7184, 4264), to(946, 4809), to(1568, 4774), to(2264, 4795), to(2846, 4842), to(3621, 4786), get_noneLocation(), to(4784, 4779), to(5392, 4778), to(6028, 4740), to(6633, 4784), to(7178, 4740)]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp;
      if (item == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = Vector2D.a9k(item.pm_1, item.qm_1);
      }
      var tmp$ret$2 = tmp;
      destination.d2(tmp$ret$2);
    }
    northernExpanseLocations = destination;
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf([to(892, 1383), to(1343, 1362), to(2041, 1396), to(2646, 1520), to(3223, 1460), get_noneLocation(), to(4813, 1550), to(5417, 1586), to(6018, 1432), to(6657, 1620), to(7276, 1551), to(862, 1794), to(1418, 1984), to(2068, 2118), to(2660, 2082), to(3403, 2019), to(4121, 1997), to(4741, 2002), to(5225, 2083), to(5980, 2117), to(6633, 2129), to(7227, 2126), to(872, 2563), to(1311, 2707), to(1972, 2801), to(2817, 2795), to(3486, 2640), to(4141, 2623), to(4616, 2579), to(5177, 2607), to(5845, 2754), to(6495, 2928), to(7134, 2886), to(860, 3027), to(1343, 3411), to(2019, 3425), to(2946, 3359), to(3533, 3246), to(4056, 3180), to(4613, 3278), to(5170, 3222), to(5756, 3532), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), to(3460, 3819), to(4150, 3736), to(4692, 3771), to(5118, 3726), get_noneLocation(), get_noneLocation(), get_noneLocation()]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var tmp_0;
      if (item_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Vector2D.a9k(item_0.pm_1, item_0.qm_1);
      }
      var tmp$ret$2_0 = tmp_0;
      destination_0.d2(tmp$ret$2_0);
    }
    drenchedLandsLocations = destination_0;
    // Inline function 'kotlin.collections.map' call
    var this_2 = listOf([get_noneLocation(), to(2367, 482), to(3176, 641), get_noneLocation(), get_noneLocation(), get_noneLocation(), to(1555, 985), to(2362, 1017), to(3215, 1066), get_noneLocation(), to(4074, 929), to(5153, 817), to(1596, 1582), to(2269, 1593), to(3271, 1572), get_noneLocation(), to(4289, 1521), to(5309, 1340), to(1558, 2166), to(2229, 2080), to(3152, 2122), get_noneLocation(), to(4252, 2215), to(5386, 2303), get_noneLocation(), to(2239, 2651), to(3088, 2629), get_noneLocation(), get_noneLocation(), get_noneLocation(), to(1486, 3049), to(2201, 3208), to(3038, 3144), to(3794, 3044), to(4570, 3029), to(5888, 3118), to(1456, 3664), to(2240, 3889), to(2968, 3661), to(3755, 3619), to(4621, 3761), to(5651, 3725), to(1780, 4328), to(2370, 4517), to(2998, 4320), to(3802, 4327), to(4532, 4479), get_noneLocation()]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_1 = this_2.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var item_1 = _iterator__ex2g4s_1.r1();
      var tmp_1;
      if (item_1 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = Vector2D.a9k(item_1.pm_1, item_1.qm_1);
      }
      var tmp$ret$2_1 = tmp_1;
      destination_1.d2(tmp$ret$2_1);
    }
    upperShatteredLocations = destination_1;
    // Inline function 'kotlin.collections.map' call
    var this_3 = listOf([to(1513, 579), to(2230, 741), get_noneLocation(), to(3079, 650), to(3822, 575), to(4599, 564), to(5923, 639), get_noneLocation(), get_noneLocation(), to(1560, 1207), to(2268, 1420), get_noneLocation(), to(2998, 1238), to(3783, 1152), to(4563, 1319), to(5636, 1327), get_noneLocation(), get_noneLocation(), to(1808, 1859), to(2385, 2033), get_noneLocation(), to(3017, 1843), to(3831, 1859), to(4555, 1989), to(5498, 1977), get_noneLocation(), get_noneLocation(), to(1681, 2304), to(2319, 2503), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), to(1547, 2724), to(2239, 2885), to(2807, 2747), to(3277, 2597), to(3885, 2620), to(4560, 2578), to(5353, 2570), get_noneLocation(), get_noneLocation(), to(1377, 3354), to(2120, 3384), to(2755, 3309), to(3339, 3261), to(3914, 3227), to(4620, 3188), to(5490, 3140), to(6403, 3161), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), get_noneLocation(), to(3934, 3691), to(4660, 3705), to(5466, 3715), to(6353, 3722), to(6978, 3758), to(1450, 3891), to(2095, 3964), to(2635, 3986), to(3316, 4045), to(3988, 4156), to(4627, 4135), to(5489, 4181), to(6348, 4165), get_noneLocation(), get_noneLocation(), to(2011, 4601), to(2645, 4600), to(3268, 4584), to(3946, 4624), to(4648, 4588), to(5421, 4678), get_noneLocation(), get_noneLocation()]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.n2(collectionSizeOrDefault(this_3, 10));
    var _iterator__ex2g4s_2 = this_3.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var item_2 = _iterator__ex2g4s_2.r1();
      var tmp_2;
      if (item_2 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = Vector2D.a9k(item_2.pm_1, item_2.qm_1);
      }
      var tmp$ret$2_2 = tmp_2;
      destination_2.d2(tmp$ret$2_2);
    }
    lowerShatteredLocations = destination_2;
    northernExpanseUiPlacing = new BeastMapUiPlacing(276, 573, 414, get_northernExpanseLocations(), listOf_0(Vector2D.a9k(7481, 3219)), 585, Size2D.l9i(743, 183), mapOf_0([to(Zone_Barum_getInstance(), Vector2D.a9k(1532, 0)), to(Zone_Vildmark_getInstance(), Vector2D.a9k(5920, 0)), to(Zone_Jarlland_getInstance(), Vector2D.a9k(5920, 5223)), to(Zone_NewElda_getInstance(), Vector2D.a9k(1532, 5223))]));
    drenchedLandsUiPlacing = new BeastMapUiPlacing(282, 573, 414, get_drenchedLandsLocations(), listOf_0(Vector2D.a9k(7481, 3219)), 585, Size2D.l9i(743, 183), mapOf_0([to(Zone_Barum_getInstance(), Vector2D.a9k(1532, 0)), to(Zone_Vildmark_getInstance(), Vector2D.a9k(5920, 0))]));
    upperShatteredUiPlacing = new BeastMapUiPlacing(273, 505, 414, get_upperShatteredLocations(), listOf([Vector2D.a9k(7481, 3257), Vector2D.a9k(92, 3256)]), 560, Size2D.l9i(743, 183), mapOf_0([to(Zone_Thealis_getInstance(), Vector2D.a9k(5920, 0)), to(Zone_Achur_getInstance(), Vector2D.a9k(1532, 5223))]));
    lowerShatteredUiPlacing = new BeastMapUiPlacing(273, 497, 414, get_lowerShatteredLocations(), listOf([Vector2D.a9k(7481, 3257), Vector2D.a9k(92, 3256)]), 560, Size2D.l9i(743, 183), mapOf_0([to(Zone_Achur_getInstance(), Vector2D.a9k(5920, 0)), to(Zone_Elysur_getInstance(), Vector2D.a9k(1810, 5223)), to(Zone_Myrna_getInstance(), Vector2D.a9k(5920, 5223))]));
    northernExpanseLogicalAndUiMapping = createLogicalAndUiMapping(get_northernExpanseMap(), get_northernExpanseUiPlacing());
    drenchedLandsLogicalAndUiMapping = createLogicalAndUiMapping(get_drenchedLandsMap(), get_drenchedLandsUiPlacing());
    upperShatteredLogicalAndUiMapping = createLogicalAndUiMapping(get_upperShatteredIslesMap(), get_upperShatteredUiPlacing());
    lowerShatteredLogicalAndUiMapping = createLogicalAndUiMapping(get_lowerShatteredIslesMap(), get_lowerShatteredUiPlacing());
  }
}
function UserInfoView$slambda$slambda($avatarUrl) {
  return constructCallableReference(function *($this$withTimeout, $completion) {
    // Inline function 'kotlin.requireNotNull' call
    var tmp0 = $avatarUrl;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalArgumentException.h2(toString(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var tmp$ret$0 = tmp$ret$1;
    return yield* readBitmap(openAsync(yield* UrlVfs(tmp$ret$0).rbh($completion)), VOID, $completion);
  }, 1);
}
function UserInfoView$slambda($view, $avatarSize, $avatarUrl) {
  return constructCallableReference(function *($this$launch, $completion) {
    try {
      var tmp = new Long(5000, 0);
      var bitmap = yield* withTimeout(tmp, UserInfoView$slambda$slambda($avatarUrl), $completion);
      // Inline function 'korlibs.korge.view.image' call
      var this_0 = $view;
      var anchor = Companion_getInstance_7().c9g_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = Image.lk7(bitmap, anchor);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'kotlin.apply' call
      this_2.oig($avatarSize);
      this_2.qig($avatarSize);
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var cancelled = $p;
        if (!(cancelled instanceof TimeoutCancellationException))
          throw cancelled;
        println('Avatar image loading timed out: ' + $avatarUrl);
      } else {
        if ($p instanceof Exception) {
          var error = $p;
          println('Avatar image loading failed: ' + $avatarUrl + ' (' + error.message + ')');
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }, 1);
}
function createUserSettingsPanel(serverDrivenConfiguration, runUpdate, onReload, onBack) {
  var tmp;
  if (runUpdate === VOID) {
    tmp = createUserSettingsPanel$slambda();
  } else {
    tmp = runUpdate;
  }
  runUpdate = tmp;
  var controlPanelY = new ButtonColumn();
  var tmp_0 = (get_gameConfiguration().olc_1 ? '[ ]' : '[x]') + ' Animations';
  addTo_0(ActionButton.vlb(tmp_0, VOID, VOID, VOID, VOID, VOID, createUserSettingsPanel$slambda_0(runUpdate, serverDrivenConfiguration, onReload)), controlPanelY);
  var tmp_1 = (get_gameConfiguration().plc_1 ? '[x]' : '[ ]') + ' Always play precisely';
  addTo_0(ActionButton.vlb(tmp_1, VOID, VOID, VOID, VOID, VOID, createUserSettingsPanel$slambda_1(runUpdate, serverDrivenConfiguration, onReload)), controlPanelY);
  addTo_0(ActionButton.vlb('Reset settings', VOID, VOID, VOID, VOID, VOID, createUserSettingsPanel$slambda_2(runUpdate, serverDrivenConfiguration, onReload)), controlPanelY);
  addTo_0(ActionButton.vlb('Back', VOID, VOID, VOID, VOID, VOID, createUserSettingsPanel$slambda_3(onBack)), controlPanelY);
  return controlPanelY.xlb_1;
}
function createUserSettingsPanel$slambda() {
  return constructCallableReference(function *(it, $completion) {
    yield* it($completion);
    return Unit_instance;
  }, 1);
}
function createUserSettingsPanel$slambda$slambda($serverDrivenConfiguration, $onReload) {
  return constructCallableReference(function *($completion) {
    var updated = (yield* $serverDrivenConfiguration.y6k(BeastUserSettings_getInstance().g6v_1.f6v(get_gameConfiguration().olc_1), $completion)).o6u_1;
    set_gameConfiguration(withUserSettings(get_gameConfiguration(), updated));
    yield* $onReload($completion);
    return Unit_instance;
  }, 0);
}
function createUserSettingsPanel$slambda_0($runUpdate, $serverDrivenConfiguration, $onReload) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $runUpdate(createUserSettingsPanel$slambda$slambda($serverDrivenConfiguration, $onReload), $completion);
    return Unit_instance;
  }, 1);
}
function createUserSettingsPanel$slambda$slambda_0($serverDrivenConfiguration, $onReload) {
  return constructCallableReference(function *($completion) {
    var updated = (yield* $serverDrivenConfiguration.y6k(BeastUserSettings_getInstance().h6v_1.f6v(!get_gameConfiguration().plc_1), $completion)).o6u_1;
    set_gameConfiguration(withUserSettings(get_gameConfiguration(), updated));
    yield* $onReload($completion);
    return Unit_instance;
  }, 0);
}
function createUserSettingsPanel$slambda_1($runUpdate, $serverDrivenConfiguration, $onReload) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $runUpdate(createUserSettingsPanel$slambda$slambda_0($serverDrivenConfiguration, $onReload), $completion);
    return Unit_instance;
  }, 1);
}
function createUserSettingsPanel$slambda$slambda_1($serverDrivenConfiguration, $onReload) {
  return constructCallableReference(function *($completion) {
    var updated = (yield* $serverDrivenConfiguration.z6k($completion)).o6u_1;
    set_gameConfiguration(withUserSettings(get_gameConfiguration(), updated));
    yield* $onReload($completion);
    return Unit_instance;
  }, 0);
}
function createUserSettingsPanel$slambda_2($runUpdate, $serverDrivenConfiguration, $onReload) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $runUpdate(createUserSettingsPanel$slambda$slambda_1($serverDrivenConfiguration, $onReload), $completion);
    return Unit_instance;
  }, 1);
}
function createUserSettingsPanel$slambda_3($onBack) {
  return constructCallableReference(function *($this$ActionButton, $completion) {
    yield* $onBack($completion);
    return Unit_instance;
  }, 1);
}
function ActionButton$_init_$slambda_iro9fo($textAndAction, $common) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* $textAndAction.tmp_1($completion);
    yield* $common($completion);
    return Unit_instance;
  }, 1);
}
function ActionButton$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if (this$0.tlb_1) {
      this$0.pl8(true);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function ActionButton$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function ActionButton$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, ActionButton$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function ActionButton$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.pl8(false);
    return Unit_instance;
  }, 1);
}
function ActionButton$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function ActionButton$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, ActionButton$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function ActionButton$slambda_1(this$0, $onActionInvoked, $onRightClick) {
  return constructCallableReference(function *(it, $completion) {
    switch (it.xhy().w1_1) {
      case 0:
        if (this$0.tlb_1)
          yield* $onActionInvoked(this$0, $completion);
        break;
      case 2:
        var tmp1_safe_receiver = $onRightClick;
        if (tmp1_safe_receiver == null)
          null;
        else
          yield* tmp1_safe_receiver($completion);
        break;
      default:
        break;
    }
    return Unit_instance;
  }, 1);
}
function ActionButton$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function ActionButton$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, ActionButton$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function ActionButton$lambda_2($this$addUpdater, dt) {
  var target = $this$addUpdater.tlb_1 && $this$addUpdater.ulb_1 ? 1.0 : 0.0;
  var progress = $this$addUpdater.rlb_1.wmt_1;
  if (!(progress === target)) {
    // Inline function 'kotlin.Long.div' call
    var this_0 = _Duration___get_inWholeNanoseconds__impl__r5x4mr(dt.ik_1);
    var tmp$ret$0 = toNumber(this_0) / 8.0E7;
    var step = coerceIn(tmp$ret$0, 0.0, 1.0);
    var tmp = $this$addUpdater.rlb_1;
    var tmp_0;
    if (target > progress) {
      // Inline function 'kotlin.comparisons.minOf' call
      var b = progress + step;
      tmp_0 = Math.min(target, b);
    } else {
      // Inline function 'kotlin.comparisons.maxOf' call
      var b_0 = progress - step;
      tmp_0 = Math.max(target, b_0);
    }
    tmp.wmt_1 = tmp_0;
    $this$addUpdater.ql8();
  }
  return Unit_instance;
}
function addClickOption(_this__u8e3s4, onClick) {
  _this__u8e3s4.sig(_this__u8e3s4.ym4());
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  var $this$mouse = get_mouse(_this__u8e3s4);
  // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
  var handler = addClickOption$slambda(onClick);
  var tmp = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_0 = getPropertyCallableRef('click', 1, tmp, MouseEvents$_get_click_$ref_klwzrm(), null).get($this$mouse);
  tmp_0.v9y(addClickOption$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
  var handler_0 = addClickOption$slambda_0(_this__u8e3s4);
  var tmp_1 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_2 = getPropertyCallableRef('over', 1, tmp_1, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
  tmp_2.v9y(addClickOption$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
  var handler_1 = addClickOption$slambda_1(_this__u8e3s4);
  var tmp_3 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_4 = getPropertyCallableRef('out', 1, tmp_3, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
  tmp_4.v9y(addClickOption$lambda_1($this$mouse, handler_1));
  return _this__u8e3s4;
}
function init_steelart_ui_korge_RoundRectWithHover(_this__u8e3s4) {
  _this__u8e3s4.emd_1 = false;
}
function CircleWithHover$slowPulse$lambda(this$0, $start) {
  return (it) => {
    this$0.xm4($start + 0.4 * it);
    this$0.ql8();
    return Unit_instance;
  };
}
function CircleWithHover$slowPulse$lambda_0(this$0, $start) {
  return (it) => {
    this$0.xm4($start + 0.4 * (1.0 - it));
    this$0.ql8();
    return Unit_instance;
  };
}
function addClickOption$slambda($onClick) {
  return constructCallableReference(function *(it, $completion) {
    yield* $onClick($completion);
    return Unit_instance;
  }, 1);
}
function addClickOption$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function addClickOption$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, addClickOption$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function addClickOption$slambda_0($this_addClickOption) {
  return constructCallableReference(function *(it, $completion) {
    $this_addClickOption.pl8(true);
    $this_addClickOption.ql8();
    return Unit_instance;
  }, 1);
}
function addClickOption$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function addClickOption$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, addClickOption$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function addClickOption$slambda_1($this_addClickOption) {
  return constructCallableReference(function *(it, $completion) {
    $this_addClickOption.pl8(false);
    $this_addClickOption.ql8();
    return Unit_instance;
  }, 1);
}
function addClickOption$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function addClickOption$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, addClickOption$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function RoundRectWithHover$_get_alpha_$ref_dj8v26(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 586, VOID, [p0]);
}
function RoundRectWithHover$_set_alpha_$ref_s70qie(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 587, VOID, [p0]);
}
function layoutButtons($this) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.rlt_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.yig()) {
      destination.d2(element);
    }
  }
  var visibleButtons = destination;
  var tmp0_0 = $this.plt_1.j9i_1;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator = visibleButtons.p1();
    if (!iterator.q1()) {
      tmp$ret$3 = null;
      break $l$block;
    }
    var maxValue = iterator.r1().qlb_1.j9i_1;
    while (iterator.q1()) {
      var v = iterator.r1().qlb_1.j9i_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    tmp$ret$3 = maxValue;
  }
  var tmp0_elvis_lhs = tmp$ret$3;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  var tmp = Math.max(tmp0_0, b);
  var tmp0_1 = $this.plt_1.k9i_1;
  var tmp$ret$8;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator_0 = visibleButtons.p1();
    if (!iterator_0.q1()) {
      tmp$ret$8 = null;
      break $l$block_0;
    }
    var maxValue_0 = iterator_0.r1().qlb_1.k9i_1;
    while (iterator_0.q1()) {
      var v_0 = iterator_0.r1().qlb_1.k9i_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = maxValue_0;
      maxValue_0 = Math.max(a_0, v_0);
    }
    tmp$ret$8 = maxValue_0;
  }
  var tmp1_elvis_lhs = tmp$ret$8;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp$ret$12 = Math.max(tmp0_1, b_0);
  var size = Size2D.y9p(tmp, tmp$ret$12);
  var surfaceY = 0.0;
  var _iterator__ex2g4s_0 = visibleButtons.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var button = _iterator__ex2g4s_0.r1();
    var tmp_0 = surfaceY;
    var tmp2_elvis_lhs = $this.slt_1.w4(button);
    surfaceY = tmp_0 + (tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
    button.zlq(size);
    xy(button, 0.0, surfaceY);
    surfaceY = surfaceY + (size.k9i_1 + $this.qlt_1);
  }
  $this.ult_1 = surfaceY;
  $this.tlt_1 = $this.ult_1;
}
function layoutButtons_0($this) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.zlr_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element.yig()) {
      destination.d2(element);
    }
  }
  var visibleButtons = destination;
  if (visibleButtons.n1())
    return Unit_instance;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = visibleButtons.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (element_0 instanceof ActionButton) {
      destination_0.d2(element_0);
    }
  }
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator = destination_0.p1();
    if (!iterator.q1()) {
      tmp$ret$5 = null;
      break $l$block;
    }
    var maxValue = iterator.r1().qlb_1.j9i_1;
    while (iterator.q1()) {
      var v = iterator.r1().qlb_1.j9i_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    tmp$ret$5 = maxValue;
  }
  var tmp0_elvis_lhs = tmp$ret$5;
  var buttonWidth = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator_0 = visibleButtons.p1();
  if (!iterator_0.q1())
    throw NoSuchElementException.w7();
  var it = iterator_0.r1();
  var maxValue_0 = layoutButtons$preferred(it).k9i_1;
  while (iterator_0.q1()) {
    var it_0 = iterator_0.r1();
    var v_0 = layoutButtons$preferred(it_0).k9i_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = maxValue_0;
    maxValue_0 = Math.max(a_0, v_0);
  }
  var height = maxValue_0;
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination_1 = ArrayList.p2();
  var _iterator__ex2g4s_1 = visibleButtons.p1();
  while (_iterator__ex2g4s_1.q1()) {
    var element_1 = _iterator__ex2g4s_1.r1();
    if (element_1 instanceof ActionButton) {
      destination_1.d2(element_1);
    }
  }
  var tmp$ret$15;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator_1 = destination_1.p1();
    if (!iterator_1.q1()) {
      tmp$ret$15 = null;
      break $l$block_0;
    }
    var maxValue_1 = iterator_1.r1().qlb_1.k9i_1;
    while (iterator_1.q1()) {
      var v_1 = iterator_1.r1().qlb_1.k9i_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_1 = maxValue_1;
      maxValue_1 = Math.max(a_1, v_1);
    }
    tmp$ret$15 = maxValue_1;
  }
  var tmp1_elvis_lhs = tmp$ret$15;
  var buttonHeight = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var x = 0.0;
  var y = 0.0;
  var _iterator__ex2g4s_2 = visibleButtons.p1();
  while (_iterator__ex2g4s_2.q1()) {
    var view = _iterator__ex2g4s_2.r1();
    var naturalSize = layoutButtons$preferred(view);
    var tmp;
    var tmp_0;
    if ($this.ylr_1) {
      tmp_0 = view instanceof ActionButton;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = Size2D.y9p(buttonWidth, naturalSize.k9i_1);
    } else {
      tmp = naturalSize;
    }
    var size = tmp;
    if (x > 0 && x + size.j9i_1 > $this.wlr_1) {
      x = 0.0;
      y = y + (height + $this.xlr_1);
    }
    if (view instanceof ActionButton) {
      view.zlq(Size2D.y9p(size.j9i_1, buttonHeight));
      xy(view, x, y + (height - buttonHeight) / 2);
    } else {
      xy(view, x, y + (height - size.k9i_1) / 2);
    }
    x = x + (size.j9i_1 + $this.xlr_1);
  }
}
function layoutButtons$preferred(view) {
  var tmp;
  if (view instanceof ActionButton) {
    tmp = view.qlb_1;
  } else {
    tmp = Size2D.y9p(view.pig(), view.rig());
  }
  return tmp;
}
function addTo_0(_this__u8e3s4, panel) {
  panel.mlr(_this__u8e3s4);
  return _this__u8e3s4;
}
function DialogCancelIcon$slambda($onCancel) {
  return constructCallableReference(function *(it, $completion) {
    yield* $onCancel($completion);
    return Unit_instance;
  }, 1);
}
function DialogCancelIcon$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function DialogCancelIcon$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, DialogCancelIcon$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function DialogCancelIcon$_get_alpha_$ref_w2lfvd(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 588, VOID, [p0]);
}
function DialogCancelIcon$_set_alpha_$ref_2rqzgt(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 589, VOID, [p0]);
}
function get_slowAnimations() {
  _init_properties_GameAnimationParams_kt__qe6cdi();
  return slowAnimations;
}
var slowAnimations;
var fastAnimations;
function set_gameAnimations(_set____db54di) {
  _init_properties_GameAnimationParams_kt__qe6cdi();
  gameAnimations = _set____db54di;
}
function get_gameAnimations() {
  _init_properties_GameAnimationParams_kt__qe6cdi();
  return gameAnimations;
}
var gameAnimations;
var ScreenSwitchMode_REPLAY_NO_SWITCHING_instance;
var ScreenSwitchMode_SWITCH_SIDES_instance;
var ScreenSwitchMode_ONLY_HUNTERS_instance;
var ScreenSwitchMode_ONLY_BEASTS_instance;
var ScreenSwitchMode_entriesInitialized;
function ScreenSwitchMode_initEntries() {
  if (ScreenSwitchMode_entriesInitialized)
    return Unit_instance;
  ScreenSwitchMode_entriesInitialized = true;
  ScreenSwitchMode_REPLAY_NO_SWITCHING_instance = new ScreenSwitchMode('REPLAY_NO_SWITCHING', 0);
  ScreenSwitchMode_SWITCH_SIDES_instance = new ScreenSwitchMode('SWITCH_SIDES', 1);
  ScreenSwitchMode_ONLY_HUNTERS_instance = new ScreenSwitchMode('ONLY_HUNTERS', 2);
  ScreenSwitchMode_ONLY_BEASTS_instance = new ScreenSwitchMode('ONLY_BEASTS', 3);
}
function ScreenSwitchMode_SWITCH_SIDES_getInstance() {
  ScreenSwitchMode_initEntries();
  return ScreenSwitchMode_SWITCH_SIDES_instance;
}
var properties_initialized_GameAnimationParams_kt_6bzufc;
function _init_properties_GameAnimationParams_kt__qe6cdi() {
  if (!properties_initialized_GameAnimationParams_kt_6bzufc) {
    properties_initialized_GameAnimationParams_kt_6bzufc = true;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$2 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    slowAnimations = new GameAnimationParams(VOID, tmp, tmp_0, tmp$ret$2);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_2 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_3 = toDuration(30, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_4 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_5 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_6 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_7 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_8 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$8 = toDuration(200, DurationUnit_MILLISECONDS_getInstance());
    fastAnimations = new GameAnimationParams(VOID, tmp_1, tmp_2, tmp_3, VOID, VOID, VOID, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp$ret$8);
    gameAnimations = new GameAnimationParams();
  }
}
function get_gameColors() {
  _init_properties_GameColors_kt__7knvfm();
  return gameColors;
}
var gameColors;
var properties_initialized_GameColors_kt_hf78ho;
function _init_properties_GameColors_kt__7knvfm() {
  if (!properties_initialized_GameColors_kt_hf78ho) {
    properties_initialized_GameColors_kt_hf78ho = true;
    gameColors = new GameColors();
  }
}
function set_numberOfDisconnectionsSoFar(_set____db54di) {
  _init_properties_GameConfiguration_kt__fm2n8y();
  numberOfDisconnectionsSoFar = _set____db54di;
}
function get_numberOfDisconnectionsSoFar() {
  _init_properties_GameConfiguration_kt__fm2n8y();
  return numberOfDisconnectionsSoFar;
}
var numberOfDisconnectionsSoFar;
function set_gameConfiguration(_set____db54di) {
  _init_properties_GameConfiguration_kt__fm2n8y();
  gameConfiguration = _set____db54di;
}
function get_gameConfiguration() {
  _init_properties_GameConfiguration_kt__fm2n8y();
  return gameConfiguration;
}
var gameConfiguration;
var LocalGameMode_HotSeat_instance;
var LocalGameMode_Sandbox_instance;
var LocalGameMode_ReplayRecording_instance;
var LocalGameMode_FindLocationPlacing_instance;
var LocalGameMode_FindRuinPlacing_instance;
var LocalGameMode_FindMovementPlacing_instance;
var LocalGameMode_CheckNearPositions_instance;
var LocalGameMode_CheckLocationType_instance;
function values_1() {
  return [LocalGameMode_HotSeat_getInstance(), LocalGameMode_Sandbox_getInstance(), LocalGameMode_ReplayRecording_getInstance(), LocalGameMode_FindLocationPlacing_getInstance(), LocalGameMode_FindRuinPlacing_getInstance(), LocalGameMode_FindMovementPlacing_getInstance(), LocalGameMode_CheckNearPositions_getInstance(), LocalGameMode_CheckLocationType_getInstance()];
}
function get_entries_8() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var LocalGameMode_entriesInitialized;
function LocalGameMode_initEntries() {
  if (LocalGameMode_entriesInitialized)
    return Unit_instance;
  LocalGameMode_entriesInitialized = true;
  LocalGameMode_HotSeat_instance = new LocalGameMode('HotSeat', 0);
  LocalGameMode_Sandbox_instance = new LocalGameMode('Sandbox', 1);
  LocalGameMode_ReplayRecording_instance = new LocalGameMode('ReplayRecording', 2);
  LocalGameMode_FindLocationPlacing_instance = new LocalGameMode('FindLocationPlacing', 3);
  LocalGameMode_FindRuinPlacing_instance = new LocalGameMode('FindRuinPlacing', 4);
  LocalGameMode_FindMovementPlacing_instance = new LocalGameMode('FindMovementPlacing', 5);
  LocalGameMode_CheckNearPositions_instance = new LocalGameMode('CheckNearPositions', 6);
  LocalGameMode_CheckLocationType_instance = new LocalGameMode('CheckLocationType', 7);
}
var $ENTRIES_1;
function withUserSettings(_this__u8e3s4, settings) {
  _init_properties_GameConfiguration_kt__fm2n8y();
  return _this__u8e3s4.glr(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, !BeastUserSettings_getInstance().g6v_1.e6v(settings), BeastUserSettings_getInstance().h6v_1.e6v(settings));
}
function get_gameProblemReporter() {
  _init_properties_GameConfiguration_kt__fm2n8y();
  return get_gameConfiguration().ulc_1;
}
function LocalGameMode_HotSeat_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_HotSeat_instance;
}
function LocalGameMode_Sandbox_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_Sandbox_instance;
}
function LocalGameMode_ReplayRecording_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_ReplayRecording_instance;
}
function LocalGameMode_FindLocationPlacing_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_FindLocationPlacing_instance;
}
function LocalGameMode_FindRuinPlacing_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_FindRuinPlacing_instance;
}
function LocalGameMode_FindMovementPlacing_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_FindMovementPlacing_instance;
}
function LocalGameMode_CheckNearPositions_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_CheckNearPositions_instance;
}
function LocalGameMode_CheckLocationType_getInstance() {
  LocalGameMode_initEntries();
  return LocalGameMode_CheckLocationType_instance;
}
var properties_initialized_GameConfiguration_kt_3m4ucs;
function _init_properties_GameConfiguration_kt__fm2n8y() {
  if (!properties_initialized_GameConfiguration_kt_3m4ucs) {
    properties_initialized_GameConfiguration_kt_3m4ucs = true;
    numberOfDisconnectionsSoFar = 0;
    gameConfiguration = new GameConfiguration();
  }
}
function get_gameDialogClose() {
  _init_properties_GameDialog_kt__y2vqnu();
  return gameDialogClose;
}
var gameDialogClose;
function get_defaultDialogColoringStyle() {
  _init_properties_GameDialog_kt__y2vqnu();
  return defaultDialogColoringStyle;
}
var defaultDialogColoringStyle;
function _get_shadow__qaz1n($this) {
  var tmp = $this.jlq_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('shadow');
  }
}
function createDialog($this, willAnimate) {
  // Inline function 'kotlin.apply' call
  var this_0 = Container.fi2();
  var shadowColor = willAnimate || !$this.glq_1.jlt_1 ? Colors_getInstance().ec3_1 : get_gameColors().ulx_1;
  if ($this.glq_1.klt_1 || $this.glq_1.jlt_1) {
    var tmp = $this;
    // Inline function 'korlibs.korge.view.solidRect' call
    var size = get_gameLayout().gl6_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SolidRect.mkf(size, shadowColor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    if ($this.glq_1.klt_1) {
      // Inline function 'korlibs.korge.input.mouse' call
      // Inline function 'kotlin.run' call
      var tmp0 = get_mouse(this_2);
      // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
      var handler = GameDialog$createDialog$slambda($this);
      var tmp_0 = KProperty1;
      // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
      var tmp_1 = getPropertyCallableRef('click', 1, tmp_0, MouseEvents$_get_click_$ref_klwzrm(), null).get(tmp0);
      tmp_1.v9y(GameDialog$createDialog$lambda(tmp0, handler));
    }
    tmp.jlq_1 = this_2;
  }
  var cornerRadius = $this.glq_1.hlt_1;
  var dialogColoringStyle = $this.glq_1.ilt_1;
  var dialogLayout = $this.glq_1.glt_1;
  var tmp_2;
  if (equals(dialogLayout, BigCenter_instance)) {
    tmp_2 = true;
  } else {
    tmp_2 = dialogLayout instanceof BigRightSided;
  }
  if (tmp_2) {
    var leftX = get_gameLayout().el6_1 * (1 - $this.ilq_1) / 2;
    var leftY = get_gameLayout().fl6_1 * (1 - $this.ilq_1) / 2;
    var tmp_3 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_3 = Container.fi2(false);
    // Inline function 'kotlin.apply' call
    var this_4 = addTo(this_3, this_0);
    var tmp_4 = $this;
    var tmp2 = get_gameLayout().gl6_1.b9q($this.ilq_1);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp4 = new RectCorners(numberToDouble(cornerRadius), numberToDouble(cornerRadius), numberToDouble(cornerRadius), numberToDouble(cornerRadius));
    var tmp6 = new RGBA(dialogColoringStyle.umw_1);
    var tmp8 = new RGBA(dialogColoringStyle.vmw_1);
    // Inline function 'korlibs.korge.view.roundRect' call
    var strokeThickness = dialogColoringStyle.wmw_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_5 = RoundRect.rka(tmp2, tmp4, tmp6, tmp8, strokeThickness, true);
    // Inline function 'kotlin.apply' call
    tmp_4.llq_1 = addTo(this_5, this_4);
    addTo($this.s2f(), this_4);
    if (dialogLayout instanceof BigRightSided) {
      xy($this.s2f(), this_4.w9z() - $this.s2f().pig() - dialogLayout.xmw_1 - dialogColoringStyle.wmw_1, this_4.x9z() / 2 - $this.s2f().rig() / 2);
    } else {
      xy($this.s2f(), this_4.w9z() / 2 - $this.s2f().pig() / 2, this_4.x9z() / 2 - $this.s2f().rig() / 2);
    }
    installCornerViews($this, this_4);
    tmp_3.klq_1 = xy(this_4, leftX, leftY);
  } else {
    if (dialogLayout instanceof FitContent) {
      var neededWidth = $this.s2f().pig() + dialogLayout.mmq_1 + dialogLayout.nmq_1;
      var neededHeight = $this.s2f().rig() + dialogLayout.omq_1 + dialogLayout.pmq_1;
      var leftX_0 = createDialog$calcPosition(dialogLayout.qmq_1, get_gameLayout().el6_1, neededWidth);
      var leftY_0 = createDialog$calcPosition(dialogLayout.rmq_1, get_gameLayout().fl6_1, neededHeight);
      var tmp_5 = $this;
      // Inline function 'korlibs.korge.view.container' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_6 = Container.fi2(false);
      // Inline function 'kotlin.apply' call
      var this_7 = addTo(this_6, this_0);
      var tmp_6 = $this;
      var tmp2_0 = Size2D.y9p(neededWidth, neededHeight);
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_11();
      var tmp4_0 = new RectCorners(numberToDouble(cornerRadius), numberToDouble(cornerRadius), numberToDouble(cornerRadius), numberToDouble(cornerRadius));
      var tmp6_0 = new RGBA(dialogColoringStyle.umw_1);
      var tmp8_0 = new RGBA(dialogColoringStyle.vmw_1);
      // Inline function 'korlibs.korge.view.roundRect' call
      var strokeThickness_0 = dialogColoringStyle.wmw_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_8 = RoundRect.rka(tmp2_0, tmp4_0, tmp6_0, tmp8_0, strokeThickness_0, true);
      // Inline function 'kotlin.apply' call
      tmp_6.llq_1 = addTo(this_8, this_7);
      xy(addTo($this.s2f(), this_7), dialogLayout.mmq_1, dialogLayout.omq_1);
      installCornerViews($this, this_7);
      tmp_5.klq_1 = xy(this_7, leftX_0, leftY_0);
    } else {
      noWhenBranchMatchedException();
    }
  }
  installBackgroundCloseBehavior($this, this_0);
  if (willAnimate) {
    $this.ymw().uif(0.05);
  }
  var tmp0_safe_receiver = $this.olq_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    installWaitingMessage($this, this_0, tmp0_safe_receiver);
  }
  return this_0;
}
function installCornerViews($this, $receiver) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = $this.glq_1.flt_1.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    $l$block: {
      // Inline function 'kotlin.collections.component1' call
      var corner = element.j3();
      // Inline function 'kotlin.collections.component2' call
      var view = element.k3();
      if (view == null) {
        break $l$block;
      }
      addTo(view, $receiver);
      var tmp;
      switch (corner.w1_1) {
        case 0:
        case 2:
          tmp = $this.glq_1.hlt_1;
          break;
        case 1:
        case 3:
          tmp = $this.ylt().w9z() - $this.glq_1.hlt_1 - view.pig();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var x = tmp;
      var tmp_0;
      switch (corner.w1_1) {
        case 0:
        case 1:
          tmp_0 = $this.glq_1.hlt_1;
          break;
        case 2:
        case 3:
          tmp_0 = $this.ylt().x9z() - $this.glq_1.hlt_1 - view.rig();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var y = tmp_0;
      position(view, x, y);
    }
  }
}
function installBackgroundCloseBehavior($this, $receiver) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = $this.glq_1.flt_1.y4();
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof DialogCancelIcon) {
      destination.d2(element);
    }
  }
  var tmp0_elvis_lhs = singleOrNull(destination);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cancelIcon = tmp;
  var tmp_0 = listOf_0($this.glq_1.elt_1);
  // Inline function 'kotlin.collections.filterNot' call
  var tmp0_0 = filterNotNull($this.glq_1.flt_1.y4());
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination_0 = ArrayList.p2();
  var _iterator__ex2g4s_0 = tmp0_0.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    if (!(element_0 === cancelIcon)) {
      destination_0.d2(element_0);
    }
  }
  var childViews = plus(tmp_0, destination_0);
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  var $this$mouse = get_mouse($receiver);
  // Inline function 'korlibs.korge.input.MouseEvents.onOver' call
  var handler = GameDialog$installBackgroundCloseBehavior$slambda(cancelIcon, childViews);
  var tmp_1 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_2 = getPropertyCallableRef('over', 1, tmp_1, MouseEvents$_get_over_$ref_7juzhw(), null).get($this$mouse);
  tmp_2.v9y(GameDialog$installBackgroundCloseBehavior$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onMove' call
  var handler_0 = GameDialog$installBackgroundCloseBehavior$slambda_0(cancelIcon, childViews);
  var tmp_3 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_4 = getPropertyCallableRef('move', 1, tmp_3, MouseEvents$_get_move_$ref_mt1fcf(), null).get($this$mouse);
  tmp_4.v9y(GameDialog$installBackgroundCloseBehavior$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onOut' call
  var handler_1 = GameDialog$installBackgroundCloseBehavior$slambda_1(cancelIcon);
  var tmp_5 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_6 = getPropertyCallableRef('out', 1, tmp_5, MouseEvents$_get_out_$ref_qyed9w(), null).get($this$mouse);
  tmp_6.v9y(GameDialog$installBackgroundCloseBehavior$lambda_1($this$mouse, handler_1));
  // Inline function 'korlibs.korge.input.mouse' call
  var this_0 = $this.ymw();
  // Inline function 'kotlin.run' call
  var tmp0_1 = get_mouse(this_0);
  // Inline function 'korlibs.korge.input.MouseEvents.onClick' call
  var handler_2 = GameDialog$installBackgroundCloseBehavior$slambda_2(childViews, cancelIcon, $this);
  var tmp_7 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEvent' call
  var tmp_8 = getPropertyCallableRef('click', 1, tmp_7, MouseEvents$_get_click_$ref_klwzrm(), null).get(tmp0_1);
  tmp_8.v9y(GameDialog$installBackgroundCloseBehavior$lambda_2(tmp0_1, handler_2));
}
function installWaitingMessage($this, container, message) {
  var tmp0_safe_receiver = $this.plq_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.uih();
  }
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = BorderedText(message, get_gameLayout().sl5_1 * 2);
  this_0.rif($this.ymw().wea() + ($this.ymw().pig() - this_0.pig()) / 2);
  this_0.sif(coerceAtLeast($this.ymw().xea() - this_0.rig() - get_gameLayout().yl5_1 / 2, 0.0));
  addTo(this_0, container);
  tmp.plq_1 = this_0;
}
function GameDialog$_init_$slambda_h5cqsy() {
  return constructCallableReference(function *(it, $completion) {
    return Unit_instance;
  }, 1);
}
function GameDialog$_init_$slambda_h5cqsy_0() {
  return constructCallableReference(function *(it, $completion) {
    return Unit_instance;
  }, 1);
}
function GameDialog$awaitUntilNotShown$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    while (true) {
      var tmp0_safe_receiver = this$0.plq_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp = KMutableProperty0;
        var tmp_0 = View$_get_alpha_$ref_oftner(tmp0_safe_receiver);
        var tmp0 = getPropertyCallableRef('alpha', 0, tmp, tmp_0, View$_set_alpha_$ref_4v0szt(tmp0_safe_receiver));
        // Inline function 'korlibs.korge.tween.get' call
        var initial = tmp0_safe_receiver.tig();
        var tmp_1 = [new V2(tmp0, initial, 0.25, _interpolate$ref(), true)];
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$3 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* tween(tmp0_safe_receiver, tmp_1, tmp$ret$3, VOID, VOID, VOID, VOID, VOID, $completion);
      }
      var tmp1_safe_receiver = this$0.plq_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp_2 = KMutableProperty0;
        var tmp_3 = View$_get_alpha_$ref_oftner(tmp1_safe_receiver);
        var tmp0_0 = getPropertyCallableRef('alpha', 0, tmp_2, tmp_3, View$_set_alpha_$ref_4v0szt(tmp1_safe_receiver));
        // Inline function 'korlibs.korge.tween.get' call
        var initial_0 = tmp1_safe_receiver.tig();
        var tmp_4 = [new V2(tmp0_0, initial_0, 1.0, _interpolate$ref(), true)];
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$7 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
        yield* tween(tmp1_safe_receiver, tmp_4, tmp$ret$7, VOID, VOID, VOID, VOID, VOID, $completion);
      }
    }
    return Unit_instance;
  }, 1);
}
function GameDialog$awaitUntilNotShown$slambda$slambda_0() {
  return constructCallableReference(function *(it, $completion) {
    return !it;
  }, 1);
}
function GameDialog$awaitUntilNotShown$slambda($message, this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp;
    if (!($message == null)) {
      this$0.olq_1 = $message;
      installWaitingMessage(this$0, this$0.umq(), $message);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (!($message == null) && !get_gameConfiguration().olc_1) {
      tmp_0 = launch($this$coroutineScope, VOID, VOID, GameDialog$awaitUntilNotShown$slambda$slambda(this$0));
    } else {
      tmp_0 = null;
    }
    var pulseJob = tmp_0;
    var tmp_1;
    try {
      tmp_1 = yield* first_1(this$0.nlq_1, GameDialog$awaitUntilNotShown$slambda$slambda_0(), $completion);
    }finally {
      if (pulseJob == null)
        null;
      else {
        pulseJob.o1n();
      }
      if (!($message == null) && this$0.olq_1 == $message) {
        this$0.olq_1 = null;
        var tmp1_safe_receiver = this$0.plq_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.uih();
        }
        this$0.plq_1 = null;
      }
    }
    return tmp_1;
  }, 1);
}
function SolidRect$_get_color_$ref_9nfdbc(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.qd9());
  }, 0, 0, 590, VOID, [p0]);
}
function SolidRect$_set_color_$ref_jnf338(p0) {
  return constructCallableReference((p0_0) => {
    p0.zjp(p0_0.sci_1);
    return Unit_instance;
  }, 1, 0, 591, VOID, [p0]);
}
function GameDialog$animateInstall$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = _get_shadow__qaz1n(this$0);
    var tmp0 = _get_shadow__qaz1n(this$0);
    var tmp_0 = KMutableProperty0;
    var tmp_1 = SolidRect$_get_color_$ref_9nfdbc(tmp0);
    var tmp0_0 = getPropertyCallableRef('color', 0, tmp_0, tmp_1, SolidRect$_set_color_$ref_jnf338(tmp0));
    var tmp2 = Colors_getInstance().ec3_1;
    // Inline function 'korlibs.korge.tween.get' call
    var end = get_gameColors().ulx_1;
    var tmp$ret$0 = new V2(tmp0_0, new RGBA(tmp2), new RGBA(end), _interpolateColor$ref(), true);
    yield* tween(tmp, [tmp$ret$0], get_gameAnimations().ql4_1, VOID, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function View$_get_scale_$ref_5ah2s7(p0) {
  return constructCallableReference(() => p0.vif(), 0, 0, 469, VOID, [p0]);
}
function View$_set_scale_$ref_o0ddmd(p0) {
  return constructCallableReference((p0_0) => {
    p0.uif(p0_0);
    return Unit_instance;
  }, 1, 0, 470, VOID, [p0]);
}
function GameDialog$animateInstall$slambda$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = this$0.ymw();
    var tmp0 = this$0.ymw();
    var tmp_0 = KMutableProperty0;
    var tmp_1 = View$_get_scale_$ref_5ah2s7(tmp0);
    // Inline function 'korlibs.korge.tween.get' call
    var tmp0_0 = getPropertyCallableRef('scale', 0, tmp_0, tmp_1, View$_set_scale_$ref_o0ddmd(tmp0));
    var tmp2 = numberToDouble(0.05);
    // Inline function 'korlibs.korge.tween.get' call
    var end = numberToDouble(1);
    var tmp$ret$0 = new V2(tmp0_0, tmp2, end, _interpolate$ref(), true);
    yield* tween(tmp, [tmp$ret$0], get_gameAnimations().ql4_1, VOID, VOID, VOID, VOID, VOID, $completion);
    return Unit_instance;
  }, 1);
}
function GameDialog$animateInstall$slambda(this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp;
    if (this$0.glq_1.jlt_1) {
      launch($this$coroutineScope, VOID, VOID, GameDialog$animateInstall$slambda$slambda(this$0));
      tmp = Unit_instance;
    }
    return launch($this$coroutineScope, VOID, VOID, GameDialog$animateInstall$slambda$slambda_0(this$0));
  }, 1);
}
function RoundRect$_get_size_$ref_djl5fv(p0) {
  return constructCallableReference(() => p0.s2(), 0, 0, 592, VOID, [p0]);
}
function RoundRect$_set_size_$ref_qchgwn(p0) {
  return constructCallableReference((p0_0) => {
    p0.hig(p0_0);
    return Unit_instance;
  }, 1, 0, 593, VOID, [p0]);
}
function createDialog$calcPosition(dialogAxisPlacing, fullLength, contentLength) {
  var tmp;
  if (dialogAxisPlacing instanceof OffsetFromCenter) {
    tmp = (fullLength - contentLength) / 2 + dialogAxisPlacing.bmx_1;
  } else {
    if (dialogAxisPlacing instanceof OffsetFromEnd) {
      tmp = fullLength - contentLength - dialogAxisPlacing.amx_1;
    } else {
      if (dialogAxisPlacing instanceof OffsetFromStart) {
        tmp = dialogAxisPlacing.zmw_1;
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function GameDialog$createDialog$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* this$0.hlq_1(this$0, $completion);
    return Unit_instance;
  }, 1);
}
function GameDialog$createDialog$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function GameDialog$createDialog$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, GameDialog$createDialog$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function installBackgroundCloseBehavior$isIn(_this__u8e3s4, view) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (current === view)
      return true;
    current = current.x1m();
  }
  return false;
}
function *installBackgroundCloseBehavior$updateCancelIcon(cancelIcon, childViews, hitView, $completion) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp;
    if (isInterface(childViews, Collection)) {
      tmp = childViews.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = childViews.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (installBackgroundCloseBehavior$isIn(hitView, element)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  yield* cancelIcon.clx(tmp$ret$0, $completion);
  return Unit_instance;
}
function GameDialog$installBackgroundCloseBehavior$slambda($cancelIcon, $childViews) {
  return constructCallableReference(function *(it, $completion) {
    yield* /*#__NOINLINE__*/installBackgroundCloseBehavior$updateCancelIcon($cancelIcon, $childViews, it.nhx_1, $completion);
    return Unit_instance;
  }, 1);
}
function GameDialog$installBackgroundCloseBehavior$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function GameDialog$installBackgroundCloseBehavior$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, GameDialog$installBackgroundCloseBehavior$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function GameDialog$installBackgroundCloseBehavior$slambda_0($cancelIcon, $childViews) {
  return constructCallableReference(function *(it, $completion) {
    yield* /*#__NOINLINE__*/installBackgroundCloseBehavior$updateCancelIcon($cancelIcon, $childViews, it.nhx_1, $completion);
    return Unit_instance;
  }, 1);
}
function GameDialog$installBackgroundCloseBehavior$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function GameDialog$installBackgroundCloseBehavior$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, GameDialog$installBackgroundCloseBehavior$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function GameDialog$installBackgroundCloseBehavior$slambda_1($cancelIcon) {
  return constructCallableReference(function *(it, $completion) {
    yield* $cancelIcon.clx(false, $completion);
    return Unit_instance;
  }, 1);
}
function GameDialog$installBackgroundCloseBehavior$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function GameDialog$installBackgroundCloseBehavior$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, GameDialog$installBackgroundCloseBehavior$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function GameDialog$installBackgroundCloseBehavior$slambda_2($childViews, $cancelIcon, this$0) {
  return constructCallableReference(function *(it, $completion) {
    var hitView = it.nhx_1;
    var tmp;
    var tmp_0;
    var tmp0 = $childViews;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(tmp0, Collection)) {
        tmp_1 = tmp0.n1();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (installBackgroundCloseBehavior$isIn(hitView, element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      tmp_0 = !installBackgroundCloseBehavior$isIn(hitView, $cancelIcon);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = yield* this$0.hlq_1(this$0, $completion);
    }
    return Unit_instance;
  }, 1);
}
function GameDialog$installBackgroundCloseBehavior$lambda$slambda_2($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function GameDialog$installBackgroundCloseBehavior$lambda_2($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, GameDialog$installBackgroundCloseBehavior$lambda$slambda_2($handler, it));
    return Unit_instance;
  };
}
function dialogCornerText(message) {
  _init_properties_GameDialog_kt__y2vqnu();
  var tmp;
  if (message == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = BorderedText(message, get_gameLayout().ul5_1);
  }
  return tmp;
}
var DialogCorner_LEFT_TOP_instance;
var DialogCorner_RIGHT_TOP_instance;
var DialogCorner_LEFT_BOTTOM_instance;
var DialogCorner_RIGHT_BOTTOM_instance;
var DialogCorner_entriesInitialized;
function DialogCorner_initEntries() {
  if (DialogCorner_entriesInitialized)
    return Unit_instance;
  DialogCorner_entriesInitialized = true;
  DialogCorner_LEFT_TOP_instance = new DialogCorner('LEFT_TOP', 0);
  DialogCorner_RIGHT_TOP_instance = new DialogCorner('RIGHT_TOP', 1);
  DialogCorner_LEFT_BOTTOM_instance = new DialogCorner('LEFT_BOTTOM', 2);
  DialogCorner_RIGHT_BOTTOM_instance = new DialogCorner('RIGHT_BOTTOM', 3);
}
var BigCenter_instance;
function BigCenter_getInstance() {
  return BigCenter_instance;
}
function gameDialogClose$slambda() {
  return constructCallableReference(function *(it, $completion) {
    it.qlq();
    return Unit_instance;
  }, 1);
}
function DialogCorner_LEFT_TOP_getInstance() {
  DialogCorner_initEntries();
  return DialogCorner_LEFT_TOP_instance;
}
function DialogCorner_RIGHT_TOP_getInstance() {
  DialogCorner_initEntries();
  return DialogCorner_RIGHT_TOP_instance;
}
var properties_initialized_GameDialog_kt_6tjlyc;
function _init_properties_GameDialog_kt__y2vqnu() {
  if (!properties_initialized_GameDialog_kt_6tjlyc) {
    properties_initialized_GameDialog_kt_6tjlyc = true;
    gameDialogClose = gameDialogClose$slambda();
    defaultDialogColoringStyle = new DialogColoringStyle();
  }
}
function get_globalLoadingResourceManager() {
  _init_properties_GameImageManager_kt__wyldks();
  return globalLoadingResourceManager;
}
var globalLoadingResourceManager;
function LoadingResourceManager$startLoadingManagement$slambda$slambda($function) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $function($completion);
    return Unit_instance;
  }, 1);
}
function LoadingResourceManager$startLoadingManagement$slambda(this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp;
    try {
      while (true) {
        var function_0 = yield* this$0.llo_1.n22($completion);
        launch($this$coroutineScope, VOID, VOID, LoadingResourceManager$startLoadingManagement$slambda$slambda(function_0));
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ClosedReceiveChannelException) {
        var _unused_var__etf5q3 = $p;
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function maskFor($this, bitmap, color) {
  var tmp0 = $this.dle_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var key = to(bitmap, new RGBA(color));
  var value = tmp0.w4(key);
  var tmp;
  if (value == null) {
    var copied = bitmap.ec2().g9m();
    // Inline function 'korlibs.image.bitmap.Bitmap32.updateColors' call
    var width = copied.sc1_1 - 0 | 0;
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var inductionVariable = 0;
    var last = 0 + (copied.tc1_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = copied.nc2(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            var it = copied.dcb(_unary__edvuaz);
            var tmp$ret$5 = !(_RGBA___get_a__impl__6msvu7(it) === 0) ? color : Colors_getInstance().ec3_1;
            copied.icb(_unary__edvuaz, tmp$ret$5);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var answer = copied;
    tmp0.b5(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function GameImageManager$getImageWithCaching$slambda(this$0, $path, $completableDeferred) {
  return constructCallableReference(function *($completion) {
    var isFirstAttempt = true;
    $l$loop: while (true) {
      try {
        var bitmap = yield* readBitmap_0(get_resourcesVfs().wi(this$0.xld_1 + $path), VOID, $completion);
        $completableDeferred.l1t(bitmap);
        // Inline function 'kotlinx.coroutines.sync.withLock' call
        var this_0 = this$0.ale_1;
        yield* this_0.y2a(null, $completion);
        var tmp;
        try {
          var tmp0 = this$0.ble_1;
          // Inline function 'kotlin.collections.set' call
          var key = $path;
          tmp0.b5(key, bitmap);
          tmp = this$0.cle_1.c5($path);
        }finally {
          this_0.k2a(null);
        }
        yield* this$0.ylb($path, ImageLoadingStage_Finished_getInstance(), $completion);
      } catch ($p) {
        if ($p instanceof CancellationException) {
          var e = $p;
          $completableDeferred.n1n(e);
        } else {
          if ($p instanceof Error) {
            var e_0 = $p;
            var tmp_0;
            if (isFailedToFetch(e_0)) {
              tmp_0 = true;
            } else {
              tmp_0 = e_0 instanceof UnsupportedOperationException;
            }
            if (tmp_0) {
              if (isFirstAttempt) {
                yield* this$0.ylb($path, ImageLoadingStage_Disconnected_getInstance(), $completion);
              }
              isFirstAttempt = false;
              // Inline function 'kotlin.time.Companion.milliseconds' call
              Companion_getInstance();
              var tmp$ret$3 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
              yield* delay(tmp$ret$3, $completion);
              continue $l$loop;
            }
            println('Error loading ' + $path);
            println('Error#1 ' + toString(getKClassFromExpression(e_0)));
            println('Error#2 ' + e_0.toString());
            println('Error#3 ' + e_0.message);
            var tmp0_elvis_lhs = e_0.message;
            cancel_0($completableDeferred, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, e_0);
          } else {
            throw $p;
          }
        }
      }
      break $l$loop;
    }
    return Unit_instance;
  }, 0);
}
var ImageLoadingStage_Started_instance;
var ImageLoadingStage_Disconnected_instance;
var ImageLoadingStage_Finished_instance;
var ImageLoadingStage_entriesInitialized;
function ImageLoadingStage_initEntries() {
  if (ImageLoadingStage_entriesInitialized)
    return Unit_instance;
  ImageLoadingStage_entriesInitialized = true;
  ImageLoadingStage_Started_instance = new ImageLoadingStage('Started', 0);
  ImageLoadingStage_Disconnected_instance = new ImageLoadingStage('Disconnected', 1);
  ImageLoadingStage_Finished_instance = new ImageLoadingStage('Finished', 2);
}
function ImageLoadingStage_Started_getInstance() {
  ImageLoadingStage_initEntries();
  return ImageLoadingStage_Started_instance;
}
function ImageLoadingStage_Disconnected_getInstance() {
  ImageLoadingStage_initEntries();
  return ImageLoadingStage_Disconnected_instance;
}
function ImageLoadingStage_Finished_getInstance() {
  ImageLoadingStage_initEntries();
  return ImageLoadingStage_Finished_instance;
}
var properties_initialized_GameImageManager_kt_ix9cpy;
function _init_properties_GameImageManager_kt__wyldks() {
  if (!properties_initialized_GameImageManager_kt_ix9cpy) {
    properties_initialized_GameImageManager_kt_ix9cpy = true;
    globalLoadingResourceManager = new LoadingResourceManager();
  }
}
function set_gameLayoutCurrent(_set____db54di) {
  _init_properties_GameLayout_kt__8e7ask();
  gameLayoutCurrent = _set____db54di;
}
function get_gameLayoutCurrent() {
  _init_properties_GameLayout_kt__8e7ask();
  return gameLayoutCurrent;
}
var gameLayoutCurrent;
function get_gameLayout() {
  _init_properties_GameLayout_kt__8e7ask();
  return get_gameLayoutCurrent();
}
var SidePanelLayout_Narrow_instance;
var SidePanelLayout_Wide_instance;
var SidePanelLayout_entriesInitialized;
function SidePanelLayout_initEntries() {
  if (SidePanelLayout_entriesInitialized)
    return Unit_instance;
  SidePanelLayout_entriesInitialized = true;
  SidePanelLayout_Narrow_instance = new SidePanelLayout('Narrow', 0);
  SidePanelLayout_Wide_instance = new SidePanelLayout('Wide', 1);
}
function SidePanelLayout_Narrow_getInstance() {
  SidePanelLayout_initEntries();
  return SidePanelLayout_Narrow_instance;
}
function SidePanelLayout_Wide_getInstance() {
  SidePanelLayout_initEntries();
  return SidePanelLayout_Wide_instance;
}
var properties_initialized_GameLayout_kt_wy2i0y;
function _init_properties_GameLayout_kt__8e7ask() {
  if (!properties_initialized_GameLayout_kt_wy2i0y) {
    properties_initialized_GameLayout_kt_wy2i0y = true;
    gameLayoutCurrent = new GameLayout();
  }
}
var NullVariant_instance;
function NullVariant_getInstance() {
  return NullVariant_instance;
}
function get_onboardingTemporaryDialogs() {
  _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr();
  return onboardingTemporaryDialogs;
}
var onboardingTemporaryDialogs;
function clearOnboardingGlobalMode() {
  _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr();
  var tmp = get_gameConfiguration();
  var tmp_0;
  if (get_gameConfiguration().slc_1 === KorgeOnboardingGameFlowListener_getInstance()) {
    tmp_0 = EmptyListener_instance;
  } else {
    tmp_0 = get_gameConfiguration().slc_1;
  }
  set_gameConfiguration(tmp.glr(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, false, tmp_0));
  closeLastInfoDialog();
  closeOnboardingTemporaryDialogs();
}
function applyOnboardingGlobalMode(startFromInfoStep, startFromAnswer) {
  startFromInfoStep = startFromInfoStep === VOID ? 0 : startFromInfoStep;
  startFromAnswer = startFromAnswer === VOID ? 0 : startFromAnswer;
  _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr();
  KorgeOnboardingGameFlowListener_getInstance().hmx(startFromInfoStep, startFromAnswer);
  set_gameConfiguration(get_gameConfiguration().glr(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true, KorgeOnboardingGameFlowListener_getInstance()));
}
function clearAfterInfoDialogs($this, $receiver, fn) {
  if (!($receiver instanceof KorgeControlAgent))
    return Unit_instance;
  if ($this.sdy_1 < ($this.rdy_1 + 1 | 0) || $this.tdy_1 < $this.udy_1)
    return Unit_instance;
  fn();
}
function _get_asKorgeAgent__wlcdb4($this, $receiver) {
  return $receiver instanceof KorgeControlAgent ? $receiver : THROW_CCE();
}
function *showInfoImpl($this, $receiver, needAddNextButton, lines, dialogLayout, $completion) {
  dialogLayout = dialogLayout === VOID ? new FitContent() : dialogLayout;
  yield* applyMapScalingAndPosition($this, $receiver, $this.ydy_1, $completion);
  setReplayCodeInUrl(get_onboardingReplayCode(), false, $this.tdy_1, $this.sdy_1 - 1 | 0);
  var notTrivialPrepareStep = !equals($this.bll_1, $this.all_1);
  yield* $this.bll_1($receiver, $completion);
  $this.bll_1 = $this.all_1;
  yield* coroutineScope(KorgeOnboardingGameFlowListener$showInfoImpl$slambda(needAddNextButton, $receiver, lines, dialogLayout, notTrivialPrepareStep), $completion);
  $this.xdy_1 = $this.ydy_1;
  return Unit_instance;
}
function *applyMapScalingAndPosition($this, $receiver, mapSettings, $completion) {
  if (!(mapSettings == null)) {
    yield* $receiver.gl2_1.kl7_1(Vector2D.a9k(mapSettings.q6x_1, mapSettings.r6x_1), mapSettings.s6x_1, $completion);
  } else {
    $receiver.gl2_1.ylm();
  }
  return Unit_instance;
}
function installAreaHighlightOnContractContent($this, content, rectY, textHeight, coroutineScope) {
  var tmp = Vector2D.t9g(57.0, rectY);
  var tmp_0 = Size2D.y9p(1498.0 - 57.0 * 2, textHeight);
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  Companion_getInstance_11();
  var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
  return installHighlightOnContent(content, tmp, tmp_0, tmp$ret$0, 20.0, coroutineScope);
}
function initiateRevertIntoAnotherListener($this, $receiver, notificationType) {
  var revertMode = $this.fdz($receiver, notificationType);
  launch($receiver.jl2_1, VOID, VOID, KorgeOnboardingGameFlowListener$initiateRevertIntoAnotherListener$slambda($receiver, revertMode));
}
function hintLayout($this, hint) {
  var tmp;
  switch (hint.w1_1) {
    case 47:
    case 54:
    case 55:
    case 56:
    case 57:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(600.0));
      break;
    case 148:
    case 0:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 11:
    case 12:
    case 29:
    case 103:
    case 104:
    case 105:
    case 79:
    case 80:
    case 87:
    case 88:
    case 89:
    case 123:
    case 191:
    case 223:
    case 225:
    case 292:
    case 295:
    case 71:
    case 84:
    case 291:
      tmp = new FitContent();
      break;
    case 275:
    case 282:
    case 283:
    case 58:
    case 59:
    case 93:
    case 142:
    case 180:
    case 266:
    case 273:
    case 269:
    case 284:
    case 285:
    case 286:
    case 287:
    case 48:
    case 49:
    case 107:
    case 276:
    case 288:
    case 30:
    case 39:
    case 50:
    case 51:
    case 61:
    case 62:
    case 63:
    case 64:
    case 65:
    case 68:
    case 70:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 81:
    case 82:
    case 83:
    case 85:
    case 86:
    case 94:
    case 95:
    case 96:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 106:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
    case 124:
    case 125:
    case 126:
    case 127:
    case 128:
    case 129:
    case 130:
    case 131:
    case 132:
    case 133:
    case 134:
    case 136:
    case 137:
    case 138:
    case 139:
    case 140:
    case 141:
    case 143:
    case 144:
    case 145:
    case 146:
    case 147:
    case 149:
    case 150:
    case 151:
    case 152:
    case 153:
    case 154:
    case 155:
    case 156:
    case 157:
    case 158:
    case 159:
    case 160:
    case 161:
    case 162:
    case 163:
    case 164:
    case 165:
    case 166:
    case 167:
    case 168:
    case 169:
    case 170:
    case 171:
    case 172:
    case 173:
    case 174:
    case 175:
    case 176:
    case 177:
    case 178:
    case 179:
    case 181:
    case 182:
    case 183:
    case 184:
    case 185:
    case 186:
    case 187:
    case 188:
    case 189:
    case 190:
    case 192:
    case 193:
    case 194:
    case 195:
    case 196:
    case 197:
    case 198:
    case 199:
    case 200:
    case 201:
    case 202:
    case 203:
    case 204:
    case 205:
    case 206:
    case 207:
    case 208:
    case 209:
    case 210:
    case 211:
    case 212:
    case 213:
    case 214:
    case 215:
    case 216:
    case 217:
    case 218:
    case 219:
    case 220:
    case 221:
    case 222:
    case 224:
    case 226:
    case 227:
    case 228:
    case 229:
    case 230:
    case 231:
    case 232:
    case 233:
    case 234:
    case 235:
    case 236:
    case 237:
    case 238:
    case 239:
    case 240:
    case 241:
    case 242:
    case 243:
    case 244:
    case 245:
    case 246:
    case 247:
    case 248:
    case 249:
    case 250:
    case 251:
    case 252:
    case 253:
    case 254:
    case 255:
    case 256:
    case 257:
    case 258:
    case 259:
    case 260:
    case 261:
    case 262:
    case 263:
    case 264:
    case 265:
    case 267:
    case 268:
    case 270:
    case 271:
    case 272:
    case 274:
    case 277:
    case 278:
    case 279:
    case 280:
    case 281:
    case 294:
    case 90:
    case 91:
    case 92:
      tmp = new FitContent(VOID, VOID, VOID, VOID, VOID, new OffsetFromStart(50.0));
      break;
    case 1:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromCenter(-100.0));
      break;
    case 2:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromCenter(-100.0), new OffsetFromStart(200.0));
      break;
    case 3:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromCenter(-50.0));
      break;
    case 10:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromStart(200.0));
      break;
    case 13:
    case 16:
    case 17:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(720.0));
      break;
    case 14:
    case 15:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(720.0), new OffsetFromStart(70.0));
      break;
    case 18:
    case 19:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(720.0), new OffsetFromEnd(70.0));
      break;
    case 20:
    case 24:
    case 34:
    case 40:
    case 41:
    case 42:
    case 44:
    case 46:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(650.0));
      break;
    case 21:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(650.0), new OffsetFromCenter(-200.0));
      break;
    case 22:
    case 23:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(650.0), new OffsetFromCenter(200.0));
      break;
    case 25:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromStart(300.0), new OffsetFromEnd(100.0));
      break;
    case 26:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromStart(300.0));
      break;
    case 27:
    case 28:
    case 31:
    case 32:
    case 33:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(500.0));
      break;
    case 135:
    case 289:
      tmp = new FitContent(VOID, VOID, VOID, VOID, VOID, new OffsetFromEnd(50.0));
      break;
    case 35:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(500.0), new OffsetFromEnd(200.0));
      break;
    case 36:
    case 37:
    case 38:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(500.0), new OffsetFromEnd(100.0));
      break;
    case 43:
    case 45:
    case 53:
    case 66:
    case 67:
    case 69:
      tmp = new FitContent(VOID, VOID, VOID, VOID, VOID, new OffsetFromStart(150.0));
      break;
    case 52:
      tmp = new FitContent(VOID, VOID, VOID, VOID, VOID, new OffsetFromStart(10.0));
      break;
    case 60:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(200.0), new OffsetFromStart(50.0));
      break;
    case 290:
    case 293:
      tmp = new FitContent(VOID, VOID, VOID, VOID, new OffsetFromEnd(50.0), new OffsetFromStart(50.0));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function KorgeOnboardingGameFlowListener$emptyApplyPrepareStep$slambda() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$showInfoImpl$slambda$lambda($backCalled) {
  return () => {
    $backCalled.l1t(Unit_instance);
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$showInfoImpl$slambda$slambda($this_showInfoImpl, $needAddNextButton, $backCallback, $lines, $dialogLayout, $scopeJob) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* showInformationDialog($this_showInfoImpl, $needAddNextButton, $backCallback, $lines, $dialogLayout, $needAddNextButton ? $this_showInfoImpl.amp() : null, $completion);
    var tmp;
    if ($needAddNextButton) {
      var tmp0_safe_receiver = $scopeJob;
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancelChildren(tmp0_safe_receiver);
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$showInfoImpl$slambda$slambda_0() {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* awaitCancellation($completion);
    throwKotlinNothingValueException();
  }, 1);
}
function KorgeOnboardingGameFlowListener$showInfoImpl$slambda$slambda_1($backCalled, $notTrivialPrepareStep, $this_showInfoImpl) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $backCalled.m1q($completion);
    closeLastInfoDialog();
    closeOnboardingTemporaryDialogs();
    var tmp;
    if ($notTrivialPrepareStep) {
      $this_showInfoImpl.lmo();
      tmp = Unit_instance;
    }
    yield* /*#__NOINLINE__*/applyMapScalingAndPosition(KorgeOnboardingGameFlowListener_getInstance(), $this_showInfoImpl, KorgeOnboardingGameFlowListener_getInstance().xdy_1, $completion);
    KorgeOnboardingGameFlowListener_getInstance().ydy_1 = KorgeOnboardingGameFlowListener_getInstance().xdy_1;
    throw PressedBackException.pdy();
  }, 1);
}
function KorgeOnboardingGameFlowListener$showInfoImpl$slambda($needAddNextButton, $this_showInfoImpl, $lines, $dialogLayout, $notTrivialPrepareStep) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var backCalled = CompletableDeferred_0();
    KorgeOnboardingGameFlowListener_getInstance().cll_1 = backCalled;
    // Inline function 'kotlin.takeIf' call
    var this_0 = KorgeOnboardingGameFlowListener$showInfoImpl$slambda$lambda(backCalled);
    var tmp;
    if (!(KorgeOnboardingGameFlowListener_getInstance().tdy_1 === 0) || KorgeOnboardingGameFlowListener_getInstance().sdy_1 > 1) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var backCallback = tmp;
    var scopeJob = $this$coroutineScope.d1m().ae(Key_instance);
    launch($this$coroutineScope, VOID, VOID, KorgeOnboardingGameFlowListener$showInfoImpl$slambda$slambda($this_showInfoImpl, $needAddNextButton, backCallback, $lines, $dialogLayout, scopeJob));
    var tmp_0;
    if (!$needAddNextButton) {
      launch($this$coroutineScope, VOID, VOID, KorgeOnboardingGameFlowListener$showInfoImpl$slambda$slambda_0());
      tmp_0 = Unit_instance;
    }
    return launch($this$coroutineScope, VOID, VOID, KorgeOnboardingGameFlowListener$showInfoImpl$slambda$slambda_1(backCalled, $notTrivialPrepareStep, $this_showInfoImpl));
  }, 1);
}
function KorgeOnboardingGameFlowListener$initiateRevertIntoAnotherListener$slambda($this_initiateRevertIntoAnotherListener, $revertMode) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $this_initiateRevertIntoAnotherListener.pe1($revertMode, $completion);
    return Unit_instance;
  }, 1);
}
function *invoke$showNext($holder, hints, $completion) {
  return yield* KorgeOnboardingGameFlowListener_getInstance().ce0($holder, hints.r1(), $completion);
}
function invoke$highlightSettlers(_this__u8e3s4, particularType) {
  var settlersMapping = _this__u8e3s4.gl2_1.zlm();
  var container = Container.fi2();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = settlersMapping.i3().p1();
  $l$loop: while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var settler = _destruct__k2r9zo.j3();
    // Inline function 'kotlin.collections.component2' call
    var circleInfo = _destruct__k2r9zo.k3();
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.t6h();
    if (!(particularType == null) && !equals(get_objectType($this$with, settler), particularType))
      continue $l$loop;
    var pos = circleInfo.jm();
    var radius = circleInfo.km();
    var tmp4 = new RGBA(Colors_getInstance().ec3_1);
    var tmp6 = new RGBA(Colors_getInstance().bc3_1);
    // Inline function 'korlibs.korge.view.circle' call
    var strokeThickness = radius / 5;
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Circle.ajq(numberToDouble(radius), tmp4, tmp6, numberToDouble(strokeThickness), true, renderer);
    // Inline function 'kotlin.apply' call
    var circle = addTo(this_0, container);
    circle.fcw(pos);
    circle.sig(0.7);
    circle.ijb(Companion_getInstance_7().o9g());
  }
  _this__u8e3s4.gl2_1.hl7_1.uie(container);
  return container;
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda$slambda($content) {
  return constructCallableReference(function *($this$launch, $completion) {
    installAreaHighlightOnContractContent(KorgeOnboardingGameFlowListener_getInstance(), $content, 940.0, 195.0, $this$launch);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda($this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var contractInfoDialog = trackOnboardingTemporaryDialog(yield* _this__u8e3s4.smo(true, false, $completion));
    var content = contractInfoDialog.s2f();
    launch($this_coroutineScope, VOID, VOID, KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda$slambda(content));
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_0() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showMovementCardsByRows(_this__u8e3s4, listOf_0(listOf([Companion_getInstance_0().h3l_1, Companion_getInstance_0().i3l_1])), 1.0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_1($dialog) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $dialog._v = yield* showMovementCardsByRows(_this__u8e3s4, listOf([listOf([Companion_getInstance_0().f3l_1, Companion_getInstance_0().h3l_1]), listOf([Companion_getInstance_0().i3l_1, Companion_getInstance_0().g3l_1]), listOf_0(NoMovement_getInstance())]), 1.0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda($dialog) {
  return () => {
    var tmp;
    if ($dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp = $dialog._v;
    }
    tmp.qlq();
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_2($contractInfoDialog, $content) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $contractInfoDialog._v = yield* _this__u8e3s4.smo(true, false, $completion);
    $content._v = ensureNotNull($contractInfoDialog._v).s2f();
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_3($contractInfoDialog, $prev, $rectForContract, $content, $this_coroutineScope, $rectPlayerNumber) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($contractInfoDialog._v == null) {
      tmp = yield* $prev(_this__u8e3s4, $completion);
    }
    var tmp_0 = KorgeOnboardingGameFlowListener_getInstance();
    var tmp_1;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_1 = $content._v;
    }
    $rectForContract._v = installAreaHighlightOnContractContent(tmp_0, tmp_1, 685.0, 170.0, $this_coroutineScope);
    var tmp_2;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_2 = $content._v;
    }
    var tmp_3 = tmp_2;
    var tmp_4 = Vector2D.a9k(0, 0);
    var tmp_5 = Size2D.l9i(270, 380);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $rectPlayerNumber._v = installHighlightOnContent(tmp_3, tmp_4, tmp_5, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_0($rectForContract, $rectPlayerNumber) {
  return () => {
    var tmp0_safe_receiver = $rectForContract._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    var tmp1_safe_receiver = $rectPlayerNumber._v;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_4($contractInfoDialog, $prev, $rectForWinConditions, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($contractInfoDialog._v == null) {
      tmp = yield* $prev(_this__u8e3s4, $completion);
    }
    var tmp_0 = KorgeOnboardingGameFlowListener_getInstance();
    var tmp_1;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_1 = $content._v;
    }
    $rectForWinConditions._v = installAreaHighlightOnContractContent(tmp_0, tmp_1, 1232.0, 315.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_1($rectForWinConditions, $contractInfoDialog) {
  return () => {
    var tmp0_safe_receiver = $rectForWinConditions._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    var tmp1_safe_receiver = $contractInfoDialog._v;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.qlq();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_5($highlightedAllSettlers) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $highlightedAllSettlers._v = invoke$highlightSettlers(_this__u8e3s4, null);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_2($highlightedAllSettlers) {
  return () => {
    var tmp0_safe_receiver = $highlightedAllSettlers._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_6($highlightedFarmers) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $highlightedFarmers._v = invoke$highlightSettlers(_this__u8e3s4, FarmerType_getInstance());
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_3($highlightedFarmers) {
  return () => {
    var tmp0_safe_receiver = $highlightedFarmers._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_7($highlightedNobles) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $highlightedNobles._v = invoke$highlightSettlers(_this__u8e3s4, NobleType_getInstance());
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_4($highlightedNobles) {
  return () => {
    var tmp0_safe_receiver = $highlightedNobles._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_8($costs, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp = Vector2D.a9k(3080, 5180);
    var tmp_0 = Size2D.l9i(2000, 200);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $costs._v = installHighlightOnContent(_this__u8e3s4.gl2_1.hl7_1, tmp, tmp_0, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_5($costs) {
  return () => {
    var tmp0_safe_receiver = $costs._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_9($phases, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp = Vector2D.a9k(70, 1600);
    var tmp_0 = Size2D.l9i(580, 3600);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $phases._v = installHighlightOnContent(_this__u8e3s4.gl2_1.hl7_1, tmp, tmp_0, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_6($phases) {
  return () => {
    var tmp0_safe_receiver = $phases._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_10($dayPhase, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp = Vector2D.a9k(70, 3100);
    var tmp_0 = Size2D.l9i(580, 1000);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $dayPhase._v = installHighlightOnContent(_this__u8e3s4.gl2_1.hl7_1, tmp, tmp_0, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_7($dayPhase) {
  return () => {
    var tmp0_safe_receiver = $dayPhase._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_11() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showCardsByRows(_this__u8e3s4, listOf([listOf_0(new RageCard(0)), listOf_0(DisappearCard_getInstance())]), 1.5, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_12() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showDifferentCardTypes(_this__u8e3s4, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_13() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showCardsByRows(_this__u8e3s4, listOf([listOf([SilverArrowCard_getInstance(), new TrackCard(Iona_getInstance())]), listOf([new FireTrapCard(0), new SmokeBombCard(0)])]), 1.2, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_14($lastCardsDialog) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $lastCardsDialog._v = yield* showCardsByRows(_this__u8e3s4, listOf([listOf([AurorasPassage_getInstance(), new DisperseCard(0)]), listOf([new FireTrapCard(0), new SmokeBombCard(0)])]), 1.2, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_8($lastCardsDialog) {
  return () => {
    var tmp;
    if ($lastCardsDialog._v == null) {
      throwUninitializedPropertyAccessException('lastCardsDialog');
    } else {
      tmp = $lastCardsDialog._v;
    }
    tmp.qlq();
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_15($nightPhase, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp = Vector2D.a9k(70, 4200);
    var tmp_0 = Size2D.l9i(580, 1000);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $nightPhase._v = installHighlightOnContent(_this__u8e3s4.gl2_1.hl7_1, tmp, tmp_0, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_9($nightPhase) {
  return () => {
    var tmp0_safe_receiver = $nightPhase._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_16($rewardSubPhase, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp = Vector2D.a9k(70, 4320);
    var tmp_0 = Size2D.l9i(580, 130);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $rewardSubPhase._v = installHighlightOnContent(_this__u8e3s4.gl2_1.hl7_1, tmp, tmp_0, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_10($rewardSubPhase) {
  return () => {
    var tmp0_safe_receiver = $rewardSubPhase._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_17($contractInfoDialog, $content) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $contractInfoDialog._v = yield* _this__u8e3s4.smo(true, false, $completion);
    $content._v = $contractInfoDialog._v.s2f();
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_18($secondTimeContract, $firstReward, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* $secondTimeContract(_this__u8e3s4, $completion);
    var tmp;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp = $content._v;
    }
    var tmp_0 = tmp;
    var tmp_1 = Vector2D.d9t(57.0, 1605);
    var tmp_2 = Size2D.l9i(700, 360);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $firstReward._v = installHighlightOnContent(tmp_0, tmp_1, tmp_2, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_11($firstReward) {
  return () => {
    var tmp0_safe_receiver = $firstReward._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_19($contractInfoDialog, $secondTimeContract, $sameRewardCondition, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($contractInfoDialog._v == null) {
      tmp = yield* $secondTimeContract(_this__u8e3s4, $completion);
    }
    var tmp_0;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_0 = $content._v;
    }
    var tmp_1 = tmp_0;
    var tmp_2 = Vector2D.a9k(80, 1620);
    var tmp_3 = Size2D.l9i(225, 730);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $sameRewardCondition._v = installHighlightOnContent(tmp_1, tmp_2, tmp_3, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_12($sameRewardCondition, $contractInfoDialog) {
  return () => {
    var tmp0_safe_receiver = $sameRewardCondition._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.uih();
    }
    var tmp1_safe_receiver = $contractInfoDialog._v;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.qlq();
    }
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_20($dialog) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $dialog._v = yield* showCardsByRows(_this__u8e3s4, listOf_0(listOf_0(new SmokeBombCard(0))), 2.0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_13($dialog) {
  return () => {
    var tmp;
    if ($dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp = $dialog._v;
    }
    tmp.qlq();
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_21($dialog) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $dialog._v = yield* showCardsByRows(_this__u8e3s4, listOf_0(listOf_0(new FlareCard(0))), 2.0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_14($dialog) {
  return () => {
    var tmp;
    if ($dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp = $dialog._v;
    }
    tmp.qlq();
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_22($isOutpost, $dialog) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var card = $isOutpost ? new OutpostCard(0) : BladeOfValhCard_getInstance();
    $dialog._v = yield* showCardsByRows(_this__u8e3s4, listOf_0(listOf_0(card)), 2.0, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_15($dialog) {
  return () => {
    var tmp;
    if ($dialog._v == null) {
      throwUninitializedPropertyAccessException('dialog');
    } else {
      tmp = $dialog._v;
    }
    tmp.qlq();
    return Unit_instance;
  };
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_23($bolginInfoDialog, $content) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $bolginInfoDialog._v = yield* showCharacterBoardForOnboarding(_this__u8e3s4, Bolgin_getInstance(), $completion);
    var tmp = ensureNotNull($bolginInfoDialog._v).s2f();
    $content._v = single((tmp instanceof Container ? tmp : THROW_CCE()).xi1_1);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_24($bolginInfoDialog, $prev1, $highlightedInfo, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($bolginInfoDialog._v == null) {
      tmp = yield* $prev1(_this__u8e3s4, $completion);
    }
    var tmp_0;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_0 = $content._v;
    }
    var tmp_1 = tmp_0;
    var tmp_2 = Vector2D.a9k(75, 1320);
    var tmp_3 = Size2D.l9i(205, 205);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $highlightedInfo._v = installHighlightOnContent(tmp_1, tmp_2, tmp_3, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_25($bolginInfoDialog, $prev1, $highlightedInfo, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($bolginInfoDialog._v == null) {
      tmp = yield* $prev1(_this__u8e3s4, $completion);
    }
    var tmp_0;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_0 = $content._v;
    }
    var tmp_1 = tmp_0;
    var tmp_2 = Vector2D.a9k(1220, 1325);
    var tmp_3 = Size2D.l9i(200, 200);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $highlightedInfo._v = installHighlightOnContent(tmp_1, tmp_2, tmp_3, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_26() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showCardsByRows(_this__u8e3s4, listOf([listOf([SummonPolypCard_getInstance(), BeastlyTongueCard_getInstance()]), listOf([EngorgeCard_getInstance(), LeapCard_getInstance()])]), 1.2, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_27($bolginInfoDialog, $content) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $bolginInfoDialog._v = yield* showCharacterBoardForOnboarding(_this__u8e3s4, Bolgin_getInstance(), $completion);
    var tmp = $bolginInfoDialog._v.s2f();
    $content._v = single((tmp instanceof Container ? tmp : THROW_CCE()).xi1_1);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_28($prev2, $highlightedInfo, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* $prev2(_this__u8e3s4, $completion);
    var tmp;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp = $content._v;
    }
    var tmp_0 = tmp;
    var tmp_1 = Vector2D.a9k(35, 1540);
    var tmp_2 = Size2D.l9i(1430, 940);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $highlightedInfo._v = installHighlightOnContent(tmp_0, tmp_1, tmp_2, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_29($bolginInfoDialog, $prev2, $highlightedInfo, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($bolginInfoDialog._v == null) {
      tmp = yield* $prev2(_this__u8e3s4, $completion);
    }
    var tmp_0;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_0 = $content._v;
    }
    var tmp_1 = tmp_0;
    var tmp_2 = Vector2D.a9k(35, 2500);
    var tmp_3 = Size2D.l9i(355, 395);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    $highlightedInfo._v = installHighlightOnContent(tmp_1, tmp_2, tmp_3, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_30($bolginInfoDialog, $prev2, $content, $this_coroutineScope) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var tmp;
    if ($bolginInfoDialog._v == null) {
      tmp = yield* $prev2(_this__u8e3s4, $completion);
    }
    var tmp_0;
    if ($content._v == null) {
      throwUninitializedPropertyAccessException('content');
    } else {
      tmp_0 = $content._v;
    }
    var tmp_1 = tmp_0;
    var tmp_2 = Vector2D.a9k(395, 2500);
    var tmp_3 = Size2D.l9i(460, 410);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var tmp$ret$0 = new RectCorners(numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0), numberToDouble(5.0));
    installHighlightOnContent(tmp_1, tmp_2, tmp_3, tmp$ret$0, 20.0, $this_coroutineScope);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_31() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showCardsByRows(_this__u8e3s4, listOf([listOf([new TrackCard(Helga_getInstance()), new HuntCard(Helga_getInstance())]), listOf_0(SeerCard_getInstance())]), 1.2, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_32() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showCharacterBoardForOnboarding(_this__u8e3s4, Helga_getInstance(), $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_33() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    yield* showCardsByRows(_this__u8e3s4, listOf([listOf([new TrackCard(Varja_getInstance()), new HuntCard(Varja_getInstance())]), listOf_0(CommandCard_getInstance())]), 1.2, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_34($ionaCardsDialog) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    $ionaCardsDialog._v = yield* showCardsByRows(_this__u8e3s4, listOf([listOf([new TrackCard(Iona_getInstance()), new HuntCard(Iona_getInstance())]), listOf_0(SilverArrowCard_getInstance())]), 1.2, $completion);
    return Unit_instance;
  }, 1);
}
function KorgeOnboardingGameFlowListener$presentSequence$slambda($sequence, $holder) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var hints = $sequence.qdz_1.p1();
    // Inline function 'kotlin.with' call
    var $this$with = $holder;
    switch ($sequence.w1_1) {
      case 5:
        var tmp = KorgeOnboardingGameFlowListener_getInstance();
        tmp.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda($this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        break;
      case 6:
        var tmp_0 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_0.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_0();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var dialog = {_v: null};
        var tmp_1 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_1.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_1(dialog);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_2 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_2, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda(dialog));
        break;
      case 0:
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var contractInfoDialog = {_v: null};
        var content = {_v: null};
        var tmp_3 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_3.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_2(contractInfoDialog, content);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var rectForContract = {_v: null};
        var rectPlayerNumber = {_v: null};
        var prev = KorgeOnboardingGameFlowListener_getInstance().bll_1;
        var tmp_4 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_4.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_3(contractInfoDialog, prev, rectForContract, content, $this$coroutineScope, rectPlayerNumber);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_5 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_5, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_0(rectForContract, rectPlayerNumber));
        var rectForWinConditions = {_v: null};
        var tmp_6 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_6.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_4(contractInfoDialog, prev, rectForWinConditions, content, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_7 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_7, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_1(rectForWinConditions, contractInfoDialog));
        var highlightedAllSettlers = {_v: null};
        try {
          var tmp_8 = KorgeOnboardingGameFlowListener_getInstance();
          tmp_8.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_5(highlightedAllSettlers);
          yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        }finally {
          var tmp_9 = KorgeOnboardingGameFlowListener_getInstance();
          clearAfterInfoDialogs(tmp_9, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_2(highlightedAllSettlers));
        }

        var highlightedFarmers = {_v: null};
        try {
          var tmp_10 = KorgeOnboardingGameFlowListener_getInstance();
          tmp_10.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_6(highlightedFarmers);
          yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        }finally {
          var tmp_11 = KorgeOnboardingGameFlowListener_getInstance();
          clearAfterInfoDialogs(tmp_11, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_3(highlightedFarmers));
        }

        var highlightedNobles = {_v: null};
        try {
          var tmp_12 = KorgeOnboardingGameFlowListener_getInstance();
          tmp_12.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_7(highlightedNobles);
          yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        }finally {
          var tmp_13 = KorgeOnboardingGameFlowListener_getInstance();
          clearAfterInfoDialogs(tmp_13, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_4(highlightedNobles));
        }

        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var costs = {_v: null};
        var tmp_14 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_14.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_8(costs, $this$coroutineScope);
        KorgeOnboardingGameFlowListener_getInstance().ee0(-868, -1176, 0.3845);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_15 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_15, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_5(costs));
        var phases = {_v: null};
        var tmp_16 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_16.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_9(phases, $this$coroutineScope);
        KorgeOnboardingGameFlowListener_getInstance().ee0(0, -243, 0.2117);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_17 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_17, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_6(phases));
        var dayPhase = {_v: null};
        var tmp_18 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_18.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_10(dayPhase, $this$coroutineScope);
        KorgeOnboardingGameFlowListener_getInstance().ee0(0, -1320, 0.4883);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_19 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_19, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_7(dayPhase));
        var tmp_20 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_20.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_11();
        KorgeOnboardingGameFlowListener_getInstance().fe0();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_21 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_21.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_12();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_22 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_22.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_13();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var lastCardsDialog = {_v: null};
        var tmp_23 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_23.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_14(lastCardsDialog);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_24 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_24, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_8(lastCardsDialog));
        var nightPhase = {_v: null};
        var tmp_25 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_25.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_15(nightPhase, $this$coroutineScope);
        KorgeOnboardingGameFlowListener_getInstance().ee0(0, -1304, 0.4082);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_26 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_26, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_9(nightPhase));
        var rewardSubPhase = {_v: null};
        var tmp_27 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_27.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_16(rewardSubPhase, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_28 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_28, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_10(rewardSubPhase));
        var secondTimeContract = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_17(contractInfoDialog, content);
        var firstReward = {_v: null};
        var tmp_29 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_29.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_18(secondTimeContract, firstReward, content, $this$coroutineScope);
        KorgeOnboardingGameFlowListener_getInstance().fe0();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_30 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_30, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_11(firstReward));
        var sameRewardCondition = {_v: null};
        var tmp_31 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_31.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_19(contractInfoDialog, secondTimeContract, sameRewardCondition, content, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_32 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_32, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_12(sameRewardCondition, contractInfoDialog));
        closeLastInfoDialog();
        break;
      case 7:
        var dialog_0 = {_v: null};
        var tmp_33 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_33.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_20(dialog_0);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_34 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_34, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_13(dialog_0));
        closeLastInfoDialog();
        break;
      case 8:
        var dialog_1 = {_v: null};
        var tmp_35 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_35.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_21(dialog_1);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_36 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_36, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_14(dialog_1));
        closeLastInfoDialog();
        break;
      case 9:
      case 10:
        var dialog_2 = {_v: null};
        var isOutpost = $sequence.equals(OnboardingSequence_Outpost_getInstance());
        var tmp_37 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_37.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_22(isOutpost, dialog_2);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_38 = KorgeOnboardingGameFlowListener_getInstance();
        clearAfterInfoDialogs(tmp_38, $this$with, KorgeOnboardingGameFlowListener$presentSequence$slambda$lambda_15(dialog_2));
        break;
      case 1:
        var bolginInfoDialog = {_v: null};
        var content_0 = {_v: null};
        var highlightedInfo = {_v: null};
        var tmp_39 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_39.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_23(bolginInfoDialog, content_0);
        var prev1 = KorgeOnboardingGameFlowListener_getInstance().bll_1;
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_40 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_40.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_24(bolginInfoDialog, prev1, highlightedInfo, content_0, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp1_safe_receiver = highlightedInfo._v;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.uih();
        }

        var tmp_41 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_41.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_25(bolginInfoDialog, prev1, highlightedInfo, content_0, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_42 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_42.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_26();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_43 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_43.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_27(bolginInfoDialog, content_0);
        var prev2 = KorgeOnboardingGameFlowListener_getInstance().bll_1;
        var tmp_44 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_44.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_28(prev2, highlightedInfo, content_0, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp2_safe_receiver = highlightedInfo._v;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.uih();
        }

        var tmp_45 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_45.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_29(bolginInfoDialog, prev2, highlightedInfo, content_0, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp3_safe_receiver = highlightedInfo._v;
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.uih();
        }

        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp4_safe_receiver = highlightedInfo._v;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.uih();
        }

        var tmp_46 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_46.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_30(bolginInfoDialog, prev2, content_0, $this$coroutineScope);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        break;
      case 2:
        var tmp_47 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_47.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_31();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        var tmp_48 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_48.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_32();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        break;
      case 3:
        var tmp_49 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_49.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_33();
        yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        break;
      case 4:
        var ionaCardsDialog = {_v: null};
        var tmp_50 = KorgeOnboardingGameFlowListener_getInstance();
        tmp_50.bll_1 = KorgeOnboardingGameFlowListener$presentSequence$slambda$slambda_34(ionaCardsDialog);
        try {
          yield* /*#__NOINLINE__*/invoke$showNext($holder, hints, $completion);
        }finally {
          var tmp5_safe_receiver = ionaCardsDialog._v;
          if (tmp5_safe_receiver == null)
            null;
          else {
            tmp5_safe_receiver.qlq();
          }
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    // Inline function 'kotlin.check' call
    if (!!hints.q1()) {
      var message = 'Presentation omitted hints from ' + $sequence.toString();
      throw IllegalStateException.o(toString(message));
    }
    cancelChildren_0($this$coroutineScope.d1m());
    return Unit_instance;
  }, 1);
}
var KorgeOnboardingGameFlowListener_instance;
function KorgeOnboardingGameFlowListener_getInstance() {
  if (KorgeOnboardingGameFlowListener_instance === VOID)
    new KorgeOnboardingGameFlowListener();
  return KorgeOnboardingGameFlowListener_instance;
}
function closeOnboardingTemporaryDialogs() {
  _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = get_onboardingTemporaryDialogs().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.qlq();
  }
  get_onboardingTemporaryDialogs().a5();
}
function installHighlightOnContent(parent, xy, size, radius, strokeThickness, coroutineScope) {
  _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr();
  var tmp0_safe_receiver = parent instanceof Container ? parent : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp6 = new RGBA(Colors_getInstance().ec3_1);
    // Inline function 'korlibs.korge.view.roundRect' call
    var stroke = new RGBA(Colors_getInstance().bc3_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.rka(size, radius, tmp6, stroke, strokeThickness, true);
    // Inline function 'kotlin.apply' call
    tmp = addTo(this_0, tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp;
  var result = tmp1_safe_receiver == null ? null : xy_0(tmp1_safe_receiver, xy);
  launch(coroutineScope, VOID, VOID, installHighlightOnContent$slambda(result));
  return result;
}
function trackOnboardingTemporaryDialog(dialog) {
  _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr();
  // Inline function 'kotlin.also' call
  get_onboardingTemporaryDialogs().d2(dialog);
  return dialog;
}
function *showMovementCardsByRows(_this__u8e3s4, cardRows, zoom, $completion) {
  return yield* showCardsByRows_0(_this__u8e3s4, cardRows, zoom, showMovementCardsByRows$slambda(_this__u8e3s4), $completion);
}
function *showCardsByRows(_this__u8e3s4, cardRows, zoom, $completion) {
  return yield* showCardsByRows_0(_this__u8e3s4, cardRows, zoom, showCardsByRows$slambda(_this__u8e3s4), $completion);
}
function *showDifferentCardTypes(_this__u8e3s4, $completion) {
  var controlPanelY = new ControlPanelY();
  var cardRows = listOf([listOf([EngorgeCard_getInstance(), new HuntCard(Iona_getInstance())]), listOf([PursuitCard_getInstance(), ChargeCard_getInstance()]), listOf([new FireTrapCard(0), new RageCard(0)])]);
  var zoom = 0.9;
  var _iterator__ex2g4s = cardRows.p1();
  while (_iterator__ex2g4s.q1()) {
    var row = _iterator__ex2g4s.r1();
    var controlPanelX = new ControlPanelX(VOID, VOID, VOID, VOID, get_gameLayout().il6_1 * zoom / 4);
    var _iterator__ex2g4s_0 = row.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var card = _iterator__ex2g4s_0.r1();
      var c = Container.fi2();
      var tmp = yield* (yield* _this__u8e3s4.pl6().kle(card, $completion)).m1q($completion);
      var back = addTo(toHeight(CardUi.tm1(tmp, VOID, VOID, true, VOID, showDifferentCardTypes$slambda()), get_gameLayout().ol5_1 * zoom), c);
      var tmp_0 = yield* (yield* _this__u8e3s4.pl6().mle(card, $completion)).m1q($completion);
      // Inline function 'kotlin.let' call
      var it = xy(toHeight(CardUi.tm1(tmp_0, VOID, VOID, true, VOID, showDifferentCardTypes$slambda_0()), get_gameLayout().ol5_1 * zoom), back.pig() * 0.6, back.rig() * 0.1);
      c.bif(it, 0);
      addTo_0(c, controlPanelX);
    }
    controlPanelY.mlr(controlPanelX.xlb_1);
  }
  var dialogLayout = new BigRightSided(controlPanelY.xlb_1.pig() / 10);
  return trackOnboardingTemporaryDialog(yield* _this__u8e3s4.xmo(DialogContent.llt(controlPanelY.xlb_1, VOID, dialogLayout), get_gameDialogClose(), false, $completion));
}
function *showCharacterBoardForOnboarding(_this__u8e3s4, character, $completion) {
  var boardContainer = Container.fi2();
  // Inline function 'korlibs.korge.view.image' call
  var texture = yield* (yield* _this__u8e3s4.pl6().tle(character, _this__u8e3s4.t6h(), $completion)).m1q($completion);
  var anchor = Companion_getInstance_7().c9g_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.lk7(texture, anchor);
  // Inline function 'kotlin.apply' call
  addTo(this_0, boardContainer);
  if (isInterface(character, HunterCharacter)) {
    toWidth(boardContainer, get_gameLayout().el6_1 * 0.6);
  } else {
    toHeight(boardContainer, get_gameLayout().fl6_1 * get_gameLayout().cl6_1);
  }
  var dialogContent = DialogContent.llt(boardContainer, VOID, new BigRightSided(boardContainer.pig() / 10));
  return trackOnboardingTemporaryDialog(yield* _this__u8e3s4.xmo(dialogContent, showCharacterBoardForOnboarding$slambda(), false, $completion));
}
function *showCardsByRows_0(_this__u8e3s4, cardRows, zoom, fn, $completion) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var bitmapRows = ArrayList.p2();
  yield* coroutineScope(showCardsByRows$slambda_0(cardRows, fn, bitmapRows), $completion);
  return yield* showCardPicturesByRows(_this__u8e3s4, bitmapRows, zoom, $completion);
}
function *showCardPicturesByRows(_this__u8e3s4, bitmapRows, zoom, $completion) {
  var controlPanelY = cardPicturesByRows(zoom, bitmapRows);
  var dialogLayout = new BigRightSided(controlPanelY.xlb_1.pig() / 10);
  return trackOnboardingTemporaryDialog(yield* _this__u8e3s4.xmo(DialogContent.llt(controlPanelY.xlb_1, VOID, dialogLayout), get_gameDialogClose(), false, $completion));
}
function RoundRect$_get_alpha_$ref_jd2wkw(p0) {
  return constructCallableReference(() => p0.tig(), 0, 0, 594, VOID, [p0]);
}
function RoundRect$_set_alpha_$ref_9xrjto(p0) {
  return constructCallableReference((p0_0) => {
    p0.sig(p0_0);
    return Unit_instance;
  }, 1, 0, 595, VOID, [p0]);
}
function installHighlightOnContent$slambda($result) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      while (true) {
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$0 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
        var tmp0_safe_receiver = $result;
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp0 = $result;
          var tmp_0 = KMutableProperty0;
          var tmp_1 = RoundRect$_get_alpha_$ref_jd2wkw(tmp0);
          // Inline function 'korlibs.korge.tween.get' call
          var this_0 = getPropertyCallableRef('alpha', 0, tmp_0, tmp_1, RoundRect$_set_alpha_$ref_9xrjto(tmp0));
          var tmp_2 = [new V2(this_0, 1.0, 0.3, _interpolate$ref(), true)];
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$2 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
          yield* tween(tmp0_safe_receiver, tmp_2, tmp$ret$2, VOID, VOID, VOID, VOID, VOID, $completion);
        }
        var tmp1_safe_receiver = $result;
        if (tmp1_safe_receiver == null)
          null;
        else {
          var tmp0_0 = $result;
          var tmp_3 = KMutableProperty0;
          var tmp_4 = RoundRect$_get_alpha_$ref_jd2wkw(tmp0_0);
          // Inline function 'korlibs.korge.tween.get' call
          var this_1 = getPropertyCallableRef('alpha', 0, tmp_3, tmp_4, RoundRect$_set_alpha_$ref_9xrjto(tmp0_0));
          var tmp_5 = [new V2(this_1, 0.3, 1.0, _interpolate$ref(), true)];
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$4 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
          yield* tween(tmp1_safe_receiver, tmp_5, tmp$ret$4, VOID, VOID, VOID, VOID, VOID, $completion);
        }
      }
      tmp = Unit_instance;
    }finally {
      var tmp2_safe_receiver = $result;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.uih();
      }
    }
    return Unit_instance;
  }, 1);
}
function showMovementCardsByRows$slambda($this_showMovementCardsByRows) {
  return constructCallableReference(function *(movement, $completion) {
    return yield* (yield* $this_showMovementCardsByRows.pl6().wle(movement, $completion)).m1q($completion);
  }, 1);
}
function showCardsByRows$slambda($this_showCardsByRows) {
  return constructCallableReference(function *(card, $completion) {
    return yield* (yield* $this_showCardsByRows.pl6().mle(card, $completion)).m1q($completion);
  }, 1);
}
function showDifferentCardTypes$slambda() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function showDifferentCardTypes$slambda_0() {
  return constructCallableReference(function *($completion) {
    return Unit_instance;
  }, 0);
}
function showCharacterBoardForOnboarding$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return Unit_instance;
  }, 1);
}
function showCardsByRows$slambda_0($cardRows, $fn, $bitmapRows) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var _iterator__ex2g4s = $cardRows.p1();
    while (_iterator__ex2g4s.q1()) {
      var row = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.mutableListOf' call
      var rowList = ArrayList.p2();
      var _iterator__ex2g4s_0 = row.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var card = _iterator__ex2g4s_0.r1();
        rowList.d2(yield* $fn(card, $completion));
      }
      $bitmapRows.d2(rowList);
    }
    return Unit_instance;
  }, 1);
}
var properties_initialized_KorgeOnboardingGameFlowListener_kt_au4ifp;
function _init_properties_KorgeOnboardingGameFlowListener_kt__eiklzr() {
  if (!properties_initialized_KorgeOnboardingGameFlowListener_kt_au4ifp) {
    properties_initialized_KorgeOnboardingGameFlowListener_kt_au4ifp = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    onboardingTemporaryDialogs = LinkedHashSet.v2();
  }
}
function createLinkText(text, url, textSize) {
  // Inline function 'kotlin.apply' call
  var this_0 = PlainText(text, textSize, Colors_getInstance().zc2_1);
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  var $this$mouse = get_mouse(this_0);
  $this$mouse.whw_1.w9y(createLinkText$lambda(this_0));
  $this$mouse.xhw_1.w9y(createLinkText$lambda_0(this_0));
  $this$mouse.vhw_1.w9y(createLinkText$lambda_1(url));
  return this_0;
}
function createLinkText$lambda($$this$apply) {
  return (it) => {
    $$this$apply.zjp(Colors_getInstance().ac4_1);
    set_cursor($$this$apply, Cursor_HAND_getInstance());
    return Unit_instance;
  };
}
function createLinkText$lambda_0($$this$apply) {
  return (it) => {
    $$this$apply.zjp(Colors_getInstance().zc2_1);
    set_cursor($$this$apply, Cursor_DEFAULT_getInstance());
    return Unit_instance;
  };
}
function createLinkText$lambda_1($url) {
  return (it) => {
    openLinkInNewTab($url);
    return Unit_instance;
  };
}
function *startLoading($this, path, $completion) {
  // Inline function 'kotlinx.coroutines.sync.withLock' call
  var this_0 = $this.kld_1;
  yield* this_0.y2a(null, $completion);
  try {
    $this.mld_1.d2(path);
    $this.rld_1 = $this.rld_1 + 1 | 0;
    var state = calculateState($this);
    var tmp0_safe_receiver = $this.old_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o1n();
    }
    $this.old_1 = null;
    if ($this.pld_1) {
      yield* reportProgress($this, state, $completion);
      return Unit_instance;
    }
    var now = System_instance.xu();
    var first = $this.qld_1;
    if (!(first == null) && !$this.pld_1 && $this.nld_1 == null) {
      var tmp = now.pv(first);
      Companion_getInstance();
      // Inline function 'kotlin.time.Companion.milliseconds' call
      var this_1 = multiply(numberToLong(2), $this.hld_1);
      var tmp$ret$2 = toDuration_1(this_1, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(tmp, tmp$ret$2) < 0) {
        $this.pld_1 = true;
        yield* reportProgress($this, state, $completion);
        return Unit_instance;
      } else {
        $this.qld_1 = null;
      }
    }
    if ($this.qld_1 == null) {
      $this.qld_1 = now;
      var tmp1_safe_receiver = $this.nld_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.o1n();
      }
      var tmp_0 = $this;
      tmp_0.nld_1 = launch($this.gld_1, VOID, VOID, LoadingResourceReporter$startLoading$slambda($this));
    }
  }finally {
    this_0.k2a(null);
  }
  return Unit_instance;
}
function *finishLoading($this, path, $completion) {
  // Inline function 'kotlinx.coroutines.sync.withLock' call
  var this_0 = $this.kld_1;
  yield* this_0.y2a(null, $completion);
  try {
    var wasRemoved = $this.lld_1.z4(path);
    if (wasRemoved && $this.lld_1.n1()) {
      var tmp0_safe_receiver = $this.jld_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        yield* tmp0_safe_receiver.hmr($completion);
    }
    $this.mld_1.z4(path);
    $this.sld_1 = $this.sld_1 + 1 | 0;
    yield* reportProgress($this, calculateState($this), $completion);
    if ($this.mld_1.n1()) {
      var tmp1_safe_receiver = $this.old_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.o1n();
      }
      var tmp = $this;
      tmp.old_1 = launch($this.gld_1, VOID, VOID, LoadingResourceReporter$finishLoading$slambda($this));
    }
  }finally {
    this_0.k2a(null);
  }
  return Unit_instance;
}
function *reportProgress($this, state, $completion) {
  var tmp0_safe_receiver = $this.jld_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    yield* tmp0_safe_receiver.dmr(state, $completion);
  return Unit_instance;
}
function calculateState($this) {
  return new LoadingProgressState($this.rld_1, $this.sld_1);
}
function LoadingResourceReporter$startLoading$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    Companion_getInstance();
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = this$0.hld_1;
    var tmp$ret$0 = toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_1 = this$0.kld_1;
    yield* this_1.y2a(null, $completion);
    try {
      if (!this$0.mld_1.n1()) {
        this$0.pld_1 = true;
        yield* /*#__NOINLINE__*/reportProgress(this$0, calculateState(this$0), $completion);
      }
      this$0.nld_1 = null;
    }finally {
      this_1.k2a(null);
    }
    return Unit_instance;
  }, 1);
}
function LoadingResourceReporter$finishLoading$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay_0(this$0.ild_1, $completion);
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.kld_1;
    yield* this_0.y2a(null, $completion);
    try {
      var tmp0_safe_receiver = this$0.jld_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        yield* tmp0_safe_receiver.imr($completion);
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }, 1);
}
function notificationElement(string, background, centered) {
  background = background === VOID ? get_gameColors().slx_1 : background;
  centered = centered === VOID ? true : centered;
  var c = Container.fi2();
  var textSize = get_gameLayout().vl5_1;
  var text = PlainText(string, textSize, get_gameColors().rlx_1);
  var additionalSize = Size2D.y9p(textSize * 1.5, textSize / 2);
  var tmp;
  if (centered) {
    // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
    var this_0 = toPoint(text.nig());
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var this_1 = Vector2D.t9g(-this_0.r9g_1, -this_0.s9g_1);
    tmp = Vector2D.t9g(this_1.r9g_1 / 2, this_1.s9g_1 / 2);
  } else {
    tmp = toPoint(additionalSize.l9s(2));
  }
  text.fcw(tmp);
  var tmp2 = text.nig().f9s(additionalSize);
  Companion_getInstance_11();
  // Inline function 'korlibs.math.geom.Companion.invoke' call
  var corner = text.rig() / 2;
  var tmp4 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
  var tmp6 = new RGBA(background);
  // Inline function 'korlibs.korge.view.roundRect' call
  var stroke = new RGBA(get_gameColors().rlx_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = RoundRect.rka(tmp2, tmp4, tmp6, stroke, 10.0, true);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, c);
  if (centered) {
    // Inline function 'korlibs.korge.view.anchor' call
    anchor(this_3, Anchor2D.p9g(numberToDouble(0.5), numberToDouble(0.5)));
  }
  addTo(text, c);
  return c;
}
function RoundButton$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.ylj_1 = true;
    this$0.ql8();
    return Unit_instance;
  }, 1);
}
function RoundButton$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function RoundButton$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, RoundButton$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function RoundButton$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.ylj_1 = false;
    this$0.ql8();
    return Unit_instance;
  }, 1);
}
function RoundButton$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function RoundButton$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, RoundButton$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function RoundButton$slambda_1($isActive, $onActionInvoked, $onRightClick) {
  return constructCallableReference(function *(it, $completion) {
    switch (it.xhy().w1_1) {
      case 0:
        if ($isActive)
          yield* $onActionInvoked($completion);
        break;
      case 2:
        var tmp1_safe_receiver = $onRightClick;
        if (tmp1_safe_receiver == null)
          null;
        else
          yield* tmp1_safe_receiver($completion);
        break;
      default:
        break;
    }
    return Unit_instance;
  }, 1);
}
function RoundButton$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function RoundButton$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, RoundButton$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function addScrollableGameRows(_this__u8e3s4, rows) {
  var availableWidth = get_gameLayout().kl6_1 - 2 * get_gameLayout().zl5_1;
  var availableHeight = get_gameLayout().fl6_1 * get_gameLayout().pl5_1 - 2 * get_gameLayout().zl5_1;
  var tmp0 = _this__u8e3s4.xlb_1.w9z();
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = rows.xlb_1.w9z();
  var contentWidth = Math.max(tmp0, b);
  // Inline function 'kotlin.comparisons.minOf' call
  var b_0 = availableWidth / contentWidth;
  var tmp$ret$1 = Math.min(1.0, b_0);
  _this__u8e3s4.xlb_1.uif(tmp$ret$1);
  var viewport = VerticalScrollViewport.amg();
  addTo(rows.xlb_1, viewport.xmf_1);
  var tmp0_0 = rows.xlb_1.x9z();
  // Inline function 'kotlin.comparisons.minOf' call
  var b_1 = coerceAtLeast(availableHeight / _this__u8e3s4.xlb_1.vif() - _this__u8e3s4.dlr_1, 0.0);
  var tmp$ret$2 = Math.min(tmp0_0, b_1);
  viewport.hml(tmp$ret$2, VOID, 0.0);
  addTo_0(viewport, _this__u8e3s4);
}
function ShaderButtonBackground$ButtonUB$_get_u_Size_$ref_3wbedx() {
  return constructCallableReference((p0) => p0.cmy(), 1, 0, 596);
}
function ShaderButtonBackground$ButtonUB$_get_u_Margin_$ref_azhadk() {
  return constructCallableReference((p0) => p0.dmy(), 1, 0, 597);
}
function ShaderButtonBackground$ButtonUB$_get_u_Hover_$ref_sz4kaw() {
  return constructCallableReference((p0) => p0.emy(), 1, 0, 598);
}
function ShaderButtonBackground$ButtonUB$_get_u_Enabled_$ref_rhuajh() {
  return constructCallableReference((p0) => p0.fmy(), 1, 0, 599);
}
function ShaderButtonBackground$ButtonUB$_get_u_Highlights_$ref_pp9iuh() {
  return constructCallableReference((p0) => p0.gmy(), 1, 0, 600);
}
function ShaderButtonBackground$ButtonUB$_get_u_OuterGlow_$ref_55sfxg() {
  return constructCallableReference((p0) => p0.hmy(), 1, 0, 601);
}
function ShaderButtonBackground$ButtonUB$_get_u_InnerGlow_$ref_4v8vfj() {
  return constructCallableReference((p0) => p0.imy(), 1, 0, 602);
}
function ShaderButtonBackground$ButtonUB$_get_u_Radius_$ref_jt75no() {
  return constructCallableReference((p0) => p0.jmy(), 1, 0, 603);
}
function ShaderButtonBackground$ButtonUB$_get_u_Border_$ref_71fitm() {
  return constructCallableReference((p0) => p0.kmy(), 1, 0, 604);
}
function ShaderButtonBackground$ButtonUB$_get_u_EdgePositions_$ref_kb1yfd() {
  return constructCallableReference((p0) => p0.lmy(), 1, 0, 605);
}
function ShaderButtonBackground$ButtonUB$_get_u_EdgeWidths_$ref_xyrqxg() {
  return constructCallableReference((p0) => p0.mmy(), 1, 0, 606);
}
function ShaderButtonBackground$ButtonUB$_get_u_TopCornerGains_$ref_b9ek8k() {
  return constructCallableReference((p0) => p0.nmy(), 1, 0, 607);
}
function ShaderButtonBackground$ButtonUB$_get_u_BottomCornerGains_$ref_l18tgw() {
  return constructCallableReference((p0) => p0.omy(), 1, 0, 608);
}
function ShaderButtonBackground$ButtonUB$_get_u_TopCornerSpreads_$ref_buncxs() {
  return constructCallableReference((p0) => p0.pmy(), 1, 0, 609);
}
function ShaderButtonBackground$ButtonUB$_get_u_BottomCornerSpreads_$ref_7mk9yc() {
  return constructCallableReference((p0) => p0.qmy(), 1, 0, 610);
}
function ShaderButtonBackground$ButtonUB$_get_u_Variation_$ref_l8twb5() {
  return constructCallableReference((p0) => p0.rmy(), 1, 0, 611);
}
function makeEdgeHighlights($this, seed) {
  var random = Random(toBits(seed));
  return new HighlightPattern(makeEdgeHighlights$pair(random, 0.22, 0.78), makeEdgeHighlights$pair(random, 10.0, 19.0), makeEdgeHighlights$pair(random, 0.88, 1.12), makeEdgeHighlights$pair(random, 0.88, 1.12), makeEdgeHighlights$pair(random, 0.9, 1.1), makeEdgeHighlights$pair(random, 0.9, 1.1));
}
function makeEdgeHighlights$pair(random, min, max) {
  return Vector2D.t9g(random.or(min, max), random.or(min, max));
}
var ButtonUB_instance;
function ButtonUB_getInstance() {
  if (ButtonUB_instance === VOID)
    new ButtonUB();
  return ButtonUB_instance;
}
var Companion_instance_4;
function Companion_getInstance_18() {
  if (Companion_instance_4 === VOID)
    new Companion();
  return Companion_instance_4;
}
function get_fonts() {
  _init_properties_TextUtils_kt__cenejy();
  return fonts;
}
var fonts;
function BorderedText(text, textSize, color) {
  color = color === VOID ? Colors_getInstance().zc2_1 : color;
  _init_properties_TextUtils_kt__cenejy();
  return Text.aj6(text, textSize, color, outlinedFont(TextStyle_Bordered_getInstance(), 128));
}
var TextStyle_Plain_instance;
var TextStyle_Outlined_instance;
var TextStyle_Bordered_instance;
var TextStyle_entriesInitialized;
function TextStyle_initEntries() {
  if (TextStyle_entriesInitialized)
    return Unit_instance;
  TextStyle_entriesInitialized = true;
  TextStyle_Plain_instance = new TextStyle('Plain', 0);
  TextStyle_Outlined_instance = new TextStyle('Outlined', 1);
  TextStyle_Bordered_instance = new TextStyle('Bordered', 2);
}
function outlinedFont(textStyle, textSize) {
  _init_properties_TextUtils_kt__cenejy();
  var tmp0 = get_fonts();
  // Inline function 'kotlin.collections.getOrPut' call
  var key = to(textStyle, textSize);
  var value = tmp0.w4(key);
  var tmp;
  if (value == null) {
    var tmp_0;
    switch (textStyle.w1_1) {
      case 0:
        tmp_0 = null;
        break;
      case 2:
        tmp_0 = new BitmapEffect(VOID, VOID, VOID, VOID, VOID, numberToInt(textSize / 20.0));
        break;
      case 1:
        var shadowSize = numberToInt(textSize / 35.0);
        tmp_0 = new BitmapEffect(VOID, shadowSize, shadowSize, shadowSize);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var effect = tmp_0;
    var answer = createBitmapFontFromFontAdjusted(get_DefaultTtfFont(), textSize, VOID, VOID, VOID, true, effect);
    tmp0.b5(key, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  return tmp;
}
function createBitmapFontFromFontAdjusted(font, fontSize, chars, fontName, paint, mipmaps_0, effect) {
  chars = chars === VOID ? Companion_getInstance_17().kcn_1 : chars;
  fontName = fontName === VOID ? font.h1() : fontName;
  paint = paint === VOID ? new RGBA(Colors_getInstance().zc2_1) : paint;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  effect = effect === VOID ? null : effect;
  _init_properties_TextUtils_kt__cenejy();
  var fontSizeD = numberToDouble(fontSize);
  var fmetrics = font.yck(fontSizeD);
  // Inline function 'kotlin.collections.map' call
  var this_0 = chars.lcn_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(this_0.length);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp$ret$2 = font.gcl(fontSizeD, item, VOID, null);
    destination.d2(tmp$ret$2);
  }
  var glyphMetrics = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.n2(collectionSizeOrDefault(glyphMetrics, 10));
  var _iterator__ex2g4s = glyphMetrics.p1();
  while (_iterator__ex2g4s.q1()) {
    var item_0 = _iterator__ex2g4s.r1();
    var tmp$ret$5 = (item_0.w9z() + 4) * (fmetrics.fck() + 4);
    destination_0.d2(tmp$ret$5);
  }
  var requiredArea = toIntCeil(sum_0(destination_0));
  // Inline function 'kotlin.math.sqrt' call
  var tmp$ret$6 = Math.sqrt(requiredArea);
  var requiredAreaSide = toIntCeil_0(tmp$ret$6);
  var matlas = MutableAtlas.oc1(get_nextPowerOfTwo(requiredAreaSide), get_nextPowerOfTwo(requiredAreaSide));
  var border = 2;
  var indexedObject = chars.lcn_1;
  var inductionVariable_0 = 0;
  var last_0 = indexedObject.length;
  while (inductionVariable_0 < last_0) {
    var codePoint = indexedObject[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var result = renderGlyphToBitmap(font, fontSizeD, codePoint, paint, true, effect, 1);
    matlas.qc1(result.bcq_1.ec2().scc(), result);
  }
  var fm = first(matlas.sc0_1).jc0_1.ccq_1;
  mipmaps(matlas.qc0_1, mipmaps_0);
  var base = fontSizeD * 0.88;
  var tmp4 = fmetrics.fck();
  // Inline function 'kotlin.collections.associate' call
  var this_1 = matlas.sc0_1;
  var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_1 = LinkedHashMap.cd(capacity);
  var _iterator__ex2g4s_0 = this_1.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element = _iterator__ex2g4s_0.r1();
    var slice = element.ic0_1;
    var g = first(element.jc0_1.ecq_1);
    var m = g.ucq_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(g.scq_1, new Glyph(fontSizeD, g.scq_1, slice, -border | 0, numberToInt(border - m.x9z() - m.x9h()) + numberToInt(base) | 0, toIntCeil(m.ecl_1)));
    destination_1.b5(pair.pm_1, pair.qm_1);
  }
  var tmp8 = toIntMap(destination_1);
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var kernings = IntMap.fa7();
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(tmp4), numberToDouble(base), tmp8, kernings, fontName, null);
}
function PlainText(text, textSize, color) {
  color = color === VOID ? Colors_getInstance().zc2_1 : color;
  _init_properties_TextUtils_kt__cenejy();
  return Text.aj6(text, textSize, color, outlinedFont(TextStyle_Plain_getInstance(), 128));
}
function OutlinedText(text, textSize, color) {
  color = color === VOID ? Colors_getInstance().zc2_1 : color;
  _init_properties_TextUtils_kt__cenejy();
  return Text.aj6(text, textSize, color, outlinedFont(TextStyle_Outlined_getInstance(), 128));
}
function TextStyle_Plain_getInstance() {
  TextStyle_initEntries();
  return TextStyle_Plain_instance;
}
function TextStyle_Outlined_getInstance() {
  TextStyle_initEntries();
  return TextStyle_Outlined_instance;
}
function TextStyle_Bordered_getInstance() {
  TextStyle_initEntries();
  return TextStyle_Bordered_instance;
}
var properties_initialized_TextUtils_kt_ts4a0k;
function _init_properties_TextUtils_kt__cenejy() {
  if (!properties_initialized_TextUtils_kt_ts4a0k) {
    properties_initialized_TextUtils_kt_ts4a0k = true;
    // Inline function 'kotlin.collections.mutableMapOf' call
    fonts = LinkedHashMap.m7();
  }
}
function willBeRemoved($this) {
  return minus($this.uln_1.x4(), $this.vln_1);
}
function get_cachedGlowBitmap() {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  var tmp0 = cachedGlowBitmap$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('cachedGlowBitmap', 0, tmp, _get_cachedGlowBitmap_$ref_jra04c(), null);
  return tmp0.k3();
}
var cachedGlowBitmap$delegate;
function makeGlowBitmap(size) {
  size = size === VOID ? 256 : size;
  _init_properties_UiKorgeUtils_kt__85pdkp();
  var bmp = Bitmap32.lc1(size, size);
  var cx = (size - 1 | 0) * 0.5;
  var cy = (size - 1 | 0) * 0.5;
  var radius = size * 0.45;
  var invR = 1.0 / radius;
  var stops = listOf([new makeGlowBitmap$Stop(0.0, Companion_getInstance_15().ich(255, 255, 255, 255)), new makeGlowBitmap$Stop(0.25, Companion_getInstance_15().ich(0, 255, 255, 230)), new makeGlowBitmap$Stop(1.0, Companion_getInstance_15().ich(0, 255, 255, 0))]);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var dy = y - cy;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < size)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dx = x - cx;
          // Inline function 'kotlin.math.sqrt' call
          var x_0 = dx * dx + dy * dy;
          var d = Math.sqrt(x_0) * invR;
          var c = d <= 1.0 ? makeGlowBitmap$sample(stops, d) : Companion_getInstance_15().ich(0, 0, 0, 0);
          bmp.uc2(x, y, c);
        }
         while (inductionVariable_0 < size);
    }
     while (inductionVariable < size);
  return bmp;
}
function toHeight(_this__u8e3s4, shouldBeHeight) {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  _this__u8e3s4.qig(shouldBeHeight);
  _this__u8e3s4.wif(_this__u8e3s4.zif());
  return _this__u8e3s4;
}
function toWidth(_this__u8e3s4, shouldBeWidth) {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  _this__u8e3s4.oig(shouldBeWidth);
  _this__u8e3s4.yif(_this__u8e3s4.xif());
  return _this__u8e3s4;
}
function get_centerAndSize(_this__u8e3s4) {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  if (isInterface(_this__u8e3s4, Anchorable)) {
    return new CenterAndSize(_this__u8e3s4.wb5(), _this__u8e3s4.nig());
  } else {
    // Inline function 'kotlin.let' call
    var it = _this__u8e3s4.nig();
    var tmp0 = _this__u8e3s4.wb5();
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = toPoint(it.l9s(2));
    var tmp$ret$2 = Vector2D.t9g(tmp0.r9g_1 + that.r9g_1, tmp0.s9g_1 + that.s9g_1);
    return new CenterAndSize(tmp$ret$2, it);
  }
}
function toContainerOrSelf(_this__u8e3s4) {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  var tmp0_elvis_lhs = singleOrNull(_this__u8e3s4);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = Container.fi2();
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var e = _iterator__ex2g4s.r1();
      this_0.uie(e);
    }
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function createGlowImage() {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  return Image.lk7(get_cachedGlowBitmap());
}
var LinearEasing_instance;
function LinearEasing_getInstance() {
  return LinearEasing_instance;
}
function scaleToHeight(_this__u8e3s4, newHeight) {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  return Size2D.y9p(_this__u8e3s4.j9i_1 * newHeight / _this__u8e3s4.k9i_1, newHeight);
}
function scaleToWidth(_this__u8e3s4, newWidth) {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  return Size2D.y9p(newWidth, _this__u8e3s4.k9i_1 * newWidth / _this__u8e3s4.j9i_1);
}
function cachedGlowBitmap$delegate$lambda() {
  _init_properties_UiKorgeUtils_kt__85pdkp();
  return makeGlowBitmap(256);
}
function _get_cachedGlowBitmap_$ref_jra04c() {
  return constructCallableReference(() => get_cachedGlowBitmap(), 0, 0, 612);
}
function makeGlowBitmap$lerp(a, b, t) {
  return coerceIn_0(numberToInt(a + (b - a | 0) * t), 0, 255);
}
function makeGlowBitmap$sample(stops, t) {
  var tt = coerceIn_1(t, 0.0, 1.0);
  var i = 0;
  while ((i + 1 | 0) < stops.s2() && tt > stops.u2(i + 1 | 0).cmz_1) {
    i = i + 1 | 0;
  }
  var s0 = stops.u2(i);
  var tmp0 = i + 1 | 0;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_lastIndex(stops);
  var tmp$ret$0 = Math.min(tmp0, b);
  var s1 = stops.u2(tmp$ret$0);
  // Inline function 'kotlin.takeIf' call
  var this_0 = s1.cmz_1 - s0.cmz_1;
  var tmp;
  if (this_0 > 1.0E-9) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var span = tmp0_elvis_lhs == null ? 1.0 : tmp0_elvis_lhs;
  var u = coerceIn_1((tt - s0.cmz_1) / span, 0.0, 1.0);
  var c0 = s0.dmz_1;
  var c1 = s1.dmz_1;
  return Companion_getInstance_15().ich(makeGlowBitmap$lerp(_RGBA___get_r__impl__duz7mo(c0), _RGBA___get_r__impl__duz7mo(c1), u), makeGlowBitmap$lerp(_RGBA___get_g__impl__o8pukr(c0), _RGBA___get_g__impl__o8pukr(c1), u), makeGlowBitmap$lerp(_RGBA___get_b__impl__m6tl80(c0), _RGBA___get_b__impl__m6tl80(c1), u), makeGlowBitmap$lerp(_RGBA___get_a__impl__6msvu7(c0), _RGBA___get_a__impl__6msvu7(c1), u));
}
var properties_initialized_UiKorgeUtils_kt_gqt0zf;
function _init_properties_UiKorgeUtils_kt__85pdkp() {
  if (!properties_initialized_UiKorgeUtils_kt_gqt0zf) {
    properties_initialized_UiKorgeUtils_kt_gqt0zf = true;
    cachedGlowBitmap$delegate = lazy(cachedGlowBitmap$delegate$lambda);
  }
}
function VerticalEdgeFadeFilter$FadeUB$_get_u_FadeRatio_$ref_5ch4ot() {
  return constructCallableReference((p0) => p0.jmz(), 1, 0, 613);
}
var FadeUB_instance;
function FadeUB_getInstance() {
  if (FadeUB_instance === VOID)
    new FadeUB();
  return FadeUB_instance;
}
var Program_instance;
function Program_getInstance() {
  if (Program_instance === VOID)
    new Program();
  return Program_instance;
}
function VerticalScrollViewport$lambda(this$0) {
  return (it) => {
    this$0.wmz(-this$0.wmf_1 * it.yhy());
    return Unit_instance;
  };
}
function VerticalScrollViewport$slambda(this$0, $dragging, $lastDragY) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if (this$0.zmf_1) {
      $dragging._v = true;
      $lastDragY._v = it.uhy().s9g_1;
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_down_$ref_qneabi() {
  return constructCallableReference((p0) => p0.yhw_1, 1, 0, 386);
}
function VerticalScrollViewport$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function VerticalScrollViewport$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, VerticalScrollViewport$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function VerticalScrollViewport$slambda_0($dragging, this$0, $lastDragY) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if ($dragging._v) {
      var currentY = it.uhy().s9g_1;
      this$0.wmz(currentY - $lastDragY._v);
      $lastDragY._v = currentY;
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_moveAnywhere_$ref_si2le4() {
  return constructCallableReference((p0) => p0.hhx_1, 1, 0, 388);
}
function VerticalScrollViewport$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function VerticalScrollViewport$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, VerticalScrollViewport$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function VerticalScrollViewport$slambda_1($dragging) {
  return constructCallableReference(function *(it, $completion) {
    $dragging._v = false;
    return Unit_instance;
  }, 1);
}
function MouseEvents$_get_upAnywhere_$ref_s41vu2() {
  return constructCallableReference((p0) => p0.fhx_1, 1, 0, 387);
}
function VerticalScrollViewport$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function VerticalScrollViewport$lambda_2($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately(tmp, VerticalScrollViewport$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function supervisorSubScope(_this__u8e3s4, extraContext) {
  extraContext = extraContext === VOID ? EmptyCoroutineContext_getInstance() : extraContext;
  var tmp0_elvis_lhs = _this__u8e3s4.d1m().ae(Key_instance);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Scope has no Job in its context';
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parentJob = tmp;
  return CoroutineScope(_this__u8e3s4.d1m().cp(Key_instance).ep(extraContext).ep(SupervisorJob(parentJob)));
}
function *insideScope(_this__u8e3s4, block, $completion) {
  var deferred = async(_this__u8e3s4, VOID, VOID, insideScope$slambda(block));
  var tmp;
  try {
    tmp = yield* deferred.m1q($completion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      deferred.o1n();
      throw e;
    } else {
      throw $p;
    }
  }
  return tmp;
}
function insideScope$slambda($block) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* $block($this$async, $completion);
  }, 1);
}
function copyToClipboard(text) {
  // Inline function 'kotlin.js.asDynamic' call
  var nav = window.navigator;
  var clipboard = nav.clipboard;
  if (clipboard != undefined && clipboard != null) {
    clipboard.writeText(text);
    return true;
  }
  return false;
}
function openLinkInNewTab(url) {
  window.open(url, '_blank');
}
function fixFullScreen(views) {
  var tmp = window;
  tmp.addEventListener('fullscreenchange', fixFullScreen$lambda(views));
  var tmp_0 = window;
  tmp_0.addEventListener('resize', fixFullScreen$lambda_0(views));
}
function fixFullScreen$reapply($views) {
  $views.jhn_1.qgk(Quality_QUALITY_getInstance());
  $views.wkg();
}
function fixFullScreen$lambda$lambda($views) {
  return () => {
    fixFullScreen$reapply($views);
    return Unit_instance;
  };
}
function fixFullScreen$lambda$lambda$lambda($views) {
  return (it) => {
    fixFullScreen$reapply($views);
    return Unit_instance;
  };
}
function fixFullScreen$lambda$lambda_0($views) {
  return (it) => {
    var tmp = window;
    tmp.requestAnimationFrame(fixFullScreen$lambda$lambda$lambda($views));
    return Unit_instance;
  };
}
function fixFullScreen$lambda($views) {
  return (it) => {
    var tmp = window;
    tmp.setTimeout(fixFullScreen$lambda$lambda($views), 50);
    var tmp_0 = window;
    tmp_0.requestAnimationFrame(fixFullScreen$lambda$lambda_0($views));
    return Unit_instance;
  };
}
function fixFullScreen$lambda$lambda_1($views) {
  return (it) => {
    fixFullScreen$reapply($views);
    return Unit_instance;
  };
}
function fixFullScreen$lambda_0($views) {
  return (it) => {
    var tmp = window;
    tmp.requestAnimationFrame(fixFullScreen$lambda$lambda_1($views));
    return Unit_instance;
  };
}
function set_navigationUrlChangeListener(_set____db54di) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  navigationUrlChangeListener = _set____db54di;
}
function get_navigationUrlChangeListener() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  return navigationUrlChangeListener;
}
var navigationUrlChangeListener;
function get_hashChangeListenerInstalled() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  return hashChangeListenerInstalled;
}
var hashChangeListenerInstalled;
function clearNavigationUrl(addToHistory) {
  addToHistory = addToHistory === VOID ? false : addToHistory;
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  clearNavigationParams(params);
  updateNavigationParams(params, addToHistory);
}
function setGameCodeInUrl(gameCode, teamId) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  clearNavigationParams(params);
  params.set('game', gameCode.o6k_1);
  params.set('team', teamId.toString());
  updateNavigationParams(params);
}
function setSandboxCodeInUrl(sandboxCode) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  clearNavigationParams(params);
  params.set('sandbox', sandboxCode.o6k_1);
  updateNavigationParams(params);
}
function setNavigationUrlChangeListener(listener) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  get_hashChangeListenerInstalled();
  set_navigationUrlChangeListener(listener);
}
function getReplayStartParamsFromUrl() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  var tmp0 = get_entries_5();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (element.v1_1 === params.get('replayVisibility')) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var replayVisibility = tmp0_elvis_lhs == null ? ReplayVisibility_CurrentTeam_getInstance() : tmp0_elvis_lhs;
  var sandboxValue = params.get('sample');
  if (!(sandboxValue == null)) {
    var tmp1_safe_receiver = params.get('startFromAnswer');
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : coerceAtLeast_0(tmp2_safe_receiver, 0);
    var startFrom = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    var tmp4_safe_receiver = params.get('infoStep');
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : toIntOrNull(tmp4_safe_receiver);
    var infoStep = tmp5_safe_receiver == null ? null : coerceAtLeast_0(tmp5_safe_receiver, 0);
    return new UrlReplayStartParams(new GameCode(sandboxValue), true, startFrom, infoStep, replayVisibility);
  }
  var replayValue = params.get('replay');
  if (!(replayValue == null)) {
    var tmp6_safe_receiver = params.get('startFromAnswer');
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : toIntOrNull(tmp6_safe_receiver);
    var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : coerceAtLeast_0(tmp7_safe_receiver, 0);
    var startFrom_0 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
    var tmp9_safe_receiver = params.get('infoStep');
    var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : toIntOrNull(tmp9_safe_receiver);
    var infoStep_0 = tmp10_safe_receiver == null ? null : coerceAtLeast_0(tmp10_safe_receiver, 0);
    return new UrlReplayStartParams(new GameCode(replayValue), false, startFrom_0, infoStep_0, replayVisibility);
  }
  return null;
}
function navigateToFullPage(url, replaceCurrentPage) {
  replaceCurrentPage = replaceCurrentPage === VOID ? false : replaceCurrentPage;
  _init_properties_UrlUtils_js_kt__7iee4j();
  if (replaceCurrentPage) {
    window.location.replace(url);
  } else {
    window.location.assign(url);
  }
}
function getContentReferenceFromUrl() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  var tmp0_safe_receiver = params.get('reference');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new UrlContentReferenceParams(tmp0_safe_receiver, params.get('expansions'), params.get('chosen'));
  }
  return tmp;
}
function setContentReferenceInUrl(params, addToHistory) {
  addToHistory = addToHistory === VOID ? true : addToHistory;
  _init_properties_UrlUtils_js_kt__7iee4j();
  var navigation = navigationParams();
  clearNavigationParams(navigation);
  navigation.set('reference', params.mmi_1);
  var tmp0_safe_receiver = params.nmi_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    navigation.set('expansions', tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = params.omi_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    navigation.set('chosen', tmp1_safe_receiver);
  }
  updateNavigationParams(navigation, addToHistory);
}
function getGameReconnectParamsFromUrl() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  var tmp0_elvis_lhs = params.get('game');
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var gameValue = tmp;
  var teamValue = params.get('team');
  var teamId = teamValue == null ? null : toIntOrNull(teamValue);
  return new UrlGameReconnectionParams(new GameCode(gameValue), teamId);
}
function getSandboxCodeFromUrl() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  var value = params.get('sandbox');
  var tmp;
  if (value == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new GameCode(value);
  }
  return tmp;
}
function setReplayCodeInUrl(replayCode, isSandboxGame, startFromAnswer, infoStep, replayVisibility) {
  startFromAnswer = startFromAnswer === VOID ? null : startFromAnswer;
  infoStep = infoStep === VOID ? null : infoStep;
  replayVisibility = replayVisibility === VOID ? ReplayVisibility_CurrentTeam_getInstance() : replayVisibility;
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  clearNavigationParams(params);
  params.set(isSandboxGame ? 'sample' : 'replay', replayCode.o6k_1);
  if (!(startFromAnswer == null)) {
    params.set('startFromAnswer', startFromAnswer.toString());
  } else {
    params.delete('startFromAnswer');
  }
  if (!(infoStep == null)) {
    params.set('infoStep', infoStep.toString());
  } else {
    params.delete('infoStep');
  }
  updateReplayVisibilityParam(params, replayVisibility);
  updateNavigationParams(params);
}
function isFailedToFetch(t) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  // Inline function 'kotlin.js.asDynamic' call
  var d = t;
  var tmp = d instanceof TypeError;
  var isTypeError = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
  var tmp_0 = d == null ? null : d.message;
  var msg = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null;
  var tmp_1;
  if (isTypeError) {
    tmp_1 = (msg == null ? null : contains_0(msg, 'Failed to fetch')) === true;
  } else {
    tmp_1 = false;
  }
  return tmp_1;
}
function navigationParams() {
  _init_properties_UrlUtils_js_kt__7iee4j();
  return new URLSearchParams(removePrefix(removePrefix(window.location.hash, '#'), '?'));
}
function clearNavigationParams(params) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  params.delete('reference');
  params.delete('expansions');
  params.delete('chosen');
  params.delete('game');
  params.delete('team');
  params.delete('sandbox');
  params.delete('replay');
  params.delete('sample');
  params.delete('startFromAnswer');
  params.delete('infoStep');
  params.delete('replayVisibility');
}
function updateNavigationParams(params, addToHistory) {
  addToHistory = addToHistory === VOID ? false : addToHistory;
  _init_properties_UrlUtils_js_kt__7iee4j();
  var hash = toString(params);
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.l1();
  this_0.m1(window.location.pathname);
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(hash) > 0) {
    this_0.o1(_Char___init__impl__6a9atx(35));
    this_0.m1(hash);
  }
  var newUrl = this_0.toString();
  if (addToHistory) {
    window.history.pushState(null, '', newUrl);
  } else {
    window.history.replaceState(null, '', newUrl);
  }
}
function updateReplayVisibilityParam(params, replayVisibility) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  if (replayVisibility.equals(ReplayVisibility_CurrentTeam_getInstance())) {
    params.delete('replayVisibility');
  } else {
    params.set('replayVisibility', replayVisibility.v1_1);
  }
}
function setReplayVisibilityInUrl(replayVisibility) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var params = navigationParams();
  updateReplayVisibilityParam(params, replayVisibility);
  updateNavigationParams(params);
}
function hashChangeListenerInstalled$lambda(it) {
  _init_properties_UrlUtils_js_kt__7iee4j();
  var tmp0_safe_receiver = get_navigationUrlChangeListener();
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  return Unit_instance;
}
var properties_initialized_UrlUtils_js_kt_81ngsb;
function _init_properties_UrlUtils_js_kt__7iee4j() {
  if (!properties_initialized_UrlUtils_js_kt_81ngsb) {
    properties_initialized_UrlUtils_js_kt_81ngsb = true;
    navigationUrlChangeListener = null;
    // Inline function 'kotlin.run' call
    var tmp = window;
    tmp.addEventListener('hashchange', hashChangeListenerInstalled$lambda);
    hashChangeListenerInstalled = true;
  }
}
//region block: post-declaration
initMetadataForClass(AwaitingGameReloadScene, 'AwaitingGameReloadScene', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(GameImageManager, 'GameImageManager', VOID, VOID, VOID, [3, 1, 2]);
initMetadataForClass(BeastGameImages, 'BeastGameImages', VOID, VOID, VOID, [2, 1, 0, 3]);
initMetadataForClass(InterfaceIcon, 'InterfaceIcon');
initMetadataForClass(GeneralTokens, 'GeneralTokens');
initMetadataForClass(BeastGameScene, 'BeastGameScene', VOID, VOID, VOID, [1, 0, 3]);
initMetadataForClass(BeastGameUi, 'BeastGameUi');
initMetadataForInterface(GameUiContext, 'GameUiContext');
protoOf(BeastUiMap).be1 = canSeePrivateInfoOf;
initMetadataForClass(BeastUiMap, 'BeastUiMap', VOID, VOID, [GameUiContext, GameTeamProvider], [0, 1, 2]);
initMetadataForClass(BeastMapUiForDevelop, 'BeastMapUiForDevelop', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(HotSeatSceneManager, 'HotSeatSceneManager');
protoOf(BindingTestMenuManagement).z97 = get_replayTimeline;
protoOf(BindingTestMenuManagement).rdx = get_isNetworkGame;
protoOf(BindingTestMenuManagement).sdx = get_canShareReplay;
protoOf(BindingTestMenuManagement).tdx = shareReplay;
protoOf(BindingTestMenuManagement).vdx = reloadGameCallback;
initMetadataForObject(BindingTestMenuManagement, 'BindingTestMenuManagement', VOID, VOID, [MenuManagement], [0, 1]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
protoOf(MainMenuScene$performGameReplay$1$menuManagement$1).rdx = get_isNetworkGame;
protoOf(MainMenuScene$performGameReplay$1$menuManagement$1).vdx = reloadGameCallback;
initMetadataForClass(MainMenuScene$performGameReplay$1$menuManagement$1, VOID, VOID, VOID, [MenuManagement], [0, 1]);
initMetadataForClass(MainMenuScene, 'MainMenuScene', VOID, VOID, VOID, [1, 3, 2, 4, 0, 7]);
protoOf(initGame$menuManagement$1).z97 = get_replayTimeline;
protoOf(initGame$menuManagement$1).sdx = get_canShareReplay;
protoOf(initGame$menuManagement$1).tdx = shareReplay;
initMetadataForClass(initGame$menuManagement$1, VOID, VOID, VOID, [MenuManagement], [0, 1]);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(MapHoveredUi, 'MapHoveredUi', VOID, VOID, VOID, [0]);
initMetadataForClass(BeastUiMap$installSandboxRelatedHovers$1, VOID, VOID, VOID, [MapHoveredUi], [0]);
initMetadataForClass(BeastUiMap$installRuinHover$2, VOID, VOID, VOID, [MapHoveredUi], [0]);
initMetadataForClass(BeastUiMap$installSnareHover$2, VOID, VOID, VOID, [MapHoveredUi], [0]);
initMetadataForClass(BeastUiMap$collectUiUpdate$$inlined$with$12);
initMetadataForInterface(HoverableUiElement, 'HoverableUiElement', VOID, VOID, VOID, [0]);
initMetadataForInterface(TransparencyHoverableUiElement, 'TransparencyHoverableUiElement', VOID, VOID, [HoverableUiElement], [0]);
protoOf(CircleWithHover).ql8 = applyStyle;
initMetadataForClass(CircleWithHover, 'CircleWithHover', CircleWithHover.wm4, VOID, [TransparencyHoverableUiElement], [0]);
initMetadataForClass(BeastUiMap$addCustomHighlightingAreaIfNeeded$1, VOID, VOID, VOID, VOID, [0]);
initMetadataForClass(BeastMovementsKey, 'BeastMovementsKey');
initMetadataForClass(AlternativeBeastSetupPlaceholder, 'AlternativeBeastSetupPlaceholder');
initMetadataForClass(GroupedObjectsInfo, 'GroupedObjectsInfo');
initMetadataForClass(TrailInfoKey, 'TrailInfoKey');
initMetadataForClass(PlacedTrapsZoneInfo, 'PlacedTrapsZoneInfo');
initMetadataForClass(TrailRenderInfo, 'TrailRenderInfo');
protoOf(RoundRectWithHover).ym4 = get_inactiveAlpha;
protoOf(RoundRectWithHover).zm4 = get_hoverAlpha;
protoOf(RoundRectWithHover).ql8 = applyStyle;
protoOf(RoundRectWithHover).klo = pingHighlight;
initMetadataForClass(RoundRectWithHover, 'RoundRectWithHover', VOID, VOID, [TransparencyHoverableUiElement], [0]);
initMetadataForClass(createHoveredIconAction$roundRect$1, VOID, VOID, VOID, VOID, [0]);
protoOf(createHoveredIconAction$1).klo = pingHighlight;
initMetadataForClass(createHoveredIconAction$1, VOID, VOID, VOID, [HoverableUiElement], [0]);
protoOf(CardUi).klo = pingHighlight;
initMetadataForClass(CardUi, 'CardUi', VOID, VOID, [HoverableUiElement], [0]);
initMetadataForClass(UrgullMoltEggsToReturnBoardData, 'UrgullMoltEggsToReturnBoardData');
initMetadataForObject(JustShowTheCard, 'JustShowTheCard');
initMetadataForObject(ShowDiscardedCard, 'ShowDiscardedCard');
initMetadataForClass(AdditionalButton, 'AdditionalButton');
initMetadataForClass(ShowTheCardWithAdditionalButtons, 'ShowTheCardWithAdditionalButtons');
initMetadataForClass(ShowTheCardWithAction, 'ShowTheCardWithAction');
initMetadataForClass(PlayTheCard, 'PlayTheCard');
initMetadataForClass(DiscardCardsType, 'DiscardCardsType');
initMetadataForClass(showHands$HandRow, 'HandRow');
initMetadataForClass(ChooseScenarioScene, 'ChooseScenarioScene', VOID, VOID, VOID, [1, 2, 3, 0]);
initMetadataForClass(ContentReferenceDialogState, 'ContentReferenceDialogState', VOID, VOID, VOID, [0, 2, 1, 3]);
initMetadataForClass(ResolvedContentReference, 'ResolvedContentReference');
initMetadataForClass(ContentReferenceRoute, 'ContentReferenceRoute', ContentReferenceRoute);
initMetadataForClass(Beast, 'Beast');
initMetadataForClass(Hunter, 'Hunter');
initMetadataForClass(Cards, 'Cards');
initMetadataForClass(Contract, 'Contract');
initMetadataForClass(ContentReferenceDialogCardsKind, 'ContentReferenceDialogCardsKind');
initMetadataForClass(AnimationInfo, 'AnimationInfo');
initMetadataForClass(GamePresencePanel, 'GamePresencePanel', GamePresencePanel.iml);
initMetadataForClass(SandboxGamePlaying, 'SandboxGamePlaying');
initMetadataForObject(OtherControlAgentMode, 'OtherControlAgentMode');
initMetadataForClass(TurnVariantRequest, 'TurnVariantRequest');
initMetadataForClass(UpgradeRequest, 'UpgradeRequest');
initMetadataForClass(KorgeControlAgent$choiceFlow$2$1, VOID, VOID, VOID, [ChoicePresentation], [0, 4, 2, 1]);
initMetadataForClass(KorgeControlAgent$chooseAncientPowerNumber$clickable$1, VOID, VOID, VOID, VOID, [0]);
protoOf(KorgeControlAgent).z6h = applyGameStateChanges;
protoOf(KorgeControlAgent).a6i = applyGameStateRevertChanges;
protoOf(KorgeControlAgent).k6i = applyGameStateRevertChanges_0;
initMetadataForClass(KorgeControlAgent, 'KorgeControlAgent', VOID, VOID, [GameUiContext, GameTeamProvider, MasterFixingSupportingAgent, RevertSupportingAgent, CurrentAndOldStateHolder, PingingSupport], [1, 0, 2, 3, 4, 5, 7, 11]);
initMetadataForClass(CharacterVisualInfoAndContainer, 'CharacterVisualInfoAndContainer');
initMetadataForClass(CharacterVisualInfo, 'CharacterVisualInfo');
initMetadataForClass(StatusBarKey, 'StatusBarKey');
initMetadataForClass(TwoBeastsHpElement, 'TwoBeastsHpElement');
initMetadataForObject(MenuButtonElement, 'MenuButtonElement');
initMetadataForClass(CharacterElement, 'CharacterElement');
initMetadataForObject(DiscardButtonElement, 'DiscardButtonElement');
initMetadataForObject(RuinButtonElement, 'RuinButtonElement');
initMetadataForClass(CardAtSidePanelElement, 'CardAtSidePanelElement');
initMetadataForClass(TextGameScopeElement, 'TextGameScopeElement');
initMetadataForClass(OverPanelUiHoverPosition, 'OverPanelUiHoverPosition');
initMetadataForClass(CardsGridPlacing, 'CardsGridPlacing');
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(KorgeStateLogging, 'KorgeStateLogging');
protoOf(EmptyKorgeStateLogging).oll = debugPrintPosAndScale;
protoOf(EmptyKorgeStateLogging).qmp = logGivenAnswer;
protoOf(EmptyKorgeStateLogging).rmi = logTurnOfPlayer;
protoOf(EmptyKorgeStateLogging).fld = logImageLoading;
protoOf(EmptyKorgeStateLogging).rmp = logTodo;
initMetadataForObject(EmptyKorgeStateLogging, 'EmptyKorgeStateLogging', VOID, VOID, [KorgeStateLogging]);
initMetadataForClass(MapZoomAnimation, 'MapZoomAnimation', VOID, VOID, VOID, [0]);
initMetadataForClass(ReplayLoadingProgress, 'ReplayLoadingProgress');
initMetadataForClass(SameScreenControlAgent$1, VOID, VOID, VOID, VOID, [0, 1, 3]);
initMetadataForClass(SameScreenControlAgent, 'SameScreenControlAgent', VOID, VOID, VOID, [3, 1, 0]);
initMetadataForClass(SharedTeamsScene, 'SharedTeamsScene', VOID, VOID, VOID, [1, 3, 0]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(createStatusLayer$2, VOID, VOID, VOID, VOID, [1, 0]);
initMetadataForClass(BeastMapUiPlacing, 'BeastMapUiPlacing');
initMetadataForClass(LocationArea, 'LocationArea');
initMetadataForClass(MapLogicalAndUiMappingImpl, 'MapLogicalAndUiMappingImpl');
initMetadataForClass(LocationUiType, 'LocationUiType');
initMetadataForClass(MapFormat, 'MapFormat');
initMetadataForClass(UserInfoView, 'UserInfoView');
protoOf(ActionButton).klo = pingHighlight;
initMetadataForClass(ActionButton, 'ActionButton', VOID, VOID, [HoverableUiElement], [0]);
initMetadataForClass(TextAndAction, 'TextAndAction');
initMetadataForClass(ControlPanel, 'ControlPanel');
initMetadataForClass(ButtonColumn, 'ButtonColumn', ButtonColumn);
initMetadataForClass(ButtonRow, 'ButtonRow', ButtonRow);
initMetadataForClass(ButtonLayoutContainer, 'ButtonLayoutContainer', ButtonLayoutContainer.smw);
initMetadataForClass(ControlPanelY, 'ControlPanelY', ControlPanelY);
initMetadataForClass(ControlPanelX, 'ControlPanelX', ControlPanelX);
initMetadataForClass(DialogCancelIcon, 'DialogCancelIcon', VOID, VOID, VOID, [1]);
initMetadataForClass(GameAnimationParams, 'GameAnimationParams', GameAnimationParams);
initMetadataForClass(ScreenSwitchMode, 'ScreenSwitchMode');
initMetadataForClass(GameColors, 'GameColors', GameColors);
initMetadataForClass(GameConfiguration, 'GameConfiguration', GameConfiguration);
initMetadataForClass(LocalGameMode, 'LocalGameMode');
initMetadataForClass(DefaultProblemReporter, 'DefaultProblemReporter', DefaultProblemReporter, VOID, VOID, [1]);
initMetadataForClass(GameDialog, 'GameDialog', VOID, VOID, VOID, [1, 0, 3]);
initMetadataForClass(DialogColoringStyle, 'DialogColoringStyle', DialogColoringStyle);
initMetadataForClass(DialogContent, 'DialogContent');
initMetadataForClass(DialogCorner, 'DialogCorner');
initMetadataForObject(BigCenter, 'BigCenter');
initMetadataForClass(BigRightSided, 'BigRightSided', BigRightSided);
initMetadataForClass(FitContent, 'FitContent', FitContent);
initMetadataForClass(OffsetFromStart, 'OffsetFromStart');
initMetadataForClass(OffsetFromEnd, 'OffsetFromEnd');
initMetadataForClass(OffsetFromCenter, 'OffsetFromCenter');
initMetadataForClass(LoadingResourceManager, 'LoadingResourceManager', LoadingResourceManager, VOID, VOID, [0]);
initMetadataForClass(ImageLoadingStage, 'ImageLoadingStage');
initMetadataForClass(GameLayout, 'GameLayout', GameLayout);
initMetadataForClass(SidePanelLayout, 'SidePanelLayout');
protoOf(GameUiContextImpl).qln = get_dialogLayerContainer;
initMetadataForClass(GameUiContextImpl, 'GameUiContextImpl', VOID, VOID, [GameUiContext]);
initMetadataForClass(AutoHighlight, 'AutoHighlight');
initMetadataForObject(NullVariant, 'NullVariant');
initMetadataForObject(KorgeOnboardingGameFlowListener, 'KorgeOnboardingGameFlowListener', VOID, VOID, VOID, [2, 4, 3]);
initMetadataForClass(LoadingResourceReporter, 'LoadingResourceReporter', VOID, VOID, VOID, [0, 2, 1]);
initMetadataForClass(LoadingProgressState, 'LoadingProgressState');
protoOf(RoundButton).klo = pingHighlight;
initMetadataForClass(RoundButton, 'RoundButton', VOID, VOID, [HoverableUiElement], [0]);
initMetadataForClass(HighlightPattern, 'HighlightPattern');
initMetadataForObject(ButtonUB, 'ButtonUB');
initMetadataForCompanion(Companion);
initMetadataForClass(ShaderButtonBackground, 'ShaderButtonBackground', ShaderButtonBackground.gmu);
initMetadataForClass(TextStyle, 'TextStyle');
initMetadataForClass(UiDynamicLayer, 'UiDynamicLayer', UiDynamicLayer, VOID, VOID, [5, 0]);
initMetadataForClass(ViewAndAnimation, 'ViewAndAnimation');
initMetadataForClass(CenterAndSize, 'CenterAndSize');
protoOf(LinearEasing).p9f = invoke;
protoOf(LinearEasing).q9f = invoke_0;
initMetadataForObject(LinearEasing, 'LinearEasing', VOID, VOID, [Easing]);
initMetadataForClass(makeGlowBitmap$Stop, 'Stop');
initMetadataForClass(UrlReplayStartParams, 'UrlReplayStartParams');
initMetadataForClass(UrlContentReferenceParams, 'UrlContentReferenceParams');
initMetadataForClass(UrlGameReconnectionParams, 'UrlGameReconnectionParams');
initMetadataForObject(FadeUB, 'FadeUB');
initMetadataForObject(Program, 'Program');
initMetadataForClass(VerticalEdgeFadeFilter, 'VerticalEdgeFadeFilter', VerticalEdgeFadeFilter);
initMetadataForClass(VerticalScrollViewport, 'VerticalScrollViewport', VerticalScrollViewport.amg);
//endregion
//region block: init
BindingTestMenuManagement_instance = new BindingTestMenuManagement();
JustShowTheCard_instance = new JustShowTheCard();
ShowDiscardedCard_instance = new ShowDiscardedCard();
OtherControlAgentMode_instance = new OtherControlAgentMode();
MenuButtonElement_instance = new MenuButtonElement();
DiscardButtonElement_instance = new DiscardButtonElement();
RuinButtonElement_instance = new RuinButtonElement();
EmptyKorgeStateLogging_instance = new EmptyKorgeStateLogging();
lastInfoDialog = null;
BigCenter_instance = new BigCenter();
NullVariant_instance = new NullVariant();
LinearEasing_instance = new LinearEasing();
//endregion
//region block: exports
export {
  startKorgeUi as startKorgeUi38919czmdh3gu,
  GameConfiguration as GameConfiguration2d0q42j89bphu,
  set_gameConfiguration as set_gameConfiguration1pq4o217f3vsu,
};
//endregion
